/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(513);
	module.exports = __webpack_require__(522);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(681);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(341)();
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 4 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.getScrollbarWidth = getScrollbarWidth;
	exports.setScrollbarWidth = setScrollbarWidth;
	exports.isBodyOverflowing = isBodyOverflowing;
	exports.getOriginalBodyPadding = getOriginalBodyPadding;
	exports.conditionallyUpdateScrollbar = conditionallyUpdateScrollbar;
	exports.setGlobalCssModule = setGlobalCssModule;
	exports.mapToCssModules = mapToCssModules;
	exports.omit = omit;
	exports.pick = pick;
	exports.warnOnce = warnOnce;
	exports.deprecated = deprecated;
	exports.DOMElement = DOMElement;
	exports.isReactRefObj = isReactRefObj;
	exports.findDOMElements = findDOMElements;
	exports.isArrayOrNodeList = isArrayOrNodeList;
	exports.getTarget = getTarget;
	exports.addMultipleEventListeners = addMultipleEventListeners;
	exports.focusableElements = exports.defaultToggleEvents = exports.canUseDOM = exports.PopperPlacements = exports.keyCodes = exports.TransitionStatuses = exports.TransitionPropTypeKeys = exports.TransitionTimeouts = exports.tagPropType = exports.targetPropType = void 0;
	
	var _lodash = _interopRequireDefault(__webpack_require__(756));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
	function getScrollbarWidth() {
	  var scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
	
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.width = '50px';
	  scrollDiv.style.height = '50px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarWidth;
	}
	
	function setScrollbarWidth(padding) {
	  document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
	}
	
	function isBodyOverflowing() {
	  return document.body.clientWidth < window.innerWidth;
	}
	
	function getOriginalBodyPadding() {
	  var style = window.getComputedStyle(document.body, null);
	  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
	}
	
	function conditionallyUpdateScrollbar() {
	  var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
	
	  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
	  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
	
	  if (isBodyOverflowing()) {
	    setScrollbarWidth(bodyPadding + scrollbarWidth);
	  }
	}
	
	var globalCssModule;
	
	function setGlobalCssModule(cssModule) {
	  globalCssModule = cssModule;
	}
	
	function mapToCssModules(className, cssModule) {
	  if (className === void 0) {
	    className = '';
	  }
	
	  if (cssModule === void 0) {
	    cssModule = globalCssModule;
	  }
	
	  if (!cssModule) return className;
	  return className.split(' ').map(function (c) {
	    return cssModule[c] || c;
	  }).join(' ');
	}
	/**
	 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
	 */
	
	
	function omit(obj, omitKeys) {
	  var result = {};
	  Object.keys(obj).forEach(function (key) {
	    if (omitKeys.indexOf(key) === -1) {
	      result[key] = obj[key];
	    }
	  });
	  return result;
	}
	/**
	 * Returns a filtered copy of an object with only the specified keys.
	 */
	
	
	function pick(obj, keys) {
	  var pickKeys = Array.isArray(keys) ? keys : [keys];
	  var length = pickKeys.length;
	  var key;
	  var result = {};
	
	  while (length > 0) {
	    length -= 1;
	    key = pickKeys[length];
	    result[key] = obj[key];
	  }
	
	  return result;
	}
	
	var warned = {};
	
	function warnOnce(message) {
	  if (!warned[message]) {
	    /* istanbul ignore else */
	    if (typeof console !== 'undefined') {
	      console.error(message); // eslint-disable-line no-console
	    }
	
	    warned[message] = true;
	  }
	}
	
	function deprecated(propType, explanation) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
	      warnOnce("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
	    }
	
	    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      rest[_key - 3] = arguments[_key];
	    }
	
	    return propType.apply(void 0, [props, propName, componentName].concat(rest));
	  };
	} // Shim Element if needed (e.g. in Node environment)
	
	
	var Element = typeof window === 'object' && window.Element || function () {};
	
	function DOMElement(props, propName, componentName) {
	  if (!(props[propName] instanceof Element)) {
	    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
	  }
	}
	
	var targetPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, DOMElement, _propTypes.default.shape({
	  current: _propTypes.default.any
	})]);
	
	exports.targetPropType = targetPropType;
	
	var tagPropType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
	  $$typeof: _propTypes.default.symbol,
	  render: _propTypes.default.func
	}), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
	  $$typeof: _propTypes.default.symbol,
	  render: _propTypes.default.func
	})]))]);
	/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
	// These are all setup to match what is in the bootstrap _variables.scss
	// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
	
	
	exports.tagPropType = tagPropType;
	var TransitionTimeouts = {
	  Fade: 150,
	  // $transition-fade
	  Collapse: 350,
	  // $transition-collapse
	  Modal: 300,
	  // $modal-transition
	  Carousel: 600 // $carousel-transition
	
	}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
	// for distribution properly exclude these keys for nested child HTML attributes
	// since `react-transition-group` removes propTypes in production builds.
	
	exports.TransitionTimeouts = TransitionTimeouts;
	var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
	exports.TransitionPropTypeKeys = TransitionPropTypeKeys;
	var TransitionStatuses = {
	  ENTERING: 'entering',
	  ENTERED: 'entered',
	  EXITING: 'exiting',
	  EXITED: 'exited'
	};
	exports.TransitionStatuses = TransitionStatuses;
	var keyCodes = {
	  esc: 27,
	  space: 32,
	  enter: 13,
	  tab: 9,
	  up: 38,
	  down: 40,
	  home: 36,
	  end: 35,
	  n: 78,
	  p: 80
	};
	exports.keyCodes = keyCodes;
	var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	exports.PopperPlacements = PopperPlacements;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;
	
	function isReactRefObj(target) {
	  if (target && typeof target === 'object') {
	    return 'current' in target;
	  }
	
	  return false;
	}
	
	function findDOMElements(target) {
	  if (isReactRefObj(target)) {
	    return target.current;
	  }
	
	  if ((0, _lodash.default)(target)) {
	    return target();
	  }
	
	  if (typeof target === 'string' && canUseDOM) {
	    var selection = document.querySelectorAll(target);
	
	    if (!selection.length) {
	      selection = document.querySelectorAll("#" + target);
	    }
	
	    if (!selection.length) {
	      throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
	    }
	
	    return selection;
	  }
	
	  return target;
	}
	
	function isArrayOrNodeList(els) {
	  if (els === null) {
	    return false;
	  }
	
	  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
	}
	
	function getTarget(target) {
	  var els = findDOMElements(target);
	
	  if (isArrayOrNodeList(els)) {
	    return els[0];
	  }
	
	  return els;
	}
	
	var defaultToggleEvents = ['touchstart', 'click'];
	exports.defaultToggleEvents = defaultToggleEvents;
	
	function addMultipleEventListeners(_els, handler, _events, useCapture) {
	  var els = _els;
	
	  if (!isArrayOrNodeList(els)) {
	    els = [els];
	  }
	
	  var events = _events;
	
	  if (typeof events === 'string') {
	    events = events.split(/\s+/);
	  }
	
	  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
	    throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
	  }
	
	  Array.prototype.forEach.call(events, function (event) {
	    Array.prototype.forEach.call(els, function (el) {
	      el.addEventListener(event, handler, useCapture);
	    });
	  });
	  return function removeEvents() {
	    Array.prototype.forEach.call(events, function (event) {
	      Array.prototype.forEach.call(els, function (el) {
	        el.removeEventListener(event, handler, useCapture);
	      });
	    });
	  };
	}
	
	var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
	exports.focusableElements = focusableElements;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 7 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Development = {
		FB_APP_ID: "1298993600235375",
		GOOGLE_CLIENT_ID: "352086129390-nph4r09st93tpc8ql0ppn66s2r6bbhqa.apps.googleusercontent.com",
		BASE_API_URL: "http://127.0.0.1:8080",
		HOME_PAGE_BANNERS: [{ img: "http://127.0.0.1:8080/profile_pics/banners/Pari Banner1.jpg", url: "/store/Random-Nepali", title: "Random Nepali - Merchandise" }, { img: "http://127.0.0.1:8080/profile_pics/banners/Girish Khatiwada Banner2.jpg", url: "/store/Mr-Foodie-Nepal", title: "Mr. Foodie Nepal - Merchandise" }],
		TOP_ARTISTS: [{ id: 191, username: 'Abiraj Tamang', userType: "DESIGNER" }, { id: 190, username: 'Something', userType: "DESIGNER" }, { id: 318, username: 'Some Regular User', userType: "DESIGNER" }],
		ADMIN_USER_ID: 2,
	
		CUSTOM_PRODUCTS: {
			MUSIC_PLAQUE: [64, 68],
			PHOTO_FRAME: [69]
		},
		ACRYCLIC_MUSIC_PLAQUE: 64,
		CUSTOM_FRAME_PRODUCT: 69,
		CYBERSOURCE_FORM_URL: "https://testsecureacceptance.cybersource.com/pay"
	};
	
	var LocalServer = {
		FB_APP_ID: "1298993600235375",
		GOOGLE_CLIENT_ID: "352086129390-nph4r09st93tpc8ql0ppn66s2r6bbhqa.apps.googleusercontent.com",
		BASE_API_URL: "http://127.0.0.1:8080",
	
		HOME_PAGE_BANNERS: [{ img: "https://www.setocanvas.com/masi/profile_pics/banners/Random Banner1.jpg", url: "/store/Random-Nepali", title: "Random Nepali - Merchandise" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/Foodie Banner3.jpg", url: "/store/Mr-Foodie-Nepal", title: "Mr. Foodie Nepal - Merchandise" }],
		TOP_ARTISTS: [{ id: 191, username: 'Abiraj Tamang' }, { id: 190, username: 'Something' }, { id: 318, username: 'Some Regular User' }],
		ADMIN_USER_ID: 2,
		CUSTOM_PRODUCTS: {
			MUSIC_PLAQUE: [64, 68],
			PHOTO_FRAME: [69]
		},
		ACRYCLIC_MUSIC_PLAQUE: 64,
		CUSTOM_FRAME_PRODUCT: 69,
		CYBERSOURCE_FORM_URL: "https://testsecureacceptance.cybersource.com/pay"
	};
	
	var Production = {
		FB_APP_ID: "306120713289427",
		GOOGLE_CLIENT_ID: "626962822748-8vs5kbmrc9jmp73ekcivja3ib8u507q3.apps.googleusercontent.com",
		BASE_API_URL: "https://api.setocanvas.com",
	
		HOME_PAGE_BANNERS: [{ img: "https://www.setocanvas.com/masi/profile_pics/banners/AMTees-Banner.jpg", url: "/store/AM-Tees", title: "AM Tees - Tshirt and Hoodies" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/Yatri-Banner.jpg", url: "/store/Yatri-Design", title: "Yatri Design - Merchandise" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/ChetanV Banner2.jpg", url: "/store/Chetan-Vlog", title: "Chetan Vlog - Merchandise" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/PB Hoodie Banner.JPG", url: "/store/Pari-Store", title: "Pari - Prechya Bajracharya Merchandise" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/Girish Khatiwada Banner1.jpg", url: "/store/Gorkhali-Store", title: "Gorkali Store - Girish Khatiwada" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/B8Banner2.jpg", url: "/store/B-8Eight", title: "B8Eight - Merchandise" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/Foodie Banner3.jpg", url: "/store/Mr-Foodie-Nepal", title: "Mr. Foodie Nepal - Merchandise" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/Random Banner1.jpg", url: "/store/Random-Nepali", title: "Random Nepali - Merchandise" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/Prashant NKS Banner.jpg", url: "/store/nksPrashant", title: "Prashant NKS - Merchandise" }, { img: "https://www.setocanvas.com/masi/profile_pics/banners/Dose-of-Ride_social.jpg", url: "/store/Dose-Of-Ride", title: "Dose of Ride - Merchandise" }],
		TOP_ARTISTS: [{ id: 323, username: 'Suraj Maharjan', userType: "DESIGNER" }, { id: 269, username: 'Prasiddha Shrestha', userType: "DESIGNER" }, { id: 480, username: 'Sampurnaa Chalize', userType: "DESIGNER" }, { id: 248, username: 'Siddhant Acharya', userType: "DESIGNER" }, { id: 463, username: 'Merishna Suwal', userType: "DESIGNER" }, { id: 182, username: 'Johnson Dhakal', userType: "DESIGNER" }, { id: 533, username: 'D20 Design Labs', userType: "DESIGNER" }, { id: 625, username: 'Anjal Soti', userType: "DESIGNER" }, { id: 25, username: 'Ashwin Neupane', userType: "DESIGNER" }],
		ADMIN_USER_ID: 2,
		CUSTOM_PRODUCTS: {
			MUSIC_PLAQUE: [1500, 1578],
			PHOTO_FRAME: [1624]
		},
		ACRYCLIC_MUSIC_PLAQUE: 1500,
		CUSTOM_FRAME_PRODUCT: 1624,
	
		CYBERSOURCE_FORM_URL: "https://secureacceptance.cybersource.com/pay"
	};
	
	var Env = { 'dev': Development,
		'prod': Production,
		'localserver': LocalServer };
	
	var APP_ENV = ("prod");
	
	var CLOTH_SIZES = {
		S: { label: 'Small (38")', shortLabel: 'S (38")', priceAddition: 0 },
		M: { label: 'Medium (40")', shortLabel: 'M (40")', priceAddition: 0 },
		L: { label: 'Large (42")', shortLabel: 'L (42")', priceAddition: 0 },
		XL: { label: 'Extra Large (44")', shortLabel: 'XL (44")', priceAddition: 0 }
	};
	
	var HOODIE_SIZES = {
		M: { label: 'Medium (40")', shortLabel: 'M (40")', priceAddition: 0 },
		L: { label: 'Large (42")', shortLabel: 'L (42")', priceAddition: 0 },
		XL: { label: 'Extra Large (44")', shortLabel: 'XL (44")', priceAddition: 0 }
	};
	
	var SHIRT_SIZES = {
		S: { label: 'Small (38")', shortLabel: 'S (38")', priceAddition: 0 },
		M: { label: 'Medium (40")', shortLabel: 'M (40")', priceAddition: 0 },
		L: { label: 'Large (42")', shortLabel: 'L (42")', priceAddition: 0 },
		XL: { label: 'Extra Large (44")', shortLabel: 'XL (44")', priceAddition: 0 }
	};
	
	var SWEAT_SHIRT_SIZES = {
		M: { label: 'Medium (40")', shortLabel: 'M (40")', priceAddition: 0 },
		L: { label: 'Large (42")', shortLabel: 'L (42")', priceAddition: 0 },
		XL: { label: 'Extra Large (44")', shortLabel: 'XL (44")', priceAddition: 0 }
	};
	
	var JACKET_SIZES = {
		S: { label: 'Small (32")', shortLabel: 'S (32")', priceAddition: 0 },
		M: { label: 'Medium (34")', shortLabel: 'M (34")', priceAddition: 0 },
		L: { label: 'Large (36")', shortLabel: 'L (36")', priceAddition: 0 },
		XL: { label: 'Extra Large (38")', shortLabel: 'XL (38")', priceAddition: 0 },
		XXL: { label: 'XX Large (40")', shortLabel: 'XXL (40")', priceAddition: 0 }
	};
	
	//in photo frame, price and margin increases per size
	var PHOTO_FRAME_SIZES = {
		S: { label: 'Small (8" x 11")', shortLabel: 'S (8" x 11")', priceAddition: 0 },
		M: { label: 'Medium (11" x 15")', shortLabel: 'M (11" x 15")', priceAddition: 400 },
		L: { label: 'Large (13" x 18")', shortLabel: 'L (13" x 18")', priceAddition: 1400 },
		XL: { label: 'Extra Large (15" x 21")', shortLabel: 'XL (15" x 21")', priceAddition: 1800 }
	};
	
	var NO_SIZE = {
		NA: { label: "Regular", shortLabel: "R", priceAddition: 0 }
	};
	
	var PAPER_SIZE = {
		A4: { label: 'A4 (8.14" x 11.34")', shortLabel: 'A4 (8.14" x 11.34")', priceAddition: 0 }
	};
	
	var PRODUCT_TYPES = {
		T_SHIRT: { val: "T_SHIRT", url: "tshirt", label: "T-Shirt", previewRequired: true,
			basePrice: 1000, available: true,
			psdTemplateUrl: "https://drive.google.com/open?id=1VOaGPFNMeViqfqdkwy0WGxns_CzthR2o",
			SIZE: CLOTH_SIZES,
			hasImmediateDelivery: false },
	
		SWEAT_SHIRT: { val: "SWEAT_SHIRT", url: "sweatshirt", label: "Sweatshirt", previewRequired: true,
			basePrice: 1500, available: true, psdTemplateUrl: "https://drive.google.com/file/d/1uL7RvgMuou_3WOsl6_LOJKB1oOcu-Vrj/view?usp=sharing",
			SIZE: SWEAT_SHIRT_SIZES, hasImmediateDelivery: false },
	
		HOODIES: { val: "HOODIES", url: "hoodies", label: "Hoodies", previewRequired: true,
			basePrice: 1800, available: true, psdTemplateUrl: "https://drive.google.com/file/d/1EX4Qgx_IWaucC1J78B7lSUeCNdPy_YNj/view?usp=sharing",
			SIZE: HOODIE_SIZES, hasImmediateDelivery: false },
	
		//remove it later, added to support backward compatibility after adding Art Frame
		PHOTO_FRAME: { val: "PHOTO_FRAME", url: "frame", label: "Frame", previewRequired: true,
			basePrice: 1200, available: true, psdTemplateUrl: "https://drive.google.com/file/d/1oggNf0ghLa6de9dtvtjeIo35draVlNYq/view?usp=sharing",
			SIZE: PHOTO_FRAME_SIZES, hasImmediateDelivery: false,
			deliveryLocationType: {
				INSIDE_KTM_VALLEY: { val: "INSIDE_KTM_VALLEY", label: "Inside KTM Valley, Nepal", extraCost: 100.0 },
				OUTSIDE_KTM_VALLEY: { val: "OUTSIDE_KTM_VALLEY", label: "Outside KTM Valley, Nepal", extraCost: 350.0 }
			}
		},
	
		OLD_PHOTO_FRAME: { val: "PHOTO_FRAME", url: "photoframe", label: "Photo Frame", previewRequired: true,
			basePrice: 1200, available: false, psdTemplateUrl: "https://drive.google.com/file/d/1oggNf0ghLa6de9dtvtjeIo35draVlNYq/view?usp=sharing",
			SIZE: PHOTO_FRAME_SIZES, hasImmediateDelivery: false },
	
		PILLOW: { val: "PILLOW", url: "pillow", label: "Pillow", previewRequired: false,
			basePrice: 1500, available: false,
			SIZE: NO_SIZE, hasImmediateDelivery: false },
	
		PAINTING: { val: "PAINTING", url: "painting", label: "Painting", previewRequired: false,
			basePrice: 1000, available: true, psdTemplateUrl: "",
			SIZE: NO_SIZE, hasImmediateDelivery: false },
	
		SKETCH: { val: "SKETCH", url: "sketch", label: "Sketch", previewRequired: false,
			basePrice: 1000, available: true, psdTemplateUrl: "",
			SIZE: NO_SIZE, hasImmediateDelivery: false },
	
		MUSIC_PLAQUE: { val: "MUSIC_PLAQUE", url: "music-plaque", label: "Music Plaque", previewRequired: false,
			basePrice: 1200, available: false, psdTemplateUrl: "",
			SIZE: PAPER_SIZE, hasImmediateDelivery: false,
			deliveryLocationType: {
				INSIDE_KTM_VALLEY: { val: "INSIDE_KTM_VALLEY", label: "Inside KTM Valley, Nepal", extraCost: 100.0 },
				OUTSIDE_KTM_VALLEY: { val: "OUTSIDE_KTM_VALLEY", label: "Outside KTM Valley, Nepal", extraCost: 250.0 }
			}
		},
	
		JACKET: { val: "JACKET", url: "jacket", label: "Jacket", previewRequired: false,
			basePrice: 2500, available: true, psdTemplateUrl: "",
			SIZE: JACKET_SIZES, hasImmediateDelivery: true },
	
		FASHION_DESIGNER_WEAR: { val: "FASHION_DESIGNER_WEAR", url: "fashion-wear", label: "Fashion Designer Wear",
			previewRequired: true,
			basePrice: 1500, available: true, psdTemplateUrl: "",
			SIZE: SHIRT_SIZES, hasImmediateDelivery: false },
	
		OTHER: { val: "OTHER", url: "other", label: "Other",
			previewRequired: false,
			basePrice: 50, available: true, psdTemplateUrl: "",
			SIZE: NO_SIZE, hasImmediateDelivery: false }
	};
	
	var ARTWORK_TYPES = {
		DIGITAL_ART: { val: "DIGITAL_ART", label: "Graphic Art",
			supportedProductTypes: [PRODUCT_TYPES.SWEAT_SHIRT.val, PRODUCT_TYPES.T_SHIRT.val, PRODUCT_TYPES.HOODIES.val, PRODUCT_TYPES.PILLOW.val, PRODUCT_TYPES.PHOTO_FRAME.val, PRODUCT_TYPES.MUSIC_PLAQUE.val] },
		PHOTOGRAPH: { val: "PHOTOGRAPH", label: "Photograph",
			supportedProductTypes: [PRODUCT_TYPES.T_SHIRT.val, PRODUCT_TYPES.PILLOW.val, PRODUCT_TYPES.PHOTO_FRAME.val] },
		PHYSICAL_ART: { val: "PHYSICAL_ART", label: "Physical Art",
			supportedProductTypes: [PRODUCT_TYPES.PAINTING.val, PRODUCT_TYPES.SKETCH.val, PRODUCT_TYPES.PHOTO_FRAME.val, PRODUCT_TYPES.FASHION_DESIGNER_WEAR.val, PRODUCT_TYPES.OTHER.val] }
	};
	
	var USER_TYPE = {
		ADMIN: "ADMIN",
		DESIGNER: "DESIGNER",
		INFLUENCER: "INFLUENCER",
		PHOTOGRAPHER: "PHOTOGRAPHER",
		FASHION_DESIGNER: "FASHION_DESIGNER",
		REGULAR: "REGULAR",
		SALES: "SALES"
	};
	
	var PRODUCT_STATE = {
		PENDING_APPROVAL: "PENDING_APPROVAL",
		APPROVED: "APPROVED",
		UNPUBLISHED: "UNPUBLISHED",
		ARCHIVED: "ARCHIVED"
	};
	
	var ORDER_STATE = {
		ORDER_PLACED: { label: "Order Placed", value: "ORDER_PLACED" },
		ORDER_CONFIRMED: { label: "Order Confirmed", value: "ORDER_CONFIRMED" },
		SHIPPING: { label: 'Shipping', value: "SHIPPING" },
		DELIVERED: { label: 'Delivered', value: "DELIVERED" },
		DELIVERED_CLOSED: { label: 'Closed', value: "DELIVERED_CLOSED" },
		CANCELLED: { label: 'Cancelled', value: "CANCELLED" }
	};
	
	var regularDelivery = _react2.default.createElement(
		"span",
		{ style: { color: '#596161' } },
		"Regular Delivery ",
		_react2.default.createElement("i", { className: "fa fa-motorcycle", "aria-hidden": "true" })
	);
	var immediateDelivery = _react2.default.createElement(
		"span",
		{ style: { color: '#596161' } },
		"Immediate Delivery ",
		_react2.default.createElement("i", { className: "fa fa-space-shuttle", "aria-hidden": "true" })
	);
	
	var DELIVERY_TYPE = { REGULAR: { val: "REGULAR", label: regularDelivery, extraCost: 0.0 },
		IMMEDIATE: { val: "IMMEDIATE", label: immediateDelivery, extraCost: 100.0 }
	};
	
	var DELIVERY_LOCATION_TYPE = { INSIDE_KTM_VALLEY: { val: "INSIDE_KTM_VALLEY", label: "Inside KTM Valley, Nepal", extraCost: 100.0 },
		INSIDE_RING_ROAD: { val: "INSIDE_RING_ROAD", label: "Inside Ring Road, KTM Valley, Nepal", extraCost: 100.0 },
		OUTSIDE_RING_ROAD: { val: "OUTSIDE_RING_ROAD", label: "Outside Ring Road, KTM Valley, Nepal", extraCost: 150.0 },
		OUTSIDE_KTM_VALLEY: { val: "OUTSIDE_KTM_VALLEY", label: "Outside KTM Valley, Nepal", extraCost: 250.0 }
	};
	
	//these are static for the nav bar
	var TOP_INFLUENCERS = [{ username: 'Girish Khatiwada', storeName: 'Gorkhali Store' }, { username: 'Prechya Bajracharya', storeName: 'Pari Store' }, { username: 'Chetan Raj Karki', storeName: 'Chetan Vlog' }, { username: 'Beestdesigns', storeName: 'Beestdesigns' }, { username: 'B-8Eight', storeName: 'B 8Eight' }, { username: 'Mr. Foodie Nepal', storeName: 'Mr Foodie Nepal' }, { username: 'Dose Of Ride', storeName: 'Dose Of Ride' }, { username: 'Random Nepali', storeName: 'Random Nepali' }, { username: 'Ashish Prasai', storeName: 'Prankster Revival' }, { username: 'Buddhi Tamang', storeName: 'Buddhi Tamang' }, { username: 'Prashant NKS', storeName: 'nksPrashant' }];
	
	var TOP_STORES = [{ storeName: 'Comedy Circle' }, { storeName: 'MMA Merch Nepal' }, { storeName: 'AM Tees' }, { storeName: 'TShirt Guy' }, { storeName: 'Yatri Design' }, { storeName: 'loveKUSH Tee' }, { storeName: 'The Doers Nepal' }, { storeName: 'Chill And Green' }, { storeName: 'Celebrate Nepal' }];
	
	var TOP_TAGS = [{ name: "funny", value: "Funny" }, { name: "profession", value: "Professions" }, { name: "travel", value: "Travel" }, { name: "gods", value: "Gods" }, { name: "nepal", value: "Nepal" }, { name: "quote", value: "Quote" }, { name: "animal", value: "Animal" }, { name: "superhero", value: "Superhero" }];
	
	var SIGN_UP_FORMS = {
		LOGIN_FORM: "LOGIN",
		REGISTER_FORM: "REGISTER",
		FORGOT_PASSWORD: "FORGOT_PASSWORD",
		SOCIAL_LOGIN: "SOCIAL_LOGIN"
	};
	
	var PAYMENT_OPTIONS = {
		COD: { val: "COD", label: "Cash On Delivery" },
		ESEWA: { val: "ESEWA", label: "eSewa", image: "/images/payment/eSewa.png" },
		QR_CODE_SCAN: { val: "QR_CODE_SCAN", label: "QR Code Scan", image: "/images/payment/fonePay.png" },
		VISA_MASTER: { val: "VISA_MASTER", label: "Credit/Debit Card" },
		BANK_TRANSER: { val: "BANK_TRANSER", label: "Bank Transfer", image: "/images/payment/bankTransfer.png" }
	};
	
	var AppConstants = {
		APP_NAME: "Seto Canvas",
		CONTACT_EMAIL: "setocanvas@gmail.com",
	
		BASE_API_URL: Env[APP_ENV].BASE_API_URL,
	
		CUSTOM_PRODUCTS: Env[APP_ENV].CUSTOM_PRODUCTS,
		ACRYCLIC_MUSIC_PLAQUE: Env[APP_ENV].ACRYCLIC_MUSIC_PLAQUE,
		CUSTOM_FRAME_PRODUCT: Env[APP_ENV].CUSTOM_FRAME_PRODUCT,
	
		CYBERSOURCE_FORM_URL: Env[APP_ENV].CYBERSOURCE_FORM_URL,
	
		FB_APP_ID: Env[APP_ENV].FB_APP_ID,
		GOOGLE_CLIENT_ID: Env[APP_ENV].GOOGLE_CLIENT_ID,
	
		HOME_PAGE_BANNERS: Env[APP_ENV].HOME_PAGE_BANNERS,
	
		WEBSITE: 'https://www.setocanvas.com',
		USER_ADDRESS_KEY: "USER_ADDRESS_KEY",
	
		SIZE_INCREMENT: 2,
	
		ADMIN_USER_ID: Env[APP_ENV].ADMIN_USER_ID,
	
		USER_TYPE: USER_TYPE,
		PRODUCT_STATE: PRODUCT_STATE,
	
		ORDER_STATE: ORDER_STATE,
		PRODUCT_TYPES: PRODUCT_TYPES,
		ARTWORK_TYPES: ARTWORK_TYPES,
	
		WHATS_APP: '9840843155',
		CONTACT_NUMBER: '9840843155, 9803947082',
		DELIVERY_LOCATION_TYPE: DELIVERY_LOCATION_TYPE,
		DELIVERY_TYPE: DELIVERY_TYPE,
	
		FB_PAGE_ID: "417097095539625",
	
		DEFAULT_PRODUCT_PAGE_SIZE: 15,
	
		DEFAULT_PRODUCT_TAGS: ['funny', 'cute', 'cartoon', 'animal', 'superhero', 'music', 'movie', 'anime', 'shows', 'local', 'nepal', 'travel', 'food', 'adventure', 'gods', 'mma', 'sports', 'bike', 'quotes', 'abstract'],
	
		TOP_INFLUENCERS: TOP_INFLUENCERS,
		TOP_ARTISTS: Env[APP_ENV].TOP_ARTISTS,
		TOP_STORES: TOP_STORES,
		TOP_TAGS: TOP_TAGS,
	
		BITLY_API_KEY: "R_415998193e644457aaab67924e93fa52",
		BITLY_LOGIN: "setocanvas",
	
		FB_PAGE: "https://www.facebook.com/setocanvascom/",
		INSTA_PAGE: "https://www.instagram.com/setocanvas/",
		YT_CHANNEL: "https://www.youtube.com/channel/UCjSM4-8VZ8NcvljZoQ_3pnA",
		FB_GROUP: "https://www.facebook.com/groups/1664344370379950",
	
		SIGN_UP_FORMS: SIGN_UP_FORMS,
	
		LOGIN_TO_CONTINUE_MSG: "Use one of the options to Login/Sign Up.",
	
		PAYMENT_OPTIONS: PAYMENT_OPTIONS,
	
		BULK_ORDER_DISCOUNT_PCT: 0.15,
		BULK_MINMUM_QUANTITY: 10
	};
	
	exports.default = AppConstants;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SCSlider = exports.Separator = exports.Title = exports.Img = exports.Col = exports.Row = exports.Container = exports.A = exports.Button = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(71);
	
	var _divider = __webpack_require__(69);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _row = __webpack_require__(337);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(334);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _container = __webpack_require__(335);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _Loader = __webpack_require__(63);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _button = __webpack_require__(84);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MBtn = (0, _radium2.default)(_button2.default);
	
	//Note: Radium does not work with MUI button, so use mui-custom.css file to modify it
	var Button = exports.Button = (0, _radium2.default)(function (props) {
	  var button = null;
	
	  if (props.mui === 'true') {
	    button = _react2.default.createElement(
	      MBtn,
	      Object.assign({ style: props.style }, props),
	      props.children
	    );
	  } else {
	    button = _react2.default.createElement(
	      'button',
	      Object.assign({ style: props.style }, props),
	      props.children
	    );
	  }
	
	  if (props.href || props.to) {
	    var routerProps = Object.assign({}, props);
	    if (typeof routerProps.onClick === 'function') {
	      delete routerProps.onClick;
	    }
	    return _react2.default.createElement(
	      _reactRouterDom.Link,
	      Object.assign({ to: props.href }, routerProps),
	      button
	    );
	  } else {
	    return button;
	  }
	});
	
	var Link = (0, _radium2.default)(_reactRouterDom.Link);
	var A = exports.A = (0, _radium2.default)(function (props) {
	
	  if (props.href.startsWith("http")) return _react2.default.createElement(
	    'a',
	    Object.assign({ target: '_blank', rel: 'nofollow', href: props.href }, props),
	    props.children
	  );
	
	  if (props.disabled === true) {
	    var linkStyle = props.style || {};
	    var disabledStyle = { background: 'gray', color: 'white' };
	    if (Array.isArray(linkStyle)) {
	      linkStyle.push([disabledStyle]);
	    } else {
	      linkStyle = Object.assign(linkStyle, disabledStyle);
	    }
	
	    return _react2.default.createElement(
	      Link,
	      { to: '#', style: linkStyle, onClick: function onClick(e) {
	          e.preventDefault();
	        } },
	      props.children
	    );
	  }
	  return _react2.default.createElement(
	    Link,
	    Object.assign({ to: props.href }, props),
	    props.children
	  );
	});
	
	//-- Grid 
	var G = (0, _radium2.default)(_container2.default);
	var Container = exports.Container = function Container(props) {
	  return _react2.default.createElement(
	    G,
	    props,
	    props.children
	  );
	};
	
	var R = (0, _radium2.default)(_row2.default);
	var Row = exports.Row = function Row(props) {
	  return _react2.default.createElement(
	    R,
	    props,
	    props.children
	  );
	};
	
	var C = (0, _radium2.default)(_col2.default);
	var Col = exports.Col = function Col(props) {
	  return _react2.default.createElement(
	    C,
	    props,
	    props.children
	  );
	};
	
	var AppImg = function (_React$Component) {
	  _inherits(AppImg, _React$Component);
	
	  function AppImg(props) {
	    _classCallCheck(this, AppImg);
	
	    var _this = _possibleConstructorReturn(this, (AppImg.__proto__ || Object.getPrototypeOf(AppImg)).call(this, props));
	
	    _this.state = { imageLoaded: false };
	    return _this;
	  }
	
	  _createClass(AppImg, [{
	    key: 'onImageLoad',
	    value: function onImageLoad(img) {
	      this.setState({ imageLoaded: true });
	      if (this.props.onImgLoad && typeof this.props.onImgLoad === 'function') this.props.onImgLoad(img);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var height = this.props.height;
	      var width = this.props.width;
	
	      var dimensionStyle = {};
	
	      if (height) dimensionStyle.height = height;
	      if (width) dimensionStyle.width = width;
	
	      var styles = Object.assign({}, dimensionStyle, this.props.style ? this.props.style : {});
	      var title = this.props.alt || "Seto Canvas Img";
	
	      if (this.state.imageLoaded === false) {
	        return _react2.default.createElement(
	          'div',
	          { style: styles, className: 'imgLoader' },
	          _react2.default.createElement(_Loader2.default, { noEffect: true, style: styles, className: this.props.className }),
	          this.props.src && _react2.default.createElement('img', { src: this.props.src, id: this.props.id, className: 'invisible', style: { width: '100%' }, title: title, alt: title, onLoad: this.onImageLoad.bind(this) })
	        );
	      }
	
	      return _react2.default.createElement('img', { src: this.props.src, id: this.props.id, title: title, alt: title, style: styles,
	        className: this.props.className,
	        onLoad: this.onImageLoad.bind(this) });
	    }
	  }]);
	
	  return AppImg;
	}(_react2.default.Component);
	
	;
	
	var Img = exports.Img = (0, _radium2.default)(function (props) {
	  return _react2.default.createElement(AppImg, props);
	});
	
	var Title = exports.Title = (0, _radium2.default)(function (props) {
	  if (!props.title) return null;
	
	  var styles = [{ color: '#3d3d3d', textAlign: 'center', margin: '20px 0',
	    '@media (max-width: 450px)': { fontSize: '190%' } }];
	
	  if (props.align) styles.push({ textAlign: props.align });
	
	  if (props.style) styles.push(props.style);
	
	  var h1 = _react2.default.createElement(
	    'h1',
	    { style: styles },
	    props.title
	  );
	
	  if (props.hideDivider) return h1;
	
	  var separatorPosition = props.separatorPosition || "bottom";
	  return _react2.default.createElement(
	    'div',
	    { className: 'scTitle' },
	    separatorPosition === 'top' && _react2.default.createElement(Separator, null),
	    h1,
	    separatorPosition === 'bottom' && _react2.default.createElement(Separator, null)
	  );
	});
	
	var Divdr = (0, _radium2.default)(_divider2.default);
	
	var Separator = exports.Separator = (0, _radium2.default)(function (props) {
	  var styles = { width: '80px', height: '3px', background: '#f49600', margin: '10px auto' };
	
	  if (props.style) styles = Object.assign({}, styles, props.style);
	
	  return _react2.default.createElement(Divdr, { style: styles });
	});
	
	var DEFAULT_SLIDER_SETTINGS = {
	  speed: 500,
	  infinite: false,
	  dots: true,
	  arrows: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  swipeToSlide: true,
	  swipe: true
	};
	
	var SCSlider = exports.SCSlider = function SCSlider(_ref) {
	  var children = _ref.children,
	      sliderRef = _ref.sliderRef,
	      sliderSettings = _ref.sliderSettings;
	
	  var settings = Object.assign({}, DEFAULT_SLIDER_SETTINGS);
	
	  if (sliderSettings) settings = Object.assign(settings, sliderSettings);
	
	  return _react2.default.createElement(
	    _reactSlick2.default,
	    Object.assign({ ref: sliderRef }, settings),
	    children
	  );
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _mobileDetect = __webpack_require__(329);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	var DELIVERY_TYPE = _AppConstants2.default.DELIVERY_TYPE;
	
	var DELIVERY_LOCATION_TYPE = _AppConstants2.default.DELIVERY_LOCATION_TYPE;
	var OUTSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY;
	
	var AppUtil = {
		isMobileDevice: function isMobileDevice() {
			return new _mobileDetect2.default(window.navigator.userAgent).mobile() !== null;
		},
		isDashainRunning: function isDashainRunning() {
			var startDate = new Date(2019, 9, 5);
			var endDate = new Date(2019, 9, 11);
			var today = new Date();
	
			return today.getTime() > startDate.getTime() && today.getTime() < endDate.getTime();
		},
		startsWithNumber: function startsWithNumber(arg) {
			if (!arg) return false;
	
			return arg.match(/^\d/);
		},
		phoneNumberValidation: function phoneNumberValidation() {
			var phoneNumberErrMsg = "Enter your valid 10 digit Nepali Phone Number.";
			return _yup2.default.string().trim().required(phoneNumberErrMsg).matches(/^9[678][0-9]{8}$/, phoneNumberErrMsg);
		},
	
		formatNumber: function formatNumber(arg) {
			return arg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
	
		scrollToHashTagIfAny: function scrollToHashTagIfAny(offset) {
			var id = window.location.hash.replace("#", "");
			if (id !== "") {
				setTimeout(function () {
					var element = document.getElementById(id);
					var elementPosition = element.getBoundingClientRect().top;
					var offsetPosition = elementPosition - (offset || 0);
	
					if (element) window.scrollTo({ top: offsetPosition, behavior: "smooth" });
				}, 0);
			}
		},
	
		//Scroll Options available here: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
		scrollToElement: function scrollToElement(elementId, scrollOptions) {
			var element = document.getElementById(elementId);
	
			if (element) element.scrollIntoView(scrollOptions);
		},
		scrollToTop: function scrollToTop() {
			window.scroll(0, 0);
		},
		isAuthorizedForProduct: function isAuthorizedForProduct(user, product) {
			var isAuthorized = user && (user.id === product.creator.id || user.userType === _AppConstants2.default.USER_TYPE.ADMIN);
			return isAuthorized;
		},
		isAdminUser: function isAdminUser(user) {
			var isAdmin = user && user.userType === _AppConstants2.default.USER_TYPE.ADMIN;
			return isAdmin;
		},
		getProductURL: function getProductURL(product) {
			var productType = PRODUCT_TYPES[product.productType];
			var productTypeStr = productType.url;
	
			if (productType.val === 'OTHER') return "/shop/" + encodeURIComponent(product.title) + "/" + product.id;
	
			return "/" + productTypeStr + "/" + encodeURIComponent(product.title) + "/" + product.id;
		},
		getProductEditURL: function getProductEditURL(product) {
			var productTypeStr = PRODUCT_TYPES[product.productType].url;
			return "/" + productTypeStr + "/edit/" + encodeURIComponent(product.title) + "/" + product.id;
		},
		getAddSubProductURL: function getAddSubProductURL(product) {
			var productTypeStr = PRODUCT_TYPES[product.productType].url;
			return "/" + productTypeStr + "/addSub/" + product.title + "/" + product.id;
		},
		getDesignerURL: function getDesignerURL(creator) {
			if (creator.storeName) return "/store/" + creator.storeName.replace(/ /g, "-");
	
			if (creator.userType && creator.userType === _AppConstants2.default.USER_TYPE["PHOTOGRAPHER"]) return "/photographer/" + creator.username + "/" + creator.id;else if (creator.userType && creator.userType === _AppConstants2.default.USER_TYPE["FASHION_DESIGNER"]) return "/fashion-designer/" + creator.username + "/" + creator.id;else if (creator.userType && (creator.userType === _AppConstants2.default.USER_TYPE["DESIGNER"] || creator.userType === _AppConstants2.default.USER_TYPE["INFLUENCER"])) return "/designer/" + creator.username + "/" + creator.id;
	
			return "#";
		},
		getCreaterName: function getCreaterName(creator) {
			if (creator.storeName) return creator.storeName;
	
			return creator.username;
		},
		getProductTitle: function getProductTitle(product) {
			var productTypeLabel = PRODUCT_TYPES[product.productType].label;
			if (product.productType === PRODUCT_TYPES.T_SHIRT.val || product.title.indexOf(productTypeLabel) >= 0) return product.title;
	
			return product.title + " - " + productTypeLabel;
		},
		findProductTypeFromURL: function findProductTypeFromURL(productTypeURL) {
			var matchedProductTypes = Object.keys(PRODUCT_TYPES).filter(function (k) {
				return PRODUCT_TYPES[k].url.toLowerCase() === productTypeURL.toLowerCase();
			});
	
			return matchedProductTypes.length === 1 ? PRODUCT_TYPES[matchedProductTypes[0]] : null;
		},
		calculatePercentDiff: function calculatePercentDiff(newValue, baseValue) {
			return (newValue - baseValue) / baseValue * 100.0;
		},
		getProductSizeOptions: function getProductSizeOptions(product) {
			var productSizes = AppUtil.getSizeInfo(product);
			var sizeOptions = AppUtil._getSizeOptions(productSizes, product.outofStock ? true : false);
			return sizeOptions;
		},
		_getSizeOptions: function _getSizeOptions(sizeMetaData, disableAll) {
			var sizes = Object.keys(sizeMetaData);
			var sizeOptions = [];
			for (var i = 0; i < sizes.length; i++) {
				var size = sizes[i];
				var label = sizeMetaData[size].label;
	
				if (disableAll && label.toLowerCase().indexOf("out of stock") < 0) label += " - Out of Stock";
	
				sizeOptions.push({ label: label, value: size,
					disabled: disableAll || label.toLowerCase().indexOf("out of stock") >= 0 });
			}
	
			return sizeOptions;
		},
		getOrderSizeString: function getOrderSizeString(order, product, shortStr) {
			var orderSizeMetaData = order.sizeMetaData;
	
			if (!product) {
				if (order.isBulkOrder) {
					return Object.keys(order.sizeQuantity).map(function (s) {
						return order.sizeQuantity[s] + " x " + s;
					}).join(", ");
				} else {
					var quantity = order.quantity;
					var orderSizes = order.productSizes;
					return quantity + " x " + orderSizes.toString();
				}
			} else {
				var sizeMetaData = orderSizeMetaData || AppUtil.getSizeInfo(product);
				if (order.isBulkOrder) {
					return Object.keys(order.sizeQuantity).map(function (s) {
						return order.sizeQuantity[s] + " x " + sizeMetaData[s].label;
					}).join(", ");
				} else {
					var _quantity = order.quantity;
					var _orderSizes = order.productSizes;
					if (this.isCoupleProduct(product)) return _quantity + " x Pair of Male: " + this._getSizeString([_orderSizes[0]], sizeMetaData, shortStr) + ", Female: " + this._getSizeString([_orderSizes[1]], sizeMetaData, shortStr);else return _quantity + " x " + this._getSizeString(_orderSizes, sizeMetaData, shortStr);
				}
			}
		},
		_getSizeString: function _getSizeString(orderSizes, sizeMetaData, shortStr) {
			return orderSizes.map(function (s) {
				var size = sizeMetaData[s];
	
				if (!size) return s;
	
				return shortStr ? size.shortLabel : size.label;
			}).toString();
		},
		getSizeInfo: function getSizeInfo(product) {
			return product.sizeMetaData ? product.sizeMetaData : PRODUCT_TYPES[product.productType].SIZE;
		},
		isCoupleProduct: function isCoupleProduct(product) {
			if (!product) return false;
	
			var productType = product.productType;
			return product.title.toLowerCase().indexOf("couple") >= 0 && (productType === PRODUCT_TYPES.T_SHIRT.val || productType === PRODUCT_TYPES.SWEAT_SHIRT.val || productType === PRODUCT_TYPES.HOODIES.val);
		},
		fetchYoutubeVideoID: function fetchYoutubeVideoID(link) {
			if (link && link.indexOf("https://www.youtube.com/watch?v=") === 0) return link.split("=")[1].split("&")[0];
	
			if (link && link.indexOf("https://youtu.be/") === 0) return link.split("https://youtu.be/")[1];
	
			if (link && link.indexOf("https://m.youtube.com/watch?v=") === 0) return link.split("https://m.youtube.com/watch?v=")[1].split("&")[0];
	
			if (link && link.indexOf("https://www.youtube.com/embed/") === 0) return link.split("https://www.youtube.com/embed/")[1];
	
			return null;
		},
	
		getDeliveryTime: function getDeliveryTime(productType, deliveryType) {
			var isPhotoFrame = productType === PRODUCT_TYPES['PHOTO_FRAME'].val;
			if (isPhotoFrame) {
				return "3-6 business days";
			} else {
				if (deliveryType === DELIVERY_TYPE.REGULAR.val) return "2-3 business days";else return "next 24 hours";
			}
		},
		getAppLogo: function getAppLogo() {
			var year = new Date().getFullYear();
	
			var logoImg = "logo.png";
			if (year === 2020) {
				var currMin = new Date().getMinutes();
	
				if (currMin % 2 === 0) logoImg = "santa_logo3.png";else if (currMin % 3 === 0) logoImg = "santa_logo2.png";else logoImg = "santa_logo1.png";
			}
	
			return "/images/" + logoImg;
		},
		getAppIcon: function getAppIcon() {
			var year = new Date().getFullYear();
	
			var iconImg = "canvas_icon.png";
			if (year === 2020) {
				iconImg = "canvas_icon_santa.png";
			}
	
			return "/images/" + iconImg;
		},
	
		isCustomProduct: function isCustomProduct(product) {
			if (!product) return false;
	
			var productTypes = Object.keys(_AppConstants2.default.PRODUCT_TYPES);
	
			for (var i = 0; i < productTypes.length; i++) {
				var customProductsIds = _AppConstants2.default.CUSTOM_PRODUCTS[productTypes[i]];
				if (customProductsIds && customProductsIds.indexOf(product.id) >= 0) return true;
			}
			return false;
		},
		getDefaultDeliveryType: function getDefaultDeliveryType(productType, locationType) {
			if (productType === _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val) {
				return DELIVERY_TYPE.REGULAR.val;
			} else {
				if (locationType === OUTSIDE_KTM_VALLEY.val) return DELIVERY_TYPE.REGULAR.val;
			}
	
			return '';
		},
		getDefaultProductImage: function getDefaultProductImage(product) {
			var productImage = '';
			if (product.productType !== _AppConstants2.default.PRODUCT_TYPES['T_SHIRT'].val) productImage = product.productImages[0];else if (product.productImages.length === 1) productImage = product.productImages[0];
	
			return productImage;
		},
		getUrlQueryParams: function getUrlQueryParams(location) {
			var queryParams = {};
	
			location.search.substring(1).split("&").forEach(function (p) {
				var data = p.split("=");
				queryParams[data[0]] = data[1];
			});
	
			return queryParams;
		},
		getLocationExtraCost: function getLocationExtraCost(locationType, product) {
			//TODO: to make it dynamic per product, we have this information in the database instead
			var productDeliveryLocationType = PRODUCT_TYPES[product.productType].deliveryLocationType;
	
			if (productDeliveryLocationType && productDeliveryLocationType[locationType]) {
				return productDeliveryLocationType[locationType].extraCost;
			}
	
			return DELIVERY_LOCATION_TYPE[locationType].extraCost;
		}
	};
	
	exports.default = AppUtil;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enhancer = __webpack_require__(184);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _plugins = __webpack_require__(189);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _style = __webpack_require__(347);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _styleRoot = __webpack_require__(345);
	
	var _styleRoot2 = _interopRequireDefault(_styleRoot);
	
	var _getState = __webpack_require__(186);
	
	var _getState2 = _interopRequireDefault(_getState);
	
	var _keyframes = __webpack_require__(348);
	
	var _keyframes2 = _interopRequireDefault(_keyframes);
	
	var _resolveStyles = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Radium(ComposedComponent) {
	  return (0, _enhancer2.default)(ComposedComponent);
	}
	
	Radium.Plugins = _plugins2.default;
	Radium.Style = _style2.default;
	Radium.StyleRoot = _styleRoot2.default;
	Radium.getState = _getState2.default;
	Radium.keyframes = _keyframes2.default;
	
	if (false) {
	  Radium.TestMode = {
	    clearState: _resolveStyles.__clearStateForTests,
	    disable: _resolveStyles.__setTestMode.bind(null, false),
	    enable: _resolveStyles.__setTestMode.bind(null, true)
	  };
	}
	
	exports.default = Radium;
	module.exports = exports['default'];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.HttpService = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(296);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _AppAction = __webpack_require__(22);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PROJECT_NAME = _AppConstants2.default.APP_NAME;
	
	var BITLY_API = _axios2.default.create({ baseURL: 'https://api-ssl.bit.ly/v3/', timeout: 300000 });
	
	var HttpService = exports.HttpService = function () {
		function HttpService(baseUrl) {
			_classCallCheck(this, HttpService);
	
			this.axios = _axios2.default.create({
				baseURL: baseUrl,
				timeout: 900000
			});
	
			this.afterLoginCallback = null;
			this.defaultErrorHandler = this.defaultErrorHandler.bind(this);
	
			this.saveAfterLoginCallback = this.saveAfterLoginCallback.bind(this);
		}
	
		_createClass(HttpService, [{
			key: 'redirect',
			value: function redirect(url) {
				//TODO: figure out a better way to do it
				window.location.href = url;
			}
		}, {
			key: 'saveAfterLoginCallback',
			value: function saveAfterLoginCallback(callback) {
				this.afterLoginCallback = callback;
			}
		}, {
			key: 'defaultErrorHandler',
			value: function defaultErrorHandler(error) {
				console.log("UI Error", error);
	
				if (error.response) _Dispatcher2.default.dispatchAnAlert(error.response.data);else if (error.message === "Network Error") _Dispatcher2.default.dispatchAnAlert({ message: "NETWORK ERROR: Could not connect to the server. Please try again later.", type: "ERROR" });else if (error.message.indexOf("timeout") >= 0) _Dispatcher2.default.dispatchAnAlert({ message: "TIMEOUT ERROR: Could not fetch your data. Please try again later.", type: "ERROR" });else if (error.message) _Dispatcher2.default.dispatchAnAlert({ message: error.message, type: "ERROR" });
	
				if (error.response) {
					if (error.response.status === 401) {
						this.logout();
						_Dispatcher2.default.dispatchAlertWithAction(_AppConstants2.default.LOGIN_TO_CONTINUE_MSG, "WARN");
					} else if (error.response.status === 404) {
						this.redirect("/404");
					}
				}
			}
		}, {
			key: 'get',
			value: function get(url, onSuccess, onError) {
				var errorHandler = onError || this.defaultErrorHandler;
	
				this.axios({
					url: url,
					method: 'get',
					headers: this.getHeaders()
				}).then(onSuccess).catch(errorHandler);
			}
		}, {
			key: 'post',
			value: function post(url, postData, onSuccess, onError) {
				var errorHandler = onError || this.defaultErrorHandler.bind(this);
				this.axios({
					url: url,
					method: 'post',
					data: postData,
					headers: this.getHeaders()
				}).then(onSuccess).catch(errorHandler);
			}
		}, {
			key: 'postFormData',
			value: function postFormData(url, postData, onSuccess, onError) {
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				var errorHandler = onError || this.defaultErrorHandler.bind(this);
				this.axios({
					url: url,
					method: 'post',
					data: postData,
					headers: headers
				}).then(onSuccess).catch(errorHandler);
			}
		}, {
			key: 'delete',
			value: function _delete(url, onSuccess, onError) {
				var errorHandler = onError || this.defaultErrorHandler;
				this.axios({
					url: url,
					method: 'delete',
					headers: this.getHeaders()
				}).then(onSuccess).catch(errorHandler);
			}
		}, {
			key: 'getHeaders',
			value: function getHeaders() {
				var headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
	
				var session = _SessionStore2.default.getCurrentSession();
				if (session !== null) headers['Authorization'] = 'Bearer ' + session.token;
	
				return headers;
			}
		}, {
			key: 'login',
			value: function login(email, password, callback) {
				var loginData = { 'password': btoa(password) };
				if (_AppUtil2.default.startsWithNumber(email)) {
					loginData['phoneNumber'] = email;
					loginData['loginType'] = "PHONE_LOGIN";
				} else {
					loginData['email'] = email;
					loginData['loginType'] = "REGULAR";
				}
	
				this.doLogin(loginData, callback);
			}
		}, {
			key: 'loginWithFB',
			value: function loginWithFB(accessToken, callback) {
				var data = { 'fbAccessToken': accessToken, 'loginType': 'FB_CONNECT' };
				this.doLogin(data, callback);
			}
		}, {
			key: 'loginWithGEmail',
			value: function loginWithGEmail(idToken, callback) {
				var data = { 'gmailIdToken': idToken, 'loginType': 'GMAIL_SIGN_IN' };
				this.doLogin(data, callback);
			}
		}, {
			key: 'doLogin',
			value: function doLogin(loginRequest, callback) {
				var _this = this;
	
				this.post("/user/login", loginRequest, function (response) {
					var bearerToken = response.data['bearer'];
					var user = response.data['user'];
					var expiresOn = response.data['expiresOn'];
	
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.LOGIN_SUCCESS,
						user: user,
						token: bearerToken,
						expiresOn: expiresOn
					});
	
					//call any callback if saved
					if (typeof _this.afterLoginCallback === "function") {
						_this.afterLoginCallback();
						_this.afterLoginCallback = null;
					}
	
					if (loginRequest.loginType === 'SIGNUP_AND_LOGIN') {
						if (loginRequest.email) _Dispatcher2.default.dispatchAlertWithAction("Your " + PROJECT_NAME + " account has been created. Do verify your email by following the instruction sent to '" + loginRequest.email + "'.", "INFO", "LOGGED_IN");else _Dispatcher2.default.dispatchAlertWithAction("Your " + PROJECT_NAME + " account has been created.", "INFO", "LOGGED_IN");
					}
	
					if (typeof callback === 'function') callback(true);
				}, function (error) {
					_this.defaultErrorHandler(error);
					if (typeof callback === 'function') {
						if (error.response) {
							callback(false, error.response.data);
						} else {
							callback(false, error);
						}
					}
				});
			}
		}, {
			key: 'logout',
			value: function logout() {
				_Dispatcher2.default.dispatch({
					type: _AppAction.UserAction.LOGOUT
				});
			}
		}, {
			key: 'getUserBasicInfo',
			value: function getUserBasicInfo(storeName, userId) {
				var url = "/user/profile/basic";
	
				if (storeName) url += "?storeName=" + storeName;else if (userId) url += "?userId=" + userId;
	
				this.get(url, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.LOAD_USER_PROFILE,
						userInfo: response.data,
						storeName: storeName,
						userId: userId
					});
				});
			}
		}, {
			key: 'updateUserInfo',
			value: function updateUserInfo(userInfo, callback) {
				var _this2 = this;
	
				this.post("/user/userinfo", userInfo, function (response) {
					var updatedUser = response.data['user'];
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.LOGIN_SUCCESS,
						user: updatedUser,
						token: response.data['bearer'],
						expiresOn: response.data['expiresOn']
	
					});
	
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.LOAD_USER_PROFILE,
						userInfo: updatedUser,
						storeName: updatedUser.storeName,
						userId: updatedUser.id
					});
	
					_Dispatcher2.default.dispatchAnAlert("Your account info updated successfully.");
					callback(true);
				}, function (error) {
					_this2.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'upgradeToDesigner',
			value: function upgradeToDesigner(callback) {
				var _this3 = this;
	
				this.post("/designer/upgrade", null, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.LOGIN_SUCCESS,
						user: response.data['user'],
						token: response.data['bearer'],
						expiresOn: response.data['expiresOn']
					});
	
					callback(true);
				}, function (error) {
					_this3.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'updatePhone',
			value: function updatePhone(phoneNumber, callback) {
				var _this4 = this;
	
				this.post("/user/phone?number=" + phoneNumber, null, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.PHONE_UPDATE,
						phoneNumber: phoneNumber
					});
	
					_Dispatcher2.default.dispatchAnAlert(response.data);
					callback(true);
				}, function (error) {
					_this4.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'addProduct',
			value: function addProduct(addProductRequestJson, previewImage, productImages, callback) {
				var _this5 = this;
	
				var formData = new FormData();
				formData.append("addProductRequestJson", JSON.stringify(addProductRequestJson));
	
				if (previewImage) formData.append("previewImageFile", previewImage);
	
				for (var i = 0; i < productImages.length; i++) {
					var productImage = productImages[i];
	
					formData.append("productImagesFile", productImage);
				}
	
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				this.axios({
					url: "/product/add",
					method: 'post',
					data: formData,
					headers: headers
				}).then(function (response) {
					var user = _SessionStore2.default.getCurrentSession().user;
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.UPLOAD_NEW_PRODUCT,
						userId: user.id
					});
	
					_Dispatcher2.default.dispatchAnAlert("Product added successfully. Our team will verify your design and will contact you soon.");
					callback(true);
				}).catch(function (response) {
					callback(false);
					_this5.defaultErrorHandler(response);
				});
			}
		}, {
			key: 'addSubProduct',
			value: function addSubProduct(addSubProductRequestJson, productImages, callback) {
				var _this6 = this;
	
				var formData = new FormData();
				formData.append("addSubProductRequestJson", JSON.stringify(addSubProductRequestJson));
	
				for (var i = 0; i < productImages.length; i++) {
					var productImage = productImages[i];
					formData.append("productImagesFile", productImage);
				}
	
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				this.axios({
					url: "/product/add/subproduct",
					method: 'post',
					data: formData,
					headers: headers
				}).then(function (response) {
					var user = _SessionStore2.default.getCurrentSession().user;
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.UPLOAD_NEW_PRODUCT,
						userId: user.id
					});
	
					_Dispatcher2.default.dispatchAnAlert("Product added successfully.");
					callback(true);
				}).catch(function (response) {
					callback(false);
					_this6.defaultErrorHandler(response);
				});
			}
		}, {
			key: 'getProduct',
			value: function getProduct(productId) {
				this.get("/product/" + productId, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_SINGLE_PRODUCT,
						product: response.data,
						productId: productId
					});
				});
			}
		}, {
			key: 'updateProductInfo',
			value: function updateProductInfo(productId, product, callback) {
				var _this7 = this;
	
				this.post("/product/" + productId, product, function (response) {
	
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_SINGLE_PRODUCT,
						product: response.data,
						productId: productId
					});
	
					_Dispatcher2.default.dispatchAnAlert("Product Information Updated successfully.");
					callback(true);
				}, function (error) {
					_this7.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'updatePreviewImage',
			value: function updatePreviewImage(productId, newImage, callback) {
				var _this8 = this;
	
				var formData = new FormData();
				formData.append("newImageFile", newImage);
	
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				this.axios({
					url: "/product/" + productId + "/updatePreviewImage",
					method: 'post',
					data: formData,
					headers: headers
				}).then(function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_SINGLE_PRODUCT,
						product: response.data,
						productId: productId
					});
	
					_Dispatcher2.default.dispatchAnAlert("Preview Image Modified Successfully.");
					callback(true);
				}).catch(function (response) {
					_this8.defaultErrorHandler(response);
					callback(false);
				});
			}
		}, {
			key: 'updateProductImage',
			value: function updateProductImage(productId, imageUrl, newImage, callback) {
				var _this9 = this;
	
				var formData = new FormData();
				formData.append("currentImageUrl", imageUrl);
				formData.append("newImageFile", newImage);
	
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				this.axios({
					url: "/product/" + productId + "/updateImage",
					method: 'post',
					data: formData,
					headers: headers
				}).then(function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_SINGLE_PRODUCT,
						product: response.data,
						productId: productId
					});
	
					_Dispatcher2.default.dispatchAnAlert("Product Image Modified Successfully.");
					callback(true);
				}).catch(function (response) {
					_this9.defaultErrorHandler(response);
					callback(false);
				});
			}
		}, {
			key: 'addNewProductImage',
			value: function addNewProductImage(productId, newImage, callback) {
				var _this10 = this;
	
				var formData = new FormData();
				formData.append("newImageFile", newImage);
	
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				this.axios({
					url: "/product/" + productId + "/addImage",
					method: 'post',
					data: formData,
					headers: headers
				}).then(function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_SINGLE_PRODUCT,
						product: response.data,
						productId: productId
					});
	
					_Dispatcher2.default.dispatchAnAlert("Product Image Uploaded Successfully.");
					callback(true);
				}).catch(function (response) {
					_this10.defaultErrorHandler(response);
					callback(false);
				});
			}
		}, {
			key: 'deleteProductImage',
			value: function deleteProductImage(productId, imageUrl, callback) {
				var _this11 = this;
	
				this.delete("/product/" + productId + "/productImage?imageUrl=" + imageUrl, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_SINGLE_PRODUCT,
						product: response.data,
						productId: productId
					});
	
					_Dispatcher2.default.dispatchAnAlert("Product Image deleted successfully.");
					callback(true);
				}, function (error) {
					_this11.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'publishUnpublishProduct',
			value: function publishUnpublishProduct(productId, publish, callback) {
				var _this12 = this;
	
				var str = publish === true ? "publish" : "unpublish";
				this.post("/product/" + productId + "/" + str, null, function (response) {
	
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_SINGLE_PRODUCT,
						product: response.data,
						productId: productId
					});
	
					_Dispatcher2.default.dispatchAnAlert("Product " + str + "ed successfully.");
					callback(true);
				}, function (error) {
					_this12.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'getFeaturedProductsForDashain',
			value: function getFeaturedProductsForDashain() {
				this.get("/dashaincampaign/featuredproducts", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_DASHAIN_FEATURED_PRODUCTS,
						products: response.data
					});
				});
			}
		}, {
			key: 'getRecentProducts',
			value: function getRecentProducts(pageNumber, pageSize, callback) {
				var pgNumber = pageNumber || 0;
				var pgSize = pageSize || _AppConstants2.default.DEFAULT_PRODUCT_PAGE_SIZE;
	
				this.get("/product/recent?pageNumber=" + pgNumber + "&pageSize=" + pgSize, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_RECENT_PRODUCTS,
						products: response.data,
						nextPageNumber: pgNumber + 1,
						pageSize: pgSize
					});
	
					if (typeof callback === 'function') callback(response.data);
				});
			}
		}, {
			key: 'getCreatorProducts',
			value: function getCreatorProducts(creator) {
				if (creator.storeName) this.getStoreProducts(creator.storeName);else this.getProducts(creator.id);
			}
		}, {
			key: 'getProducts',
			value: function getProducts(userId) {
				this.get("/product/" + userId + "/list", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_USER_PRODUCTS,
						products: response.data,
						userId: userId
					});
				});
			}
		}, {
			key: 'getStoreProducts',
			value: function getStoreProducts(storeName) {
				this.get("/product/store/" + storeName, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_STORE_PRODUCTS,
						products: response.data,
						storeName: storeName
					});
				});
			}
		}, {
			key: 'getProductStat',
			value: function getProductStat(productId) {
				this.get("/product/" + productId + "/productstat", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_PRODUCT_STAT,
						productStat: response.data,
						productId: productId
					});
				});
			}
		}, {
			key: 'deleteProduct',
			value: function deleteProduct(productId) {
				this.delete("/product/" + productId, function (response) {
					//TODO: dispatch  DELETE EVENT and redirect to home page too
					_Dispatcher2.default.dispatchAnAlert(response.data);
				});
			}
		}, {
			key: 'getAllProducts',
			value: function getAllProducts(productState) {
				this.get("/product/list?productState=" + productState, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_ALL_PRODUCTS,
						products: response.data,
						productState: productState
					});
				});
			}
		}, {
			key: 'increaseCurrentTarget',
			value: function increaseCurrentTarget(productId, target, callback) {
				var _this13 = this;
	
				this.post("/product/" + productId + "/salesTarget/increase?target=" + target, null, function (response) {
					_Dispatcher2.default.dispatchAnAlert("Your sales target is active and running.");
					callback(true);
				}, function (error) {
					_this13.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'getProductOrders',
			value: function getProductOrders(productId) {
				this.get("/product/" + productId + "/orders", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.LOAD_PRODUCT_ORDERS,
						orders: response.data,
						productId: productId
					});
				});
			}
		}, {
			key: 'getAllOrders',
			value: function getAllOrders(orderStates) {
				this.get("/order/list?orderStates=" + orderStates, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.LOAD_ALL_ORDERS_BY_STATE,
						orders: response.data,
						orderStates: orderStates
					});
				});
			}
	
			/** Dashain Campaign Orders */
	
		}, {
			key: 'getDashainCampaignOrders',
			value: function getDashainCampaignOrders() {
				this.get("/dashaincampaign/orders", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.LOAD_DASHAIN_CAMPAIGN_ORDERS,
						orders: response.data
					});
				});
			}
		}, {
			key: 'getMyOrders',
			value: function getMyOrders(orderStates) {
				this.get("/order/list/my", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.LOAD_USER_ORDERS,
						orders: response.data
					});
				});
			}
		}, {
			key: 'getDesignerPendingOrders',
			value: function getDesignerPendingOrders(userId) {
				var url = "/designer/orders/pending";
	
				if (userId) url += "?userId=" + userId;
	
				this.get(url, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.DesignerAction.LOAD_ALL_PENDING_ORDERS,
						orders: response.data
					});
				});
			}
		}, {
			key: 'getOrderStat',
			value: function getOrderStat() {
				this.get("/order/stat", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.LOAD_ORDER_STAT,
						stat: response.data
					});
				});
			}
		}, {
			key: 'getOrder',
			value: function getOrder(orderId) {
				this.get("/order/" + orderId, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.LOAD_SINGLE_ORDER,
						order: response.data
					});
				});
			}
		}, {
			key: 'updateOrder',
			value: function updateOrder(orderId, order, callback) {
				var _this14 = this;
	
				this.post("/order/" + orderId + "/update", order, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.UPDATE_SINGLE_ORDER,
						order: response.data
					});
	
					_Dispatcher2.default.dispatchAnAlert("Order updated successfully.");
					callback(true);
				}, function (error) {
					_this14.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'getRedeemHistory',
			value: function getRedeemHistory() {
				this.get("/redeem/list", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.RedeemAction.LOAD_REDEEM_HISTORY,
						redeemHistory: response.data
					});
				});
			}
		}, {
			key: 'getDesignerBalance',
			value: function getDesignerBalance(userId) {
				var url = "/designer/balance";
	
				if (userId) url += "?userId=" + userId;
	
				this.get(url, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.DesignerAction.LOAD_BALANCE,
						balance: response.data
					});
				});
			}
		}, {
			key: 'redeem',
			value: function redeem(cachableSalesTargetId, sendToDetail, callback) {
				var _this15 = this;
	
				var postData = {
					toCashSalesTarget: cachableSalesTargetId,
					sendToDetail: sendToDetail
				};
	
				this.post("/redeem", postData, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.RedeemAction.REDEEMED
					});
	
					_Dispatcher2.default.dispatchAnAlert(response.data);
	
					callback(true);
				}, function (error) {
					_this15.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'getPopularStores',
			value: function getPopularStores() {
				this.get("/user/stores/popular", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.DesignerAction.LOAD_POPULAR_STORES,
						stores: response.data
					});
				});
			}
		}, {
			key: 'bitlyShortenURL',
			value: function bitlyShortenURL(longURL, onShorten) {
				var apiKey = _AppConstants2.default.BITLY_API_KEY;
				var apiLogin = _AppConstants2.default.BITLY_LOGIN;
				var apiUrl = "/shorten?login=" + apiLogin + "&apiKey=" + apiKey + "&longUrl=" + longURL + "&format=json";
	
				BITLY_API.get(apiUrl).then(function (response) {
					onShorten(response.data.data.url);
				});
			}
		}]);
	
		return HttpService;
	}();
	
	exports.default = new HttpService(_AppConstants2.default.BASE_API_URL);

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.RGForm = exports.ComboBox = exports.RadioButton = exports.Checkbox = exports.TextArea = exports.Input = exports.SubmitButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(21);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _button = __webpack_require__(84);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _reactSelect = __webpack_require__(144);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var errorStyle = { color: "rgb(250, 16, 0)", fontSize: "12px", display: "block", marginBottom: "10px" };
	
	var InputField = (0, _radium2.default)(function (_ref) {
		var field = _ref.field,
		    _ref$form = _ref.form,
		    touched = _ref$form.touched,
		    errors = _ref$form.errors,
		    props = _objectWithoutProperties(_ref, ['field', 'form']);
	
		var label = props.label ? _react2.default.createElement(
			'label',
			null,
			props.label
		) : '';
	
		var input = _react2.default.createElement('input', Object.assign({}, field, props));
	
		//by default its on
		if (props.mui !== "off") input = _react2.default.createElement(
			'div',
			{ className: 'mui-textfield' },
			label,
			input
		);
	
		return _react2.default.createElement(
			'span',
			null,
			label !== '' && props.mui === "off" && label,
			input,
			touched[field.name] && errors[field.name] && _react2.default.createElement(
				'span',
				{ style: errorStyle },
				errors[field.name]
			)
		);
	});
	
	var ComboBoxField = (0, _radium2.default)(function (_ref2) {
		var field = _ref2.field,
		    _ref2$form = _ref2.form,
		    touched = _ref2$form.touched,
		    errors = _ref2$form.errors,
		    setFieldValue = _ref2$form.setFieldValue,
		    setFieldTouched = _ref2$form.setFieldTouched,
		    props = _objectWithoutProperties(_ref2, ['field', 'form']);
	
		var fieldName = field.name;
	
		var onFieldChange = function onFieldChange(opt) {
			var value = null;
			if (opt) {
				value = props.multi === true ? opt.map(function (o) {
					return o.value;
				}) : opt.value;
			} else {
				value = props.multi === true ? [] : '';
			}
	
			setFieldValue(fieldName, value);
	
			if (props.onComboChange && typeof props.onComboChange === 'function') props.onComboChange(value, setFieldValue);
		};
	
		var onFieldBlur = function onFieldBlur(opt) {
			setFieldTouched(fieldName, true);
		};
	
		var containerStyle = [{ margin: '20px 0' }];
	
		if (props.style) containerStyle.push(props.style);
	
		var labelStyle = { color: 'rgba(0,0,0,.54)', fontSize: '12px', fontWeight: '400', lineHeight: '15px' };
		var label = props.label ? _react2.default.createElement(
			'label',
			{ style: labelStyle },
			props.label
		) : '';
	
		var isCreatable = props.creatable && props.creatable === true;
		var isAsync = props.async && props.async === true;
		return _react2.default.createElement(
			'div',
			{ style: containerStyle },
			label !== '' && label,
			isCreatable && isAsync && _react2.default.createElement(_reactSelect2.default.AsyncCreatable, Object.assign({ onChange: onFieldChange, onBlur: onFieldBlur }, props)),
			isCreatable && !isAsync && _react2.default.createElement(_reactSelect2.default.Creatable, Object.assign({ onChange: onFieldChange, onBlur: onFieldBlur }, props)),
			!isCreatable && isAsync && _react2.default.createElement(_reactSelect2.default.Async, Object.assign({ onChange: onFieldChange, onBlur: onFieldBlur }, props)),
			!isCreatable && !isAsync && _react2.default.createElement(_reactSelect2.default, Object.assign({ onChange: onFieldChange, onBlur: onFieldBlur }, props)),
			touched[field.name] && errors[field.name] && _react2.default.createElement(
				'span',
				{ style: errorStyle },
				errors[field.name]
			)
		);
	});
	
	var TextAreaField = (0, _radium2.default)(function (_ref3) {
		var field = _ref3.field,
		    _ref3$form = _ref3.form,
		    touched = _ref3$form.touched,
		    errors = _ref3$form.errors,
		    props = _objectWithoutProperties(_ref3, ['field', 'form']);
	
		var label = props.label ? _react2.default.createElement(
			'span',
			null,
			_react2.default.createElement(
				'label',
				null,
				props.label
			),
			_react2.default.createElement('br', null),
			_react2.default.createElement('br', null)
		) : '';
		var input = _react2.default.createElement('textarea', Object.assign({}, field, props));
	
		if (props.mui !== "off") input = _react2.default.createElement(
			'div',
			{ className: 'mui-textfield' },
			label,
			input
		);
	
		return _react2.default.createElement(
			'span',
			{ style: props.style },
			label !== '' && props.mui === "off" && label,
			input,
			touched[field.name] && errors[field.name] && _react2.default.createElement(
				'span',
				{ style: errorStyle },
				errors[field.name]
			)
		);
	});
	
	var CheckBoxField = (0, _radium2.default)(function (_ref4) {
		var field = _ref4.field,
		    _ref4$form = _ref4.form,
		    touched = _ref4$form.touched,
		    errors = _ref4$form.errors,
		    props = _objectWithoutProperties(_ref4, ['field', 'form']);
	
		return _react2.default.createElement(
			'span',
			null,
			_react2.default.createElement('input', Object.assign({}, props, { id: field.name, type: 'checkbox', checked: field.value, onChange: function onChange(event) {
	
					if (typeof props.onChange === 'function') props.onChange(event);
	
					field.onChange(event);
				} })),
			_react2.default.createElement(
				'label',
				{ htmlFor: field.name, style: { cursor: 'pointer' } },
				' ',
				props.label
			),
			_react2.default.createElement('br', null),
			touched[field.name] && errors[field.name] && _react2.default.createElement(
				'span',
				{ style: errorStyle },
				errors[field.name]
			)
		);
	});
	
	var RadioField = (0, _radium2.default)(function (_ref5) {
		var field = _ref5.field,
		    _ref5$form = _ref5.form,
		    touched = _ref5$form.touched,
		    errors = _ref5$form.errors,
		    props = _objectWithoutProperties(_ref5, ['field', 'form']);
	
		var label = props.label ? props.label : '';
	
		var input = _react2.default.createElement('input', Object.assign({}, field, props, { type: 'radio' }));
	
		//by default its on
		if (props.mui !== "off") input = _react2.default.createElement(
			'div',
			{ className: 'mui-radio' },
			_react2.default.createElement(
				'label',
				null,
				input,
				' ',
				label
			)
		);
	
		return _react2.default.createElement(
			'span',
			{ style: props.style },
			input,
			label !== '' && props.mui === "off" && _react2.default.createElement(
				'label',
				null,
				' ',
				label
			),
			touched[field.name] && errors[field.name] && _react2.default.createElement(
				'span',
				{ style: errorStyle },
				errors[field.name]
			)
		);
	});
	
	//Note: Don't pass array of styles. Radium does not work with MUIButton in older version of Firefox
	var SubmitButton = exports.SubmitButton = function SubmitButton(props) {
		return _react2.default.createElement(_button2.default, Object.assign({ variant: 'raised', type: 'submit' }, props, { disabled: props.disabled }));
	};
	
	var Input = exports.Input = function Input(props) {
		return _react2.default.createElement(_formik.Field, Object.assign({}, props, { component: InputField }));
	};
	
	var TextArea = exports.TextArea = function TextArea(props) {
		return _react2.default.createElement(_formik.Field, Object.assign({}, props, { component: TextAreaField }));
	};
	
	var Checkbox = exports.Checkbox = function Checkbox(props) {
	
		return _react2.default.createElement(_formik.Field, Object.assign({}, props, { component: CheckBoxField }));
	};
	
	var RadioButton = exports.RadioButton = function RadioButton(props) {
	
		return _react2.default.createElement(_formik.Field, Object.assign({}, props, { component: RadioField }));
	};
	
	var ComboBox = exports.ComboBox = function ComboBox(props) {
	
		return _react2.default.createElement(_formik.Field, Object.assign({}, props, { component: ComboBoxField }));
	};
	
	var RGForm = exports.RGForm = (0, _radium2.default)(function (props) {
		return _react2.default.createElement(
			_formik.Form,
			{ style: props.style },
			props.children
		);
	});

/***/ },
/* 14 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Container = __webpack_require__(318);
	module.exports.Mixin = __webpack_require__(320);
	module.exports.ReduceStore = __webpack_require__(321);
	module.exports.Store = __webpack_require__(179);


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _NoticeBanner = __webpack_require__(569);
	
	var _NoticeBanner2 = _interopRequireDefault(_NoticeBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SetoCanvasPage(_ref) {
		var title = _ref.title,
		    metaDescription = _ref.metaDescription,
		    id = _ref.id,
		    children = _ref.children,
		    preContainerComp = _ref.preContainerComp,
		    postContainerComp = _ref.postContainerComp,
		    noticeMessage = _ref.noticeMessage,
		    turnOffSticky = _ref.turnOffSticky;
	
		return _react2.default.createElement(
			'div',
			{ id: id },
			_react2.default.createElement(
				_reactHelmet.Helmet,
				null,
				_react2.default.createElement(
					'title',
					null,
					title || "Seto Canvas"
				),
				metaDescription && _react2.default.createElement('meta', { name: 'description', content: metaDescription })
			),
			noticeMessage && _react2.default.createElement(
				_NoticeBanner2.default,
				null,
				noticeMessage
			),
			_react2.default.createElement(_HeaderContainer2.default, { turnOffSticky: turnOffSticky }),
			preContainerComp,
			_react2.default.createElement(
				'div',
				{ className: 'mainContainer' },
				children
			),
			postContainerComp,
			_react2.default.createElement(_Footer2.default, null)
		);
	}
	
	exports.default = (0, _radium2.default)(SetoCanvasPage);

/***/ },
/* 17 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _flux = __webpack_require__(316);
	
	var _AppAction = __webpack_require__(22);
	
	var dispatcher = new _flux.Dispatcher();
	
	dispatcher.dispatchAlertWithAction = function (msgText, msgType, msgAction, actionData) {
		dispatcher.dispatch({
			type: _AppAction.MessageAction.MESSAGE_WITH_ACTION,
			message: { 'message': msgText, 'type': msgType, 'alertAction': msgAction, 'actionData': actionData }
		});
	};
	
	dispatcher.dispatchAnAlert = function (message) {
		dispatcher.dispatch({
			type: _AppAction.MessageAction.MESSAGE,
			message: message
		});
	};
	
	dispatcher.dispatchClearAlert = function () {
		dispatcher.dispatch({
			type: _AppAction.MessageAction.CLEAR_MESSAGE
		});
	};
	
	exports.default = dispatcher;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidationError = exports.addMethod = exports.isSchema = exports.reach = exports.lazy = exports.ref = exports.array = exports.object = exports.date = exports.boolean = exports.bool = exports.number = exports.string = exports.mixed = undefined;
	
	var _mixed = __webpack_require__(51);
	
	var _mixed2 = _interopRequireDefault(_mixed);
	
	var _boolean = __webpack_require__(775);
	
	var _boolean2 = _interopRequireDefault(_boolean);
	
	var _string = __webpack_require__(779);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _number = __webpack_require__(777);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _date = __webpack_require__(776);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _object = __webpack_require__(778);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _array = __webpack_require__(774);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _Reference = __webpack_require__(77);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _Lazy = __webpack_require__(773);
	
	var _Lazy2 = _interopRequireDefault(_Lazy);
	
	var _ValidationError = __webpack_require__(152);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	var _reach = __webpack_require__(783);
	
	var _reach2 = _interopRequireDefault(_reach);
	
	var _isSchema = __webpack_require__(52);
	
	var _isSchema2 = _interopRequireDefault(_isSchema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var boolean = _boolean2.default;
	var ref = function ref(key, options) {
	  return new _Reference2.default(key, options);
	};
	
	var lazy = function lazy(fn) {
	  return new _Lazy2.default(fn);
	};
	
	function addMethod(schemaType, name, fn) {
	  if (!schemaType || !(0, _isSchema2.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
	
	  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
	  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
	
	  schemaType.prototype[name] = fn;
	}
	
	exports.mixed = _mixed2.default;
	exports.string = _string2.default;
	exports.number = _number2.default;
	exports.bool = _boolean2.default;
	exports.boolean = boolean;
	exports.date = _date2.default;
	exports.object = _object2.default;
	exports.array = _array2.default;
	exports.ref = ref;
	exports.lazy = lazy;
	exports.reach = _reach2.default;
	exports.isSchema = _isSchema2.default;
	exports.addMethod = addMethod;
	exports.ValidationError = _ValidationError2.default;
	exports.default = {
	  mixed: _mixed2.default,
	  string: _string2.default,
	  number: _number2.default,
	  bool: _boolean2.default,
	  boolean: boolean,
	  date: _date2.default,
	  object: _object2.default,
	  array: _array2.default,
	  ref: ref,
	  lazy: lazy,
	  reach: _reach2.default,
	  isSchema: _isSchema2.default,
	  addMethod: addMethod,
	  ValidationError: _ValidationError2.default
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Session = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(43);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(15);
	
	var _AppAction = __webpack_require__(22);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Session = new _immutable2.default.Record({
		user: null,
		createdDate: null,
		token: null,
		expiresOn: null
	});
	
	var SessionStore = function (_ReduceStore) {
		_inherits(SessionStore, _ReduceStore);
	
		function SessionStore() {
			_classCallCheck(this, SessionStore);
	
			return _possibleConstructorReturn(this, (SessionStore.__proto__ || Object.getPrototypeOf(SessionStore)).call(this, _Dispatcher2.default));
		}
	
		_createClass(SessionStore, [{
			key: 'getInitialState',
			value: function getInitialState() {
				try {
					this.USER_SESSION_CACHE = "User_Session";
	
					var sessionJson = JSON.parse(_CacheService2.default.get(this.USER_SESSION_CACHE));
					var session = new Session(sessionJson);
	
					var expiresOn = session.get('expiresOn');
					var currentTime = new Date().getTime();
					if (expiresOn === null || currentTime > expiresOn) {
						_CacheService2.default.remove(this.USER_SESSION_CACHE);
						_CacheService2.default.remove(_AppConstants2.default.USER_ADDRESS_KEY);
						return new Session(); //return empty session
					}
	
					return session;
				} catch (error) {
					console.log("Session Init State error", error);
					return new Session(); //return empty session
				}
			}
		}, {
			key: 'getCurrentSession',
			value: function getCurrentSession() {
				if (!this.getState()) return null;
	
				return this.getState().user === null ? null : this.getState();
			}
		}, {
			key: '_updateUser',
			value: function _updateUser(updatedUser) {
				var newState = this.getState().set('user', updatedUser);
				_CacheService2.default.save(this.USER_SESSION_CACHE, JSON.stringify(newState.toJSON()), true);
				return new Session(newState.toJS());
			}
		}, {
			key: 'reduce',
			value: function reduce(state, action) {
				switch (action.type) {
					case _AppAction.UserAction.LOGIN_SUCCESS:
						var sessionJson = { user: action.user, token: action.token, createdDate: new Date(), expiresOn: action.expiresOn };
						_CacheService2.default.save(this.USER_SESSION_CACHE, JSON.stringify(sessionJson), true);
						return new Session(sessionJson);
	
					case _AppAction.UserAction.LOGOUT:
						_CacheService2.default.remove(this.USER_SESSION_CACHE);
						_CacheService2.default.remove(_AppConstants2.default.USER_ADDRESS_KEY);
						return new Session();
	
					case _AppAction.UserAction.USER_UPDATE:
						var sessJson = { user: action.user, token: action.token, createdDate: new Date() };
						_CacheService2.default.save(this.USER_SESSION_CACHE, JSON.stringify(sessJson), true);
						return new Session(sessJson);
					case _AppAction.UserAction.PHONE_UPDATE:
						var phoneUpdatedUser = this.getState().user;
						phoneUpdatedUser.phoneNumber = action.phoneNumber;
	
						return this._updateUser(phoneUpdatedUser);
					case _AppAction.UserAction.PROFILE_PIC_UPDATE:
						var picUpdateUser = this.getState().user;
						picUpdateUser.profilePicture = action.profilePicture;
						return this._updateUser(picUpdateUser);
	
					case _AppAction.UserAction.BANNER_UPDATE:
						var bannerUpdateUser = this.getState().user;
						bannerUpdateUser.bannerImages = action.bannerImages;
						return this._updateUser(bannerUpdateUser);
					default:
						break;
				}
				return state;
			}
		}]);
	
		return SessionStore;
	}(_utils.ReduceStore);
	
	exports.Session = Session;
	exports.default = new SessionStore();

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var React = __webpack_require__(1);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	}
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	var emptyFunction_1 = emptyFunction;
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var invariant_1 = invariant;
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction_1;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var warning_1 = warning;
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
	if (false) {
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	var checkPropTypes_1 = checkPropTypes;
	
	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant_1(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  }
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var index = createCommonjsModule(function (module) {
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});
	
	var index_1 = index.object;
	var index_2 = index.oneOfType;
	var index_3 = index.string;
	var index_4 = index.node;
	var index_5 = index.func;
	var index_6 = index.bool;
	
	var index$2 = createCommonjsModule(function (module, exports) {
	/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	});
	
	function isPromise(value) {
	    if (value !== null && typeof value === 'object') {
	        return value && typeof value.then === 'function';
	    }
	    return false;
	}
	var isReactNative = typeof window !== 'undefined' &&
	    window.navigator &&
	    window.navigator.product &&
	    window.navigator.product === 'ReactNative';
	function values(obj) {
	    var vals = [];
	    for (var key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            vals.push(obj[key]);
	        }
	    }
	    return vals;
	}
	var isFunction = function (obj) { return 'function' === typeof obj; };
	var isEmptyChildren = function (children) {
	    return React.Children.count(children) === 0;
	};
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning$2 = function() {};
	
	if (__DEV__) {
	  warning$2 = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	var warning_1$2 = warning$2;
	
	var Field = (function (_super) {
	    __extends(Field, _super);
	    function Field() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Field.prototype.componentWillMount = function () {
	        var _a = this.props, render = _a.render, children = _a.children, component = _a.component;
	        warning_1$2(!(component && render), 'You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored');
	        warning_1$2(!(component && children && isFunction(children)), 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.');
	        warning_1$2(!(render && children && !isEmptyChildren(children)), 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored');
	    };
	    Field.prototype.render = function () {
	        var _a = this
	            .props, name = _a.name, render = _a.render, children = _a.children, _b = _a.component, component = _b === void 0 ? 'input' : _b, props = __rest(_a, ["name", "render", "children", "component"]);
	        var formik = this.context.formik;
	        var field = {
	            value: props.type === 'radio' || props.type === 'checkbox'
	                ? props.value
	                : formik.values[name],
	            name: name,
	            onChange: formik.handleChange,
	            onBlur: formik.handleBlur,
	        };
	        var bag = { field: field, form: formik };
	        if (render) {
	            return render(bag);
	        }
	        if (isFunction(children)) {
	            return children(bag);
	        }
	        if (typeof component === 'string') {
	            return React.createElement(component, __assign({}, field, props, { children: children }));
	        }
	        return React.createElement(component, __assign({}, bag, props, { children: children }));
	    };
	    Field.contextTypes = {
	        formik: index_1,
	    };
	    Field.propTypes = {
	        name: index_3.isRequired,
	        component: index_2([index_3, index_5]),
	        render: index_5,
	        children: index_2([index_5, index_4]),
	    };
	    return Field;
	}(React.Component));
	
	var Form = function (props, context) { return (React.createElement("form", __assign({ onSubmit: context.formik.handleSubmit }, props))); };
	Form.contextTypes = {
	    formik: index_1,
	};
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true,
	};
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true,
	};
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	        var keys = getOwnPropertyNames(sourceComponent);
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] &&
	                !KNOWN_STATICS[key] &&
	                (!blacklist || !blacklist[key])) {
	                if (propIsEnumerable.call(sourceComponent, key) ||
	                    typeof sourceComponent[key] === 'function') {
	                    try {
	                        targetComponent[key] = sourceComponent[key];
	                    }
	                    catch (e) { }
	                }
	            }
	        }
	        return targetComponent;
	    }
	    return targetComponent;
	}
	
	function withFormik$$1(_a) {
	    var _b = _a.mapPropsToValues, mapPropsToValues = _b === void 0 ? function (vanillaProps) {
	        var val = {};
	        for (var k in vanillaProps) {
	            if (vanillaProps.hasOwnProperty(k) &&
	                typeof vanillaProps[k] !== 'function') {
	                val[k] = vanillaProps[k];
	            }
	        }
	        return val;
	    } : _b, config = __rest(_a, ["mapPropsToValues"]);
	    return function createFormik(Component$$1) {
	        var C = (function (_super) {
	            __extends(C, _super);
	            function C() {
	                var _this = _super !== null && _super.apply(this, arguments) || this;
	                _this.validate = function (values$$1) {
	                    return config.validate(values$$1, _this.props);
	                };
	                _this.validationSchema = function () {
	                    return isFunction(config.validationSchema)
	                        ? config.validationSchema(_this.props)
	                        : config.validationSchema;
	                };
	                _this.handleSubmit = function (values$$1, actions) {
	                    return config.handleSubmit(values$$1, __assign({}, actions, { props: _this.props }));
	                };
	                _this.renderFormComponent = function (formikProps) {
	                    return React.createElement(Component$$1, __assign({}, _this.props, formikProps));
	                };
	                return _this;
	            }
	            C.prototype.render = function () {
	                return (React.createElement(Formik, __assign({}, this.props, config, { validate: config.validate && this.validate, validationSchema: config.validationSchema && this.validationSchema, initialValues: mapPropsToValues(this.props), onSubmit: this.handleSubmit, render: this.renderFormComponent })));
	            };
	            return C;
	        }(React.Component));
	        return hoistNonReactStatics(C, Component$$1);
	    };
	}
	
	var Formik = (function (_super) {
	    __extends(Formik, _super);
	    function Formik(props) {
	        var _this = _super.call(this, props) || this;
	        _this.setErrors = function (errors) {
	            _this.setState({ errors: errors });
	        };
	        _this.setTouched = function (touched) {
	            _this.setState({ touched: touched }, function () {
	                if (_this.props.validateOnBlur) {
	                    _this.runValidations(_this.state.values);
	                }
	            });
	        };
	        _this.setValues = function (values$$1) {
	            _this.setState({ values: values$$1 }, function () {
	                if (_this.props.validateOnChange) {
	                    _this.runValidations(values$$1);
	                }
	            });
	        };
	        _this.setStatus = function (status) {
	            _this.setState({ status: status });
	        };
	        _this.setError = function (error) {
	            if (false) {
	                console.warn("Warning: Formik's setError(error) is deprecated and may be removed in future releases. Please use Formik's setStatus(status) instead. It works identically. For more info see https://github.com/jaredpalmer/formik#setstatus-status-any--void");
	            }
	            _this.setState({ error: error });
	        };
	        _this.setSubmitting = function (isSubmitting) {
	            _this.setState({ isSubmitting: isSubmitting });
	        };
	        _this.runValidationSchema = function (values$$1, onSuccess) {
	            var validationSchema = _this.props.validationSchema;
	            var schema = isFunction(validationSchema)
	                ? validationSchema()
	                : validationSchema;
	            validateYupSchema(values$$1, schema).then(function () {
	                _this.setState({ errors: {} });
	                if (onSuccess) {
	                    onSuccess();
	                }
	            }, function (err) {
	                return _this.setState({ errors: yupToFormErrors(err), isSubmitting: false });
	            });
	        };
	        _this.runValidations = function (values$$1) {
	            if (_this.props.validationSchema) {
	                _this.runValidationSchema(values$$1);
	            }
	            if (_this.props.validate) {
	                var maybePromisedErrors = _this.props.validate(values$$1);
	                if (isPromise(maybePromisedErrors)) {
	                    maybePromisedErrors.then(function () {
	                        _this.setState({ errors: {} });
	                    }, function (errors) { return _this.setState({ errors: errors, isSubmitting: false }); });
	                }
	                else {
	                    _this.setErrors(maybePromisedErrors);
	                }
	            }
	        };
	        _this.handleChange = function (e) {
	            if (isReactNative) {
	                if (false) {
	                    console.error("Warning: Formik's handleChange does not work with React Native. Use setFieldValue and within a callback instead. For more info see https://github.com/jaredpalmer/formikhttps://github.com/jaredpalmer/formik#react-native");
	                }
	                return;
	            }
	            e.persist();
	            var _a = e.target, type = _a.type, name = _a.name, id = _a.id, value = _a.value, checked = _a.checked, outerHTML = _a.outerHTML;
	            var field = name ? name : id;
	            var val = /number|range/.test(type)
	                ? parseFloat(value)
	                : /checkbox/.test(type) ? checked : value;
	            if (!field && ("production") !== 'production') {
	                warnAboutMissingIdentifier({
	                    htmlContent: outerHTML,
	                    documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
	                    handlerName: 'handleChange',
	                });
	            }
	            _this.setState(function (prevState) {
	                return (__assign({}, prevState, { values: __assign({}, prevState.values, (_a = {}, _a[field] = val, _a)) }));
	                var _a;
	            });
	            if (_this.props.validateOnChange) {
	                _this.runValidations(__assign({}, _this.state.values, (_b = {}, _b[field] = val, _b)));
	            }
	            var _b;
	        };
	        _this.handleChangeValue = function (field, value) {
	            if (false) {
	                console.warn("Warning: Formik's handleChangeValue is deprecated and may be removed in future releases. Use Formik's setFieldValue(field, value) and setFieldTouched(field, isTouched) instead. React will merge the updates under the hood and avoid a double render. For more info see https://github.com/jaredpalmer/formik#setfieldvalue-field-string-value-any--void");
	            }
	            _this.setState(function (prevState) {
	                return (__assign({}, prevState, { values: __assign({}, prevState.values, (_a = {}, _a[field] = value, _a)), touched: __assign({}, prevState.touched, (_b = {}, _b[field] = true, _b)) }));
	                var _a, _b;
	            });
	            _this.runValidationSchema(__assign({}, _this.state.values, (_a = {}, _a[field] = value, _a)));
	            var _a;
	        };
	        _this.setFieldValue = function (field, value) {
	            _this.setState(function (prevState) {
	                return (__assign({}, prevState, { values: __assign({}, prevState.values, (_a = {}, _a[field] = value, _a)) }));
	                var _a;
	            }, function () {
	                if (_this.props.validateOnChange) {
	                    _this.runValidations(__assign({}, _this.state.values, (_a = {}, _a[field] = value, _a)));
	                }
	                var _a;
	            });
	        };
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            _this.submitForm();
	        };
	        _this.submitForm = function () {
	            _this.setState({
	                touched: touchAllFields(_this.state.values),
	                isSubmitting: true,
	            });
	            if (_this.props.validate) {
	                var maybePromisedErrors = _this.props.validate(_this.state.values) || {};
	                if (isPromise(maybePromisedErrors)) {
	                    maybePromisedErrors.then(function () {
	                        _this.setState({ errors: {} });
	                        _this.executeSubmit();
	                    }, function (errors) { return _this.setState({ errors: errors, isSubmitting: false }); });
	                    return;
	                }
	                else {
	                    var isValid = Object.keys(maybePromisedErrors).length === 0;
	                    _this.setState({
	                        errors: maybePromisedErrors,
	                        isSubmitting: isValid,
	                    });
	                    if (isValid) {
	                        _this.executeSubmit();
	                    }
	                }
	            }
	            else if (_this.props.validationSchema) {
	                _this.runValidationSchema(_this.state.values, _this.executeSubmit);
	            }
	            else {
	                _this.executeSubmit();
	            }
	        };
	        _this.executeSubmit = function () {
	            _this.props.onSubmit(_this.state.values, {
	                resetForm: _this.resetForm,
	                setError: _this.setError,
	                setErrors: _this.setErrors,
	                setFieldError: _this.setFieldError,
	                setFieldTouched: _this.setFieldTouched,
	                setFieldValue: _this.setFieldValue,
	                setStatus: _this.setStatus,
	                setSubmitting: _this.setSubmitting,
	                setTouched: _this.setTouched,
	                setValues: _this.setValues,
	                submitForm: _this.submitForm,
	            });
	        };
	        _this.handleBlur = function (e) {
	            if (isReactNative) {
	                if (false) {
	                    console.error("Warning: Formik's handleBlur does not work with React Native. Use setFieldTouched(field, isTouched) within a callback instead. For more info see https://github.com/jaredpalmer/formik#setfieldtouched-field-string-istouched-boolean--void");
	                }
	                return;
	            }
	            e.persist();
	            var _a = e.target, name = _a.name, id = _a.id, outerHTML = _a.outerHTML;
	            var field = name ? name : id;
	            if (!field && ("production") !== 'production') {
	                warnAboutMissingIdentifier({
	                    htmlContent: outerHTML,
	                    documentationAnchorLink: 'handleblur-e-any--void',
	                    handlerName: 'handleBlur',
	                });
	            }
	            _this.setState(function (prevState) {
	                return ({
	                    touched: __assign({}, prevState.touched, (_a = {}, _a[field] = true, _a)),
	                });
	                var _a;
	            });
	            if (_this.props.validateOnBlur) {
	                _this.runValidations(_this.state.values);
	            }
	        };
	        _this.setFieldTouched = function (field, touched) {
	            if (touched === void 0) { touched = true; }
	            _this.setState(function (prevState) {
	                return (__assign({}, prevState, { touched: __assign({}, prevState.touched, (_a = {}, _a[field] = touched, _a)) }));
	                var _a;
	            }, function () {
	                if (_this.props.validateOnBlur) {
	                    _this.runValidations(_this.state.values);
	                }
	            });
	        };
	        _this.setFieldError = function (field, message) {
	            _this.setState(function (prevState) {
	                return (__assign({}, prevState, { errors: __assign({}, prevState.errors, (_a = {}, _a[field] = message, _a)) }));
	                var _a;
	            });
	        };
	        _this.resetForm = function (nextValues) {
	            if (nextValues) {
	                _this.initialValues = nextValues;
	            }
	            _this.setState({
	                isSubmitting: false,
	                errors: {},
	                touched: {},
	                error: undefined,
	                status: undefined,
	                values: nextValues ? nextValues : _this.props.initialValues,
	            });
	        };
	        _this.handleReset = function () {
	            _this.resetForm();
	        };
	        _this.state = {
	            values: props.initialValues || {},
	            errors: {},
	            touched: {},
	            isSubmitting: false,
	        };
	        _this.initialValues = props.initialValues || {};
	        return _this;
	    }
	    Formik.prototype.getChildContext = function () {
	        var dirty = values(this.state.touched).filter(Boolean).length > 0;
	        return {
	            formik: __assign({}, this.state, { dirty: dirty, isValid: dirty
	                    ? this.state.errors && Object.keys(this.state.errors).length === 0
	                    : this.props.isInitialValid !== false &&
	                        isFunction(this.props.isInitialValid)
	                        ? this.props.isInitialValid(this.props)
	                        : this.props.isInitialValid, handleSubmit: this.handleSubmit, handleChange: this.handleChange, handleBlur: this.handleBlur, handleReset: this.handleReset, setStatus: this.setStatus, setTouched: this.setTouched, setErrors: this.setErrors, setError: this.setError, setValues: this.setValues, setFieldError: this.setFieldError, setFieldValue: this.setFieldValue, setFieldTouched: this.setFieldTouched, setSubmitting: this.setSubmitting, resetForm: this.resetForm, submitForm: this.submitForm, initialValues: this.initialValues }),
	        };
	    };
	    Formik.prototype.componentWillReceiveProps = function (nextProps) {
	        if (this.props.enableReinitialize &&
	            !index$2(nextProps.initialValues, this.props.initialValues)) {
	            this.initialValues = nextProps.initialValues;
	            this.resetForm(nextProps.initialValues);
	        }
	    };
	    Formik.prototype.componentWillMount = function () {
	        warning_1$2(!(this.props.component && this.props.render), 'You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored');
	        warning_1$2(!(this.props.component &&
	            this.props.children &&
	            !isEmptyChildren(this.props.children)), 'You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
	        warning_1$2(!(this.props.render &&
	            this.props.children &&
	            !isEmptyChildren(this.props.children)), 'You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
	    };
	    Formik.prototype.render = function () {
	        var _a = this.props, component = _a.component, render = _a.render, children = _a.children, isInitialValid = _a.isInitialValid;
	        var dirty = values(this.state.touched).filter(Boolean).length > 0;
	        var props = __assign({}, this.state, { dirty: dirty, isValid: dirty
	                ? this.state.errors && Object.keys(this.state.errors).length === 0
	                : isInitialValid !== false && isFunction(isInitialValid)
	                    ? isInitialValid(this.props)
	                    : isInitialValid, handleBlur: this.handleBlur, handleChange: this.handleChange, handleReset: this.handleReset, handleSubmit: this.handleSubmit, initialValues: this.initialValues, resetForm: this.resetForm, setError: this.setError, setErrors: this.setErrors, setFieldError: this.setFieldError, setFieldTouched: this.setFieldTouched, setFieldValue: this.setFieldValue, setStatus: this.setStatus, setSubmitting: this.setSubmitting, setTouched: this.setTouched, setValues: this.setValues, submitForm: this.submitForm });
	        return component
	            ? React.createElement(component, props)
	            : render
	                ? render(props)
	                : children
	                    ? typeof children === 'function'
	                        ? children(props)
	                        : !isEmptyChildren(children) ? React.Children.only(children) : null
	                    : null;
	    };
	    Formik.defaultProps = {
	        validateOnChange: true,
	        validateOnBlur: true,
	        isInitialValid: false,
	        enableReinitialize: false,
	    };
	    Formik.propTypes = {
	        validateOnChange: index_6,
	        validateOnBlur: index_6,
	        isInitialValid: index_2([index_5, index_6]),
	        initialValues: index_1,
	        onSubmit: index_5.isRequired,
	        validationSchema: index_2([index_5, index_1]),
	        validate: index_5,
	        component: index_5,
	        render: index_5,
	        children: index_2([index_5, index_4]),
	        enableReinitialize: index_6,
	    };
	    Formik.childContextTypes = {
	        formik: index_1,
	    };
	    return Formik;
	}(React.Component));
	function warnAboutMissingIdentifier(_a) {
	    var htmlContent = _a.htmlContent, documentationAnchorLink = _a.documentationAnchorLink, handlerName = _a.handlerName;
	    console.error("Warning: `" + handlerName + "` has triggered and you forgot to pass an `id` or `name` attribute to your input:\n  \n    " + htmlContent + "\n  \n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
	}
	function yupToFormErrors(yupError) {
	    var errors = {};
	    for (var _i = 0, _a = yupError.inner; _i < _a.length; _i++) {
	        var err = _a[_i];
	        if (!errors[err.path]) {
	            errors[err.path] = err.message;
	        }
	    }
	    return errors;
	}
	function validateYupSchema(data, schema, context) {
	    if (context === void 0) { context = {}; }
	    var validateData = {};
	    for (var k in data) {
	        if (data.hasOwnProperty(k)) {
	            var key = String(k);
	            validateData[key] =
	                data[key] !== '' ? data[key] : undefined;
	        }
	    }
	    return schema.validate(validateData, { abortEarly: false, context: context });
	}
	function touchAllFields(fields) {
	    var touched = {};
	    for (var _i = 0, _a = Object.keys(fields); _i < _a.length; _i++) {
	        var k = _a[_i];
	        touched[k] = true;
	    }
	    return touched;
	}
	
	exports.Formik = Formik;
	exports.yupToFormErrors = yupToFormErrors;
	exports.validateYupSchema = validateYupSchema;
	exports.touchAllFields = touchAllFields;
	exports.Field = Field;
	exports.Form = Form;
	exports.withFormik = withFormik$$1;
	//# sourceMappingURL=formik.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 22 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var UserAction = exports.UserAction = {
		LOGIN_SUCCESS: "LOGIN_SUCCESS",
		LOGOUT: "LOGOUT",
		PHONE_UPDATE: "PHONE_UPDATE",
		LOAD_USER_PROFILE: "LOAD_USER_PROFILE",
	
		PROFILE_PIC_UPDATE: "PROFILE_PIC_UPDATE",
		BANNER_UPDATE: "BANNER_UPDATE"
	};
	
	var MessageAction = exports.MessageAction = {
		MESSAGE: "MESSAGE",
		MESSAGE_WITH_ACTION: "MESSAGE_WITH_ACTION",
		CLEAR_MESSAGE: "CLEAR_MESSAGE"
	};
	
	var DesignerAction = exports.DesignerAction = {
		LOAD_BALANCE: "LOAD_BALANCE",
	
		LOAD_CACHABLE_SALES_TARGET: "LOAD_CACHABLE_SALES_TARGET",
	
		LOAD_ALL_PENDING_ORDERS: "LOAD_ALL_PENDING_ORDERS",
	
		LOAD_POPULAR_STORES: "LOAD_POPULAR_STORES",
	
		LOAD_ALL_STORES: "LOAD_ALL_STORES",
	
		LOAD_POPULAR_ARTISTS: "LOAD_POPULAR_ARTISTS",
	
		LOAD_ACTIVE_ARTISTS: "LOAD_ACTIVE_ARTISTS",
	
		LOAD_ALL_ARTISTS: "LOAD_ALL_ARTISTS"
	};
	
	var ProductAction = exports.ProductAction = {
		LOAD_FEATURED_PRODUCTS: "LOAD_FEATURED_PRODUCTS",
	
		LOAD_POPULAR_PRODUCTS: "LOAD_POPULAR_PRODUCTS",
	
		LOAD_DASHAIN_FEATURED_PRODUCTS: "LOAD_DASHAIN_FEATURED_PRODUCTS",
	
		LOAD_RECENT_PRODUCTS: "LOAD_RECENT_PRODUCTS",
	
		LOAD_RECENT_PRODUCTS_PER_TYPE: "LOAD_RECENT_PRODUCTS_PER_TYPE",
	
		LOAD_USER_PRODUCTS: "LOAD_USER_PRODUCTS",
		LOAD_USER_PRODUCTS_PER_TYPE: "LOAD_USER_PRODUCTS_PER_TYPE",
		LOAD_STORE_PRODUCTS: "LOAD_STORE_PRODUCTS",
	
		LOAD_SINGLE_PRODUCT: "LOAD_SINGLE_PRODUCT",
	
		LOAD_PRODUCT_STAT: "LOAD_PRODUCT_STAT",
	
		LOAD_ALL_PRODUCTS: "LOAD_ALL_PRODUCTS",
	
		LOAD_TAG_PRODUCTS: "LOAD_TAG_PRODUCTS",
	
		LOAD_TYPE_PRODUCTS: "LOAD_TYPE_PRODUCTS",
	
		SEARCH_PRODUCTS: "SEARCH_PRODUCTS",
	
		UPDATE_PRODUCT_STATE: "UPDATE_PRODUCT_STATE",
	
		UPLOAD_NEW_PRODUCT: "UPLOAD_NEW_PRODUCT",
	
		LOAD_DISCOUNTED_PRODUCTS: "LOAD_DISCOUNTED_PRODUCTS"
	};
	
	var OrderAction = exports.OrderAction = {
		PLACE_ORDER: "PLACE_ORDER",
	
		LOAD_DISCOUNT_COUPON: "LOAD_DISCOUNT_COUPON",
	
		LOAD_PRODUCT_ORDERS: "LOAD_PRODUCT_ORDERS",
	
		LOAD_USER_ORDERS: "LOAD_USER_ORDERS",
	
		LOAD_ALL_ORDERS_BY_STATE: "LOAD_ALL_ORDERS_BY_STATE",
	
		LOAD_DASHAIN_CAMPAIGN_ORDERS: "LOAD_DASHAIN_CAMPAIGN_ORDERS",
	
		LOAD_CHETAN_CAMPAGIN_ORDERS: "LOAD_CHETAN_CAMPAGIN_ORDERS",
	
		UPDATE_ORDER_STATE: "UPDATE_ORDER_STATE",
	
		LOAD_ORDER_STAT: "LOAD_ORDER_STAT",
	
		LOAD_SINGLE_ORDER: "LOAD_SINGLE_ORDER",
	
		UPDATE_SINGLE_ORDER: "UPDATE_SINGLE_ORDER"
	};
	
	var RedeemAction = exports.RedeemAction = {
		LOAD_REDEEM_HISTORY: "LOAD_REDEEM_HISTORY",
		REDEEMED: "REDEEMED"
	};
	
	var StockAction = exports.StockAction = {
		LOAD_STOCK_OWNERS: "LOAD_STOCK_OWNERS",
		LOAD_SINGLE_STOCK_OWNER: "LOAD_SINGLE_STOCK_OWNER",
	
		LOAD_OWNER_STOCKS: "LOAD_OWNER_STOCKS",
		CLEAR_OWNER_STOCKS: "CLEAR_OWNER_STOCKS",
	
		LOAD_STOCK_HISTORY: "LOAD_STOCK_HISTORY"
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(15);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _DesignerStore = __webpack_require__(91);
	
	var _DesignerStore2 = _interopRequireDefault(_DesignerStore);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _MessageStore = __webpack_require__(564);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _Header = __webpack_require__(568);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _AlertMessageBox = __webpack_require__(566);
	
	var _AlertMessageBox2 = _interopRequireDefault(_AlertMessageBox);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderContainer = function (_React$Component) {
		_inherits(HeaderContainer, _React$Component);
	
		function HeaderContainer() {
			_classCallCheck(this, HeaderContainer);
	
			return _possibleConstructorReturn(this, (HeaderContainer.__proto__ || Object.getPrototypeOf(HeaderContainer)).apply(this, arguments));
		}
	
		_createClass(HeaderContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (!this.state.stores) _HttpService2.default.getPopularStores();
			}
		}, {
			key: 'render',
			value: function render() {
				var currentSession = this.state.session;
				var alertMessage = this.state.alertMessage;
	
				var forceOpenLogin = alertMessage && alertMessage.message === _AppConstants2.default.LOGIN_TO_CONTINUE_MSG ? { selectedForm: _AppConstants2.default.SIGN_UP_FORMS.SOCIAL_LOGIN } : null;
				var alertAction = alertMessage && alertMessage.alertAction ? alertMessage.alertAction : null;
				var actionData = alertMessage && alertMessage.actionData ? alertMessage.actionData : null;
	
				if (alertAction) {
					var availableForms = Object.values(_AppConstants2.default.SIGN_UP_FORMS);
	
					if (availableForms.indexOf(alertAction) >= 0) forceOpenLogin = { selectedForm: alertAction, formData: actionData };
				}
	
				var stores = this.state.stores;
				var influencers = this.state.influencers;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_Header2.default, { session: currentSession, forceOpenLogin: forceOpenLogin,
						influencers: influencers, popularStores: stores,
						turnOffSticky: this.props.turnOffSticky }),
					_react2.default.createElement(_AlertMessageBox2.default, { message: alertMessage })
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_SessionStore2.default, _MessageStore2.default, _DesignerStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState) {
				var newState = {
					session: _SessionStore2.default.getCurrentSession(),
					alertMessage: _MessageStore2.default.getAlertMessage(),
	
					stores: _DesignerStore2.default.getPopularStores(),
					influencers: _DesignerStore2.default.getPopularInfluencers()
				};
				return newState;
			}
		}]);
	
		return HeaderContainer;
	}(_react2.default.Component);
	
	exports.default = _utils.Container.create(HeaderContainer);

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _divider = __webpack_require__(69);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _reactMessengerCustomerChat = __webpack_require__(420);
	
	var _reactMessengerCustomerChat2 = _interopRequireDefault(_reactMessengerCustomerChat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = (0, _radium2.default)(function (props) {
		var currentYear = 1900 + new Date().getYear();
	
		return _react2.default.createElement(
			'div',
			{ id: 'footer' },
			_react2.default.createElement(
				'div',
				{ id: 'linksRow', className: 'flexRow scWidth' },
				_react2.default.createElement(
					'div',
					{ className: 'linkColumn', id: 'followUsOn' },
					_react2.default.createElement(
						'h3',
						null,
						'Follow Us On'
					),
					_react2.default.createElement(
						'ul',
						{ className: 'linkList' },
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								_AppElements.A,
								{ href: _AppConstants2.default.FB_PAGE },
								_react2.default.createElement('i', { className: 'fa fa-facebook-official', 'aria-hidden': 'true' }),
								'Facebook'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								_AppElements.A,
								{ href: _AppConstants2.default.INSTA_PAGE },
								_react2.default.createElement('i', { className: 'fa fa-instagram', 'aria-hidden': 'true' }),
								'Instagram'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								_AppElements.A,
								{ href: _AppConstants2.default.YT_CHANNEL },
								_react2.default.createElement('i', { className: 'fa fa-youtube-play', 'aria-hidden': 'true' }),
								'Youtube'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'linkColumn', id: 'importantLinks' },
					_react2.default.createElement(
						'h3',
						null,
						'Important Links'
					),
					_react2.default.createElement(
						'ul',
						{ className: 'linkList' },
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								_AppElements.A,
								{ href: '/how-to-make-money' },
								'How to Make Money At Home?'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								_AppElements.A,
								{ href: '/terms-of-use-and-privacy-policy', target: '_blank' },
								'Terms of Use'
							),
							' & ',
							_react2.default.createElement(
								_AppElements.A,
								{ href: '/terms-of-use-and-privacy-policy', target: '_blank' },
								'Privacy Policy'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								_AppElements.A,
								{ href: '/dashain/buyonedonateone', target: '_blank' },
								'Buy One Donate 1'
							)
						)
					)
				)
			),
			_react2.default.createElement(_divider2.default, { id: 'footerDivider' }),
			_react2.default.createElement(
				'div',
				{ id: 'copyrightRow', className: 'scWidth flexRow' },
				_react2.default.createElement(
					'span',
					{ id: 'copyright' },
					_react2.default.createElement('i', { className: 'fa fa-copyright', 'aria-hidden': 'true' }),
					' ',
					currentYear,
					' ',
					_AppConstants2.default.APP_NAME
				),
				_react2.default.createElement(
					'span',
					null,
					'Call us at ',
					_react2.default.createElement('i', { style: { color: "#f8941c" }, className: 'fa fa-phone-square', 'aria-hidden': 'true' }),
					' ',
					_AppConstants2.default.CONTACT_NUMBER,
					' or WhatsApp at ',
					_react2.default.createElement('i', { style: { color: "green" }, className: 'fa fa-whatsapp', 'aria-hidden': 'true' }),
					' ',
					_AppConstants2.default.WHATS_APP,
					'.'
				)
			),
			_react2.default.createElement(_reactMessengerCustomerChat2.default, { pageId: _AppConstants2.default.FB_PAGE_ID, appId: _AppConstants2.default.FB_APP_ID,
				htmlRef: window.location.pathname,
				themeColor: '#ff7e29' })
		);
	});
	
	exports.default = Footer;

/***/ },
/* 25 */
/***/ function(module, exports) {

	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
	
	          if (desc.get || desc.set) {
	            Object.defineProperty(newObj, key, desc);
	          } else {
	            newObj[key] = obj[key];
	          }
	        }
	      }
	    }
	
	    newObj["default"] = obj;
	    return newObj;
	  }
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(395);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(394);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(392);
	
	var _HelmetConstants = __webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(43);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(15);
	
	var _AppAction = __webpack_require__(22);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductStore = function (_ReduceStore) {
		_inherits(ProductStore, _ReduceStore);
	
		function ProductStore() {
			_classCallCheck(this, ProductStore);
	
			var _this = _possibleConstructorReturn(this, (ProductStore.__proto__ || Object.getPrototypeOf(ProductStore)).call(this, _Dispatcher2.default));
	
			_this.RECENT_PRODUCTS_PAGINATION = "RECENT_PRODUCTS_PAGINATION";
			_this.PRODUCT_DETAIL = "PRODUCT_DETAIL";
			_this.PRODUCT_STAT = "PRODUCT_STAT";
			_this.ALL_PRODUCTS = "ALL_PRODUCTS";
			return _this;
		}
	
		_createClass(ProductStore, [{
			key: 'getInitialState',
			value: function getInitialState() {
				return _immutable2.default.Map();
			}
		}, {
			key: 'getFeaturedProducts',
			value: function getFeaturedProducts() {
				return this.getState().get(_AppAction.ProductAction.LOAD_FEATURED_PRODUCTS) || null;
			}
		}, {
			key: 'getPopularProducts',
			value: function getPopularProducts() {
				return this.getState().get(_AppAction.ProductAction.LOAD_POPULAR_PRODUCTS) || null;
			}
		}, {
			key: 'getDashainFeaturedProducts',
			value: function getDashainFeaturedProducts() {
				return this.getState().get(_AppAction.ProductAction.LOAD_DASHAIN_FEATURED_PRODUCTS) || null;
			}
		}, {
			key: 'getRecentProducts',
			value: function getRecentProducts() {
				return this.getState().get(_AppAction.ProductAction.LOAD_RECENT_PRODUCTS) || null;
			}
		}, {
			key: 'getRecentProductsPagination',
			value: function getRecentProductsPagination() {
				return this.getState().get(this.RECENT_PRODUCTS_PAGINATION) || { nextPageNumber: 0, hasMore: true };
			}
		}, {
			key: 'getRecentProductsPerType',
			value: function getRecentProductsPerType() {
				return this.getState().get(_AppAction.ProductAction.LOAD_RECENT_PRODUCTS_PER_TYPE) || null;
			}
	
			//Takes a creator object
	
		}, {
			key: 'getCreatorProducts',
			value: function getCreatorProducts(creator) {
				if (creator.storeName) return this.getStoreProducts(creator.storeName);else return this.getProducts(creator.id);
			}
		}, {
			key: 'getProducts',
			value: function getProducts(userId) {
				var products = this.getState().get(_AppAction.ProductAction.LOAD_USER_PRODUCTS + "_" + userId) || null;
				return products;
			}
		}, {
			key: 'getStoreProducts',
			value: function getStoreProducts(storeName) {
				return this.getState().get(_AppAction.ProductAction.LOAD_STORE_PRODUCTS + "_" + storeName) || null;
			}
		}, {
			key: 'getProduct',
			value: function getProduct(productId) {
				return this.getState().get(this.PRODUCT_DETAIL + "_" + productId) || null;
			}
		}, {
			key: 'getProductStat',
			value: function getProductStat(productId) {
				return this.getState().get(this.PRODUCT_STAT + "_" + productId) || null;
			}
		}, {
			key: 'getAllProducts',
			value: function getAllProducts(productState) {
				return this.getState().get(this.ALL_PRODUCTS + "_" + productState) || null;
			}
		}, {
			key: 'getTagProducts',
			value: function getTagProducts(tagName) {
				var tagProducts = this.getState().get(_AppAction.ProductAction.LOAD_TAG_PRODUCTS + "_" + tagName) || null;
				return tagProducts;
			}
		}, {
			key: 'getProductsByType',
			value: function getProductsByType(productType) {
				return this.getState().get(_AppAction.ProductAction.LOAD_TYPE_PRODUCTS + "_" + productType) || null;
			}
		}, {
			key: 'getProductsByTypeForUser',
			value: function getProductsByTypeForUser(userId, productType) {
				return this.getState().get(_AppAction.ProductAction.LOAD_USER_PRODUCTS_PER_TYPE + "_" + userId + "_" + productType) || null;
			}
		}, {
			key: 'getProductsByTypePagination',
			value: function getProductsByTypePagination(productType) {
				var pagination = this.getState().get(_AppAction.ProductAction.LOAD_TYPE_PRODUCTS + "_" + productType + "_pagination") || { nextPageNumber: 0, hasMore: true };
				return pagination;
			}
		}, {
			key: 'getSearchProducts',
			value: function getSearchProducts(keyword) {
				return this.getState().get(_AppAction.ProductAction.SEARCH_PRODUCTS + "_" + keyword.toLowerCase()) || null;
			}
		}, {
			key: 'getDiscountedProducts',
			value: function getDiscountedProducts(userId) {
				return this.getState().get(_AppAction.ProductAction.LOAD_DISCOUNTED_PRODUCTS + "_" + userId) || null;
			}
		}, {
			key: '_updateState',
			value: function _updateState(state, key, data) {
				return state.set(key, data);
			}
		}, {
			key: 'updateProducts',
			value: function updateProducts(products, state) {
				for (var i in products) {
					state = this.updateProduct(products[i], state);
				}return state;
			}
		}, {
			key: 'updateProduct',
			value: function updateProduct(product, state) {
				return state.set(this.PRODUCT_DETAIL + "_" + product.id, product);
			}
		}, {
			key: 'reduce',
			value: function reduce(state, action) {
				var _this2 = this;
	
				switch (action.type) {
					case _AppAction.ProductAction.LOAD_FEATURED_PRODUCTS:
						var updatedFeaturedProductState = this._updateState(state, action.type, action.products);
						return this.updateProducts(action.products, updatedFeaturedProductState);
	
					case _AppAction.ProductAction.LOAD_POPULAR_PRODUCTS:
						var updatedPopularProductState = this._updateState(state, action.type, action.products);
						return this.updateProducts(action.products, updatedPopularProductState);
	
					case _AppAction.ProductAction.LOAD_DASHAIN_FEATURED_PRODUCTS:
						return this._updateState(state, action.type, action.products);
	
					case _AppAction.ProductAction.LOAD_RECENT_PRODUCTS:
						var currentRecentProducts = this.getRecentProducts();
	
						var newRecentProducts = null;
						if (currentRecentProducts === null) {
							newRecentProducts = action.products;
						} else {
							//since its recent products list i.e. they are ordered ib id in desc, we can only add records that are smaller in id with our last current record
							var isProductListNew = action.products.length > 0 && action.products[0].id < currentRecentProducts[currentRecentProducts.length - 1].id;
							newRecentProducts = isProductListNew ? currentRecentProducts.concat(action.products) : currentRecentProducts;
						}
	
						var nextPageNumber = action.nextPageNumber;
						var hasMore = action.products.length >= action.pageSize;
	
						var updatedState = this._updateState(state, action.type, newRecentProducts).set(this.RECENT_PRODUCTS_PAGINATION, { nextPageNumber: nextPageNumber, hasMore: hasMore });
	
						return this.updateProducts(newRecentProducts, updatedState);
	
					case _AppAction.ProductAction.LOAD_RECENT_PRODUCTS_PER_TYPE:
						return state.set(_AppAction.ProductAction.LOAD_RECENT_PRODUCTS_PER_TYPE, action.products);
	
					case _AppAction.ProductAction.UPLOAD_NEW_PRODUCT:
						return state.set(_AppAction.ProductAction.LOAD_USER_PRODUCTS + "_" + action.userId, null);
	
					case _AppAction.ProductAction.LOAD_USER_PRODUCTS:
						var userId = action.userId;
						var userProductsState = this._updateState(state, action.type + "_" + userId, action.products);
						return this.updateProducts(action.products, userProductsState);
	
					case _AppAction.ProductAction.LOAD_STORE_PRODUCTS:
						var storeName = action.storeName;
						var storeProductsState = this._updateState(state, action.type + "_" + storeName, action.products);
						return this.updateProducts(action.products, storeProductsState);
	
					case _AppAction.ProductAction.LOAD_SINGLE_PRODUCT:
						return this.updateProduct(action.product, state);
	
					case _AppAction.ProductAction.LOAD_PRODUCT_STAT:
						return state.set(this.PRODUCT_STAT + "_" + action.productId, action.productStat);
	
					case _AppAction.ProductAction.LOAD_ALL_PRODUCTS:
						var updateAllProductsState = state.set(this.ALL_PRODUCTS + "_" + action.productState, action.products);
						return this.updateProducts(action.products, updateAllProductsState);
	
					case _AppAction.ProductAction.LOAD_TAG_PRODUCTS:
						var updatedTagProductsState = this._updateState(state, action.type + "_" + action.tag, action.products);
						return this.updateProducts(action.products, updatedTagProductsState);
	
					case _AppAction.ProductAction.LOAD_TYPE_PRODUCTS:
						var currentProductsByType = this.getProductsByType(action.productType);
	
						var newProductsByType = null;
						if (currentProductsByType === null) {
							newProductsByType = action.products;
						} else {
							//since its recent products list i.e. they are ordered ib id in desc, we can only add records that are smaller in id with our last current record
							var isProductListType = action.products.length > 0 && action.products[0].id < currentProductsByType[currentProductsByType.length - 1].id;
							newProductsByType = isProductListType ? currentProductsByType.concat(action.products) : currentProductsByType;
						}
	
						var updatedTypeProductsState = state.set(_AppAction.ProductAction.LOAD_TYPE_PRODUCTS + "_" + action.productType, newProductsByType).set(_AppAction.ProductAction.LOAD_TYPE_PRODUCTS + "_" + action.productType + "_pagination", { nextPageNumber: action.nextPageNumber,
							hasMore: action.products.length >= action.pageSize });
	
						return this.updateProducts(action.products, updatedTypeProductsState);
	
					case _AppAction.ProductAction.SEARCH_PRODUCTS:
						var updatedSearchProductsState = state.set(action.type + "_" + action.keyword.toLowerCase(), action.products);
						return this.updateProducts(action.products, updatedSearchProductsState);
	
					case _AppAction.ProductAction.UPDATE_PRODUCT_STATE:
						//create a new map with all products data cleared
						var newStateMap = this.getInitialState();
						state.entrySeq().forEach(function (e) {
							var key = e[0],
							    value = e[1];
	
							if (!key.startsWith(_this2.ALL_PRODUCTS)) newStateMap = newStateMap.set(key, value);
						});
	
						return newStateMap;
	
					case _AppAction.ProductAction.LOAD_DISCOUNTED_PRODUCTS:
						return this._updateState(state, action.type + "_" + action.userId, action.products);
	
					case _AppAction.ProductAction.LOAD_USER_PRODUCTS_PER_TYPE:
						var currentProductsByTypeForUser = this.getProductsByTypeForUser(action.userId, action.productType);
	
						var newProducts = null;
						if (currentProductsByTypeForUser === null) {
							newProducts = action.products;
						} else {
							//since its recent products list i.e. they are ordered by id in desc, we can only add records that are smaller in id with our last current record
							var isUpdateList = action.products.length > 0 && action.products[0].id < currentProductsByTypeForUser[currentProductsByTypeForUser.length - 1].id;
							newProducts = isUpdateList ? currentProductsByTypeForUser.concat(action.products) : currentProductsByTypeForUser;
						}
	
						var userProductTypeKey = _AppAction.ProductAction.LOAD_USER_PRODUCTS_PER_TYPE + "_" + action.userId + "_" + action.productType;
	
						var updatedUserTypeProductsState = state.set(userProductTypeKey, newProducts).set(userProductTypeKey + "_pagination", { nextPageNumber: action.nextPageNumber, hasMore: action.products.length >= action.pageSize });
	
						return this.updateProducts(action.products, updatedUserTypeProductsState);
	
					case _AppAction.RedeemAction.REDEEMED:
						//create a new map with product stat data cleared
						var newMap = this.getInitialState();
						state.entrySeq().forEach(function (e) {
							var key = e[0],
							    value = e[1];
	
							if (!key.startsWith(_this2.PRODUCT_STAT)) newMap = newMap.set(key, value);
						});
	
						return newMap;
					default:
						break;
	
				}
	
				return state;
			}
		}]);
	
		return ProductStore;
	}(_utils.ReduceStore);
	
	exports.default = new ProductStore();

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _ProductDesignThumbnail = __webpack_require__(588);
	
	var _ProductDesignThumbnail2 = _interopRequireDefault(_ProductDesignThumbnail);
	
	var _reactInfiniteScroller = __webpack_require__(399);
	
	var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);
	
	var _AppElements = __webpack_require__(9);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_SLIDER_SETTINGS = {
		speed: 350,
		infinite: false,
		className: 'productSlider',
		variableWidth: false,
		cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
		slidesToShow: 4,
		slidesToScroll: 1,
		swipeToSlide: true,
		swipe: true,
		responsive: [{
			breakpoint: 900,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				variableWidth: true
	
			}
		}, {
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true
	
			}
		}]
	};
	
	var ProductSlider = function (_React$Component) {
		_inherits(ProductSlider, _React$Component);
	
		function ProductSlider() {
			_classCallCheck(this, ProductSlider);
	
			return _possibleConstructorReturn(this, (ProductSlider.__proto__ || Object.getPrototypeOf(ProductSlider)).apply(this, arguments));
		}
	
		_createClass(ProductSlider, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//start from first slide on every update
				this.slide.slickGoTo(0);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var settings = Object.assign({}, DEFAULT_SLIDER_SETTINGS);
	
				if (this.props.productViewMode === 'both') settings.slidesToShow = 1;
	
				settings.dots = this.props.navigator === 'dots';
				settings.arrows = this.props.navigator === 'arrows';
				settings.autoplay = this.props.autoplay;
				settings.infinite = this.props.infinite;
	
				return _react2.default.createElement(
					'div',
					{ className: 'productSlider', id: this.props.id },
					_react2.default.createElement(_AppElements.Title, { title: this.props.title }),
					_react2.default.createElement(
						_reactSlick2.default,
						Object.assign({}, settings, { ref: function ref(r) {
								return _this2.slide = r;
							} }),
						this.props.children
					)
				);
			}
		}]);
	
		return ProductSlider;
	}(_react2.default.Component);
	
	ProductSlider = (0, _radium2.default)(ProductSlider);
	
	var ProductList = function (_React$Component2) {
		_inherits(ProductList, _React$Component2);
	
		function ProductList() {
			_classCallCheck(this, ProductList);
	
			return _possibleConstructorReturn(this, (ProductList.__proto__ || Object.getPrototypeOf(ProductList)).apply(this, arguments));
		}
	
		_createClass(ProductList, [{
			key: 'loadFunc',
			value: function loadFunc() {
				if (this.props.loadMore) this.props.loadMore();
			}
		}, {
			key: 'getProducts',
			value: function getProducts() {
				var products = this.props.products;
	
				if (products == null) return null;
	
				if (this.props.flattenProductImages === true) {
	
					var multiProducts = [];
	
					var _loop = function _loop() {
						var product = products[i];
	
						if (product.productImages.length > 1) {
							var eachImgProducts = product.productImages.map(function (pImg) {
								var productClone = JSON.parse(JSON.stringify(product));
								productClone.productImages = [pImg];
								return productClone;
							});
	
							multiProducts = multiProducts.concat(eachImgProducts);
						} else {
							multiProducts.push(product);
						}
					};
	
					for (var i in products) {
						_loop();
					}
	
					return multiProducts;
				}
	
				return products;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var title = this.props.title;
				var hasMore = this.props.hasMore || false;
				var products = this.getProducts();
	
				var productViewMode = this.props.productViewMode;
	
				var loadMoreLoader = _react2.default.createElement(
					'div',
					{ key: 0, style: { fontSize: '160%', textAlign: 'center' } },
					_react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true' })
				);
	
				var viewProductTags = this.props.viewProductTags || false;
	
				var productkeySuffix = (productViewMode ? productViewMode : "defaultView") + "-" + (this.props.showSlider ? "inslider" : "inlist") + "-" + (title ? title : "NA");
				var thumbnails = products !== null ? products.map(function (p, i) {
					var key = "Product-" + p.productType + "-" + p.id + "-" + productkeySuffix;
	
					if (_this4.props.flattenProductImages === true) key += "-" + p.productImages[0];
	
					return _react2.default.createElement(_ProductDesignThumbnail2.default, { product: p, hrefParams: _this4.props.flattenProductImages === true ? { "sc_img": p.productImages[0] } : null, productViewMode: productViewMode, viewProductTags: viewProductTags, key: key });
				}) : [1, 2, 3, 4].map(function (v) {
					return _react2.default.createElement(_ProductDesignThumbnail2.default, { product: null, productViewMode: productViewMode, key: "ProductLoader-" + v });
				});
	
				if (this.props.showSlider) return _react2.default.createElement(
					ProductSlider,
					{ title: title, productViewMode: productViewMode, autoplay: this.props.autoplay || false,
						navigator: this.props.navigator || "dots", id: this.props.id, infinite: this.props.infinite || false },
					thumbnails
				);
	
				var emptyMsg = this.props.emptyMsg ? this.props.emptyMsg : "No Products Found";
	
				return _react2.default.createElement(
					_reactInfiniteScroller2.default,
					{
						pageStart: 0,
						loadMore: this.loadFunc.bind(this),
						hasMore: hasMore,
						loader: loadMoreLoader },
					title && _react2.default.createElement(_AppElements.Title, { title: title }),
					_react2.default.createElement(
						'div',
						{ className: 'flexRow', style: { margin: '0 -5px' }, id: this.props.id },
						thumbnails
					),
					products !== null && products.length === 0 && _react2.default.createElement(
						'div',
						{ style: { fontSize: "220%", textAlign: "center", margin: "20px 0", color: "#757474" } },
						_react2.default.createElement('i', { className: 'fa fa-minus-circle', 'aria-hidden': 'true' }),
						' ',
						emptyMsg
					)
				);
			}
		}]);
	
		return ProductList;
	}(_react2.default.Component);
	
	exports.default = ProductList;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(178);
	var isBuffer = __webpack_require__(314);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  babelHelpers.classCallCheck = _classCallCheck;
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  babelHelpers.createClass = _createClass;
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  babelHelpers.defineProperty = _defineProperty;
	
	  function _extends() {
	    babelHelpers.extends = _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  babelHelpers.extends = _extends;
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) babelHelpers.setPrototypeOf(subClass, superClass);
	  }
	
	  babelHelpers.inherits = _inherits;
	
	  function _getPrototypeOf(o) {
	    babelHelpers.getPrototypeOf = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  babelHelpers.getPrototypeOf = _getPrototypeOf;
	
	  function _setPrototypeOf(o, p) {
	    babelHelpers.setPrototypeOf = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  babelHelpers.setPrototypeOf = _setPrototypeOf;
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  babelHelpers.interopRequireDefault = _interopRequireDefault;
	
	  function _interopRequireWildcard(obj) {
	    if (obj && obj.__esModule) {
	      return obj;
	    } else {
	      var newObj = {};
	
	      if (obj != null) {
	        for (var key in obj) {
	          if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
	
	            if (desc.get || desc.set) {
	              Object.defineProperty(newObj, key, desc);
	            } else {
	              newObj[key] = obj[key];
	            }
	          }
	        }
	      }
	
	      newObj.default = obj;
	      return newObj;
	    }
	  }
	
	  babelHelpers.interopRequireWildcard = _interopRequireWildcard;
	
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	
	    return target;
	  }
	
	  babelHelpers.objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;
	
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	    var target = babelHelpers.objectWithoutPropertiesLoose(source, excluded);
	    var key, i;
	
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	
	    return target;
	  }
	
	  babelHelpers.objectWithoutProperties = _objectWithoutProperties;
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  babelHelpers.assertThisInitialized = _assertThisInitialized;
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    }
	
	    return babelHelpers.assertThisInitialized(self);
	  }
	
	  babelHelpers.possibleConstructorReturn = _possibleConstructorReturn;
	});

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(388);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactJss = __webpack_require__(429);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _modal = __webpack_require__(421);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _styles = __webpack_require__(422);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reactJss2.default)(_styles2.default)(_modal2.default);

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _HttpService2 = __webpack_require__(12);
	
	var _AppAction = __webpack_require__(22);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //Note: Important!!!
	//import the class here, not the object
	
	
	var BASE_URL = _AppConstants2.default.BASE_API_URL + "/user";
	
	var UserAPI = function (_HttpService) {
		_inherits(UserAPI, _HttpService);
	
		function UserAPI() {
			_classCallCheck(this, UserAPI);
	
			return _possibleConstructorReturn(this, (UserAPI.__proto__ || Object.getPrototypeOf(UserAPI)).apply(this, arguments));
		}
	
		_createClass(UserAPI, [{
			key: 'register',
			value: function register(registerRequest, callback) {
				var _this2 = this;
	
				this.post("/register", registerRequest, function (response) {
					var message = response.data;
					_Dispatcher2.default.dispatchAnAlert(message);
	
					if (typeof callback === 'function') callback(true);
				}, function (error) {
					_this2.defaultErrorHandler(error);
					callback(false, error);
				});
			}
		}, {
			key: 'verifyAccount',
			value: function verifyAccount(token, callback) {
				var _this3 = this;
	
				this.post("/verify?token=" + token, null, function (response) {
					var session = response.data;
	
					var bearerToken = session['bearer'];
					var user = session['user'];
					var expiresOn = session['expiresOn'];
	
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.LOGIN_SUCCESS,
						user: user,
						token: bearerToken,
						expiresOn: expiresOn
					});
	
					callback(true);
				}, function (error) {
					_this3.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'sendVerificationEmail',
			value: function sendVerificationEmail(emailAddress, callback) {
				var _this4 = this;
	
				this.post("/sendVerificationEmail", emailAddress, function (response) {
					var message = response.data;
					_Dispatcher2.default.dispatchAnAlert(message);
	
					if (typeof callback === 'function') callback(true);
				}, function (error) {
					_this4.defaultErrorHandler(error);
					callback(false, error);
				});
			}
		}, {
			key: 'sendForgetPasswordEmail',
			value: function sendForgetPasswordEmail(emailAddress, callback) {
				var _this5 = this;
	
				this.post("/sendForgetPwdEmail", emailAddress, function (response) {
					var message = response.data;
					_Dispatcher2.default.dispatchAnAlert(message);
	
					if (typeof callback === 'function') callback(true);
				}, function (error) {
					_this5.defaultErrorHandler(error);
					callback(false, error);
				});
			}
		}, {
			key: 'changePassword',
			value: function changePassword(token, newPassword, callback) {
				var _this6 = this;
	
				var data = { token: token, password: btoa(newPassword) };
	
				this.post("/changePassword", data, function (response) {
					var message = response.data;
					_Dispatcher2.default.dispatchAnAlert(message);
	
					if (typeof callback === 'function') callback(true);
				}, function (error) {
					_this6.defaultErrorHandler(error);
					callback(false, error);
				});
			}
		}, {
			key: 'updateProfilePic',
			value: function updateProfilePic(newImage) {
				var formData = new FormData();
				formData.append("newImageFile", newImage);
	
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				this.postFormData("/updateProfilePic", formData, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.PROFILE_PIC_UPDATE,
						profilePicture: response.data.profilePicture,
						user: response.data
					});
	
					_Dispatcher2.default.dispatchAnAlert("Profile Pic Updated Successfully.");
				});
			}
		}, {
			key: 'addBanner',
			value: function addBanner(newImage) {
				var formData = new FormData();
				formData.append("newImageFile", newImage);
	
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				this.postFormData("/addBanner", formData, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.BANNER_UPDATE,
						bannerImages: response.data.bannerImages,
						user: response.data
					});
	
					_Dispatcher2.default.dispatchAnAlert("Banner added successfully.");
				});
			}
		}, {
			key: 'removeBanner',
			value: function removeBanner(bannerImgUrl) {
				this.delete("/removeBanner?imageUrl=" + bannerImgUrl, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.BANNER_UPDATE,
						bannerImages: response.data.bannerImages,
						user: response.data
					});
	
					_Dispatcher2.default.dispatchAnAlert("Banner removed successfully.");
				});
			}
		}, {
			key: 'getPopularArtists',
			value: function getPopularArtists() {
				var url = "/artists/popular";
	
				_get(UserAPI.prototype.__proto__ || Object.getPrototypeOf(UserAPI.prototype), 'get', this).call(this, url, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.DesignerAction.LOAD_POPULAR_ARTISTS,
						artists: response.data
					});
				});
			}
		}, {
			key: 'getActiveArtists',
			value: function getActiveArtists() {
				var url = "/artists/active";
	
				_get(UserAPI.prototype.__proto__ || Object.getPrototypeOf(UserAPI.prototype), 'get', this).call(this, url, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.DesignerAction.LOAD_ACTIVE_ARTISTS,
						artists: response.data
					});
				});
			}
		}, {
			key: 'getAllStores',
			value: function getAllStores() {
				_get(UserAPI.prototype.__proto__ || Object.getPrototypeOf(UserAPI.prototype), 'get', this).call(this, "/stores/list?pageNumber=0&pageSize=100", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.DesignerAction.LOAD_ALL_STORES,
						stores: response.data
					});
				});
			}
		}, {
			key: 'getAllArtist',
			value: function getAllArtist(prefix) {
				_get(UserAPI.prototype.__proto__ || Object.getPrototypeOf(UserAPI.prototype), 'get', this).call(this, "/artists/list?prefix=" + prefix, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.DesignerAction.LOAD_ALL_ARTISTS,
						artists: response.data,
						prefix: prefix
					});
				});
			}
		}, {
			key: 'getAllUsers',
			value: function getAllUsers(pageNumber, pageSize, userTypes, userStatus, callback) {
				var _this7 = this;
	
				this.get("/list?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&userTypes=" + userTypes.join(",") + "&userStatus=" + userStatus, function (response) {
					var users = response.data;
	
					if (typeof callback === 'function') callback(users);
				}, function (error) {
					_this7.defaultErrorHandler(error);
					callback(false, error);
				});
			}
		}, {
			key: 'deactivateAccount',
			value: function deactivateAccount(userId, onSuccess) {
				var _this8 = this;
	
				_get(UserAPI.prototype.__proto__ || Object.getPrototypeOf(UserAPI.prototype), 'post', this).call(this, "/" + userId + "/deactivate", null, function (response) {
					_this8.logout();
					_Dispatcher2.default.dispatchAnAlert("Account deactivatd successfully.");
					onSuccess();
				});
			}
		}, {
			key: 'updateUserStatus',
			value: function updateUserStatus(userId, newStatus, onSuccess) {
				_get(UserAPI.prototype.__proto__ || Object.getPrototypeOf(UserAPI.prototype), 'post', this).call(this, "/" + userId + "/updateStatus?newStatus=" + newStatus, null, function (response) {
					_Dispatcher2.default.dispatchAnAlert("Account updated successfully.");
					onSuccess();
				});
			}
		}]);
	
		return UserAPI;
	}(_HttpService2.HttpService);
	
	exports.default = new UserAPI(BASE_URL);

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(107);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrderInfo = exports.SubmitBtn = exports.ErrorMessages = exports.TotalCost = exports.OrderContext = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	var _OrderAPI = __webpack_require__(90);
	
	var _OrderAPI2 = _interopRequireDefault(_OrderAPI);
	
	var _FormElements = __webpack_require__(13);
	
	var _AppElements = __webpack_require__(9);
	
	var _UserAvatar = __webpack_require__(48);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _PriceLabel = __webpack_require__(142);
	
	var _PriceLabel2 = _interopRequireDefault(_PriceLabel);
	
	var _ProductUtil = __webpack_require__(74);
	
	var _ProductUtil2 = _interopRequireDefault(_ProductUtil);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _OrderFormLoader = __webpack_require__(140);
	
	var _OrderFormLoader2 = _interopRequireDefault(_OrderFormLoader);
	
	var _ProductSocialShare = __webpack_require__(231);
	
	var _ProductSocialShare2 = _interopRequireDefault(_ProductSocialShare);
	
	var _OrderProductImage = __webpack_require__(582);
	
	var _OrderProductImage2 = _interopRequireDefault(_OrderProductImage);
	
	var _LocationTypeInput = __webpack_require__(229);
	
	var _LocationTypeInput2 = _interopRequireDefault(_LocationTypeInput);
	
	var _CouponCodeInput = __webpack_require__(228);
	
	var _CouponCodeInput2 = _interopRequireDefault(_CouponCodeInput);
	
	var _OrderConfirmation = __webpack_require__(224);
	
	var _OrderConfirmation2 = _interopRequireDefault(_OrderConfirmation);
	
	var _PaymentPreferenceInput = __webpack_require__(230);
	
	var _PaymentPreferenceInput2 = _interopRequireDefault(_PaymentPreferenceInput);
	
	var _PaymentInfo = __webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderContext = exports.OrderContext = (0, _react.createContext)();
	
	var DELIVERY_TYPE = _AppConstants2.default.DELIVERY_TYPE;
	
	var ProductInfo = function ProductInfo(_ref) {
	    var showCreator = _ref.showCreator;
	
	    var _useContext = (0, _react.useContext)(OrderContext),
	        product = _useContext.product,
	        values = _useContext.values,
	        productSizes = _useContext.productSizes;
	
	    var productSizeOptions = values.productSizeMetaData || productSizes;
	    var perPrice = product.price + (values.productSize ? productSizeOptions[values.productSize].priceAddition : 0);
	
	    var creatorURL = null,
	        createrName = null;
	    if (showCreator) {
	        creatorURL = _AppUtil2.default.getDesignerURL(product.creator);
	        createrName = product.creator ? _AppUtil2.default.getCreaterName(product.creator) : null;
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h1',
	            { className: 'flexColumn productTitle' },
	            _react2.default.createElement(
	                'span',
	                null,
	                product.title
	            ),
	            product.productMetaData && _react2.default.createElement(
	                'small',
	                null,
	                '- ',
	                product.productMetaData
	            )
	        ),
	        product.creator && showCreator === true && _react2.default.createElement(
	            'div',
	            { className: 'flexRow', style: { alignItems: "center" } },
	            _react2.default.createElement(
	                _AppElements.A,
	                { href: creatorURL },
	                _react2.default.createElement(_UserAvatar2.default, { user: product.creator })
	            ),
	            _react2.default.createElement(
	                'span',
	                { style: { color: '#5b5b5b', fontSize: '90%' } },
	                'from ',
	                _react2.default.createElement(
	                    _AppElements.A,
	                    { href: creatorURL, style: { color: '#f8931b', textTransform: 'capitalize', fontWeight: 'bold' } },
	                    createrName
	                )
	            )
	        ),
	        _react2.default.createElement(_PriceLabel2.default, { style: { margin: '10px 0', fontWeight: 'bold', fontSize: '26px', display: 'block' },
	            price: perPrice,
	            aliasPrice: product.aliasPrice,
	            productType: product.productType, invertColor: true, discountFont: '65%' }),
	        product.description && _react2.default.createElement(
	            'span',
	            { style: { display: 'block', color: 'gray', margin: '15px 0', fontSize: '110%', whiteSpace: 'pre-line' } },
	            '- ',
	            product.description
	        )
	    );
	};
	
	var TotalCost = exports.TotalCost = function TotalCost(_ref2) {
	    var showPriceOnly = _ref2.showPriceOnly;
	
	    var _useContext2 = (0, _react.useContext)(OrderContext),
	        product = _useContext2.product,
	        values = _useContext2.values,
	        status = _useContext2.status,
	        productSizes = _useContext2.productSizes;
	
	    var discountAmount = 0;
	    if (values.hasCouponCode && status && status.discountCoupon && status.discountCoupon.couponCode === values.couponCode) discountAmount = status.discountCoupon.discountAmount * values.quantity;
	
	    var productSizeOptions = values.productSizeMetaData || productSizes;
	
	    var totalPrice = void 0;
	    if (values.isBulkOrderForm === true) {
	        var discountPct = _AppConstants2.default.BULK_ORDER_DISCOUNT_PCT;
	        totalPrice = Object.keys(values.sizeQuantity).map(function (s) {
	            var quantity = values.sizeQuantity[s];
	            var perPrice = (product.price + productSizeOptions[s].priceAddition) * (1 - discountPct);
	
	            return quantity * perPrice;
	        }).reduce(function (p1, p2) {
	            return p1 + p2;
	        }, 0);
	    } else {
	        var perPrice = product.price + (values.productSize ? productSizeOptions[values.productSize].priceAddition : 0);
	        totalPrice = values.quantity && values.quantity > 0 ? perPrice * values.quantity : perPrice;
	    }
	
	    var locationExtraCost = values.locationType ? _AppUtil2.default.getLocationExtraCost(values.locationType, product) : 0;
	    var deliveryTypeExtraCost = values.deliveryType ? DELIVERY_TYPE[values.deliveryType].extraCost : 0;
	    var productVariants = product.productVariants;
	
	    var variantPriceAddition = 0;
	    if (productVariants) {
	        productVariants.forEach(function (v) {
	            var variantKey = _ProductUtil2.default.getProductVariantKey(v);
	            var selectedVariantValue = values[variantKey];
	
	            var priceAddition = v.variants.filter(function (v) {
	                return v.variantId === selectedVariantValue;
	            })[0].priceAddition || 0;
	            variantPriceAddition += priceAddition;
	        });
	    }
	
	    var totalExtraCost = locationExtraCost + deliveryTypeExtraCost + variantPriceAddition;
	
	    var totalCharge = totalPrice + totalExtraCost - discountAmount;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h2',
	            { className: 'totalCost' },
	            showPriceOnly !== true && _react2.default.createElement(
	                'span',
	                null,
	                'Total Cost '
	            ),
	            _react2.default.createElement(
	                'span',
	                null,
	                'Rs. ',
	                _AppUtil2.default.formatNumber(totalCharge)
	            )
	        )
	    );
	};
	
	var ErrorMessages = exports.ErrorMessages = function ErrorMessages() {
	    var _useContext3 = (0, _react.useContext)(OrderContext),
	        errors = _useContext3.errors,
	        touched = _useContext3.touched;
	
	    var errorMessages = Object.keys(errors).filter(function (k) {
	        return touched[k] === true;
	    }).map(function (k) {
	        return _react2.default.createElement(
	            'span',
	            { className: 'errorMessage', key: "errror-" + k },
	            _react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
	            ' ',
	            errors[k]
	        );
	    });
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        errorMessages.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'errorMessageDiv' },
	            _react2.default.createElement(_AppElements.Separator, null),
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Please scroll up and fix below errors: '
	            ),
	            errorMessages
	        )
	    );
	};
	
	var SubmitBtn = exports.SubmitBtn = function SubmitBtn(_ref3) {
	    var displayDeliveryInputs = _ref3.displayDeliveryInputs;
	
	    var _useContext4 = (0, _react.useContext)(OrderContext),
	        isSubmitting = _useContext4.isSubmitting,
	        values = _useContext4.values;
	
	    var submitBtn = "Buy Now";
	
	    if (isSubmitting === true) {
	        if (values.hasCouponCode) submitBtn = _react2.default.createElement(
	            'span',
	            null,
	            'Validating Coupon',
	            _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
	        );
	    } else {
	        if (values.hasCouponCode) submitBtn = "Apply Coupon";else if (displayDeliveryInputs !== true) submitBtn = "Next";
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _FormElements.SubmitButton,
	            { color: 'primary', disabled: isSubmitting, style: { width: '100%' } },
	            submitBtn
	        )
	    );
	};
	
	var OrderInfo = exports.OrderInfo = function OrderInfo(_ref4) {
	    var prepaymentRequired = _ref4.prepaymentRequired;
	
	    var _useContext5 = (0, _react.useContext)(OrderContext),
	        product = _useContext5.product;
	
	    var isPhotoFrame = product.productType === _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val;
	    var hasOutsideRingroadCharge = product.outsideRingRoadCharge || false;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'ul',
	                { style: { padding: '0', margin: '0 15px', color: '#596161', fontSize: '100%' } },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        _react2.default.createElement(_AppElements.Img, { src: '/images/nepal flag.png', title: 'Nepal Flag', alt: 'Nepal Flag', style: { height: "12px", marginLeft: "3px", display: 'inline' } }),
	                        '  Made in Nepal'
	                    )
	                ),
	                prepaymentRequired !== true && _react2.default.createElement(
	                    'li',
	                    { style: { margin: '5px 0' } },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-money', 'aria-hidden': 'true' }),
	                        ' Cash On Delivery for Inside KTM Valley.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { style: { margin: '5px 0' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flexColumn' },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Available Payment Options:'
	                        ),
	                        _react2.default.createElement(_PaymentInfo.PaymentOptions, null)
	                    )
	                )
	            ),
	            _react2.default.createElement('hr', null)
	        )
	    );
	};
	
	var styles = {
	    headerStyle: { background: 'rgb(224 224 224 / 93%)', color: '#5f5d5d', padding: '5px 10px', textAlign: 'center' }
	};
	
	var OrderForm = function (_React$Component) {
	    _inherits(OrderForm, _React$Component);
	
	    function OrderForm(props) {
	        _classCallCheck(this, OrderForm);
	
	        var _this = _possibleConstructorReturn(this, (OrderForm.__proto__ || Object.getPrototypeOf(OrderForm)).call(this, props));
	
	        _this.validationScheme = _this.validationScheme.bind(_this);
	        _this.setSubmittedOrder = _this.setSubmittedOrder.bind(_this);
	        _this.saveFormData = _this.saveFormData.bind(_this);
	        _this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(OrderForm, [{
	        key: 'validationScheme',
	        value: function validationScheme() {
	            var validation = this.props.validationScheme;
	            return _yup2.default.object().shape(validation);
	        }
	    }, {
	        key: 'setSubmittedOrder',
	        value: function setSubmittedOrder(setStatus, formValues, discountCoupon) {
	            var orderReq = this.props.createOrderRequest(formValues);
	
	            //Note: This overrides other status if any
	            setStatus({ submittedOrder: orderReq, discountCoupon: discountCoupon });
	        }
	    }, {
	        key: 'saveFormData',
	        value: function saveFormData(formValue) {
	            _CacheService2.default.save(_AppConstants2.default.USER_ADDRESS_KEY, JSON.stringify({ phone: formValue.phone,
	                streetAddress: formValue.streetAddress,
	                locationType: formValue.locationType }), true);
	        }
	    }, {
	        key: 'handleFormSubmission',
	        value: function handleFormSubmission(value, _ref5) {
	            var setSubmitting = _ref5.setSubmitting,
	                setStatus = _ref5.setStatus;
	
	            var couponCode = value.hasCouponCode ? value.couponCode : null;
	
	            if (couponCode) {
	                _OrderAPI2.default.validateDiscountCoupon(couponCode, this.props.product.id, function (success, discountCoupon) {
	                    if (success) {
	                        this.setSubmittedOrder(setStatus, value, discountCoupon);
	                    } else {
	                        setSubmitting(false);
	                    }
	                }.bind(this));
	            } else {
	                this.setSubmittedOrder(setStatus, value);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var product = this.props.product;
	
	            if (product === null) return _react2.default.createElement(_OrderFormLoader2.default, null);
	
	            var productSizes = _AppUtil2.default.getSizeInfo(product);
	
	            return _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: this.props.initialValues, onSubmit: this.handleFormSubmission,
	                validationSchema: this.validationScheme,
	                render: function render(formikProps) {
	                    var values = formikProps.values;
	                    var status = formikProps.status;
	                    var submittedOrder = status && status.submittedOrder ? status.submittedOrder : null;
	
	                    if (submittedOrder) {
	                        return _react2.default.createElement(_OrderConfirmation2.default, { order: submittedOrder, product: product,
	                            discountCoupon: status.discountCoupon,
	                            customerImage: values.customerUploadedImage,
	                            onClose: function onClose(reset) {
	                                formikProps.setStatus({}); //remove subittedOrder from status
	                                formikProps.setSubmitting(false);
	
	                                if (reset === true) formikProps.resetForm();
	                            } });
	                    }
	
	                    var prepaymentRequired = _this2.props.isPrePaymentRequired(values);
	
	                    var displayDeliveryInputs = _this2.props.displayDeliveryInputs(values);
	                    return _react2.default.createElement(
	                        OrderContext.Provider,
	                        { value: Object.assign({ product: product, productSizes: productSizes,
	                                setBulkOrderFormType: function setBulkOrderFormType(orderFormType) {
	                                    formikProps.setFieldValue('isBulkOrderForm', orderFormType);
	                                    formikProps.setFieldValue('paymentPreference', "");
	                                }
	                            }, formikProps) },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'productPurchaseFormContainer' },
	                            _react2.default.createElement(
	                                _FormElements.RGForm,
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flexRow' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { flexGrow: "1", maxWidth: '500px', margin: '20px 5px 0 5px', height: '100%' } },
	                                        _react2.default.createElement(_OrderProductImage2.default, null)
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { flexGrow: "1", maxWidth: "500px" } },
	                                        _react2.default.createElement(ProductInfo, { showCreator: true }),
	                                        _this2.props.render(values),
	                                        displayDeliveryInputs && _react2.default.createElement(
	                                            _react2.default.Fragment,
	                                            null,
	                                            _react2.default.createElement(
	                                                'h2',
	                                                { style: styles.headerStyle },
	                                                'Delivery Detail'
	                                            ),
	                                            _react2.default.createElement(_LocationTypeInput2.default, { prepaymentRequired: prepaymentRequired }),
	                                            _react2.default.createElement(_LocationTypeInput.AddressInput, null),
	                                            _react2.default.createElement(_CouponCodeInput2.default, null),
	                                            _react2.default.createElement(
	                                                'h2',
	                                                { style: styles.headerStyle },
	                                                'Payment Preference'
	                                            ),
	                                            _react2.default.createElement(_PaymentPreferenceInput2.default, { prepaymentRequired: prepaymentRequired }),
	                                            _react2.default.createElement(TotalCost, null),
	                                            _react2.default.createElement(ErrorMessages, null)
	                                        ),
	                                        _react2.default.createElement(SubmitBtn, { displayDeliveryInputs: displayDeliveryInputs }),
	                                        _react2.default.createElement('hr', null),
	                                        _react2.default.createElement(OrderInfo, { prepaymentRequired: prepaymentRequired }),
	                                        _react2.default.createElement(_ProductSocialShare2.default, { product: product, productImage: values.productImage })
	                                    )
	                                )
	                            )
	                        )
	                    );
	                } });
	        }
	    }]);
	
	    return OrderForm;
	}(_react2.default.Component);
	
	exports.default = OrderForm;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AppAction = __webpack_require__(22);
	
	var _HttpService2 = __webpack_require__(12);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Note: Important!!!
	//import the class here, not the object
	
	var BASE_URL = _AppConstants2.default.BASE_API_URL + "/product";
	
	var ProductAPI = function (_HttpService) {
		_inherits(ProductAPI, _HttpService);
	
		function ProductAPI() {
			_classCallCheck(this, ProductAPI);
	
			return _possibleConstructorReturn(this, (ProductAPI.__proto__ || Object.getPrototypeOf(ProductAPI)).apply(this, arguments));
		}
	
		_createClass(ProductAPI, [{
			key: 'getProductsByType',
			value: function getProductsByType(productType, pageNumber, pageSize, onSuccess) {
				var pgNumber = pageNumber || 0;
				var pgSize = pageSize || _AppConstants2.default.DEFAULT_PRODUCT_PAGE_SIZE;
	
				this.get("/list/type?productType=" + productType.val + "&pageNumber=" + pgNumber + "&pageSize=" + pgSize, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_TYPE_PRODUCTS,
						products: response.data,
						productType: productType.url.toLowerCase(),
						nextPageNumber: pgNumber + 1,
						pageSize: pgSize
					});
	
					if (typeof onSuccess === "function") {
						onSuccess();
					}
				});
			}
	
			//this always returns 1st page data for all product types,
			//for second page, call respective product type API
	
		}, {
			key: 'getUserProductsPerType',
			value: function getUserProductsPerType(userId, pageSize, onSuccess) {
				var pgSize = pageSize || _AppConstants2.default.DEFAULT_PRODUCT_PAGE_SIZE;
	
				this.get("/" + userId + "/listPerType?pageSize=" + pgSize, function (response) {
					var res = response.data;
	
					Object.keys(res).forEach(function (type) {
						var products = res[type];
						_Dispatcher2.default.dispatch({
							type: _AppAction.ProductAction.LOAD_USER_PRODUCTS_PER_TYPE,
							products: products,
							userId: userId,
							productType: _AppConstants2.default.PRODUCT_TYPES[type].url,
							nextPageNumber: 1,
							pageSize: pageSize
						});
					});
	
					if (typeof onSuccess === "function") {
						onSuccess();
					}
				});
			}
		}, {
			key: 'getRecentProductsByType',
			value: function getRecentProductsByType(productTypes, size) {
				var number = size || 4;
				var types = productTypes.map(function (t) {
					return t.val;
				}).join(",");
	
				this.get("/recentPerType?productTypes=" + types + "&number=" + number, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_RECENT_PRODUCTS_PER_TYPE,
						products: response.data
					});
				});
			}
		}, {
			key: 'searchProductsByTag',
			value: function searchProductsByTag(tagName) {
				this.get("/search/tag?tagName=" + tagName, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_TAG_PRODUCTS,
						products: response.data,
						tag: tagName
					});
				});
			}
		}, {
			key: 'searchProducts',
			value: function searchProducts(keyword) {
				if (!keyword || keyword.length < 2) {
					return;
				}
	
				this.post("/search", { keyword: keyword }, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.SEARCH_PRODUCTS,
						products: response.data,
						keyword: keyword
					});
				});
			}
		}, {
			key: 'getDiscountedProducts',
			value: function getDiscountedProducts(userId) {
				this.get("/couponlist?userId=" + userId, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_DISCOUNTED_PRODUCTS,
						products: response.data,
						userId: userId
					});
				});
			}
		}, {
			key: 'getFeaturedProducts',
			value: function getFeaturedProducts() {
				this.get("/featured", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_FEATURED_PRODUCTS,
						products: response.data
					});
				});
			}
		}, {
			key: 'getPopularProducts',
			value: function getPopularProducts() {
				this.get("/popular", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.ProductAction.LOAD_POPULAR_PRODUCTS,
						products: response.data
					});
				});
			}
		}]);
	
		return ProductAPI;
	}(_HttpService2.HttpService);
	
	exports.default = new ProductAPI(BASE_URL);

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(278);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 40 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ },
/* 41 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CacheService = function () {
		function CacheService() {
			_classCallCheck(this, CacheService);
		}
	
		_createClass(CacheService, [{
			key: "save",
			value: function save(key, value, permanently) {
				try {
					if (permanently === true) localStorage.setItem(key, value);else sessionStorage.setItem(key, value);
				} catch (error) {
					//expected because localstorage and session storage does not work in some mobile
					console.log(error);
	
					this._saveInCookie(key, value);
				}
			}
		}, {
			key: "_saveInCookie",
			value: function _saveInCookie(key, value) {
				try {
					//90days after
					var expirationTime = new Date(new Date().getTime() + 90 * 24 * 60 * 60 * 1000);
	
					//no expiration, so it will be deleted by default when browser closes
					document.cookie = key + "=" + value + ";path=/;expires=" + expirationTime.toUTCString();
				} catch (error) {
					console.log("Cookie Error", error);
				}
			}
		}, {
			key: "get",
			value: function get(key) {
				try {
					return localStorage.getItem(key) || sessionStorage.getItem(key);
				} catch (error) {
					//expected because localstorage and session storage does not work in some mobile
					console.log(error);
					return this._getFromCookie(key);
				}
			}
		}, {
			key: "getAllKeys",
			value: function getAllKeys() {
				return Object.keys(localStorage).concat(Object.keys(sessionStorage));
			}
		}, {
			key: "_getFromCookie",
			value: function _getFromCookie(key) {
				try {
					var cookieVal = document.cookie.split(";").filter(function (v) {
						return v.split("=")[0].trim() === key;
					});
	
					if (cookieVal && cookieVal.length > 0) {
						return cookieVal[0].split(key + "=")[1];
					}
	
					return null;
				} catch (error) {
					console.log("Cookie Error", error);
					return null;
				}
			}
		}, {
			key: "remove",
			value: function remove(key) {
				try {
					localStorage.removeItem(key);
					sessionStorage.removeItem(key);
				} catch (error) {
					//expected because localstorage and session storage does not work in some mobile
					console.log(error);
					this._removeFromCookie(key);
				}
			}
		}, {
			key: "_removeFromCookie",
			value: function _removeFromCookie(key) {
				try {
					document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
				} catch (error) {
					console.log("Cookie Error", error);
				}
			}
		}]);
	
		return CacheService;
	}();
	
	exports.default = new CacheService();

/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	function useReduceStore(store, storeProvider, fetchAction, deps) {
	    //setState is used to trigger useState hook, so it returns most recent data from the storeProvider
	    //we do not track the state locally, tracking that can lead to stale state issue
	    //and since we are already tracking state in the ReduceStore, we use ReduceStore as the only source of data
	    var storeData = storeProvider(store);
	
	    var _useState = (0, _react.useState)(storeData),
	        _useState2 = _slicedToArray(_useState, 2),
	        state = _useState2[0],
	        setState = _useState2[1];
	
	    if (state !== storeData) setState(storeData);
	
	    (0, _react.useEffect)(function () {
	        var storeData = storeProvider(store);
	
	        var listener = store.addListener(function () {
	            //this will trigger useState hook causing the UI to re-render with storeProvider data
	            setState(storeProvider(store));
	        });
	
	        if (!storeData) {
	            fetchAction();
	        }
	        return function () {
	            return listener.remove();
	        };
	    }, deps);
	
	    return storeProvider(store);
	}
	
	exports.default = useReduceStore;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BASIC_SLIDER_SETTINGS = { speed: 350, className: 'headerSlickSlider',
		cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
		autoplay: true,
		autoplaySpeed: 3500,
		dots: true,
		arrows: false,
		slidesToShow: 1,
		swipeToSlide: true,
		swipe: true,
		infinite: true,
		responsive: [{
			breakpoint: 600,
			settings: {
				dots: true,
				arrows: true
			}
		}]
	};
	
	var EachBanner = function EachBanner(_ref) {
		var banner = _ref.banner;
	
		var imgTag = null;
	
		if (banner.mobileImg && _AppUtil2.default.isMobileDevice()) imgTag = _react2.default.createElement(_AppElements.Img, { className: 'bannerImg', src: banner.mobileImg, alt: banner.title });else imgTag = _react2.default.createElement(_AppElements.Img, { className: 'bannerImg', src: banner.img, alt: banner.title });
	
		return _react2.default.createElement(
			'div',
			{ className: 'bannerImgContainer' },
			banner.url && _react2.default.createElement(
				_AppElements.A,
				{ href: banner.url },
				imgTag
			),
			!banner.url && imgTag
		);
	};
	
	var BannerLoader = function BannerLoader(_ref2) {
		var title = _ref2.title;
	
		var bannerTitle = title ? title.toUpperCase() : null;
		return _react2.default.createElement(
			'div',
			{ className: 'bannerImgContainer' },
			_react2.default.createElement(
				'h1',
				{ className: 'bannerTitle' },
				bannerTitle
			)
		);
	};
	
	var HeaderBanner = function HeaderBanner(_ref3) {
		var bannerImages = _ref3.bannerImages,
		    title = _ref3.title,
		    autoplay = _ref3.autoplay,
		    _ref3$navigator = _ref3.navigator,
		    navigator = _ref3$navigator === undefined ? "dots" : _ref3$navigator;
	
		var banners = bannerImages ? bannerImages.filter(function (bi) {
			return !bi.expiration || new Date().getTime() < bi.expiration;
		}).map(function (bi) {
			return _react2.default.createElement(EachBanner, { key: bi.title, banner: bi });
		}) : null;
		if (!banners) return _react2.default.createElement(BannerLoader, { title: title });
	
		if (banners.length === 0) return null;
	
		var settings = Object.assign({}, BASIC_SLIDER_SETTINGS);
		if (autoplay !== undefined && autoplay !== null) settings.autoplay = autoplay;
	
		return _react2.default.createElement(
			'div',
			{ style: { width: '100%' } },
			_react2.default.createElement(
				_reactSlick2.default,
				settings,
				banners
			)
		);
	};
	
	exports.default = HeaderBanner;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserAvatar = function UserAvatar(_ref) {
		var user = _ref.user;
	
		if (!user) return _react2.default.createElement(
			'div',
			{ className: 'userAvatar flexRow' },
			_react2.default.createElement(_AppElements.Img, { className: 'avatarLoader' })
		);
	
		var profilePicture = user.profilePicture;
		var userId = user.id;
		var userTitle = user.storeName ? user.storeName.toUpperCase() : user.username;
	
		var LetterAvatar = function LetterAvatar(_ref2) {
			var userTitle = _ref2.userTitle;
	
			return _react2.default.createElement(
				'div',
				{ className: 'letterAvatar' },
				userTitle.toUpperCase().charAt(0)
			);
		};
		var ImgAvatar = function ImgAvatar(_ref3) {
			var profilePicture = _ref3.profilePicture,
			    userId = _ref3.userId;
	
			return _react2.default.createElement(_AppElements.Img, { src: profilePicture, key: userId });
		};
	
		var avatar = profilePicture ? _react2.default.createElement(ImgAvatar, { profilePicture: profilePicture, userId: userId }) : _react2.default.createElement(LetterAvatar, { userTitle: userTitle });
	
		return _react2.default.createElement(
			'div',
			{ className: 'userAvatar flexRow' },
			avatar
		);
	};
	
	exports.default = UserAvatar;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(635);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _slider2.default;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactTableDefaults = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(104);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(147);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _lifecycle = __webpack_require__(650);
	
	var _lifecycle2 = _interopRequireDefault(_lifecycle);
	
	var _methods = __webpack_require__(651);
	
	var _methods2 = _interopRequireDefault(_methods);
	
	var _defaultProps = __webpack_require__(649);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _propTypes = __webpack_require__(653);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//
	
	
	var ReactTableDefaults = exports.ReactTableDefaults = _defaultProps2.default;
	
	var ReactTable = function (_Methods) {
	  _inherits(ReactTable, _Methods);
	
	  function ReactTable(props) {
	    _classCallCheck(this, ReactTable);
	
	    var _this = _possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this));
	
	    _this.getResolvedState = _this.getResolvedState.bind(_this);
	    _this.getDataModel = _this.getDataModel.bind(_this);
	    _this.getSortedData = _this.getSortedData.bind(_this);
	    _this.fireFetchData = _this.fireFetchData.bind(_this);
	    _this.getPropOrState = _this.getPropOrState.bind(_this);
	    _this.getStateOrProp = _this.getStateOrProp.bind(_this);
	    _this.filterData = _this.filterData.bind(_this);
	    _this.sortData = _this.sortData.bind(_this);
	    _this.getMinRows = _this.getMinRows.bind(_this);
	    _this.onPageChange = _this.onPageChange.bind(_this);
	    _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
	    _this.sortColumn = _this.sortColumn.bind(_this);
	    _this.filterColumn = _this.filterColumn.bind(_this);
	    _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
	    _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
	    _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);
	
	    _this.state = {
	      page: props.defaultPage,
	      pageSize: props.defaultPageSize,
	      sorted: props.defaultSorted,
	      expanded: props.defaultExpanded,
	      filtered: props.defaultFiltered,
	      resized: props.defaultResized,
	      currentlyResizing: false,
	      skipNextSort: false
	    };
	    return _this;
	  }
	
	  _createClass(ReactTable, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var resolvedState = this.getResolvedState();
	      var children = resolvedState.children,
	          className = resolvedState.className,
	          style = resolvedState.style,
	          getProps = resolvedState.getProps,
	          getTableProps = resolvedState.getTableProps,
	          getTheadGroupProps = resolvedState.getTheadGroupProps,
	          getTheadGroupTrProps = resolvedState.getTheadGroupTrProps,
	          getTheadGroupThProps = resolvedState.getTheadGroupThProps,
	          getTheadProps = resolvedState.getTheadProps,
	          getTheadTrProps = resolvedState.getTheadTrProps,
	          getTheadThProps = resolvedState.getTheadThProps,
	          getTheadFilterProps = resolvedState.getTheadFilterProps,
	          getTheadFilterTrProps = resolvedState.getTheadFilterTrProps,
	          getTheadFilterThProps = resolvedState.getTheadFilterThProps,
	          getTbodyProps = resolvedState.getTbodyProps,
	          getTrGroupProps = resolvedState.getTrGroupProps,
	          getTrProps = resolvedState.getTrProps,
	          getTdProps = resolvedState.getTdProps,
	          getTfootProps = resolvedState.getTfootProps,
	          getTfootTrProps = resolvedState.getTfootTrProps,
	          getTfootTdProps = resolvedState.getTfootTdProps,
	          getPaginationProps = resolvedState.getPaginationProps,
	          getLoadingProps = resolvedState.getLoadingProps,
	          getNoDataProps = resolvedState.getNoDataProps,
	          getResizerProps = resolvedState.getResizerProps,
	          showPagination = resolvedState.showPagination,
	          showPaginationTop = resolvedState.showPaginationTop,
	          showPaginationBottom = resolvedState.showPaginationBottom,
	          manual = resolvedState.manual,
	          loadingText = resolvedState.loadingText,
	          noDataText = resolvedState.noDataText,
	          sortable = resolvedState.sortable,
	          multiSort = resolvedState.multiSort,
	          resizable = resolvedState.resizable,
	          filterable = resolvedState.filterable,
	          pivotIDKey = resolvedState.pivotIDKey,
	          pivotValKey = resolvedState.pivotValKey,
	          pivotBy = resolvedState.pivotBy,
	          subRowsKey = resolvedState.subRowsKey,
	          aggregatedKey = resolvedState.aggregatedKey,
	          originalKey = resolvedState.originalKey,
	          indexKey = resolvedState.indexKey,
	          groupedByPivotKey = resolvedState.groupedByPivotKey,
	          loading = resolvedState.loading,
	          pageSize = resolvedState.pageSize,
	          page = resolvedState.page,
	          sorted = resolvedState.sorted,
	          filtered = resolvedState.filtered,
	          resized = resolvedState.resized,
	          expanded = resolvedState.expanded,
	          pages = resolvedState.pages,
	          onExpandedChange = resolvedState.onExpandedChange,
	          TableComponent = resolvedState.TableComponent,
	          TheadComponent = resolvedState.TheadComponent,
	          TbodyComponent = resolvedState.TbodyComponent,
	          TrGroupComponent = resolvedState.TrGroupComponent,
	          TrComponent = resolvedState.TrComponent,
	          ThComponent = resolvedState.ThComponent,
	          TdComponent = resolvedState.TdComponent,
	          TfootComponent = resolvedState.TfootComponent,
	          PaginationComponent = resolvedState.PaginationComponent,
	          LoadingComponent = resolvedState.LoadingComponent,
	          SubComponent = resolvedState.SubComponent,
	          NoDataComponent = resolvedState.NoDataComponent,
	          ResizerComponent = resolvedState.ResizerComponent,
	          ExpanderComponent = resolvedState.ExpanderComponent,
	          PivotValueComponent = resolvedState.PivotValueComponent,
	          PivotComponent = resolvedState.PivotComponent,
	          AggregatedComponent = resolvedState.AggregatedComponent,
	          FilterComponent = resolvedState.FilterComponent,
	          PadRowComponent = resolvedState.PadRowComponent,
	          resolvedData = resolvedState.resolvedData,
	          allVisibleColumns = resolvedState.allVisibleColumns,
	          headerGroups = resolvedState.headerGroups,
	          hasHeaderGroups = resolvedState.hasHeaderGroups,
	          sortedData = resolvedState.sortedData,
	          currentlyResizing = resolvedState.currentlyResizing;
	
	      // Pagination
	
	      var startRow = pageSize * page;
	      var endRow = startRow + pageSize;
	      var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
	      var minRows = this.getMinRows();
	      var padRows = _utils2.default.range(Math.max(minRows - pageRows.length, 0));
	
	      var hasColumnFooter = allVisibleColumns.some(function (d) {
	        return d.Footer;
	      });
	      var hasFilters = filterable || allVisibleColumns.some(function (d) {
	        return d.filterable;
	      });
	
	      var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
	        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	        return [rows.map(function (row, i) {
	          index += 1;
	          var rowWithViewIndex = _extends({}, row, {
	            _viewIndex: index
	          });
	          var newPath = path.concat([i]);
	          if (rowWithViewIndex[subRowsKey] && _utils2.default.get(expanded, newPath)) {
	            var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);
	
	            var _recurseRowsViewIndex2 = _slicedToArray(_recurseRowsViewIndex, 2);
	
	            rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
	            index = _recurseRowsViewIndex2[1];
	          }
	          return rowWithViewIndex;
	        }), index];
	      };
	
	      var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);
	
	      var _recurseRowsViewIndex4 = _slicedToArray(_recurseRowsViewIndex3, 1);
	
	      pageRows = _recurseRowsViewIndex4[0];
	
	
	      var canPrevious = page > 0;
	      var canNext = page + 1 < pages;
	
	      var rowMinWidth = _utils2.default.sum(allVisibleColumns.map(function (d) {
	        var resizedColumn = resized.find(function (x) {
	          return x.id === d.id;
	        }) || {};
	        return _utils2.default.getFirstDefined(resizedColumn.value, d.width, d.minWidth);
	      }));
	
	      var rowIndex = -1;
	
	      var finalState = _extends({}, resolvedState, {
	        startRow: startRow,
	        endRow: endRow,
	        pageRows: pageRows,
	        minRows: minRows,
	        padRows: padRows,
	        hasColumnFooter: hasColumnFooter,
	        canPrevious: canPrevious,
	        canNext: canNext,
	        rowMinWidth: rowMinWidth
	      });
	
	      var rootProps = _utils2.default.splitProps(getProps(finalState, undefined, undefined, this));
	      var tableProps = _utils2.default.splitProps(getTableProps(finalState, undefined, undefined, this));
	      var tBodyProps = _utils2.default.splitProps(getTbodyProps(finalState, undefined, undefined, this));
	      var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
	      var noDataProps = getNoDataProps(finalState, undefined, undefined, this);
	
	      // Visual Components
	
	      var makeHeaderGroup = function makeHeaderGroup(column, i) {
	        var resizedValue = function resizedValue(col) {
	          return (resized.find(function (x) {
	            return x.id === col.id;
	          }) || {}).value;
	        };
	        var flex = _utils2.default.sum(column.columns.map(function (col) {
	          return col.width || resizedValue(col) ? 0 : col.minWidth;
	        }));
	        var width = _utils2.default.sum(column.columns.map(function (col) {
	          return _utils2.default.getFirstDefined(resizedValue(col), col.width, col.minWidth);
	        }));
	        var maxWidth = _utils2.default.sum(column.columns.map(function (col) {
	          return _utils2.default.getFirstDefined(resizedValue(col), col.width, col.maxWidth);
	        }));
	
	        var theadGroupThProps = _utils2.default.splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadGroupThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadGroupThProps.rest, columnHeaderProps.rest);
	
	        var flexStyles = {
	          flex: flex + ' 0 auto',
	          width: _utils2.default.asPx(width),
	          maxWidth: _utils2.default.asPx(maxWidth)
	        };
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes),
	            style: _extends({}, styles, flexStyles)
	          }, rest),
	          _utils2.default.normalizeComponent(column.Header, {
	            data: sortedData,
	            column: column
	          })
	        );
	      };
	
	      var makeHeaderGroups = function makeHeaderGroups() {
	        var theadGroupProps = _utils2.default.splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
	        var theadGroupTrProps = _utils2.default.splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-headerGroups', theadGroupProps.className),
	            style: _extends({}, theadGroupProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadGroupProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadGroupTrProps.className,
	              style: theadGroupTrProps.style
	            }, theadGroupTrProps.rest),
	            headerGroups.map(makeHeaderGroup)
	          )
	        );
	      };
	
	      var makeHeader = function makeHeader(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var sort = sorted.find(function (d) {
	          return d.id === column.id;
	        });
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var theadThProps = _utils2.default.splitProps(getTheadThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadThProps.rest, columnHeaderProps.rest);
	
	        var isResizable = _utils2.default.getFirstDefined(column.resizable, resizable, false);
	        var resizer = isResizable ? _react2.default.createElement(ResizerComponent, _extends({
	          onMouseDown: function onMouseDown(e) {
	            return _this2.resizeColumnStart(e, column, false);
	          },
	          onTouchStart: function onTouchStart(e) {
	            return _this2.resizeColumnStart(e, column, true);
	          }
	        }, getResizerProps('finalState', undefined, column, _this2))) : null;
	
	        var isSortable = _utils2.default.getFirstDefined(column.sortable, sortable, false);
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            }),
	            toggleSort: function toggleSort(e) {
	              if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
	            }
	          }, rest),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(isResizable && 'rt-resizable-header-content') },
	            _utils2.default.normalizeComponent(column.Header, {
	              data: sortedData,
	              column: column
	            })
	          ),
	          resizer
	        );
	      };
	
	      var makeHeaders = function makeHeaders() {
	        var theadProps = _utils2.default.splitProps(getTheadProps(finalState, undefined, undefined, _this2));
	        var theadTrProps = _utils2.default.splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-header', theadProps.className),
	            style: _extends({}, theadProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadTrProps.className,
	              style: theadTrProps.style
	            }, theadTrProps.rest),
	            allVisibleColumns.map(makeHeader)
	          )
	        );
	      };
	
	      var makeFilter = function makeFilter(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var theadFilterThProps = _utils2.default.splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
	        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
	
	        var classes = [column.headerClassName, theadFilterThProps.className, columnHeaderProps.className];
	
	        var styles = _extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);
	
	        var rest = _extends({}, theadFilterThProps.rest, columnHeaderProps.rest);
	
	        var filter = filtered.find(function (filter) {
	          return filter.id === column.id;
	        });
	
	        var ResolvedFilterComponent = column.Filter || FilterComponent;
	
	        var isFilterable = _utils2.default.getFirstDefined(column.filterable, filterable, false);
	
	        return _react2.default.createElement(
	          ThComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, rest),
	          isFilterable ? _utils2.default.normalizeComponent(ResolvedFilterComponent, {
	            column: column,
	            filter: filter,
	            onChange: function onChange(value) {
	              return _this2.filterColumn(column, value);
	            }
	          }, _defaultProps2.default.column.Filter) : null
	        );
	      };
	
	      var makeFilters = function makeFilters() {
	        var theadFilterProps = _utils2.default.splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
	        var theadFilterTrProps = _utils2.default.splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TheadComponent,
	          _extends({
	            className: (0, _classnames2.default)('-filters', theadFilterProps.className),
	            style: _extends({}, theadFilterProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, theadFilterProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: theadFilterTrProps.className,
	              style: theadFilterTrProps.style
	            }, theadFilterTrProps.rest),
	            allVisibleColumns.map(makeFilter)
	          )
	        );
	      };
	
	      var makePageRow = function makePageRow(row, i) {
	        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	        var rowInfo = {
	          original: row[originalKey],
	          row: row,
	          index: row[indexKey],
	          viewIndex: rowIndex += 1,
	          pageSize: pageSize,
	          page: page,
	          level: path.length,
	          nestingPath: path.concat([i]),
	          aggregated: row[aggregatedKey],
	          groupedByPivot: row[groupedByPivotKey],
	          subRows: row[subRowsKey]
	        };
	        var isExpanded = _utils2.default.get(expanded, rowInfo.nestingPath);
	        var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
	        var trProps = _utils2.default.splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
	        return _react2.default.createElement(
	          TrGroupComponent,
	          _extends({ key: rowInfo.nestingPath.join('_') }, trGroupProps),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: (0, _classnames2.default)(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
	              style: trProps.style
	            }, trProps.rest),
	            allVisibleColumns.map(function (column, i2) {
	              var resizedCol = resized.find(function (x) {
	                return x.id === column.id;
	              }) || {};
	              var show = typeof column.show === 'function' ? column.show() : column.show;
	              var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	              var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	              var tdProps = _utils2.default.splitProps(getTdProps(finalState, rowInfo, column, _this2));
	              var columnProps = _utils2.default.splitProps(column.getProps(finalState, rowInfo, column, _this2));
	
	              var classes = [tdProps.className, column.className, columnProps.className];
	
	              var styles = _extends({}, tdProps.style, column.style, columnProps.style);
	
	              var cellInfo = _extends({}, rowInfo, {
	                isExpanded: isExpanded,
	                column: _extends({}, column),
	                value: rowInfo.row[column.id],
	                pivoted: column.pivoted,
	                expander: column.expander,
	                resized: resized,
	                show: show,
	                width: width,
	                maxWidth: maxWidth,
	                tdProps: tdProps,
	                columnProps: columnProps,
	                classes: classes,
	                styles: styles
	              });
	
	              var value = cellInfo.value;
	
	              var useOnExpanderClick = void 0;
	              var isBranch = void 0;
	              var isPreview = void 0;
	
	              var onExpanderClick = function onExpanderClick(e) {
	                var newExpanded = _utils2.default.clone(expanded);
	                if (isExpanded) {
	                  newExpanded = _utils2.default.set(newExpanded, cellInfo.nestingPath, false);
	                } else {
	                  newExpanded = _utils2.default.set(newExpanded, cellInfo.nestingPath, {});
	                }
	
	                return _this2.setStateWithData({
	                  expanded: newExpanded
	                }, function () {
	                  return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e, cellInfo);
	                });
	              };
	
	              // Default to a standard cell
	              var resolvedCell = _utils2.default.normalizeComponent(column.Cell, cellInfo, value);
	
	              // Resolve Renderers
	              var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
	              var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
	              var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
	              var DefaultResolvedPivotComponent = PivotComponent || function (props) {
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(ResolvedExpanderComponent, props),
	                  _react2.default.createElement(ResolvedPivotValueComponent, props)
	                );
	              };
	              var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;
	
	              // Is this cell expandable?
	              if (cellInfo.pivoted || cellInfo.expander) {
	                // Make it expandable by defualt
	                cellInfo.expandable = true;
	                useOnExpanderClick = true;
	                // If pivoted, has no subRows, and does not have a subComponent,
	                // do not make expandable
	                if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
	                  cellInfo.expandable = false;
	                }
	              }
	
	              if (cellInfo.pivoted) {
	                // Is this column a branch?
	                isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
	                // Should this column be blank?
	                isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
	                // Pivot Cell Render Override
	                if (isBranch) {
	                  // isPivot
	                  resolvedCell = _utils2.default.normalizeComponent(ResolvedPivotComponent, _extends({}, cellInfo, {
	                    value: row[pivotValKey]
	                  }), row[pivotValKey]);
	                } else if (isPreview) {
	                  // Show the pivot preview
	                  resolvedCell = _utils2.default.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
	                } else {
	                  resolvedCell = null;
	                }
	              } else if (cellInfo.aggregated) {
	                resolvedCell = _utils2.default.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
	              }
	
	              if (cellInfo.expander) {
	                resolvedCell = _utils2.default.normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
	                if (pivotBy) {
	                  if (cellInfo.groupedByPivot) {
	                    resolvedCell = null;
	                  }
	                  if (!cellInfo.subRows && !SubComponent) {
	                    resolvedCell = null;
	                  }
	                }
	              }
	
	              var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function () {};
	
	              // If there are multiple onClick events, make sure they don't
	              // override eachother. This should maybe be expanded to handle all
	              // function attributes
	              var interactionProps = {
	                onClick: resolvedOnExpanderClick
	              };
	
	              if (tdProps.rest.onClick) {
	                interactionProps.onClick = function (e) {
	                  tdProps.rest.onClick(e, function () {
	                    return resolvedOnExpanderClick(e);
	                  });
	                };
	              }
	
	              if (columnProps.rest.onClick) {
	                interactionProps.onClick = function (e) {
	                  columnProps.rest.onClick(e, function () {
	                    return resolvedOnExpanderClick(e);
	                  });
	                };
	              }
	
	              // Return the cell
	              return _react2.default.createElement(
	                TdComponent
	                // eslint-disable-next-line react/no-array-index-key
	                ,
	                _extends({ key: i2 + '-' + column.id,
	                  className: (0, _classnames2.default)(classes, !cellInfo.expandable && !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
	                  style: _extends({}, styles, {
	                    flex: width + ' 0 auto',
	                    width: _utils2.default.asPx(width),
	                    maxWidth: _utils2.default.asPx(maxWidth)
	                  })
	                }, tdProps.rest, columnProps.rest, interactionProps),
	                resolvedCell
	              );
	            })
	          ),
	          rowInfo.subRows && isExpanded && rowInfo.subRows.map(function (d, i) {
	            return makePageRow(d, i, rowInfo.nestingPath);
	          }),
	          SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo, function () {
	            var newExpanded = _utils2.default.clone(expanded);
	
	            _utils2.default.set(newExpanded, rowInfo.nestingPath, false);
	          })
	        );
	      };
	
	      var makePadColumn = function makePadColumn(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var flex = width;
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var tdProps = _utils2.default.splitProps(getTdProps(finalState, undefined, column, _this2));
	        var columnProps = _utils2.default.splitProps(column.getProps(finalState, undefined, column, _this2));
	
	        var classes = [tdProps.className, column.className, columnProps.className];
	
	        var styles = _extends({}, tdProps.style, column.style, columnProps.style);
	
	        return _react2.default.createElement(
	          TdComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, !show && 'hidden'),
	            style: _extends({}, styles, {
	              flex: flex + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, tdProps.rest),
	          _utils2.default.normalizeComponent(PadRowComponent)
	        );
	      };
	
	      var makePadRow = function makePadRow(row, i) {
	        var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
	        var trProps = _utils2.default.splitProps(getTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TrGroupComponent,
	          _extends({ key: 'pad-' + i }, trGroupProps),
	          _react2.default.createElement(
	            TrComponent,
	            {
	              className: (0, _classnames2.default)('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
	              style: trProps.style || {}
	            },
	            allVisibleColumns.map(makePadColumn)
	          )
	        );
	      };
	
	      var makeColumnFooter = function makeColumnFooter(column, i) {
	        var resizedCol = resized.find(function (x) {
	          return x.id === column.id;
	        }) || {};
	        var show = typeof column.show === 'function' ? column.show() : column.show;
	        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
	        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
	        var tFootTdProps = _utils2.default.splitProps(getTfootTdProps(finalState, undefined, undefined, _this2));
	        var columnProps = _utils2.default.splitProps(column.getProps(finalState, undefined, column, _this2));
	        var columnFooterProps = _utils2.default.splitProps(column.getFooterProps(finalState, undefined, column, _this2));
	
	        var classes = [tFootTdProps.className, column.className, columnProps.className, columnFooterProps.className];
	
	        var styles = _extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);
	
	        return _react2.default.createElement(
	          TdComponent,
	          _extends({
	            key: i + '-' + column.id,
	            className: (0, _classnames2.default)(classes, !show && 'hidden'),
	            style: _extends({}, styles, {
	              flex: width + ' 0 auto',
	              width: _utils2.default.asPx(width),
	              maxWidth: _utils2.default.asPx(maxWidth)
	            })
	          }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest),
	          _utils2.default.normalizeComponent(column.Footer, {
	            data: sortedData,
	            column: column
	          })
	        );
	      };
	
	      var makeColumnFooters = function makeColumnFooters() {
	        var tFootProps = _utils2.default.splitProps(getTfootProps(finalState, undefined, undefined, _this2));
	        var tFootTrProps = _utils2.default.splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(
	          TfootComponent,
	          _extends({
	            className: tFootProps.className,
	            style: _extends({}, tFootProps.style, {
	              minWidth: rowMinWidth + 'px'
	            })
	          }, tFootProps.rest),
	          _react2.default.createElement(
	            TrComponent,
	            _extends({
	              className: (0, _classnames2.default)(tFootTrProps.className),
	              style: tFootTrProps.style
	            }, tFootTrProps.rest),
	            allVisibleColumns.map(makeColumnFooter)
	          )
	        );
	      };
	
	      var makePagination = function makePagination(isTop) {
	        var paginationProps = _utils2.default.splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
	        return _react2.default.createElement(PaginationComponent, _extends({}, resolvedState, {
	          pages: pages,
	          canPrevious: canPrevious,
	          canNext: canNext,
	          onPageChange: _this2.onPageChange,
	          onPageSizeChange: _this2.onPageSizeChange,
	          className: paginationProps.className,
	          style: paginationProps.style,
	          isTop: isTop
	        }, paginationProps.rest));
	      };
	
	      var makeTable = function makeTable() {
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('ReactTable', className, rootProps.className),
	            style: _extends({}, style, rootProps.style)
	          }, rootProps.rest),
	          showPagination && showPaginationTop ? _react2.default.createElement(
	            'div',
	            { className: 'pagination-top' },
	            makePagination(true)
	          ) : null,
	          _react2.default.createElement(
	            TableComponent,
	            _extends({
	              className: (0, _classnames2.default)(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
	              style: tableProps.style
	            }, tableProps.rest),
	            hasHeaderGroups ? makeHeaderGroups() : null,
	            makeHeaders(),
	            hasFilters ? makeFilters() : null,
	            _react2.default.createElement(
	              TbodyComponent,
	              _extends({
	                className: (0, _classnames2.default)(tBodyProps.className),
	                style: _extends({}, tBodyProps.style, {
	                  minWidth: rowMinWidth + 'px'
	                })
	              }, tBodyProps.rest),
	              pageRows.map(function (d, i) {
	                return makePageRow(d, i);
	              }),
	              padRows.map(makePadRow)
	            ),
	            hasColumnFooter ? makeColumnFooters() : null
	          ),
	          showPagination && showPaginationBottom ? _react2.default.createElement(
	            'div',
	            { className: 'pagination-bottom' },
	            makePagination(false)
	          ) : null,
	          !pageRows.length && _react2.default.createElement(
	            NoDataComponent,
	            noDataProps,
	            _utils2.default.normalizeComponent(noDataText)
	          ),
	          _react2.default.createElement(LoadingComponent, _extends({ loading: loading, loadingText: loadingText }, loadingProps))
	        );
	      };
	
	      // childProps are optionally passed to a function-as-a-child
	      return children ? children(finalState, makeTable, this) : makeTable();
	    }
	  }]);
	
	  return ReactTable;
	}((0, _methods2.default)((0, _lifecycle2.default)(_react.Component)));
	
	ReactTable.propTypes = _propTypes2.default;
	ReactTable.defaultProps = _defaultProps2.default;
	exports.default = ReactTable;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = SchemaType;
	
	var _has = __webpack_require__(67);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _cloneDeepWith = __webpack_require__(886);
	
	var _cloneDeepWith2 = _interopRequireDefault(_cloneDeepWith);
	
	var _toArray = __webpack_require__(904);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _locale = __webpack_require__(65);
	
	var _Condition = __webpack_require__(772);
	
	var _Condition2 = _interopRequireDefault(_Condition);
	
	var _runValidations = __webpack_require__(154);
	
	var _runValidations2 = _interopRequireDefault(_runValidations);
	
	var _merge = __webpack_require__(782);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isSchema = __webpack_require__(52);
	
	var _isSchema2 = _interopRequireDefault(_isSchema);
	
	var _isAbsent = __webpack_require__(78);
	
	var _isAbsent2 = _interopRequireDefault(_isAbsent);
	
	var _createValidation = __webpack_require__(780);
	
	var _createValidation2 = _interopRequireDefault(_createValidation);
	
	var _printValue = __webpack_require__(153);
	
	var _printValue2 = _interopRequireDefault(_printValue);
	
	var _Reference = __webpack_require__(77);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notEmpty = function notEmpty(value) {
	  return !(0, _isAbsent2.default)(value);
	};
	
	function extractTestParams(name, message, test) {
	  var opts = name;
	
	  if (typeof message === 'function') {
	    test = message;message = _locale.mixed.default;name = null;
	  }
	
	  if (typeof name === 'function') {
	    test = name;message = _locale.mixed.default;name = null;
	  }
	
	  if (typeof name === 'string' || name === null) opts = { name: name, test: test, message: message, exclusive: false };
	
	  if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
	
	  return opts;
	}
	
	function SchemaType() {
	  var _this = this;
	
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (!(this instanceof SchemaType)) return new SchemaType();
	
	  this._deps = [];
	  this._conditions = [];
	  this._options = { abortEarly: true, recursive: true };
	  this._exclusive = Object.create(null);
	  this._whitelist = new Set();
	  this._blacklist = new Set();
	  this.tests = [];
	  this.transforms = [];
	
	  this.withMutation(function () {
	    _this.typeError(_locale.mixed.notType);
	  });
	
	  if ((0, _has2.default)(options, 'default')) this._defaultDefault = options.default;
	
	  this._type = options.type || 'mixed';
	}
	
	SchemaType.prototype = {
	
	  __isYupSchema__: true,
	
	  constructor: SchemaType,
	
	  clone: function clone() {
	    var _this2 = this;
	
	    if (this._mutate) return this;
	
	    // if the nested value is a schema we can skip cloning, since
	    // they are already immutable
	    return (0, _cloneDeepWith2.default)(this, function (value) {
	      if ((0, _isSchema2.default)(value) && value !== _this2) return value;
	    });
	  },
	  label: function label(_label) {
	    var next = this.clone();
	    next._label = _label;
	    return next;
	  },
	  meta: function meta(obj) {
	    if (arguments.length === 0) return this._meta;
	
	    var next = this.clone();
	    next._meta = _extends(next._meta || {}, obj);
	    return next;
	  },
	  withMutation: function withMutation(fn) {
	    this._mutate = true;
	    var result = fn(this);
	    this._mutate = false;
	    return result;
	  },
	  concat: function concat(schema) {
	    if (!schema) return this;
	
	    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError('You cannot `concat()` schema\'s of different types: ' + this._type + ' and ' + schema._type);
	    var cloned = this.clone();
	    var next = (0, _merge2.default)(this.clone(), schema.clone());
	
	    // undefined isn't merged over, but is a valid value for default
	    if ((0, _has2.default)(schema, '_default')) next._default = schema._default;
	
	    next.tests = cloned.tests;
	    next._exclusive = cloned._exclusive;
	
	    // manually add the new tests to ensure
	    // the deduping logic is consistent
	    schema.tests.forEach(function (fn) {
	      next = next.test(fn.TEST);
	    });
	
	    next._type = schema._type;
	
	    return next;
	  },
	  isType: function isType(v) {
	    if (this._nullable && v === null) return true;
	    return !this._typeCheck || this._typeCheck(v);
	  },
	  resolve: function resolve(_ref) {
	    var context = _ref.context,
	        parent = _ref.parent;
	
	    if (this._conditions.length) {
	      return this._conditions.reduce(function (schema, match) {
	        return match.resolve(schema, match.getValue(parent, context));
	      }, this);
	    }
	
	    return this;
	  },
	  cast: function cast(value) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var resolvedSchema = this.resolve(options);
	    var result = resolvedSchema._cast(value, options);
	
	    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
	      var formattedValue = (0, _printValue2.default)(value);
	      var formattedResult = (0, _printValue2.default)(result);
	      throw new TypeError('The value of ' + (options.path || 'field') + ' could not be cast to a value ' + ('that satisfies the schema type: "' + resolvedSchema._type + '". \n\n') + ('attempted value: ' + formattedValue + ' \n') + (formattedResult !== formattedValue ? 'result of cast: ' + formattedResult : ''));
	    }
	
	    return result;
	  },
	  _cast: function _cast(rawValue) {
	    var _this3 = this;
	
	    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
	      return fn.call(_this3, value, rawValue);
	    }, rawValue);
	
	    if (value === undefined && (0, _has2.default)(this, '_default')) {
	      value = this.default();
	    }
	
	    return value;
	  },
	  _validate: function _validate(_value) {
	    var _this4 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var value = _value;
	    var originalValue = options.originalValue != null ? options.originalValue : _value;
	
	    var isStrict = this._option('strict', options);
	    var endEarly = this._option('abortEarly', options);
	
	    var sync = options.sync;
	    var path = options.path;
	    var label = this._label;
	
	    if (!isStrict) {
	      value = this._cast(value, _extends({ assert: false }, options));
	    }
	    // value is cast, we can check if it meets type requirements
	    var validationParams = { value: value, path: path, schema: this, options: options, label: label, originalValue: originalValue, sync: sync };
	    var initialTests = [];
	
	    if (this._typeError) initialTests.push(this._typeError(validationParams));
	
	    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
	
	    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
	
	    return (0, _runValidations2.default)({ validations: initialTests, endEarly: endEarly, value: value, path: path, sync: sync }).then(function (value) {
	      return (0, _runValidations2.default)({
	        path: path,
	        sync: sync,
	        value: value,
	        endEarly: endEarly,
	        validations: _this4.tests.map(function (fn) {
	          return fn(validationParams);
	        })
	      });
	    });
	  },
	  validate: function validate(value) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var schema = this.resolve(options);
	    return schema._validate(value, options);
	  },
	  validateSync: function validateSync(value) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var schema = this.resolve(options);
	    var result = void 0,
	        err = void 0;
	
	    schema._validate(value, _extends({}, options, { sync: true })).then(function (r) {
	      return result = r;
	    }).catch(function (e) {
	      return err = e;
	    });
	
	    if (err) throw err;
	    return result;
	  },
	  isValid: function isValid(value, options) {
	    return this.validate(value, options).then(function () {
	      return true;
	    }).catch(function (err) {
	      if (err.name === 'ValidationError') return false;
	
	      throw err;
	    });
	  },
	  isValidSync: function isValidSync(value, options) {
	    try {
	      this.validateSync(value, _extends({}, options));
	      return true;
	    } catch (err) {
	      if (err.name === 'ValidationError') return false;
	      throw err;
	    }
	  },
	  getDefault: function getDefault(_ref2) {
	    var context = _ref2.context,
	        parent = _ref2.parent;
	
	    return this._resolve(context, parent).default();
	  },
	  default: function _default(def) {
	    if (arguments.length === 0) {
	      var defaultValue = (0, _has2.default)(this, '_default') ? this._default : this._defaultDefault;
	
	      return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, _cloneDeepWith2.default)(defaultValue);
	    }
	
	    var next = this.clone();
	    next._default = def;
	    return next;
	  },
	  strict: function strict() {
	    var next = this.clone();
	    next._options.strict = true;
	    return next;
	  },
	  required: function required(msg) {
	    return this.test('required', msg || _locale.mixed.required, notEmpty);
	  },
	  nullable: function nullable(value) {
	    var next = this.clone();
	    next._nullable = value === false ? false : true;
	    return next;
	  },
	  transform: function transform(fn) {
	    var next = this.clone();
	    next.transforms.push(fn);
	    return next;
	  },
	
	
	  /**
	   * Adds a test function to the schema's queue of tests.
	   * tests can be exclusive or non-exclusive.
	   *
	   * - exclusive tests, will replace any existing tests of the same name.
	   * - non-exclusive: can be stacked
	   *
	   * If a non-exclusive test is added to a schema with an exclusive test of the same name
	   * the exclusive test is removed and further tests of the same name will be stacked.
	   *
	   * If an exclusive test is added to a schema with non-exclusive tests of the same name
	   * the previous tests are removed and further tests of the same name will replace each other.
	   */
	  test: function test(name, message, _test) {
	    var opts = extractTestParams(name, message, _test),
	        next = this.clone();
	
	    var validate = (0, _createValidation2.default)(opts);
	
	    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;
	
	    if (opts.exclusive && !opts.name) {
	      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
	    }
	
	    next._exclusive[opts.name] = !!opts.exclusive;
	
	    next.tests = next.tests.filter(function (fn) {
	      if (fn.TEST_NAME === opts.name) {
	        if (isExclusive) return false;
	        if (fn.TEST.test === validate.TEST.test) return false;
	      }
	      return true;
	    });
	
	    next.tests.push(validate);
	
	    return next;
	  },
	  when: function when(keys, options) {
	    var next = this.clone(),
	        deps = [].concat(keys).map(function (key) {
	      return new _Reference2.default(key);
	    });
	
	    deps.forEach(function (dep) {
	      if (!dep.isContext) next._deps.push(dep.key);
	    });
	
	    next._conditions.push(new _Condition2.default(deps, options));
	
	    return next;
	  },
	  typeError: function typeError(message) {
	    var next = this.clone();
	
	    next._typeError = (0, _createValidation2.default)({
	      name: 'typeError',
	      message: message,
	      test: function test(value) {
	        if (value !== undefined && !this.schema.isType(value)) return this.createError({
	          params: {
	            type: this.schema._type
	          }
	        });
	        return true;
	      }
	    });
	    return next;
	  },
	  oneOf: function oneOf(enums) {
	    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _locale.mixed.oneOf;
	
	    var next = this.clone();
	
	    enums.forEach(function (val) {
	      if (next._blacklist.has(val)) next._blacklist.delete(val);
	      next._whitelist.add(val);
	    });
	
	    next._whitelistError = (0, _createValidation2.default)({
	      message: message,
	      name: 'oneOf',
	      test: function test(value) {
	        var valids = this.schema._whitelist;
	        if (valids.size && !(value === undefined || valids.has(value))) return this.createError({
	          params: {
	            values: (0, _toArray2.default)(valids).join(', ')
	          }
	        });
	        return true;
	      }
	    });
	
	    return next;
	  },
	  notOneOf: function notOneOf(enums) {
	    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _locale.mixed.notOneOf;
	
	    var next = this.clone();
	
	    enums.forEach(function (val) {
	      next._whitelist.delete(val);
	      next._blacklist.add(val);
	    });
	
	    next._blacklistError = (0, _createValidation2.default)({
	      message: message,
	      name: 'notOneOf',
	      test: function test(value) {
	        var invalids = this.schema._blacklist;
	        if (invalids.size && invalids.has(value)) return this.createError({
	          params: {
	            values: (0, _toArray2.default)(invalids).join(', ')
	          }
	        });
	        return true;
	      }
	    });
	
	    return next;
	  },
	  strip: function strip() {
	    var strip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    var next = this.clone();
	    next._strip = strip;
	    return next;
	  },
	  _option: function _option(key, overrides) {
	    return (0, _has2.default)(overrides, key) ? overrides[key] : this._options[key];
	  },
	  describe: function describe() {
	    var next = this.clone();
	
	    return {
	      type: next._type,
	      meta: next._meta,
	      label: next._label,
	      tests: next.tests.map(function (fn) {
	        return fn.TEST_NAME;
	      }, {})
	    };
	  }
	};
	
	var aliases = {
	  oneOf: ['equals', 'is'],
	  notOneOf: ['not', 'nope']
	};
	
	Object.keys(aliases).forEach(function (method) {
	  aliases[method].forEach(function (alias) {
	    return SchemaType.prototype[alias] = SchemaType.prototype[method];
	  });
	});
	module.exports = exports['default'];

/***/ },
/* 52 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj) {
	  return obj && obj.__isYupSchema__;
	};
	
	module.exports = exports["default"];

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(38);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(53),
	    getRawTag = __webpack_require__(841),
	    objectToString = __webpack_require__(869);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(808),
	    getValue = __webpack_require__(842);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * MUI CSS/JS utilities module
	 * @module lib/util
	 */
	
	'use strict';
	
	
	var config = __webpack_require__(330),
	    jqLite = __webpack_require__(83),
	    scrollLock = 0,
	    scrollLockCls = 'mui-scroll-lock',
	    scrollLockPos,
	    scrollStyleEl,
	    scrollEventHandler,
	    _scrollBarWidth,
	    _supportsPointerEvents;
	
	
	scrollEventHandler = function(ev) {
	  // stop propagation on window scroll events
	  if (!ev.target.tagName) ev.stopImmediatePropagation();
	}
	
	
	/**
	 * Logging function
	 */
	function logFn() {
	  var win = window;
	  
	  if (config.debug && typeof win.console !== "undefined") {
	    try {
	      win.console.log.apply(win.console, arguments);
	    } catch (a) {
	      var e = Array.prototype.slice.call(arguments);
	      win.console.log(e.join("\n"));
	    }
	  }
	}
	
	
	/**
	 * Load CSS text in new stylesheet
	 * @param {string} cssText - The css text.
	 */
	function loadStyleFn(cssText) {
	  var doc = document,
	      head;
	  
	  // copied from jQuery 
	  head = doc.head ||
	    doc.getElementsByTagName('head')[0] ||
	    doc.documentElement;
	  
	  var e = doc.createElement('style');
	  e.type = 'text/css';
	  
	  if (e.styleSheet) e.styleSheet.cssText = cssText;
	  else e.appendChild(doc.createTextNode(cssText));
	  
	  // add to document
	  head.insertBefore(e, head.firstChild);
	  
	  return e;
	}
	
	
	/**
	 * Raise an error
	 * @param {string} msg - The error message.
	 */
	function raiseErrorFn(msg, useConsole) {
	  if (useConsole) {
	    if (typeof console !== 'undefined') console.warn('MUI Warning: ' + msg);
	  } else {
	    throw new Error('MUI: ' + msg);
	  }
	}
	
	
	/**
	 * Convert Classname object, with class as key and true/false as value, to an
	 * class string.
	 * @param  {Object} classes The classes
	 * @return {String}         class string
	 */
	function classNamesFn(classes) {
	  var cs = '';
	  for (var i in classes) {
	    cs += (classes[i]) ? i + ' ' : '';
	  }
	  return cs.trim();
	}
	
	
	/**
	 * Check if client supports pointer events.
	 */
	function supportsPointerEventsFn() {
	  // check cache
	  if (_supportsPointerEvents !== undefined) return _supportsPointerEvents;
	  
	  var element = document.createElement('x');
	  element.style.cssText = 'pointer-events:auto';
	  _supportsPointerEvents = (element.style.pointerEvents === 'auto');
	  return _supportsPointerEvents;
	}
	
	
	/**
	 * Create callback closure.
	 * @param {Object} instance - The object instance.
	 * @param {String} funcName - The name of the callback function.
	 */
	function callbackFn(instance, funcName) {
	  return function() {instance[funcName].apply(instance, arguments);};
	}
	
	
	/**
	 * Dispatch event.
	 * @param {Element} element - The DOM element.
	 * @param {String} eventType - The event type.
	 * @param {Boolean} bubbles=true - If true, event bubbles.
	 * @param {Boolean} cancelable=true = If true, event is cancelable
	 * @param {Object} [data] - Data to add to event object
	 */
	function dispatchEventFn(element, eventType, bubbles, cancelable, data) {
	  var ev = document.createEvent('HTMLEvents'),
	      bubbles = (bubbles !== undefined) ? bubbles : true,
	      cancelable = (cancelable !== undefined) ? cancelable : true,
	      k;
	
	  ev.initEvent(eventType, bubbles, cancelable);
	  
	  // add data to event object
	  if (data) for (k in data) ev[k] = data[k];
	  
	  // dispatch
	  if (element) element.dispatchEvent(ev);
	  
	  return ev;
	}
	
	
	/**
	 * Turn on window scroll lock.
	 */
	function enableScrollLockFn() {
	  // increment counter
	  scrollLock += 1;
	  
	  // add lock
	  if (scrollLock === 1) {
	    var doc = document,
	        win = window,
	        htmlEl = doc.documentElement,
	        bodyEl = doc.body,
	        scrollBarWidth = getScrollBarWidth(),
	        cssProps,
	        cssStr,
	        x;
	
	    // define scroll lock class dynamically
	    cssProps = ['overflow:hidden'];
	
	    if (scrollBarWidth) {
	      // scrollbar-y
	      if (htmlEl.scrollHeight > htmlEl.clientHeight) {
	        x = parseInt(jqLite.css(bodyEl, 'padding-right')) + scrollBarWidth;
	        cssProps.push('padding-right:' + x + 'px');
	      }
	    
	      // scrollbar-x
	      if (htmlEl.scrollWidth > htmlEl.clientWidth) {
	        x = parseInt(jqLite.css(bodyEl, 'padding-bottom')) + scrollBarWidth;
	        cssProps.push('padding-bottom:' + x + 'px');
	      }
	    }
	
	    // define css class dynamically
	    cssStr = '.' + scrollLockCls + '{';
	    cssStr += cssProps.join(' !important;') + ' !important;}';
	    scrollStyleEl = loadStyleFn(cssStr);
	
	    // cancel 'scroll' event listener callbacks
	    jqLite.on(win, 'scroll', scrollEventHandler, true);
	
	    // add scroll lock
	    scrollLockPos = {left: jqLite.scrollLeft(win), top: jqLite.scrollTop(win)};
	    jqLite.addClass(bodyEl, scrollLockCls);
	  }
	}
	
	
	/**
	 * Turn off window scroll lock.
	 * @param {Boolean} resetPos - Reset scroll position to original value.
	 */
	function disableScrollLockFn(resetPos) {
	  // ignore
	  if (scrollLock === 0) return;
	
	  // decrement counter
	  scrollLock -= 1;
	
	  // remove lock 
	  if (scrollLock === 0) {
	    // remove scroll lock and delete style element
	    jqLite.removeClass(document.body, scrollLockCls);
	
	    // restore scroll position
	    if (resetPos) window.scrollTo(scrollLockPos.left, scrollLockPos.top);
	
	    // restore scroll event listeners
	    jqLite.off(window, 'scroll', scrollEventHandler, true);
	
	    // delete style element (deferred for Firefox Quantum bugfix)
	    setTimeout(function() {
	      scrollStyleEl.parentNode.removeChild(scrollStyleEl);      
	    }, 0);
	  }
	}
	
	/**
	 * Return scroll bar width.
	 */
	var getScrollBarWidth = function() {
	  // check cache
	  if (_scrollBarWidth !== undefined) return _scrollBarWidth;
	  
	  // calculate scroll bar width
	  var doc = document,
	      bodyEl = doc.body,
	      el = doc.createElement('div');
	
	  el.innerHTML = '<div style="width:50px;height:50px;position:absolute;' + 
	    'left:-50px;top:-50px;overflow:auto;"><div style="width:1px;' + 
	    'height:100px;"></div></div>';
	  el = el.firstChild;
	  bodyEl.appendChild(el);
	  _scrollBarWidth = el.offsetWidth - el.clientWidth;
	  bodyEl.removeChild(el);
	
	  return _scrollBarWidth;
	}
	
	
	/**
	 * requestAnimationFrame polyfilled
	 * @param {Function} callback - The callback function
	 */
	function requestAnimationFrameFn(callback) {
	  var fn = window.requestAnimationFrame;
	  if (fn) fn(callback);
	  else setTimeout(callback, 0);
	}
	
	
	/**
	 * Define the module API
	 */
	module.exports = {
	  /** Create callback closures */
	  callback: callbackFn,
	  
	  /** Classnames object to string */
	  classNames: classNamesFn,
	
	  /** Disable scroll lock */
	  disableScrollLock: disableScrollLockFn,
	
	  /** Dispatch event */
	  dispatchEvent: dispatchEventFn,
	  
	  /** Enable scroll lock */
	  enableScrollLock: enableScrollLockFn,
	
	  /** Log messages to the console when debug is turned on */
	  log: logFn,
	
	  /** Load CSS text as new stylesheet */
	  loadStyle: loadStyleFn,
	
	  /** Raise MUI error */
	  raiseError: raiseErrorFn,
	
	  /** Request animation frame */
	  requestAnimationFrame: requestAnimationFrameFn,
	
	  /** Support Pointer Events check */
	  supportsPointerEvents: supportsPointerEventsFn
	};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _toCss = __webpack_require__(133);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	var _toCssValue = __webpack_require__(88);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleRule = function () {
	  function StyleRule(key, style, options) {
	    _classCallCheck(this, StyleRule);
	
	    this.type = 'style';
	    this.isProcessed = false;
	    var sheet = options.sheet,
	        Renderer = options.Renderer,
	        selector = options.selector;
	
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (selector) this.selectorText = selector;
	    this.renderer = sheet ? sheet.renderer : new Renderer();
	  }
	
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  _createClass(StyleRule, [{
	    key: 'prop',
	
	
	    /**
	     * Get or set a style property.
	     */
	    value: function prop(name, value) {
	      // It's a getter.
	      if (value === undefined) return this.style[name];
	
	      // Don't do anything if the value has not changed.
	      if (this.style[name] === value) return this;
	
	      value = this.options.jss.plugins.onChangeValue(value, name, this);
	
	      var isEmpty = value == null || value === false;
	      var isDefined = name in this.style;
	
	      // Value is empty and wasn't defined before.
	      if (isEmpty && !isDefined) return this;
	
	      // We are going to remove this value.
	      var remove = isEmpty && isDefined;
	
	      if (remove) delete this.style[name];else this.style[name] = value;
	
	      // Renderable is defined if StyleSheet option `link` is true.
	      if (this.renderable) {
	        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
	        return this;
	      }
	
	      var sheet = this.options.sheet;
	
	      if (sheet && sheet.attached) {
	        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
	      }
	      return this;
	    }
	
	    /**
	     * Apply rule to an element inline.
	     */
	
	  }, {
	    key: 'applyTo',
	    value: function applyTo(renderable) {
	      var json = this.toJSON();
	      for (var prop in json) {
	        this.renderer.setProperty(renderable, prop, json[prop]);
	      }return this;
	    }
	
	    /**
	     * Returns JSON representation of the rule.
	     * Fallbacks are not supported.
	     * Useful for inline styles.
	     */
	
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      var json = {};
	      for (var prop in this.style) {
	        var value = this.style[prop];
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
	      }
	      return json;
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      var sheet = this.options.sheet;
	
	      var link = sheet ? sheet.options.link : false;
	      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
	      return (0, _toCss2['default'])(this.selector, this.style, opts);
	    }
	  }, {
	    key: 'selector',
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	
	      this.selectorText = selector;
	
	      if (!this.renderable) return;
	
	      var hasChanged = this.renderer.setSelector(this.renderable, selector);
	
	      // If selector setter is not implemented, rerender the rule.
	      if (!hasChanged && this.renderable) {
	        var renderable = this.renderer.replaceRule(this.renderable, this);
	        if (renderable) this.renderable = renderable;
	      }
	    }
	
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}();
	
	exports['default'] = StyleRule;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(499);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(43);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(15);
	
	var _AppAction = __webpack_require__(22);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscountCoupon = new _immutable2.default.Record({
		couponCode: null,
		discountAmount: null,
		isValid: null
	});
	
	var OrderStore = function (_ReduceStore) {
		_inherits(OrderStore, _ReduceStore);
	
		function OrderStore() {
			_classCallCheck(this, OrderStore);
	
			var _this = _possibleConstructorReturn(this, (OrderStore.__proto__ || Object.getPrototypeOf(OrderStore)).call(this, _Dispatcher2.default));
	
			_this.PRODUCT_ORDERS = "DESIGN_ORDERS";
			_this.ORDERS_BY_STATE = "ORDERS_BY_STATE";
	
			_this.ORDER_STAT = "ORDER_STAT";
	
			_this.SINGLE_ORDER = "ORDER";
			return _this;
		}
	
		_createClass(OrderStore, [{
			key: 'getInitialState',
			value: function getInitialState() {
				return _immutable2.default.Map();
			}
		}, {
			key: 'getProductOrders',
			value: function getProductOrders(productId) {
				return this.getState().get(this.PRODUCT_ORDERS + "_" + productId) || null;
			}
		}, {
			key: 'getUserOrders',
			value: function getUserOrders() {
				return this.getState().get(_AppAction.OrderAction.LOAD_USER_ORDERS) || null;
			}
		}, {
			key: 'getOrdersByState',
			value: function getOrdersByState(orderStates) {
				return this.getState().get(this.ORDERS_BY_STATE + "_" + orderStates) || null;
			}
		}, {
			key: 'getOrderStat',
			value: function getOrderStat() {
				return this.getState().get(this.ORDER_STAT) || null;
			}
		}, {
			key: 'getOrder',
			value: function getOrder(orderId) {
				return this.getState().get(this.SINGLE_ORDER + "_" + orderId) || null;
			}
		}, {
			key: 'getDashainCampaignOrders',
			value: function getDashainCampaignOrders() {
				return this.getState().get(_AppAction.OrderAction.LOAD_DASHAIN_CAMPAIGN_ORDERS) || null;
			}
		}, {
			key: 'getDiscountCoupon',
			value: function getDiscountCoupon(couponCode) {
				return this.getState().get(_AppAction.OrderAction.LOAD_DISCOUNT_COUPON + "_" + couponCode) || null;
			}
		}, {
			key: 'getActionOrders',
			value: function getActionOrders(actionName) {
				return this.getState().get(actionName) || null;
			}
		}, {
			key: 'reduce',
			value: function reduce(state, action) {
	
				switch (action.type) {
					case _AppAction.OrderAction.LOAD_PRODUCT_ORDERS:
						var productId = action.productId;
	
						return state.set(this.PRODUCT_ORDERS + "_" + productId, _immutable2.default.List(action.orders));
	
					case _AppAction.OrderAction.LOAD_ALL_ORDERS_BY_STATE:
						var orderStates = action.orderStates;
	
						return state.set(this.ORDERS_BY_STATE + "_" + orderStates, _immutable2.default.List(action.orders));
	
					case _AppAction.OrderAction.LOAD_USER_ORDERS:
						return state.set(_AppAction.OrderAction.LOAD_USER_ORDERS, _immutable2.default.List(action.orders));
	
					case _AppAction.OrderAction.LOAD_DASHAIN_CAMPAIGN_ORDERS:
						return state.set(action.type, _immutable2.default.List(action.orders));
	
					case _AppAction.OrderAction.LOAD_CHETAN_CAMPAGIN_ORDERS:
						return state.set(action.type, _immutable2.default.List(action.orders));
	
					case _AppAction.OrderAction.UPDATE_ORDER_STATE:
						var order = action.order;
						var newState = action.newState;
						var oldState = order.orderState;
	
						//reset new state orders list and remove this order from current state order list
						var oldStateList = this.getOrdersByState(oldState);
	
						if (oldStateList) oldStateList = oldStateList.filter(function (o) {
							return o.orderId !== order.orderId;
						});
	
						return state.set(this.ORDERS_BY_STATE + "_" + newState, null).set(this.ORDERS_BY_STATE + "_" + oldState, oldStateList);
	
					case _AppAction.OrderAction.LOAD_ORDER_STAT:
						return state.set(this.ORDER_STAT, action.stat);
	
					case _AppAction.OrderAction.LOAD_SINGLE_ORDER:
						return state.set(this.SINGLE_ORDER + "_" + action.order.orderId, action.order);
	
					case _AppAction.OrderAction.UPDATE_SINGLE_ORDER:
						return state.clear().set(this.SINGLE_ORDER + "_" + action.order.orderId, action.order);
	
					case _AppAction.OrderAction.PLACE_ORDER:
						return state.set(_AppAction.OrderAction.LOAD_USER_ORDERS, null);
	
					case _AppAction.OrderAction.LOAD_DISCOUNT_COUPON:
						var discountCoupon = new DiscountCoupon({
							couponCode: action.couponCode,
							discountAmount: action.discountAmount,
							isValid: action.isValid
						});
	
						return state.set(_AppAction.OrderAction.LOAD_DISCOUNT_COUPON + "_" + action.couponCode, discountCoupon);
	
					case _AppAction.UserAction.LOGOUT:
						return state.clear();
					default:
						break;
	
				}
				return state;
			}
		}]);
	
		return OrderStore;
	}(_utils.ReduceStore);
	
	exports.default = new OrderStore();

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateComponent = function (_React$Component) {
		_inherits(DateComponent, _React$Component);
	
		function DateComponent() {
			_classCallCheck(this, DateComponent);
	
			return _possibleConstructorReturn(this, (DateComponent.__proto__ || Object.getPrototypeOf(DateComponent)).apply(this, arguments));
		}
	
		_createClass(DateComponent, [{
			key: 'render',
			value: function render() {
				var date = new Date(this.props.date);
	
				var showTime = this.props.showTime || false;
				if (this.props.relative === true) return _react2.default.createElement(_reactIntl.FormattedRelative, { value: date });else {
					if (showTime) return _react2.default.createElement(_reactIntl.FormattedDate, { value: date,
						day: 'numeric', month: 'short', year: 'numeric',
						minute: "numeric", second: "numeric", hour: "numeric" });else return _react2.default.createElement(_reactIntl.FormattedDate, { value: date,
						day: 'numeric', month: 'long', year: 'numeric' });
				}
			}
		}]);
	
		return DateComponent;
	}(_react2.default.Component);
	
	exports.default = DateComponent;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	__webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = function (_React$Component) {
		_inherits(Loader, _React$Component);
	
		function Loader() {
			_classCallCheck(this, Loader);
	
			return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
		}
	
		_createClass(Loader, [{
			key: 'render',
			value: function render() {
				var style = this.props.style;
	
				//by default there is a shining effect but can be removed by noEffect attribute
				var noEffect = this.props.noEffect === true;
	
				var className = 'loaderBox';
	
				if (this.props.className) className += ' ' + this.props.className;
	
				return _react2.default.createElement(
					'div',
					{ style: style, className: className },
					!noEffect && _react2.default.createElement('i', { className: 'loader' })
				);
			}
		}]);
	
		return Loader;
	}(_react2.default.Component);
	
	;
	
	Loader = (0, _radium2.default)(Loader);
	exports.default = Loader;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectedImagePreview = function (_React$Component) {
		_inherits(SelectedImagePreview, _React$Component);
	
		function SelectedImagePreview() {
			_classCallCheck(this, SelectedImagePreview);
	
			return _possibleConstructorReturn(this, (SelectedImagePreview.__proto__ || Object.getPrototypeOf(SelectedImagePreview)).apply(this, arguments));
		}
	
		_createClass(SelectedImagePreview, [{
			key: "render",
			value: function render() {
				var file = this.props.file || null;
				var className = this.props.className || "";
				var src = this.props.src;
				var id = this.props.id;
	
				// console.log(id, "onImgLoad", onImgLoad);
	
				if (file !== null) {
					var reader = new FileReader();
					reader.onload = function (e) {
						var _this2 = this;
	
						var img = document.getElementById(id);
						var onImgLoad = this.props.onImgLoad;
	
						if (img) {
							var imgClassName = img.getAttribute("class").replace("invisible", "");
							img.setAttribute('src', e.target.result);
							img.setAttribute('class', imgClassName);
	
							img.onload = function () {
								if (onImgLoad && typeof onImgLoad === 'function') _this2.props.onImgLoad(img);
							};
						}
					}.bind(this);
	
					reader.readAsDataURL(file);
	
					return _react2.default.createElement("img", { id: id, style: this.props.style, alt: id, className: 'miniImg invisible ' + className });
				} else if (src != null) {
					return _react2.default.createElement("img", { id: id, style: this.props.style, src: src, alt: id, className: 'miniImg ' + className });
				} else {
					return _react2.default.createElement("div", { id: id, style: this.props.style, className: "miniImageLoader " + className });
				}
			}
		}]);
	
		return SelectedImagePreview;
	}(_react2.default.Component);
	
	exports.default = SelectedImagePreview;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = undefined;
	
	var _printValue = __webpack_require__(153);
	
	var _printValue2 = _interopRequireDefault(_printValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixed = exports.mixed = {
	  default: '${path} is invalid',
	  required: '${path} is a required field',
	  oneOf: '${path} must be one of the following values: ${values}',
	  notOneOf: '${path} must not be one of the following values: ${values}',
	  notType: function notType(_ref) {
	    var path = _ref.path,
	        type = _ref.type,
	        value = _ref.value,
	        originalValue = _ref.originalValue;
	
	    var isCast = originalValue != null && originalValue !== value;
	    var msg = path + ' must be a `' + type + '` type, ' + ('but the final value was: `' + (0, _printValue2.default)(value, true) + '`') + (isCast ? ' (cast from the value `' + (0, _printValue2.default)(originalValue, true) + '`).' : '.');
	
	    if (value === null) {
	      msg += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`';
	    }
	
	    return msg;
	  }
	};
	
	var string = exports.string = {
	  length: '${path} must be exactly ${length} characters',
	  min: '${path} must be at least ${min} characters',
	  max: '${path} must be at most ${max} characters',
	  matches: '${path} must match the following: "${regex}"',
	  email: '${path} must be a valid email',
	  url: '${path} must be a valid URL',
	  trim: '${path} must be a trimmed string',
	  lowercase: '${path} must be a lowercase string',
	  uppercase: '${path} must be a upper case string'
	};
	
	var number = exports.number = {
	  min: '${path} must be greater than or equal to ${min}',
	  max: '${path} must be less than or equal to ${max}',
	  positive: '${path} must be a positive number',
	  negative: '${path} must be a negative number',
	  integer: '${path} must be an integer'
	};
	
	var date = exports.date = {
	  min: '${path} field must be later than ${min}',
	  max: '${path} field must be at earlier than ${max}'
	};
	
	var boolean = exports.boolean = {};
	
	var object = exports.object = {
	  noUnknown: '${path} field cannot have keys not specified in the object shape'
	};
	
	var array = exports.array = {
	  min: '${path} field must have at least ${min} items',
	  max: '${path} field must have less than ${max} items'
	};
	
	exports.default = {
	  mixed: mixed,
	  string: string,
	  number: number,
	  date: date,
	  object: object,
	  array: array,
	  boolean: boolean
	};

/***/ },
/* 66 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = inherits;
	function inherits(ctor, superCtor, spec) {
	  ctor.prototype = Object.create(superCtor.prototype, {
	    constructor: {
	      value: ctor,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  _extends(ctor.prototype, spec);
	}
	module.exports = exports["default"];

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(802),
	    hasPath = __webpack_require__(282);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(267),
	    baseKeys = __webpack_require__(811),
	    isArrayLike = __webpack_require__(171);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React divider module
	 * @module react/divider
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	/**
	 * Divider constructor
	 * @class
	 */
	var Divider =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Divider, _React$Component);
	
	  function Divider() {
	    babelHelpers.classCallCheck(this, Divider);
	    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Divider).apply(this, arguments));
	  }
	
	  babelHelpers.createClass(Divider, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          reactProps = babelHelpers.objectWithoutProperties(_this$props, ["children", "className"]);
	      return _react["default"].createElement("div", babelHelpers["extends"]({}, reactProps, {
	        className: 'mui-divider ' + className
	      }));
	    }
	  }]);
	  return Divider;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Divider, "defaultProps", {
	  className: ''
	});
	var _default = Divider;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createRule = __webpack_require__(87);
	
	var _createRule2 = _interopRequireDefault(_createRule);
	
	var _linkRule = __webpack_require__(206);
	
	var _linkRule2 = _interopRequireDefault(_linkRule);
	
	var _StyleRule = __webpack_require__(58);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _escape = __webpack_require__(469);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Contains rules objects and allows adding/removing etc.
	 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	 */
	var RuleList = function () {
	
	  // Original styles object.
	  function RuleList(options) {
	    var _this = this;
	
	    _classCallCheck(this, RuleList);
	
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	
	    this.update = function (name, data) {
	      var _options = _this.options,
	          plugins = _options.jss.plugins,
	          sheet = _options.sheet;
	
	      if (typeof name === 'string') {
	        plugins.onUpdate(data, _this.get(name), sheet);
	      } else {
	        for (var index = 0; index < _this.index.length; index++) {
	          plugins.onUpdate(name, _this.index[index], sheet);
	        }
	      }
	    };
	
	    this.options = options;
	    this.classes = options.classes;
	  }
	
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  // Used to ensure correct rules order.
	
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	
	
	  _createClass(RuleList, [{
	    key: 'add',
	    value: function add(name, decl, options) {
	      var _options2 = this.options,
	          parent = _options2.parent,
	          sheet = _options2.sheet,
	          jss = _options2.jss,
	          Renderer = _options2.Renderer,
	          generateClassName = _options2.generateClassName;
	
	
	      options = _extends({
	        classes: this.classes,
	        parent: parent,
	        sheet: sheet,
	        jss: jss,
	        Renderer: Renderer,
	        generateClassName: generateClassName
	      }, options);
	
	      if (!options.selector && this.classes[name]) {
	        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
	      }
	
	      this.raw[name] = decl;
	
	      var rule = (0, _createRule2['default'])(name, decl, options);
	
	      var className = void 0;
	
	      if (!options.selector && rule instanceof _StyleRule2['default']) {
	        className = generateClassName(rule, sheet);
	        rule.selector = '.' + (0, _escape2['default'])(className);
	      }
	
	      this.register(rule, className);
	
	      var index = options.index === undefined ? this.index.length : options.index;
	      this.index.splice(index, 0, rule);
	
	      return rule;
	    }
	
	    /**
	     * Get a rule.
	     */
	
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this.map[name];
	    }
	
	    /**
	     * Delete a rule.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(rule) {
	      this.unregister(rule);
	      this.index.splice(this.indexOf(rule), 1);
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.index.indexOf(rule);
	    }
	
	    /**
	     * Run `onProcessRule()` plugins on every rule.
	     */
	
	  }, {
	    key: 'process',
	    value: function process() {
	      var plugins = this.options.jss.plugins;
	      // We need to clone array because if we modify the index somewhere else during a loop
	      // we end up with very hard-to-track-down side effects.
	
	      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
	    }
	
	    /**
	     * Register a rule in `.map` and `.classes` maps.
	     */
	
	  }, {
	    key: 'register',
	    value: function register(rule, className) {
	      this.map[rule.key] = rule;
	      if (rule instanceof _StyleRule2['default']) {
	        this.map[rule.selector] = rule;
	        if (className) this.classes[rule.key] = className;
	      }
	    }
	
	    /**
	     * Unregister a rule.
	     */
	
	  }, {
	    key: 'unregister',
	    value: function unregister(rule) {
	      delete this.map[rule.key];
	      if (rule instanceof _StyleRule2['default']) {
	        delete this.map[rule.selector];
	        delete this.classes[rule.key];
	      }
	    }
	
	    /**
	     * Update the function values with a new data.
	     */
	
	  }, {
	    key: 'link',
	
	
	    /**
	     * Link renderable rules with CSSRuleList.
	     */
	    value: function link(cssRules) {
	      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);
	
	      for (var i = 0; i < cssRules.length; i++) {
	        var cssRule = cssRules[i];
	        var _key = this.options.sheet.renderer.getKey(cssRule);
	        if (map[_key]) _key = map[_key];
	        var rule = this.map[_key];
	        if (rule) (0, _linkRule2['default'])(rule, cssRule);
	      }
	    }
	
	    /**
	     * Convert rules to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      var str = '';
	      var sheet = this.options.sheet;
	
	      var link = sheet ? sheet.options.link : false;
	
	      for (var index = 0; index < this.index.length; index++) {
	        var rule = this.index[index];
	        var css = rule.toString(options);
	
	        // No need to render an empty rule.
	        if (!css && !link) continue;
	
	        if (str) str += '\n';
	        str += css;
	      }
	
	      return str;
	    }
	  }]);
	
	  return RuleList;
	}();
	
	exports['default'] = RuleList;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(489);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(490);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(210);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(491);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(492);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(493);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(494);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(211);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(134);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(495);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(496);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(497);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(498);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(512);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useAllArtist = exports.useActiveArtist = exports.useAllStores = exports.useStoresAndInfluencers = exports.usePopularInfluencers = exports.usePopularStores = exports.userStoreInfo = exports.userDesignerInfo = exports.useCurrentSession = undefined;
	
	var _ReduceStoreHook = __webpack_require__(45);
	
	var _ReduceStoreHook2 = _interopRequireDefault(_ReduceStoreHook);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _DesignerStore = __webpack_require__(91);
	
	var _DesignerStore2 = _interopRequireDefault(_DesignerStore);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useCurrentSession = exports.useCurrentSession = function useCurrentSession() {
	    var session = (0, _ReduceStoreHook2.default)(_SessionStore2.default, function (store) {
	        return store.getCurrentSession();
	    }, function () {
	        return _Dispatcher2.default.dispatchAlertWithAction(_AppConstants2.default.LOGIN_TO_CONTINUE_MSG, "WARN");
	    }, []);
	
	    return session;
	};
	
	var userDesignerInfo = exports.userDesignerInfo = function userDesignerInfo(userId) {
	    var userInfo = (0, _ReduceStoreHook2.default)(_DesignerStore2.default, function (store) {
	        return store.getDesignerInfo(userId);
	    }, function () {
	        return _HttpService2.default.getUserBasicInfo(null, userId);
	    }, [userId]);
	    return userInfo;
	};
	
	var userStoreInfo = exports.userStoreInfo = function userStoreInfo(storeName) {
	    var storeInfo = (0, _ReduceStoreHook2.default)(_DesignerStore2.default, function (store) {
	        return store.getStoreInfo(storeName);
	    }, function () {
	        return _HttpService2.default.getUserBasicInfo(storeName, null);
	    }, [storeName]);
	    return storeInfo;
	};
	
	var usePopularStores = exports.usePopularStores = function usePopularStores() {
	    var stores = (0, _ReduceStoreHook2.default)(_DesignerStore2.default, function (store) {
	        return store.getPopularStores();
	    }, function () {
	        return _HttpService2.default.getPopularStores();
	    }, []);
	
	    return stores;
	};
	
	var usePopularInfluencers = exports.usePopularInfluencers = function usePopularInfluencers() {
	    var stores = (0, _ReduceStoreHook2.default)(_DesignerStore2.default, function (store) {
	        return store.getPopularInfluencers();
	    }, function () {
	        return _HttpService2.default.getPopularStores();
	    }, []);
	
	    return stores;
	};
	
	/** Note: Code Smell because as of now, same API returns both Stores and Influencers */
	var useStoresAndInfluencers = exports.useStoresAndInfluencers = function useStoresAndInfluencers() {
	    var stores = (0, _ReduceStoreHook2.default)(_DesignerStore2.default, function (store) {
	        return store.getAllPopularStores();
	    }, function () {
	        return _HttpService2.default.getPopularStores();
	    }, []);
	
	    return stores;
	};
	
	var useAllStores = exports.useAllStores = function useAllStores() {
	    var stores = (0, _ReduceStoreHook2.default)(_DesignerStore2.default, function (store) {
	        return store.getAllStores();
	    }, function () {
	        return _UserAPI2.default.getAllStores();
	    }, []);
	
	    return stores;
	};
	
	var useActiveArtist = exports.useActiveArtist = function useActiveArtist() {
	    var stores = (0, _ReduceStoreHook2.default)(_DesignerStore2.default, function (store) {
	        return store.getActiveArtists();
	    }, function () {
	        return _UserAPI2.default.getActiveArtists();
	    }, []);
	
	    return stores;
	};
	
	var useAllArtist = exports.useAllArtist = function useAllArtist(prefix) {
	    var stores = (0, _ReduceStoreHook2.default)(_DesignerStore2.default, function (store) {
	        return store.getAllArtist(prefix);
	    }, function () {
	        return _UserAPI2.default.getAllArtist(prefix);
	    }, [prefix]);
	
	    return stores;
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _HttpService2 = __webpack_require__(12);
	
	var _AppAction = __webpack_require__(22);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Note: Important!!!
	//import the class here, not the object
	
	
	var BASE_URL = _AppConstants2.default.BASE_API_URL + "/stock";
	
	var StockAPI = function (_HttpService) {
	    _inherits(StockAPI, _HttpService);
	
	    function StockAPI() {
	        _classCallCheck(this, StockAPI);
	
	        return _possibleConstructorReturn(this, (StockAPI.__proto__ || Object.getPrototypeOf(StockAPI)).apply(this, arguments));
	    }
	
	    _createClass(StockAPI, [{
	        key: 'getStocks',
	        value: function getStocks(ownerAlias, onSuccess) {
	            var url = "/" + ownerAlias + "/list";
	
	            _get(StockAPI.prototype.__proto__ || Object.getPrototypeOf(StockAPI.prototype), 'get', this).call(this, url, function (response) {
	                _Dispatcher2.default.dispatch({
	                    type: _AppAction.StockAction.LOAD_OWNER_STOCKS,
	                    stocks: response.data,
	                    ownerAlias: ownerAlias
	                });
	
	                if (onSuccess && typeof onSuccess === 'function') onSuccess(response.data);
	            });
	        }
	    }, {
	        key: 'refillStock',
	        value: function refillStock(request, callback) {
	            _get(StockAPI.prototype.__proto__ || Object.getPrototypeOf(StockAPI.prototype), 'post', this).call(this, "/refill", request, function (response) {
	                _Dispatcher2.default.dispatchAnAlert(response.data);
	
	                callback(true);
	            });
	        }
	    }, {
	        key: 'transferStock',
	        value: function transferStock(request, callback) {
	            _get(StockAPI.prototype.__proto__ || Object.getPrototypeOf(StockAPI.prototype), 'post', this).call(this, "/transfer", request, function (response) {
	                _Dispatcher2.default.dispatchAnAlert(response.data);
	                callback(true);
	            });
	        }
	    }, {
	        key: 'getStockHistories',
	        value: function getStockHistories(stockProductId) {
	            _get(StockAPI.prototype.__proto__ || Object.getPrototypeOf(StockAPI.prototype), 'get', this).call(this, "/history?stockProductId=" + stockProductId, function (response) {
	                _Dispatcher2.default.dispatch({
	                    type: _AppAction.StockAction.LOAD_STOCK_HISTORY,
	                    history: response.data,
	                    stockProductId: stockProductId
	                });
	            });
	        }
	    }]);
	
	    return StockAPI;
	}(_HttpService2.HttpService);
	
	exports.default = new StockAPI(BASE_URL);

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	var frameProductType = PRODUCT_TYPES['PHOTO_FRAME'];
	var INCH_PER_PIXEL = 16 / 4800;
	
	var FRAME_SIZE_TYPES = ["XXXS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];
	
	var FRAME_BASE_MARGIN = 450;
	
	var ProductUtil = function () {
	    function ProductUtil() {
	        _classCallCheck(this, ProductUtil);
	    }
	
	    _createClass(ProductUtil, null, [{
	        key: 'computeFrameAvailableSizes',
	
	
	        //Note: Reference => https://stackoverflow.com/questions/44756505/how-to-calculate-pixels-per-inch-of-an-image-in-different-dpi
	        value: function computeFrameAvailableSizes(imgWidth, imgHeight) {
	            var maxDPI = ProductUtil._computeMaxDPI(imgWidth);
	            var minDPI = 100;
	            var interval = Math.ceil((maxDPI - minDPI) / FRAME_SIZE_TYPES.length);
	
	            var possibleSizes = {};
	            var sizeTypesIndex = 0;
	
	            var d = maxDPI;
	            while (d >= minDPI) {
	                var widthInches = imgWidth / d;
	                var heightInches = imgHeight / d;
	
	                if (Math.max(widthInches, heightInches) < 5) {
	                    d -= interval;
	                    continue;
	                }
	
	                var sizeType = FRAME_SIZE_TYPES[sizeTypesIndex];
	
	                if (!sizeType) break;
	
	                possibleSizes[sizeType] = ProductUtil.createFrameSizeObject(widthInches, heightInches, d);
	
	                sizeTypesIndex++;
	
	                if (d - interval < minDPI) {
	                    var remainingSizes = FRAME_SIZE_TYPES.length - sizeTypesIndex;
	                    interval = Math.ceil((d - 100) / remainingSizes);
	
	                    if (interval === 0) break;
	
	                    d -= interval;
	                } else {
	                    d -= interval;
	                }
	            }
	
	            return possibleSizes;
	        }
	    }, {
	        key: '_computeMaxDPI',
	        value: function _computeMaxDPI(imgWidth) {
	            var widthInches = imgWidth * INCH_PER_PIXEL;
	            var maxDpi = imgWidth / widthInches;
	
	            if (widthInches < 5) {
	                while (widthInches < 5) {
	                    widthInches++;
	                    maxDpi = imgWidth / widthInches;
	                }
	            } else {
	                while (widthInches >= 5) {
	                    widthInches--;
	                    maxDpi = imgWidth / widthInches;
	                }
	            }
	
	            return Math.floor(maxDpi);
	        }
	    }, {
	        key: 'createFrameSizeObject',
	        value: function createFrameSizeObject(widthInches, heightInches, dpi) {
	            var label = widthInches.toFixed(2) + "\" x " + heightInches.toFixed(2) + "\"";
	
	            var prices = ProductUtil.computeFrameCost(widthInches, heightInches);
	            var priceAddition = prices[0] - frameProductType.basePrice;
	            var marginAddition = prices[1] - FRAME_BASE_MARGIN;
	
	            return { "label": label, "shortLabel": label, "priceAddition": priceAddition, "marginAddition": marginAddition, "dpi": dpi, "widthInches": widthInches, "heightInches": heightInches };
	        }
	    }, {
	        key: 'computeFrameCost',
	        value: function computeFrameCost(width, height) {
	            var w = Math.ceil(width) + 2;
	            var h = Math.ceil(height) + 2;
	
	            var noOfSqrFeet = Math.ceil(width * height / 144);
	            var glassCost = noOfSqrFeet * 200;
	            var frameCost = (w + h) * 10 * 2;
	            var photoCost = (noOfSqrFeet === 1 ? 50 : 250) * Math.ceil(noOfSqrFeet / 2.0);
	            var deliveryCost = 300 * Math.ceil(noOfSqrFeet / 2.0);
	            var packagingCost = 50 * Math.ceil(noOfSqrFeet / 2.0);
	            var operationCost = 100;
	            var totalCost = glassCost + frameCost + photoCost + deliveryCost + packagingCost + operationCost;
	
	            var margin = void 0;
	            var maxLength = Math.max(width, height);
	            if (maxLength > 18) {
	                margin = totalCost;
	                totalCost += margin;
	            } else if (maxLength > 12) {
	                margin = 0.35 * totalCost;
	                totalCost += margin;
	            } else {
	                margin = FRAME_BASE_MARGIN;
	                totalCost *= 1.25;
	            };
	
	            return [Math.ceil(totalCost / 10) * 10, margin];
	        }
	    }, {
	        key: 'getProductVariantKey',
	        value: function getProductVariantKey(productVariant) {
	            return productVariant.variantLabel.replaceAll(" ", "").toLowerCase();
	        }
	    }, {
	        key: 'getSelectedVariants',
	        value: function getSelectedVariants(productVariants, selectedVariantIds) {
	            if (!productVariants) return [];
	            if (!selectedVariantIds) return [];
	
	            var variantsById = {};
	            productVariants.forEach(function (pv) {
	                pv.variants.forEach(function (vr) {
	                    variantsById[vr.variantId] = vr;
	                });
	            });
	
	            var selectedVariants = selectedVariantIds.map(function (id) {
	                return variantsById[id];
	            }).filter(function (vr) {
	                return vr !== null;
	            });
	            return selectedVariants;
	        }
	    }]);
	
	    return ProductUtil;
	}();
	
	exports.default = ProductUtil;

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _reactTransitionGroup = __webpack_require__(151);
	
	var _utils = __webpack_require__(5);
	
	var propTypes = (0, _objectSpread2.default)({}, _reactTransitionGroup.Transition.propTypes, {
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  tag: _utils.tagPropType,
	  baseClass: _propTypes.default.string,
	  baseClassActive: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	});
	var defaultProps = (0, _objectSpread2.default)({}, _reactTransitionGroup.Transition.defaultProps, {
	  tag: 'div',
	  baseClass: 'fade',
	  baseClassActive: 'show',
	  timeout: _utils.TransitionTimeouts.Fade,
	  appear: true,
	  enter: true,
	  exit: true,
	  in: true
	});
	
	function Fade(props) {
	  var Tag = props.tag,
	      baseClass = props.baseClass,
	      baseClassActive = props.baseClassActive,
	      className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      innerRef = props.innerRef,
	      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"]);
	  var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
	  var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
	  return _react.default.createElement(_reactTransitionGroup.Transition, transitionProps, function (status) {
	    var isActive = status === 'entered';
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, baseClass, isActive && baseClassActive), cssModule);
	    return _react.default.createElement(Tag, (0, _extends2.default)({
	      className: classes
	    }, childProps, {
	      ref: innerRef
	    }), children);
	  });
	}
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propertyExpr = __webpack_require__(119);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var validateName = function validateName(d) {
	  if (typeof d !== 'string') throw new TypeError('ref\'s must be strings, got: ' + d);
	};
	
	var Reference = function () {
	  Reference.isRef = function isRef(value) {
	    return !!(value && (value.__isYupRef || value instanceof Reference));
	  };
	
	  function Reference(key, mapFn) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _classCallCheck(this, Reference);
	
	    validateName(key);
	    var prefix = options.contextPrefix || '$';
	
	    if (typeof key === 'function') {
	      key = '.';
	    }
	
	    this.key = key.trim();
	    this.prefix = prefix;
	    this.isContext = this.key.indexOf(prefix) === 0;
	    this.isSelf = this.key === '.';
	
	    this.path = this.isContext ? this.key.slice(this.prefix.length) : this.key;
	    this._get = (0, _propertyExpr.getter)(this.path, true);
	    this.map = mapFn || function (value) {
	      return value;
	    };
	  }
	
	  Reference.prototype.resolve = function resolve() {
	    return this;
	  };
	
	  Reference.prototype.cast = function cast(value, _ref) {
	    var parent = _ref.parent,
	        context = _ref.context;
	
	    return this.getValue(parent, context);
	  };
	
	  Reference.prototype.getValue = function getValue(parent, context) {
	    var isContext = this.isContext;
	    var value = this._get(isContext ? context : parent || context || {});
	    return this.map(value);
	  };
	
	  return Reference;
	}();
	
	exports.default = Reference;
	
	
	Reference.prototype.__isYupRef = true;
	module.exports = exports['default'];

/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (value) {
	  return value == null;
	};
	
	module.exports = exports["default"];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(268),
	    baseAssignValue = __webpack_require__(111);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(786),
	    Map = __webpack_require__(155),
	    Promise = __webpack_require__(788),
	    Set = __webpack_require__(789),
	    WeakMap = __webpack_require__(791),
	    baseGetTag = __webpack_require__(54),
	    toSource = __webpack_require__(291);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(118);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(820);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * MUI CSS/JS jqLite module
	 * @module lib/jqLite
	 */
	
	'use strict';
	
	
	/**
	 * Add a class to an element.
	 * @param {Element} element - The DOM element.
	 * @param {string} cssClasses - Space separated list of class names.
	 */
	function jqLiteAddClass(element, cssClasses) {
	  if (!cssClasses || !element.setAttribute) return;
	
	  var existingClasses = _getExistingClasses(element),
	      splitClasses = cssClasses.split(' '),
	      cssClass;
	
	  for (var i=0; i < splitClasses.length; i++) {
	    cssClass = splitClasses[i].trim();
	    if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	      existingClasses += cssClass + ' ';
	    }
	  }
	  
	  element.setAttribute('class', existingClasses.trim());
	}
	
	
	/**
	 * Get or set CSS properties.
	 * @param {Element} element - The DOM element.
	 * @param {string} [name] - The property name.
	 * @param {string} [value] - The property value.
	 */
	function jqLiteCss(element, name, value) {
	  // Return full style object
	  if (name === undefined) {
	    return getComputedStyle(element);
	  }
	
	  var nameType = jqLiteType(name);
	
	  // Set multiple values
	  if (nameType === 'object') {
	    for (var key in name) element.style[_camelCase(key)] = name[key];
	    return;
	  }
	
	  // Set a single value
	  if (nameType === 'string' && value !== undefined) {
	    element.style[_camelCase(name)] = value;
	  }
	
	  var styleObj = getComputedStyle(element),
	      isArray = (jqLiteType(name) === 'array');
	
	  // Read single value
	  if (!isArray) return _getCurrCssProp(element, name, styleObj);
	
	  // Read multiple values
	  var outObj = {},
	      key;
	
	  for (var i=0; i < name.length; i++) {
	    key = name[i];
	    outObj[key] = _getCurrCssProp(element, key, styleObj);
	  }
	
	  return outObj;
	}
	
	
	/**
	 * Check if element has class.
	 * @param {Element} element - The DOM element.
	 * @param {string} cls - The class name string.
	 */
	function jqLiteHasClass(element, cls) {
	  if (!cls || !element.getAttribute) return false;
	  return (_getExistingClasses(element).indexOf(' ' + cls + ' ') > -1);
	}
	
	
	/**
	 * Return the type of a variable.
	 * @param {} somevar - The JavaScript variable.
	 */
	function jqLiteType(somevar) {
	  // handle undefined
	  if (somevar === undefined) return 'undefined';
	
	  // handle others (of type [object <Type>])
	  var typeStr = Object.prototype.toString.call(somevar);
	  if (typeStr.indexOf('[object ') === 0) {
	    return typeStr.slice(8, -1).toLowerCase();
	  } else {
	    throw new Error("MUI: Could not understand type: " + typeStr);
	  }    
	}
	
	
	/**
	 * Attach an event handler to a DOM element
	 * @param {Element} element - The DOM element.
	 * @param {string} events - Space separated event names.
	 * @param {Function} callback - The callback function.
	 * @param {Boolean} useCapture - Use capture flag.
	 */
	function jqLiteOn(element, events, callback, useCapture) {
	  useCapture = (useCapture === undefined) ? false : useCapture;
	
	  var cache = element._muiEventCache = element._muiEventCache || {};  
	
	  events.split(' ').map(function(event) {
	    // add to DOM
	    element.addEventListener(event, callback, useCapture);
	
	    // add to cache
	    cache[event] = cache[event] || [];
	    cache[event].push([callback, useCapture]);
	  });
	}
	
	
	/**
	 * Remove an event handler from a DOM element
	 * @param {Element} element - The DOM element.
	 * @param {string} events - Space separated event names.
	 * @param {Function} callback - The callback function.
	 * @param {Boolean} useCapture - Use capture flag.
	 */
	function jqLiteOff(element, events, callback, useCapture) {
	  useCapture = (useCapture === undefined) ? false : useCapture;
	
	  // remove from cache
	  var cache = element._muiEventCache = element._muiEventCache || {},
	      argsList,
	      args,
	      i;
	
	  events.split(' ').map(function(event) {
	    argsList = cache[event] || [];
	
	    i = argsList.length;
	    while (i--) {
	      args = argsList[i];
	
	      // remove all events if callback is undefined
	      if (callback === undefined ||
	          (args[0] === callback && args[1] === useCapture)) {
	
	        // remove from cache
	        argsList.splice(i, 1);
	        
	        // remove from DOM
	        element.removeEventListener(event, args[0], args[1]);
	      }
	    }
	  });
	}
	
	
	/**
	 * Attach an event hander which will only execute once per element per event
	 * @param {Element} element - The DOM element.
	 * @param {string} events - Space separated event names.
	 * @param {Function} callback - The callback function.
	 * @param {Boolean} useCapture - Use capture flag.
	 */
	function jqLiteOne(element, events, callback, useCapture) {
	  events.split(' ').map(function(event) {
	    jqLiteOn(element, event, function onFn(ev) {
	      // execute callback
	      if (callback) callback.apply(this, arguments);
	
	      // remove wrapper
	      jqLiteOff(element, event, onFn, useCapture);
	    }, useCapture);
	  });
	}
	
	
	/**
	 * Get or set horizontal scroll position
	 * @param {Element} element - The DOM element
	 * @param {number} [value] - The scroll position
	 */
	function jqLiteScrollLeft(element, value) {
	  var win = window;
	
	  // get
	  if (value === undefined) {
	    if (element === win) {
	      var docEl = document.documentElement;
	      return (win.pageXOffset || docEl.scrollLeft) - (docEl.clientLeft || 0);
	    } else {
	      return element.scrollLeft;
	    }
	  }
	
	  // set
	  if (element === win) win.scrollTo(value, jqLiteScrollTop(win));
	  else element.scrollLeft = value;
	}
	
	
	/**
	 * Get or set vertical scroll position
	 * @param {Element} element - The DOM element
	 * @param {number} value - The scroll position
	 */
	function jqLiteScrollTop(element, value) {
	  var win = window;
	
	  // get
	  if (value === undefined) {
	    if (element === win) {
	      var docEl = document.documentElement;
	      return (win.pageYOffset || docEl.scrollTop) - (docEl.clientTop || 0);
	    } else {
	      return element.scrollTop;
	    }
	  }
	
	  // set
	  if (element === win) win.scrollTo(jqLiteScrollLeft(win), value);
	  else element.scrollTop = value;
	}
	
	
	/**
	 * Return object representing top/left offset and element height/width.
	 * @param {Element} element - The DOM element.
	 */
	function jqLiteOffset(element) {
	  var win = window,
	      rect = element.getBoundingClientRect(),
	      scrollTop = jqLiteScrollTop(win),
	      scrollLeft = jqLiteScrollLeft(win);
	
	  return {
	    top: rect.top + scrollTop,
	    left: rect.left + scrollLeft,
	    height: rect.height,
	    width: rect.width
	  };
	}
	
	
	/**
	 * Attach a callback to the DOM ready event listener
	 * @param {Function} fn - The callback function.
	 */
	function jqLiteReady(fn) {
	  var done = false,
	      top = true,
	      doc = document,
	      win = doc.defaultView,
	      root = doc.documentElement,
	      add = doc.addEventListener ? 'addEventListener' : 'attachEvent',
	      rem = doc.addEventListener ? 'removeEventListener' : 'detachEvent',
	      pre = doc.addEventListener ? '' : 'on';
	
	  var init = function(e) {
	    if (e.type == 'readystatechange' && doc.readyState != 'complete') {
	      return;
	    }
	
	    (e.type == 'load' ? win : doc)[rem](pre + e.type, init, false);
	    if (!done && (done = true)) fn.call(win, e.type || e);
	  };
	
	  var poll = function() {
	    try { root.doScroll('left'); } catch(e) { setTimeout(poll, 50); return; }
	    init('poll');
	  };
	
	  if (doc.readyState == 'complete') {
	    fn.call(win, 'lazy');
	  } else {
	    if (doc.createEventObject && root.doScroll) {
	      try { top = !win.frameElement; } catch(e) { }
	      if (top) poll();
	    }
	    doc[add](pre + 'DOMContentLoaded', init, false);
	    doc[add](pre + 'readystatechange', init, false);
	    win[add](pre + 'load', init, false);
	  }
	}
	
	
	/**
	 * Remove classes from a DOM element
	 * @param {Element} element - The DOM element.
	 * @param {string} cssClasses - Space separated list of class names.
	 */
	function jqLiteRemoveClass(element, cssClasses) {
	  if (!cssClasses || !element.setAttribute) return;
	
	  var existingClasses = _getExistingClasses(element),
	      splitClasses = cssClasses.split(' '),
	      cssClass;
	  
	  for (var i=0; i < splitClasses.length; i++) {
	    cssClass = splitClasses[i].trim();
	    while (existingClasses.indexOf(' ' + cssClass + ' ') >= 0) {
	      existingClasses = existingClasses.replace(' ' + cssClass + ' ', ' ');
	    }
	  }
	
	  element.setAttribute('class', existingClasses.trim());
	}
	
	
	// ------------------------------
	// Utilities
	// ------------------------------
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g,
	    MOZ_HACK_REGEXP = /^moz([A-Z])/,
	    ESCAPE_REGEXP = /([.*+?^=!:${}()|\[\]\/\\])/g;
	
	
	function _getExistingClasses(element) {
	  var classes = (element.getAttribute('class') || '').replace(/[\n\t]/g, '');
	  return ' ' + classes + ' ';
	}
	
	
	function _camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	
	function _escapeRegExp(string) {
	  return string.replace(ESCAPE_REGEXP, "\\$1");
	}
	
	
	function _getCurrCssProp(elem, name, computed) {
	  var ret;
	
	  // try computed style
	  ret = computed.getPropertyValue(name);
	
	  // try style attribute (if element is not attached to document)
	  if (ret === '' && !elem.ownerDocument) ret = elem.style[_camelCase(name)];
	
	  return ret;
	}
	
	
	/**
	 * Module API
	 */
	module.exports = {
	  /** Add classes */
	  addClass: jqLiteAddClass,
	
	  /** Get or set CSS properties */
	  css: jqLiteCss,
	
	  /** Check for class */
	  hasClass: jqLiteHasClass,
	
	  /** Remove event handlers */
	  off: jqLiteOff,
	
	  /** Return offset values */
	  offset: jqLiteOffset,
	
	  /** Add event handlers */
	  on: jqLiteOn,
	
	  /** Add an execute-once event handler */
	  one: jqLiteOne,
	
	  /** DOM ready event handler */
	  ready: jqLiteReady,
	
	  /** Remove classes */
	  removeClass: jqLiteRemoveClass,
	
	  /** Check JavaScript variable instance type */
	  type: jqLiteType,
	
	  /** Get or set horizontal scroll position */
	  scrollLeft: jqLiteScrollLeft,
	
	  /** Get or set vertical scroll position */
	  scrollTop: jqLiteScrollTop
	};


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React button module
	 * @module react/button
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	var jqLite = babelHelpers.interopRequireWildcard(__webpack_require__(83));
	var util = babelHelpers.interopRequireWildcard(__webpack_require__(57));
	var btnClass = 'mui-btn',
	    btnAttrs = {
	  color: 1,
	  variant: 1,
	  size: 1
	};
	/**
	 * Button element
	 * @class
	 */
	
	var Button =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Button, _React$Component);
	
	  function Button(props) {
	    var _this;
	
	    babelHelpers.classCallCheck(this, Button);
	    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Button).call(this, props));
	    babelHelpers.defineProperty(babelHelpers.assertThisInitialized(_this), "state", {
	      rippleStyle: {},
	      rippleIsVisible: false
	    });
	    var cb = util.callback;
	    _this.onMouseDownCB = cb(babelHelpers.assertThisInitialized(_this), 'onMouseDown');
	    _this.onMouseUpCB = cb(babelHelpers.assertThisInitialized(_this), 'onMouseUp');
	    _this.onMouseLeaveCB = cb(babelHelpers.assertThisInitialized(_this), 'onMouseLeave');
	    _this.onTouchStartCB = cb(babelHelpers.assertThisInitialized(_this), 'onTouchStart');
	    _this.onTouchEndCB = cb(babelHelpers.assertThisInitialized(_this), 'onTouchEnd');
	    return _this;
	  }
	
	  babelHelpers.createClass(Button, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // disable MUI js
	      var el = this.buttonElRef;
	      el._muiDropdown = true;
	      el._muiRipple = true;
	    }
	  }, {
	    key: "onMouseDown",
	    value: function onMouseDown(ev) {
	      this.showRipple(ev); // execute callback
	
	      var fn = this.props.onMouseDown;
	      fn && fn(ev);
	    }
	  }, {
	    key: "onMouseUp",
	    value: function onMouseUp(ev) {
	      this.hideRipple(ev); // execute callback
	
	      var fn = this.props.onMouseUp;
	      fn && fn(ev);
	    }
	  }, {
	    key: "onMouseLeave",
	    value: function onMouseLeave(ev) {
	      this.hideRipple(ev); // execute callback
	
	      var fn = this.props.onMouseLeave;
	      fn && fn(ev);
	    }
	  }, {
	    key: "onTouchStart",
	    value: function onTouchStart(ev) {
	      this.showRipple(ev); // execute callback
	
	      var fn = this.props.onTouchStart;
	      fn && fn(ev);
	    }
	  }, {
	    key: "onTouchEnd",
	    value: function onTouchEnd(ev) {
	      this.hideRipple(ev); // execute callback
	
	      var fn = this.props.onTouchEnd;
	      fn && fn(ev);
	    }
	  }, {
	    key: "showRipple",
	    value: function showRipple(ev) {
	      var buttonEl = this.buttonElRef; // de-dupe touch events
	
	      if ('ontouchstart' in buttonEl && ev.type === 'mousedown') return; // get (x, y) position of click
	
	      var offset = jqLite.offset(this.buttonElRef),
	          clickEv;
	      if (ev.type === 'touchstart' && ev.touches) clickEv = ev.touches[0];else clickEv = ev; // calculate radius
	
	      var radius = Math.sqrt(offset.width * offset.width + offset.height * offset.height);
	      var diameterPx = radius * 2 + 'px'; // add ripple to state
	
	      this.setState({
	        rippleStyle: {
	          top: Math.round(clickEv.pageY - offset.top - radius) + 'px',
	          left: Math.round(clickEv.pageX - offset.left - radius) + 'px',
	          width: diameterPx,
	          height: diameterPx
	        },
	        rippleIsVisible: true
	      });
	    }
	  }, {
	    key: "hideRipple",
	    value: function hideRipple(ev) {
	      this.setState({
	        rippleIsVisible: false
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var state = this.state,
	          rippleEl = this.rippleElRef; // show ripple
	
	      if (state.rippleIsVisible && !prevState.rippleIsVisible) {
	        jqLite.removeClass(rippleEl, 'mui--is-animating');
	        jqLite.addClass(rippleEl, 'mui--is-visible');
	        util.requestAnimationFrame(function () {
	          jqLite.addClass(rippleEl, 'mui--is-animating');
	        });
	      } // hide ripple
	
	
	      if (!state.rippleIsVisible && prevState.rippleIsVisible) {
	        // allow a repaint to occur before removing class so animation shows for
	        // tap events
	        util.requestAnimationFrame(function () {
	          jqLite.removeClass(rippleEl, 'mui--is-visible');
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var cls = btnClass,
	          k,
	          v;
	      var _this$props = this.props,
	          color = _this$props.color,
	          size = _this$props.size,
	          variant = _this$props.variant,
	          reactProps = babelHelpers.objectWithoutProperties(_this$props, ["color", "size", "variant"]); // button attributes
	
	      for (k in btnAttrs) {
	        v = this.props[k];
	        if (v !== 'default') cls += ' ' + btnClass + '--' + v;
	      }
	
	      return _react["default"].createElement("button", babelHelpers["extends"]({}, reactProps, {
	        ref: function ref(el) {
	          _this2.buttonElRef = el;
	        },
	        className: cls + ' ' + this.props.className,
	        onMouseUp: this.onMouseUpCB,
	        onMouseDown: this.onMouseDownCB,
	        onMouseLeave: this.onMouseLeaveCB,
	        onTouchStart: this.onTouchStartCB,
	        onTouchEnd: this.onTouchEndCB
	      }), this.props.children, _react["default"].createElement("span", {
	        className: "mui-btn__ripple-container"
	      }, _react["default"].createElement("span", {
	        ref: function ref(el) {
	          _this2.rippleElRef = el;
	        },
	        className: "mui-ripple",
	        style: this.state.rippleStyle
	      })));
	    }
	  }]);
	  return Button;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Button, "defaultProps", {
	  className: '',
	  color: 'default',
	  size: 'default',
	  variant: 'default'
	});
	var _default = Button;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React tabs module
	 * @module react/tabs
	 */
	
	/* jshint quotmark:false */
	// jscs:disable validateQuoteMarks
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	/**
	 * Tab constructor
	 * @class
	 */
	var Tab =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Tab, _React$Component);
	
	  function Tab() {
	    babelHelpers.classCallCheck(this, Tab);
	    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Tab).apply(this, arguments));
	  }
	
	  babelHelpers.createClass(Tab, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	  return Tab;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Tab, "defaultProps", {
	  value: null,
	  label: '',
	  onActive: null
	});
	var _default = Tab;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 86 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = createRule;
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _StyleRule = __webpack_require__(58);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _cloneStyle = __webpack_require__(468);
	
	var _cloneStyle2 = _interopRequireDefault(_cloneStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Create a rule instance.
	 */
	function createRule() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
	  var decl = arguments[1];
	  var options = arguments[2];
	  var jss = options.jss;
	
	  var declCopy = (0, _cloneStyle2['default'])(decl);
	
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule;
	
	  // It is an at-rule and it has no instance.
	  if (name[0] === '@') {
	    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
	  }
	
	  return new _StyleRule2['default'](name, declCopy, options);
	}

/***/ },
/* 88 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toCssValue;
	var join = function join(value, by) {
	  var result = '';
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	  return result;
	};
	
	/**
	 * Converts array values to string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	function toCssValue(value) {
	  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (!Array.isArray(value)) return value;
	
	  var cssValue = '';
	
	  // Support space separated values via `[['5px', '10px']]`.
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', ');
	
	  // Add !important, because it was ignored.
	  if (!ignoreImportant && value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	}

/***/ },
/* 89 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '__THEMING__';

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _HttpService2 = __webpack_require__(12);
	
	var _AppAction = __webpack_require__(22);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //Note: Important!!!
	//import the class here, not the object
	
	
	var SUBMIT_ORDER_MSG = "We have received your order. You will get a call from our operator soon.";
	var BASE_URL = _AppConstants2.default.BASE_API_URL + "/order";
	
	var OrderAPI = function (_HttpService) {
		_inherits(OrderAPI, _HttpService);
	
		function OrderAPI() {
			_classCallCheck(this, OrderAPI);
	
			return _possibleConstructorReturn(this, (OrderAPI.__proto__ || Object.getPrototypeOf(OrderAPI)).apply(this, arguments));
		}
	
		_createClass(OrderAPI, [{
			key: '_handleOrderSubmission',
			value: function _handleOrderSubmission(response, callback) {
				//API can return session if user chose to Guest
				var session = response.data.session;
				if (session) {
					var bearerToken = session['bearer'];
					var user = session['user'];
					var expiresOn = session['expiresOn'];
	
					_Dispatcher2.default.dispatch({
						type: _AppAction.UserAction.LOGIN_SUCCESS,
						user: user,
						token: bearerToken,
						expiresOn: expiresOn
					});
				}
	
				_Dispatcher2.default.dispatch({
					type: _AppAction.OrderAction.PLACE_ORDER,
					order: response.data
				});
	
				_Dispatcher2.default.dispatchAnAlert(SUBMIT_ORDER_MSG);
				callback(true);
			}
		}, {
			key: 'placeOrder',
			value: function placeOrder(orderReq, callback) {
				var _this2 = this;
	
				var url = orderReq.isBulkOrder ? "/bulk" : "";
				this.post(url, orderReq, function (response) {
					_this2._handleOrderSubmission(response, callback);
				}, function (error) {
					_this2.defaultErrorHandler(error);
					callback(false, null);
				});
			}
		}, {
			key: 'placeCustomOrder',
			value: function placeCustomOrder(orderReq, customerImage, callback) {
				var _this3 = this;
	
				var formData = new FormData();
				formData.append("orderReqJson", JSON.stringify(orderReq));
				formData.append("customerImageFile", customerImage);
	
				var headers = this.getHeaders();
				headers['content-type'] = 'multipart/form-data';
	
				this.axios({
					url: "/custom",
					method: 'post',
					data: formData,
					headers: headers
				}).then(function (response) {
					_this3._handleOrderSubmission(response, callback);
				}).catch(function (response) {
					callback(false);
					_this3.defaultErrorHandler(response);
				});
			}
		}, {
			key: 'validateDiscountCoupon',
			value: function validateDiscountCoupon(couponCode, productId, callback) {
				var _this4 = this;
	
				this.post("/coupon/" + couponCode + "/validate?productId=" + productId, null, function (response) {
					callback(true, response.data);
					_Dispatcher2.default.dispatchClearAlert();
				}, function (error) {
					_this4.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'closeOrder',
			value: function closeOrder(orderCloseRequest, callback) {
				_get(OrderAPI.prototype.__proto__ || Object.getPrototypeOf(OrderAPI.prototype), 'post', this).call(this, "/close", orderCloseRequest, function (response) {
					_Dispatcher2.default.dispatchAnAlert(response.data);
					callback();
				});
			}
		}, {
			key: 'cancelOrder',
			value: function cancelOrder(order, cancelledReason, stockProductId, callback) {
				var _this5 = this;
	
				var cancelRequest = { orderId: order.orderId, cancelledReason: cancelledReason, stockProductId: stockProductId };
	
				this.post("/cancel", cancelRequest, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.UPDATE_ORDER_STATE,
						order: order,
						newState: _AppConstants2.default.ORDER_STATE.CANCELLED.value
					});
	
					_Dispatcher2.default.dispatchAnAlert(response.data);
					callback(true);
				}, function (error) {
					_this5.defaultErrorHandler(error);
					callback(false);
				});
			}
		}, {
			key: 'updateOrderState',
			value: function updateOrderState(order, orderState, stockProductId, callback) {
				var _this6 = this;
	
				var stateUpdateRequest = { orderId: order.orderId, newState: orderState, stockProductId: stockProductId };
				this.post("/updateState", stateUpdateRequest, function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.UPDATE_ORDER_STATE,
						order: order,
						newState: orderState
					});
	
					_Dispatcher2.default.dispatchAnAlert(response.data);
					callback(true);
				}, function (error) {
					_this6.defaultErrorHandler(error);
					callback(false);
				});
			}
		}]);
	
		return OrderAPI;
	}(_HttpService2.HttpService);
	
	exports.default = new OrderAPI(BASE_URL);

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(43);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(15);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppAction = __webpack_require__(22);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DesignerStore = function (_ReduceStore) {
		_inherits(DesignerStore, _ReduceStore);
	
		function DesignerStore() {
			_classCallCheck(this, DesignerStore);
	
			var _this = _possibleConstructorReturn(this, (DesignerStore.__proto__ || Object.getPrototypeOf(DesignerStore)).call(this, _Dispatcher2.default));
	
			_this.DESIGNER_BALANCE = "DESIGNER_BALANCE";
			_this.DESIGNER_PENDING_ORDERS = "DESIGNER_PENDING_ORDERS";
			_this.ALL_STORES = _AppAction.DesignerAction.LOAD_ALL_STORES;
			return _this;
		}
	
		_createClass(DesignerStore, [{
			key: 'getInitialState',
			value: function getInitialState() {
				this.POPULAR_STORES = "POPULAR_STORES";
				var map = _immutable2.default.Map();
				var popularStores = JSON.parse(_CacheService2.default.get(this.POPULAR_STORES));
	
				if (popularStores) {
					return map.set(this.POPULAR_STORES, _immutable2.default.List(popularStores));
				} else {
					return map;
				}
			}
		}, {
			key: 'getDesignerBalance',
			value: function getDesignerBalance() {
				return this.getState().get(this.DESIGNER_BALANCE) || null;
			}
		}, {
			key: 'getAllPendingOrders',
			value: function getAllPendingOrders() {
				return this.getState().get(this.DESIGNER_PENDING_ORDERS) || null;
			}
		}, {
			key: 'getPopularStores',
			value: function getPopularStores() {
				if (this.getState().get(this.POPULAR_STORES)) return this.getState().get(this.POPULAR_STORES).filter(function (s) {
					return s.userType !== _AppConstants2.default.USER_TYPE.INFLUENCER;
				});
	
				return null;
			}
		}, {
			key: 'getAllPopularStores',
			value: function getAllPopularStores() {
				if (this.getState().get(this.POPULAR_STORES)) return this.getState().get(this.POPULAR_STORES);
	
				return null;
			}
		}, {
			key: 'getAllStores',
			value: function getAllStores() {
				if (this.getState().get(this.ALL_STORES)) return this.getState().get(this.ALL_STORES);
	
				return null;
			}
		}, {
			key: 'getAllArtist',
			value: function getAllArtist(prefix) {
				var allArtists = this.getState().get(_AppAction.DesignerAction.LOAD_ALL_ARTISTS + "_" + prefix.toUpperCase());
				if (allArtists === null || allArtists === undefined) return null;
	
				return allArtists;
			}
		}, {
			key: 'getPopularInfluencers',
			value: function getPopularInfluencers() {
				if (this.getState().get(this.POPULAR_STORES)) return this.getState().get(this.POPULAR_STORES).filter(function (s) {
					return s.userType === _AppConstants2.default.USER_TYPE.INFLUENCER;
				});
	
				return null;
			}
		}, {
			key: 'getStoreInfo',
			value: function getStoreInfo(storeName) {
				return this.getState().get(_AppAction.UserAction.LOAD_USER_PROFILE + "_" + storeName.toUpperCase()) || null;
			}
		}, {
			key: 'getDesignerInfo',
			value: function getDesignerInfo(userId) {
				return this.getState().get(_AppAction.UserAction.LOAD_USER_PROFILE + "_" + userId) || null;
			}
		}, {
			key: '_upateUserProfile',
			value: function _upateUserProfile(state, updatedUser) {
				var updatedState = state.set(_AppAction.UserAction.LOAD_USER_PROFILE + "_" + updatedUser.id, updatedUser);
				if (updatedUser.storeName) return updatedState.set(_AppAction.UserAction.LOAD_USER_PROFILE + "_" + updatedUser.storeName.toUpperCase(), updatedUser);else return updatedState;
			}
		}, {
			key: 'getPopularArtists',
			value: function getPopularArtists() {
				return this.getState().get(_AppAction.DesignerAction.LOAD_POPULAR_ARTISTS) || null;
			}
		}, {
			key: 'getActiveArtists',
			value: function getActiveArtists() {
				return this.getState().get(_AppAction.DesignerAction.LOAD_ACTIVE_ARTISTS) || null;
			}
		}, {
			key: 'reduce',
			value: function reduce(state, action) {
	
				switch (action.type) {
					case _AppAction.DesignerAction.LOAD_BALANCE:
						return state.set(this.DESIGNER_BALANCE, action.balance);
	
					case _AppAction.DesignerAction.LOAD_ALL_PENDING_ORDERS:
						return state.set(this.DESIGNER_PENDING_ORDERS, _immutable2.default.List(action.orders));
	
					case _AppAction.DesignerAction.LOAD_POPULAR_STORES:
						_CacheService2.default.save(this.POPULAR_STORES, JSON.stringify(action.stores));
						return state.set(this.POPULAR_STORES, _immutable2.default.List(action.stores));
	
					case _AppAction.DesignerAction.LOAD_ALL_STORES:
						return state.set(this.ALL_STORES, _immutable2.default.List(action.stores));
	
					case _AppAction.UserAction.LOAD_USER_PROFILE:
						return this._upateUserProfile(state, action.userInfo);
	
					case _AppAction.UserAction.BANNER_UPDATE:
						return this._upateUserProfile(state, action.user);
	
					case _AppAction.UserAction.PROFILE_PIC_UPDATE:
						return this._upateUserProfile(state, action.user);
	
					case _AppAction.DesignerAction.LOAD_ACTIVE_ARTISTS:
						return state.set(_AppAction.DesignerAction.LOAD_ACTIVE_ARTISTS, _immutable2.default.List(action.artists));
	
					case _AppAction.DesignerAction.LOAD_POPULAR_ARTISTS:
						return state.set(_AppAction.DesignerAction.LOAD_POPULAR_ARTISTS, _immutable2.default.List(action.artists));
	
					case _AppAction.DesignerAction.LOAD_ALL_ARTISTS:
						return state.set(_AppAction.DesignerAction.LOAD_ALL_ARTISTS + "_" + action.prefix.toUpperCase(), _immutable2.default.List(action.artists));
	
					case _AppAction.UserAction.LOGOUT:
						return state.clear();
					default:
						break;
	
				}
				return state;
			}
		}]);
	
		return DesignerStore;
	}(_utils.ReduceStore);
	
	exports.default = new DesignerStore();

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(43);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(15);
	
	var _AppAction = __webpack_require__(22);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StockStore = function (_ReduceStore) {
	    _inherits(StockStore, _ReduceStore);
	
	    function StockStore() {
	        _classCallCheck(this, StockStore);
	
	        return _possibleConstructorReturn(this, (StockStore.__proto__ || Object.getPrototypeOf(StockStore)).call(this, _Dispatcher2.default));
	    }
	
	    _createClass(StockStore, [{
	        key: 'getInitialState',
	        value: function getInitialState() {
	            return _immutable2.default.Map();
	        }
	    }, {
	        key: 'getStockOwners',
	        value: function getStockOwners() {
	            return this.getState().get(_AppAction.StockAction.LOAD_STOCK_OWNERS) || null;
	        }
	    }, {
	        key: 'getStockOwner',
	        value: function getStockOwner(ownerName) {
	            return this.getState().get(_AppAction.StockAction.LOAD_SINGLE_STOCK_OWNER + "_" + ownerName) || null;
	        }
	    }, {
	        key: 'getStocks',
	        value: function getStocks(ownerName) {
	            return this.getState().get(_AppAction.StockAction.LOAD_OWNER_STOCKS + "_" + ownerName) || null;
	        }
	    }, {
	        key: 'getStockProductHistory',
	        value: function getStockProductHistory(stockProductId) {
	            return this.getState().get(_AppAction.StockAction.LOAD_STOCK_HISTORY + "_" + stockProductId) || null;
	        }
	    }, {
	        key: 'reduce',
	        value: function reduce(state, action) {
	            switch (action.type) {
	                case _AppAction.StockAction.LOAD_STOCK_OWNERS:
	                    var stockOwners = action.stockOwners;
	
	                    for (var i in stockOwners) {
	                        var owner = stockOwners[i];
	                        state = state.set(_AppAction.StockAction.LOAD_SINGLE_STOCK_OWNER + "_" + owner.ownerAlias, owner);
	                    }
	
	                    return state.set(_AppAction.StockAction.LOAD_STOCK_OWNERS, stockOwners);
	                case _AppAction.StockAction.LOAD_SINGLE_STOCK_OWNER:
	                    return state.set(_AppAction.StockAction.LOAD_SINGLE_STOCK_OWNER + "_" + action.stockOwner.ownerAlias, action.stockOwner);
	
	                case _AppAction.StockAction.LOAD_OWNER_STOCKS:
	                    return state.set(_AppAction.StockAction.LOAD_OWNER_STOCKS + "_" + action.ownerAlias, action.stocks);
	                case _AppAction.StockAction.CLEAR_OWNER_STOCKS:
	                    return state.set(_AppAction.StockAction.LOAD_OWNER_STOCKS + "_" + action.stockOwner, null);
	
	                case _AppAction.StockAction.LOAD_STOCK_HISTORY:
	                    return state.set(_AppAction.StockAction.LOAD_STOCK_HISTORY + "_" + action.stockProductId, action.history);
	                default:
	                    break;
	            }
	            return state;
	        }
	    }]);
	
	    return StockStore;
	}(_utils.ReduceStore);
	
	exports.default = new StockStore();

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectedImagePreview = __webpack_require__(64);
	
	var _SelectedImagePreview2 = _interopRequireDefault(_SelectedImagePreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImgUploadForm = function ImgUploadForm(_ref) {
	    var previewId = _ref.previewId,
	        className = _ref.className,
	        defaultPreviewImg = _ref.defaultPreviewImg,
	        imgWidth = _ref.imgWidth,
	        imgHeight = _ref.imgHeight,
	        imgInfo = _ref.imgInfo,
	        onUpload = _ref.onUpload,
	        onImgChange = _ref.onImgChange,
	        onImgReset = _ref.onImgReset,
	        addOnly = _ref.addOnly;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        uploadedImgFile = _useState2[0],
	        setUploadedImgFile = _useState2[1];
	
	    var uploadBtn = (0, _react.useRef)(null);
	    var fileInput = (0, _react.useRef)(null);
	
	    var onChange = function onChange(e) {
	        if (e.target.files.length > 0) {
	            var uploadedFile = e.target.files[0];
	            setUploadedImgFile(uploadedFile);
	
	            if (typeof onImgChange === 'function') onImgChange(uploadedFile);
	        }
	    };
	
	    var onReset = function onReset() {
	        setUploadedImgFile(null);
	        fileInput.current.value = '';
	
	        if (typeof onImgReset === 'function') onImgReset();
	    };
	
	    var onUploadClick = function onUploadClick() {
	        if (uploadedImgFile === null) return;
	
	        //pass new image file and old image
	        onUpload(uploadedImgFile);
	        uploadBtn.current.setAttribute("disabled", true);
	        uploadBtn.current.innerHTML = "<i class='fa fa-circle-o-notch fa-spin' aria-hidden='true'></i>";
	    };
	
	    (0, _react.useLayoutEffect)(function () {
	        setUploadedImgFile(null);
	    }, [defaultPreviewImg]); //uploadedImg gets updated by the API call, so when that happens, reset the profile pic
	
	
	    var showAddIcon = addOnly && !defaultPreviewImg;
	
	    var uploadIcon = showAddIcon ? _react2.default.createElement('i', { style: uploadedImgFile ? { visibility: 'hidden' } : {}, className: 'fa fa-plus', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { style: uploadedImgFile ? { visibility: 'hidden' } : {}, className: 'fa fa-camera-retro', 'aria-hidden': 'true' });
	
	    var showUploadIcon = showAddIcon || !addOnly;
	
	    return _react2.default.createElement(
	        'div',
	        { className: "imgUploadForm " + (className ? className : ''), style: { width: imgWidth, height: 'auto' } },
	        _react2.default.createElement(_SelectedImagePreview2.default, { style: { width: "100%", minHeight: 'unset', height: imgHeight },
	            id: previewId, file: uploadedImgFile, src: defaultPreviewImg }),
	        showUploadIcon && _react2.default.createElement(
	            'label',
	            { htmlFor: previewId + "Input", className: 'imgUploader', style: uploadedImgFile ? { backgroundColor: 'unset' } : {} },
	            uploadIcon
	        ),
	        _react2.default.createElement('input', { style: { display: 'none' }, id: previewId + "Input",
	            name: previewId + "Input", type: 'file', accept: '.png, .jpg, .jpeg',
	            onChange: onChange, ref: fileInput }),
	        imgInfo && _react2.default.createElement(
	            'div',
	            { style: { color: 'gray', fontSize: '80%' }, className: 'imgDimensionInfo' },
	            imgInfo
	        ),
	        uploadedImgFile && _react2.default.createElement(
	            'span',
	            { className: 'closeUploadedPic', onClick: onReset },
	            _react2.default.createElement('i', { className: 'fa fa-window-close-o', 'aria-hidden': 'true' })
	        ),
	        uploadedImgFile && typeof onUpload === 'function' && _react2.default.createElement(
	            'button',
	            { onClick: onUploadClick, ref: uploadBtn,
	                style: { width: '100px', height: '25px', marginTop: '10px', cursor: 'pointer', background: 'unset' } },
	            _react2.default.createElement('i', { className: 'fa fa-upload', 'aria-hidden': 'true' }),
	            ' Upload'
	        )
	    );
	};
	
	exports.default = ImgUploadForm;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactRouterDom = __webpack_require__(71);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	    searchInputDiv: { justifyContent: 'center', padding: '5px 10px', position: 'relative' },
	    seachInputContainer: { width: '50%', paddingRight: '20px 5px', '@media (max-width: 770px)': { flexGrow: '1' } }
	};
	
	var SearchInput = function (_React$Component) {
	    _inherits(SearchInput, _React$Component);
	
	    function SearchInput(props) {
	        _classCallCheck(this, SearchInput);
	
	        var _this = _possibleConstructorReturn(this, (SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).call(this, props));
	
	        _this.onKeywordChange = function (event) {
	            _this.setState({ keyword: event.target.value });
	        };
	
	        _this.onKeyDown = function (e) {
	            if (e.key === 'Enter') {
	                var href = _this.fetchSearchLink();
	                _this.props.history.push(href);
	                _this.onSearch();
	            }
	        };
	
	        _this.state = { keyword: props.keyword };
	        _this.fetchSearchLink = _this.fetchSearchLink.bind(_this);
	        _this.onSearch = _this.onSearch.bind(_this);
	        return _this;
	    }
	
	    _createClass(SearchInput, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.keyword !== this.props.keyword) this.setState({ keyword: this.props.keyword });
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch() {
	            if (typeof this.props.onSearch === "function") this.props.onSearch(this.state.keyword);
	        }
	    }, {
	        key: 'fetchSearchLink',
	        value: function fetchSearchLink() {
	            var keyword = this.state.keyword;
	            var href = keyword && keyword.length > 1 ? "/search/" + keyword : "#";
	            return href;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var href = this.fetchSearchLink();
	            var title = this.props.title;
	            return _react2.default.createElement(
	                'div',
	                { className: 'flexColumn searchInputContainer' },
	                title && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h1',
	                        { style: styles.searchTitle, className: 'searchInputTitle' },
	                        title
	                    ),
	                    _react2.default.createElement(_AppElements.Separator, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexRow', style: [styles.searchInputDiv] },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mui-textfield', style: styles.seachInputContainer },
	                        _react2.default.createElement('input', { className: 'mui--is-untouched mui--is-pristine mui--is-not-empty', type: 'text',
	                            value: this.state.keyword,
	                            onChange: this.onKeywordChange,
	                            onKeyDown: this.onKeyDown,
	                            placeholder: 'Influencers, Design, Artists and more...',
	                            ref: function ref(input) {
	                                _this2.searchInput = input;
	                            }, id: 'searchInput' })
	                    ),
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: href, className: 'searchIconBtn', style: [this.props.btnStyle], onClick: this.onSearch },
	                        _react2.default.createElement('i', { className: 'fa fa-search', 'aria-hidden': 'true' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchInput;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)((0, _radium2.default)(SearchInput));

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminDashboardTabs = function (_React$Component) {
	    _inherits(AdminDashboardTabs, _React$Component);
	
	    function AdminDashboardTabs() {
	        _classCallCheck(this, AdminDashboardTabs);
	
	        return _possibleConstructorReturn(this, (AdminDashboardTabs.__proto__ || Object.getPrototypeOf(AdminDashboardTabs)).apply(this, arguments));
	    }
	
	    _createClass(AdminDashboardTabs, [{
	        key: 'render',
	        value: function render() {
	            var activeTab = this.props.active;
	
	            var orderTabClassName = activeTab === "orders" ? 'active-admin-tab' : 'inactive-admin-tab';
	            var stockTabClassName = activeTab === "stocks" ? 'active-admin-tab' : 'inactive-admin-tab';
	            var productTabClassName = activeTab === "products" ? 'active-admin-tab' : 'inactive-admin-tab';
	            var userTabClassName = activeTab === "users" ? 'active-admin-tab' : 'inactive-admin-tab';
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexRow adminTabs' },
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: '/order/dashboard', className: orderTabClassName },
	                        'Orders'
	                    ),
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: '/stock/dashboard', className: stockTabClassName },
	                        'Stocks'
	                    ),
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: '/product/dashboard', className: productTabClassName },
	                        'Products'
	                    ),
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: '/all-users/dashboard', className: userTabClassName },
	                        'Users'
	                    )
	                ),
	                this.props.children
	            );
	        }
	    }]);
	
	    return AdminDashboardTabs;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(AdminDashboardTabs);

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _OrderForm = __webpack_require__(36);
	
	var _OrderForm2 = _interopRequireDefault(_OrderForm);
	
	var _OrderSizeInput = __webpack_require__(585);
	
	var _OrderSizeInput2 = _interopRequireDefault(_OrderSizeInput);
	
	var _QuantityInput = __webpack_require__(587);
	
	var _QuantityInput2 = _interopRequireDefault(_QuantityInput);
	
	var _ProductUtil = __webpack_require__(74);
	
	var _ProductUtil2 = _interopRequireDefault(_ProductUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DELIVERY_LOCATION_TYPE = _AppConstants2.default.DELIVERY_LOCATION_TYPE;
	
	var OUTSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY;
	var INSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.INSIDE_KTM_VALLEY;
	
	var INSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.INSIDE_RING_ROAD;
	var OUTSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD;
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	var USER_TYPE = _AppConstants2.default.USER_TYPE;
	
	var DELIVERY_TYPE = _AppConstants2.default.DELIVERY_TYPE;
	
	function getDefaultLocationType(productType, savedAddress) {
		if (productType === _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val) {
			return INSIDE_KTM_VALLEY.val;
		} else {
			if (savedAddress && savedAddress.locationType) return savedAddress.locationType;
		}
	
		return '';
	}
	
	var ProductOrderForm = function (_React$Component) {
		_inherits(ProductOrderForm, _React$Component);
	
		function ProductOrderForm(props) {
			_classCallCheck(this, ProductOrderForm);
	
			var _this = _possibleConstructorReturn(this, (ProductOrderForm.__proto__ || Object.getPrototypeOf(ProductOrderForm)).call(this, props));
	
			_this.initialValues = _this.initialValues.bind(_this);
			_this.validationScheme = _this.validationScheme.bind(_this);
			_this.createOrderRequest = _this.createOrderRequest.bind(_this);
			_this.isPrePaymentRequired = _this.isPrePaymentRequired.bind(_this);
			return _this;
		}
	
		_createClass(ProductOrderForm, [{
			key: 'initialValues',
			value: function initialValues() {
				if (!this.props.product) return {};
	
				var currentSession = _SessionStore2.default.getCurrentSession();
				var currentUser = currentSession ? currentSession.user : null;
	
				var isSalesUser = currentUser && (currentUser.userType === USER_TYPE.ADMIN || currentUser.userType === USER_TYPE.SALES);
				var savedAddress = JSON.parse(_CacheService2.default.get(_AppConstants2.default.USER_ADDRESS_KEY));
	
				var product = this.props.product;
	
				var initLocationType = getDefaultLocationType(product.productType, savedAddress);
				var initDeliveryType = _AppUtil2.default.getDefaultDeliveryType(product.productType, initLocationType);
	
				var productImage = '';
				var selectedImage = '';
				if (this.props.selectedImage) {
					productImage = this.props.selectedImage;
					selectedImage = this.props.selectedImage;
				} else {
					productImage = _AppUtil2.default.getDefaultProductImage(product);
	
					//Note: preview image may not be available and only product image can be available.
					if (product.previewImage) selectedImage = product.previewImage;else if (productImage) selectedImage = productImage;else selectedImage = product.productImages[0];
				};
	
				var userOrder = {
					quantity: 1,
					productImage: productImage,
					selectedImage: selectedImage,
					phone: savedAddress ? savedAddress.phone : '',
					streetAddress: savedAddress ? savedAddress.streetAddress : '',
					additionalNote: '',
					locationType: initLocationType,
					deliveryType: initDeliveryType,
					productPrice: product.price,
					customerName: !isSalesUser && currentUser ? currentUser.username : '',
					receiveEmailNotification: false,
					customerEmail: !isSalesUser && currentUser && currentUser.emailAddress ? currentUser.emailAddress : '',
					paymentPreference: 'COD',
					hasCouponCode: false,
					couponCode: '',
	
					//for bulk order
					isBulkOrderForm: false,
					sizeQuantity: {}
				};
	
				userOrder.productSize = '';
				var productVariants = this.props.product.productVariants;
				if (productVariants) {
					productVariants.forEach(function (v) {
	
						var variantKey = _ProductUtil2.default.getProductVariantKey(v);
						userOrder[variantKey] = v.variants[0].variantId;
					});
				}
	
				return userOrder;
			}
		}, {
			key: 'validationScheme',
			value: function validationScheme() {
				var _this2 = this;
	
				if (!this.props.product) return {};
	
				var productType = PRODUCT_TYPES[this.props.product.productType];
	
				var validation = {
					quantity: _yup2.default.number().typeError("Enter a quantity").min(1, "Enter a positive quantity.").required("Enter a quantity"),
					isBulkOrderForm: _yup2.default.boolean()
				};
	
				validation.productSize = _yup2.default.string().when('isBulkOrderForm', function (isBulkOrderForm, schema) {
					if (!isBulkOrderForm) return _yup2.default.string().required("Select a preferrable size.");
	
					return _yup2.default.string();
				});
	
				// validation.productSize = Yup.string().required("Select a preferrable size.");
	
				validation.locationType = _yup2.default.string().required("Where are you located?");
				validation.paymentPreference = _yup2.default.string().when(['locationType', 'isBulkOrderForm'], function (locationType, isBulkOrderForm, schema) {
					return _this2.isPrePaymentRequired({ locationType: locationType, isBulkOrderForm: isBulkOrderForm }) ? _yup2.default.string().required("Select one option to pay.") : _yup2.default.string();
				});
	
				validation.streetAddress = _yup2.default.string().required("Enter your delivery street address.");
				validation.phone = _AppUtil2.default.phoneNumberValidation();
				validation.customerName = _yup2.default.string().required("Enter your Full Name");
				validation.receiveEmailNotification = _yup2.default.boolean();
				validation.customerEmail = _yup2.default.boolean().when('receiveEmailNotification', function (receiveEmailNotification, schema) {
	
					if (receiveEmailNotification) return _yup2.default.string().required("Enter a valid email address.").email('Invalid Email address');
	
					return _yup2.default.string();
				});
	
				validation.deliveryType = _yup2.default.string().when('locationType', function (locationType, schema) {
					if (locationType === INSIDE_KTM_VALLEY.val || locationType === OUTSIDE_RING_ROAD.val || locationType === INSIDE_RING_ROAD.val) {
						var yupValidation = _yup2.default.string().required("Specify how you would like to get it delivered.");
						if (productType.hasImmediateDelivery) return yupValidation;else return yupValidation.matches(/(REGULAR)/, "Immediate delivery not supported on " + productType.label + ".");
					}
	
					return _yup2.default.string();
				});
	
				validation.hasCouponCode = _yup2.default.boolean();
				validation.couponCode = _yup2.default.boolean().when('hasCouponCode', function (hasCouponCode, schema) {
					if (hasCouponCode) return _yup2.default.string().required("Enter a coupon code");
	
					return _yup2.default.string();
				});
	
				validation.productImage = _yup2.default.string().required("Select which " + productType.label + " you want.");
	
				return validation;
			}
		}, {
			key: 'createOrderRequest',
			value: function createOrderRequest(formValue) {
				var order = {};
				order.productId = this.props.product.id;
	
				order.isBulkOrder = formValue.isBulkOrderForm;
				if (formValue.isBulkOrderForm === true) {
					order.sizeQuantity = formValue.sizeQuantity;
				} else {
					order.productSizes = [];
					order.productSizes.push(formValue.productSize);
					order.quantity = formValue.quantity;
				}
	
				order.orderedProductImage = formValue.productImage;
	
				order.phone = formValue.phone.trim();
				order.locationType = formValue.locationType;
				order.deliveryCharge = _AppUtil2.default.getLocationExtraCost(order.locationType, this.props.product);
				order.streetAddress = formValue.streetAddress.trim();
				order.additionalNote = formValue.additionalNote;
				order.deliveryType = formValue.deliveryType;
				order.paymentPreference = formValue.paymentPreference;
				order.customerName = formValue.customerName.trim();
				order.customerEmail = formValue.receiveEmailNotification ? formValue.customerEmail.trim() : null;
				order.couponCode = formValue.hasCouponCode ? formValue.couponCode : null;
				order.paymentPreference = formValue.paymentPreference;
	
				var productVariants = this.props.product.productVariants;
	
				if (productVariants) {
					order.selectedVariants = [];
					productVariants.forEach(function (v) {
						var variantKey = _ProductUtil2.default.getProductVariantKey(v);
						order.orderMetaData = order.orderMetaData || {};
	
						var selectedVariantValue = formValue[variantKey];
						if (selectedVariantValue) {
							order.selectedVariants.push(selectedVariantValue);
							var selectedVariantLabel = v.variants.filter(function (vr) {
								return vr.variantId === selectedVariantValue;
							})[0].label;
							order.orderMetaData[v.variantLabel] = selectedVariantLabel;
						}
					});
				}
	
				return order;
			}
		}, {
			key: 'displayDeliveryInputs',
			value: function displayDeliveryInputs(formValue) {
				var isBulkOrder = formValue.isBulkOrderForm;
	
				if (isBulkOrder) {
					var sizeQuantity = formValue.sizeQuantity;
					return Object.keys(sizeQuantity).length > 0;
				} else {
					var quantity = formValue.quantity;
					var size = formValue.productSize;
					return !isNaN(quantity) && size !== '';
				}
			}
		}, {
			key: 'isPrePaymentRequired',
			value: function isPrePaymentRequired(formValue) {
				return formValue.locationType === OUTSIDE_KTM_VALLEY.val || formValue.isBulkOrderForm;
			}
		}, {
			key: 'render',
			value: function render() {
				var initialValues = this.initialValues();
				var validationScheme = this.validationScheme();
	
				return _react2.default.createElement(_OrderForm2.default, { initialValues: initialValues, validationScheme: validationScheme,
					product: this.props.product,
					createOrderRequest: this.createOrderRequest,
					displayDeliveryInputs: this.displayDeliveryInputs,
					isPrePaymentRequired: this.isPrePaymentRequired,
					render: function render() {
						return _react2.default.createElement(
							_react2.default.Fragment,
							null,
							_react2.default.createElement(_QuantityInput2.default, null),
							_react2.default.createElement(_OrderSizeInput2.default, null)
						);
					} });
			}
		}]);
	
		return ProductOrderForm;
	}(_react2.default.Component);
	
	exports.default = ProductOrderForm;

/***/ },
/* 97 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 98 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(627);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(100);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _defaultArrowRenderer = __webpack_require__(240);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(241);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(145);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(146);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(238);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(239);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 100 */
6,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ },
/* 102 */
6,
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StickyContainer = exports.Sticky = undefined;
	
	var _Sticky = __webpack_require__(646);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	var _Container = __webpack_require__(645);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sticky = _Sticky2.default;
	exports.StickyContainer = _Container2.default;
	exports.default = _Sticky2.default;

/***/ },
/* 104 */
6,
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactPopper = __webpack_require__(108);
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _DropdownContext = __webpack_require__(106);
	
	var _utils = __webpack_require__(5);
	
	/* eslint react/no-find-dom-node: 0 */
	// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
	var propTypes = {
	  disabled: _propTypes.default.bool,
	  direction: _propTypes.default.oneOf(['up', 'down', 'left', 'right']),
	  group: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  nav: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  addonType: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['prepend', 'append'])]),
	  size: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  inNavbar: _propTypes.default.bool,
	  setActiveFromChild: _propTypes.default.bool
	};
	var defaultProps = {
	  isOpen: false,
	  direction: 'down',
	  nav: false,
	  active: false,
	  addonType: false,
	  inNavbar: false,
	  setActiveFromChild: false
	};
	
	var Dropdown =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Dropdown, _React$Component);
	
	  function Dropdown(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.addEvents = _this.addEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.removeEvents = _this.removeEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.containerRef = _react.default.createRef();
	    return _this;
	  }
	
	  var _proto = Dropdown.prototype;
	
	  _proto.getContextValue = function getContextValue() {
	    return {
	      toggle: this.props.toggle,
	      isOpen: this.props.isOpen,
	      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
	      inNavbar: this.props.inNavbar
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.handleProps();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.isOpen !== prevProps.isOpen) {
	      this.handleProps();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.removeEvents();
	  };
	
	  _proto.getContainer = function getContainer() {
	    return this.containerRef.current;
	  };
	
	  _proto.getMenuCtrl = function getMenuCtrl() {
	    if (this._$menuCtrl) return this._$menuCtrl;
	    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
	    return this._$menuCtrl;
	  };
	
	  _proto.getMenuItems = function getMenuItems() {
	    return [].slice.call(this.getContainer().querySelectorAll('[role="menuitem"]'));
	  };
	
	  _proto.addEvents = function addEvents() {
	    var _this2 = this;
	
	    ['click', 'touchstart', 'keyup'].forEach(function (event) {
	      return document.addEventListener(event, _this2.handleDocumentClick, true);
	    });
	  };
	
	  _proto.removeEvents = function removeEvents() {
	    var _this3 = this;
	
	    ['click', 'touchstart', 'keyup'].forEach(function (event) {
	      return document.removeEventListener(event, _this3.handleDocumentClick, true);
	    });
	  };
	
	  _proto.handleDocumentClick = function handleDocumentClick(e) {
	    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== _utils.keyCodes.tab)) return;
	    var container = this.getContainer();
	
	    if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === _utils.keyCodes.tab)) {
	      return;
	    }
	
	    this.toggle(e);
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(e) {
	    var _this4 = this;
	
	    if (/input|textarea/i.test(e.target.tagName) || _utils.keyCodes.tab === e.which && e.target.getAttribute('role') !== 'menuitem') {
	      return;
	    }
	
	    e.preventDefault();
	    if (this.props.disabled) return;
	
	    if (this.getMenuCtrl() === e.target) {
	      if (!this.props.isOpen && [_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down].indexOf(e.which) > -1) {
	        this.toggle(e);
	        setTimeout(function () {
	          return _this4.getMenuItems()[0].focus();
	        });
	      }
	    }
	
	    if (this.props.isOpen && e.target.getAttribute('role') === 'menuitem') {
	      if ([_utils.keyCodes.tab, _utils.keyCodes.esc].indexOf(e.which) > -1) {
	        this.toggle(e);
	        this.getMenuCtrl().focus();
	      } else if ([_utils.keyCodes.space, _utils.keyCodes.enter].indexOf(e.which) > -1) {
	        e.target.click();
	        this.getMenuCtrl().focus();
	      } else if ([_utils.keyCodes.down, _utils.keyCodes.up].indexOf(e.which) > -1 || [_utils.keyCodes.n, _utils.keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
	        var $menuitems = this.getMenuItems();
	        var index = $menuitems.indexOf(e.target);
	
	        if (_utils.keyCodes.up === e.which || _utils.keyCodes.p === e.which && e.ctrlKey) {
	          index = index !== 0 ? index - 1 : $menuitems.length - 1;
	        } else if (_utils.keyCodes.down === e.which || _utils.keyCodes.n === e.which && e.ctrlKey) {
	          index = index === $menuitems.length - 1 ? 0 : index + 1;
	        }
	
	        $menuitems[index].focus();
	      } else if (_utils.keyCodes.end === e.which) {
	        var _$menuitems = this.getMenuItems();
	
	        _$menuitems[_$menuitems.length - 1].focus();
	      } else if (_utils.keyCodes.home === e.which) {
	        var _$menuitems2 = this.getMenuItems();
	
	        _$menuitems2[0].focus();
	      } else if (e.which >= 48 && e.which <= 90) {
	        var _$menuitems3 = this.getMenuItems();
	
	        var charPressed = String.fromCharCode(e.which).toLowerCase();
	
	        for (var i = 0; i < _$menuitems3.length; i += 1) {
	          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();
	
	          if (firstLetter === charPressed) {
	            _$menuitems3[i].focus();
	
	            break;
	          }
	        }
	      }
	    }
	  };
	
	  _proto.handleProps = function handleProps() {
	    if (this.props.isOpen) {
	      this.addEvents();
	    } else {
	      this.removeEvents();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    if (this.props.disabled) {
	      return e && e.preventDefault();
	    }
	
	    return this.props.toggle(e);
	  };
	
	  _proto.render = function render() {
	    var _classNames, _ref;
	
	    var _omit = (0, _utils.omit)(this.props, ['toggle', 'disabled', 'inNavbar']),
	        className = _omit.className,
	        cssModule = _omit.cssModule,
	        direction = _omit.direction,
	        isOpen = _omit.isOpen,
	        group = _omit.group,
	        size = _omit.size,
	        nav = _omit.nav,
	        setActiveFromChild = _omit.setActiveFromChild,
	        active = _omit.active,
	        addonType = _omit.addonType,
	        tag = _omit.tag,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_omit, ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType", "tag"]);
	
	    var Tag = tag || (nav ? 'li' : 'div');
	    var subItemIsActive = false;
	
	    if (setActiveFromChild) {
	      _react.default.Children.map(this.props.children[1].props.children, function (dropdownItem) {
	        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
	      });
	    }
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
	    return _react.default.createElement(_DropdownContext.DropdownContext.Provider, {
	      value: this.getContextValue()
	    }, _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(Tag, (0, _extends2.default)({}, attrs, (_ref = {}, _ref[typeof Tag === 'string' ? 'ref' : 'innerRef'] = this.containerRef, _ref), {
	      onKeyDown: this.handleKeyDown,
	      className: classes
	    }))));
	  };
	
	  return Dropdown;
	}(_react.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	var _default = Dropdown;
	exports.default = _default;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.DropdownContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	/**
	 * DropdownContext
	 * {
	 *  toggle: PropTypes.func.isRequired,
	 *  isOpen: PropTypes.bool.isRequired,
	 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
	 *  inNavbar: PropTypes.bool.isRequired,
	 * }
	 */
	var DropdownContext = _react.default.createContext({});
	
	exports.DropdownContext = DropdownContext;

/***/ },
/* 107 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(758));
	
	var _Manager = _interopRequireDefault(__webpack_require__(150));
	
	var _Reference = _interopRequireDefault(__webpack_require__(759));

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(856),
	    listCacheDelete = __webpack_require__(857),
	    listCacheGet = __webpack_require__(858),
	    listCacheHas = __webpack_require__(859),
	    listCacheSet = __webpack_require__(860);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(169);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(276);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(35),
	    isKey = __webpack_require__(166),
	    stringToPath = __webpack_require__(881),
	    toString = __webpack_require__(82);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(853);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(288);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(38),
	    stubFalse = __webpack_require__(903);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)(module)))

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(54),
	    isObject = __webpack_require__(56);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(54),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
	 */
	'use strict'
	
	function Cache(maxSize) {
	  this._maxSize = maxSize
	  this.clear()
	}
	Cache.prototype.clear = function() {
	  this._size = 0
	  this._values = {}
	}
	Cache.prototype.get = function(key) {
	  return this._values[key]
	}
	Cache.prototype.set = function(key, value) {
	  this._size >= this._maxSize && this.clear()
	  if (!this._values.hasOwnProperty(key)) {
	    this._size++
	  }
	  return this._values[key] = value
	}
	
	var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
	  DIGIT_REGEX = /^\d+$/,
	  LEAD_DIGIT_REGEX = /^\d/,
	  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
	  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
	  MAX_CACHE_SIZE = 512
	
	var contentSecurityPolicy = false,
	  pathCache = new Cache(MAX_CACHE_SIZE),
	  setCache = new Cache(MAX_CACHE_SIZE),
	  getCache = new Cache(MAX_CACHE_SIZE)
	
	try {
	  new Function('')
	} catch (error) {
	  contentSecurityPolicy = true
	}
	
	module.exports = {
	  Cache: Cache,
	
	  expr: expr,
	
	  split: split,
	
	  normalizePath: normalizePath,
	
	  setter: contentSecurityPolicy
	    ? function(path) {
	      var parts = normalizePath(path)
	      return function(data, value) {
	        return setterFallback(parts, data, value)
	      }
	    }
	    : function(path) {
	      return setCache.get(path) || setCache.set(
	        path,
	        new Function(
	          'data, value',
	          expr(path, 'data') + ' = value'
	        )
	      )
	    },
	
	  getter: contentSecurityPolicy
	    ? function(path, safe) {
	      var parts = normalizePath(path)
	      return function(data) {
	        return getterFallback(parts, safe, data)
	      }
	    }
	    : function(path, safe) {
	      var key = path + '_' + safe
	      return getCache.get(key) || getCache.set(
	        key,
	        new Function('data', 'return ' + expr(path, safe, 'data'))
	      )
	    },
	
	  join: function(segments) {
	    return segments.reduce(function(path, part) {
	      return (
	        path +
	        (isQuoted(part) || DIGIT_REGEX.test(part)
	          ? '[' + part + ']'
	          : (path ? '.' : '') + part)
	      )
	    }, '')
	  },
	
	  forEach: function(path, cb, thisArg) {
	    forEach(split(path), cb, thisArg)
	  }
	}
	
	function setterFallback(parts, data, value) {
	  var index = 0,
	    len = parts.length
	  while (index < len - 1) {
	    data = data[parts[index++]]
	  }
	  data[parts[index]] = value
	}
	
	function getterFallback(parts, safe, data) {
	  var index = 0,
	    len = parts.length
	  while (index < len) {
	    if (data != null || !safe) {
	      data = data[parts[index++]]
	    } else {
	      return
	    }
	  }
	  return data
	}
	
	function normalizePath(path) {
	  return pathCache.get(path) || pathCache.set(
	    path,
	    split(path).map(function(part) {
	      return part.replace(CLEAN_QUOTES_REGEX, '$2')
	    })
	  )
	}
	
	function split(path) {
	  return path.match(SPLIT_REGEX)
	}
	
	function expr(expression, safe, param) {
	  expression = expression || ''
	
	  if (typeof safe === 'string') {
	    param = safe
	    safe = false
	  }
	
	  param = param || 'data'
	
	  if (expression && expression.charAt(0) !== '[') expression = '.' + expression
	
	  return safe ? makeSafe(expression, param) : param + expression
	}
	
	function forEach(parts, iter, thisArg) {
	  var len = parts.length,
	    part,
	    idx,
	    isArray,
	    isBracket
	
	  for (idx = 0; idx < len; idx++) {
	    part = parts[idx]
	
	    if (part) {
	      if (shouldBeQuoted(part)) {
	        part = '"' + part + '"'
	      }
	
	      isBracket = isQuoted(part)
	      isArray = !isBracket && /^\d+$/.test(part)
	
	      iter.call(thisArg, part, isBracket, isArray, idx, parts)
	    }
	  }
	}
	
	function isQuoted(str) {
	  return (
	    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
	  )
	}
	
	function makeSafe(path, param) {
	  var result = param,
	    parts = split(path),
	    isLast
	
	  forEach(parts, function(part, isBracket, isArray, idx, parts) {
	    isLast = idx === parts.length - 1
	
	    part = isBracket || isArray ? '[' + part + ']' : '.' + part
	
	    result += part + (!isLast ? ' || {})' : ')')
	  })
	
	  return new Array(parts.length + 1).join('(') + result
	}
	
	function hasLeadingNumber(part) {
	  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
	}
	
	function hasSpecialChars(part) {
	  return SPEC_CHAR_REGEX.test(part)
	}
	
	function shouldBeQuoted(part) {
	  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
	}


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(29);
	var normalizeHeaderName = __webpack_require__(311);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(174);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(174);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)))

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(315);
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        e.clipboardData.clearData();
	        e.clipboardData.setData(options.format, text);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React tabs module
	 * @module react/tabs
	 */
	
	/* jshint quotmark:false */
	// jscs:disable validateQuoteMarks
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	var _tab = babelHelpers.interopRequireDefault(__webpack_require__(85));
	
	var util = babelHelpers.interopRequireWildcard(__webpack_require__(57));
	var tabsBarClass = 'mui-tabs__bar',
	    tabsBarJustifiedClass = 'mui-tabs__bar--justified',
	    tabsPaneClass = 'mui-tabs__pane',
	    isActiveClass = 'mui--is-active';
	/**
	 * Tabs constructor
	 * @class
	 */
	
	var Tabs =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Tabs, _React$Component);
	
	  function Tabs(props) {
	    var _this;
	
	    babelHelpers.classCallCheck(this, Tabs);
	
	    /*
	     * The following code exists only to warn about deprecating props.initialSelectedIndex in favor of props.defaultSelectedIndex.
	     * It can be removed once support for props.initialSelectedIndex is officially dropped.
	     */
	    var defaultSelectedIndex;
	
	    if (typeof props.initialSelectedIndex === 'number') {
	      defaultSelectedIndex = props.initialSelectedIndex;
	
	      if (console && process && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENV":"prod"}) && process.NODE_ENV !== 'production') {
	        console.warn('MUICSS DEPRECATION WARNING: ' + 'property "initialSelectedIndex" on the muicss Tabs component is deprecated in favor of "defaultSelectedIndex". ' + 'It will be removed in a future release.');
	      }
	    } else {
	      defaultSelectedIndex = props.defaultSelectedIndex;
	    }
	    /*
	     * End deprecation warning
	     */
	
	
	    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Tabs).call(this, props));
	    _this.state = {
	      currentSelectedIndex: typeof props.selectedIndex === 'number' ? props.selectedIndex : defaultSelectedIndex
	    };
	    return _this;
	  }
	
	  babelHelpers.createClass(Tabs, [{
	    key: "onClick",
	    value: function onClick(i, tab, ev) {
	      if (typeof this.props.selectedIndex === 'number' && i !== this.props.selectedIndex || i !== this.state.currentSelectedIndex) {
	        this.setState({
	          currentSelectedIndex: i
	        }); // onActive callback
	
	        if (tab.props.onActive) tab.props.onActive(tab); // onChange callback
	
	        if (this.props.onChange) {
	          this.props.onChange(i, tab.props.value, tab, ev);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          defaultSelectedIndex = _this$props.defaultSelectedIndex,
	          initialSelectedIndex = _this$props.initialSelectedIndex,
	          justified = _this$props.justified,
	          selectedIndex = _this$props.selectedIndex,
	          reactProps = babelHelpers.objectWithoutProperties(_this$props, ["children", "defaultSelectedIndex", "initialSelectedIndex", "justified", "selectedIndex"]);
	
	      var tabs = _react["default"].Children.toArray(children);
	
	      var tabEls = [],
	          paneEls = [],
	          m = tabs.length,
	          currentSelectedIndex = (typeof selectedIndex === 'number' ? selectedIndex : this.state.currentSelectedIndex) % m,
	          isActive,
	          item,
	          cls,
	          i;
	
	      for (i = 0; i < m; i++) {
	        item = tabs[i]; // only accept MUITab elements
	
	        if (item.type !== _tab["default"]) util.raiseError('Expecting MUITab React Element');
	        isActive = i === currentSelectedIndex ? true : false; // tab element
	
	        tabEls.push(_react["default"].createElement("li", {
	          key: i,
	          className: isActive ? isActiveClass : ''
	        }, _react["default"].createElement("a", {
	          onClick: this.onClick.bind(this, i, item)
	        }, item.props.label))); // pane element
	
	        cls = tabsPaneClass + ' ';
	        if (isActive) cls += isActiveClass;
	        paneEls.push(_react["default"].createElement("div", {
	          key: i,
	          className: cls
	        }, item.props.children));
	      }
	
	      cls = tabsBarClass;
	      if (justified) cls += ' ' + tabsBarJustifiedClass;
	      return _react["default"].createElement("div", reactProps, _react["default"].createElement("ul", {
	        className: cls
	      }, tabEls), paneEls);
	    }
	  }]);
	  return Tabs;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Tabs, "defaultProps", {
	  className: '',
	  defaultSelectedIndex: 0,
	
	  /*
	   * @deprecated
	   */
	  initialSelectedIndex: null,
	  justified: false,
	  onChange: null,
	  selectedIndex: null
	});
	var _default = Tabs;
	exports["default"] = _default;
	module.exports = exports.default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)))

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cssRuleSetToString;
	
	var _appendPxIfNeeded = __webpack_require__(183);
	
	var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);
	
	var _camelCasePropsToDashCase = __webpack_require__(344);
	
	var _camelCasePropsToDashCase2 = _interopRequireDefault(_camelCasePropsToDashCase);
	
	var _mapObject = __webpack_require__(188);
	
	var _mapObject2 = _interopRequireDefault(_mapObject);
	
	var _prefixer = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMarkupForStyles(style) {
	  return Object.keys(style).map(function (property) {
	    return property + ': ' + style[property] + ';';
	  }).join('\n');
	}
	
	function cssRuleSetToString(selector, rules, userAgent) {
	  if (!rules) {
	    return '';
	  }
	
	  var rulesWithPx = (0, _mapObject2.default)(rules, function (value, key) {
	    return (0, _appendPxIfNeeded2.default)(key, value);
	  });
	  var prefixedRules = (0, _prefixer.getPrefixedStyle)(rulesWithPx, userAgent);
	  var cssPrefixedRules = (0, _camelCasePropsToDashCase2.default)(prefixedRules);
	  var serializedRules = createMarkupForStyles(cssPrefixedRules);
	
	  return selector + '{' + serializedRules + '}';
	}
	module.exports = exports['default'];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Based on https://github.com/jsstyles/css-vendor, but without having to
	                                                                                                                                                                                                                                                                               * convert between different cases all the time.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * 
	                                                                                                                                                                                                                                                                               */
	
	exports.getPrefixedKeyframes = getPrefixedKeyframes;
	exports.getPrefixedStyle = getPrefixedStyle;
	
	var _inlineStylePrefixer = __webpack_require__(360);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transformValues(style) {
	  return Object.keys(style).reduce(function (newStyle, key) {
	    var value = style[key];
	    if (Array.isArray(value)) {
	      value = value.join(';' + key + ':');
	    } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toString === 'function') {
	      value = value.toString();
	    }
	
	    newStyle[key] = value;
	    return newStyle;
	  }, {});
	}
	
	var _hasWarnedAboutUserAgent = false;
	var _lastUserAgent = void 0;
	var _cachedPrefixer = void 0;
	
	function getPrefixer(userAgent) {
	  var actualUserAgent = userAgent || global && global.navigator && global.navigator.userAgent;
	
	  if (false) {
	    if (!actualUserAgent && !_hasWarnedAboutUserAgent) {
	      /* eslint-disable no-console */
	      console.warn('Radium: userAgent should be supplied for server-side rendering. See ' + 'https://github.com/FormidableLabs/radium/tree/master/docs/api#radium ' + 'for more information.');
	      /* eslint-enable no-console */
	      _hasWarnedAboutUserAgent = true;
	    }
	  }
	
	  if (!_cachedPrefixer || actualUserAgent !== _lastUserAgent) {
	    if (actualUserAgent === 'all') {
	      _cachedPrefixer = {
	        prefix: _inlineStylePrefixer2.default.prefixAll,
	        prefixedKeyframes: 'keyframes'
	      };
	    } else {
	      _cachedPrefixer = new _inlineStylePrefixer2.default({ userAgent: actualUserAgent });
	    }
	    _lastUserAgent = actualUserAgent;
	  }
	  return _cachedPrefixer;
	}
	
	function getPrefixedKeyframes(userAgent) {
	  return getPrefixer(userAgent).prefixedKeyframes;
	}
	
	// Returns a new style object with vendor prefixes added to property names
	// and values.
	function getPrefixedStyle(style, userAgent) {
	  var styleWithFallbacks = transformValues(style);
	  var prefixer = getPrefixer(userAgent);
	  var prefixedStyle = prefixer.prefix(styleWithFallbacks);
	  return prefixedStyle;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 125 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleKeeper = function () {
	  function StyleKeeper(userAgent) {
	    _classCallCheck(this, StyleKeeper);
	
	    this._userAgent = userAgent;
	    this._listeners = [];
	    this._cssSet = {};
	  }
	
	  StyleKeeper.prototype.subscribe = function subscribe(listener) {
	    var _this = this;
	
	    if (this._listeners.indexOf(listener) === -1) {
	      this._listeners.push(listener);
	    }
	
	    return {
	      // Must be fat arrow to capture `this`
	      remove: function remove() {
	        var listenerIndex = _this._listeners.indexOf(listener);
	        if (listenerIndex > -1) {
	          _this._listeners.splice(listenerIndex, 1);
	        }
	      }
	    };
	  };
	
	  StyleKeeper.prototype.addCSS = function addCSS(css) {
	    var _this2 = this;
	
	    if (!this._cssSet[css]) {
	      this._cssSet[css] = true;
	      this._emitChange();
	    }
	
	    return {
	      // Must be fat arrow to capture `this`
	      remove: function remove() {
	        delete _this2._cssSet[css];
	        _this2._emitChange();
	      }
	    };
	  };
	
	  StyleKeeper.prototype.getCSS = function getCSS() {
	    return Object.keys(this._cssSet).join('\n');
	  };
	
	  StyleKeeper.prototype._emitChange = function _emitChange() {
	    this._listeners.forEach(function (listener) {
	      return listener();
	    });
	  };
	
	  return StyleKeeper;
	}();
	
	exports.default = StyleKeeper;
	module.exports = exports['default'];

/***/ },
/* 126 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ },
/* 127 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createGenerateClassNameDefault = exports.SheetsManager = exports.getDynamicStyles = exports.SheetsRegistry = undefined;
	
	var _jss = __webpack_require__(203);
	
	Object.defineProperty(exports, 'SheetsRegistry', {
	  enumerable: true,
	  get: function get() {
	    return _jss.SheetsRegistry;
	  }
	});
	Object.defineProperty(exports, 'getDynamicStyles', {
	  enumerable: true,
	  get: function get() {
	    return _jss.getDynamicStyles;
	  }
	});
	Object.defineProperty(exports, 'SheetsManager', {
	  enumerable: true,
	  get: function get() {
	    return _jss.SheetsManager;
	  }
	});
	Object.defineProperty(exports, 'createGenerateClassNameDefault', {
	  enumerable: true,
	  get: function get() {
	    return _jss.createGenerateClassName;
	  }
	});
	
	var _jssPresetDefault = __webpack_require__(432);
	
	var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = (0, _jss.create)((0, _jssPresetDefault2['default'])());

/***/ },
/* 129 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Namespaces to avoid conflicts on the context.
	 */
	var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
	var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
	var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
	var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInBrowser = __webpack_require__(131);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var js = ''; /**
	              * Export javascript style and css style vendor prefixes.
	              * Based on "transform" support test.
	              */
	
	var css = '';
	
	// We should not do anything if required serverside.
	if (_isInBrowser2['default']) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    // IE did it wrong again ...
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  }
	}
	
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String}}
	 * @api public
	 */
	exports['default'] = { js: js, css: css };

/***/ },
/* 131 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SheetsRegistry = __webpack_require__(201);
	
	var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	exports['default'] = new _SheetsRegistry2['default']();

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toCss;
	
	var _toCssValue = __webpack_require__(88);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }return result + str;
	}
	
	/**
	 * Converts a Rule to CSS string.
	 */
	
	function toCss(selector, style) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var result = '';
	
	  if (!style) return result;
	
	  var _options$indent = options.indent,
	      indent = _options$indent === undefined ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	
	
	  indent++;
	
	  // Apply fallbacks first.
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	        for (var prop in fallback) {
	          var value = fallback[prop];
	          if (value != null) {
	            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	        if (_value != null) {
	          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
	    }
	  }
	
	  // Allow empty style in this case, because properties will be added dynamically.
	  if (!result && !options.allowEmpty) return result;
	
	  indent--;
	  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);
	
	  return result;
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(135);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(214);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(15);
	
	var _OrderStore = __webpack_require__(61);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _StockStore = __webpack_require__(92);
	
	var _StockStore2 = _interopRequireDefault(_StockStore);
	
	var _OrdersList = __webpack_require__(225);
	
	var _OrdersList2 = _interopRequireDefault(_OrdersList);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _StockOwnerAPI = __webpack_require__(217);
	
	var _StockOwnerAPI2 = _interopRequireDefault(_StockOwnerAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderListContainer = function (_React$Component) {
		_inherits(OrderListContainer, _React$Component);
	
		_createClass(OrderListContainer, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_OrderStore2.default, _StockStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState, props) {
				var session = props.session;
				var product = props.product;
	
				var orderState = props.orderState;
				return {
					userOrders: session ? _OrderStore2.default.getUserOrders() : null,
					productOrders: product ? _OrderStore2.default.getProductOrders(product.id) : null,
					allOrders: _OrderStore2.default.getOrdersByState(orderState),
	
					stockOwners: _StockStore2.default.getStockOwners()
				};
			}
		}]);
	
		function OrderListContainer(props) {
			_classCallCheck(this, OrderListContainer);
	
			var _this = _possibleConstructorReturn(this, (OrderListContainer.__proto__ || Object.getPrototypeOf(OrderListContainer)).call(this, props));
	
			_this.getOrderListTitle = _this.getOrderListTitle.bind(_this);
			_this.getOrders = _this.getOrders.bind(_this);
			return _this;
		}
	
		_createClass(OrderListContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.session) {
					if (this.state.userOrders === null) _HttpService2.default.getMyOrders();
				} else if (this.props.product) {
					if (this.state.productOrders === null) _HttpService2.default.getProductOrders(this.props.product.id);
				} else if (this.props.orderState) {
					if (this.state.allOrders === null) _HttpService2.default.getAllOrders(this.props.orderState);
				}
	
				if (this.props.changeOrderState) {
					//fetch all owners, if not available
					if (!_StockStore2.default.getStockOwners()) _StockOwnerAPI2.default.getAllOwners();
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
	
				//currently, this is only required in case of order state thing from OrderDashboard
				//for others, the above componentDidMount will work
				if (this.props.orderState) {
					if (this.props.orderState !== prevProps.orderState) {
						if (this.state.allOrders === null) _HttpService2.default.getAllOrders(this.props.orderState);
					}
				}
			}
		}, {
			key: 'getOrderListTitle',
			value: function getOrderListTitle() {
				if (this.props.session) return "My Orders";
	
				if (this.props.product) return this.props.product.title + " Orders";
	
				return null;
			}
		}, {
			key: 'getOrders',
			value: function getOrders() {
				if (this.props.session) return this.state.userOrders;
	
				if (this.props.product) return this.state.productOrders;
	
				return this.state.allOrders;
			}
		}, {
			key: 'render',
			value: function render() {
				var orders = this.getOrders();
				var title = this.getOrderListTitle();
	
				return _react2.default.createElement(_OrdersList2.default, { style: { margin: "10px 0", padding: "0 5px" },
					orders: orders, title: title,
					showPaymentOption: this.props.showPaymentOption,
					showProductInfo: this.props.showProductInfo,
					changeOrderState: this.props.changeOrderState,
					showExportAsCSV: this.props.showExportAsCSV,
					stockOwners: this.state.stockOwners });
			}
		}]);
	
		return OrderListContainer;
	}(_react2.default.Component);
	
	exports.default = _utils.Container.create(OrderListContainer, { withProps: true });

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useProduct = exports.useDesignerProducts = exports.usePopularProducts = exports.useFeaturedProducts = undefined;
	
	var _ReduceStoreHook = __webpack_require__(45);
	
	var _ReduceStoreHook2 = _interopRequireDefault(_ReduceStoreHook);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useFeaturedProducts = exports.useFeaturedProducts = function useFeaturedProducts() {
	    var featuredProducts = (0, _ReduceStoreHook2.default)(_ProductStore2.default, function (store) {
	        return store.getFeaturedProducts();
	    }, function () {
	        return _ProductAPI2.default.getFeaturedProducts();
	    }, []);
	
	    return featuredProducts;
	};
	
	var usePopularProducts = exports.usePopularProducts = function usePopularProducts() {
	    var featuredProducts = (0, _ReduceStoreHook2.default)(_ProductStore2.default, function (store) {
	        return store.getPopularProducts();
	    }, function () {
	        return _ProductAPI2.default.getPopularProducts();
	    }, []);
	
	    return featuredProducts;
	};
	
	//userId can be null, when getting for current session, hence adding if userid avaiilable check
	var useDesignerProducts = exports.useDesignerProducts = function useDesignerProducts(userId) {
	    var userProducts = (0, _ReduceStoreHook2.default)(_ProductStore2.default, function (store) {
	        return userId ? store.getProducts(userId) : null;
	    }, function () {
	        if (userId) _HttpService2.default.getProducts(userId);
	    }, [userId]);
	
	    //TODO: use per product type later
	    // ProductAPI.getUserProductsPerType(userId);
	    return userProducts;
	};
	
	var useProduct = exports.useProduct = function useProduct(productId) {
	    var product = (0, _ReduceStoreHook2.default)(_ProductStore2.default, function (store) {
	        return store.getProduct(productId);
	    }, function () {
	        return _HttpService2.default.getProduct(productId);
	    }, [productId]);
	
	    return product;
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HttpService2 = __webpack_require__(12);
	
	var _AppAction = __webpack_require__(22);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //Note: Important!!!
	//import the class here, not the object
	
	
	var BASE_URL = _AppConstants2.default.BASE_API_URL + "/adcampaign";
	
	var AdAPI = function (_HttpService) {
		_inherits(AdAPI, _HttpService);
	
		function AdAPI() {
			_classCallCheck(this, AdAPI);
	
			return _possibleConstructorReturn(this, (AdAPI.__proto__ || Object.getPrototypeOf(AdAPI)).apply(this, arguments));
		}
	
		_createClass(AdAPI, [{
			key: 'getChetanCampaignOrders',
			value: function getChetanCampaignOrders() {
				this.get("/chetan-camper/orders", function (response) {
					_Dispatcher2.default.dispatch({
						type: _AppAction.OrderAction.LOAD_CHETAN_CAMPAGIN_ORDERS,
						orders: response.data
					});
				});
			}
		}, {
			key: 'getCodersMerch',
			value: function getCodersMerch(callback) {
				this.get("/promotion/merch?code=CODER_MERCH", function (response) {
					callback(response.data);
				});
			}
		}, {
			key: 'getNepalThemeMerch',
			value: function getNepalThemeMerch(callback) {
				this.get("/promotion/merch?code=NEPAL_MERCH", function (response) {
					callback(response.data);
				});
			}
		}, {
			key: 'subscribeToCodersMerchCoupon',
			value: function subscribeToCodersMerchCoupon(emailAddress, callback) {
				var _this2 = this;
	
				var postData = { emailAddress: emailAddress };
				this.post("/coding-merch-coupon", postData, function (response) {
					_Dispatcher2.default.dispatchAnAlert(response.data);
	
					if (typeof callback === 'function') callback(true);
				}, function (error) {
					if (typeof callback === 'function') callback(false);
	
					_this2.defaultErrorHandler(error);
				});
			}
		}]);
	
		return AdAPI;
	}(_HttpService2.HttpService);
	
	exports.default = new AdAPI(BASE_URL);

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ThumbnailLoader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _Loader = __webpack_require__(63);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThumbnailLoader = exports.ThumbnailLoader = function ThumbnailLoader(props) {
	
		return _react2.default.createElement(_Loader2.default, { style: { height: '442px', width: '442px', flexGrow: "1", maxWidth: '500px', marginRight: '20px', marginBottom: '10px',
				'@media (max-width: 884px)': { width: '100%', marginRight: '0', height: '300px' } }, noEffect: true });
	};
	
	var OrderFormLoder = (0, _radium2.default)(function (props) {
	
		return _react2.default.createElement(
			'div',
			{ className: 'flexRow', style: { paddingTop: '20px' } },
			_react2.default.createElement(ThumbnailLoader, null),
			_react2.default.createElement(
				'div',
				{ style: { flexGrow: "1", maxWidth: "500px" } },
				_react2.default.createElement(_Loader2.default, { style: { height: '35px', width: '50%', marginBottom: '15px' } }),
				_react2.default.createElement(_Loader2.default, { style: { height: '15px', width: '30%' } }),
				_react2.default.createElement(_Loader2.default, { style: { height: '30px', width: '25%', margin: '40px 0' } }),
				_react2.default.createElement('hr', null),
				_react2.default.createElement(
					'div',
					{ className: 'flexRow', style: { marginTop: '40px' } },
					_react2.default.createElement(_Loader2.default, { style: { height: '100px', width: '100px', marginRight: '10px' }, noEffect: true }),
					_react2.default.createElement(_Loader2.default, { style: { height: '100px', width: '100px', marginRight: '10px' }, noEffect: true })
				),
				_react2.default.createElement(_Loader2.default, { style: { height: '30px', width: '100%', marginTop: '30px' }, noEffect: true }),
				_react2.default.createElement(_Loader2.default, { style: { height: '30px', width: '100%', marginTop: '30px' }, noEffect: true })
			)
		);
	});
	
	exports.default = OrderFormLoder;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectedImagePreview = __webpack_require__(64);
	
	var _SelectedImagePreview2 = _interopRequireDefault(_SelectedImagePreview);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImgLoader = function ImgLoader(_ref) {
	    var text = _ref.text;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'span',
	            { style: { fontSize: '1.5em' } },
	            text
	        ),
	        _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin', 'aria-hidden': 'true', style: { fontSize: '1.5em' } })
	    );
	};
	
	var PhotoFrameImg = function PhotoFrameImg(_ref2) {
	    var id = _ref2.id,
	        className = _ref2.className,
	        imgUrl = _ref2.imgUrl,
	        imgFile = _ref2.imgFile,
	        matting = _ref2.matting,
	        style = _ref2.style,
	        borderColor = _ref2.borderColor,
	        _onImgLoad = _ref2.onImgLoad;
	
	    var _useState = (0, _react.useState)(true),
	        _useState2 = _slicedToArray(_useState, 2),
	        loadingImg = _useState2[0],
	        setLoadingImg = _useState2[1]; //the actual image object
	
	    var mattingClassName = matting ? matting + "Matting" : ' ';
	    var loadingClassName = loadingImg ? "frameImgLoader" : "";
	    var borderClassName = borderColor ? borderColor : "blackBorder";
	    return _react2.default.createElement(
	        'div',
	        { className: "framePreviewContainer " + mattingClassName + " " + loadingClassName + " " + borderClassName },
	        loadingImg && _react2.default.createElement(ImgLoader, { text: imgUrl ? "Loading..." : "Uploading..." }),
	        imgFile && _react2.default.createElement(_SelectedImagePreview2.default, { id: id, style: style,
	            className: "imgPreview " + className, file: imgFile,
	            onImgLoad: function onImgLoad(img) {
	                setLoadingImg(false);
	
	                if (typeof _onImgLoad === 'function') _onImgLoad(img);
	            } }),
	        imgUrl && _react2.default.createElement(_AppElements.Img, { id: id, src: imgUrl, alt: id + "-photo-frame-img", style: style, className: className,
	            onImgLoad: function onImgLoad(img) {
	                setLoadingImg(false);
	
	                if (typeof _onImgLoad === 'function') _onImgLoad(img);
	            } })
	    );
	};
	
	exports.default = PhotoFrameImg;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BRIGHT_COLOR = '#f49600';
	var DARK_COLOR = 'gray';
	
	var PriceLabel = function (_React$Component) {
		_inherits(PriceLabel, _React$Component);
	
		function PriceLabel() {
			_classCallCheck(this, PriceLabel);
	
			return _possibleConstructorReturn(this, (PriceLabel.__proto__ || Object.getPrototypeOf(PriceLabel)).apply(this, arguments));
		}
	
		_createClass(PriceLabel, [{
			key: 'render',
			value: function render() {
				var price = this.props.price;
				var productType = _AppConstants2.default.PRODUCT_TYPES[this.props.productType];
	
				var aliasPrice = this.props.aliasPrice || productType.basePrice;
				var discount = parseInt(_AppUtil2.default.calculatePercentDiff(price, aliasPrice), 10);
	
				var priceColor = this.props.invertColor === true ? DARK_COLOR : BRIGHT_COLOR;
				var discountColor = this.props.invertColor === true ? BRIGHT_COLOR : DARK_COLOR;
	
				var style = [{ color: priceColor }];
	
				if (this.props.style) style.push(this.props.style);
	
				var discountFont = this.props.discountFont ? this.props.discountFont : '80%';
	
				return _react2.default.createElement(
					'span',
					{ style: style },
					_react2.default.createElement(
						'span',
						null,
						'Rs. ',
						_AppUtil2.default.formatNumber(price)
					),
					discount < 0 && _react2.default.createElement(
						'span',
						{ style: { display: 'block', fontSize: discountFont, color: discountColor } },
						_react2.default.createElement(
							'span',
							{ style: { textDecoration: 'line-through', marginRight: '5px' } },
							'Rs. ',
							_AppUtil2.default.formatNumber(aliasPrice)
						),
						_react2.default.createElement(
							'span',
							null,
							Math.abs(discount),
							'% off'
						)
					)
				);
			}
		}]);
	
		return PriceLabel;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(PriceLabel);

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _HeaderBanner = __webpack_require__(47);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuggestedProducts = (0, _radium2.default)(function (props) {
		var products = props.products;
		var filterProduct = props.filterProduct;
	
		if (!products) return null;
	
		var suggestedProducts = products.filter(function (p) {
			if (filterProduct) return p.id !== filterProduct.id;
	
			return true;
		}).sort(function () {
			return .5 - Math.random();
		});
	
		if (!suggestedProducts || suggestedProducts.length === 0) return null;
	
		return _react2.default.createElement(
			'div',
			{ className: 'suggestedProducts', style: { margin: '0 15px' } },
			_react2.default.createElement(
				'h2',
				{ style: { color: 'darkcyan', paddingTop: '10px', borderTop: '1px solid gray' } },
				props.title || 'You May Also Like!'
			),
			_react2.default.createElement(_ProductList2.default, { products: suggestedProducts, showSlider: true,
				autoplay: props.autoplay, navigator: props.navigator,
				flattenProductImages: true })
		);
	});
	
	exports.default = SuggestedProducts;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(99);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(236);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(624);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(237);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(239);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(238);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(146);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(240);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(241);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(145);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(242);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(626);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(100);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(104);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	//
	exports.default = {
	  get: get,
	  set: set,
	  takeRight: takeRight,
	  last: last,
	  orderBy: orderBy,
	  range: range,
	  remove: remove,
	  clone: clone,
	  getFirstDefined: getFirstDefined,
	  sum: sum,
	  makeTemplateComponent: makeTemplateComponent,
	  groupBy: groupBy,
	  isArray: isArray,
	  splitProps: splitProps,
	  compactObject: compactObject,
	  isSortingDesc: isSortingDesc,
	  normalizeComponent: normalizeComponent,
	  asPx: asPx
	};
	
	
	function get(obj, path, def) {
	  if (!path) {
	    return obj;
	  }
	  var pathObj = makePathArray(path);
	  var val = void 0;
	  try {
	    val = pathObj.reduce(function (current, pathPart) {
	      return current[pathPart];
	    }, obj);
	  } catch (e) {
	    // continue regardless of error
	  }
	  return typeof val !== 'undefined' ? val : def;
	}
	
	function set() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var path = arguments[1];
	  var value = arguments[2];
	
	  var keys = makePathArray(path);
	  var keyPart = void 0;
	  var cursor = obj;
	  while ((keyPart = keys.shift()) && keys.length) {
	    if (!cursor[keyPart]) {
	      cursor[keyPart] = {};
	    }
	    cursor = cursor[keyPart];
	  }
	  cursor[keyPart] = value;
	  return obj;
	}
	
	function takeRight(arr, n) {
	  var start = n > arr.length ? 0 : arr.length - n;
	  return arr.slice(start);
	}
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function range(n) {
	  var arr = [];
	  for (var i = 0; i < n; i += 1) {
	    arr.push(n);
	  }
	  return arr;
	}
	
	function orderBy(arr, funcs, dirs, indexKey) {
	  return arr.sort(function (rowA, rowB) {
	    for (var i = 0; i < funcs.length; i += 1) {
	      var comp = funcs[i];
	      var desc = dirs[i] === false || dirs[i] === 'desc';
	      var sortInt = comp(rowA, rowB);
	      if (sortInt) {
	        return desc ? -sortInt : sortInt;
	      }
	    }
	    // Use the row index for tie breakers
	    return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
	  });
	}
	
	function remove(a, b) {
	  return a.filter(function (o, i) {
	    var r = b(o);
	    if (r) {
	      a.splice(i, 1);
	      return true;
	    }
	    return false;
	  });
	}
	
	function clone(a) {
	  try {
	    return JSON.parse(JSON.stringify(a, function (key, value) {
	      if (typeof value === 'function') {
	        return value.toString();
	      }
	      return value;
	    }));
	  } catch (e) {
	    return a;
	  }
	}
	
	function getFirstDefined() {
	  for (var i = 0; i < arguments.length; i += 1) {
	    if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') {
	      return arguments.length <= i ? undefined : arguments[i];
	    }
	  }
	}
	
	function sum(arr) {
	  return arr.reduce(function (a, b) {
	    return a + b;
	  }, 0);
	}
	
	function makeTemplateComponent(compClass, displayName) {
	  if (!displayName) {
	    throw new Error('No displayName found for template component:', compClass);
	  }
	  var cmp = function cmp(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        rest = _objectWithoutProperties(_ref, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)(compClass, className) }, rest),
	      children
	    );
	  };
	  cmp.displayName = displayName;
	  return cmp;
	}
	
	function groupBy(xs, key) {
	  return xs.reduce(function (rv, x, i) {
	    var resKey = typeof key === 'function' ? key(x, i) : x[key];
	    rv[resKey] = isArray(rv[resKey]) ? rv[resKey] : [];
	    rv[resKey].push(x);
	    return rv;
	  }, {});
	}
	
	function asPx(value) {
	  value = Number(value);
	  return Number.isNaN(value) ? null : value + 'px';
	}
	
	function isArray(a) {
	  return Array.isArray(a);
	}
	
	// ########################################################################
	// Non-exported Helpers
	// ########################################################################
	
	function makePathArray(obj) {
	  return flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
	}
	
	function flattenDeep(arr) {
	  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (!isArray(arr)) {
	    newArr.push(arr);
	  } else {
	    for (var i = 0; i < arr.length; i += 1) {
	      flattenDeep(arr[i], newArr);
	    }
	  }
	  return newArr;
	}
	
	function splitProps(_ref2) {
	  var className = _ref2.className,
	      style = _ref2.style,
	      rest = _objectWithoutProperties(_ref2, ['className', 'style']);
	
	  return {
	    className: className,
	    style: style,
	    rest: rest || {}
	  };
	}
	
	function compactObject(obj) {
	  var newObj = {};
	  if (obj) {
	    Object.keys(obj).map(function (key) {
	      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') {
	        newObj[key] = obj[key];
	      }
	      return true;
	    });
	  }
	  return newObj;
	}
	
	function isSortingDesc(d) {
	  return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
	}
	
	function normalizeComponent(Comp) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;
	
	  return typeof Comp === 'function' ? _react2.default.createElement(Comp, params) : fallback;
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _reactTransitionGroup = __webpack_require__(151);
	
	var _utils = __webpack_require__(5);
	
	var CarouselItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.state = {
	      startAnimation: false
	    };
	    _this.onEnter = _this.onEnter.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onEntering = _this.onEntering.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExit = _this.onExit.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExiting = _this.onExiting.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExited = _this.onExited.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = CarouselItem.prototype;
	
	  _proto.onEnter = function onEnter(node, isAppearing) {
	    this.setState({
	      startAnimation: false
	    });
	    this.props.onEnter(node, isAppearing);
	  };
	
	  _proto.onEntering = function onEntering(node, isAppearing) {
	    // getting this variable triggers a reflow
	    var offsetHeight = node.offsetHeight;
	    this.setState({
	      startAnimation: true
	    });
	    this.props.onEntering(node, isAppearing);
	    return offsetHeight;
	  };
	
	  _proto.onExit = function onExit(node) {
	    this.setState({
	      startAnimation: false
	    });
	    this.props.onExit(node);
	  };
	
	  _proto.onExiting = function onExiting(node) {
	    this.setState({
	      startAnimation: true
	    });
	    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
	    this.props.onExiting(node);
	  };
	
	  _proto.onExited = function onExited(node) {
	    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
	    this.props.onExited(node);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        isIn = _this$props.in,
	        children = _this$props.children,
	        cssModule = _this$props.cssModule,
	        slide = _this$props.slide,
	        Tag = _this$props.tag,
	        className = _this$props.className,
	        transitionProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["in", "children", "cssModule", "slide", "tag", "className"]);
	    return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
	      enter: slide,
	      exit: slide,
	      in: isIn,
	      onEnter: this.onEnter,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }), function (status) {
	      var direction = _this2.context.direction;
	      var isActive = status === _utils.TransitionStatuses.ENTERED || status === _utils.TransitionStatuses.EXITING;
	      var directionClassName = (status === _utils.TransitionStatuses.ENTERING || status === _utils.TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
	      var orderClassName = status === _utils.TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
	      var itemClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
	      return _react.default.createElement(Tag, {
	        className: itemClasses
	      }, children);
	    });
	  };
	
	  return CarouselItem;
	}(_react.default.Component);
	
	CarouselItem.propTypes = (0, _objectSpread2.default)({}, _reactTransitionGroup.Transition.propTypes, {
	  tag: _utils.tagPropType,
	  in: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  slide: _propTypes.default.bool,
	  className: _propTypes.default.string
	});
	CarouselItem.defaultProps = (0, _objectSpread2.default)({}, _reactTransitionGroup.Transition.defaultProps, {
	  tag: 'div',
	  timeout: _utils.TransitionTimeouts.Carousel,
	  slide: true
	});
	CarouselItem.contextTypes = {
	  direction: _propTypes.default.string
	};
	var _default = CarouselItem;
	exports.default = _default;

/***/ },
/* 149 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerContext = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(107));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(761));
	
	var ManagerContext = (0, _createReactContext.default)({
	  setReferenceNode: undefined,
	  referenceNode: undefined
	});
	exports.ManagerContext = ManagerContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    _this = _React$Component.call(this) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setReferenceNode", function (referenceNode) {
	      if (!referenceNode || _this.state.context.referenceNode === referenceNode) {
	        return;
	      }
	
	      _this.setState(function (_ref) {
	        var context = _ref.context;
	        return {
	          context: (0, _extends2.default)({}, context, {
	            referenceNode: referenceNode
	          })
	        };
	      });
	    });
	    _this.state = {
	      context: {
	        setReferenceNode: _this.setReferenceNode,
	        referenceNode: undefined
	      }
	    };
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.render = function render() {
	    return React.createElement(ManagerContext.Provider, {
	      value: this.state.context
	    }, this.props.children);
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(766));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(767));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(262));
	
	var _Transition = _interopRequireDefault(__webpack_require__(261));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ValidationError;
	
	var _printValue = __webpack_require__(153);
	
	var _printValue2 = _interopRequireDefault(_printValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var strReg = /\$\{\s*(\w+)\s*\}/g;
	
	var replace = function replace(str) {
	  return function (params) {
	    return str.replace(strReg, function (_, key) {
	      return (0, _printValue2.default)(params[key]);
	    });
	  };
	};
	
	function ValidationError(errors, value, field, type) {
	  var _this = this;
	
	  this.name = 'ValidationError';
	  this.value = value;
	  this.path = field;
	  this.type = type;
	  this.errors = [];
	  this.inner = [];
	
	  if (errors) [].concat(errors).forEach(function (err) {
	    _this.errors = _this.errors.concat(err.errors || err);
	
	    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
	  });
	
	  this.message = this.errors.length > 1 ? this.errors.length + ' errors occurred' : this.errors[0];
	
	  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
	}
	
	ValidationError.prototype = Object.create(Error.prototype);
	ValidationError.prototype.constructor = ValidationError;
	
	ValidationError.isError = function (err) {
	  return err && err.name === 'ValidationError';
	};
	
	ValidationError.formatError = function (message, params) {
	
	  if (typeof message === 'string') message = replace(message);
	
	  var fn = function fn(_ref) {
	    var path = _ref.path,
	        label = _ref.label,
	        params = _objectWithoutProperties(_ref, ['path', 'label']);
	
	    params.path = label || path || 'this';
	    return typeof message === 'function' ? message(params) : message;
	  };
	
	  return arguments.length === 1 ? fn : fn(params);
	};
	module.exports = exports['default'];

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = printValue;
	
	var _isFunction = __webpack_require__(117);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isSymbol = __webpack_require__(118);
	
	var _isSymbol2 = _interopRequireDefault(_isSymbol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toString = Object.prototype.toString;
	var toISOString = Date.prototype.toISOString;
	var errorToString = Error.prototype.toString;
	var regExpToString = RegExp.prototype.toString;
	var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
	  return '';
	};
	
	var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
	
	function printNumber(val) {
	  if (val != +val) return 'NaN';
	  var isNegativeZero = val === 0 && 1 / val < 0;
	  return isNegativeZero ? '-0' : '' + val;
	}
	
	function printFunction(val) {
	  return '[Function ' + (val.name || 'anonymous') + ']';
	}
	
	function printSymbol(val) {
	  return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
	}
	
	function printError(val) {
	  return '[' + errorToString.call(val) + ']';
	}
	
	function printSimpleValue(val) {
	  var quoteStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (val === true || val === false) return '' + val;
	  if (val === undefined) return 'undefined';
	  if (val === null) return 'null';
	
	  var typeOf = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	
	  if (typeOf === 'number') return printNumber(val);
	  if (typeOf === 'string') return quoteStrings ? '"' + val + '"' : val;
	  if ((0, _isFunction2.default)(val)) return printFunction(val);
	  if ((0, _isSymbol2.default)(val)) return printSymbol(val);
	
	  var tag = toString.call(val);
	  if (tag === '[object Date]') return isNaN(val.getTime()) ? String(val) : toISOString.call(val);
	  if (tag === '[object Error]' || val instanceof Error) return printError(val);
	  if (tag === '[object RegExp]') return regExpToString.call(val);
	
	  return null;
	}
	
	function printValue(value, quoteStrings) {
	  var result = printSimpleValue(value, quoteStrings);
	  if (result !== null) return result;
	
	  return JSON.stringify(value, function (key, value) {
	    var result = printSimpleValue(this[key], quoteStrings);
	    if (result !== null) return result;
	    return value;
	  }, 2);
	}
	module.exports = exports['default'];

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.propagateErrors = propagateErrors;
	exports.settled = settled;
	exports.collectErrors = collectErrors;
	exports.default = runValidations;
	
	var _synchronousPromise = __webpack_require__(295);
	
	var _ValidationError = __webpack_require__(152);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var promise = function promise(sync) {
	  return sync ? _synchronousPromise.SynchronousPromise : Promise;
	};
	
	var unwrapError = function unwrapError() {
	  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
	};
	
	function scopeToValue(promises, value, sync) {
	  //console.log('scopeToValue', promises, value)
	  var p = promise(sync).all(promises);
	
	  //console.log('scopeToValue B', p)
	
	  var b = p.catch(function (err) {
	    if (err.name === 'ValidationError') err.value = value;
	    throw err;
	  });
	  //console.log('scopeToValue c', b)
	  var c = b.then(function () {
	    return value;
	  });
	  //console.log('scopeToValue d', c)
	  return c;
	}
	
	/**
	 * If not failing on the first error, catch the errors
	 * and collect them in an array
	 */
	function propagateErrors(endEarly, errors) {
	  return endEarly ? null : function (err) {
	    errors.push(err);
	    return err.value;
	  };
	}
	
	function settled(promises, sync) {
	  var settle = function settle(promise) {
	    return promise.then(function (value) {
	      return { fulfilled: true, value: value };
	    }, function (value) {
	      return { fulfilled: false, value: value };
	    });
	  };
	
	  return promise(sync).all(promises.map(settle));
	}
	
	function collectErrors(_ref) {
	  var validations = _ref.validations,
	      value = _ref.value,
	      path = _ref.path,
	      sync = _ref.sync,
	      errors = _ref.errors,
	      sort = _ref.sort;
	
	  errors = unwrapError(errors);
	  return settled(validations, sync).then(function (results) {
	    var nestedErrors = results.filter(function (r) {
	      return !r.fulfilled;
	    }).reduce(function (arr, _ref2) {
	      var error = _ref2.value;
	
	      // we are only collecting validation errors
	      if (!_ValidationError2.default.isError(error)) {
	        throw error;
	      }
	      return arr.concat(error);
	    }, []);
	
	    if (sort) nestedErrors.sort(sort);
	
	    //show parent errors after the nested ones: name.first, name
	    errors = nestedErrors.concat(errors);
	
	    if (errors.length) throw new _ValidationError2.default(errors, value, path);
	
	    return value;
	  });
	}
	
	function runValidations(_ref3) {
	  var endEarly = _ref3.endEarly,
	      options = _objectWithoutProperties(_ref3, ['endEarly']);
	
	  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);
	
	  return collectErrors(options);
	}

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55),
	    root = __webpack_require__(38);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(861),
	    mapCacheDelete = __webpack_require__(862),
	    mapCacheGet = __webpack_require__(863),
	    mapCacheHas = __webpack_require__(864),
	    mapCacheSet = __webpack_require__(865);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(109),
	    stackClear = __webpack_require__(876),
	    stackDelete = __webpack_require__(877),
	    stackGet = __webpack_require__(878),
	    stackHas = __webpack_require__(879),
	    stackSet = __webpack_require__(880);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(801),
	    keys = __webpack_require__(68);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(112),
	    toKey = __webpack_require__(81);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(813),
	    baseMatchesProperty = __webpack_require__(814),
	    identity = __webpack_require__(292),
	    isArray = __webpack_require__(35),
	    property = __webpack_require__(901);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(265);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(793),
	    stubArray = __webpack_require__(294);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(35),
	    isSymbol = __webpack_require__(118);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 167 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(278);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)(module)))

/***/ },
/* 169 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(804),
	    isObjectLike = __webpack_require__(42);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(117),
	    isLength = __webpack_require__(172);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 172 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(810),
	    baseUnary = __webpack_require__(163),
	    nodeUtil = __webpack_require__(168);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	var settle = __webpack_require__(303);
	var buildURL = __webpack_require__(306);
	var parseHeaders = __webpack_require__(312);
	var isURLSameOrigin = __webpack_require__(310);
	var createError = __webpack_require__(177);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(305);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(308);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 175 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 176 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(302);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 178 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc. All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxStore
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _require = __webpack_require__(323);
	
	var EventEmitter = _require.EventEmitter;
	
	var invariant = __webpack_require__(39);
	
	/**
	 * This class represents the most basic functionality for a FluxStore. Do not
	 * extend this store directly; instead extend FluxReduceStore when creating a
	 * new store.
	 */
	
	var FluxStore = (function () {
	  function FluxStore(dispatcher) {
	    var _this = this;
	
	    _classCallCheck(this, FluxStore);
	
	    this.__className = this.constructor.name;
	
	    this.__changed = false;
	    this.__changeEvent = 'change';
	    this.__dispatcher = dispatcher;
	    this.__emitter = new EventEmitter();
	    this._dispatchToken = dispatcher.register(function (payload) {
	      _this.__invokeOnDispatch(payload);
	    });
	  }
	
	  FluxStore.prototype.addListener = function addListener(callback) {
	    return this.__emitter.addListener(this.__changeEvent, callback);
	  };
	
	  FluxStore.prototype.getDispatcher = function getDispatcher() {
	    return this.__dispatcher;
	  };
	
	  /**
	   * This exposes a unique string to identify each store's registered callback.
	   * This is used with the dispatcher's waitFor method to declaratively depend
	   * on other stores updating themselves first.
	   */
	
	  FluxStore.prototype.getDispatchToken = function getDispatchToken() {
	    return this._dispatchToken;
	  };
	
	  /**
	   * Returns whether the store has changed during the most recent dispatch.
	   */
	
	  FluxStore.prototype.hasChanged = function hasChanged() {
	    !this.__dispatcher.isDispatching() ?  false ? invariant(false, '%s.hasChanged(): Must be invoked while dispatching.', this.__className) : invariant(false) : undefined;
	    return this.__changed;
	  };
	
	  FluxStore.prototype.__emitChange = function __emitChange() {
	    !this.__dispatcher.isDispatching() ?  false ? invariant(false, '%s.__emitChange(): Must be invoked while dispatching.', this.__className) : invariant(false) : undefined;
	    this.__changed = true;
	  };
	
	  /**
	   * This method encapsulates all logic for invoking __onDispatch. It should
	   * be used for things like catching changes and emitting them after the
	   * subclass has handled a payload.
	   */
	
	  FluxStore.prototype.__invokeOnDispatch = function __invokeOnDispatch(payload) {
	    this.__changed = false;
	    this.__onDispatch(payload);
	    if (this.__changed) {
	      this.__emitter.emit(this.__changeEvent);
	    }
	  };
	
	  /**
	   * The callback that will be registered with the dispatcher during
	   * instantiation. Subclasses must override this method. This callback is the
	   * only way the store receives new data.
	   */
	
	  FluxStore.prototype.__onDispatch = function __onDispatch(payload) {
	     true ?  false ? invariant(false, '%s has not overridden FluxStore.__onDispatch(), which is required', this.__className) : invariant(false) : undefined;
	  };
	
	  return FluxStore;
	})();
	
	module.exports = FluxStore;
	
	// private
	
	// protected, available to subclasses

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxStoreGroup
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(39);
	
	/**
	 * FluxStoreGroup allows you to execute a callback on every dispatch after
	 * waiting for each of the given stores.
	 */
	
	var FluxStoreGroup = (function () {
	  function FluxStoreGroup(stores, callback) {
	    var _this = this;
	
	    _classCallCheck(this, FluxStoreGroup);
	
	    this._dispatcher = _getUniformDispatcher(stores);
	
	    // Precompute store tokens.
	    var storeTokens = stores.map(function (store) {
	      return store.getDispatchToken();
	    });
	
	    // Register with the dispatcher.
	    this._dispatchToken = this._dispatcher.register(function (payload) {
	      _this._dispatcher.waitFor(storeTokens);
	      callback();
	    });
	  }
	
	  FluxStoreGroup.prototype.release = function release() {
	    this._dispatcher.unregister(this._dispatchToken);
	  };
	
	  return FluxStoreGroup;
	})();
	
	function _getUniformDispatcher(stores) {
	  !(stores && stores.length) ?  false ? invariant(false, 'Must provide at least one store to FluxStoreGroup') : invariant(false) : undefined;
	  var dispatcher = stores[0].getDispatcher();
	  if (false) {
	    for (var _iterator = stores, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var store = _ref;
	
	      !(store.getDispatcher() === dispatcher) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'All stores in a FluxStoreGroup must use the same dispatcher') : invariant(false) : undefined;
	    }
	  }
	  return dispatcher;
	}
	
	module.exports = FluxStoreGroup;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 * 
	 * @providesModule EmitterSubscription
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventSubscription = __webpack_require__(325);
	
	/**
	 * EmitterSubscription represents a subscription with listener and context data.
	 */
	
	var EmitterSubscription = (function (_EventSubscription) {
	  _inherits(EmitterSubscription, _EventSubscription);
	
	  /**
	   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
	   *   this subscription
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  function EmitterSubscription(subscriber, listener, context) {
	    _classCallCheck(this, EmitterSubscription);
	
	    _EventSubscription.call(this, subscriber);
	    this.listener = listener;
	    this.context = context;
	  }
	
	  return EmitterSubscription;
	})(EventSubscription);
	
	module.exports = EmitterSubscription;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**                                                                            
	 * MUI React Input Component
	 * @module react/input
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	var _textfieldHelpers = __webpack_require__(332);
	
	/**
	 * Input constructor
	 * @class
	 */
	var Input = (0, _textfieldHelpers.textfieldWrapper)(function (props) {
	  var inputRef = props.inputRef,
	      rest = babelHelpers.objectWithoutProperties(props, ["inputRef"]);
	  return _react["default"].createElement("input", babelHelpers["extends"]({
	    ref: inputRef
	  }, rest));
	});
	/** Module API */
	
	var _default = Input;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 183 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appendPxIfNeeded;
	
	
	// Copied from https://github.com/facebook/react/blob/
	// 102cd291899f9942a76c40a0e78920a6fe544dc1/
	// src/renderers/dom/shared/CSSProperty.js
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	function appendPxIfNeeded(propertyName, value) {
	  var needsPxSuffix = !isUnitlessNumber[propertyName] && typeof value === 'number' && value !== 0;
	  return needsPxSuffix ? value + 'px' : value;
	}
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = enhanceWithRadium;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styleKeeper = __webpack_require__(125);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	var _resolveStyles = __webpack_require__(190);
	
	var _resolveStyles2 = _interopRequireDefault(_resolveStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];
	
	function copyProperties(source, target) {
	  Object.getOwnPropertyNames(source).forEach(function (key) {
	    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
	      var descriptor = Object.getOwnPropertyDescriptor(source, key);
	      Object.defineProperty(target, key, descriptor);
	    }
	  });
	}
	
	function isStateless(component) {
	  return !component.render && !(component.prototype && component.prototype.render);
	}
	
	// Check if value is a real ES class in Native / Node code.
	// See: https://stackoverflow.com/a/30760236
	function isNativeClass(component) {
	  return typeof component === 'function' && /^\s*class\s+/.test(component.toString());
	}
	
	// Manually apply babel-ish class inheritance.
	function inherits(subClass, superClass) {
	  if (typeof superClass !== 'function' && superClass !== null) {
	    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (superClass) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(subClass, superClass);
	    } else {
	      subClass.__proto__ = superClass; // eslint-disable-line no-proto
	    }
	  }
	}
	
	function enhanceWithRadium(configOrComposedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof configOrComposedComponent !== 'function') {
	    var newConfig = _extends({}, config, configOrComposedComponent);
	    return function (configOrComponent) {
	      return enhanceWithRadium(configOrComponent, newConfig);
	    };
	  }
	
	  var component = configOrComposedComponent;
	  var ComposedComponent = component;
	
	  // Handle Native ES classes.
	  if (isNativeClass(ComposedComponent)) {
	    // Manually approximate babel's class transpilation, but _with_ a real `new` call.
	    ComposedComponent = function (OrigComponent) {
	      function NewComponent() {
	        // Ordinarily, babel would produce something like:
	        //
	        // ```
	        // return _possibleConstructorReturn(this, OrigComponent.apply(this, arguments));
	        // ```
	        //
	        // Instead, we just call `new` directly without the `_possibleConstructorReturn` wrapper.
	        var source = new (Function.prototype.bind.apply(OrigComponent, [null].concat(Array.prototype.slice.call(arguments))))();
	
	        // Then we manually update context with properties.
	        copyProperties(source, this);
	
	        return this;
	      }
	
	      inherits(NewComponent, OrigComponent);
	
	      return NewComponent;
	    }(ComposedComponent);
	  }
	
	  // Handle stateless components
	  if (isStateless(ComposedComponent)) {
	    ComposedComponent = function (_Component) {
	      _inherits(ComposedComponent, _Component);
	
	      function ComposedComponent() {
	        _classCallCheck(this, ComposedComponent);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ComposedComponent.prototype.render = function render() {
	        return component(this.props, this.context);
	      };
	
	      return ComposedComponent;
	    }(_react.Component);
	
	    ComposedComponent.displayName = component.displayName || component.name;
	  }
	
	  var RadiumEnhancer = (_temp = _class = function (_ComposedComponent) {
	    _inherits(RadiumEnhancer, _ComposedComponent);
	
	    function RadiumEnhancer() {
	      _classCallCheck(this, RadiumEnhancer);
	
	      var _this2 = _possibleConstructorReturn(this, _ComposedComponent.apply(this, arguments));
	
	      _this2.state = _this2.state || {};
	      _this2.state._radiumStyleState = {};
	      _this2._radiumIsMounted = true;
	      return _this2;
	    }
	
	    RadiumEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (_ComposedComponent.prototype.componentWillUnmount) {
	        _ComposedComponent.prototype.componentWillUnmount.call(this);
	      }
	
	      this._radiumIsMounted = false;
	
	      if (this._radiumMouseUpListener) {
	        this._radiumMouseUpListener.remove();
	      }
	
	      if (this._radiumMediaQueryListenersByQuery) {
	        Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
	          this._radiumMediaQueryListenersByQuery[query].remove();
	        }, this);
	      }
	    };
	
	    RadiumEnhancer.prototype.getChildContext = function getChildContext() {
	      var superChildContext = _ComposedComponent.prototype.getChildContext ? _ComposedComponent.prototype.getChildContext.call(this) : {};
	
	      if (!this.props.radiumConfig) {
	        return superChildContext;
	      }
	
	      var newContext = _extends({}, superChildContext);
	
	      if (this.props.radiumConfig) {
	        newContext._radiumConfig = this.props.radiumConfig;
	      }
	
	      return newContext;
	    };
	
	    RadiumEnhancer.prototype.render = function render() {
	      var renderedElement = _ComposedComponent.prototype.render.call(this);
	      var currentConfig = this.props.radiumConfig || this.context._radiumConfig || config;
	
	      if (config && currentConfig !== config) {
	        currentConfig = _extends({}, config, currentConfig);
	      }
	
	      return (0, _resolveStyles2.default)(this, renderedElement, currentConfig);
	    };
	
	    return RadiumEnhancer;
	  }(ComposedComponent), _class._isRadiumEnhanced = true, _temp);
	
	  // Class inheritance uses Object.create and because of __proto__ issues
	  // with IE <10 any static properties of the superclass aren't inherited and
	  // so need to be manually populated.
	  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
	
	  copyProperties(component, RadiumEnhancer);
	
	  if (false) {
	    // This also fixes React Hot Loader by exposing the original components top
	    // level prototype methods on the Radium enhanced prototype as discussed in
	    // https://github.com/FormidableLabs/radium/issues/219.
	    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
	  }
	
	  if (RadiumEnhancer.propTypes && RadiumEnhancer.propTypes.style) {
	    RadiumEnhancer.propTypes = _extends({}, RadiumEnhancer.propTypes, {
	      style: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
	    });
	  }
	
	  RadiumEnhancer.displayName = component.displayName || component.name || 'Component';
	
	  RadiumEnhancer.contextTypes = _extends({}, RadiumEnhancer.contextTypes, {
	    _radiumConfig: _propTypes2.default.object,
	    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	  });
	
	  RadiumEnhancer.childContextTypes = _extends({}, RadiumEnhancer.childContextTypes, {
	    _radiumConfig: _propTypes2.default.object,
	    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	  });
	
	  return RadiumEnhancer;
	}
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getStateKey = function getStateKey(elementKey) {
	  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
	};
	
	exports.default = getStateKey;
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getStateKey = __webpack_require__(185);
	
	var _getStateKey2 = _interopRequireDefault(_getStateKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getState = function getState(state, elementKey, value) {
	  var key = (0, _getStateKey2.default)(elementKey);
	
	  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
	};
	
	exports.default = getState;
	module.exports = exports['default'];

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hash;
	
	
	// a simple djb2 hash based on hash-string:
	// https://github.com/MatthewBarker/hash-string/blob/master/source/hash-string.js
	// returns a hex-encoded hash
	function hash(text) {
	  if (!text) {
	    return '';
	  }
	
	  var hashValue = 5381;
	  var index = text.length - 1;
	
	  while (index) {
	    hashValue = hashValue * 33 ^ text.charCodeAt(index);
	    index -= 1;
	  }
	
	  return (hashValue >>> 0).toString(16);
	}
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapObject;
	function mapObject(object, mapper) {
	  return Object.keys(object).reduce(function (result, key) {
	    result[key] = mapper(object[key], key);
	    return result;
	  }, {});
	}
	module.exports = exports["default"];

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkPropsPlugin = __webpack_require__(350);
	
	var _checkPropsPlugin2 = _interopRequireDefault(_checkPropsPlugin);
	
	var _keyframesPlugin = __webpack_require__(351);
	
	var _keyframesPlugin2 = _interopRequireDefault(_keyframesPlugin);
	
	var _mergeStyleArrayPlugin = __webpack_require__(352);
	
	var _mergeStyleArrayPlugin2 = _interopRequireDefault(_mergeStyleArrayPlugin);
	
	var _prefixPlugin = __webpack_require__(354);
	
	var _prefixPlugin2 = _interopRequireDefault(_prefixPlugin);
	
	var _removeNestedStylesPlugin = __webpack_require__(355);
	
	var _removeNestedStylesPlugin2 = _interopRequireDefault(_removeNestedStylesPlugin);
	
	var _resolveInteractionStylesPlugin = __webpack_require__(356);
	
	var _resolveInteractionStylesPlugin2 = _interopRequireDefault(_resolveInteractionStylesPlugin);
	
	var _resolveMediaQueriesPlugin = __webpack_require__(357);
	
	var _resolveMediaQueriesPlugin2 = _interopRequireDefault(_resolveMediaQueriesPlugin);
	
	var _visitedPlugin = __webpack_require__(358);
	
	var _visitedPlugin2 = _interopRequireDefault(_visitedPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  checkProps: _checkPropsPlugin2.default,
	  keyframes: _keyframesPlugin2.default,
	  mergeStyleArray: _mergeStyleArrayPlugin2.default,
	  prefix: _prefixPlugin2.default,
	  removeNestedStyles: _removeNestedStylesPlugin2.default,
	  resolveInteractionStyles: _resolveInteractionStylesPlugin2.default,
	  resolveMediaQueries: _resolveMediaQueriesPlugin2.default,
	  visited: _visitedPlugin2.default
	};
	/* eslint-disable block-scoped-const */
	
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _appendImportantToEachValue = __webpack_require__(343);
	
	var _appendImportantToEachValue2 = _interopRequireDefault(_appendImportantToEachValue);
	
	var _cssRuleSetToString = __webpack_require__(123);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _getState = __webpack_require__(186);
	
	var _getState2 = _interopRequireDefault(_getState);
	
	var _getStateKey = __webpack_require__(185);
	
	var _getStateKey2 = _interopRequireDefault(_getStateKey);
	
	var _hash = __webpack_require__(187);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _mergeStyles = __webpack_require__(349);
	
	var _plugins = __webpack_require__(189);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _exenv = __webpack_require__(359);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_CONFIG = {
	  plugins: [_plugins2.default.mergeStyleArray, _plugins2.default.checkProps, _plugins2.default.resolveMediaQueries, _plugins2.default.resolveInteractionStyles, _plugins2.default.keyframes, _plugins2.default.visited, _plugins2.default.removeNestedStyles, _plugins2.default.prefix, _plugins2.default.checkProps]
	};
	
	// Gross
	var globalState = {};
	
	// Declare early for recursive helpers.
	var resolveStyles = null;
	
	var _shouldResolveStyles = function _shouldResolveStyles(component) {
	  return component.type && !component.type._isRadiumEnhanced;
	};
	
	var _resolveChildren = function _resolveChildren(_ref) {
	  var children = _ref.children,
	      component = _ref.component,
	      config = _ref.config,
	      existingKeyMap = _ref.existingKeyMap;
	
	  if (!children) {
	    return children;
	  }
	
	  var childrenType = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
	  if (childrenType === 'string' || childrenType === 'number') {
	    // Don't do anything with a single primitive child
	    return children;
	  }
	
	  if (childrenType === 'function') {
	    // Wrap the function, resolving styles on the result
	    return function () {
	      var result = children.apply(this, arguments);
	      if (_react2.default.isValidElement(result)) {
	        return resolveStyles(component, result, config, existingKeyMap, true);
	      }
	      return result;
	    };
	  }
	
	  if (_react2.default.Children.count(children) === 1 && children.type) {
	    // If a React Element is an only child, don't wrap it in an array for
	    // React.Children.map() for React.Children.only() compatibility.
	    var onlyChild = _react2.default.Children.only(children);
	    return resolveStyles(component, onlyChild, config, existingKeyMap, true);
	  }
	
	  return _react2.default.Children.map(children, function (child) {
	    if (_react2.default.isValidElement(child)) {
	      return resolveStyles(component, child, config, existingKeyMap, true);
	    }
	
	    return child;
	  });
	};
	
	// Recurse over props, just like children
	var _resolveProps = function _resolveProps(_ref2) {
	  var component = _ref2.component,
	      config = _ref2.config,
	      existingKeyMap = _ref2.existingKeyMap,
	      props = _ref2.props;
	
	  var newProps = props;
	
	  Object.keys(props).forEach(function (prop) {
	    // We already recurse over children above
	    if (prop === 'children') {
	      return;
	    }
	
	    var propValue = props[prop];
	    if (_react2.default.isValidElement(propValue)) {
	      newProps = _extends({}, newProps);
	      newProps[prop] = resolveStyles(component, propValue, config, existingKeyMap, true);
	    }
	  });
	
	  return newProps;
	};
	
	var _buildGetKey = function _buildGetKey(_ref3) {
	  var componentName = _ref3.componentName,
	      existingKeyMap = _ref3.existingKeyMap,
	      renderedElement = _ref3.renderedElement;
	
	  // We need a unique key to correlate state changes due to user interaction
	  // with the rendered element, so we know to apply the proper interactive
	  // styles.
	  var originalKey = typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
	  var key = (0, _getStateKey2.default)(originalKey);
	
	  var alreadyGotKey = false;
	  var getKey = function getKey() {
	    if (alreadyGotKey) {
	      return key;
	    }
	
	    alreadyGotKey = true;
	
	    if (existingKeyMap[key]) {
	      var elementName = void 0;
	      if (typeof renderedElement.type === 'string') {
	        elementName = renderedElement.type;
	      } else if (renderedElement.type.constructor) {
	        elementName = renderedElement.type.constructor.displayName || renderedElement.type.constructor.name;
	      }
	
	      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.') + ' ' + 'Component: "' + componentName + '". ' + (elementName ? 'Element: "' + elementName + '".' : ''));
	    }
	
	    existingKeyMap[key] = true;
	
	    return key;
	  };
	
	  return getKey;
	};
	
	var _setStyleState = function _setStyleState(component, key, stateKey, value) {
	  if (!component._radiumIsMounted) {
	    return;
	  }
	
	  var existing = component._lastRadiumState || component.state && component.state._radiumStyleState || {};
	
	  var state = { _radiumStyleState: _extends({}, existing) };
	  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
	  state._radiumStyleState[key][stateKey] = value;
	
	  component._lastRadiumState = state._radiumStyleState;
	  component.setState(state);
	};
	
	var _runPlugins = function _runPlugins(_ref4) {
	  var component = _ref4.component,
	      config = _ref4.config,
	      existingKeyMap = _ref4.existingKeyMap,
	      props = _ref4.props,
	      renderedElement = _ref4.renderedElement;
	
	  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
	  // no style.
	  if (!_react2.default.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
	    return props;
	  }
	
	  var newProps = props;
	
	  var plugins = config.plugins || DEFAULT_CONFIG.plugins;
	
	  var componentName = component.constructor.displayName || component.constructor.name;
	  var getKey = _buildGetKey({
	    renderedElement: renderedElement,
	    existingKeyMap: existingKeyMap,
	    componentName: componentName
	  });
	  var getComponentField = function getComponentField(key) {
	    return component[key];
	  };
	  var getGlobalState = function getGlobalState(key) {
	    return globalState[key];
	  };
	  var componentGetState = function componentGetState(stateKey, elementKey) {
	    return (0, _getState2.default)(component.state, elementKey || getKey(), stateKey);
	  };
	  var setState = function setState(stateKey, value, elementKey) {
	    return _setStyleState(component, elementKey || getKey(), stateKey, value);
	  };
	
	  var addCSS = function addCSS(css) {
	    var styleKeeper = component._radiumStyleKeeper || component.context._radiumStyleKeeper;
	    if (!styleKeeper) {
	      if (__isTestModeEnabled) {
	        return {
	          remove: function remove() {}
	        };
	      }
	
	      throw new Error('To use plugins requiring `addCSS` (e.g. keyframes, media queries), ' + 'please wrap your application in the StyleRoot component. Component ' + 'name: `' + componentName + '`.');
	    }
	
	    return styleKeeper.addCSS(css);
	  };
	
	  var newStyle = props.style;
	
	  plugins.forEach(function (plugin) {
	    var result = plugin({
	      ExecutionEnvironment: _exenv2.default,
	      addCSS: addCSS,
	      appendImportantToEachValue: _appendImportantToEachValue2.default,
	      componentName: componentName,
	      config: config,
	      cssRuleSetToString: _cssRuleSetToString2.default,
	      getComponentField: getComponentField,
	      getGlobalState: getGlobalState,
	      getState: componentGetState,
	      hash: _hash2.default,
	      mergeStyles: _mergeStyles.mergeStyles,
	      props: newProps,
	      setState: setState,
	      isNestedStyle: _mergeStyles.isNestedStyle,
	      style: newStyle
	    }) || {};
	
	    newStyle = result.style || newStyle;
	
	    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;
	
	    var newComponentFields = result.componentFields || {};
	    Object.keys(newComponentFields).forEach(function (fieldName) {
	      component[fieldName] = newComponentFields[fieldName];
	    });
	
	    var newGlobalState = result.globalState || {};
	    Object.keys(newGlobalState).forEach(function (key) {
	      globalState[key] = newGlobalState[key];
	    });
	  });
	
	  if (newStyle !== props.style) {
	    newProps = _extends({}, newProps, { style: newStyle });
	  }
	
	  return newProps;
	};
	
	// Wrapper around React.cloneElement. To avoid processing the same element
	// twice, whenever we clone an element add a special prop to make sure we don't
	// process this element again.
	var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
	  // Only add flag if this is a normal DOM element
	  if (typeof renderedElement.type === 'string') {
	    newProps = _extends({}, newProps, { 'data-radium': true });
	  }
	
	  return _react2.default.cloneElement(renderedElement, newProps, newChildren);
	};
	
	//
	// The nucleus of Radium. resolveStyles is called on the rendered elements
	// before they are returned in render. It iterates over the elements and
	// children, rewriting props to add event handlers required to capture user
	// interactions (e.g. mouse over). It also replaces the style prop because it
	// adds in the various interaction styles (e.g. :hover).
	//
	resolveStyles = function resolveStyles(component, // ReactComponent, flow+eslint complaining
	renderedElement) {
	  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONFIG;
	  var existingKeyMap = arguments[3];
	  var shouldCheckBeforeResolve = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // ReactElement
	  existingKeyMap = existingKeyMap || {};
	  if (!renderedElement ||
	  // Bail if we've already processed this element. This ensures that only the
	  // owner of an element processes that element, since the owner's render
	  // function will be called first (which will always be the case, since you
	  // can't know what else to render until you render the parent component).
	  renderedElement.props && renderedElement.props['data-radium'] ||
	  // Bail if this element is a radium enhanced element, because if it is,
	  // then it will take care of resolving its own styles.
	  shouldCheckBeforeResolve && !_shouldResolveStyles(renderedElement)) {
	    return renderedElement;
	  }
	
	  var newChildren = _resolveChildren({
	    children: renderedElement.props.children,
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap
	  });
	
	  var newProps = _resolveProps({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: renderedElement.props
	  });
	
	  newProps = _runPlugins({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: newProps,
	    renderedElement: renderedElement
	  });
	
	  // If nothing changed, don't bother cloning the element. Might be a bit
	  // wasteful, as we add the sentinal to stop double-processing when we clone.
	  // Assume benign double-processing is better than unneeded cloning.
	  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
	    return renderedElement;
	  }
	
	  return _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);
	};
	
	// Only for use by tests
	var __isTestModeEnabled = false;
	if (false) {
	  resolveStyles.__clearStateForTests = function () {
	    globalState = {};
	  };
	  resolveStyles.__setTestMode = function (isEnabled) {
	    __isTestModeEnabled = isEnabled;
	  };
	}
	
	exports.default = resolveStyles;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(384);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(2));
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	}
	
	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	function zeroPad(value) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	  var strValue = String(value);
	  if (length === 0) return strValue;
	  var match = strValue.match(/(.*?)([0-9]+)(.*)/);
	  var prefix = match ? match[1] : '';
	  var suffix = match ? match[3] : '';
	  var strNo = match ? match[2] : strValue;
	  var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function () {
	    return '0';
	  }).join('') + strNo).slice(length * -1);
	  return "".concat(prefix).concat(paddedNo).concat(suffix);
	}
	var timeDeltaFormatOptionsDefaults = {
	  daysInHours: false,
	  zeroPadTime: 2
	};
	function calcTimeDelta(date) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$now = _ref.now,
	      now = _ref$now === void 0 ? Date.now : _ref$now,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === void 0 ? 0 : _ref$precision,
	      _ref$controlled = _ref.controlled,
	      controlled = _ref$controlled === void 0 ? false : _ref$controlled,
	      _ref$offsetTime = _ref.offsetTime,
	      offsetTime = _ref$offsetTime === void 0 ? 0 : _ref$offsetTime;
	
	  var startTimestamp;
	
	  if (typeof date === 'string') {
	    startTimestamp = new Date(date).getTime();
	  } else if (date instanceof Date) {
	    startTimestamp = date.getTime();
	  } else {
	    startTimestamp = date;
	  }
	
	  if (!controlled) {
	    startTimestamp += offsetTime;
	  }
	
	  var total = Math.round(parseFloat((Math.max(0, controlled ? startTimestamp : startTimestamp - now()) / 1000).toFixed(Math.max(0, Math.min(20, precision)))) * 1000);
	  var seconds = total / 1000;
	  return {
	    total: total,
	    days: Math.floor(seconds / (3600 * 24)),
	    hours: Math.floor(seconds / 3600 % 24),
	    minutes: Math.floor(seconds / 60 % 60),
	    seconds: Math.floor(seconds % 60),
	    milliseconds: Number((seconds % 1 * 1000).toFixed()),
	    completed: total <= 0
	  };
	}
	function formatTimeDelta(delta, options) {
	  var days = delta.days,
	      hours = delta.hours,
	      minutes = delta.minutes,
	      seconds = delta.seconds;
	
	  var _Object$assign = Object.assign({}, timeDeltaFormatOptionsDefaults, options),
	      daysInHours = _Object$assign.daysInHours,
	      zeroPadTime = _Object$assign.zeroPadTime,
	      _Object$assign$zeroPa = _Object$assign.zeroPadDays,
	      zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;
	
	  var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, Math.min(2, zeroPadTime));
	  return {
	    days: daysInHours ? '' : zeroPad(days, zeroPadDays),
	    hours: formattedHours,
	    minutes: zeroPad(minutes, Math.min(2, zeroPadTime)),
	    seconds: zeroPad(seconds, Math.min(2, zeroPadTime))
	  };
	}
	
	var isEqual = __webpack_require__(387);
	
	var Countdown = function (_React$Component) {
	  _inherits(Countdown, _React$Component);
	
	  function Countdown(props) {
	    var _this;
	
	    _classCallCheck(this, Countdown);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Countdown).call(this, props));
	    _this.mounted = false;
	
	    _this.tick = function () {
	      var onTick = _this.props.onTick;
	
	      var delta = _this.calcTimeDelta();
	
	      _this.setTimeDeltaState(Object.assign({}, delta));
	
	      if (onTick && delta.total > 0) {
	        onTick(delta);
	      }
	    };
	
	    _this.start = function () {
	      _this.setState(function (_ref) {
	        var offsetStart = _ref.offsetStart,
	            offsetTime = _ref.offsetTime;
	        return {
	          offsetStart: 0,
	          offsetTime: offsetTime + (offsetStart ? Date.now() - offsetStart : 0)
	        };
	      }, function () {
	        var timeDelta = _this.calcTimeDelta();
	
	        _this.setTimeDeltaState(timeDelta);
	
	        _this.props.onStart && _this.props.onStart(timeDelta);
	
	        if (!_this.props.controlled) {
	          _this.clearInterval();
	
	          _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
	        }
	      });
	    };
	
	    _this.pause = function () {
	      _this.setState({
	        offsetStart: _this.calcOffsetStart()
	      }, function () {
	        _this.clearInterval();
	
	        _this.props.onPause && _this.props.onPause(_this.calcTimeDelta());
	      });
	    };
	
	    _this.isPaused = function () {
	      return _this.state.offsetStart > 0;
	    };
	
	    _this.isCompleted = function () {
	      return _this.state.timeDelta.completed;
	    };
	
	    _this.state = {
	      timeDelta: _this.calcTimeDelta(),
	      offsetStart: props.autoStart ? 0 : _this.calcOffsetStart(),
	      offsetTime: 0
	    };
	    return _this;
	  }
	
	  _createClass(Countdown, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.props.autoStart && this.start();
	      this.props.onMount && this.props.onMount(this.calcTimeDelta());
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (!isEqual(this.props, prevProps)) {
	        this.setTimeDeltaState(this.calcTimeDelta());
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	      this.clearInterval();
	    }
	  }, {
	    key: "calcTimeDelta",
	    value: function calcTimeDelta$1() {
	      var _this$props = this.props,
	          date = _this$props.date,
	          now = _this$props.now,
	          precision = _this$props.precision,
	          controlled = _this$props.controlled;
	      return calcTimeDelta(date, {
	        now: now,
	        precision: precision,
	        controlled: controlled,
	        offsetTime: this.state ? this.state.offsetTime : 0
	      });
	    }
	  }, {
	    key: "calcOffsetStart",
	    value: function calcOffsetStart() {
	      return Date.now();
	    }
	  }, {
	    key: "clearInterval",
	    value: function clearInterval() {
	      window.clearInterval(this.interval);
	    }
	  }, {
	    key: "setTimeDeltaState",
	    value: function setTimeDeltaState(delta) {
	      var _this2 = this;
	
	      var callback;
	
	      if (!this.state.timeDelta.completed && delta.completed) {
	        this.clearInterval();
	
	        callback = function callback() {
	          return _this2.props.onComplete && _this2.props.onComplete(delta);
	        };
	      }
	
	      if (this.mounted) {
	        return this.setState({
	          timeDelta: delta
	        }, callback);
	      }
	    }
	  }, {
	    key: "getApi",
	    value: function getApi() {
	      return this.api = this.api || {
	        start: this.start,
	        pause: this.pause,
	        isPaused: this.isPaused,
	        isCompleted: this.isCompleted
	      };
	    }
	  }, {
	    key: "getRenderProps",
	    value: function getRenderProps() {
	      var _this$props2 = this.props,
	          daysInHours = _this$props2.daysInHours,
	          zeroPadTime = _this$props2.zeroPadTime,
	          zeroPadDays = _this$props2.zeroPadDays;
	      var timeDelta = this.state.timeDelta;
	      return Object.assign({}, timeDelta, {
	        api: this.getApi(),
	        props: this.props,
	        formatted: formatTimeDelta(timeDelta, {
	          daysInHours: daysInHours,
	          zeroPadTime: zeroPadTime,
	          zeroPadDays: zeroPadDays
	        })
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          renderer = _this$props3.renderer;
	      var renderProps = this.getRenderProps();
	
	      if (renderer) {
	        return renderer(renderProps);
	      }
	
	      if (children && this.state.timeDelta.completed) {
	        return React.cloneElement(children, {
	          countdown: renderProps
	        });
	      }
	
	      var _renderProps$formatte = renderProps.formatted,
	          days = _renderProps$formatte.days,
	          hours = _renderProps$formatte.hours,
	          minutes = _renderProps$formatte.minutes,
	          seconds = _renderProps$formatte.seconds;
	      return React.createElement("span", null, days, days ? ':' : '', hours, ":", minutes, ":", seconds);
	    }
	  }]);
	
	  return Countdown;
	}(React.Component);
	Countdown.defaultProps = Object.assign({}, timeDeltaFormatOptionsDefaults, {
	  controlled: false,
	  intervalDelay: 1000,
	  precision: 0,
	  autoStart: true
	});
	Countdown.propTypes = {
	  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.number]).isRequired,
	  daysInHours: PropTypes.bool,
	  zeroPadTime: PropTypes.number,
	  zeroPadDays: PropTypes.number,
	  controlled: PropTypes.bool,
	  intervalDelay: PropTypes.number,
	  precision: PropTypes.number,
	  autoStart: PropTypes.bool,
	  children: PropTypes.element,
	  renderer: PropTypes.func,
	  now: PropTypes.func,
	  onMount: PropTypes.func,
	  onStart: PropTypes.func,
	  onPause: PropTypes.func,
	  onTick: PropTypes.func,
	  onComplete: PropTypes.func
	};
	
	exports.calcTimeDelta = calcTimeDelta;
	exports.default = Countdown;
	exports.formatTimeDelta = formatTimeDelta;
	exports.zeroPad = zeroPad;


/***/ },
/* 195 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2019, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(911));
	var IntlMessageFormat = _interopDefault(__webpack_require__(197));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(412));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var hoistNonReactStatics = _interopDefault(__webpack_require__(400));
	var invariant = _interopDefault(__webpack_require__(418));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(404));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var locales = Array.isArray(data) ? data : [data];
	
	  locales.forEach(function (localeData) {
	    if (localeData && localeData.locale) {
	      IntlMessageFormat.__addLocaleData(localeData);
	      IntlRelativeFormat.__addLocaleData(localeData);
	    }
	  });
	}
	
	function hasLocaleData(locale) {
	  var localeParts = (locale || '').split('-');
	
	  while (localeParts.length > 0) {
	    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	      return true;
	    }
	
	    localeParts.pop();
	  }
	
	  return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	  var normalizedLocale = locale && locale.toLowerCase();
	
	  return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = PropTypes.bool;
	var number = PropTypes.number;
	var string = PropTypes.string;
	var func = PropTypes.func;
	var object = PropTypes.object;
	var oneOf = PropTypes.oneOf;
	var shape = PropTypes.shape;
	var any = PropTypes.any;
	var oneOfType = PropTypes.oneOfType;
	
	var localeMatcher = oneOf(['best fit', 'lookup']);
	var narrowShortLong = oneOf(['narrow', 'short', 'long']);
	var numeric2digit = oneOf(['numeric', '2-digit']);
	var funcReq = func.isRequired;
	
	var intlConfigPropTypes = {
	  locale: string,
	  timeZone: string,
	  formats: object,
	  messages: object,
	  textComponent: any,
	
	  defaultLocale: string,
	  defaultFormats: object,
	
	  onError: func
	};
	
	var intlFormatPropTypes = {
	  formatDate: funcReq,
	  formatTime: funcReq,
	  formatRelative: funcReq,
	  formatNumber: funcReq,
	  formatPlural: funcReq,
	  formatMessage: funcReq,
	  formatHTMLMessage: funcReq
	};
	
	var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
	  formatters: object,
	  now: funcReq
	}));
	
	var messageDescriptorPropTypes = {
	  id: string.isRequired,
	  description: oneOfType([string, object]),
	  defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	  localeMatcher: localeMatcher,
	  formatMatcher: oneOf(['basic', 'best fit']),
	
	  timeZone: string,
	  hour12: bool,
	
	  weekday: narrowShortLong,
	  era: narrowShortLong,
	  year: numeric2digit,
	  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	  day: numeric2digit,
	  hour: numeric2digit,
	  minute: numeric2digit,
	  second: numeric2digit,
	  timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	  localeMatcher: localeMatcher,
	
	  style: oneOf(['decimal', 'currency', 'percent']),
	  currency: string,
	  currencyDisplay: oneOf(['symbol', 'code', 'name']),
	  useGrouping: bool,
	
	  minimumIntegerDigits: number,
	  minimumFractionDigits: number,
	  maximumFractionDigits: number,
	  minimumSignificantDigits: number,
	  maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	  style: oneOf(['best fit', 'numeric']),
	  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
	};
	
	var pluralFormatPropTypes = {
	  style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  "'": '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	    return ESCAPED_CHARS[match];
	  });
	}
	
	function filterProps(props, whitelist) {
	  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return whitelist.reduce(function (filtered, name) {
	    if (props.hasOwnProperty(name)) {
	      filtered[name] = props[name];
	    } else if (defaults$$1.hasOwnProperty(name)) {
	      filtered[name] = defaults$$1[name];
	    }
	
	    return filtered;
	  }, {});
	}
	
	function invariantIntlContext() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      intl = _ref.intl;
	
	  invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	  var props = _ref2.props,
	      state = _ref2.state,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === undefined ? {} : _ref2$context;
	  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var _context$intl = context.intl,
	      intl = _context$intl === undefined ? {} : _context$intl;
	  var _nextContext$intl = nextContext.intl,
	      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	function createError(message, exception) {
	  var eMsg = exception ? '\n' + exception : '';
	  return '[React Intl] ' + message + eMsg;
	}
	
	function defaultErrorHandler(error) {
	  if (false) {
	    console.error(error);
	  }
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component$$1) {
	  return Component$$1.displayName || Component$$1.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$intlPropName = options.intlPropName,
	      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var InjectIntl = function (_Component) {
	    inherits(InjectIntl, _Component);
	
	    function InjectIntl(props, context) {
	      classCallCheck(this, InjectIntl);
	
	      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	      invariantIntlContext(context);
	      return _this;
	    }
	
	    createClass(InjectIntl, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	        return this._wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return React__default.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	          ref: withRef ? /* istanbul ignore next */function (ref) {
	            return _this2._wrappedInstance = ref;
	          } : null
	        }));
	      }
	    }]);
	    return InjectIntl;
	  }(React.Component);
	
	  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	  InjectIntl.contextTypes = {
	    intl: intlShape
	  };
	  InjectIntl.WrappedComponent = WrappedComponent;
	
	
	  return hoistNonReactStatics(InjectIntl, WrappedComponent);
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	  return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	  return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  classCallCheck(this, IntlPluralFormat);
	
	  var useOrdinal = options.style === 'ordinal';
	  var pluralFn = findPluralFunction(resolveLocale(locales));
	
	  this.format = function (value) {
	    return pluralFn(value, useOrdinal);
	  };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	  second: 60, // seconds to minute
	  minute: 60, // minutes to hour
	  hour: 24, // hours to day
	  day: 30, // days to month
	  month: 12 };
	
	function updateRelativeFormatThresholds(newThresholds) {
	  var thresholds = IntlRelativeFormat.thresholds;
	  thresholds.second = newThresholds.second;
	  thresholds.minute = newThresholds.minute;
	  thresholds.hour = newThresholds.hour;
	  thresholds.day = newThresholds.day;
	  thresholds.month = newThresholds.month;
	  thresholds['second-short'] = newThresholds['second-short'];
	  thresholds['minute-short'] = newThresholds['minute-short'];
	  thresholds['hour-short'] = newThresholds['hour-short'];
	  thresholds['day-short'] = newThresholds['day-short'];
	  thresholds['month-short'] = newThresholds['month-short'];
	}
	
	function getNamedFormat(formats, type, name, onError) {
	  var format = formats && formats[type] && formats[type][name];
	  if (format) {
	    return format;
	  }
	
	  onError(createError('No ' + type + ' format named: ' + name));
	}
	
	function formatDate(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      timeZone = config.timeZone;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    onError(createError('Error formatting date.', e));
	  }
	
	  return String(date);
	}
	
	function formatTime(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      timeZone = config.timeZone;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	    // Add default formatting options if hour, minute, or second isn't defined.
	    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	  }
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    onError(createError('Error formatting time.', e));
	  }
	
	  return String(date);
	}
	
	function formatRelative(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var now = new Date(options.now);
	  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
	  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
	
	  // Capture the current threshold values, then temporarily override them with
	  // specific values just for this render.
	  var oldThresholds = _extends({}, IntlRelativeFormat.thresholds);
	  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	  try {
	    return state.getRelativeFormat(locale, filteredOptions).format(date, {
	      now: isFinite(now) ? now : state.now()
	    });
	  } catch (e) {
	    onError(createError('Error formatting relative time.', e));
	  } finally {
	    updateRelativeFormatThresholds(oldThresholds);
	  }
	
	  return String(date);
	}
	
	function formatNumber(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
	  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getNumberFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    onError(createError('Error formatting number.', e));
	  }
	
	  return String(value);
	}
	
	function formatPlural(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale;
	
	
	  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	  var onError = config.onError || defaultErrorHandler;
	
	  try {
	    return state.getPluralFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    onError(createError('Error formatting plural.', e));
	  }
	
	  return 'other';
	}
	
	function formatMessage(config, state) {
	  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      messages = config.messages,
	      defaultLocale = config.defaultLocale,
	      defaultFormats = config.defaultFormats;
	  var id = messageDescriptor.id,
	      defaultMessage = messageDescriptor.defaultMessage;
	
	  // Produce a better error if the user calls `intl.formatMessage(element)`
	
	  if (false) {
	    invariant(!React.isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
	  }
	
	  // `id` is a required field of a Message Descriptor.
	  invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	  var message = messages && messages[id];
	  var hasValues = Object.keys(values).length > 0;
	
	  // Avoid expensive message formatting for simple messages without values. In
	  // development messages will always be formatted in case of missing values.
	  if (!hasValues && ("production") === 'production') {
	    return message || defaultMessage || id;
	  }
	
	  var formattedMessage = void 0;
	  var onError = config.onError || defaultErrorHandler;
	
	  if (message) {
	    try {
	      var formatter = state.getMessageFormat(message, locale, formats);
	
	      formattedMessage = formatter.format(values);
	    } catch (e) {
	      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
	    }
	  } else {
	    // This prevents warnings from littering the console in development
	    // when no `messages` are passed into the <IntlProvider> for the
	    // default locale, and a default message is in the source.
	    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
	    }
	  }
	
	  if (!formattedMessage && defaultMessage) {
	    try {
	      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	      formattedMessage = _formatter.format(values);
	    } catch (e) {
	      onError(createError('Error formatting the default message for: "' + id + '"', e));
	    }
	  }
	
	  if (!formattedMessage) {
	    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
	  }
	
	  return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  // Process all the values before they are used when formatting the ICU
	  // Message string. Since the formatted message might be injected via
	  // `innerHTML`, all String-based values need to be HTML-escaped.
	  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	    var value = rawValues[name];
	    escaped[name] = typeof value === 'string' ? escape(value) : value;
	    return escaped;
	  }, {});
	
	  return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
		formatDate: formatDate,
		formatTime: formatTime,
		formatRelative: formatRelative,
		formatNumber: formatNumber,
		formatPlural: formatPlural,
		formatMessage: formatMessage,
		formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	  formats: {},
	  messages: {},
	  timeZone: null,
	  textComponent: 'span',
	
	  defaultLocale: 'en',
	  defaultFormats: {},
	
	  onError: defaultErrorHandler
	};
	
	var IntlProvider = function (_Component) {
	  inherits(IntlProvider, _Component);
	
	  function IntlProvider(props) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, IntlProvider);
	
	    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	    invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	    var intlContext = context.intl;
	
	    // Used to stabilize time when performing an initial rendering so that
	    // all relative times use the same reference "now" time.
	
	    var initialNow = void 0;
	    if (isFinite(props.initialNow)) {
	      initialNow = Number(props.initialNow);
	    } else {
	      // When an `initialNow` isn't provided via `props`, look to see an
	      // <IntlProvider> exists in the ancestry and call its `now()`
	      // function to propagate its value for "now".
	      initialNow = intlContext ? intlContext.now() : Date.now();
	    }
	
	    // Creating `Intl*` formatters is expensive. If there's a parent
	    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	    // memoize the `Intl*` constructors and cache them for the lifecycle of
	    // this IntlProvider instance.
	
	    var _ref = intlContext || {},
	        _ref$formatters = _ref.formatters,
	        formatters = _ref$formatters === undefined ? {
	      getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	      getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	      getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	      getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	      getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	    } : _ref$formatters;
	
	    _this.state = _extends({}, formatters, {
	
	      // Wrapper to provide stable "now" time for initial render.
	      now: function now() {
	        return _this._didDisplay ? Date.now() : initialNow;
	      }
	    });
	    return _this;
	  }
	
	  createClass(IntlProvider, [{
	    key: 'getConfig',
	    value: function getConfig() {
	      var intlContext = this.context.intl;
	
	      // Build a whitelisted config object from `props`, defaults, and
	      // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	      // Apply default props. This must be applied last after the props have
	      // been resolved and inherited from any <IntlProvider> in the ancestry.
	      // This matches how React resolves `defaultProps`.
	      for (var propName in defaultProps) {
	        if (config[propName] === undefined) {
	          config[propName] = defaultProps[propName];
	        }
	      }
	
	      if (!hasLocaleData(config.locale)) {
	        var _config = config,
	            locale = _config.locale,
	            defaultLocale = _config.defaultLocale,
	            defaultFormats = _config.defaultFormats,
	            onError = _config.onError;
	
	
	        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));
	
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        config = _extends({}, config, {
	          locale: defaultLocale,
	          formats: defaultFormats,
	          messages: defaultProps.messages
	        });
	      }
	
	      return config;
	    }
	  }, {
	    key: 'getBoundFormatFns',
	    value: function getBoundFormatFns(config, state) {
	      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	        boundFormatFns[name] = format[name].bind(null, config, state);
	        return boundFormatFns;
	      }, {});
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var config = this.getConfig();
	
	      // Bind intl factories and current config to the format functions.
	      var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	      var _state = this.state,
	          now = _state.now,
	          formatters = objectWithoutProperties(_state, ['now']);
	
	
	      return {
	        intl: _extends({}, config, boundFormatFns, {
	          formatters: formatters,
	          now: now
	        })
	      };
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._didDisplay = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.Children.only(this.props.children);
	    }
	  }]);
	  return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	IntlProvider.contextTypes = {
	  intl: intlShape
	};
	IntlProvider.childContextTypes = {
	  intl: intlShape.isRequired
	};
	 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
	  children: PropTypes.element.isRequired,
	  initialNow: PropTypes.any
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	  inherits(FormattedDate, _Component);
	
	  function FormattedDate(props, context) {
	    classCallCheck(this, FormattedDate);
	
	    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedDate, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatDate = _context$intl.formatDate,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedDate = formatDate(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedDate);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedDate
	      );
	    }
	  }]);
	  return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	FormattedDate.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	  inherits(FormattedTime, _Component);
	
	  function FormattedTime(props, context) {
	    classCallCheck(this, FormattedTime);
	
	    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedTime, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatTime = _context$intl.formatTime,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedTime = formatTime(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedTime);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedTime
	      );
	    }
	  }]);
	  return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	FormattedTime.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	  var absDelta = Math.abs(delta);
	
	  if (absDelta < MINUTE) {
	    return 'second';
	  }
	
	  if (absDelta < HOUR) {
	    return 'minute';
	  }
	
	  if (absDelta < DAY) {
	    return 'hour';
	  }
	
	  // The maximum scheduled delay will be measured in days since the maximum
	  // timer delay is less than the number of milliseconds in 25 days.
	  return 'day';
	}
	
	function getUnitDelay(units) {
	  switch (units) {
	    case 'second':
	      return SECOND;
	    case 'minute':
	      return MINUTE;
	    case 'hour':
	      return HOUR;
	    case 'day':
	      return DAY;
	    default:
	      return MAX_TIMER_DELAY;
	  }
	}
	
	function isSameDate(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  var aTime = new Date(a).getTime();
	  var bTime = new Date(b).getTime();
	
	  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	  inherits(FormattedRelative, _Component);
	
	  function FormattedRelative(props, context) {
	    classCallCheck(this, FormattedRelative);
	
	    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	    invariantIntlContext(context);
	
	    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	    // `now` is stored as state so that `render()` remains a function of
	    // props + state, instead of accessing `Date.now()` inside `render()`.
	    _this.state = { now: now };
	    return _this;
	  }
	
	  createClass(FormattedRelative, [{
	    key: 'scheduleNextUpdate',
	    value: function scheduleNextUpdate(props, state) {
	      var _this2 = this;
	
	      // Cancel and pending update because we're scheduling a new update.
	      clearTimeout(this._timer);
	
	      var value = props.value,
	          units = props.units,
	          updateInterval = props.updateInterval;
	
	      var time = new Date(value).getTime();
	
	      // If the `updateInterval` is falsy, including `0` or we don't have a
	      // valid date, then auto updates have been turned off, so we bail and
	      // skip scheduling an update.
	      if (!updateInterval || !isFinite(time)) {
	        return;
	      }
	
	      var delta = time - state.now;
	      var unitDelay = getUnitDelay(units || selectUnits(delta));
	      var unitRemainder = Math.abs(delta % unitDelay);
	
	      // We want the largest possible timer delay which will still display
	      // accurate information while reducing unnecessary re-renders. The delay
	      // should be until the next "interesting" moment, like a tick from
	      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	      this._timer = setTimeout(function () {
	        _this2.setState({ now: _this2.context.intl.now() });
	      }, delay);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleNextUpdate(this.props, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var nextValue = _ref.value;
	
	      // When the `props.value` date changes, `state.now` needs to be updated,
	      // and the next update can be rescheduled.
	      if (!isSameDate(nextValue, this.props.value)) {
	        this.setState({ now: this.context.intl.now() });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.scheduleNextUpdate(nextProps, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatRelative = _context$intl.formatRelative,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));
	
	      if (typeof children === 'function') {
	        return children(formattedRelative);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedRelative
	      );
	    }
	  }]);
	  return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	FormattedRelative.contextTypes = {
	  intl: intlShape
	};
	FormattedRelative.defaultProps = {
	  updateInterval: 1000 * 10
	};
	 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  updateInterval: PropTypes.number,
	  initialNow: PropTypes.any,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	  inherits(FormattedNumber, _Component);
	
	  function FormattedNumber(props, context) {
	    classCallCheck(this, FormattedNumber);
	
	    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedNumber, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatNumber = _context$intl.formatNumber,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedNumber = formatNumber(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedNumber);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedNumber
	      );
	    }
	  }]);
	  return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	FormattedNumber.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	  inherits(FormattedPlural, _Component);
	
	  function FormattedPlural(props, context) {
	    classCallCheck(this, FormattedPlural);
	
	    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedPlural, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatPlural = _context$intl.formatPlural,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          other = _props.other,
	          children = _props.children;
	
	
	      var pluralCategory = formatPlural(value, this.props);
	      var formattedPlural = this.props[pluralCategory] || other;
	
	      if (typeof children === 'function') {
	        return children(formattedPlural);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedPlural
	      );
	    }
	  }]);
	  return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	FormattedPlural.contextTypes = {
	  intl: intlShape
	};
	FormattedPlural.defaultProps = {
	  style: 'cardinal'
	};
	 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	
	  other: PropTypes.node.isRequired,
	  zero: PropTypes.node,
	  one: PropTypes.node,
	  two: PropTypes.node,
	  few: PropTypes.node,
	  many: PropTypes.node,
	
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
	  if (false) {
	    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
	  }
	  return formatMessage({}, { getMessageFormat: memoizeIntlConstructor(IntlMessageFormat) }, descriptor, values);
	};
	
	var FormattedMessage = function (_Component) {
	  inherits(FormattedMessage, _Component);
	
	  function FormattedMessage(props, context) {
	    classCallCheck(this, FormattedMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	    if (!props.defaultMessage) {
	      invariantIntlContext(context);
	    }
	    return _this;
	  }
	
	  createClass(FormattedMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref = this.context.intl || {},
	          _ref$formatMessage = _ref.formatMessage,
	          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
	          _ref$textComponent = _ref.textComponent,
	          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;
	
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          values = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var tokenDelimiter = void 0;
	      var tokenizedValues = void 0;
	      var elements = void 0;
	
	      var hasValues = values && Object.keys(values).length > 0;
	      if (hasValues) {
	        // Creates a token with a random UID that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	        var generateToken = function () {
	          var counter = 0;
	          return function () {
	            return 'ELEMENT-' + uid + '-' + (counter += 1);
	          };
	        }();
	
	        // Splitting with a delimiter to support IE8. When using a regex
	        // with a capture group IE8 does not include the capture group in
	        // the resulting array.
	        tokenDelimiter = '@__' + uid + '__@';
	        tokenizedValues = {};
	        elements = {};
	
	        // Iterates over the `props` to keep track of any React Element
	        // values so they can be represented by the `token` as a placeholder
	        // when the `message` is formatted. This allows the formatted
	        // message to then be broken-up into parts with references to the
	        // React Elements inserted back in.
	        Object.keys(values).forEach(function (name) {
	          var value = values[name];
	
	          if (React.isValidElement(value)) {
	            var token = generateToken();
	            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	            elements[token] = value;
	          } else {
	            tokenizedValues[name] = value;
	          }
	        });
	      }
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);
	
	      var nodes = void 0;
	
	      var hasElements = elements && Object.keys(elements).length > 0;
	      if (hasElements) {
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while
	        // keeping React's virtual diffing working properly.
	        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	          return !!part;
	        }).map(function (part) {
	          return elements[part] || part;
	        });
	      } else {
	        nodes = [formattedMessage];
	      }
	
	      if (typeof children === 'function') {
	        return children.apply(undefined, toConsumableArray(nodes));
	      }
	
	      // Needs to use `createElement()` instead of JSX, otherwise React will
	      // warn about a missing `key` prop with rich-text message formatting.
	      return React.createElement.apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
	    }
	  }]);
	  return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	FormattedMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	  inherits(FormattedHTMLMessage, _Component);
	
	  function FormattedHTMLMessage(props, context) {
	    classCallCheck(this, FormattedHTMLMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedHTMLMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatHTMLMessage = _context$intl.formatHTMLMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          rawValues = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	      if (typeof children === 'function') {
	        return children(formattedHTMLMessage);
	      }
	
	      // Since the message presumably has HTML in it, we need to set
	      // `innerHTML` in order for it to be rendered and not escaped by React.
	      // To be safe, all string prop values were escaped when formatting the
	      // message. It is assumed that the message is not UGC, and came from the
	      // developer making it more like a template.
	      //
	      // Note: There's a perf impact of using this component since there's no
	      // way for React to do its virtual DOM diffing.
	      var html = { __html: formattedHTMLMessage };
	      return React__default.createElement(Component$$1, { dangerouslySetInnerHTML: html });
	    }
	  }]);
	  return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	FormattedHTMLMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedHTMLMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(409)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(912);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 198 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ns$jss$ns$sheetOptio;
	
	var _propTypes = __webpack_require__(2);
	
	var _ns = __webpack_require__(129);
	
	var ns = _interopRequireWildcard(_ns);
	
	var _propTypes2 = __webpack_require__(200);
	
	var _propTypes3 = _interopRequireDefault(_propTypes2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	exports['default'] = {
	  jss: (0, _propTypes.shape)({
	    options: (0, _propTypes.shape)({
	      createGenerateClassName: _propTypes.func.isRequired
	    }).isRequired,
	    createStyleSheet: _propTypes.func.isRequired,
	    removeStyleSheet: _propTypes.func.isRequired
	  }),
	  registry: (0, _propTypes.shape)({
	    add: _propTypes.func.isRequired,
	    toString: _propTypes.func.isRequired
	  })
	};

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry = function () {
	  function SheetsRegistry() {
	    _classCallCheck(this, SheetsRegistry);
	
	    this.registry = [];
	  }
	
	  _createClass(SheetsRegistry, [{
	    key: 'add',
	
	
	    /**
	     * Register a Style Sheet.
	     */
	    value: function add(sheet) {
	      var registry = this.registry;
	      var index = sheet.options.index;
	
	
	      if (registry.indexOf(sheet) !== -1) return;
	
	      if (registry.length === 0 || index >= this.index) {
	        registry.push(sheet);
	        return;
	      }
	
	      // Find a position.
	      for (var i = 0; i < registry.length; i++) {
	        if (registry[i].options.index > index) {
	          registry.splice(i, 0, sheet);
	          return;
	        }
	      }
	    }
	
	    /**
	     * Reset the registry.
	     */
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.registry = [];
	    }
	
	    /**
	     * Remove a Style Sheet.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(sheet) {
	      var index = this.registry.indexOf(sheet);
	      this.registry.splice(index, 1);
	    }
	
	    /**
	     * Convert all attached sheets to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return this.registry.filter(function (sheet) {
	        return sheet.attached;
	      }).map(function (sheet) {
	        return sheet.toString(options);
	      }).join('\n');
	    }
	  }, {
	    key: 'index',
	
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	exports['default'] = SheetsRegistry;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _linkRule = __webpack_require__(206);
	
	var _linkRule2 = _interopRequireDefault(_linkRule);
	
	var _RuleList = __webpack_require__(70);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable-next-line no-use-before-define */
	var StyleSheet = function () {
	  function StyleSheet(styles, options) {
	    var _this = this;
	
	    _classCallCheck(this, StyleSheet);
	
	    this.update = function (name, data) {
	      if (typeof name === 'string') {
	        _this.rules.update(name, data);
	      } else {
	        _this.rules.update(name);
	      }
	      return _this;
	    };
	
	    this.attached = false;
	    this.deployed = false;
	    this.linked = false;
	    this.classes = {};
	    this.options = _extends({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes
	    });
	    this.renderer = new options.Renderer(this);
	    this.rules = new _RuleList2['default'](this.options);
	
	    for (var _name in styles) {
	      this.rules.add(_name, styles[_name]);
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  _createClass(StyleSheet, [{
	    key: 'attach',
	    value: function attach() {
	      if (this.attached) return this;
	      if (!this.deployed) this.deploy();
	      this.renderer.attach();
	      if (!this.linked && this.options.link) this.link();
	      this.attached = true;
	      return this;
	    }
	
	    /**
	     * Remove renderable from render tree.
	     */
	
	  }, {
	    key: 'detach',
	    value: function detach() {
	      if (!this.attached) return this;
	      this.renderer.detach();
	      this.attached = false;
	      return this;
	    }
	
	    /**
	     * Add a rule to the current stylesheet.
	     * Will insert a rule also after the stylesheet has been rendered first time.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, decl, options) {
	      var queue = this.queue;
	
	      // Plugins can create rules.
	      // In order to preserve the right order, we need to queue all `.addRule` calls,
	      // which happen after the first `rules.add()` call.
	
	      if (this.attached && !queue) this.queue = [];
	
	      var rule = this.rules.add(name, decl, options);
	      this.options.jss.plugins.onProcessRule(rule);
	
	      if (this.attached) {
	        if (!this.deployed) return rule;
	        // Don't insert rule directly if there is no stringified version yet.
	        // It will be inserted all together when .attach is called.
	        if (queue) queue.push(rule);else {
	          this.insertRule(rule);
	          if (this.queue) {
	            this.queue.forEach(this.insertRule, this);
	            this.queue = undefined;
	          }
	        }
	        return rule;
	      }
	
	      // We can't add rules to a detached style node.
	      // We will redeploy the sheet once user will attach it.
	      this.deployed = false;
	
	      return rule;
	    }
	
	    /**
	     * Insert rule into the StyleSheet
	     */
	
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule) {
	      var renderable = this.renderer.insertRule(rule);
	      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
	    }
	
	    /**
	     * Create and add rules.
	     * Will render also after Style Sheet was rendered the first time.
	     */
	
	  }, {
	    key: 'addRules',
	    value: function addRules(styles, options) {
	      var added = [];
	      for (var _name2 in styles) {
	        added.push(this.addRule(_name2, styles[_name2], options));
	      }
	      return added;
	    }
	
	    /**
	     * Get a rule by name.
	     */
	
	  }, {
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Delete a rule by name.
	     * Returns `true`: if rule has been deleted from the DOM.
	     */
	
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(name) {
	      var rule = this.rules.get(name);
	
	      if (!rule) return false;
	
	      this.rules.remove(rule);
	
	      if (this.attached && rule.renderable) {
	        return this.renderer.deleteRule(rule.renderable);
	      }
	
	      return true;
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Deploy pure CSS string to a renderable.
	     */
	
	  }, {
	    key: 'deploy',
	    value: function deploy() {
	      this.renderer.deploy();
	      this.deployed = true;
	      return this;
	    }
	
	    /**
	     * Link renderable CSS rules from sheet with their corresponding models.
	     */
	
	  }, {
	    key: 'link',
	    value: function link() {
	      var cssRules = this.renderer.getRules();
	
	      // Is undefined when VirtualRenderer is used.
	      if (cssRules) this.rules.link(cssRules);
	      this.linked = true;
	      return this;
	    }
	
	    /**
	     * Update the function values with a new data.
	     */
	
	  }, {
	    key: 'toString',
	
	
	    /**
	     * Convert rules to a CSS string.
	     */
	    value: function toString(options) {
	      return this.rules.toString(options);
	    }
	  }]);
	
	  return StyleSheet;
	}();
	
	exports['default'] = StyleSheet;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;
	
	var _getDynamicStyles = __webpack_require__(470);
	
	Object.defineProperty(exports, 'getDynamicStyles', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getDynamicStyles)['default'];
	  }
	});
	
	var _toCssValue = __webpack_require__(88);
	
	Object.defineProperty(exports, 'toCssValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_toCssValue)['default'];
	  }
	});
	
	var _SheetsRegistry = __webpack_require__(201);
	
	Object.defineProperty(exports, 'SheetsRegistry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SheetsRegistry)['default'];
	  }
	});
	
	var _SheetsManager = __webpack_require__(457);
	
	Object.defineProperty(exports, 'SheetsManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SheetsManager)['default'];
	  }
	});
	
	var _RuleList = __webpack_require__(70);
	
	Object.defineProperty(exports, 'RuleList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RuleList)['default'];
	  }
	});
	
	var _sheets = __webpack_require__(132);
	
	Object.defineProperty(exports, 'sheets', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sheets)['default'];
	  }
	});
	
	var _createGenerateClassName = __webpack_require__(204);
	
	Object.defineProperty(exports, 'createGenerateClassName', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createGenerateClassName)['default'];
	  }
	});
	
	var _Jss = __webpack_require__(455);
	
	var _Jss2 = _interopRequireDefault(_Jss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a new instance of Jss.
	 */
	var create = exports.create = function create(options) {
	  return new _Jss2['default'](options);
	};
	
	/**
	 * A global Jss instance.
	 */
	exports['default'] = create();

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _StyleSheet = __webpack_require__(202);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _moduleId = __webpack_require__(471);
	
	var _moduleId2 = _interopRequireDefault(_moduleId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var maxRules = 1e10;
	
	
	var env = ("production");
	
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	
	exports['default'] = function () {
	  var ruleCounter = 0;
	  var defaultPrefix = env === 'production' ? 'c' : '';
	
	  return function (rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
	    }
	
	    var prefix = defaultPrefix;
	    var jssId = '';
	
	    if (sheet) {
	      prefix = sheet.options.classNamePrefix || defaultPrefix;
	      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
	    }
	
	    if (env === 'production') {
	      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
	  };
	};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _symbolObservable = __webpack_require__(473);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (value) {
	  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
	};

/***/ },
/* 206 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = linkRule;
	/**
	 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
	 */
	function linkRule(rule, cssRule) {
	  rule.renderable = cssRule;
	  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
	}

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createThemeListener;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _channel = __webpack_require__(89);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function createThemeListener() {
	  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel2.default;
	
	  var contextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.object.isRequired);
	
	  function initial(context) {
	    if (!context[CHANNEL]) {
	      throw new Error('[' + this.displayName + '] Please use ThemeProvider to be able to use WithTheme');
	    }
	
	    return context[CHANNEL].getState();
	  }
	
	  function subscribe(context, cb) {
	    if (context[CHANNEL]) {
	      return context[CHANNEL].subscribe(cb);
	    }
	  }
	
	  function unsubscribe(context, subscriptionId) {
	    if (context[CHANNEL]) {
	      context[CHANNEL].unsubscribe(subscriptionId);
	    }
	  }
	
	  return {
	    contextTypes: contextTypes,
	    initial: initial,
	    subscribe: subscribe,
	    unsubscribe: unsubscribe
	  };
	}

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.themeListener = exports.ThemeProvider = exports.withTheme = exports.channel = undefined;
	exports.createTheming = createTheming;
	
	var _createThemeProvider = __webpack_require__(475);
	
	var _createThemeProvider2 = _interopRequireDefault(_createThemeProvider);
	
	var _createWithTheme = __webpack_require__(476);
	
	var _createWithTheme2 = _interopRequireDefault(_createWithTheme);
	
	var _createThemeListener = __webpack_require__(207);
	
	var _createThemeListener2 = _interopRequireDefault(_createThemeListener);
	
	var _channel = __webpack_require__(89);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var channel = exports.channel = _channel2.default;
	var withTheme = exports.withTheme = (0, _createWithTheme2.default)();
	var ThemeProvider = exports.ThemeProvider = (0, _createThemeProvider2.default)();
	var themeListener = exports.themeListener = (0, _createThemeListener2.default)();
	function createTheming() {
	  var customChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel2.default;
	
	  return {
	    channel: customChannel,
	    withTheme: (0, _createWithTheme2.default)(customChannel),
	    ThemeProvider: (0, _createThemeProvider2.default)(customChannel),
	    themeListener: (0, _createThemeListener2.default)(customChannel)
	  };
	}
	
	exports.default = {
	  channel: _channel2.default,
	  withTheme: withTheme,
	  ThemeProvider: ThemeProvider,
	  themeListener: themeListener,
	  createTheming: createTheming
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore everything but left clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");
	
	    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');
	
	    var history = this.context.router.history;
	
	    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;
	
	    var href = history.createHref(location);
	    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(212);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(136);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(214);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(510)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PaymentConfirmationDM = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _VisaCheckoutForm = __webpack_require__(583);
	
	var _VisaCheckoutForm2 = _interopRequireDefault(_VisaCheckoutForm);
	
	var _tabs = __webpack_require__(122);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _tab = __webpack_require__(85);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _QRCodeForm = __webpack_require__(570);
	
	var _QRCodeForm2 = _interopRequireDefault(_QRCodeForm);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _OrderHook = __webpack_require__(521);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB_VALUES = ["QR_CODE_SCAN", "ESEWA", "BANK_TRANSER"];
	
	var PaymentConfirmationDM = exports.PaymentConfirmationDM = function PaymentConfirmationDM() {
	    return _react2.default.createElement(
	        'ul',
	        { className: 'dmSources' },
	        _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://m.me/setocanvascom' },
	                'Messenger'
	            )
	        ),
	        _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	                'a',
	                { target: '_blank', href: _AppConstants2.default.INSTA_PAGE },
	                'Instagram'
	            )
	        ),
	        _react2.default.createElement(
	            'li',
	            null,
	            'or, ',
	            _react2.default.createElement(
	                'span',
	                { style: { color: "green" } },
	                'WhatsApp'
	            ),
	            ' at ',
	            _AppConstants2.default.WHATS_APP
	        )
	    );
	};
	
	var EsewaIdPayment = function EsewaIdPayment(_ref) {
	    var amount = _ref.amount;
	
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'esewaIdForm', className: 'paymentForm' },
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Send to Esewa Id: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    '9862441133'
	                ),
	                ', Name: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Se*****'
	                )
	            ),
	            amount !== null && amount !== undefined && amount > 0 && _react2.default.createElement(
	                'li',
	                null,
	                'Enter Amount: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    "Rs. " + _AppUtil2.default.formatNumber(amount)
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Enter Purpose: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Bill Sharing'
	                ),
	                '.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Enter Remarks: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Your Name'
	                ),
	                ' ',
	                _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        '(same as in your order)'
	                    )
	                ),
	                '.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'After finishing your payment, DM Us it\'s screenshot and our operator shall confirm and mark your order paid. You can send the screenshot in:'
	            ),
	            _react2.default.createElement(PaymentConfirmationDM, null)
	        )
	    );
	};
	
	var BankTransferPayment = function BankTransferPayment(_ref2) {
	    var amount = _ref2.amount;
	
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'bankTransferForm', className: 'paymentForm' },
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Bank Name: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'NIC Asia Bank, Kapan Branch'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Account Id: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    '0604150047260002'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Account Name: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'SETO CANVAS PVT. LTD.'
	                )
	            ),
	            amount !== null && amount !== undefined && amount > 0 && _react2.default.createElement(
	                'li',
	                null,
	                'Amount: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    "Rs. " + _AppUtil2.default.formatNumber(amount)
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'After finishing your payment, DM Us it\'s screenshot and our operator shall confirm and update your order. You can send the screenshot in:'
	            ),
	            _react2.default.createElement(PaymentConfirmationDM, null)
	        )
	    );
	};
	
	var CardPayment = function CardPayment(_ref3) {
	    var amount = _ref3.amount,
	        orderIds = _ref3.orderIds;
	
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'cardPaymentForm', className: 'paymentForm' },
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'You can use your ',
	                _react2.default.createElement('i', { className: 'fa fa-cc-visa', 'aria-hidden': 'true' }),
	                ' Visa or ',
	                _react2.default.createElement('i', { className: 'fa fa-cc-mastercard', 'aria-hidden': 'true' }),
	                ' Master Card to make the payment.'
	            ),
	            amount !== null && amount !== undefined && amount > 0 && _react2.default.createElement(
	                'li',
	                null,
	                'Total Amount: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    "Rs. " + _AppUtil2.default.formatNumber(amount)
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Clicking on the ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    '\'Continue\''
	                ),
	                ' button will redirect you to a secure payment page where you can enter your card details to make the payment.'
	            )
	        ),
	        _react2.default.createElement(_VisaCheckoutForm2.default, { amount: amount, orderIds: orderIds })
	    );
	};
	
	var CheckoutPage = function CheckoutPage(props) {
	    var currentSession = _SessionStore2.default.getCurrentSession();
	    var queryParams = _AppUtil2.default.getUrlQueryParams(props.location);
	
	    var tabIndex = TAB_VALUES.indexOf(queryParams['via']);
	
	    var amount = queryParams['amount'];
	    var orderIds = queryParams['orderId'] ? queryParams['orderId'].split(",").map(function (o) {
	        return parseInt(o, 10);
	    }) : [];
	
	    if (!amount || !orderIds) {
	        if (currentSession) {
	            var orders = (0, _OrderHook.useUserActiveOrders)();
	
	            if (orders) {
	                var unpaidOrderFilter = function unpaidOrderFilter(o) {
	                    return o.orderState !== 'DELIVERED' && o.orderState !== 'CANCELLED' && !o.paid;
	                };
	
	                orderIds = orders.filter(unpaidOrderFilter).map(function (o) {
	                    return o.orderId;
	                }).toArray();
	
	                amount = orders.filter(unpaidOrderFilter).map(function (o) {
	                    return o.totalCharge;
	                }).reduce(function (a, b) {
	                    return a + b;
	                }, 0);
	            }
	        }
	    }
	
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'checkoutPage', title: "Checkout Artworks, Merchandise, T-Shirt, Hoodies and more | Seto Canvas",
	            metaDescription: "Checkout tshirts, arts and many more at SetoCanvas.com" },
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow', id: 'checkoutHeader' },
	            _react2.default.createElement(
	                'h2',
	                { id: 'selectPaymentTxt' },
	                'Select Payment Method'
	            ),
	            currentSession && _react2.default.createElement(
	                'div',
	                { className: 'viewOrdersLink' },
	                _react2.default.createElement(
	                    _AppElements.A,
	                    { href: '/orders' },
	                    _react2.default.createElement('i', { className: 'fa fa-long-arrow-left', 'aria-hidden': 'true' }),
	                    ' View Orders'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _tabs2.default,
	            { defaultSelectedIndex: tabIndex > 0 ? tabIndex : 0, style: { minHeight: '300px' } },
	            _react2.default.createElement(
	                _tab2.default,
	                { value: TAB_VALUES[0], label: _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-qrcode', 'aria-hidden': 'true' }),
	                        ' QR Code Scan'
	                    ) },
	                _react2.default.createElement(_QRCodeForm2.default, { amount: amount })
	            ),
	            _react2.default.createElement(
	                _tab2.default,
	                { value: TAB_VALUES[1], label: 'eSewa' },
	                _react2.default.createElement(EsewaIdPayment, { amount: amount })
	            ),
	            _react2.default.createElement(
	                _tab2.default,
	                { value: TAB_VALUES[2], label: _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-university', 'aria-hidden': 'true' }),
	                        ' Bank Transfer'
	                    ) },
	                _react2.default.createElement(BankTransferPayment, { amount: amount })
	            )
	        )
	    );
	};
	
	exports.default = CheckoutPage;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DCUtil = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _OrderStore = __webpack_require__(61);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactCountdownNow = __webpack_require__(194);
	
	var _reactCountdownNow2 = _interopRequireDefault(_reactCountdownNow);
	
	var _reactSticky = __webpack_require__(103);
	
	var _DateComponent = __webpack_require__(62);
	
	var _DateComponent2 = _interopRequireDefault(_DateComponent);
	
	var _copyToClipboard = __webpack_require__(121);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _AppAction = __webpack_require__(22);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VIDEO_IDS = ["b2TioTkgr_w", "wstX8kMNcko", "Oc6Ku8_bpi8"];
	
	var DASHAIN_CAMPAIGN_BANNER = [{ img: "/images/banners/dashain/banner1.jpg", url: "/dashain/buyonedonateone", title: "This Dashain Buy One Donate 1 - Dashain Campaign by SetoCanvas" }, { img: "/images/banners/dashain/banner2.jpg", url: "/dashain/buyonedonateone", title: "This Dashain Buy One Donate 1 - Dashain Campaign by SetoCanvas" }, { img: "/images/banners/dashain/banner3.jpg", url: "/dashain/buyonedonateone", title: "This Dashain Buy One Donate 1 - Dashain Campaign by SetoCanvas" }];
	
	var CAMPAIGN_URL = _AppConstants2.default.WEBSITE + "/dashain/buyonedonateone";
	
	var DCUtil = exports.DCUtil = {
	    isCampaignActive: function isCampaignActive() {
	        var today = new Date();
	        var endDate = this.campaignEndDate();
	        return today.getTime() < endDate.getTime();
	    },
	
	    campaignStartDate: function campaignStartDate() {
	        //Aug 29
	        return new Date(2019, 7, 29);
	    },
	    campaignEndDate: function campaignEndDate() {
	        //Sep 30
	        return new Date(2019, 8, 30);
	    },
	
	    getDashainCampaignBanner: function getDashainCampaignBanner() {
	        return DASHAIN_CAMPAIGN_BANNER;
	    }
	};
	
	var ContributersList = function ContributersList(props) {
	    var contributers = props.contributers;
	
	    if (!contributers) return null;
	
	    //Ram hari Bought one Gorkhali Hustle Tshirt
	    var contributersLi = contributers.map(function (c) {
	        var productURL = _AppUtil2.default.getProductURL(c.product);
	        var delivered = c.orderState === _AppConstants2.default.ORDER_STATE.DELIVERED.value;
	
	        var donationInfo = null;
	        if (delivered) {
	            donationInfo = _react2.default.createElement(
	                'span',
	                { className: 'donatedInfo deliveredInfo' },
	                _react2.default.createElement('i', { className: 'fa fa-check-circle', 'aria-hidden': 'true' }),
	                ' ',
	                c.quantity,
	                ' T-Shirt donated to campaign.'
	            );
	        } else {
	            donationInfo = _react2.default.createElement(
	                'span',
	                { className: 'donatedInfo pendingDeliveryInfo' },
	                _react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
	                ' Pending Delivery.'
	            );
	        }
	
	        var productStr = _react2.default.createElement(
	            _AppElements.A,
	            { href: productURL },
	            c.product.title
	        );
	        return _react2.default.createElement(
	            'li',
	            { key: c.orderId, className: 'eachContributer' },
	            _react2.default.createElement(
	                'b',
	                null,
	                c.user.username
	            ),
	            ' bought ',
	            c.quantity,
	            ' ',
	            productStr,
	            ' ',
	            _AppConstants2.default.PRODUCT_TYPES[c.product.productType].label,
	            ' ',
	            _react2.default.createElement(
	                'small',
	                null,
	                'on ',
	                _react2.default.createElement(_DateComponent2.default, { date: c.createdDate, relative: false })
	            ),
	            _react2.default.createElement('br', null),
	            donationInfo
	        );
	    });
	    return _react2.default.createElement(
	        'ul',
	        { id: 'contributersList' },
	        contributersLi
	    );
	};
	
	var CountDownRenderer = function CountDownRenderer(props) {
	    var isPlural = function isPlural(num) {
	        return num > 1;
	    };
	
	    var daysLabel = _react2.default.createElement(
	        'div',
	        { className: 'flexColumn eachTimerBox' },
	        _react2.default.createElement(
	            'span',
	            { className: 'timer' },
	            props.formatted.days
	        ),
	        ' ',
	        _react2.default.createElement(
	            'span',
	            { className: 'timerLabel' },
	            'day',
	            isPlural(props.days) ? 's' : ''
	        )
	    );
	    var hoursLabel = _react2.default.createElement(
	        'div',
	        { className: 'flexColumn eachTimerBox' },
	        _react2.default.createElement(
	            'span',
	            { className: 'timer' },
	            props.formatted.hours
	        ),
	        ' ',
	        _react2.default.createElement(
	            'span',
	            { className: 'timerLabel' },
	            'hour',
	            isPlural(props.hours) ? 's' : ''
	        )
	    );
	    var minutesLabel = _react2.default.createElement(
	        'div',
	        { className: 'flexColumn eachTimerBox' },
	        _react2.default.createElement(
	            'span',
	            { className: 'timer' },
	            props.formatted.minutes
	        ),
	        ' ',
	        _react2.default.createElement(
	            'span',
	            { className: 'timerLabel' },
	            'minute',
	            isPlural(props.minutes) ? 's' : ''
	        )
	    );
	    var secondsLabel = _react2.default.createElement(
	        'div',
	        { className: 'flexColumn eachTimerBox' },
	        _react2.default.createElement(
	            'span',
	            { className: 'timer' },
	            props.formatted.seconds
	        ),
	        ' ',
	        _react2.default.createElement(
	            'span',
	            { className: 'timerLabel' },
	            'second',
	            isPlural(props.seconds) ? 's' : ''
	        )
	    );
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexColumn' },
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow timerBox' },
	            daysLabel,
	            hoursLabel,
	            minutesLabel,
	            secondsLabel
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'forDashainLabel' },
	            'for Dashain'
	        )
	    );
	};
	
	var DEFAULT_VIDEO_SLIDER_SETTINGS = {
	    speed: 350,
	    infinite: true,
	    className: 'videoSlider',
	    cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
	    dots: true,
	    arrows: true,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    swipeToSlide: true,
	    swipe: true
	};
	
	var VideosList = (0, _radium2.default)(function (props) {
	    var videos = VIDEO_IDS.map(function (videoId) {
	        var videoURL = "https://www.youtube.com/embed/" + videoId + "?autoplay=0&origin=" + _AppConstants2.default.WEBSITE + "&modestbranding=1&disablekb=1&iv_load_policy=3";
	
	        return _react2.default.createElement('iframe', { key: videoId, className: 'dcYTplayer', type: 'text/html',
	            src: videoURL,
	            frameBorder: '0', allowFullScreen: true });
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { style: { width: "60%", "@media (max-width: 884px)": { width: '100%', margin: '0 auto' } },
	            id: 'dashainCampaginVideoContainer' },
	        _react2.default.createElement(
	            _reactSlick2.default,
	            DEFAULT_VIDEO_SLIDER_SETTINGS,
	            videos
	        )
	    );
	});
	
	var FeaturedProductsModal = function FeaturedProductsModal(props) {
	
	    var products = props.products;
	
	    return _react2.default.createElement(
	        _reactResponsiveModal2.default,
	        { closeOnOverlayClick: false, open: props.open,
	            onClose: props.onClose,
	            classNames: { modal: 'dashain-campaign-modal', closeIcon: 'dashain-campaign-close-icon' } },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_ProductList2.default, { products: products, showSlider: true,
	                title: "FEATURED PRODUCTS",
	                productViewMode: 'productOnly', navigator: 'arrows',
	                infinite: true,
	                autoplay: false, id: 'featuredProducts' }),
	            _react2.default.createElement(
	                _AppElements.Button,
	                { id: 'browseMoreBtn', href: '/', mui: 'true', color: 'primary' },
	                'Browse More'
	            )
	        )
	    );
	};
	
	var CampaignStat = (0, _radium2.default)(function (props) {
	    var campaignStat = props.campaignStat;
	
	    return _react2.default.createElement(
	        'div',
	        { style: props.style, id: 'campaignStat' },
	        DCUtil.isCampaignActive() && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h1',
	                { id: 'tshirtRemaining' },
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    campaignStat.totalRemaining
	                ),
	                ' Tshirts Remaining'
	            ),
	            _react2.default.createElement(
	                'h4',
	                { id: 'tshirtFulfilled' },
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    campaignStat.totalFulfilled,
	                    '/',
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        '100'
	                    ),
	                    ' Tshirts Fulfilled'
	                )
	            )
	        ),
	        !DCUtil.isCampaignActive() && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h1',
	                { id: 'tshirtFulfilled' },
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    campaignStat.totalFulfilled,
	                    '/',
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        '100'
	                    ),
	                    ' Tshirts Fulfilled'
	                )
	            )
	        ),
	        _react2.default.createElement(_AppElements.Separator, { style: { margin: '0px auto 25px auto', width: '100%' } }),
	        _react2.default.createElement(_reactCountdownNow2.default, { date: DCUtil.campaignEndDate(), renderer: CountDownRenderer }),
	        _react2.default.createElement(
	            _AppElements.Button,
	            { onClick: props.onContributeNowClick, mui: 'true', color: 'primary', style: { width: '100%' } },
	            'Contribute Now'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(
	                'b',
	                null,
	                'Help by Sharing'
	            )
	        ),
	        _react2.default.createElement(_AppElements.Separator, { style: { margin: '0px auto 25px auto', width: '100%' } }),
	        _react2.default.createElement(
	            'h4',
	            { style: { fontSize: '90%', color: 'gray' } },
	            _react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
	            ' Use the link below to share on Facebook, Twitter, Blog and other platforms.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow' },
	            _react2.default.createElement('input', { id: 'campaignLinkInput', type: 'text', value: CAMPAIGN_URL, readOnly: true, style: { flexGrow: '1', padding: '5px 10px' } }),
	            _react2.default.createElement(
	                _AppElements.Button,
	                { id: 'copyLinkBtn', onClick: props.onCopy },
	                _react2.default.createElement('i', { className: 'fa fa-files-o', 'aria-hidden': 'true' }),
	                ' Copy'
	            )
	        ),
	        props.copied && _react2.default.createElement(
	            'small',
	            null,
	            'Copied. You can paste it now.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'socialShareBtns', className: 'flexRow' },
	            _react2.default.createElement(
	                _AppElements.A,
	                { className: 'fbLink', href: 'https://www.facebook.com/', mui: 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-facebook', 'aria-hidden': 'true' }),
	                ' Facebook'
	            ),
	            _react2.default.createElement(
	                _AppElements.A,
	                { className: 'fbLink', href: 'https://twitter.com/home', mui: 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-twitter', 'aria-hidden': 'true' }),
	                ' Twitter'
	            )
	        )
	    );
	});
	
	var BuyOneDonateOne = function (_React$Component) {
	    _inherits(BuyOneDonateOne, _React$Component);
	
	    _createClass(BuyOneDonateOne, null, [{
	        key: 'getStores',
	        value: function getStores() {
	            return [_OrderStore2.default, _ProductStore2.default];
	        }
	    }, {
	        key: 'calculateState',
	        value: function calculateState(prevState) {
	            var newState = {
	                orders: _OrderStore2.default.getActionOrders(_AppAction.OrderAction.LOAD_DASHAIN_CAMPAIGN_ORDERS),
	                featuredProducts: _ProductStore2.default.getDashainFeaturedProducts(),
	                openFeaturedProducts: prevState ? prevState.openFeaturedProducts : false
	            };
	            return newState;
	        }
	    }]);
	
	    function BuyOneDonateOne(props) {
	        _classCallCheck(this, BuyOneDonateOne);
	
	        var _this = _possibleConstructorReturn(this, (BuyOneDonateOne.__proto__ || Object.getPrototypeOf(BuyOneDonateOne)).call(this, props));
	
	        _this.state = { copied: false, openFeaturedProducts: false };
	        _this.onCopy = _this.onCopy.bind(_this);
	        _this.onContributeNowClick = _this.onContributeNowClick.bind(_this);
	        _this.onFeaturedProductsModalClose = _this.onFeaturedProductsModalClose.bind(_this);
	
	        _this.getCampaignStat = _this.getCampaignStat.bind(_this);
	        return _this;
	    }
	
	    _createClass(BuyOneDonateOne, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.state.orders) {
	                _HttpService2.default.getDashainCampaignOrders();
	            }
	        }
	    }, {
	        key: 'onCopy',
	        value: function onCopy() {
	            this.setState({ copied: (0, _copyToClipboard2.default)(CAMPAIGN_URL) });
	        }
	    }, {
	        key: 'onContributeNowClick',
	        value: function onContributeNowClick() {
	            this.setState({ openFeaturedProducts: true });
	
	            if (!this.state.featuredProducts) {
	                _ProductAPI2.default.getFeaturedProductsForDashain();
	            }
	        }
	    }, {
	        key: 'onFeaturedProductsModalClose',
	        value: function onFeaturedProductsModalClose() {
	            this.setState({ openFeaturedProducts: false });
	        }
	    }, {
	        key: 'getCampaignStat',
	        value: function getCampaignStat() {
	            if (this.state.orders) {
	                var totalFulfilled = 25 + this.state.orders.size;
	                return { totalFulfilled: totalFulfilled,
	                    totalRemaining: 100 - totalFulfilled };
	            }
	
	            return { totalFulfilled: "-", totalRemaining: "-" };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var campaignStat = this.getCampaignStat();
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'dashainCampaignPage' },
	                _react2.default.createElement(
	                    _reactHelmet.Helmet,
	                    null,
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        'This Dashain Buy One, Donate 1 | Seto Canvas'
	                    ),
	                    _react2.default.createElement('meta', { name: 'description', content: 'This Dashain, Seto Canvas Team will be donating Dashain T-Shirts to the needy and less fortunate people who hardly get to wear any new cloth in years.' })
	                ),
	                _react2.default.createElement(_HeaderContainer2.default, null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mainContainer' },
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'campaignHeader', className: 'flexRow', style: { height: '380px', marginBottom: '20px', "@media (max-width: 884px)": { height: 'auto' } } },
	                        _react2.default.createElement(VideosList, null),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { '@media (min-width: 884px)': { display: 'none' } }, id: 'mobileStat' },
	                            _react2.default.createElement(CampaignStat, { style: { height: 'auto', margin: '30px 0 0 0' }, campaignStat: campaignStat,
	                                onContributeNowClick: this.onContributeNowClick,
	                                copied: this.state.copied, onCopy: this.onCopy })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { '@media (max-width: 884px)': { display: 'none' } }, id: 'webStat' },
	                            _react2.default.createElement(
	                                _reactSticky.Sticky,
	                                { topOffset: 128 },
	                                function (_ref) {
	                                    var style = _ref.style,
	                                        isSticky = _ref.isSticky;
	
	                                    style.margin = '0 10px';
	                                    style.width = 'inherit';
	                                    style.top = '60px';
	
	                                    return _react2.default.createElement(CampaignStat, { style: style, campaignStat: campaignStat,
	                                        onContributeNowClick: _this2.onContributeNowClick,
	                                        copied: _this2.state.copied, onCopy: _this2.onCopy });
	                                }
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'campaignBody', className: 'flexColumn' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: "60%", "@media (max-width: 884px)": { width: '100%' } } },
	                            _react2.default.createElement(
	                                'p',
	                                { id: 'campaignInfo' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { id: 'highlightedMsg' },
	                                    'This Dashain, we plan on donating at least ',
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        '100 T-Shirts'
	                                    ),
	                                    ' and we need ',
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'YOUR HELP to reach that target'
	                                    ),
	                                    '.'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Simply purchase any T-Shirts from our website and for every T-Shirts purchased during the period before Ghatasthapana, SetoCanvas Team will donate one T-Shirt to the campaign.'
	                                ),
	                                _react2.default.createElement('br', null),
	                                'SetoCanvas Team will also initially donate ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '25 T-Shirts'
	                                ),
	                                ' to the campaign. So help us donate the remaining ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '75 T-Shirts'
	                                ),
	                                '.'
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Contributers List ',
	                                    _react2.default.createElement('i', { className: 'fa fa-thumbs-o-up', 'aria-hidden': 'true' })
	                                )
	                            ),
	                            _react2.default.createElement(_AppElements.Separator, { style: { margin: '0px auto 25px auto', width: '100%' } }),
	                            _react2.default.createElement(
	                                'h2',
	                                { id: 'setoCanvasContribution' },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '- 25 T-Shirts from SetoCanvas Team'
	                                )
	                            ),
	                            _react2.default.createElement(ContributersList, { contributers: this.state.orders }),
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'contributeNowSecondBtn' },
	                                _react2.default.createElement(
	                                    _AppElements.Button,
	                                    { onClick: this.onContributeNowClick, mui: 'true', color: 'primary' },
	                                    'Contribute Now'
	                                )
	                            ),
	                            _react2.default.createElement('br', null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(FeaturedProductsModal, { open: this.state.openFeaturedProducts, products: this.state.featuredProducts, onClose: this.onFeaturedProductsModalClose }),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }]);
	
	    return BuyOneDonateOne;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(_utils.Container.create(BuyOneDonateOne));

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _HttpService2 = __webpack_require__(12);
	
	var _AppAction = __webpack_require__(22);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Note: Important!!!
	//import the class here, not the object
	
	
	var BASE_URL = _AppConstants2.default.BASE_API_URL + "/stock/owner";
	
	var StockOwnerAPI = function (_HttpService) {
	    _inherits(StockOwnerAPI, _HttpService);
	
	    function StockOwnerAPI() {
	        _classCallCheck(this, StockOwnerAPI);
	
	        return _possibleConstructorReturn(this, (StockOwnerAPI.__proto__ || Object.getPrototypeOf(StockOwnerAPI)).apply(this, arguments));
	    }
	
	    _createClass(StockOwnerAPI, [{
	        key: 'getAllOwners',
	        value: function getAllOwners() {
	            _get(StockOwnerAPI.prototype.__proto__ || Object.getPrototypeOf(StockOwnerAPI.prototype), 'get', this).call(this, "/list", function (response) {
	                _Dispatcher2.default.dispatch({
	                    type: _AppAction.StockAction.LOAD_STOCK_OWNERS,
	                    stockOwners: response.data
	                });
	            });
	        }
	    }, {
	        key: 'getStockOwner',
	        value: function getStockOwner(ownerName) {
	            _get(StockOwnerAPI.prototype.__proto__ || Object.getPrototypeOf(StockOwnerAPI.prototype), 'get', this).call(this, "/find?ownerAlias=" + ownerName, function (response) {
	                _Dispatcher2.default.dispatch({
	                    type: _AppAction.StockAction.LOAD_SINGLE_STOCK_OWNER,
	                    stockOwner: response.data
	                });
	            });
	        }
	    }]);
	
	    return StockOwnerAPI;
	}(_HttpService2.HttpService);
	
	exports.default = new StockOwnerAPI(BASE_URL);

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.NavBarContent = exports.DropDownNav = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _SearchInput = __webpack_require__(94);
	
	var _SearchInput2 = _interopRequireDefault(_SearchInput);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _dropdown = __webpack_require__(336);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _reactstrap = __webpack_require__(755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
		eachNav: { color: '#939598', textDecoration: 'none', flexGrow: '1', textAlign: 'right',
			'@media (max-width: 770px)': { textAlign: 'center' } },
		dropDownNav: { display: 'block', margin: '0', padding: '5px 10px', ':hover': { background: '#eee' }, textAlign: 'center' },
		navDivider: { margin: '5px 0' },
		searchBtn: { fontSize: '150%', marginLeft: '15px', color: 'rgb(248, 148, 28)', paddingTop: '5px', display: 'block', '@media (max-width: 770px)': { display: 'none' } },
		mobileSearchBtn: { color: 'rgb(248, 148, 28)' }
	};
	
	var displayOnlyMobileStyle = { display: 'none', '@media (max-width: 770px)': { display: 'block' } };
	
	var DropDownNav = exports.DropDownNav = function DropDownNav(_ref) {
		var session = _ref.session;
	
		var user = session.user;
		var userType = user.userType;
	
		return _react2.default.createElement(
			_dropdown2.default,
			{ label: session.user.username, alignMenu: 'center' },
			(userType === _AppConstants2.default.USER_TYPE.DESIGNER || userType === _AppConstants2.default.USER_TYPE.INFLUENCER || userType === _AppConstants2.default.USER_TYPE.PHOTOGRAPHER) && _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(
					_AppElements.A,
					{ href: '/designer/dashboard', style: [styles.eachNav, styles.dropDownNav] },
					'Dashboard'
				),
				_react2.default.createElement('hr', { style: styles.navDivider }),
				_react2.default.createElement(
					_AppElements.A,
					{ href: _AppUtil2.default.getDesignerURL(user), style: [styles.eachNav, styles.dropDownNav] },
					'My Page'
				),
				_react2.default.createElement(
					_AppElements.A,
					{ href: '/designer/coupons', style: [styles.eachNav, styles.dropDownNav] },
					'My Coupons'
				),
				_react2.default.createElement(
					_AppElements.A,
					{ href: '/withdrawals', style: [styles.eachNav, styles.dropDownNav] },
					'Withdrawal History'
				),
				_react2.default.createElement('hr', { style: styles.navDivider })
			),
			userType === _AppConstants2.default.USER_TYPE.ADMIN && _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(
					_AppElements.A,
					{ href: '/order/dashboard', style: [styles.eachNav, styles.dropDownNav] },
					'Admin Dashboard'
				),
				_react2.default.createElement('hr', { style: styles.navDivider })
			),
			userType === _AppConstants2.default.USER_TYPE.SALES && _react2.default.createElement(
				_AppElements.A,
				{ href: '/order/dashboard', style: [styles.eachNav, styles.dropDownNav] },
				'All Orders'
			),
			userType !== _AppConstants2.default.USER_TYPE.SALES && _react2.default.createElement(
				_AppElements.A,
				{ href: '/orders', style: [styles.eachNav, styles.dropDownNav] },
				'My Orders'
			),
			_react2.default.createElement('hr', { style: styles.navDivider }),
			_react2.default.createElement(
				_AppElements.A,
				{ href: '/settings', style: [styles.eachNav, styles.dropDownNav] },
				'Settings'
			),
			_react2.default.createElement(
				_AppElements.A,
				{ href: '/logout', style: [styles.eachNav, styles.dropDownNav] },
				'Logout'
			)
		);
	};
	
	var NavBarContent = exports.NavBarContent = (0, _radium2.default)(function (_ref2) {
		var influencers = _ref2.influencers,
		    popularStores = _ref2.popularStores,
		    onCloseClick = _ref2.onCloseClick;
	
	
		function createDropDowns(title, menuItems) {
			return _react2.default.createElement(
				_reactstrap.UncontrolledDropdown,
				{ nav: true, inNavbar: true },
				_react2.default.createElement(
					_reactstrap.DropdownToggle,
					{ nav: true, caret: true },
					title
				),
				_react2.default.createElement(
					_reactstrap.DropdownMenu,
					null,
					menuItems
				)
			);
		}
	
		var influencersLinks = !influencers ? [] : influencers.map(function (i) {
			return _react2.default.createElement(
				_AppElements.A,
				{ key: i.username, className: 'dropdown-item', href: _AppUtil2.default.getDesignerURL(i) },
				i.username
			);
		});
		var influencersDropDown = createDropDowns("Influencers", influencersLinks);
	
		var ARTISTS = _AppConstants2.default.TOP_ARTISTS.map(function (u) {
			return _react2.default.createElement(
				_AppElements.A,
				{ key: u.username, className: 'dropdown-item', href: _AppUtil2.default.getDesignerURL(u) },
				u.username
			);
		});
		ARTISTS.push(_react2.default.createElement(
			_AppElements.A,
			{ key: 'All Artists', style: { color: 'orange' }, className: 'dropdown-item', href: '/artist/all' },
			'View All'
		));
		var artistsDropDown = createDropDowns("Artists", ARTISTS);
	
		var storeLinks = !popularStores ? [] : popularStores.map(function (s) {
			return _react2.default.createElement(
				_AppElements.A,
				{ key: s.storeName, className: 'dropdown-item', href: _AppUtil2.default.getDesignerURL(s) },
				s.storeName
			);
		}).toArray();
		storeLinks.push(_react2.default.createElement(
			_AppElements.A,
			{ key: 'All Stores', style: { color: 'orange' }, className: 'dropdown-item', href: '/stores/all' },
			'View All'
		));
	
		var storesDropDown = createDropDowns("Top Stores", storeLinks);
	
		var PRODUCT_TYPES = Object.keys(_AppConstants2.default.PRODUCT_TYPES).map(function (k) {
			return _AppConstants2.default.PRODUCT_TYPES[k];
		}).filter(function (p) {
			return p.available === true;
		}).map(function (p) {
			return _react2.default.createElement(
				_AppElements.A,
				{ key: p.val, className: 'dropdown-item', href: "/shop/" + p.url },
				p.label
			);
		});
	
		var shopDropdowns = createDropDowns("Shop", PRODUCT_TYPES);
	
		return _react2.default.createElement(
			_reactstrap.Nav,
			{ navbar: true },
			onCloseClick !== undefined && _react2.default.createElement(
				_reactstrap.NavItem,
				null,
				_react2.default.createElement(
					_AppElements.A,
					{ href: '#', onClick: onCloseClick, className: 'closeNavBar' },
					_react2.default.createElement('i', { className: 'fa fa-times', 'aria-hidden': 'true' })
				)
			),
			_react2.default.createElement(
				_reactstrap.NavItem,
				null,
				_react2.default.createElement(
					_AppElements.A,
					{ href: '/' },
					'Home'
				)
			),
			_react2.default.createElement(
				_reactstrap.NavItem,
				null,
				_react2.default.createElement(
					_AppElements.A,
					{ href: '/custom-order/music-plaque', className: 'musicPlaqueNav' },
					_react2.default.createElement('i', { className: 'fa fa-music rotateClockWise', style: { color: '#f8951b' }, 'aria-hidden': 'true' }),
					' Music Plaque ',
					_react2.default.createElement('i', { className: 'fa fa-music rotateAntiClockWise', style: { color: '#f8951b' }, 'aria-hidden': 'true' })
				)
			),
			_react2.default.createElement(
				_reactstrap.NavItem,
				null,
				_react2.default.createElement(
					_AppElements.A,
					{ href: '/custom-order/photo-frame', className: 'photoFrameNav' },
					_react2.default.createElement(
						'span',
						null,
						'[ '
					),
					'Frame your Photo',
					_react2.default.createElement(
						'span',
						null,
						' ]'
					)
				)
			),
			shopDropdowns,
			influencersDropDown,
			artistsDropDown,
			storesDropDown,
			_react2.default.createElement(
				_reactstrap.NavItem,
				null,
				_react2.default.createElement('hr', { style: styles.navDivider })
			),
			_react2.default.createElement(
				'div',
				{ style: displayOnlyMobileStyle },
				_react2.default.createElement(
					_reactstrap.NavItem,
					null,
					_react2.default.createElement(
						_AppElements.A,
						{ href: _AppConstants2.default.FB_PAGE, style: { letterSpacing: '1px', textTransform: 'uppercase' }, className: 'facebookNav' },
						_react2.default.createElement('i', { className: 'fa fa-facebook-official', 'aria-hidden': 'true',
							style: { color: '#4267b1', fontWeight: 'bold' } }),
						' Facebook'
					)
				),
				_react2.default.createElement(
					_reactstrap.NavItem,
					null,
					_react2.default.createElement(
						_AppElements.A,
						{ href: _AppConstants2.default.INSTA_PAGE, className: 'instagramNav' },
						_react2.default.createElement('i', { className: 'fa fa-instagram', 'aria-hidden': 'true',
							style: { color: '#f8941c', fontWeight: 'bold' } }),
						' INSTAGRAM'
					)
				),
				_react2.default.createElement(
					_reactstrap.NavItem,
					{ style: { padding: '0' } },
					_react2.default.createElement(_SearchInput2.default, { keyword: "", btnStyle: styles.mobileSearchBtn })
				)
			),
			_react2.default.createElement(
				_reactstrap.NavItem,
				{ style: { padding: '0' } },
				_react2.default.createElement(
					_AppElements.A,
					{ href: "/search/", style: styles.searchBtn },
					_react2.default.createElement('i', { className: 'fa fa-search', 'aria-hidden': 'true' })
				)
			)
		);
	});
	
	var AppMenu = function (_React$Component) {
		_inherits(AppMenu, _React$Component);
	
		function AppMenu(props) {
			_classCallCheck(this, AppMenu);
	
			var _this = _possibleConstructorReturn(this, (AppMenu.__proto__ || Object.getPrototypeOf(AppMenu)).call(this, props));
	
			_this.toggle = _this.toggle.bind(_this);
			_this.state = {
				isOpen: false
			};
			return _this;
		}
	
		_createClass(AppMenu, [{
			key: 'toggle',
			value: function toggle() {
				this.setState({
					isOpen: !this.state.isOpen
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var defaultLogoStyle = { cursor: 'pointer', width: '80%', margin: '0 auto' };
	
				//show sticky logo only in web, because by default, the logo is visible in mobile
				var desktopStickyLogoStyle = { display: 'none', '@media (min-width: 770px)': { position: 'absolute', top: '5px', left: '160px', display: 'block', height: '49px', cursor: 'pointer' } };
	
				var logoImg = _AppUtil2.default.getAppLogo();
				var iconImg = _AppUtil2.default.getAppIcon();
				return _react2.default.createElement(
					'div',
					{ style: this.props.style, id: 'headerNavigation' },
					_AppUtil2.default.isDashainRunning() && _react2.default.createElement(
						'div',
						{ style: { background: '#f8941c', padding: '5px', textAlign: 'center', color: 'white', fontSize: '14px', borderTop: '1px solid white' } },
						_react2.default.createElement(
							'span',
							null,
							'Happy Dashain! All orders will be processed after Oct 13, 2019. '
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'span',
							null,
							'For any inquiry, call ',
							_AppConstants2.default.CONTACT_NUMBER,
							'.'
						)
					),
					_react2.default.createElement(
						_reactstrap.Navbar,
						{ color: 'light', light: true, expand: 'md' },
						_react2.default.createElement(
							_reactstrap.NavbarBrand,
							{ href: '/' },
							_react2.default.createElement('img', { src: iconImg, alt: 'Seto Canvas', style: [this.props.isSticky ? desktopStickyLogoStyle : { display: 'none' }] }),
							_react2.default.createElement('img', { src: logoImg, alt: 'Seto Canvas', style: [displayOnlyMobileStyle, defaultLogoStyle] })
						),
						_react2.default.createElement(_reactstrap.NavbarToggler, { onClick: this.props.onNavBarToggle }),
						_react2.default.createElement(
							_reactstrap.Collapse,
							{ isOpen: this.state.isOpen, navbar: true },
							_react2.default.createElement(NavBarContent, { influencers: this.props.influencers, popularStores: this.props.popularStores })
						)
					)
				);
			}
		}]);
	
		return AppMenu;
	}(_react2.default.Component);
	
	AppMenu = (0, _radium2.default)(AppMenu);
	
	exports.default = AppMenu;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArtistAvatar = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserAvatar = __webpack_require__(48);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SLIDER_SETTINGS = {
	  autoplay: false,
	  speed: 350,
	  infinite: false,
	  arrows: false,
	  cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
	  className: 'artistSlider',
	  variableWidth: true,
	  dots: true,
	  slidesToShow: 4,
	  slidesToScroll: 2,
	  swipeToSlide: true,
	  swipe: true,
	  responsive: [{
	    breakpoint: 1198,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 1,
	      swipeToSlide: true
	    }
	  }, {
	    breakpoint: 900,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 1,
	      swipeToSlide: true
	    }
	  }, {
	    breakpoint: 600,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      swipeToSlide: true,
	      arrows: true
	    }
	  }]
	};
	
	var AllArtistAvatar = function AllArtistAvatar() {
	  var user = { id: "allArtistAvatar", username: "All Artist" };
	
	  var link = "/artist/all";
	  return _react2.default.createElement(
	    'div',
	    { className: 'artistAvatar', id: 'allArtistPreview' },
	    _react2.default.createElement(
	      _AppElements.A,
	      { href: link, style: { textDecoration: 'none' } },
	      _react2.default.createElement(_UserAvatar2.default, { user: user })
	    ),
	    _react2.default.createElement(
	      _AppElements.A,
	      { href: link, className: 'artistName' },
	      'View All'
	    )
	  );
	};
	
	var ArtistAvatar = exports.ArtistAvatar = function ArtistAvatar(_ref) {
	  var user = _ref.user;
	
	  var userLink = user ? _AppUtil2.default.getDesignerURL(user) : "#";
	  var username = user ? user.username : "";
	  return _react2.default.createElement(
	    'div',
	    { className: 'artistAvatar' },
	    _react2.default.createElement(
	      _AppElements.A,
	      { href: userLink, style: { textDecoration: 'none' } },
	      _react2.default.createElement(_UserAvatar2.default, { user: user })
	    ),
	    _react2.default.createElement(
	      _AppElements.A,
	      { href: userLink, className: 'artistName' },
	      username
	    )
	  );
	};
	
	var ArtistSlider = function ArtistSlider(props) {
	  var users = props.users;
	
	  var avatars = null;
	  if (!users) {
	    avatars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(function (i) {
	      return _react2.default.createElement(ArtistAvatar, { user: null, key: "SliderArtistLoader_" + i });
	    });
	  } else {
	    avatars = users.map(function (u) {
	      return _react2.default.createElement(ArtistAvatar, { user: u, key: "SliderArtist" + u.username + "_" + u.id });
	    }).toArray();
	    avatars.push(_react2.default.createElement(AllArtistAvatar, { key: 'allArtist' }));
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'artistSlider' },
	    _react2.default.createElement(_AppElements.Title, { title: "ACTIVE ARTISTS" }),
	    _react2.default.createElement(
	      _reactSlick2.default,
	      SLIDER_SETTINGS,
	      avatars
	    )
	  );
	};
	
	exports.default = ArtistSlider;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _StorePreview = __webpack_require__(221);
	
	var _StorePreview2 = _interopRequireDefault(_StorePreview);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STORE_SLIDER_SETTINGS = {
		autoplay: false,
		speed: 350,
		infinite: false,
	
		cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
		className: 'storesSlider',
		variableWidth: true,
		dots: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		swipeToSlide: true,
		swipe: true,
		responsive: [{
			breakpoint: 1198,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				swipeToSlide: true
			}
		}, {
			breakpoint: 900,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				swipeToSlide: true
			}
		}, {
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				swipeToSlide: true,
				arrows: true,
				dots: false
			}
		}]
	};
	
	var StoreList = function (_React$Component) {
		_inherits(StoreList, _React$Component);
	
		function StoreList() {
			_classCallCheck(this, StoreList);
	
			return _possibleConstructorReturn(this, (StoreList.__proto__ || Object.getPrototypeOf(StoreList)).apply(this, arguments));
		}
	
		_createClass(StoreList, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//start from first slide on every update
				this.slide.slickGoTo(0);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var storesDiv = null;
	
				if (this.props.stores) {
					storesDiv = this.props.stores.map(function (store) {
						return _react2.default.createElement(_StorePreview2.default, { store: store, key: store.storeName });
					});
	
					if (this.props.appendViewAll === true) {
						var allStorePreview = _react2.default.createElement(_StorePreview.AllStoresPreview, { key: 'allStores' });
						storesDiv.push(allStorePreview);
					}
				} else {
					storesDiv = [1, 2, 3, 4].map(function (i) {
						return _react2.default.createElement(_StorePreview2.default, { store: null, key: "StoreLoader_" + i });
					});
				}
	
				return _react2.default.createElement(
					'div',
					{ style: { paddingBottom: '25px' }, id: 'storesList' },
					_react2.default.createElement(_AppElements.Title, { title: this.props.title }),
					_react2.default.createElement(
						_reactSlick2.default,
						Object.assign({}, STORE_SLIDER_SETTINGS, { ref: function ref(r) {
								return _this2.slide = r;
							} }),
						storesDiv
					)
				);
			}
		}]);
	
		return StoreList;
	}(_react2.default.Component);
	
	exports.default = StoreList;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AllStoresPreview = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _UserAvatar = __webpack_require__(48);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AllStoresPreview = exports.AllStoresPreview = function AllStoresPreview() {
		var avatar = { id: "allStoreAvatar", storeName: "Stores" };
		var storeLink = "/stores/all";
		return _react2.default.createElement(
			'div',
			{ className: 'storeDiv flexColumn', id: 'allStoresPreview' },
			_react2.default.createElement(
				_AppElements.A,
				{ href: storeLink, className: 'storeAvatar' },
				_react2.default.createElement(_UserAvatar2.default, { user: avatar })
			),
			_react2.default.createElement(
				_AppElements.A,
				{ href: storeLink, className: 'storeTitle' },
				'View All'
			)
		);
	};
	
	var StorePreview = function (_React$Component) {
		_inherits(StorePreview, _React$Component);
	
		function StorePreview() {
			_classCallCheck(this, StorePreview);
	
			return _possibleConstructorReturn(this, (StorePreview.__proto__ || Object.getPrototypeOf(StorePreview)).apply(this, arguments));
		}
	
		_createClass(StorePreview, [{
			key: 'render',
			value: function render() {
				var name = null;
				var store = this.props.store;
	
				if (store) name = store.storeName;
	
				var storeLink = store ? _AppUtil2.default.getDesignerURL(store) : "#";
				return _react2.default.createElement(
					'div',
					{ className: 'storeDiv flexColumn' },
					_react2.default.createElement(
						_AppElements.A,
						{ href: storeLink, className: 'storeAvatar' },
						_react2.default.createElement(_UserAvatar2.default, { user: store })
					),
					_react2.default.createElement(
						_AppElements.A,
						{ href: storeLink, className: 'storeTitle' },
						name
					)
				);
			}
		}]);
	
		return StorePreview;
	}(_react2.default.Component);
	
	exports.default = StorePreview;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ImgUploadForm = exports.AddedImagePreview = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _SelectedImagePreview = __webpack_require__(64);
	
	var _SelectedImagePreview2 = _interopRequireDefault(_SelectedImagePreview);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _reactYoutube = __webpack_require__(667);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _ProductSizeInput = __webpack_require__(577);
	
	var _ProductSizeInput2 = _interopRequireDefault(_ProductSizeInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRODUCT_IMAGES_LMT = 2;
	var DIGITAL_ART_IMG_CONSTRAINT = "At least 600px x 600px, Max 50-200 Kb";
	var PHOTOGRAPH_IMG_CONSTRAINT = "At least 800px in height or width, Max 50-200 Kb";
	
	var ARTWORK_TYPES = _AppConstants2.default.ARTWORK_TYPES;
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	
	var CANVAS_TO_CASH_VIDEOS = ["https://www.youtube.com/watch?v=glAyGdc5pLU", "https://www.youtube.com/watch?v=Uog8mQVfozM", "https://www.youtube.com/watch?v=Em3VXKonS_A", "https://www.youtube.com/watch?v=tK1Ycf_lAFk", "https://www.youtube.com/watch?v=RYFQwOclCmw"];
	
	var DESIGN_VIDEOS = ["https://www.youtube.com/watch?v=0APtVvBBUpI", "https://www.youtube.com/watch?v=qfjbt4DvO8Y", "https://www.youtube.com/watch?v=v2RmHH1M16w", "https://www.youtube.com/watch?v=eAPrv--96u4", "https://www.youtube.com/watch?v=fONvLV7sDGk", "https://www.youtube.com/watch?v=nHRH-96dpEI"];
	
	var DEFAULT_SLIDER_SETTINGS = {
		speed: 350,
		infinite: false,
		className: 'designVideosSlider',
		cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
		variableWidth: true,
		dots: true,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		swipeToSlide: true,
		swipe: true
	};
	
	var AccountPendingMsg = function AccountPendingMsg() {
	
		return _react2.default.createElement(
			'div',
			{ style: { padding: '10px 10px', textAlign: 'center', margin: '10px 0', background: '#f8931b', color: 'white' } },
			'Your account is pending approval! You cannot upload a design until your account is approved.'
		);
	};
	
	var VideoSlider = function VideoSlider(_ref) {
		var title = _ref.title,
		    videos = _ref.videos;
	
		var playerOpts = { width: '100%', height: '100%',
			playerVars: { autoplay: 0 }
		};
	
		var thumbnails = videos.map(function (url) {
			return _AppUtil2.default.fetchYoutubeVideoID(url);
		}).map(function (videoId) {
			return _react2.default.createElement(
				'div',
				{ className: 'ytThumbnailHolder', key: videoId },
				_react2.default.createElement(_reactYoutube2.default, { key: videoId, videoId: videoId, opts: playerOpts, className: 'ytThumbnail' })
			);
		});
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'h3',
				null,
				title
			),
			_react2.default.createElement(
				_reactSlick2.default,
				DEFAULT_SLIDER_SETTINGS,
				thumbnails
			)
		);
	};
	
	var PhoneNumberForm = function (_React$Component) {
		_inherits(PhoneNumberForm, _React$Component);
	
		function PhoneNumberForm(props) {
			_classCallCheck(this, PhoneNumberForm);
	
			var _this = _possibleConstructorReturn(this, (PhoneNumberForm.__proto__ || Object.getPrototypeOf(PhoneNumberForm)).call(this, props));
	
			_this.INIT_VALUES = { phoneNumber: '' };
			_this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
			return _this;
		}
	
		_createClass(PhoneNumberForm, [{
			key: 'validationScheme',
			value: function validationScheme() {
				var phoneNumberErrMsg = "Enter your 10 digit phone number.";
	
				return _yup2.default.object().shape({
					phoneNumber: _yup2.default.string().required(phoneNumberErrMsg).matches(/^[0-9]{10}$/, phoneNumberErrMsg)
				});
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(value, _ref2) {
				var setSubmitting = _ref2.setSubmitting,
				    resetForm = _ref2.resetForm;
	
				_HttpService2.default.updatePhone(value.phoneNumber, function (success) {
					setSubmitting(false);
					if (success) {
						resetForm();
						this.props.onClose();
					}
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_reactResponsiveModal2.default,
					{ closeOnOverlayClick: false, open: this.props.openPhoneNumberModal,
						onClose: this.props.onClose, little: true,
						classNames: { overlay: 'phonenumber-overlay', modal: 'phonenumber-modal', closeIcon: 'phonenumber-close-icon' } },
					_react2.default.createElement(_formik.Formik, { initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
						validationSchema: this.validationScheme,
						render: function render(_ref3) {
							var isSubmitting = _ref3.isSubmitting;
	
	
							var submitBtn = 'Submit';
	
							if (isSubmitting === true) submitBtn = _react2.default.createElement(
								'span',
								null,
								'Submitting ',
								_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
							);
	
							return _react2.default.createElement(
								_FormElements.RGForm,
								null,
								_react2.default.createElement(
									'h3',
									{ style: { margin: '10px 0px 20px 0' } },
									'We will contact you when your design is approved!'
								),
								_react2.default.createElement(_FormElements.Input, { type: 'text', label: 'Provide your 10-digit phone number:', name: 'phoneNumber' }),
								_react2.default.createElement(
									_FormElements.SubmitButton,
									{ color: 'primary', disabled: isSubmitting },
									submitBtn
								)
							);
						} })
				);
			}
		}]);
	
		return PhoneNumberForm;
	}(_react2.default.Component);
	
	;
	
	var AddedImagePreview = exports.AddedImagePreview = function AddedImagePreview(_ref4) {
		var id = _ref4.id,
		    file = _ref4.file,
		    onRemove = _ref4.onRemove;
	
		return _react2.default.createElement(
			'div',
			{ className: 'uploadedPreviewImg' },
			_react2.default.createElement(
				'span',
				{ className: 'closeUploadedPic', onClick: onRemove },
				_react2.default.createElement('i', { className: 'fa fa-window-close-o', 'aria-hidden': 'true' })
			),
			_react2.default.createElement(_SelectedImagePreview2.default, { id: id, file: file })
		);
	};
	
	var ImgUploadForm = exports.ImgUploadForm = function ImgUploadForm(_ref5) {
		var inputId = _ref5.inputId,
		    onChange = _ref5.onChange;
	
	
		return _react2.default.createElement(
			'div',
			{ className: 'imgUploadForm' },
			_react2.default.createElement('input', { style: { display: 'none' }, id: inputId, name: inputId, type: 'file', accept: '.png, .jpg, .jpeg',
				onChange: onChange }),
			_react2.default.createElement(
				'label',
				{ htmlFor: inputId, className: 'imgUploader' },
				_react2.default.createElement('i', { className: 'fa fa-plus', 'aria-hidden': 'true' })
			)
		);
	};
	
	function isStepOneFilled(values) {
		if (!values.productType || !values.artworkType) return false;
	
		if (values.productType === 'OTHER' && !values.otherCategory) return false;
	
		return true;
	}
	
	var StepOne = function StepOne(_ref6) {
		var values = _ref6.values,
		    onArtWorkSelect = _ref6.onArtWorkSelect;
	
		var currentUser = _SessionStore2.default.getCurrentSession() ? _SessionStore2.default.getCurrentSession().user : null;
		var isAdminUser = currentUser && currentUser.userType === _AppConstants2.default.USER_TYPE.ADMIN;
	
		var artworkType = ARTWORK_TYPES[values.artworkType];
		var productTypeOptions = Object.keys(PRODUCT_TYPES).map(function (k) {
			return PRODUCT_TYPES[k];
		}).filter(function (p) {
			return p.available === true;
		}).filter(function (p) {
			return artworkType.supportedProductTypes.indexOf(p.val) >= 0;
		}).map(function (p) {
			return { 'label': p.label,
				'value': p.val };
		});
	
		var productType = PRODUCT_TYPES[values.productType];
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'submitStep flexRow' },
				_react2.default.createElement(
					'span',
					null,
					'Step'
				),
				' ',
				_react2.default.createElement(
					'span',
					{ className: 'stepCount' },
					'1'
				)
			),
			isAdminUser && _react2.default.createElement(_FormElements.Input, { label: 'User Id: ', name: 'userId', type: 'text' }),
			_react2.default.createElement(
				'div',
				{ className: 'flexColumn' },
				_react2.default.createElement(
					'label',
					{ style: { margin: '0 0 10px 0', display: 'block' } },
					'Artwork Type:'
				),
				_react2.default.createElement(
					'div',
					{ className: 'flexRow' },
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'artworkType', value: ARTWORK_TYPES.DIGITAL_ART.val,
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							ARTWORK_TYPES.DIGITAL_ART.label
						),
						checked: values.artworkType === ARTWORK_TYPES.DIGITAL_ART.val,
						onChange: function onChange() {
							return onArtWorkSelect(ARTWORK_TYPES.DIGITAL_ART.val);
						}
					}),
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'artworkType', value: ARTWORK_TYPES.PHOTOGRAPH.val,
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							ARTWORK_TYPES.PHOTOGRAPH.label
						),
						checked: values.artworkType === ARTWORK_TYPES.PHOTOGRAPH.val,
						onChange: function onChange() {
							return onArtWorkSelect(ARTWORK_TYPES.PHOTOGRAPH.val);
						}
					}),
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'artworkType', value: ARTWORK_TYPES.PHYSICAL_ART.val,
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							ARTWORK_TYPES.PHYSICAL_ART.label
						),
						checked: values.artworkType === ARTWORK_TYPES.PHYSICAL_ART.val,
						onChange: function onChange() {
							return onArtWorkSelect(ARTWORK_TYPES.PHYSICAL_ART.val);
						}
					})
				),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'label',
					{ style: { margin: '0 0 10px 0', display: 'block' } },
					'Select Product Type:'
				),
				_react2.default.createElement(_FormElements.ComboBox, { name: 'productType', value: values.productType,
					options: productTypeOptions,
					style: { flexGrow: '1', minWidth: '50%' } }),
				productType && productType.psdTemplateUrl && _react2.default.createElement(
					'span',
					{ style: { background: '#f8921d', padding: '5px 10px', color: 'white', borderBottom: '2px solid rgb(61, 61, 61)' } },
					_react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
						' Use ',
						_react2.default.createElement(
							_AppElements.A,
							{ href: productType.psdTemplateUrl, style: { textDecoration: 'underline', fontWeight: 'bold', color: '#3d3d3d' } },
							productType.label,
							'.psd'
						),
						' to put your ',
						artworkType.label,
						' on a ',
						productType.label,
						'.'
					)
				),
				productType && productType.val === 'OTHER' && _react2.default.createElement(_FormElements.Input, { label: 'Category: ', name: 'otherCategory', type: 'text' })
			)
		);
	};
	
	var StepTwo = function StepTwo(_ref7) {
		var values = _ref7.values,
		    designImage = _ref7.designImage,
		    productImages = _ref7.productImages,
		    onDesignUpdate = _ref7.onDesignUpdate,
		    onProductImgsUpdate = _ref7.onProductImgsUpdate;
	
		if (!isStepOneFilled(values)) return null;
	
		function onDesignUpload() {
			var file = document.getElementById("designImageFile").files[0];
			// setDesignImage(file);
			onDesignUpdate(file);
		}
	
		function clearDesignImg() {
			// setDesignImage(null);
			onDesignUpdate(null);
		}
	
		function onProductImgUpload(inputId) {
			var files = document.getElementById(inputId).files;
	
			var filesArr = [];
			for (var i = 0; i < files.length; i++) {
				filesArr[i] = files[i];
			} //the productImages state is read only
			var newProductImages = filesArr.concat(productImages);
			newProductImages.reverse();
			onProductImgsUpdate(newProductImages);
		}
	
		function clearProductImage(index) {
			//the productImages state is read only
			var newProductImages = productImages.concat([]);
			newProductImages.splice(index, 1);
			onProductImgsUpdate(newProductImages);
		}
	
		var imgConstraint = values.artworkType === ARTWORK_TYPES["PHOTOGRAPH"].val ? PHOTOGRAPH_IMG_CONSTRAINT : DIGITAL_ART_IMG_CONSTRAINT;
		var imgConstraintInfo = _react2.default.createElement(
			'span',
			{ style: { fontSize: '70%', color: 'black' } },
			'(',
			imgConstraint,
			')'
		);
		var productImgConstraintInfo = _react2.default.createElement(
			'span',
			{ style: { fontSize: '70%', color: 'black' } },
			'(',
			imgConstraint + ", at least 1",
			')'
		);
	
		var productImagesPreview = productImages.map(function (img, i) {
			var preview = _react2.default.createElement(AddedImagePreview, { key: "productImage_" + i, id: "productImage_" + i, file: img, onRemove: function onRemove() {
					return clearProductImage(i);
				} });
			return preview;
		});
	
		var productUploaderSize = productImagesPreview ? PRODUCT_IMAGES_LMT - productImagesPreview.length : PRODUCT_IMAGES_LMT;
		var productImgUploaders = [].concat(_toConsumableArray(Array(productUploaderSize).keys())).map(function (i) {
			var inputId = "productImageFile_" + i;
			return _react2.default.createElement(ImgUploadForm, { inputId: inputId, key: inputId, onChange: function onChange() {
					return onProductImgUpload(inputId);
				} });
		});
	
		var artworkType = ARTWORK_TYPES[values.artworkType];
		var productType = _AppConstants2.default.PRODUCT_TYPES[values.productType];
	
		var learnMore = null;
		if (productType === _AppConstants2.default.PRODUCT_TYPES.T_SHIRT) learnMore = _react2.default.createElement(
			'small',
			{ style: { fontSize: '90%' } },
			_react2.default.createElement(
				_AppElements.A,
				{ href: '/faq#tshirtDesignLimitation' },
				'Learn More!'
			)
		);else if (productType === _AppConstants2.default.PRODUCT_TYPES.HOODIES) learnMore = _react2.default.createElement(
			'small',
			{ style: { fontSize: '90%' } },
			_react2.default.createElement(
				_AppElements.A,
				{ href: '/faq#hoodiesDesignLimitation' },
				'Learn More!'
			)
		);
	
		var productLabel = productType.val !== 'OTHER' ? productType.label : values.otherCategory;
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'submitStep flexRow' },
				_react2.default.createElement(
					'span',
					null,
					'Step'
				),
				' ',
				_react2.default.createElement(
					'span',
					{ className: 'stepCount' },
					'2'
				)
			),
			productType.previewRequired === true && _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ id: 'designImgUploader', style: { minWidth: '100px', minHeight: '150px' } },
					_react2.default.createElement(
						'label',
						null,
						_react2.default.createElement(
							'span',
							null,
							'Add ',
							artworkType.label,
							' Image: '
						),
						imgConstraintInfo
					),
					!designImage && _react2.default.createElement(
						'div',
						{ style: { marginBottom: '20px' } },
						_react2.default.createElement(ImgUploadForm, { inputId: 'designImageFile', onChange: onDesignUpload }),
						_react2.default.createElement(_FormElements.Input, { id: 'designImage', name: 'designImage', mui: 'off', type: 'hidden' })
					),
					designImage && _react2.default.createElement(
						'div',
						{ className: 'flexRow', style: { marginBottom: '20px' } },
						_react2.default.createElement(AddedImagePreview, { id: "designImagePreview", file: designImage, onRemove: clearDesignImg })
					)
				),
				_react2.default.createElement(_AppElements.Separator, null)
			),
			_react2.default.createElement(
				'div',
				{ id: 'productImgUploader', style: { minWidth: '100px', minHeight: '150px' } },
				_react2.default.createElement(
					'label',
					null,
					_react2.default.createElement(
						'span',
						null,
						'Add ',
						productLabel,
						' Image: ',
						learnMore
					),
					productImgConstraintInfo
				),
				_react2.default.createElement(
					'div',
					{ className: 'flexRow' },
					productImagesPreview && _react2.default.createElement(
						'div',
						{ className: 'flexRow' },
						productImagesPreview
					),
					productImgUploaders && _react2.default.createElement(
						'div',
						{ className: 'flexRow' },
						productImgUploaders
					)
				),
				_react2.default.createElement(_FormElements.Input, { id: 'productImage', name: 'productImage', mui: 'off', type: 'hidden' })
			)
		);
	};
	
	var StepThree = function StepThree(_ref8) {
		var values = _ref8.values,
		    setFieldValue = _ref8.setFieldValue,
		    productTagOptions = _ref8.productTagOptions,
		    isSubmitting = _ref8.isSubmitting;
	
		if (!isStepOneFilled(values)) return null;
	
		var submitBtn = _react2.default.createElement(
			'span',
			null,
			_react2.default.createElement('i', { className: 'fa fa-cloud-upload', 'aria-hidden': 'true' }),
			' Submit'
		);
	
		if (isSubmitting === true) submitBtn = _react2.default.createElement(
			'span',
			null,
			_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' }),
			' Submitting'
		);
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'submitStep flexRow' },
				_react2.default.createElement(
					'span',
					null,
					'Step'
				),
				' ',
				_react2.default.createElement(
					'span',
					{ className: 'stepCount' },
					'3'
				)
			),
			values.artworkType === ARTWORK_TYPES.PHYSICAL_ART.val && _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_FormElements.Input, { label: _react2.default.createElement(
						'span',
						null,
						'Price: (Rs.)'
					), name: 'productPrice', type: 'number' }),
				_react2.default.createElement(
					'small',
					{ style: { color: 'gray', marginBottom: '20px', display: 'block' } },
					'*MRP will later get calculated adding ',
					_AppConstants2.default.APP_NAME,
					' logistic and operational cost and VAT.'
				)
			),
			_react2.default.createElement(_FormElements.Input, { label: 'Title: ', name: 'title', type: 'text' }),
			values.artworkType === ARTWORK_TYPES.PHYSICAL_ART.val && _react2.default.createElement(_ProductSizeInput2.default, { values: values, setFieldValue: setFieldValue }),
			_react2.default.createElement(
				'label',
				{ style: { margin: '0 0 10px 0', display: 'block' } },
				'Select Tags or Enter new:'
			),
			_react2.default.createElement(_FormElements.ComboBox, { name: 'productTags', value: values.productTags,
				options: productTagOptions, placeholder: 'Select Tags or Enter new (Optional)',
				multi: true,
				closeOnSelect: true,
				creatable: true
			}),
			_react2.default.createElement(
				'label',
				{ style: { margin: '0 0 10px 0', display: 'block' } },
				'Description:'
			),
			_react2.default.createElement(_FormElements.TextArea, { placeholder: "Add a short info of your design (Optional)", name: 'description', rows: '1' }),
			_react2.default.createElement(
				_FormElements.SubmitButton,
				{ color: 'primary', disabled: isSubmitting },
				submitBtn
			),
			values.artworkType === ARTWORK_TYPES.PHOTOGRAPH.val && _react2.default.createElement(
				'div',
				{ className: 'highlightInfo' },
				_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
				' You must also email your original photograph image at: ',
				_react2.default.createElement(
					'b',
					null,
					'setocanvas@gmail.com'
				),
				'.'
			),
			values.artworkType === ARTWORK_TYPES.DIGITAL_ART.val && _react2.default.createElement(
				'div',
				{ className: 'highlightInfo' },
				_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
				' You must also email a ',
				_react2.default.createElement(
					'b',
					null,
					'300 resolution A4 size .png file (background less)'
				),
				' of your design at: ',
				_react2.default.createElement(
					'b',
					null,
					'setocanvas@gmail.com'
				),
				'.'
			)
		);
	};
	
	var SubmitProductForm = function (_React$Component2) {
		_inherits(SubmitProductForm, _React$Component2);
	
		function SubmitProductForm(props) {
			_classCallCheck(this, SubmitProductForm);
	
			var _this2 = _possibleConstructorReturn(this, (SubmitProductForm.__proto__ || Object.getPrototypeOf(SubmitProductForm)).call(this, props));
	
			_this2.validationScheme = _this2.validationScheme.bind(_this2);
			_this2.handleFormSubmission = _this2.handleFormSubmission.bind(_this2);
			_this2.INIT_VALUES = _this2.initializeValues();
	
			_this2.DESIGN_IMAGE = null;
			_this2.PRODUCT_IMAGES = [];
	
			_this2.state = { openPhoneNumberModal: false };
			_this2.handlePhoneNumberModalClose = _this2.handlePhoneNumberModalClose.bind(_this2);
			_this2.handleOnDesignImageUpload = _this2.handleOnDesignImageUpload.bind(_this2);
			_this2.handleOnProductImagesUpload = _this2.handleOnProductImagesUpload.bind(_this2);
			_this2.handleOnArtWorkSelect = _this2.handleOnArtWorkSelect.bind(_this2);
			return _this2;
		}
	
		_createClass(SubmitProductForm, [{
			key: 'initializeValues',
			value: function initializeValues() {
				var productType = '',
				    artworkType = ARTWORK_TYPES['DIGITAL_ART'].val;
	
				var currentUser = _SessionStore2.default.getCurrentSession() ? _SessionStore2.default.getCurrentSession().user : null;
	
				//set photograph and frame by default for Photographer user
				if (currentUser && currentUser.userType === _AppConstants2.default.USER_TYPE.PHOTOGRAPHER) {
					artworkType = ARTWORK_TYPES['PHOTOGRAPH'].val;
					productType = _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val;
				}
	
				return { userId: '', title: '', description: '',
					designImage: '', artworkType: artworkType, productType: productType,
					productImage: '', productTags: [],
					productPrice: '',
					otherCategory: '',
					productSizes: ''
				};
			}
		}, {
			key: 'clearUploadedFiles',
			value: function clearUploadedFiles() {
				this.DESIGN_IMAGE = null;
				this.PRODUCT_IMAGES = [];
			}
		}, {
			key: 'handleOnDesignImageUpload',
			value: function handleOnDesignImageUpload(designImage, setFieldValue) {
				this.DESIGN_IMAGE = designImage;
				setFieldValue('designImage', designImage ? '1' : ''); //set a non-empty string to indicate the value has been set
			}
		}, {
			key: 'handleOnProductImagesUpload',
			value: function handleOnProductImagesUpload(productImages, setFieldValue) {
				this.PRODUCT_IMAGES = productImages;
				setFieldValue('productImage', productImages.length > 0 ? '1' : ''); //set a non-empty string to indicate the value has been set
			}
		}, {
			key: 'handleOnArtWorkSelect',
			value: function handleOnArtWorkSelect(selectedArtwork, currentProductType, setFieldValue) {
				setFieldValue('artworkType', selectedArtwork);
				setFieldValue('productType', '');
			}
		}, {
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					title: _yup2.default.string().required("Enter a title that defines your artwork"),
					designImage: _yup2.default.string().when('productType', function (productType, schema) {
						return productType && _AppConstants2.default.PRODUCT_TYPES[productType].previewRequired ? _yup2.default.string().required("Add your artwork image") : _yup2.default.string();
					}),
					artworkType: _yup2.default.string().required("Select artwork type"),
					productType: _yup2.default.string().required("Select a product type"),
					productTags: _yup2.default.array().max(5, "Maximum 5 tags allowed"),
					productImage: _yup2.default.string().required("Add product image with your artwork"),
					otherCategory: _yup2.default.string().when('productType', function (productType, schema) {
						return productType && productType === 'OTHER' ? _yup2.default.string().required("Enter the category your Art belongs to") : _yup2.default.string();
					}),
					productPrice: _yup2.default.string().when('artworkType', function (artworkType, schema) {
						return artworkType && _AppConstants2.default.ARTWORK_TYPES.PHYSICAL_ART.val === artworkType ? _yup2.default.string().required("Enter your product price") : _yup2.default.string();
					}),
					productSizes: _yup2.default.mixed().when('artworkType', function (artworkType, schema) {
						if (artworkType && _AppConstants2.default.ARTWORK_TYPES.PHYSICAL_ART.val === artworkType) {
							return _yup2.default.mixed().required("Enter available sizes of your Artwork");
						} else return _yup2.default.mixed();
					})
				});
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(value, _ref9) {
				var setSubmitting = _ref9.setSubmitting,
				    resetForm = _ref9.resetForm,
				    setFieldValue = _ref9.setFieldValue;
	
				var selectedArtWorkType = value.artworkType;
				var selectedProductType = value.productType;
	
				var title = value.title;
	
				if (value.otherCategory !== '') title += " - " + value.otherCategory;
	
				var addProductRequest = { title: title, description: value.description,
					artworkType: selectedArtWorkType, productType: selectedProductType,
					productTags: value.productTags };
	
				if (value.productPrice) addProductRequest.productPrice = value.productPrice;
	
				if (value.userId) addProductRequest['userId'] = value.userId;
	
				if (value.productSizes) addProductRequest['sizeMetaData'] = value.productSizes;
	
				_HttpService2.default.addProduct(addProductRequest, this.DESIGN_IMAGE, this.PRODUCT_IMAGES, function (success) {
					if (!success) {
						setSubmitting(false);
						return;
					}
	
					//check if it needs to upgrade to designer or not
					var currentUser = _SessionStore2.default.getCurrentSession().user;
					if (currentUser.userType === _AppConstants2.default.USER_TYPE.REGULAR) {
						_HttpService2.default.upgradeToDesigner(function (success) {
							this.doneDesignSubmission(success, setSubmitting, resetForm);
	
							setFieldValue('artworkType', selectedArtWorkType);
							setFieldValue('productType', selectedProductType);
						}.bind(this));
					} else {
						this.doneDesignSubmission(true, setSubmitting, resetForm);
						setFieldValue('artworkType', selectedArtWorkType);
						setFieldValue('productType', selectedProductType);
					}
				}.bind(this));
			}
		}, {
			key: 'doneDesignSubmission',
			value: function doneDesignSubmission(success, setSubmitting, resetForm) {
				setSubmitting(false);
	
				if (success) {
					this.clearUploadedFiles();
					resetForm();
					_AppUtil2.default.scrollToElement("submitProductForm", { behavior: 'smooth' });
					var currentUser = _SessionStore2.default.getCurrentSession().user;
	
					if (!currentUser.phoneNumber) {
						//show phone number modal
						this.setState({ openPhoneNumberModal: true });
					}
				}
			}
		}, {
			key: 'handlePhoneNumberModalClose',
			value: function handlePhoneNumberModalClose() {
				this.setState({ openPhoneNumberModal: false });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var productTagOptions = _AppConstants2.default.DEFAULT_PRODUCT_TAGS.map(function (v) {
					return { 'label': v.toUpperCase(), 'value': v.toLowerCase() };
				});
	
				var currentUser = _SessionStore2.default.getCurrentSession() ? _SessionStore2.default.getCurrentSession().user : null;
				return _react2.default.createElement(
					'div',
					{ id: 'submitProductForm' },
					currentUser && currentUser.userStatus === "PENDING_APPROVAL" && _react2.default.createElement(AccountPendingMsg, null),
					_react2.default.createElement(
						'h3',
						null,
						'Submit Your Design'
					),
					_react2.default.createElement(_formik.Formik, { initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
						validationSchema: this.validationScheme,
						render: function render(_ref10) {
							var values = _ref10.values,
							    setFieldValue = _ref10.setFieldValue,
							    isSubmitting = _ref10.isSubmitting;
	
							return _react2.default.createElement(
								_FormElements.RGForm,
								null,
								_react2.default.createElement(StepOne, { values: values, onArtWorkSelect: function onArtWorkSelect(selectedArtWork) {
										_this3.handleOnArtWorkSelect(selectedArtWork, values.productType, setFieldValue);
									} }),
								_react2.default.createElement(StepTwo, { values: values, designImage: _this3.DESIGN_IMAGE, productImages: _this3.PRODUCT_IMAGES,
									onDesignUpdate: function onDesignUpdate(designImg) {
										_this3.handleOnDesignImageUpload(designImg, setFieldValue);
									}, onProductImgsUpdate: function onProductImgsUpdate(productImages) {
										_this3.handleOnProductImagesUpload(productImages, setFieldValue);
									} }),
								_react2.default.createElement(StepThree, { values: values, setFieldValue: setFieldValue, productTagOptions: productTagOptions, isSubmitting: isSubmitting })
							);
						} }),
					_react2.default.createElement(
						'div',
						{ id: 'designVideos' },
						_react2.default.createElement(VideoSlider, { title: 'Canvas To Cash - Tutorials', videos: CANVAS_TO_CASH_VIDEOS }),
						_react2.default.createElement('br', null),
						_react2.default.createElement(VideoSlider, { title: 'Other Videos', videos: DESIGN_VIDEOS })
					),
					_react2.default.createElement(PhoneNumberForm, { openPhoneNumberModal: this.state.openPhoneNumberModal, onClose: this.handlePhoneNumberModalClose })
				);
			}
		}]);
	
		return SubmitProductForm;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(SubmitProductForm);

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	__webpack_require__(600);
	
	var _OrderForm = __webpack_require__(36);
	
	var _OrderForm2 = _interopRequireDefault(_OrderForm);
	
	var _ImgUploadForm = __webpack_require__(93);
	
	var _ImgUploadForm2 = _interopRequireDefault(_ImgUploadForm);
	
	var _ProductOrderForm2 = __webpack_require__(96);
	
	var _ProductOrderForm3 = _interopRequireDefault(_ProductOrderForm2);
	
	var _ProductUtil = __webpack_require__(74);
	
	var _ProductUtil2 = _interopRequireDefault(_ProductUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MUSIC_PLAYER_BOTTOM_POS = "Bottom Position";
	var MUSIC_PLAYER_TOP_POS = "Top Position";
	
	var styles = {
		extraCostInfo: { color: '#2e292b', marginTop: '10px', background: '#dfdfdf', padding: '5px 10px', borderBottom: "2px solid #f8931c", fontWeight: 'bold' }
	};
	
	var MusicPlaqueVariant = function MusicPlaqueVariant(_ref) {
		var productVariant = _ref.productVariant,
		    selectedVariant = _ref.selectedVariant;
	
		var variantKey = _ProductUtil2.default.getProductVariantKey(productVariant);
	
		var selectedVariantDetail = null;
		var radioButtons = productVariant.variants.filter(function (v) {
			return v.visible === true;
		}).map(function (v) {
			var isChecked = selectedVariant === v.variantId;
	
			if (isChecked) selectedVariantDetail = v;
			return _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: variantKey,
				value: v.variantId,
				label: _react2.default.createElement(
					'span',
					{ style: { color: '#596161' } },
					v.label
				),
				checked: isChecked,
				key: v.variantId });
		});
	
		var priceAddition = selectedVariantDetail ? selectedVariantDetail.priceAddition || 0 : 0;
		return _react2.default.createElement(
			_react2.default.Fragment,
			null,
			_react2.default.createElement(
				'label',
				null,
				productVariant.variantLabel
			),
			_react2.default.createElement(
				'div',
				{ className: 'flexRow' },
				radioButtons
			),
			selectedVariantDetail && priceAddition > 0 && _react2.default.createElement(
				'div',
				{ style: styles.extraCostInfo },
				_react2.default.createElement(
					'span',
					{ style: { color: '#f49600' } },
					'Extra Rs. ',
					_AppUtil2.default.formatNumber(priceAddition)
				),
				' for \'',
				selectedVariantDetail.label,
				'\''
			)
		);
	};
	
	var MusicPlaqueInput = function MusicPlaqueInput(_ref2) {
		var isAcryclicPlaque = _ref2.isAcryclicPlaque;
	
		var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
		    values = _useContext.values,
		    product = _useContext.product,
		    setFieldValue = _useContext.setFieldValue;
	
		var musicPlayerOptions = [MUSIC_PLAYER_BOTTOM_POS, MUSIC_PLAYER_TOP_POS].map(function (p) {
			return { label: p, value: p };
		});
	
		var musicPlaqueVariants = !product.productVariants ? null : product.productVariants.filter(function (pv) {
			return pv.visible === true;
		}).map(function (pv) {
			var variantKey = _ProductUtil2.default.getProductVariantKey(pv);
			return _react2.default.createElement(MusicPlaqueVariant, { productVariant: pv, selectedVariant: values[variantKey], key: "MusicPlaqueVariant_" + pv.variantLabel });
		});
	
		return _react2.default.createElement(
			_react2.default.Fragment,
			null,
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_FormElements.Input, { label: 'Song Title: ', name: 'songTitle', type: 'text' }),
				_react2.default.createElement(_FormElements.Input, { label: _react2.default.createElement(
						'span',
						null,
						'Artist (Optional): '
					), name: 'artist', type: 'text', placeholder: '' }),
				_react2.default.createElement(_FormElements.Input, { label: _react2.default.createElement(
						'span',
						null,
						'QR Code Link (Optional): '
					), name: 'qrCodeLink', type: 'text', placeholder: 'Link to open upon scanning a QR placed on the back of the plaque' }),
				isAcryclicPlaque === true && _react2.default.createElement(
					_react2.default.Fragment,
					null,
					_react2.default.createElement(
						'small',
						null,
						'(If provided, a QR code will be placed on the back of the music plaque)'
					),
					_react2.default.createElement('br', null)
				),
				musicPlaqueVariants,
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'label',
					null,
					'Image/Artwork:'
				),
				_react2.default.createElement(
					'div',
					{ className: 'flexRow' },
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'imgPreference', value: "customUpload",
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							'I want to upload my Image'
						),
						checked: values.imgPreference === "customUpload" }),
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'imgPreference', value: "helpFindImg",
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							'Find me something from the Internet'
						),
						checked: values.imgPreference === "helpFindImg",
						onClick: function onClick() {
							setFieldValue('customerUploadedImage', null);
						} })
				),
				values.imgPreference === "customUpload" && _react2.default.createElement(_ImgUploadForm2.default, { previewId: 'customerImageFile', className: 'cutomOrderImageForm',
					imgWidth: '100px', imgHeight: '100px',
					onImgChange: function onImgChange(uploadedImgFile) {
						setFieldValue('customerUploadedImage', uploadedImgFile);
					},
	
					onImgReset: function onImgReset() {
						setFieldValue('customerUploadedImage', null);
					}
				}),
				values.imgPreference === "helpFindImg" && _react2.default.createElement(
					'span',
					{ style: { color: 'white', background: 'gray', padding: '2px 10px' } },
					'We will email you or DM you the image for your approval before printing.'
				),
				_react2.default.createElement(_FormElements.Input, { name: 'customerImage', type: 'hidden' })
			),
			isAcryclicPlaque === false && _react2.default.createElement(_FormElements.ComboBox, { label: 'Music Player Placement: ', name: 'musicPlayerPlacement', value: values.musicPlayerPlacement,
				options: musicPlayerOptions, placeholder: 'Select Music Player Placement' })
		);
	};
	
	var MusicPlaqueForm = function (_ProductOrderForm) {
		_inherits(MusicPlaqueForm, _ProductOrderForm);
	
		function MusicPlaqueForm(props) {
			_classCallCheck(this, MusicPlaqueForm);
	
			var _this = _possibleConstructorReturn(this, (MusicPlaqueForm.__proto__ || Object.getPrototypeOf(MusicPlaqueForm)).call(this, props));
	
			_this.isAcryclicPlaque = _this.isAcryclicPlaque.bind(_this);
			return _this;
		}
	
		_createClass(MusicPlaqueForm, [{
			key: 'initialValues',
			value: function initialValues() {
				var order = _get(MusicPlaqueForm.prototype.__proto__ || Object.getPrototypeOf(MusicPlaqueForm.prototype), 'initialValues', this).call(this);
				order.songTitle = '';
				order.artist = '';
				order.qrCodeLink = '';
	
				order.imgPreference = '';
				order.musicPlayerPlacement = MUSIC_PLAYER_BOTTOM_POS;
				order.productSize = 'A4';
				order.quantity = this.props.quantity || 1;
				order.additionalNote = '';
				order.paymentPreference = '';
	
				order.customerUploadedImage = null;
	
				return order;
			}
		}, {
			key: 'validationScheme',
			value: function validationScheme() {
				var validation = _get(MusicPlaqueForm.prototype.__proto__ || Object.getPrototypeOf(MusicPlaqueForm.prototype), 'validationScheme', this).call(this);
	
				validation.songTitle = _yup2.default.string().required("Enter Song Title");
				validation.imgPreference = _yup2.default.string().required("Select an image preference");
	
				validation.customerUploadedImage = _yup2.default.string().when('imgPreference', function (imgPreference, schema) {
					if (imgPreference === 'customUpload') return _yup2.default.mixed().required("Please Upload an image");
	
					return _yup2.default.mixed().nullable();
				});
	
				validation.musicPlayerPlacement = _yup2.default.string().required("Select Music Player placement in Music Player.");
				return validation;
			}
		}, {
			key: 'createOrderRequest',
			value: function createOrderRequest(formValue) {
				var order = _get(MusicPlaqueForm.prototype.__proto__ || Object.getPrototypeOf(MusicPlaqueForm.prototype), 'createOrderRequest', this).call(this, formValue);
	
				order.orderMetaData = order.orderMetaData || {};
				order.orderMetaData['Song Title'] = formValue.songTitle;
	
				if (formValue.artist) order.orderMetaData["Artist"] = formValue.artist;
				if (formValue.qrCodeLink) order.orderMetaData["Link"] = formValue.qrCodeLink;
				if (formValue.imgPreference === 'helpFindImg') order.orderMetaData['Img Preference'] = "Something from the Internet";
				if (formValue.imgPreference === 'customUpload') order.orderMetaData['Img Preference'] = "User Uploaded Image";
	
				if (!this.isAcryclicPlaque()) order.orderMetaData['Music Player Placement'] = formValue.musicPlayerPlacement;
	
				return order;
			}
		}, {
			key: 'displayDeliveryInputs',
			value: function displayDeliveryInputs(formValue) {
				var quantity = formValue.quantity;
				var productSize = formValue.productSize;
	
				var imgPreference = formValue.imgPreference;
	
				return !isNaN(quantity) && productSize !== '' && formValue.songTitle && imgPreference && (imgPreference === 'customUpload' && formValue.customerUploadedImage !== null || imgPreference === 'helpFindImg');
			}
		}, {
			key: 'isAcryclicPlaque',
			value: function isAcryclicPlaque() {
				return _AppConstants2.default.ACRYCLIC_MUSIC_PLAQUE === this.props.product.id;
			}
		}, {
			key: 'isPrePaymentRequired',
			value: function isPrePaymentRequired(formValue, product) {
				return true;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var initialValues = this.initialValues();
				var validationScheme = this.validationScheme();
	
				return _react2.default.createElement(_OrderForm2.default, { initialValues: initialValues, validationScheme: validationScheme,
					product: this.props.product,
					createOrderRequest: this.createOrderRequest,
					displayDeliveryInputs: this.displayDeliveryInputs,
					isPrePaymentRequired: this.isPrePaymentRequired,
					render: function render() {
						return _react2.default.createElement(
							_react2.default.Fragment,
							null,
							_react2.default.createElement(MusicPlaqueInput, { isAcryclicPlaque: _this2.isAcryclicPlaque() })
						);
					} });
			}
		}]);
	
		return MusicPlaqueForm;
	}(_ProductOrderForm3.default);
	
	exports.default = MusicPlaqueForm;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _ReduceStoreHook = __webpack_require__(45);
	
	var _ReduceStoreHook2 = _interopRequireDefault(_ReduceStoreHook);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _ProductUtil = __webpack_require__(74);
	
	var _ProductUtil2 = _interopRequireDefault(_ProductUtil);
	
	var _divider = __webpack_require__(69);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	var _OrderAPI = __webpack_require__(90);
	
	var _OrderAPI2 = _interopRequireDefault(_OrderAPI);
	
	var _SelectedImagePreview = __webpack_require__(64);
	
	var _SelectedImagePreview2 = _interopRequireDefault(_SelectedImagePreview);
	
	var _PhotoFrameImg = __webpack_require__(141);
	
	var _PhotoFrameImg2 = _interopRequireDefault(_PhotoFrameImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	var DELIVERY_TYPE = _AppConstants2.default.DELIVERY_TYPE;
	
	var DELIVERY_LOCATION_TYPE = _AppConstants2.default.DELIVERY_LOCATION_TYPE;
	var USER_TYPE = _AppConstants2.default.USER_TYPE;
	
	var PAYMENT_OPTIONS = _AppConstants2.default.PAYMENT_OPTIONS;
	var ORDER_TO_CONFIRM = 0,
	    PROCEED_TO_PAY = 1,
	    ORDER_CONFIRMED = 2,
	    ORDER_PLACED = 3;
	
	var h2Style = { fontSize: '175%', margin: '10px 0', '@media (max-width: 350px)': { fontSize: '150%' } };
	var h3Style = { margin: '15px 0', fontSize: '115%' };
	var h4Style = { fontSize: '110%', whiteSpace: 'pre-line', wordBreak: 'break-word' };
	
	var LoginSignUpBtn = function LoginSignUpBtn() {
	
	    return _react2.default.createElement(
	        'div',
	        { style: { marginRight: "140px", fontSize: '15px',
	                '@media (max-width: 770px)': { textAlign: 'center', marginRight: '0px', fontSize: '17px' } } },
	        _react2.default.createElement(
	            'div',
	            { style: { margin: '20px 40px 20px 0', '@media (max-width: 770px)': { margin: '20px' } } },
	            '- OR -'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { color: 'gray' } },
	            _react2.default.createElement('i', { className: 'fa fa-lock', 'aria-hidden': 'true' }),
	            ' ',
	            _react2.default.createElement(
	                _AppElements.A,
	                { href: '#', style: { color: 'gray', '@media (max-width: 770px)': { flexGrow: '1' } },
	                    onClick: function onClick() {
	                        return _Dispatcher2.default.dispatchAlertWithAction(_AppConstants2.default.LOGIN_TO_CONTINUE_MSG, "WARN");
	                    } },
	                'Login / Sign Up'
	            )
	        )
	    );
	};
	
	var OrderImage = (0, _radium2.default)(function (_ref) {
	    var product = _ref.product,
	        order = _ref.order,
	        productType = _ref.productType,
	        customerImage = _ref.customerImage;
	
	    var sizeStr = _AppUtil2.default.getOrderSizeString(order, product);
	
	    var isCustomPhotoFrame = _AppUtil2.default.isCustomProduct(product) && product.productType === PRODUCT_TYPES['PHOTO_FRAME'].val;
	    var orderMetaData = order.orderMetaData || {};
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        customerImage && isCustomPhotoFrame && _react2.default.createElement(_PhotoFrameImg2.default, { id: 'customerUploadedImgPreview', className: 'largeImg',
	            imgFile: customerImage,
	            matting: orderMetaData['matting'],
	            borderColor: orderMetaData['borderColor'] }),
	        customerImage && !isCustomPhotoFrame && _react2.default.createElement(_SelectedImagePreview2.default, { id: 'customerUploadedImgPreview', file: customerImage, className: 'largeImg' }),
	        !customerImage && _react2.default.createElement(_AppElements.Img, { src: order.orderedProductImage, className: 'largeImg' }),
	        _react2.default.createElement(
	            'h3',
	            { style: [h3Style] },
	            sizeStr,
	            ', ',
	            _react2.default.createElement(
	                'b',
	                null,
	                product.title
	            ),
	            ' ',
	            product.title.indexOf(productType.label) < 0 ? productType.label : ''
	        )
	    );
	});
	
	var OrderMetaData = (0, _radium2.default)(function (_ref2) {
	    var orderMetaData = _ref2.orderMetaData;
	
	    if (!orderMetaData) return null;
	
	    var metaDataList = Object.keys(orderMetaData).map(function (k, i) {
	        var valueString = orderMetaData[k] instanceof Object ? JSON.stringify(orderMetaData[k]) : orderMetaData[k].toString();
	        return _react2.default.createElement(
	            'span',
	            { key: i + "_" + k },
	            _react2.default.createElement(
	                'b',
	                null,
	                k.toUpperCase()
	            ),
	            ' ',
	            ": " + valueString
	        );
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexColumn orderMetaDataInfo' },
	        metaDataList
	    );
	});
	
	var OrderAmount = (0, _radium2.default)(function (_ref3) {
	    var product = _ref3.product,
	        order = _ref3.order,
	        discountCoupon = _ref3.discountCoupon;
	
	    var productSizes = _AppUtil2.default.getSizeInfo(product);
	    var productSizeOptions = order.sizeMetaData || productSizes;
	
	    var totalPrice = null;
	    if (order.isBulkOrder) {
	        var discountPct = _AppConstants2.default.BULK_ORDER_DISCOUNT_PCT;
	        totalPrice = Object.keys(order.sizeQuantity).map(function (size) {
	            var quantity = order.sizeQuantity[size];
	            var perPrice = (product.price + productSizeOptions[size].priceAddition) * (1 - discountPct);
	
	            return quantity * perPrice;
	        }).reduce(function (p1, p2) {
	            return p1 + p2;
	        }, 0);
	    } else {
	        var perPrice = product.price + productSizeOptions[order.productSizes[0]].priceAddition;
	        totalPrice = perPrice * order.quantity;
	    }
	
	    var locationExtraCost = order.deliveryCharge;
	    var deliveryTypeExtraCost = DELIVERY_TYPE[order.deliveryType].extraCost;
	
	    var productVariants = product.productVariants;
	
	    var selectedVariants = _ProductUtil2.default.getSelectedVariants(productVariants, order.selectedVariants);
	
	    var variantExtraCost = 0;
	
	    selectedVariants.forEach(function (vr) {
	        var priceAddition = vr.priceAddition || 0;
	        variantExtraCost += priceAddition;
	    });
	
	    var totalExtraCost = locationExtraCost + deliveryTypeExtraCost + variantExtraCost;
	
	    var discountAmount = 0;
	    if (discountCoupon && discountCoupon.discountPct) {
	        discountAmount = discountCoupon.discountPct * totalPrice;
	    } else if (discountCoupon && discountCoupon.discountAmount) {
	        discountAmount = discountAmount * order.quantity;
	    }
	    var totalAmount = totalPrice + totalExtraCost - discountAmount;
	
	    var paymentInfo = PAYMENT_OPTIONS[order.paymentPreference].label;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        (totalExtraCost > 0 || discountAmount > 0) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Cost Detail'
	            ),
	            _react2.default.createElement(
	                'ul',
	                { style: { paddingLeft: '15px', listStyle: 'none', '@media (max-width: 770px)': { paddingLeft: '0px', listStyle: 'devanagari' } } },
	                _react2.default.createElement(
	                    'li',
	                    { style: { paddingBottom: '5px' } },
	                    PRODUCT_TYPES[product.productType].label,
	                    ' price: Rs. ',
	                    _AppUtil2.default.formatNumber(totalPrice)
	                ),
	                selectedVariants && selectedVariants.filter(function (vr) {
	                    return vr.priceAddition !== null && vr.priceAddition !== undefined;
	                }).map(function (vr) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: vr.variantId, style: { paddingBottom: '5px' } },
	                        vr.label,
	                        ': Rs. ',
	                        _AppUtil2.default.formatNumber(vr.priceAddition)
	                    );
	                }),
	                locationExtraCost > 0 && _react2.default.createElement(
	                    'li',
	                    { style: { paddingBottom: '5px' } },
	                    DELIVERY_LOCATION_TYPE[order.locationType].label,
	                    ' Extra cost: Rs. ',
	                    _AppUtil2.default.formatNumber(locationExtraCost)
	                ),
	                deliveryTypeExtraCost > 0 && _react2.default.createElement(
	                    'li',
	                    { style: { paddingBottom: '5px' } },
	                    DELIVERY_TYPE[order.deliveryType].label,
	                    ' Extra cost: Rs. ',
	                    _AppUtil2.default.formatNumber(deliveryTypeExtraCost)
	                ),
	                discountAmount > 0 && _react2.default.createElement(
	                    'li',
	                    { style: { paddingBottom: '5px', fontWeight: 'bold', color: '#1b8000', fontSize: '110%' } },
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-tags', 'aria-hidden': 'true' })
	                    ),
	                    ' You received Rs. ',
	                    _AppUtil2.default.formatNumber(discountAmount),
	                    ' discount!'
	                )
	            ),
	            _react2.default.createElement(_divider2.default, null)
	        ),
	        _react2.default.createElement(
	            'h3',
	            { style: [h3Style] },
	            _react2.default.createElement('i', { className: 'fa fa-money', 'aria-hidden': 'true' }),
	            '  Payment Preference - ',
	            _react2.default.createElement(
	                'b',
	                null,
	                paymentInfo
	            )
	        ),
	        _react2.default.createElement(
	            'h2',
	            { style: [h2Style, { fontWeight: 'bold' }] },
	            'Total Amount: Rs. ',
	            _AppUtil2.default.formatNumber(totalAmount)
	        )
	    );
	});
	
	var OrderBasicInfo = (0, _radium2.default)(function (_ref4) {
	    var order = _ref4.order,
	        orderState = _ref4.orderState,
	        productType = _ref4.productType;
	
	    var deliveryTime = _AppUtil2.default.getDeliveryTime(productType.val, order.deliveryType);
	    var deliveryInfo = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: 'fa fa-clock-o', style: { color: "rgb(244, 150, 0)" }, 'aria-hidden': 'true' }),
	        ' Your order will be delivered within ',
	        _react2.default.createElement(
	            'b',
	            null,
	            deliveryTime
	        ),
	        '.'
	    );
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_AppElements.Separator, { style: { display: 'none', '@media (max-width: 770px)': { display: 'block' } } }),
	        _react2.default.createElement(
	            'h3',
	            { style: h3Style },
	            _react2.default.createElement('i', { className: 'fa fa-truck', 'aria-hidden': 'true' }),
	            ' Deliver To - ',
	            order.streetAddress
	        ),
	        _react2.default.createElement(
	            'h3',
	            { style: h3Style },
	            _react2.default.createElement('i', { className: 'fa fa-phone', 'aria-hidden': 'true' }),
	            ' Contact Number - ',
	            order.phone
	        ),
	        order.additionalNote && _react2.default.createElement(
	            'h4',
	            { style: h4Style },
	            '- ',
	            order.additionalNote
	        ),
	        orderState === ORDER_PLACED && _react2.default.createElement(
	            'div',
	            { style: { margin: '10px 0' } },
	            _react2.default.createElement(
	                'span',
	                null,
	                deliveryInfo
	            )
	        )
	    );
	});
	
	//hook does not work with radium, hence creating separate radium stateless element
	var RadiumizedElement = (0, _radium2.default)(function (_ref5) {
	    var order = _ref5.order,
	        product = _ref5.product,
	        discountCoupon = _ref5.discountCoupon,
	        customerImage = _ref5.customerImage,
	        orderState = _ref5.orderState,
	        onClose = _ref5.onClose,
	        onProceedToPay = _ref5.onProceedToPay,
	        onConfirm = _ref5.onConfirm;
	
	    var productType = PRODUCT_TYPES[product.productType];
	
	    var receiptTitle = null,
	        confirmBtn = null,
	        goBackBtn = null;
	
	    goBackBtn = _react2.default.createElement(
	        _AppElements.Button,
	        { mui: 'true', variant: 'default', color: 'raised',
	            onClick: function onClick() {
	                return onClose(orderState === ORDER_PLACED);
	            },
	            style: { '@media (max-width: 770px)': { flexGrow: '1' } } },
	        'Go Back'
	    );
	
	    var isLoggedIn = _SessionStore2.default.getCurrentSession() !== null;
	
	    if (orderState === ORDER_TO_CONFIRM) {
	        receiptTitle = _react2.default.createElement(
	            'span',
	            null,
	            'You are one-step away from your ',
	            productType.label,
	            ' ',
	            _react2.default.createElement('i', { style: { color: '#f8931c' }, className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' })
	        );
	        var confirmBtnText = null;
	        if (isLoggedIn) confirmBtnText = "Confirm";else confirmBtnText = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-user-circle-o', 'aria-hidden': 'true' }),
	            ' Continue as Guest'
	        );
	        confirmBtn = _react2.default.createElement(
	            _AppElements.Button,
	            { mui: 'true', variant: 'primary', color: 'raised',
	                onClick: onConfirm, style: { '@media (max-width: 770px)': { flexGrow: '1' } } },
	            confirmBtnText
	        );
	    } else if (orderState === ORDER_CONFIRMED) {
	        receiptTitle = _react2.default.createElement(
	            'span',
	            null,
	            'Placing your order ',
	            _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', style: { color: '#f8931c' }, 'aria-hidden': 'true' })
	        );
	        confirmBtn = _react2.default.createElement(
	            _AppElements.Button,
	            { mui: 'true', disabled: true, variant: 'primary', color: 'raised',
	                onClick: function onClick() {}, style: { '@media (max-width: 770px)': { flexGrow: '1' } } },
	            'Submitting ',
	            _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', style: { color: '#f8931c' }, 'aria-hidden': 'true' }),
	            ' '
	        );
	    } else if (orderState === ORDER_PLACED) {
	        var paymentPreference = order.paymentPreference;
	
	        var confirmBtnTxt = null,
	            confirmBtnUrl = null;
	
	        if (paymentPreference === 'COD') {
	            confirmBtnTxt = "View Order";
	            confirmBtnUrl = "/orders";
	        } else {
	            confirmBtnTxt = "Proceed To Pay";
	            confirmBtnUrl = "/orders/checkout?via=" + paymentPreference;
	        }
	
	        confirmBtn = _react2.default.createElement(
	            _AppElements.Button,
	            { id: 'viewOrderBtn', mui: 'true', variant: 'primary', color: 'raised', href: confirmBtnUrl, style: { marginLeft: '10px' } },
	            confirmBtnTxt
	        );
	
	        receiptTitle = _react2.default.createElement(
	            'span',
	            null,
	            'Order Placed Successfully ',
	            _react2.default.createElement('i', { style: { color: 'green' }, className: 'fa fa-check-circle', 'aria-hidden': 'true' })
	        );
	
	        goBackBtn = _react2.default.createElement(
	            _AppElements.Button,
	            { mui: 'true', variant: 'default', color: 'raised',
	                onClick: function onClick() {
	                    return onClose(orderState === ORDER_PLACED);
	                },
	                style: { '@media (max-width: 770px)': { flexGrow: '1' } } },
	            'Continue Shopping'
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexColumn', id: 'purchaseReceipt' },
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow', style: { justifyContent: 'space-between', alignItems: 'center', background: '#dedede', padding: '10px', marginTop: '10px' } },
	            _react2.default.createElement(
	                'span',
	                null,
	                'Call us at ',
	                _react2.default.createElement('i', { style: { color: "#f8941c" }, className: 'fa fa-phone-square', 'aria-hidden': 'true' }),
	                ' ',
	                _AppConstants2.default.CONTACT_NUMBER,
	                ' or WhatsApp at ',
	                _react2.default.createElement('i', { style: { color: "green" }, className: 'fa fa-whatsapp', 'aria-hidden': 'true' }),
	                ' ',
	                _AppConstants2.default.WHATS_APP
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(
	                'h2',
	                { style: [h2Style, { color: "#646464", margin: '25px 0 0 0' }] },
	                receiptTitle
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow', id: 'orderDetail', style: { marginTop: '25px', '@media (max-width: 770px)': { flexDirection: 'column-reverse' } } },
	            _react2.default.createElement(
	                'div',
	                { style: { flexGrow: 1, textAlign: 'right', borderRight: '1px solid gray', padding: '0 20px', maxWidth: '600px', '@media (max-width: 770px)': { textAlign: 'left', padding: '0 10px', borderRight: 'none' } } },
	                _react2.default.createElement(OrderBasicInfo, { order: order, orderState: orderState, productType: productType }),
	                _react2.default.createElement(_divider2.default, null),
	                order.orderMetaData && _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(OrderMetaData, { orderMetaData: order.orderMetaData }),
	                    _react2.default.createElement(_divider2.default, null)
	                ),
	                _react2.default.createElement(OrderAmount, { order: order, product: product, discountCoupon: discountCoupon }),
	                orderState === ORDER_PLACED && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h3',
	                        { style: h3Style },
	                        'You can view your orders ',
	                        _react2.default.createElement(
	                            _AppElements.A,
	                            { href: '/orders' },
	                            'here'
	                        ),
	                        '.'
	                    ),
	                    _react2.default.createElement(_divider2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexRow', style: { justifyContent: "flex-end", marginTop: '10px' } },
	                    goBackBtn,
	                    confirmBtn
	                ),
	                !isLoggedIn && _react2.default.createElement(LoginSignUpBtn, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center', flexGrow: 1, maxWidth: '45%', '@media (max-width: 770px)': { maxWidth: '100%' } } },
	                _react2.default.createElement(OrderImage, { order: order, product: product, productType: productType, customerImage: customerImage })
	            )
	        )
	    );
	});
	
	function saveOrderData(order) {
	    _CacheService2.default.save(_AppConstants2.default.USER_ADDRESS_KEY, JSON.stringify({ phone: order.phone,
	        streetAddress: order.streetAddress,
	        additionalNote: order.additionalNote,
	        locationType: order.locationType }), true);
	}
	
	//rename it to OrderConfirmation and move it to views/order 
	var OrderConfirmation = function OrderConfirmation(_ref6) {
	    var order = _ref6.order,
	        product = _ref6.product,
	        discountCoupon = _ref6.discountCoupon,
	        customerImage = _ref6.customerImage,
	        onClose = _ref6.onClose;
	
	    if (order === null || product === null) return null;
	
	    var _useState = (0, _react.useState)(ORDER_TO_CONFIRM),
	        _useState2 = _slicedToArray(_useState, 2),
	        orderState = _useState2[0],
	        setOrderState = _useState2[1];
	
	    var session = (0, _ReduceStoreHook2.default)(_SessionStore2.default, function (store) {
	        return store.getCurrentSession();
	    }, function () {
	        //do nothing, if session does not exists
	    }, []);
	
	    function onFormSubmit(success) {
	        if (success) setOrderState(ORDER_PLACED);
	    }
	
	    function onProceedToPay() {
	        setOrderState(PROCEED_TO_PAY);
	    }
	
	    function onConfirmOrder() {
	        try {
	            setOrderState(ORDER_CONFIRMED);
	
	            if (!session) {
	                saveOrderData(order);
	            } else {
	                var userType = _SessionStore2.default.getCurrentSession().user.userType;
	                if (userType !== USER_TYPE.ADMIN && userType !== USER_TYPE.SALES) saveOrderData(order);
	            }
	
	            if (!customerImage) _OrderAPI2.default.placeOrder(order, onFormSubmit);else _OrderAPI2.default.placeCustomOrder(order, customerImage, onFormSubmit);
	        } catch (err) {
	            setOrderState(ORDER_PLACED);
	            console.log("Submit Order Error", err);
	            alert("Some error occurred while submitting your order. Please DM us to place the order: " + err.toString());
	        }
	    }
	
	    (0, _react.useLayoutEffect)(function () {
	        window.setTimeout(function () {
	            _AppUtil2.default.scrollToElement("orderDetail", { block: "center", behavior: 'smooth' });
	        }, 10);
	    }, []);
	    return _react2.default.createElement(RadiumizedElement, { order: order, product: product, discountCoupon: discountCoupon,
	        customerImage: customerImage,
	        onClose: onClose, onConfirm: onConfirmOrder,
	        onProceedToPay: onProceedToPay,
	        orderState: orderState });
	};
	
	exports.default = OrderConfirmation;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactTable = __webpack_require__(50);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _DateComponent = __webpack_require__(62);
	
	var _DateComponent2 = _interopRequireDefault(_DateComponent);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _ChangeOrderStateModalForm = __webpack_require__(571);
	
	var _ChangeOrderStateModalForm2 = _interopRequireDefault(_ChangeOrderStateModalForm);
	
	var _PaymentInfo = __webpack_require__(226);
	
	var _PaymentInfo2 = _interopRequireDefault(_PaymentInfo);
	
	var _PhotoFrameImg = __webpack_require__(141);
	
	var _PhotoFrameImg2 = _interopRequireDefault(_PhotoFrameImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORDER_STATE = _AppConstants2.default.ORDER_STATE;
	var DELIVERY_LOCATION_TYPE = _AppConstants2.default.DELIVERY_LOCATION_TYPE;
	
	var OrderSubComponent = function OrderSubComponent(row) {
		var order = row.original;
	
		var orderPremise = "";
	
		if (order.locationType && order.locationType === DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY.val) orderPremise = _react2.default.createElement(
			'b',
			{ style: { color: 'rgb(248, 147, 18)' } },
			DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY.label,
			' - '
		);else if (order.locationType && order.locationType === DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD.val) orderPremise = _react2.default.createElement(
			'b',
			null,
			DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD.label,
			' - '
		);
	
		var discountAmount = order.discountAmount ? order.discountAmount * order.quantity : null;
	
		var orderMetaData = order.orderMetaData || {};
	
		var metaDataList = Object.keys(orderMetaData).map(function (k) {
			var valueString = orderMetaData[k] instanceof Object ? JSON.stringify(orderMetaData[k]) : orderMetaData[k].toString();
			return _react2.default.createElement(
				'span',
				{ key: order.orderId + "_" + k },
				_react2.default.createElement(
					'b',
					null,
					k.toUpperCase()
				),
				' ',
				": " + valueString
			);
		});
	
		var isCustomPhotoFrame = _AppUtil2.default.isCustomProduct(order.product) && order.product.productType === _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val;
	
		return _react2.default.createElement(
			'div',
			{ style: { display: 'flex', flexDirection: 'row', padding: '15px', background: 'white' } },
			isCustomPhotoFrame &&
			//TODO: later show this for all frames
			_react2.default.createElement(_PhotoFrameImg2.default, { id: "order" + order.orderId + "Img", imgUrl: order.orderedProductImage,
				matting: orderMetaData['matting'],
				borderColor: orderMetaData['borderColor'] }),
			!isCustomPhotoFrame && _react2.default.createElement('img', { src: order.orderedProductImage, style: { height: '200px' }, alt: "Ordered Image " + order.orderId }),
			_react2.default.createElement(
				'div',
				{ style: { padding: '0 10px 10px 10px', marginLeft: '50px', color: '#7b7979' } },
				_react2.default.createElement(
					'h2',
					{ style: { color: 'gray', margin: '0 10px 15px 0' } },
					_react2.default.createElement('i', { className: 'fa fa-address-card-o', 'aria-hidden': 'true' }),
					' Delivery Detail'
				),
				order.deliveryType === _AppConstants2.default.DELIVERY_TYPE.IMMEDIATE.val && _react2.default.createElement(
					'h4',
					{ style: { color: '#f89312' } },
					_react2.default.createElement(
						'b',
						null,
						'Immediate Delivery within next 24 hours!'
					)
				),
				_react2.default.createElement(
					'h4',
					null,
					_react2.default.createElement('i', { className: 'fa fa-phone-square', 'aria-hidden': 'true' }),
					' Contact Number: ',
					_react2.default.createElement(
						'b',
						{ style: { color: 'black' } },
						order.phone
					)
				),
				_react2.default.createElement(
					'h4',
					null,
					_react2.default.createElement('i', { className: 'fa fa-street-view', 'aria-hidden': 'true' }),
					' Address: ',
					orderPremise,
					' ',
					_react2.default.createElement(
						'b',
						{ style: { color: 'black' } },
						order.streetAddress
					)
				),
				order.additionalNote && _react2.default.createElement(
					'p',
					{ style: { whiteSpace: 'pre-line' } },
					'- ',
					order.additionalNote
				),
				order.paymentPreference && order.paymentPreference !== 'COD' && _react2.default.createElement(
					'p',
					{ style: { whiteSpace: 'pre-line' } },
					'Preferred Payment via ',
					order.paymentPreference
				),
				discountAmount && _react2.default.createElement(
					'h4',
					{ style: { color: 'green', margin: '0' } },
					'- ',
					_react2.default.createElement('i', { className: 'fa fa-tags', 'aria-hidden': 'true' }),
					' Discount Received Rs. ',
					discountAmount
				),
				metaDataList && _react2.default.createElement(
					'div',
					{ className: 'flexColumn orderMetaDataInfo' },
					metaDataList
				)
			)
		);
	};
	
	var OrdersList = function (_React$Component) {
		_inherits(OrdersList, _React$Component);
	
		function OrdersList(props) {
			_classCallCheck(this, OrdersList);
	
			var _this = _possibleConstructorReturn(this, (OrdersList.__proto__ || Object.getPrototypeOf(OrdersList)).call(this, props));
	
			_this.handleCloseOrderModalClose = _this.handleCloseOrderModalClose.bind(_this);
	
			_this.state = { toUpdateOrder: null };
			return _this;
		}
	
		_createClass(OrdersList, [{
			key: 'getOrderInfoColumn',
			value: function getOrderInfoColumn() {
				var userType = _SessionStore2.default.getCurrentSession() ? _SessionStore2.default.getCurrentSession().user.userType : null;
				var orderInfo = [{ Header: 'Id', accessor: 'orderId', width: 60, filterable: true,
					Cell: function Cell(props) {
						var hasSalesPermission = userType === _AppConstants2.default.USER_TYPE.ADMIN || userType === _AppConstants2.default.USER_TYPE.SALES;
						var editButton = hasSalesPermission ? _react2.default.createElement(
							_AppElements.A,
							{ href: "/order/" + props.value + "/settings" },
							_react2.default.createElement('i', { className: 'fa fa-pencil-square', 'aria-hidden': 'true' })
						) : null;
						return _react2.default.createElement(
							'span',
							null,
							props.value,
							' ',
							editButton
						);
					}
				}, { Header: 'Ordered On', accessor: 'createdDate', width: 180,
					Cell: function Cell(props) {
						return _react2.default.createElement(_DateComponent2.default, { date: props.value, showTime: true });
					}
				}, { Header: 'Info', accessor: 'productSizes', width: 280,
					Cell: function Cell(props) {
						var sizes = props.value;
						var sizeInfo = sizes.toString();
						var isCoupleProduct = false;
	
						var product = props.original.product;
						if (product) {
							isCoupleProduct = _AppUtil2.default.isCoupleProduct(product);
							var shortSizeStr = isCoupleProduct ? true : false;
							sizeInfo = _AppUtil2.default.getOrderSizeString(props.original, product, shortSizeStr);
						}
	
						var totalCharge = _react2.default.createElement(
							'b',
							null,
							'Rs. ',
							_AppUtil2.default.formatNumber(props.original.totalCharge),
							' /- '
						);
	
						var isPaid = props.original.paid || false;
						return _react2.default.createElement(
							'div',
							null,
							sizeInfo,
							' = ',
							totalCharge,
							isPaid ? _react2.default.createElement(
								'b',
								{ style: { color: "#f8951b" } },
								'PAID'
							) : ""
						);
					}
				}];
	
				return orderInfo;
			}
		}, {
			key: 'getProductInfoColumn',
			value: function getProductInfoColumn() {
				var userType = _SessionStore2.default.getCurrentSession() ? _SessionStore2.default.getCurrentSession().user.userType : null;
				var isAdmin = userType === _AppConstants2.default.USER_TYPE.ADMIN;
				var productInfo = [{ Header: 'Type', accessor: 'product', width: 100,
					Cell: function Cell(props) {
						return _AppConstants2.default.PRODUCT_TYPES[props.value.productType].label;
					} }, { Header: 'Product', accessor: 'product', width: 200,
					Cell: function Cell(props) {
						var product = props.original.product;
	
						var isPublished = product.productState === _AppConstants2.default.PRODUCT_STATE['APPROVED'];
						var productTitle = _AppUtil2.default.getProductTitle(props.original.product);
						return isAdmin || isPublished ? _react2.default.createElement(
							_AppElements.A,
							{ href: _AppUtil2.default.getProductURL(props.value) },
							productTitle
						) : _react2.default.createElement(
							'u',
							null,
							productTitle
						);
					}
				}];
	
				return productInfo;
			}
		}, {
			key: 'getOrderStateColumn',
			value: function getOrderStateColumn() {
				var _this2 = this;
	
				var stateInfo = [{ Header: 'Delivered On', accessor: 'deliveredDate', width: 140,
					Cell: function Cell(props) {
						return props.value ? _react2.default.createElement(_DateComponent2.default, { date: props.value }) : '-';
					}
				}];
				var userType = _SessionStore2.default.getCurrentSession() ? _SessionStore2.default.getCurrentSession().user.userType : null;
	
				if (this.props.changeOrderState === true) {
					var orderStateChangeForm = { Header: 'Order State', accessor: 'orderState', width: 300,
						style: { overflow: 'visible' },
						Cell: function Cell(rowData) {
	
							return _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'flexRow' },
									_react2.default.createElement(
										'b',
										null,
										ORDER_STATE[rowData.value].label
									),
									rowData.value === ORDER_STATE.DELIVERED.value && userType === _AppConstants2.default.USER_TYPE.ADMIN && _react2.default.createElement(
										_AppElements.Button,
										{ style: { marginLeft: '10px', background: '#f8f8ff', padding: '5px', borderRadius: '5px', cursor: 'pointer' },
											onClick: function onClick() {
												_this2.setState({ toUpdateOrder: rowData.original });
											} },
										'Close'
									),
									rowData.value !== ORDER_STATE.DELIVERED.value && rowData.value !== ORDER_STATE.DELIVERED_CLOSED.value && _react2.default.createElement(
										_AppElements.Button,
										{ style: { marginLeft: '10px', background: '#f8f8ff', padding: '5px', borderRadius: '5px', cursor: 'pointer' },
											onClick: function onClick() {
												_this2.setState({ toUpdateOrder: rowData.original });
											} },
										'Change State'
									)
								),
								rowData.value === ORDER_STATE.CANCELLED.value && rowData.original.cancelledReason && _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement('br', null),
									'- ',
									rowData.original.cancelledReason
								)
							);
						}
					};
					stateInfo.push(orderStateChangeForm);
				} else {
	
					var orderState = { Header: 'Order State', accessor: 'orderState', width: 200,
						Cell: function Cell(rowData) {
	
							var orderLabel = rowData.value === ORDER_STATE.DELIVERED_CLOSED.value ? ORDER_STATE.DELIVERED.label : ORDER_STATE[rowData.value].label;
	
							var cancelledReason = rowData.value === ORDER_STATE.CANCELLED.value && rowData.original.cancelledReason ? rowData.original.cancelledReason : '';
							return _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'b',
									null,
									orderLabel
								),
								cancelledReason && _react2.default.createElement(
									'p',
									null,
									'- ',
									cancelledReason
								)
							);
						} };
					stateInfo.push(orderState);
				}
	
				return stateInfo;
			}
		}, {
			key: 'handleCloseOrderModalClose',
			value: function handleCloseOrderModalClose() {
				this.setState({ toUpdateOrder: null });
			}
		}, {
			key: 'render',
			value: function render() {
				var orders = this.props.orders;
	
				var columns = [{ Header: 'Order Detail', columns: this.getOrderInfoColumn() }];
	
				if (this.props.showProductInfo === true) columns.push({ Header: 'Product Detail', columns: this.getProductInfoColumn() });
	
				columns.push({ Header: 'State Detail', columns: this.getOrderStateColumn() });
	
				var style = [];
				if (this.props.style) style.push(this.props.style);
	
				var showLoading = orders ? false : true;
	
				var unpaidOrders = null;
				if (orders) {
					unpaidOrders = orders.filter(function (o) {
						return o.paid !== true && (o.orderState === ORDER_STATE.ORDER_PLACED.value || o.orderState === ORDER_STATE.ORDER_CONFIRMED.value || o.orderState === ORDER_STATE.SHIPPING.value);
					}).toArray();
				}
	
				return _react2.default.createElement(
					'div',
					{ style: style, id: 'orderList' },
					this.props.showPaymentOption && _react2.default.createElement(_PaymentInfo2.default, { unpaidOrders: unpaidOrders }),
					_react2.default.createElement(
						'div',
						{ className: 'flexRow', style: { margin: '10px 0', justifyContent: 'space-between', alignItems: 'baseline' } },
						this.props.title && _react2.default.createElement(
							'h2',
							null,
							this.props.title,
							' ',
							_react2.default.createElement('i', { className: 'fa fa-shopping-cart', 'aria-hidden': 'true' })
						)
					),
					_react2.default.createElement(_reactTable2.default, { data: orders ? orders.toArray() : [], columns: columns, minRows: 5,
						noDataText: 'No Orders Found.', loading: showLoading,
						SubComponent: OrderSubComponent,
						className: '-highlight', defaultPageSize: 15
					}),
					this.state.toUpdateOrder && _react2.default.createElement(_ChangeOrderStateModalForm2.default, { order: this.state.toUpdateOrder,
						onClose: this.handleCloseOrderModalClose,
						stockOwners: this.props.stockOwners })
				);
			}
		}]);
	
		return OrdersList;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(OrdersList);

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PaymentOptions = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAYMENT_OPTIONS = _AppConstants2.default.PAYMENT_OPTIONS;
	
	var PaymentOptions = exports.PaymentOptions = function PaymentOptions() {
	    var images = Object.keys(PAYMENT_OPTIONS).map(function (p) {
	        return PAYMENT_OPTIONS[p];
	    }).filter(function (p) {
	        return p.image;
	    }).map(function (p) {
	        return _react2.default.createElement(_AppElements.Img, { key: p.image, src: p.image, title: p.label, alt: p.label });
	    });
	    return _react2.default.createElement(
	        'div',
	        { className: 'paymentImages flexRow' },
	        images
	    );
	};
	
	var PaymentInfo = function PaymentInfo(_ref) {
	    var unpaidOrders = _ref.unpaidOrders;
	
	    if (unpaidOrders === null || unpaidOrders.length === 0) return null;
	
	    var unpaidAmount = unpaidOrders.map(function (o) {
	        return o.totalCharge;
	    }).reduce(function (total, amount) {
	        return total + amount;
	    });
	    var unpaidOrdersId = unpaidOrders.map(function (o) {
	        return o.orderId;
	    }).join(",");
	    var recentPaymentPreference = unpaidOrders[0].paymentPreference;
	
	    var checkoutLink = "/orders/checkout?amount=" + unpaidAmount + "&orderId=" + unpaidOrdersId + "&via=" + recentPaymentPreference;
	
	    var unpaidOrdersCount = unpaidOrders.length;
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexRow', id: 'pendingOrdersPayment' },
	        _react2.default.createElement(
	            'div',
	            { id: 'orderPayInfo' },
	            _react2.default.createElement(
	                'h3',
	                { style: { margin: '0 0 20px 0' } },
	                'You can use any one of the following options to make your payment:'
	            ),
	            _react2.default.createElement(PaymentOptions, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexColumn', id: 'orderSummary' },
	            _react2.default.createElement(
	                'div',
	                { id: 'orderPayAmount' },
	                _react2.default.createElement(
	                    'h2',
	                    { id: 'orderSummaryTitle' },
	                    'Order Summary'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        unpaidOrdersCount
	                    ),
	                    ' Order',
	                    unpaidOrdersCount > 1 ? 's' : '',
	                    ' Pending Payment'
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Total Amount: ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        "Rs. " + _AppUtil2.default.formatNumber(unpaidAmount)
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _AppElements.Button,
	                { id: 'proceedToPayBtn', href: checkoutLink, variant: 'primary', mui: 'true' },
	                'Proceed to Pay'
	            )
	        )
	    );
	};
	
	exports.default = (0, _radium2.default)(PaymentInfo);

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _OrderFormLoader = __webpack_require__(140);
	
	var _OrderFormLoader2 = _interopRequireDefault(_OrderFormLoader);
	
	var _OrderAPI = __webpack_require__(90);
	
	var _OrderAPI2 = _interopRequireDefault(_OrderAPI);
	
	var _ProductSocialShare = __webpack_require__(231);
	
	var _ProductSocialShare2 = _interopRequireDefault(_ProductSocialShare);
	
	var _PhotoFrameSizeInput = __webpack_require__(586);
	
	var _PhotoFrameSizeInput2 = _interopRequireDefault(_PhotoFrameSizeInput);
	
	var _LocationTypeInput = __webpack_require__(229);
	
	var _LocationTypeInput2 = _interopRequireDefault(_LocationTypeInput);
	
	var _CouponCodeInput = __webpack_require__(228);
	
	var _CouponCodeInput2 = _interopRequireDefault(_CouponCodeInput);
	
	var _PaymentPreferenceInput = __webpack_require__(230);
	
	var _PaymentPreferenceInput2 = _interopRequireDefault(_PaymentPreferenceInput);
	
	var _OrderForm = __webpack_require__(36);
	
	var _formik = __webpack_require__(21);
	
	var _OrderConfirmation = __webpack_require__(224);
	
	var _OrderConfirmation2 = _interopRequireDefault(_OrderConfirmation);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _ProductOrderForm2 = __webpack_require__(96);
	
	var _ProductOrderForm3 = _interopRequireDefault(_ProductOrderForm2);
	
	var _FrameImageUploader = __webpack_require__(584);
	
	var _FrameImageUploader2 = _interopRequireDefault(_FrameImageUploader);
	
	var _FormElements = __webpack_require__(13);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	
	var QuantityInput = function QuantityInput() {
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'frameQuantityOption' },
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Quantity'
	        ),
	        _react2.default.createElement(_FormElements.Input, { name: 'quantity', type: 'number' })
	    );
	};
	
	var MattingInput = function MattingInput() {
	    var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
	        values = _useContext.values;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Matting ',
	            _react2.default.createElement(
	                'span',
	                { style: { fontSize: '70%' } },
	                '(1" in width)'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow' },
	            _react2.default.createElement(_FormElements.RadioButton, { name: 'matting', value: "White", label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161', marginRight: '15px' } },
	                    'White Matting'
	                ), checked: values.matting === "White" }),
	            _react2.default.createElement(_FormElements.RadioButton, { name: 'matting', value: "", label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    'No Matting'
	                ), checked: values.matting === "" })
	        )
	    );
	};
	
	var BorderColorInput = function BorderColorInput() {
	    var _useContext2 = (0, _react.useContext)(_OrderForm.OrderContext),
	        values = _useContext2.values;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Border ',
	            _react2.default.createElement(
	                'span',
	                { style: { fontSize: '70%' } },
	                '(1" in width)'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow' },
	            _react2.default.createElement(_FormElements.RadioButton, { name: 'borderColor', value: "blackBorder", label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161', marginRight: '15px' } },
	                    'Black Border'
	                ), checked: values.borderColor === "blackBorder" }),
	            _react2.default.createElement(_FormElements.RadioButton, { name: 'borderColor', value: "whiteBorder", label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    'White Border'
	                ), checked: values.borderColor === "whiteBorder" })
	        )
	    );
	};
	
	var PhotoFrameForm = function (_ProductOrderForm) {
	    _inherits(PhotoFrameForm, _ProductOrderForm);
	
	    function PhotoFrameForm(props) {
	        _classCallCheck(this, PhotoFrameForm);
	
	        var _this = _possibleConstructorReturn(this, (PhotoFrameForm.__proto__ || Object.getPrototypeOf(PhotoFrameForm)).call(this, props));
	
	        _this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
	        _this.setSubmittedOrder = _this.setSubmittedOrder.bind(_this);
	        _this.createOrderRequest = _this.createOrderRequest.bind(_this);
	        _this.displayDeliveryInputs = _this.displayDeliveryInputs.bind(_this);
	        return _this;
	    }
	
	    _createClass(PhotoFrameForm, [{
	        key: 'initialValues',
	        value: function initialValues() {
	            var formValues = _get(PhotoFrameForm.prototype.__proto__ || Object.getPrototypeOf(PhotoFrameForm.prototype), 'initialValues', this).call(this);
	            formValues.productPrice = PRODUCT_TYPES['PHOTO_FRAME'].basePrice;
	            formValues.paymentPreference = '';
	            formValues.customerUploadedImage = null;
	            formValues.matting = '';
	            formValues.borderColor = 'blackBorder';
	            formValues.productSizeMetaData = '';
	            formValues.productSize = '';
	            formValues.isCustomSize = '';
	            formValues.customWidth = '';
	            formValues.customHeight = '';
	
	            formValues.imgWidth = this.props.product && this.props.product.imgWidthPx ? this.props.product.imgWidthPx : '';
	            formValues.imgHeight = this.props.product && this.props.product.imgHeightPx ? this.props.product.imgHeightPx : '';
	
	            return formValues;
	        }
	    }, {
	        key: 'validationScheme',
	        value: function validationScheme(isCustomProduct) {
	            var validation = _get(PhotoFrameForm.prototype.__proto__ || Object.getPrototypeOf(PhotoFrameForm.prototype), 'validationScheme', this).call(this);
	            delete validation['productImage'];
	
	            validation.customerUploadedImage = isCustomProduct ? _yup2.default.mixed().required("Please Upload an image") : _yup2.default.mixed();
	
	            return _yup2.default.object().shape(validation);
	        }
	    }, {
	        key: 'createOrderRequest',
	        value: function createOrderRequest(formValue) {
	            var order = _get(PhotoFrameForm.prototype.__proto__ || Object.getPrototypeOf(PhotoFrameForm.prototype), 'createOrderRequest', this).call(this, formValue);
	
	            var selectedSize = formValue.productSize;
	            order.sizeMetaData = {};
	            order.sizeMetaData[selectedSize] = formValue.productSizeMetaData[selectedSize];
	
	            order.orderMetaData = order.orderMetaData || {};
	            order.orderMetaData['DPI'] = formValue.productSizeMetaData[selectedSize].dpi;
	            if (formValue.matting !== '') {
	                order.orderMetaData['matting'] = formValue.matting;
	            }
	
	            if (formValue.borderColor !== '') {
	                order.orderMetaData['borderColor'] = formValue.borderColor;
	            }
	
	            return order;
	        }
	    }, {
	        key: 'setSubmittedOrder',
	        value: function setSubmittedOrder(setStatus, formValues, discountCoupon) {
	            var orderReq = this.createOrderRequest(formValues);
	            //Note: This overrides other status if any
	            setStatus({ submittedOrder: orderReq, discountCoupon: discountCoupon });
	        }
	    }, {
	        key: 'isPrePaymentRequired',
	        value: function isPrePaymentRequired(isCustomProduct) {
	            return isCustomProduct ? true : false;
	        }
	    }, {
	        key: 'handleFormSubmission',
	        value: function handleFormSubmission(value, _ref) {
	            var setSubmitting = _ref.setSubmitting,
	                setStatus = _ref.setStatus;
	
	            var couponCode = value.hasCouponCode ? value.couponCode : null;
	
	            if (couponCode) {
	                _OrderAPI2.default.validateDiscountCoupon(couponCode, this.props.product.id, function (success, discountCoupon) {
	                    if (success) {
	                        this.setSubmittedOrder(setStatus, value, discountCoupon);
	                    } else {
	                        setSubmitting(false);
	                    }
	                }.bind(this));
	            } else {
	                this.setSubmittedOrder(setStatus, value);
	            }
	        }
	    }, {
	        key: 'displayDeliveryInputs',
	        value: function displayDeliveryInputs(values, isCustomProduct) {
	            var quantity = values.quantity;
	            var customerImg = values.customerUploadedImage;
	            var isSizeProvided = values.productSize !== '';
	
	            if (!isCustomProduct) return !isNaN(quantity) && isSizeProvided;else return !isNaN(quantity) && isSizeProvided && customerImg !== null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var product = this.props.product;
	
	            if (product === null) return _react2.default.createElement(_OrderFormLoader2.default, null);
	
	            var isCustomProduct = _AppUtil2.default.isCustomProduct(product);
	            var initialValues = this.initialValues();
	            var validationScheme = this.validationScheme(isCustomProduct);
	            var isPrePaymentRequired = this.isPrePaymentRequired(isCustomProduct);
	
	            return _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: initialValues, onSubmit: this.handleFormSubmission,
	                validationSchema: validationScheme,
	                render: function render(formikProps) {
	                    var values = formikProps.values;
	                    var status = formikProps.status;
	                    var submittedOrder = status && status.submittedOrder ? status.submittedOrder : null;
	
	                    if (submittedOrder) {
	                        return _react2.default.createElement(_OrderConfirmation2.default, { order: submittedOrder,
	                            product: product,
	                            discountCoupon: status.discountCoupon,
	                            customerImage: values.customerUploadedImage,
	                            onClose: function onClose(reset) {
	                                formikProps.setStatus({}); //remove subittedOrder from status
	                                formikProps.setSubmitting(false);
	
	                                if (reset === true) formikProps.resetForm();
	                            } });
	                    }
	
	                    var displayDeliveryInputs = _this2.displayDeliveryInputs(values, isCustomProduct);
	
	                    return _react2.default.createElement(
	                        _OrderForm.OrderContext.Provider,
	                        { value: Object.assign({ product: product
	                            }, formikProps) },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'customFrameFormContainer' },
	                            _react2.default.createElement(
	                                _FormElements.RGForm,
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { margin: '20px 0' }, className: 'flexRow' },
	                                    _react2.default.createElement(_FrameImageUploader2.default, { isCustomProduct: isCustomProduct,
	                                        imgSrc: isCustomProduct ? null : product.previewImage }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'flexColumn', id: 'customFrameInputSection' },
	                                        values.productSize && _react2.default.createElement(
	                                            'div',
	                                            { id: 'totalCostAtTop' },
	                                            _react2.default.createElement(_OrderForm.TotalCost, { key: 'totalCostAtTop', showPriceOnly: true })
	                                        ),
	                                        _react2.default.createElement('input', { type: 'hidden', name: 'productSizeMetaData', value: values.productSizeMetaData.toString() }),
	                                        _react2.default.createElement(_PhotoFrameSizeInput2.default, { imgWidth: values.imgWidth, imgHeight: values.imgHeight }),
	                                        _react2.default.createElement(_FormElements.Input, { type: 'hidden', mui: 'off', name: 'productSize', value: values.productSize }),
	                                        _react2.default.createElement(MattingInput, null),
	                                        _react2.default.createElement(QuantityInput, null),
	                                        displayDeliveryInputs && _react2.default.createElement(
	                                            _react2.default.Fragment,
	                                            null,
	                                            _react2.default.createElement(
	                                                'h2',
	                                                null,
	                                                'Delivery Detail'
	                                            ),
	                                            _react2.default.createElement(_LocationTypeInput2.default, null),
	                                            _react2.default.createElement(_LocationTypeInput.AddressInput, null),
	                                            _react2.default.createElement(_CouponCodeInput2.default, null),
	                                            _react2.default.createElement(
	                                                'h2',
	                                                null,
	                                                'Payment Preference'
	                                            ),
	                                            _react2.default.createElement(_PaymentPreferenceInput2.default, { prepaymentRequired: isPrePaymentRequired }),
	                                            _react2.default.createElement(_OrderForm.TotalCost, { key: 'totalCostAtTop' }),
	                                            _react2.default.createElement(_OrderForm.ErrorMessages, null)
	                                        ),
	                                        _react2.default.createElement(_OrderForm.SubmitBtn, { displayDeliveryInputs: displayDeliveryInputs }),
	                                        _react2.default.createElement(_OrderForm.OrderInfo, { prepaymentRequired: true }),
	                                        !isCustomProduct && _react2.default.createElement(_ProductSocialShare2.default, { product: product, productImage: values.productImage })
	                                    )
	                                )
	                            )
	                        )
	                    );
	                } });
	        }
	    }]);
	
	    return PhotoFrameForm;
	}(_ProductOrderForm3.default);
	
	PhotoFrameForm.contextType = _OrderForm.OrderContext;
	exports.default = PhotoFrameForm;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrderForm = __webpack_require__(36);
	
	var _FormElements = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CouponCodeInput = function CouponCodeInput() {
	    var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
	        values = _useContext.values;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { id: 'couponCodeDiv' },
	            _react2.default.createElement(
	                'div',
	                { className: 'flexRow' },
	                _react2.default.createElement(_FormElements.Checkbox, { name: 'hasCouponCode', label: 'I have a Coupon Code!' })
	            ),
	            values.hasCouponCode && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FormElements.Input, { style: { flexGrow: '1' }, name: 'couponCode', type: 'text', placeholder: 'Enter Coupon Code' })
	            )
	        )
	    );
	};
	
	exports.default = CouponCodeInput;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddressInput = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrderForm = __webpack_require__(36);
	
	var _FormElements = __webpack_require__(13);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DELIVERY_LOCATION_TYPE = _AppConstants2.default.DELIVERY_LOCATION_TYPE;
	var OUTSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY;
	var INSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.INSIDE_KTM_VALLEY;
	
	var INSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.INSIDE_RING_ROAD;
	var OUTSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD;
	
	var DELIVERY_TYPE = _AppConstants2.default.DELIVERY_TYPE;
	
	var styles = {
	    regularDeliveryInfo: { color: 'gray', fontSize: '90%' },
	    extraCostInfo: { color: '#2e292b', marginTop: '10px', background: '#dfdfdf', padding: '5px 10px', borderBottom: "2px solid #f8931c" },
	    photoFrameDeliveryInfo: { color: "#2e292b", margin: "10px 0", background: "#dfdfdf", padding: "5px", borderBottom: "2px solid #f8931c" }
	};
	
	var AddressInput = exports.AddressInput = function AddressInput() {
	    var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
	        product = _useContext.product,
	        values = _useContext.values;
	
	    var hasOutsideRingroadCharge = product.outsideRingRoadCharge || false;
	    var productType = _AppConstants2.default.PRODUCT_TYPES[product.productType];
	
	    var isPhotoFrame = product.productType === _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val;
	
	    var showDeliveryOption = (values.locationType === INSIDE_KTM_VALLEY.val || values.locationType === OUTSIDE_RING_ROAD.val || values.locationType === INSIDE_RING_ROAD.val) && !isPhotoFrame;
	
	    var deliveryTime = (0, _react.useMemo)(function () {
	        return _AppUtil2.default.getDeliveryTime(product.productType, values.deliveryType);
	    }, [product, values.deliveryType]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { marginTop: '10px' } },
	            _react2.default.createElement(_FormElements.Input, { label: 'Street Address: ', name: 'streetAddress', type: 'text', placeholder: 'E.g. GopiKrishna Nagar, Chabahil, KTM' })
	        ),
	        _react2.default.createElement(_FormElements.Input, { label: 'Phone: ', name: 'phone', type: 'text', placeholder: 'E.g. 9862441133' }),
	        _react2.default.createElement(_FormElements.Input, { label: 'Full Name: ', name: 'customerName', type: 'text', placeholder: 'E.g. Ram Prasad Koirala' }),
	        _react2.default.createElement(_FormElements.Checkbox, { name: 'receiveEmailNotification', label: 'Send Me Email Notification' }),
	        values.receiveEmailNotification && _react2.default.createElement(_FormElements.Input, { name: 'customerEmail', placeholder: 'Enter your email here', type: 'email' }),
	        showDeliveryOption && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h2',
	                { style: { color: 'gray' } },
	                'Delivery Option'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'flexRow' },
	                _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'deliveryType', value: DELIVERY_TYPE.REGULAR.val,
	                    label: DELIVERY_TYPE.REGULAR.label,
	                    checked: values.deliveryType === DELIVERY_TYPE.REGULAR.val }),
	                _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'deliveryType', value: DELIVERY_TYPE.IMMEDIATE.val,
	                    label: DELIVERY_TYPE.IMMEDIATE.label,
	                    checked: values.deliveryType === DELIVERY_TYPE.IMMEDIATE.val })
	            ),
	            values.deliveryType === DELIVERY_TYPE.REGULAR.val && _react2.default.createElement(
	                'span',
	                { style: styles.regularDeliveryInfo },
	                hasOutsideRingroadCharge ? '' : 'Free ',
	                'Home Delivery within next ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    deliveryTime
	                ),
	                '.'
	            ),
	            values.deliveryType === DELIVERY_TYPE.IMMEDIATE.val && _react2.default.createElement(
	                'span',
	                { style: styles.extraCostInfo, className: productType.hasImmediateDelivery ? '' : 'strikeout' },
	                _react2.default.createElement(
	                    'b',
	                    { style: { color: '#f49600' } },
	                    'Extra Rs. ',
	                    DELIVERY_TYPE.IMMEDIATE.extraCost
	                ),
	                ' for delivery within ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    deliveryTime
	                ),
	                '.'
	            ),
	            _react2.default.createElement('hr', null)
	        ),
	        _react2.default.createElement(_FormElements.TextArea, { placeholder: "Extra note for your delivery or any landmark detail (Optional)", name: 'additionalNote', rows: '3' }),
	        isPhotoFrame && _react2.default.createElement(
	            'div',
	            { style: styles.photoFrameDeliveryInfo },
	            _react2.default.createElement('i', { className: 'fa fa-clock-o', style: { color: "rgb(244, 150, 0)" }, 'aria-hidden': 'true' }),
	            ' Frame takes ',
	            _react2.default.createElement(
	                'b',
	                null,
	                deliveryTime
	            ),
	            ' to complete the delivery.'
	        )
	    );
	};
	
	var LocationTypeInput = function LocationTypeInput(_ref) {
	    var prepaymentRequired = _ref.prepaymentRequired;
	
	    var _useContext2 = (0, _react.useContext)(_OrderForm.OrderContext),
	        product = _useContext2.product,
	        values = _useContext2.values,
	        setFieldValue = _useContext2.setFieldValue;
	
	    var hasOutsideRingroadCharge = product.outsideRingRoadCharge || false;
	
	    var onInsideKTMValleySelect = (0, _react.useCallback)(function (setFieldValue, locationType) {
	        var deliveryType = _AppUtil2.default.getDefaultDeliveryType(product.productType, INSIDE_KTM_VALLEY.val);
	        setFieldValue('deliveryType', deliveryType);
	
	        if (!values.paymentPreference && !prepaymentRequired) setFieldValue('paymentPreference', "COD");
	
	        setFieldValue('locationType', locationType.val);
	    }, [product, values.paymentPreference]);
	
	    var onOutsideKTMValleySelect = (0, _react.useCallback)(function (setFieldValue) {
	        var deliveryType = _AppUtil2.default.getDefaultDeliveryType(product.productType, OUTSIDE_KTM_VALLEY.val);
	        setFieldValue('deliveryType', deliveryType);
	
	        if (values.paymentPreference === 'COD') setFieldValue('paymentPreference', "");
	
	        setFieldValue('locationType', OUTSIDE_KTM_VALLEY.val);
	    }, [product, values.paymentPreference]);
	
	    var locationExtraCost = values.locationType ? _AppUtil2.default.getLocationExtraCost(values.locationType, product) : 0;
	
	    var frameCostInfo = product && product.productType === _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val ? "Fragile product requires special handling, hence the added cost." : "";
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'label',
	            { style: { fontSize: '12px', color: 'rgba(0,0,0,.54)', marginBottom: '10px', display: 'block' } },
	            'Where are you located?'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: hasOutsideRingroadCharge ? 'flexColumn' : 'flexRow' },
	            !hasOutsideRingroadCharge && _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'locationType', value: INSIDE_KTM_VALLEY.val,
	                label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    INSIDE_KTM_VALLEY.label
	                ),
	                checked: values.locationType === INSIDE_KTM_VALLEY.val,
	                onChange: function onChange() {
	                    return onInsideKTMValleySelect(setFieldValue, INSIDE_KTM_VALLEY);
	                } }),
	            hasOutsideRingroadCharge && _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'locationType', value: INSIDE_RING_ROAD.val,
	                label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    INSIDE_RING_ROAD.label
	                ),
	                checked: values.locationType === INSIDE_RING_ROAD.val,
	                onChange: function onChange() {
	                    return onInsideKTMValleySelect(setFieldValue, INSIDE_RING_ROAD);
	                } }),
	            hasOutsideRingroadCharge && _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'locationType', value: OUTSIDE_RING_ROAD.val,
	                label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    OUTSIDE_RING_ROAD.label
	                ),
	                checked: values.locationType === OUTSIDE_RING_ROAD.val,
	                onChange: function onChange() {
	                    return onInsideKTMValleySelect(setFieldValue, OUTSIDE_RING_ROAD);
	                } }),
	            _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'locationType', value: OUTSIDE_KTM_VALLEY.val,
	                label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    OUTSIDE_KTM_VALLEY.label
	                ),
	                checked: values.locationType === OUTSIDE_KTM_VALLEY.val,
	                onChange: function onChange() {
	                    return onOutsideKTMValleySelect(setFieldValue);
	                } })
	        ),
	        locationExtraCost > 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { style: styles.extraCostInfo },
	                _react2.default.createElement(
	                    'b',
	                    { style: { color: '#f49600' } },
	                    'Extra Rs. ',
	                    locationExtraCost
	                ),
	                ' for ',
	                DELIVERY_LOCATION_TYPE[values.locationType].label,
	                '. ',
	                frameCostInfo
	            )
	        )
	    );
	};
	
	exports.default = LocationTypeInput;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrderForm = __webpack_require__(36);
	
	var _FormElements = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	    extraCostInfo: { color: '#2e292b', marginTop: '10px', background: '#dfdfdf', padding: '5px 10px', borderBottom: "2px solid #f8931c", fontSize: '95%' }
	};
	
	var PaymentPreferenceInput = function PaymentPreferenceInput(_ref) {
	    var prepaymentRequired = _ref.prepaymentRequired;
	
	    var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
	        values = _useContext.values;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        prepaymentRequired && _react2.default.createElement(
	            'div',
	            { style: styles.extraCostInfo },
	            _react2.default.createElement(
	                'b',
	                { style: { color: '#f49600' } },
	                'Pre-Payment Required.'
	            ),
	            ' Select the payment option you can use to make the payment.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow' },
	            !prepaymentRequired && _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'paymentPreference', value: "COD",
	                label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    'Cash On Delivery'
	                ),
	                checked: values.paymentPreference === "COD" }),
	            _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'paymentPreference', value: "ESEWA",
	                label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    'eSewa'
	                ),
	                checked: values.paymentPreference === "ESEWA" }),
	            _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'paymentPreference', value: "QR_CODE_SCAN",
	                label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    'QR Code Scan'
	                ),
	                checked: values.paymentPreference === "QR_CODE_SCAN" }),
	            _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'paymentPreference', value: "BANK_TRANSER",
	                label: _react2.default.createElement(
	                    'span',
	                    { style: { color: '#596161' } },
	                    'Bank Transfer'
	                ),
	                checked: values.paymentPreference === "BANK_TRANSER" })
	        )
	    );
	};
	
	exports.default = PaymentPreferenceInput;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _AppElements = __webpack_require__(9);
	
	var _copyToClipboard = __webpack_require__(121);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
		copyIcon: { marginLeft: '10px', padding: '5px', background: '#eee', color: '#3a3535', cursor: 'pointer' },
		socialMediaBtn: { padding: '5px 10px', flexGrow: '1', textAlign: 'center', marginRight: '5px', color: 'black',
			border: '1px solid #eee', background: 'white', textDecoration: 'none', marginTop: '10px',
			':hover': { color: 'gray' } }
	};
	
	var ProductSocialShare = function (_React$Component) {
		_inherits(ProductSocialShare, _React$Component);
	
		function ProductSocialShare(props) {
			_classCallCheck(this, ProductSocialShare);
	
			var _this = _possibleConstructorReturn(this, (ProductSocialShare.__proto__ || Object.getPrototypeOf(ProductSocialShare)).call(this, props));
	
			_this.state = { copied: false };
			_this.onCopy = _this.onCopy.bind(_this);
			return _this;
		}
	
		_createClass(ProductSocialShare, [{
			key: 'onCopy',
			value: function onCopy(fullProductURL) {
				this.setState({ copied: false });
				_HttpService2.default.bitlyShortenURL(fullProductURL, function (shortURL) {
					this.setState({ copied: (0, _copyToClipboard2.default)(shortURL) });
				}.bind(this));
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevProps.productImage !== this.props.productImage) this.setState({ copied: false });
			}
		}, {
			key: 'render',
			value: function render() {
				var product = this.props.product;
				var img = this.props.productImage;
	
				var fullProductURL = _AppConstants2.default.WEBSITE + _AppUtil2.default.getProductURL(product) + "?sc_img=" + img;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'h4',
						{ style: { fontSize: '90%', color: 'gray' } },
						_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
						' Use the link below to share on Facebook, Twitter, Blog and other platforms.'
					),
					_react2.default.createElement(
						'div',
						{ className: 'flexRow' },
						_react2.default.createElement('input', { type: 'text', value: fullProductURL, readOnly: true, style: { flexGrow: '1', padding: '5px 10px' } }),
						_react2.default.createElement(
							_AppElements.Button,
							{ style: styles.copyIcon, onClick: this.onCopy.bind(this, fullProductURL) },
							_react2.default.createElement('i', { className: 'fa fa-files-o', 'aria-hidden': 'true' }),
							' Copy'
						)
					),
					this.state.copied && _react2.default.createElement(
						'small',
						null,
						'Copied. You can paste it now.'
					),
					_react2.default.createElement(
						'div',
						{ className: 'flexRow' },
						_react2.default.createElement(
							_AppElements.A,
							{ href: 'https://www.facebook.com/setocanvascom', style: styles.socialMediaBtn },
							_react2.default.createElement('i', { className: 'fa fa-facebook', 'aria-hidden': 'true' }),
							' Facebook'
						),
						_react2.default.createElement(
							_AppElements.A,
							{ href: 'https://twitter.com/', style: styles.socialMediaBtn },
							_react2.default.createElement('i', { className: 'fa fa-twitter', 'aria-hidden': 'true' }),
							' Twitter'
						),
						_react2.default.createElement(
							_AppElements.A,
							{ href: 'https://www.instagram.com/setocanvas/', style: [styles.socialMediaBtn, { marginRight: '0px' }] },
							_react2.default.createElement('i', { className: 'fa fa-instagram', 'aria-hidden': 'true' }),
							' Instagram'
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { marginTop: "5px", color: 'gray', fontSize: '90%' } },
						_react2.default.createElement(
							'span',
							null,
							'For any inquiry, call us at ',
							_react2.default.createElement('i', { style: { color: "#f8941c" }, className: 'fa fa-phone-square', 'aria-hidden': 'true' }),
							' ',
							_AppConstants2.default.CONTACT_NUMBER,
							' or WhatsApp at ',
							_react2.default.createElement('i', { style: { color: "green" }, className: 'fa fa-whatsapp', 'aria-hidden': 'true' }),
							' ',
							_AppConstants2.default.WHATS_APP,
							'.'
						)
					)
				);
			}
		}]);
	
		return ProductSocialShare;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(ProductSocialShare);

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _immutable = __webpack_require__(43);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _tabs = __webpack_require__(122);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _tab = __webpack_require__(85);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Loader = __webpack_require__(63);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	
	var ProductTabs = function ProductTabs(_ref) {
		var products = _ref.products,
		    ownerName = _ref.ownerName,
		    productViewMode = _ref.productViewMode;
	
	
		var availableTypes = Object.keys(PRODUCT_TYPES);
		var productTypes = products ? _immutable2.default.Set(products.map(function (p) {
			return PRODUCT_TYPES[p.productType];
		})).toArray() : [{ val: "dummyTab", label: _react2.default.createElement(_Loader2.default, { style: { width: '70px' } }) }];
	
		if (productTypes.length === 0) {
			productTypes.push(PRODUCT_TYPES.T_SHIRT);
		} else {
			productTypes = productTypes.sort(function (e1, e2) {
				var i1 = availableTypes.indexOf(e1.val);
				var i2 = availableTypes.indexOf(e2.val);
				if (i1 < i2) return -1;
				if (i1 > i2) return 1;
				return 0;
			});
		}
	
		var tabs = productTypes.map(function (productType) {
			var filteredProducts = products ? products.filter(function (p) {
				return p.productType === productType.val;
			}) : null;
	
			var emptyMessage = typeof productType.label === "string" ? "No " + productType.label + " Available" : "";
			return _react2.default.createElement(
				_tab2.default,
				{ key: ownerName + "-" + productType.val, value: productType.val, label: productType.label },
				_react2.default.createElement(_ProductList2.default, { products: filteredProducts, productViewMode: productViewMode,
					flattenProductImages: true, viewProductTags: true, emptyMsg: emptyMessage })
			);
		});
	
		return _react2.default.createElement(
			_tabs2.default,
			{ defaultSelectedIndex: 0, key: ownerName, style: { minHeight: '300px' } },
			tabs
		);
	};
	
	exports.default = ProductTabs;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductTags = function (_React$Component) {
		_inherits(ProductTags, _React$Component);
	
		function ProductTags() {
			_classCallCheck(this, ProductTags);
	
			return _possibleConstructorReturn(this, (ProductTags.__proto__ || Object.getPrototypeOf(ProductTags)).apply(this, arguments));
		}
	
		_createClass(ProductTags, [{
			key: 'render',
			value: function render() {
				var productTags = this.props.productTags;
	
				if (!productTags) return null;
	
				var tags = productTags.map(function (t) {
					return _react2.default.createElement(
						_AppElements.A,
						{ href: "/tag/" + t, key: t },
						t
					);
				});
				return _react2.default.createElement(
					'div',
					{ className: 'flexRow productTags' },
					tags
				);
			}
		}]);
	
		return ProductTags;
	}(_react2.default.Component);
	
	exports.default = ProductTags;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(622);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 235 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(99);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(242);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(145);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(146);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(99);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(100);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(625);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(100);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 242 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 243 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 244 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var _Fade = _interopRequireDefault(__webpack_require__(76));
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  closeClassName: _propTypes.default.string,
	  closeAriaLabel: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  color: _propTypes.default.string,
	  fade: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  toggle: _propTypes.default.func,
	  tag: _utils.tagPropType,
	  transition: _propTypes.default.shape(_Fade.default.propTypes),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  color: 'success',
	  isOpen: true,
	  tag: 'div',
	  closeAriaLabel: 'Close',
	  fade: true,
	  transition: (0, _objectSpread2.default)({}, _Fade.default.defaultProps, {
	    unmountOnExit: true
	  })
	};
	
	function Alert(props) {
	  var className = props.className,
	      closeClassName = props.closeClassName,
	      closeAriaLabel = props.closeAriaLabel,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      color = props.color,
	      isOpen = props.isOpen,
	      toggle = props.toggle,
	      children = props.children,
	      transition = props.transition,
	      fade = props.fade,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "closeClassName", "closeAriaLabel", "cssModule", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'alert', "alert-" + color, {
	    'alert-dismissible': toggle
	  }), cssModule);
	  var closeClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('close', closeClassName), cssModule);
	  var alertTransition = (0, _objectSpread2.default)({}, _Fade.default.defaultProps, transition, {
	    baseClass: fade ? transition.baseClass : '',
	    timeout: fade ? transition.timeout : 0
	  });
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, attributes, alertTransition, {
	    tag: Tag,
	    className: classes,
	    in: isOpen,
	    role: "alert",
	    innerRef: innerRef
	  }), toggle ? _react.default.createElement("button", {
	    type: "button",
	    className: closeClasses,
	    "aria-label": closeAriaLabel,
	    onClick: toggle
	  }, _react.default.createElement("span", {
	    "aria-hidden": "true"
	  }, "\xD7")) : null, children);
	}
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	var _default = Alert;
	exports.default = _default;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  'aria-label': _propTypes.default.string,
	  block: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  disabled: _propTypes.default.bool,
	  outline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  onClick: _propTypes.default.func,
	  size: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  close: _propTypes.default.bool
	};
	var defaultProps = {
	  color: 'secondary',
	  tag: 'button'
	};
	
	var Button =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Button, _React$Component);
	
	  function Button(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Button.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        active = _this$props.active,
	        ariaLabel = _this$props['aria-label'],
	        block = _this$props.block,
	        className = _this$props.className,
	        close = _this$props.close,
	        cssModule = _this$props.cssModule,
	        color = _this$props.color,
	        outline = _this$props.outline,
	        size = _this$props.size,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"]);
	
	    if (close && typeof attributes.children === 'undefined') {
	      attributes.children = _react.default.createElement("span", {
	        "aria-hidden": true
	      }, "\xD7");
	    }
	
	    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      close: close
	    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
	      active: active,
	      disabled: this.props.disabled
	    }), cssModule);
	
	    if (attributes.href && Tag === 'button') {
	      Tag = 'a';
	    }
	
	    var defaultAriaLabel = close ? 'Close' : null;
	    return _react.default.createElement(Tag, (0, _extends2.default)({
	      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
	    }, attributes, {
	      className: classes,
	      ref: innerRef,
	      onClick: this.onClick,
	      "aria-label": ariaLabel || defaultAriaLabel
	    }));
	  };
	
	  return Button;
	}(_react.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	var _default = Button;
	exports.default = _default;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(105));
	
	var propTypes = {
	  children: _propTypes.default.node
	};
	
	var ButtonDropdown = function ButtonDropdown(props) {
	  return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	    group: true
	  }, props));
	};
	
	ButtonDropdown.propTypes = propTypes;
	var _default = ButtonDropdown;
	exports.default = _default;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(148));
	
	var _utils = __webpack_require__(5);
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Carousel, _React$Component);
	
	  function Carousel(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2.default)(_this));
	    _this.renderItems = _this.renderItems.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hoverStart = _this.hoverStart.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hoverEnd = _this.hoverEnd.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      direction: 'right',
	      indicatorClicked: false
	    };
	    return _this;
	  }
	
	  var _proto = Carousel.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      direction: this.state.direction
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    // Set up the cycle
	    if (this.props.ride === 'carousel') {
	      this.setInterval();
	    } // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
	
	
	    document.addEventListener('keyup', this.handleKeyPress);
	  };
	
	  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setInterval(nextProps); // Calculate the direction to turn
	
	    if (this.props.activeIndex + 1 === nextProps.activeIndex) {
	      this.setState({
	        direction: 'right'
	      });
	    } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
	      this.setState({
	        direction: 'left'
	      });
	    } else if (this.props.activeIndex > nextProps.activeIndex) {
	      this.setState({
	        direction: this.state.indicatorClicked ? 'left' : 'right'
	      });
	    } else if (this.props.activeIndex !== nextProps.activeIndex) {
	      this.setState({
	        direction: this.state.indicatorClicked ? 'right' : 'left'
	      });
	    }
	
	    this.setState({
	      indicatorClicked: false
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.clearInterval();
	    document.removeEventListener('keyup', this.handleKeyPress);
	  };
	
	  _proto.setInterval = function (_setInterval) {
	    function setInterval() {
	      return _setInterval.apply(this, arguments);
	    }
	
	    setInterval.toString = function () {
	      return _setInterval.toString();
	    };
	
	    return setInterval;
	  }(function (props) {
	    if (props === void 0) {
	      props = this.props;
	    }
	
	    // make sure not to have multiple intervals going...
	    this.clearInterval();
	
	    if (props.interval) {
	      this.cycleInterval = setInterval(function () {
	        props.next();
	      }, parseInt(props.interval, 10));
	    }
	  });
	
	  _proto.clearInterval = function (_clearInterval) {
	    function clearInterval() {
	      return _clearInterval.apply(this, arguments);
	    }
	
	    clearInterval.toString = function () {
	      return _clearInterval.toString();
	    };
	
	    return clearInterval;
	  }(function () {
	    clearInterval(this.cycleInterval);
	  });
	
	  _proto.hoverStart = function hoverStart() {
	    if (this.props.pause === 'hover') {
	      this.clearInterval();
	    }
	
	    if (this.props.mouseEnter) {
	      var _this$props;
	
	      (_this$props = this.props).mouseEnter.apply(_this$props, arguments);
	    }
	  };
	
	  _proto.hoverEnd = function hoverEnd() {
	    if (this.props.pause === 'hover') {
	      this.setInterval();
	    }
	
	    if (this.props.mouseLeave) {
	      var _this$props2;
	
	      (_this$props2 = this.props).mouseLeave.apply(_this$props2, arguments);
	    }
	  };
	
	  _proto.handleKeyPress = function handleKeyPress(evt) {
	    if (this.props.keyboard) {
	      if (evt.keyCode === 37) {
	        this.props.previous();
	      } else if (evt.keyCode === 39) {
	        this.props.next();
	      }
	    }
	  };
	
	  _proto.renderItems = function renderItems(carouselItems, className) {
	    var _this2 = this;
	
	    var slide = this.props.slide;
	    return _react.default.createElement("div", {
	      className: className
	    }, carouselItems.map(function (item, index) {
	      var isIn = index === _this2.props.activeIndex;
	      return _react.default.cloneElement(item, {
	        in: isIn,
	        slide: slide
	      });
	    }));
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    var _this$props3 = this.props,
	        cssModule = _this$props3.cssModule,
	        slide = _this$props3.slide,
	        className = _this$props3.className;
	    var outerClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel', slide && 'slide'), cssModule);
	    var innerClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('carousel-inner'), cssModule); // filter out booleans, null, or undefined
	
	    var children = this.props.children.filter(function (child) {
	      return child !== null && child !== undefined && typeof child !== 'boolean';
	    });
	    var slidesOnly = children.every(function (child) {
	      return child.type === _CarouselItem.default;
	    }); // Rendering only slides
	
	    if (slidesOnly) {
	      return _react.default.createElement("div", {
	        className: outerClasses,
	        onMouseEnter: this.hoverStart,
	        onMouseLeave: this.hoverEnd
	      }, this.renderItems(children, innerClasses));
	    } // Rendering slides and controls
	
	
	    if (children[0] instanceof Array) {
	      var _carouselItems = children[0];
	      var _controlLeft = children[1];
	      var _controlRight = children[2];
	      return _react.default.createElement("div", {
	        className: outerClasses,
	        onMouseEnter: this.hoverStart,
	        onMouseLeave: this.hoverEnd
	      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight);
	    } // Rendering indicators, slides and controls
	
	
	    var indicators = children[0];
	
	    var wrappedOnClick = function wrappedOnClick(e) {
	      if (typeof indicators.props.onClickHandler === 'function') {
	        _this3.setState({
	          indicatorClicked: true
	        }, function () {
	          return indicators.props.onClickHandler(e);
	        });
	      }
	    };
	
	    var wrappedIndicators = _react.default.cloneElement(indicators, {
	      onClickHandler: wrappedOnClick
	    });
	
	    var carouselItems = children[1];
	    var controlLeft = children[2];
	    var controlRight = children[3];
	    return _react.default.createElement("div", {
	      className: outerClasses,
	      onMouseEnter: this.hoverStart,
	      onMouseLeave: this.hoverEnd
	    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight);
	  };
	
	  return Carousel;
	}(_react.default.Component);
	
	Carousel.propTypes = {
	  // the current active slide of the carousel
	  activeIndex: _propTypes.default.number,
	  // a function which should advance the carousel to the next slide (via activeIndex)
	  next: _propTypes.default.func.isRequired,
	  // a function which should advance the carousel to the previous slide (via activeIndex)
	  previous: _propTypes.default.func.isRequired,
	  // controls if the left and right arrow keys should control the carousel
	  keyboard: _propTypes.default.bool,
	
	  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
	   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
	   */
	  pause: _propTypes.default.oneOf(['hover', false]),
	  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
	  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
	  ride: _propTypes.default.oneOf(['carousel']),
	  // the interval at which the carousel automatically cycles (default: 5000)
	  // eslint-disable-next-line react/no-unused-prop-types
	  interval: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
	  children: _propTypes.default.array,
	  // called when the mouse enters the Carousel
	  mouseEnter: _propTypes.default.func,
	  // called when the mouse exits the Carousel
	  mouseLeave: _propTypes.default.func,
	  // controls whether the slide animation on the Carousel works or not
	  slide: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  className: _propTypes.default.string
	};
	Carousel.defaultProps = {
	  interval: 5000,
	  pause: 'hover',
	  keyboard: true,
	  slide: true
	};
	Carousel.childContextTypes = {
	  direction: _propTypes.default.string
	};
	var _default = Carousel;
	exports.default = _default;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var CarouselCaption = function CarouselCaption(props) {
	  var captionHeader = props.captionHeader,
	      captionText = props.captionText,
	      cssModule = props.cssModule,
	      className = props.className;
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
	  return _react.default.createElement("div", {
	    className: classes
	  }, _react.default.createElement("h3", null, captionHeader), _react.default.createElement("p", null, captionText));
	};
	
	CarouselCaption.propTypes = {
	  captionHeader: _propTypes.default.string,
	  captionText: _propTypes.default.string.isRequired,
	  cssModule: _propTypes.default.object,
	  className: _propTypes.default.string
	};
	var _default = CarouselCaption;
	exports.default = _default;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var CarouselControl = function CarouselControl(props) {
	  var direction = props.direction,
	      onClickHandler = props.onClickHandler,
	      cssModule = props.cssModule,
	      directionText = props.directionText,
	      className = props.className;
	  var anchorClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "carousel-control-" + direction), cssModule);
	  var iconClasses = (0, _utils.mapToCssModules)((0, _classnames.default)("carousel-control-" + direction + "-icon"), cssModule);
	  var screenReaderClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('sr-only'), cssModule);
	  return _react.default.createElement("a", {
	    className: anchorClasses,
	    role: "button",
	    tabIndex: "0",
	    onClick: function onClick(e) {
	      e.preventDefault();
	      onClickHandler();
	    }
	  }, _react.default.createElement("span", {
	    className: iconClasses,
	    "aria-hidden": "true"
	  }), _react.default.createElement("span", {
	    className: screenReaderClasses
	  }, directionText || direction));
	};
	
	CarouselControl.propTypes = {
	  direction: _propTypes.default.oneOf(['prev', 'next']).isRequired,
	  onClickHandler: _propTypes.default.func.isRequired,
	  cssModule: _propTypes.default.object,
	  directionText: _propTypes.default.string,
	  className: _propTypes.default.string
	};
	var _default = CarouselControl;
	exports.default = _default;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var CarouselIndicators = function CarouselIndicators(props) {
	  var items = props.items,
	      activeIndex = props.activeIndex,
	      cssModule = props.cssModule,
	      onClickHandler = props.onClickHandler,
	      className = props.className;
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'carousel-indicators'), cssModule);
	  var indicators = items.map(function (item, idx) {
	    var indicatorClasses = (0, _utils.mapToCssModules)((0, _classnames.default)({
	      active: activeIndex === idx
	    }), cssModule);
	    return _react.default.createElement("li", {
	      key: "" + (item.key || Object.values(item).join('')),
	      onClick: function onClick(e) {
	        e.preventDefault();
	        onClickHandler(idx);
	      },
	      className: indicatorClasses
	    });
	  });
	  return _react.default.createElement("ol", {
	    className: listClasses
	  }, indicators);
	};
	
	CarouselIndicators.propTypes = {
	  items: _propTypes.default.array.isRequired,
	  activeIndex: _propTypes.default.number.isRequired,
	  cssModule: _propTypes.default.object,
	  onClickHandler: _propTypes.default.func.isRequired,
	  className: _propTypes.default.string
	};
	var _default = CarouselIndicators;
	exports.default = _default;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _reactTransitionGroup = __webpack_require__(151);
	
	var _utils = __webpack_require__(5);
	
	var _transitionStatusToCl;
	
	var propTypes = (0, _objectSpread2.default)({}, _reactTransitionGroup.Transition.propTypes, {
	  isOpen: _propTypes.default.bool,
	  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
	  tag: _utils.tagPropType,
	  className: _propTypes.default.node,
	  navbar: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
	});
	var defaultProps = (0, _objectSpread2.default)({}, _reactTransitionGroup.Transition.defaultProps, {
	  isOpen: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  tag: 'div',
	  timeout: _utils.TransitionTimeouts.Collapse
	});
	var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[_utils.TransitionStatuses.ENTERING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.ENTERED] = 'collapse show', _transitionStatusToCl[_utils.TransitionStatuses.EXITING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.EXITED] = 'collapse', _transitionStatusToCl);
	
	function getTransitionClass(status) {
	  return transitionStatusToClassHash[status] || 'collapse';
	}
	
	function getHeight(node) {
	  return node.scrollHeight;
	}
	
	var Collapse =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(Collapse, _Component);
	
	  function Collapse(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      height: null
	    };
	    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
	      _this[name] = _this[name].bind((0, _assertThisInitialized2.default)(_this));
	    });
	    return _this;
	  }
	
	  var _proto = Collapse.prototype;
	
	  _proto.onEntering = function onEntering(node, isAppearing) {
	    this.setState({
	      height: getHeight(node)
	    });
	    this.props.onEntering(node, isAppearing);
	  };
	
	  _proto.onEntered = function onEntered(node, isAppearing) {
	    this.setState({
	      height: null
	    });
	    this.props.onEntered(node, isAppearing);
	  };
	
	  _proto.onExit = function onExit(node) {
	    this.setState({
	      height: getHeight(node)
	    });
	    this.props.onExit(node);
	  };
	
	  _proto.onExiting = function onExiting(node) {
	    // getting this variable triggers a reflow
	    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
	
	    this.setState({
	      height: 0
	    });
	    this.props.onExiting(node);
	  };
	
	  _proto.onExited = function onExited(node) {
	    this.setState({
	      height: null
	    });
	    this.props.onExited(node);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        Tag = _this$props.tag,
	        isOpen = _this$props.isOpen,
	        className = _this$props.className,
	        navbar = _this$props.navbar,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        innerRef = _this$props.innerRef,
	        otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"]);
	    var height = this.state.height;
	    var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
	    var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
	    return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
	      in: isOpen,
	      onEntering: this.onEntering,
	      onEntered: this.onEntered,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }), function (status) {
	      var collapseClass = getTransitionClass(status);
	      var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
	      var style = height === null ? null : {
	        height: height
	      };
	      return _react.default.createElement(Tag, (0, _extends2.default)({}, childProps, {
	        style: (0, _objectSpread2.default)({}, childProps.style, style),
	        className: classes,
	        ref: _this2.props.innerRef
	      }), children);
	    });
	  };
	
	  return Collapse;
	}(_react.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	var _default = Collapse;
	exports.default = _default;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'span'
	};
	
	var InputGroupText = function InputGroupText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group-text'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	InputGroupText.propTypes = propTypes;
	InputGroupText.defaultProps = defaultProps;
	var _default = InputGroupText;
	exports.default = _default;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _TooltipPopoverWrapper = _interopRequireWildcard(__webpack_require__(258));
	
	var defaultProps = {
	  placement: 'right',
	  placementPrefix: 'bs-popover',
	  trigger: 'click'
	};
	
	var Popover = function Popover(props) {
	  var popperClasses = (0, _classnames.default)('popover', 'show');
	  var classes = (0, _classnames.default)('popover-inner', props.innerClassName);
	  return _react.default.createElement(_TooltipPopoverWrapper.default, (0, _extends2.default)({}, props, {
	    popperClassName: popperClasses,
	    innerClassName: classes
	  }));
	};
	
	Popover.propTypes = _TooltipPopoverWrapper.propTypes;
	Popover.defaultProps = defaultProps;
	var _default = Popover;
	exports.default = _default;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _reactPopper = __webpack_require__(108);
	
	var _utils = __webpack_require__(5);
	
	var _Fade = _interopRequireDefault(__webpack_require__(76));
	
	function noop() {}
	
	var propTypes = {
	  children: _propTypes.default.node.isRequired,
	  popperClassName: _propTypes.default.string,
	  placement: _propTypes.default.string,
	  placementPrefix: _propTypes.default.string,
	  arrowClassName: _propTypes.default.string,
	  hideArrow: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  isOpen: _propTypes.default.bool.isRequired,
	  cssModule: _propTypes.default.object,
	  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  fallbackPlacement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
	  flip: _propTypes.default.bool,
	  container: _utils.targetPropType,
	  target: _utils.targetPropType.isRequired,
	  modifiers: _propTypes.default.object,
	  boundariesElement: _propTypes.default.oneOfType([_propTypes.default.string, _utils.DOMElement]),
	  onClosed: _propTypes.default.func,
	  fade: _propTypes.default.bool,
	  transition: _propTypes.default.shape(_Fade.default.propTypes)
	};
	var defaultProps = {
	  boundariesElement: 'scrollParent',
	  placement: 'auto',
	  hideArrow: false,
	  isOpen: false,
	  offset: 0,
	  fallbackPlacement: 'flip',
	  flip: true,
	  container: 'body',
	  modifiers: {},
	  onClosed: noop,
	  fade: true,
	  transition: (0, _objectSpread2.default)({}, _Fade.default.defaultProps)
	};
	
	var PopperContent =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(PopperContent, _React$Component);
	
	  function PopperContent(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.handlePlacementChange = _this.handlePlacementChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.setTargetNode = _this.setTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getTargetNode = _this.getTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClosed = _this.onClosed.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.isOpen
	    };
	    return _this;
	  }
	
	  PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.isOpen && !state.isOpen) {
	      return {
	        isOpen: props.isOpen
	      };
	    } else return null;
	  };
	
	  var _proto = PopperContent.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
	      this._element.childNodes[0].focus();
	    }
	  };
	
	  _proto.setTargetNode = function setTargetNode(node) {
	    this.targetNode = node;
	  };
	
	  _proto.getTargetNode = function getTargetNode() {
	    return this.targetNode;
	  };
	
	  _proto.getContainerNode = function getContainerNode() {
	    return (0, _utils.getTarget)(this.props.container);
	  };
	
	  _proto.getRef = function getRef(ref) {
	    this._element = ref;
	  };
	
	  _proto.handlePlacementChange = function handlePlacementChange(data) {
	    if (this.state.placement !== data.placement) {
	      this.setState({
	        placement: data.placement
	      });
	    }
	
	    return data;
	  };
	
	  _proto.onClosed = function onClosed() {
	    this.props.onClosed();
	    this.setState({
	      isOpen: false
	    });
	  };
	
	  _proto.renderChildren = function renderChildren() {
	    var _this$props = this.props,
	        cssModule = _this$props.cssModule,
	        children = _this$props.children,
	        isOpen = _this$props.isOpen,
	        flip = _this$props.flip,
	        target = _this$props.target,
	        offset = _this$props.offset,
	        fallbackPlacement = _this$props.fallbackPlacement,
	        placementPrefix = _this$props.placementPrefix,
	        _arrowClassName = _this$props.arrowClassName,
	        hideArrow = _this$props.hideArrow,
	        _popperClassName = _this$props.popperClassName,
	        tag = _this$props.tag,
	        container = _this$props.container,
	        modifiers = _this$props.modifiers,
	        boundariesElement = _this$props.boundariesElement,
	        onClosed = _this$props.onClosed,
	        fade = _this$props.fade,
	        transition = _this$props.transition,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "hideArrow", "popperClassName", "tag", "container", "modifiers", "boundariesElement", "onClosed", "fade", "transition"]);
	    var arrowClassName = (0, _utils.mapToCssModules)((0, _classnames.default)('arrow', _arrowClassName), cssModule);
	    var placement = this.state.placement || attrs.placement;
	    var placementFirstPart = placement.split('-')[0];
	    var popperClassName = (0, _utils.mapToCssModules)((0, _classnames.default)(_popperClassName, placementPrefix ? placementPrefix + "-" + placementFirstPart : placementFirstPart), this.props.cssModule);
	    var extendedModifiers = (0, _objectSpread2.default)({
	      offset: {
	        offset: offset
	      },
	      flip: {
	        enabled: flip,
	        behavior: fallbackPlacement
	      },
	      preventOverflow: {
	        boundariesElement: boundariesElement
	      },
	      update: {
	        enabled: true,
	        order: 950,
	        fn: this.handlePlacementChange
	      }
	    }, modifiers);
	    var popperTransition = (0, _objectSpread2.default)({}, _Fade.default.defaultProps, transition, {
	      baseClass: fade ? transition.baseClass : '',
	      timeout: fade ? transition.timeout : 0
	    });
	    return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, popperTransition, attrs, {
	      in: isOpen,
	      onExited: this.onClosed,
	      tag: tag
	    }), _react.default.createElement(_reactPopper.Popper, {
	      referenceElement: this.targetNode,
	      modifiers: extendedModifiers,
	      placement: placement
	    }, function (_ref) {
	      var ref = _ref.ref,
	          style = _ref.style,
	          placement = _ref.placement,
	          arrowProps = _ref.arrowProps;
	      return _react.default.createElement("div", {
	        ref: ref,
	        style: style,
	        className: popperClassName,
	        "x-placement": placement
	      }, children, !hideArrow && _react.default.createElement("span", {
	        ref: arrowProps.ref,
	        className: arrowClassName,
	        style: arrowProps.style
	      }));
	    }));
	  };
	
	  _proto.render = function render() {
	    this.setTargetNode((0, _utils.getTarget)(this.props.target));
	
	    if (this.state.isOpen) {
	      return this.props.container === 'inline' ? this.renderChildren() : _reactDom.default.createPortal(_react.default.createElement("div", {
	        ref: this.getRef
	      }, this.renderChildren()), this.getContainerNode());
	    }
	
	    return null;
	  };
	
	  return PopperContent;
	}(_react.default.Component);
	
	PopperContent.propTypes = propTypes;
	PopperContent.defaultProps = defaultProps;
	var _default = PopperContent;
	exports.default = _default;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.TabContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	/**
	 * TabContext
	 * {
	 *  activeTabId: PropTypes.any
	 * }
	 */
	var TabContext = _react.default.createContext({});
	
	exports.TabContext = TabContext;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _TooltipPopoverWrapper = _interopRequireWildcard(__webpack_require__(258));
	
	var defaultProps = {
	  placement: 'top',
	  autohide: true,
	  placementPrefix: 'bs-tooltip',
	  trigger: 'click hover focus'
	};
	
	var Tooltip = function Tooltip(props) {
	  var popperClasses = (0, _classnames.default)('tooltip', 'show');
	  var classes = (0, _classnames.default)('tooltip-inner', props.innerClassName);
	  return _react.default.createElement(_TooltipPopoverWrapper.default, (0, _extends2.default)({}, props, {
	    popperClassName: popperClasses,
	    innerClassName: classes
	  }));
	};
	
	Tooltip.propTypes = _TooltipPopoverWrapper.propTypes;
	Tooltip.defaultProps = defaultProps;
	var _default = Tooltip;
	exports.default = _default;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = exports.propTypes = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _PopperContent = _interopRequireDefault(__webpack_require__(255));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  placement: _propTypes.default.oneOf(_utils.PopperPlacements),
	  target: _utils.targetPropType.isRequired,
	  container: _utils.targetPropType,
	  isOpen: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  hideArrow: _propTypes.default.bool,
	  boundariesElement: _propTypes.default.oneOfType([_propTypes.default.string, _utils.DOMElement]),
	  className: _propTypes.default.string,
	  innerClassName: _propTypes.default.string,
	  arrowClassName: _propTypes.default.string,
	  popperClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  toggle: _propTypes.default.func,
	  autohide: _propTypes.default.bool,
	  placementPrefix: _propTypes.default.string,
	  delay: _propTypes.default.oneOfType([_propTypes.default.shape({
	    show: _propTypes.default.number,
	    hide: _propTypes.default.number
	  }), _propTypes.default.number]),
	  modifiers: _propTypes.default.object,
	  offset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
	  trigger: _propTypes.default.string,
	  fade: _propTypes.default.bool,
	  flip: _propTypes.default.bool
	};
	exports.propTypes = propTypes;
	var DEFAULT_DELAYS = {
	  show: 0,
	  hide: 0
	};
	var defaultProps = {
	  isOpen: false,
	  hideArrow: false,
	  autohide: false,
	  delay: DEFAULT_DELAYS,
	  toggle: function toggle() {},
	  trigger: 'click',
	  fade: true
	};
	
	function isInDOMSubtree(element, subtreeRoot) {
	  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
	}
	
	var TooltipPopoverWrapper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(TooltipPopoverWrapper, _React$Component);
	
	  function TooltipPopoverWrapper(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this._target = null;
	    _this.addTargetEvents = _this.addTargetEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.removeTargetEvents = _this.removeTargetEvents.bind((0, _assertThisInitialized2.default)(_this));
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.showWithDelay = _this.showWithDelay.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hideWithDelay = _this.hideWithDelay.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind((0, _assertThisInitialized2.default)(_this));
	    _this.show = _this.show.bind((0, _assertThisInitialized2.default)(_this));
	    _this.hide = _this.hide.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onEscKeyDown = _this.onEscKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClosed = _this.onClosed.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.isOpen
	    };
	    return _this;
	  }
	
	  var _proto = TooltipPopoverWrapper.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateTarget();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.removeTargetEvents();
	  };
	
	  TooltipPopoverWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.isOpen && !state.isOpen) {
	      return {
	        isOpen: props.isOpen
	      };
	    } else return null;
	  };
	
	  _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
	    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (this.state.isOpen && !this.props.isOpen) {
	        this.toggle();
	      }
	    }
	  };
	
	  _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
	    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
	      if (this._showTimeout) {
	        this.clearShowTimeout();
	      }
	
	      e.persist();
	      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
	    }
	  };
	
	  _proto.onEscKeyDown = function onEscKeyDown(e) {
	    if (e.key === 'Escape') {
	      this.hide(e);
	    }
	  };
	
	  _proto.getRef = function getRef(ref) {
	    var innerRef = this.props.innerRef;
	
	    if (innerRef) {
	      if (typeof innerRef === 'function') {
	        innerRef(ref);
	      } else if (typeof innerRef === 'object') {
	        innerRef.current = ref;
	      }
	    }
	
	    this._popover = ref;
	  };
	
	  _proto.getDelay = function getDelay(key) {
	    var delay = this.props.delay;
	
	    if (typeof delay === 'object') {
	      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
	    }
	
	    return delay;
	  };
	
	  _proto.show = function show(e) {
	    if (!this.props.isOpen) {
	      this.clearShowTimeout();
	      this.toggle(e);
	    }
	  };
	
	  _proto.showWithDelay = function showWithDelay(e) {
	    if (this._hideTimeout) {
	      this.clearHideTimeout();
	    }
	
	    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
	  };
	
	  _proto.hide = function hide(e) {
	    if (this.props.isOpen) {
	      this.clearHideTimeout();
	      this.toggle(e);
	    }
	  };
	
	  _proto.hideWithDelay = function hideWithDelay(e) {
	    if (this._showTimeout) {
	      this.clearShowTimeout();
	    }
	
	    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
	  };
	
	  _proto.clearShowTimeout = function clearShowTimeout() {
	    clearTimeout(this._showTimeout);
	    this._showTimeout = undefined;
	  };
	
	  _proto.clearHideTimeout = function clearHideTimeout() {
	    clearTimeout(this._hideTimeout);
	    this._hideTimeout = undefined;
	  };
	
	  _proto.handleDocumentClick = function handleDocumentClick(e) {
	    var triggers = this.props.trigger.split(' ');
	
	    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtree(e.target, this._target))) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
	        this.hideWithDelay(e);
	      } else if (!this.props.isOpen) {
	        this.showWithDelay(e);
	      }
	    } else if (triggers.indexOf('click') > -1 && isInDOMSubtree(e.target, this._target)) {
	      if (this._hideTimeout) {
	        this.clearHideTimeout();
	      }
	
	      if (!this.props.isOpen) {
	        this.showWithDelay(e);
	      } else {
	        this.hideWithDelay(e);
	      }
	    }
	  };
	
	  _proto.addTargetEvents = function addTargetEvents() {
	    if (this.props.trigger) {
	      var triggers = this.props.trigger.split(' ');
	
	      if (triggers.indexOf('manual') === -1) {
	        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
	          document.addEventListener('click', this.handleDocumentClick, true);
	        }
	
	        if (this._target) {
	          if (triggers.indexOf('hover') > -1) {
	            this._target.addEventListener('mouseover', this.showWithDelay, true);
	
	            this._target.addEventListener('mouseout', this.hideWithDelay, true);
	          }
	
	          if (triggers.indexOf('focus') > -1) {
	            this._target.addEventListener('focusin', this.show, true);
	
	            this._target.addEventListener('focusout', this.hide, true);
	          }
	
	          this._target.addEventListener('keydown', this.onEscKeyDown, true);
	        }
	      }
	    }
	  };
	
	  _proto.removeTargetEvents = function removeTargetEvents() {
	    if (this._target) {
	      this._target.removeEventListener('mouseover', this.showWithDelay, true);
	
	      this._target.removeEventListener('mouseout', this.hideWithDelay, true);
	
	      this._target.removeEventListener('keydown', this.onEscKeyDown, true);
	
	      this._target.removeEventListener('focusin', this.show, true);
	
	      this._target.removeEventListener('focusout', this.hide, true);
	    }
	
	    document.removeEventListener('click', this.handleDocumentClick, true);
	  };
	
	  _proto.updateTarget = function updateTarget() {
	    var newTarget = (0, _utils.getTarget)(this.props.target);
	
	    if (newTarget !== this._target) {
	      this.removeTargetEvents();
	      this._target = newTarget;
	      this.addTargetEvents();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    if (this.props.disabled) {
	      return e && e.preventDefault();
	    }
	
	    return this.props.toggle(e);
	  };
	
	  _proto.onClosed = function onClosed() {
	    this.setState({
	      isOpen: false
	    });
	  };
	
	  _proto.render = function render() {
	    if (!this.state.isOpen) {
	      return null;
	    }
	
	    this.updateTarget();
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        innerClassName = _this$props.innerClassName,
	        target = _this$props.target,
	        isOpen = _this$props.isOpen,
	        hideArrow = _this$props.hideArrow,
	        boundariesElement = _this$props.boundariesElement,
	        placement = _this$props.placement,
	        placementPrefix = _this$props.placementPrefix,
	        arrowClassName = _this$props.arrowClassName,
	        popperClassName = _this$props.popperClassName,
	        container = _this$props.container,
	        modifiers = _this$props.modifiers,
	        offset = _this$props.offset,
	        fade = _this$props.fade,
	        flip = _this$props.flip;
	    var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
	    var popperClasses = (0, _utils.mapToCssModules)(popperClassName, cssModule);
	    var classes = (0, _utils.mapToCssModules)(innerClassName, cssModule);
	    return _react.default.createElement(_PopperContent.default, {
	      className: className,
	      target: target,
	      isOpen: isOpen,
	      hideArrow: hideArrow,
	      boundariesElement: boundariesElement,
	      placement: placement,
	      placementPrefix: placementPrefix,
	      arrowClassName: arrowClassName,
	      popperClassName: popperClasses,
	      container: container,
	      modifiers: modifiers,
	      offset: offset,
	      cssModule: cssModule,
	      onClosed: this.onClosed,
	      fade: fade,
	      flip: flip
	    }, _react.default.createElement("div", (0, _extends2.default)({}, attributes, {
	      ref: this.getRef,
	      className: classes,
	      role: "tooltip",
	      "aria-hidden": isOpen,
	      onMouseOver: this.onMouseOverTooltipContent,
	      onMouseLeave: this.onMouseLeaveTooltipContent,
	      onKeyDown: this.onEscKeyDown
	    })));
	  };
	
	  return TooltipPopoverWrapper;
	}(_react.default.Component);
	
	TooltipPopoverWrapper.propTypes = propTypes;
	TooltipPopoverWrapper.defaultProps = defaultProps;
	var _default = TooltipPopoverWrapper;
	exports.default = _default;

/***/ },
/* 259 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 260 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	
	exports.safeInvoke = safeInvoke;

/***/ },
/* 261 */
[915, 149, 263],
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(149);
	
	var _ChildMapping = __webpack_require__(771);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 263 */
209,
/* 264 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = makePath;
	function makePath(strings) {
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  var path = strings.reduce(function (str, next) {
	    var value = values.shift();
	    return str + (value == null ? '' : value) + next;
	  });
	
	  return path.replace(/^\./, '');
	}
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(38);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 266 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(819),
	    isArguments = __webpack_require__(170),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(116),
	    isIndex = __webpack_require__(284),
	    isTypedArray = __webpack_require__(173);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(111),
	    eq = __webpack_require__(169);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    arrayEach = __webpack_require__(266),
	    assignValue = __webpack_require__(268),
	    baseAssign = __webpack_require__(798),
	    baseAssignIn = __webpack_require__(799),
	    cloneBuffer = __webpack_require__(825),
	    copyArray = __webpack_require__(274),
	    copySymbols = __webpack_require__(830),
	    copySymbolsIn = __webpack_require__(831),
	    getAllKeys = __webpack_require__(279),
	    getAllKeysIn = __webpack_require__(280),
	    getTag = __webpack_require__(80),
	    initCloneArray = __webpack_require__(849),
	    initCloneByTag = __webpack_require__(850),
	    initCloneObject = __webpack_require__(851),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(116),
	    isMap = __webpack_require__(892),
	    isObject = __webpack_require__(56),
	    isSet = __webpack_require__(894),
	    keys = __webpack_require__(68);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(159),
	    isArray = __webpack_require__(35);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(805),
	    isObjectLike = __webpack_require__(42);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 273 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 274 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(794),
	    deburr = __webpack_require__(888),
	    words = __webpack_require__(908);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(790),
	    arraySome = __webpack_require__(795),
	    cacheHas = __webpack_require__(823);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 278 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(271),
	    getSymbols = __webpack_require__(165),
	    keys = __webpack_require__(68);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(271),
	    getSymbolsIn = __webpack_require__(281),
	    keysIn = __webpack_require__(293);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(159),
	    getPrototype = __webpack_require__(114),
	    getSymbols = __webpack_require__(165),
	    stubArray = __webpack_require__(294);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(112),
	    isArguments = __webpack_require__(170),
	    isArray = __webpack_require__(35),
	    isIndex = __webpack_require__(284),
	    isLength = __webpack_require__(172),
	    toKey = __webpack_require__(81);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 283 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },
/* 284 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 286 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 287 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 288 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 289 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(796),
	    hasUnicode = __webpack_require__(283),
	    unicodeToArray = __webpack_require__(882);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ },
/* 291 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 292 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(267),
	    baseKeysIn = __webpack_require__(812),
	    isArrayLike = __webpack_require__(171);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 294 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 295 */
/***/ function(module, exports) {

	"use strict";
	function argumentsToArray(args) {
	  return Array.prototype.slice.apply(args);
	}
	
	function looksLikePromise(thing) {
	  return thing &&
	    thing.then &&
	    typeof (thing.then) === "function" &&
	    typeof (thing.catch) === "function";
	}
	
	function SynchronousPromise(ctorFunction) {
	  this.status = "pending";
	  this._paused = false;
	  this._next = [];
	  this._data = [];
	  this._runConstructorFunction(ctorFunction);
	}
	
	SynchronousPromise.prototype = {
	  then: function (next, fail) {
	    this._next.push([next, fail]);
	
	    if (this._isPendingResolutionOrRejection()) {
	      return this;
	    }
	
	    return this._applyNext();
	  },
	  catch: function (fn) {
	    this._next.push([undefined, fn]);
	
	    if (this._isPendingResolutionOrRejection()) {
	      return this;
	    }
	
	    return this._applyNext();
	  },
	  pause: function () {
	    this._paused = true;
	    return this;
	  },
	  resume: function () {
	    this._paused = false;
	    return this._applyNext();
	  },
	  _runConstructorFunction: function (ctorFunction) {
	    var self = this;
	
	    this._next.push([
	      function (r) { return r; },
	      function (err) { throw err; }
	    ]);
	
	    var isRun = false;
	    ctorFunction(function (result) {
	      if (isRun) {
	        return;
	      }
	
	      isRun = true;
	      self._setResolved();
	      self._data = [result];
	      self._applyNext();
	    }, function (err) {
	      if (isRun) {
	        return;
	      }
	
	      isRun = true;
	      self._setRejected();
	      self._data = [err];
	      self._applyNext();
	    });
	  },
	  _setRejected: function () {
	    this.status = "rejected";
	  },
	  _setResolved: function () {
	    this.status = "resolved";
	  },
	  _setPending: function () {
	    this.status = "pending";
	  },
	  _applyNext: function () {
	    if (this._next.length === 0 || this._paused) {
	      return this;
	    }
	
	    var next = this._findNext();
	    if (!next) {
	      return this;
	    }
	    return this._applyNextHandler(next);
	  },
	  _applyNextHandler: function (handler) {
	    try {
	      var data = handler.apply(null, this._data);
	
	      if (looksLikePromise(data)) {
	        this._handleNestedPromise(data);
	        return this;
	      }
	
	      this._setResolved();
	      this._data = [data];
	      return this._applyNext();
	    } catch (e) {
	      this._setRejected();
	      this._data = [e];
	      return this._applyNext();
	    }
	  },
	  _findNext: function () {
	    if (this._isPendingResolutionOrRejection()) {
	      return undefined;
	    }
	    var handler = this.status === "resolved"
	          ? this._findFirstResolutionHandler
	          : this._findFirstRejectionHandler;
	    return handler ? handler.apply(this) : undefined;
	  },
	  _handleNestedPromise: function (promise) {
	    this._setPending();
	    var self = this;
	    promise.then(function (d) {
	      self._setResolved();
	      self._data = [d];
	      self._applyNext();
	    }).catch(function (e) {
	      self._setRejected();
	      self._data = [e];
	      self._applyNext();
	    });
	  },
	  _isPendingResolutionOrRejection: function () {
	    return this.status === "pending";
	  },
	  _findFirstResolutionHandler: function () {
	    var next;
	    while (!next && this._next.length > 0) {
	      next = this._next.shift()[0];
	    }
	
	    return next;
	  },
	  _findFirstRejectionHandler: function () {
	    var next;
	    while (!next && this._next.length > 0) {
	      next = this._next.shift()[1];
	    }
	
	    return next;
	  }
	};
	SynchronousPromise.resolve = function (data) {
	  if (looksLikePromise(data)) {
	    return data;
	  }
	
	  return new SynchronousPromise(function (resolve) {
	    resolve(data);
	  });
	};
	SynchronousPromise.reject = function (error) {
	  if (looksLikePromise(error)) {
	    return error;
	  }
	
	  return new SynchronousPromise(function (resolve, reject) {
	    reject(error);
	  });
	};
	SynchronousPromise.all = function () {
	  var args = argumentsToArray(arguments);
	  if (Array.isArray(args[0])) {
	    args = args[0];
	  }
	  if (!args.length) {
	    return SynchronousPromise.resolve([]);
	  }
	  return new SynchronousPromise(function (resolve, reject) {
	    var
	      allData = [],
	      numResolved = 0,
	      doResolve = function () {
	        if (numResolved === args.length) {
	          resolve(allData);
	        }
	      },
	      rejected = false,
	      doReject = function (err) {
	        if (rejected) {
	          return;
	        }
	        rejected = true;
	        reject(err);
	      };
	    args.forEach(function (arg, idx) {
	      SynchronousPromise.resolve(arg).then(function (thisResult) {
	        allData[idx] = thisResult;
	        numResolved += 1;
	        doResolve();
	      }).catch(function (err) {
	        doReject(err);
	      });
	    });
	  });
	};
	SynchronousPromise.unresolved = function () {
	  var stash = {};
	  var result = new SynchronousPromise(function (resolve, reject) {
	    stash.resolve = resolve;
	    stash.reject = reject;
	  });
	  result.resolve = stash.resolve;
	  result.reject = stash.reject;
	  return result;
	};
	
	module.exports = {
	  SynchronousPromise: SynchronousPromise
	};
	


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(297);

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	var bind = __webpack_require__(178);
	var Axios = __webpack_require__(299);
	var defaults = __webpack_require__(120);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(175);
	axios.CancelToken = __webpack_require__(298);
	axios.isCancel = __webpack_require__(176);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(313);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(175);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(120);
	var utils = __webpack_require__(29);
	var InterceptorManager = __webpack_require__(300);
	var dispatchRequest = __webpack_require__(301);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	var transformData = __webpack_require__(304);
	var isCancel = __webpack_require__(176);
	var defaults = __webpack_require__(120);
	var isAbsoluteURL = __webpack_require__(309);
	var combineURLs = __webpack_require__(307);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 302 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(177);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 305 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 309 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(29);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 313 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 314 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 315 */
/***/ function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(317);


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(39);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.exports = Dispatcher;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxContainer
	 * 
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FluxContainerSubscriptions = __webpack_require__(319);
	var React = __webpack_require__(1);
	
	var invariant = __webpack_require__(39);
	var shallowEqual = __webpack_require__(328);
	
	var Component = React.Component;
	
	var DEFAULT_OPTIONS = {
	  pure: true,
	  withProps: false,
	  withContext: false
	};
	
	/**
	 * A FluxContainer is used to subscribe a react component to multiple stores.
	 * The stores that are used must be returned from a static `getStores()` method.
	 *
	 * The component receives information from the stores via state. The state
	 * is generated using a static `calculateState()` method that each container
	 * must implement. A simple container may look like:
	 *
	 *   class FooContainer extends Component {
	 *     static getStores() {
	 *       return [FooStore];
	 *     }
	 *
	 *     static calculateState() {
	 *       return {
	 *         foo: FooStore.getState(),
	 *       };
	 *     }
	 *
	 *     render() {
	 *       return <FooView {...this.state} />;
	 *     }
	 *   }
	 *
	 *   module.exports = FluxContainer.create(FooContainer);
	 *
	 * Flux container also supports some other, more advanced use cases. If you need
	 * to base your state off of props as well:
	 *
	 *   class FooContainer extends Component {
	 *     ...
	 *
	 *     static calculateState(prevState, props) {
	 *       return {
	 *         foo: FooStore.getSpecificFoo(props.id),
	 *       };
	 *     }
	 *
	 *     ...
	 *   }
	 *
	 *   module.exports = FluxContainer.create(FooContainer, {withProps: true});
	 *
	 * Or if your stores are passed through your props:
	 *
	 *   class FooContainer extends Component {
	 *     ...
	 *
	 *     static getStores(props) {
	 *       const {BarStore, FooStore} = props.stores;
	 *       return [BarStore, FooStore];
	 *     }
	 *
	 *     static calculateState(prevState, props) {
	 *       const {BarStore, FooStore} = props.stores;
	 *       return {
	 *         bar: BarStore.getState(),
	 *         foo: FooStore.getState(),
	 *       };
	 *     }
	 *
	 *     ...
	 *   }
	 *
	 *   module.exports = FluxContainer.create(FooContainer, {withProps: true});
	 */
	function create(Base, options) {
	  enforceInterface(Base);
	
	  // Construct the options using default, override with user values as necessary.
	  var realOptions = _extends({}, DEFAULT_OPTIONS, options || {});
	
	  var getState = function (state, maybeProps, maybeContext) {
	    var props = realOptions.withProps ? maybeProps : undefined;
	    var context = realOptions.withContext ? maybeContext : undefined;
	    return Base.calculateState(state, props, context);
	  };
	
	  var getStores = function (maybeProps, maybeContext) {
	    var props = realOptions.withProps ? maybeProps : undefined;
	    var context = realOptions.withContext ? maybeContext : undefined;
	    return Base.getStores(props, context);
	  };
	
	  // Build the container class.
	
	  var ContainerClass = (function (_Base) {
	    _inherits(ContainerClass, _Base);
	
	    function ContainerClass(props, context) {
	      var _this = this;
	
	      _classCallCheck(this, ContainerClass);
	
	      _Base.call(this, props, context);
	      this._fluxContainerSubscriptions = new FluxContainerSubscriptions();
	      this._fluxContainerSubscriptions.setStores(getStores(props));
	      this._fluxContainerSubscriptions.addListener(function () {
	        _this.setState(function (prevState, currentProps) {
	          return getState(prevState, currentProps, context);
	        });
	      });
	      var calculatedState = getState(undefined, props, context);
	      this.state = _extends({}, this.state || {}, calculatedState);
	    }
	
	    // Make sure we override shouldComponentUpdate only if the pure option is
	    // specified. We can't override this above because we don't want to override
	    // the default behavior on accident. Super works weird with react ES6 classes.
	
	    ContainerClass.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	      if (_Base.prototype.componentWillReceiveProps) {
	        _Base.prototype.componentWillReceiveProps.call(this, nextProps, nextContext);
	      }
	
	      if (realOptions.withProps || realOptions.withContext) {
	        // Update both stores and state.
	        this._fluxContainerSubscriptions.setStores(getStores(nextProps, nextContext));
	        this.setState(function (prevState) {
	          return getState(prevState, nextProps, nextContext);
	        });
	      }
	    };
	
	    ContainerClass.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (_Base.prototype.componentWillUnmount) {
	        _Base.prototype.componentWillUnmount.call(this);
	      }
	
	      this._fluxContainerSubscriptions.reset();
	    };
	
	    return ContainerClass;
	  })(Base);
	
	  var container = realOptions.pure ? createPureComponent(ContainerClass) : ContainerClass;
	
	  // Update the name of the container before returning
	  var componentName = Base.displayName || Base.name;
	  container.displayName = 'FluxContainer(' + componentName + ')';
	  return container;
	}
	
	function createPureComponent(BaseComponent) {
	  var PureComponent = (function (_BaseComponent) {
	    _inherits(PureComponent, _BaseComponent);
	
	    function PureComponent() {
	      _classCallCheck(this, PureComponent);
	
	      _BaseComponent.apply(this, arguments);
	    }
	
	    PureComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
	    };
	
	    return PureComponent;
	  })(BaseComponent);
	
	  return PureComponent;
	}
	
	function enforceInterface(o) {
	  !o.getStores ?  false ? invariant(false, 'Components that use FluxContainer must implement `static getStores()`') : invariant(false) : undefined;
	  !o.calculateState ?  false ? invariant(false, 'Components that use FluxContainer must implement `static calculateState()`') : invariant(false) : undefined;
	}
	
	/**
	 * This is a way to connect stores to a functional stateless view. Here's a
	 * simple example:
	 *
	 *   // FooView.js
	 *
	 *   function FooView(props) {
	 *     return <div>{props.value}</div>;
	 *   }
	 *
	 *   module.exports = FooView;
	 *
	 *
	 *   // FooContainer.js
	 *
	 *   function getStores() {
	 *     return [FooStore];
	 *   }
	 *
	 *   function calculateState() {
	 *     return {
	 *       value: FooStore.getState();
	 *     };
	 *   }
	 *
	 *   module.exports = FluxContainer.createFunctional(
	 *     FooView,
	 *     getStores,
	 *     calculateState,
	 *   );
	 *
	 */
	function createFunctional(viewFn, _getStores, _calculateState, options) {
	  var FunctionalContainer = (function (_Component) {
	    _inherits(FunctionalContainer, _Component);
	
	    function FunctionalContainer() {
	      _classCallCheck(this, FunctionalContainer);
	
	      _Component.apply(this, arguments);
	    }
	
	    // Update the name of the component before creating the container.
	
	    FunctionalContainer.getStores = function getStores(props, context) {
	      return _getStores(props, context);
	    };
	
	    FunctionalContainer.calculateState = function calculateState(prevState, props, context) {
	      return _calculateState(prevState, props, context);
	    };
	
	    FunctionalContainer.prototype.render = function render() {
	      return viewFn(this.state);
	    };
	
	    return FunctionalContainer;
	  })(Component);
	
	  var viewFnName = viewFn.displayName || viewFn.name || 'FunctionalContainer';
	  FunctionalContainer.displayName = viewFnName;
	  return create(FunctionalContainer, options);
	}
	
	module.exports = { create: create, createFunctional: createFunctional };

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc. All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxContainerSubscriptions
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var FluxStoreGroup = __webpack_require__(180);
	
	function shallowArrayEqual(a, b) {
	  if (a === b) {
	    return true;
	  }
	  if (a.length !== b.length) {
	    return false;
	  }
	  for (var i = 0; i < a.length; i++) {
	    if (a[i] !== b[i]) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var FluxContainerSubscriptions = (function () {
	  function FluxContainerSubscriptions() {
	    _classCallCheck(this, FluxContainerSubscriptions);
	
	    this._callbacks = [];
	  }
	
	  FluxContainerSubscriptions.prototype.setStores = function setStores(stores) {
	    var _this = this;
	
	    if (this._stores && shallowArrayEqual(this._stores, stores)) {
	      return;
	    }
	    this._stores = stores;
	    this._resetTokens();
	    this._resetStoreGroup();
	
	    var changed = false;
	    var changedStores = [];
	
	    if (false) {
	      // Keep track of the stores that changed for debugging purposes only
	      this._tokens = stores.map(function (store) {
	        return store.addListener(function () {
	          changed = true;
	          changedStores.push(store);
	        });
	      });
	    } else {
	      (function () {
	        var setChanged = function () {
	          changed = true;
	        };
	        _this._tokens = stores.map(function (store) {
	          return store.addListener(setChanged);
	        });
	      })();
	    }
	
	    var callCallbacks = function () {
	      if (changed) {
	        _this._callbacks.forEach(function (fn) {
	          return fn();
	        });
	        changed = false;
	        if (false) {
	          // Uncomment this to print the stores that changed.
	          // console.log(changedStores);
	          changedStores = [];
	        }
	      }
	    };
	    this._storeGroup = new FluxStoreGroup(stores, callCallbacks);
	  };
	
	  FluxContainerSubscriptions.prototype.addListener = function addListener(fn) {
	    this._callbacks.push(fn);
	  };
	
	  FluxContainerSubscriptions.prototype.reset = function reset() {
	    this._resetTokens();
	    this._resetStoreGroup();
	    this._resetCallbacks();
	    this._resetStores();
	  };
	
	  FluxContainerSubscriptions.prototype._resetTokens = function _resetTokens() {
	    if (this._tokens) {
	      this._tokens.forEach(function (token) {
	        return token.remove();
	      });
	      this._tokens = null;
	    }
	  };
	
	  FluxContainerSubscriptions.prototype._resetStoreGroup = function _resetStoreGroup() {
	    if (this._storeGroup) {
	      this._storeGroup.release();
	      this._storeGroup = null;
	    }
	  };
	
	  FluxContainerSubscriptions.prototype._resetStores = function _resetStores() {
	    this._stores = null;
	  };
	
	  FluxContainerSubscriptions.prototype._resetCallbacks = function _resetCallbacks() {
	    this._callbacks = [];
	  };
	
	  return FluxContainerSubscriptions;
	})();
	
	module.exports = FluxContainerSubscriptions;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc. All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxMixinLegacy
	 * 
	 */
	
	'use strict';
	
	var FluxStoreGroup = __webpack_require__(180);
	
	var invariant = __webpack_require__(39);
	
	/**
	 * `FluxContainer` should be preferred over this mixin, but it requires using
	 * react with classes. So this mixin is provided where it is not yet possible
	 * to convert a container to be a class.
	 *
	 * This mixin should be used for React components that have state based purely
	 * on stores. `this.props` will not be available inside of `calculateState()`.
	 *
	 * This mixin will only `setState` not replace it, so you should always return
	 * every key in your state unless you know what you are doing. Consider this:
	 *
	 *   var Foo = React.createClass({
	 *     mixins: [
	 *       FluxMixinLegacy([FooStore])
	 *     ],
	 *
	 *     statics: {
	 *       calculateState(prevState) {
	 *         if (!prevState) {
	 *           return {
	 *             foo: FooStore.getFoo(),
	 *           };
	 *         }
	 *
	 *         return {
	 *           bar: FooStore.getBar(),
	 *         };
	 *       }
	 *     },
	 *   });
	 *
	 * On the second calculateState when prevState is not null, the state will be
	 * updated to contain the previous foo AND the bar that was just returned. Only
	 * returning bar will not delete foo.
	 *
	 */
	function FluxMixinLegacy(stores) {
	  var options = arguments.length <= 1 || arguments[1] === undefined ? { withProps: false } : arguments[1];
	
	  stores = stores.filter(function (store) {
	    return !!store;
	  });
	
	  return {
	    getInitialState: function () {
	      enforceInterface(this);
	      return options.withProps ? this.constructor.calculateState(null, this.props) : this.constructor.calculateState(null, undefined);
	    },
	
	    componentWillMount: function () {
	      var _this = this;
	
	      // This tracks when any store has changed and we may need to update.
	      var changed = false;
	      var setChanged = function () {
	        changed = true;
	      };
	
	      // This adds subscriptions to stores. When a store changes all we do is
	      // set changed to true.
	      this._fluxMixinSubscriptions = stores.map(function (store) {
	        return store.addListener(setChanged);
	      });
	
	      // This callback is called after the dispatch of the relevant stores. If
	      // any have reported a change we update the state, then reset changed.
	      var callback = function () {
	        if (changed) {
	          _this.setState(function (prevState) {
	            return options.withProps ? _this.constructor.calculateState(prevState, _this.props) : _this.constructor.calculateState(prevState, undefined);
	          });
	        }
	        changed = false;
	      };
	      this._fluxMixinStoreGroup = new FluxStoreGroup(stores, callback);
	    },
	
	    componentWillUnmount: function () {
	      this._fluxMixinStoreGroup.release();
	      for (var _iterator = this._fluxMixinSubscriptions, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var subscription = _ref;
	
	        subscription.remove();
	      }
	      this._fluxMixinSubscriptions = [];
	    }
	  };
	}
	
	function enforceInterface(o) {
	  !o.constructor.calculateState ?  false ? invariant(false, 'Components that use FluxMixinLegacy must implement ' + '`calculateState()` on the statics object') : invariant(false) : undefined;
	}
	
	module.exports = FluxMixinLegacy;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc. All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxReduceStore
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FluxStore = __webpack_require__(179);
	
	var abstractMethod = __webpack_require__(322);
	var invariant = __webpack_require__(39);
	
	/**
	 * This is the basic building block of a Flux application. All of your stores
	 * should extend this class.
	 *
	 *   class CounterStore extends FluxReduceStore<number> {
	 *     getInitialState(): number {
	 *       return 1;
	 *     }
	 *
	 *     reduce(state: number, action: Object): number {
	 *       switch(action.type) {
	 *         case: 'add':
	 *           return state + action.value;
	 *         case: 'double':
	 *           return state * 2;
	 *         default:
	 *           return state;
	 *       }
	 *     }
	 *   }
	 */
	
	var FluxReduceStore = (function (_FluxStore) {
	  _inherits(FluxReduceStore, _FluxStore);
	
	  function FluxReduceStore(dispatcher) {
	    _classCallCheck(this, FluxReduceStore);
	
	    _FluxStore.call(this, dispatcher);
	    this._state = this.getInitialState();
	  }
	
	  /**
	   * Getter that exposes the entire state of this store. If your state is not
	   * immutable you should override this and not expose _state directly.
	   */
	
	  FluxReduceStore.prototype.getState = function getState() {
	    return this._state;
	  };
	
	  /**
	   * Constructs the initial state for this store. This is called once during
	   * construction of the store.
	   */
	
	  FluxReduceStore.prototype.getInitialState = function getInitialState() {
	    return abstractMethod('FluxReduceStore', 'getInitialState');
	  };
	
	  /**
	   * Used to reduce a stream of actions coming from the dispatcher into a
	   * single state object.
	   */
	
	  FluxReduceStore.prototype.reduce = function reduce(state, action) {
	    return abstractMethod('FluxReduceStore', 'reduce');
	  };
	
	  /**
	   * Checks if two versions of state are the same. You do not need to override
	   * this if your state is immutable.
	   */
	
	  FluxReduceStore.prototype.areEqual = function areEqual(one, two) {
	    return one === two;
	  };
	
	  FluxReduceStore.prototype.__invokeOnDispatch = function __invokeOnDispatch(action) {
	    this.__changed = false;
	
	    // Reduce the stream of incoming actions to state, update when necessary.
	    var startingState = this._state;
	    var endingState = this.reduce(startingState, action);
	
	    // This means your ending state should never be undefined.
	    !(endingState !== undefined) ?  false ? invariant(false, '%s returned undefined from reduce(...), did you forget to return ' + 'state in the default case? (use null if this was intentional)', this.constructor.name) : invariant(false) : undefined;
	
	    if (!this.areEqual(startingState, endingState)) {
	      this._state = endingState;
	
	      // `__emitChange()` sets `this.__changed` to true and then the actual
	      // change will be fired from the emitter at the end of the dispatch, this
	      // is required in order to support methods like `hasChanged()`
	      this.__emitChange();
	    }
	
	    if (this.__changed) {
	      this.__emitter.emit(this.__changeEvent);
	    }
	  };
	
	  return FluxReduceStore;
	})(FluxStore);
	
	module.exports = FluxReduceStore;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule abstractMethod
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(39);
	
	function abstractMethod(className, methodName) {
	   true ?  false ? invariant(false, 'Subclasses of %s must override %s() with their own implementation.', className, methodName) : invariant(false) : undefined;
	}
	
	module.exports = abstractMethod;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var fbemitter = {
	  EventEmitter: __webpack_require__(324),
	  EmitterSubscription : __webpack_require__(181)
	};
	
	module.exports = fbemitter;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BaseEventEmitter
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var EmitterSubscription = __webpack_require__(181);
	var EventSubscriptionVendor = __webpack_require__(326);
	
	var emptyFunction = __webpack_require__(327);
	var invariant = __webpack_require__(39);
	
	/**
	 * @class BaseEventEmitter
	 * @description
	 * An EventEmitter is responsible for managing a set of listeners and publishing
	 * events to them when it is told that such events happened. In addition to the
	 * data for the given event it also sends a event control object which allows
	 * the listeners/handlers to prevent the default behavior of the given event.
	 *
	 * The emitter is designed to be generic enough to support all the different
	 * contexts in which one might want to emit events. It is a simple multicast
	 * mechanism on top of which extra functionality can be composed. For example, a
	 * more advanced emitter may use an EventHolder and EventFactory.
	 */
	
	var BaseEventEmitter = (function () {
	  /**
	   * @constructor
	   */
	
	  function BaseEventEmitter() {
	    _classCallCheck(this, BaseEventEmitter);
	
	    this._subscriber = new EventSubscriptionVendor();
	    this._currentSubscription = null;
	  }
	
	  /**
	   * Adds a listener to be invoked when events of the specified type are
	   * emitted. An optional calling context may be provided. The data arguments
	   * emitted will be passed to the listener function.
	   *
	   * TODO: Annotate the listener arg's type. This is tricky because listeners
	   *       can be invoked with varargs.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
	    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
	  };
	
	  /**
	   * Similar to addListener, except that the listener is removed after it is
	   * invoked once.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke only once when the
	   *   specified event is emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
	    var emitter = this;
	    return this.addListener(eventType, function () {
	      emitter.removeCurrentListener();
	      listener.apply(context, arguments);
	    });
	  };
	
	  /**
	   * Removes all of the registered listeners, including those registered as
	   * listener maps.
	   *
	   * @param {?string} eventType - Optional name of the event whose registered
	   *   listeners to remove
	   */
	
	  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
	    this._subscriber.removeAllSubscriptions(eventType);
	  };
	
	  /**
	   * Provides an API that can be called during an eventing cycle to remove the
	   * last listener that was invoked. This allows a developer to provide an event
	   * object that can remove the listener (or listener map) during the
	   * invocation.
	   *
	   * If it is called when not inside of an emitting cycle it will throw.
	   *
	   * @throws {Error} When called not during an eventing cycle
	   *
	   * @example
	   *   var subscription = emitter.addListenerMap({
	   *     someEvent: function(data, event) {
	   *       console.log(data);
	   *       emitter.removeCurrentListener();
	   *     }
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   *   emitter.emit('someEvent', 'def'); // does not log anything
	   */
	
	  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
	    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : undefined;
	    this._subscriber.removeSubscription(this._currentSubscription);
	  };
	
	  /**
	   * Returns an array of listeners that are currently registered for the given
	   * event.
	   *
	   * @param {string} eventType - Name of the event to query
	   * @return {array}
	   */
	
	  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
	      return subscription.listener;
	    }) : [];
	  };
	
	  /**
	   * Emits an event of the given type with the given data. All handlers of that
	   * particular type will be notified.
	   *
	   * @param {string} eventType - Name of the event to emit
	   * @param {*} Arbitrary arguments to be passed to each registered listener
	   *
	   * @example
	   *   emitter.addListener('someEvent', function(message) {
	   *     console.log(message);
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   */
	
	  BaseEventEmitter.prototype.emit = function emit(eventType) {
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    if (subscriptions) {
	      var keys = Object.keys(subscriptions);
	      for (var ii = 0; ii < keys.length; ii++) {
	        var key = keys[ii];
	        var subscription = subscriptions[key];
	        // The subscription may have been removed during this event loop.
	        if (subscription) {
	          this._currentSubscription = subscription;
	          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
	        }
	      }
	      this._currentSubscription = null;
	    }
	  };
	
	  /**
	   * Provides a hook to override how the emitter emits an event to a specific
	   * subscription. This allows you to set up logging and error boundaries
	   * specific to your environment.
	   *
	   * @param {EmitterSubscription} subscription
	   * @param {string} eventType
	   * @param {*} Arbitrary arguments to be passed to each registered listener
	   */
	
	  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
	    var args = Array.prototype.slice.call(arguments, 2);
	    subscription.listener.apply(subscription.context, args);
	  };
	
	  return BaseEventEmitter;
	})();
	
	module.exports = BaseEventEmitter;

/***/ },
/* 325 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventSubscription
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * EventSubscription represents a subscription to a particular event. It can
	 * remove its own subscription.
	 */
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var EventSubscription = (function () {
	
	  /**
	   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
	   *   this subscription.
	   */
	
	  function EventSubscription(subscriber) {
	    _classCallCheck(this, EventSubscription);
	
	    this.subscriber = subscriber;
	  }
	
	  /**
	   * Removes this subscription from the subscriber that controls it.
	   */
	
	  EventSubscription.prototype.remove = function remove() {
	    if (this.subscriber) {
	      this.subscriber.removeSubscription(this);
	      this.subscriber = null;
	    }
	  };
	
	  return EventSubscription;
	})();
	
	module.exports = EventSubscription;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 * 
	 * @providesModule EventSubscriptionVendor
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(39);
	
	/**
	 * EventSubscriptionVendor stores a set of EventSubscriptions that are
	 * subscribed to a particular event type.
	 */
	
	var EventSubscriptionVendor = (function () {
	  function EventSubscriptionVendor() {
	    _classCallCheck(this, EventSubscriptionVendor);
	
	    this._subscriptionsForType = {};
	    this._currentSubscription = null;
	  }
	
	  /**
	   * Adds a subscription keyed by an event type.
	   *
	   * @param {string} eventType
	   * @param {EventSubscription} subscription
	   */
	
	  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
	    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : undefined;
	    if (!this._subscriptionsForType[eventType]) {
	      this._subscriptionsForType[eventType] = [];
	    }
	    var key = this._subscriptionsForType[eventType].length;
	    this._subscriptionsForType[eventType].push(subscription);
	    subscription.eventType = eventType;
	    subscription.key = key;
	    return subscription;
	  };
	
	  /**
	   * Removes a bulk set of the subscriptions.
	   *
	   * @param {?string} eventType - Optional name of the event type whose
	   *   registered supscriptions to remove, if null remove all subscriptions.
	   */
	
	  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
	    if (eventType === undefined) {
	      this._subscriptionsForType = {};
	    } else {
	      delete this._subscriptionsForType[eventType];
	    }
	  };
	
	  /**
	   * Removes a specific subscription. Instead of calling this function, call
	   * `subscription.remove()` directly.
	   *
	   * @param {object} subscription
	   */
	
	  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
	    var eventType = subscription.eventType;
	    var key = subscription.key;
	
	    var subscriptionsForType = this._subscriptionsForType[eventType];
	    if (subscriptionsForType) {
	      delete subscriptionsForType[key];
	    }
	  };
	
	  /**
	   * Returns the array of subscriptions that are currently registered for the
	   * given event type.
	   *
	   * Note: This array can be potentially sparse as subscriptions are deleted
	   * from it when they are removed.
	   *
	   * TODO: This returns a nullable array. wat?
	   *
	   * @param {string} eventType
	   * @return {?array}
	   */
	
	  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
	    return this._subscriptionsForType[eventType];
	  };
	
	  return EventSubscriptionVendor;
	})();
	
	module.exports = EventSubscriptionVendor;

/***/ },
/* 327 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 328 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS GENERATED - DO NOT EDIT!
	/*!mobile-detect v1.4.3 2018-09-08*/
	/*global module:false, define:false*/
	/*jshint latedef:false*/
	/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
	(function (define, undefined) {
	define(function () {
	    'use strict';
	
	    var impl = {};
	
	    impl.mobileDetectRules = {
	    "phones": {
	        "iPhone": "\\biPhone\\b|\\biPod\\b",
	        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
	        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
	        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
	        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
	        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
	        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F",
	        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)",
	        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
	        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
	        "NokiaLumia": "Lumia [0-9]{3,4}",
	        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
	        "Palm": "PalmSource|Palm",
	        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
	        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
	        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
	        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
	        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
	        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
	        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
	        "Alcatel": "Alcatel",
	        "Nintendo": "Nintendo (3DS|Switch)",
	        "Amoi": "Amoi",
	        "INQ": "INQ",
	        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
	    },
	    "tablets": {
	        "iPad": "iPad|iPad.*Mobile",
	        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
	        "GoogleTablet": "Android.*Pixel C",
	        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835",
	        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
	        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
	        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
	        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
	        "BlackBerryTablet": "PlayBook|RIM Tablet",
	        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
	        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
	        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
	        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
	        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
	        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
	        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
	        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
	        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304F|TB-X304L|TB-8703F|Tab2A7-10F|TB2-X30L",
	        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
	        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
	        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
	        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
	        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
	        "IRUTablet": "M702pro",
	        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
	        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
	        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
	        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
	        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
	        "NokiaLumiaTablet": "Lumia 2520",
	        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
	        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
	        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
	        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
	        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
	        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
	        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
	        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
	        "FlyTablet": "IQ310|Fly Vision",
	        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))|Maxwell.*Lite|Maxwell.*Plus",
	        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09",
	        "NecTablet": "\\bN-06D|\\bN-08D",
	        "PantechTablet": "Pantech.*P4100",
	        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
	        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
	        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
	        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
	        "NabiTablet": "Android.*\\bNabi",
	        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
	        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
	        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
	        "PlaystationTablet": "Playstation.*(Portable|Vita)",
	        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
	        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
	        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
	        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
	        "GalapadTablet": "Android.*\\bG1\\b(?!\\))",
	        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
	        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
	        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
	        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
	        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
	        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
	        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
	        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
	        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
	        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
	        "DPSTablet": "DPS Dream 9|DPS Dual 7",
	        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
	        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
	        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
	        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
	        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
	        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
	        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
	        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
	        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
	        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
	        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
	        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
	        "iMobileTablet": "i-mobile i-note",
	        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
	        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
	        "AMPETablet": "Android.* A78 ",
	        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
	        "TecnoTablet": "TECNO P9|TECNO DP8D",
	        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
	        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
	        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
	        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
	        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
	        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
	        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
	        "CaptivaTablet": "CAPTIVA PAD",
	        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
	        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
	        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
	        "JaytechTablet": "TPC-PA762",
	        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
	        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
	        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
	        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
	        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
	        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
	        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
	        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
	        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
	        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
	        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
	        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
	        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
	        "UbislateTablet": "UbiSlate[\\s]?7C",
	        "PocketBookTablet": "Pocketbook",
	        "KocasoTablet": "\\b(TB-1207)\\b",
	        "HisenseTablet": "\\b(F5281|E2371)\\b",
	        "Hudl": "Hudl HT7S3|Hudl 2",
	        "TelstraTablet": "T-Hub2",
	        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
	    },
	    "oss": {
	        "AndroidOS": "Android",
	        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
	        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
	        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
	        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
	        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
	        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
	        "MeeGoOS": "MeeGo",
	        "MaemoOS": "Maemo",
	        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
	        "webOS": "webOS|hpwOS",
	        "badaOS": "\\bBada\\b",
	        "BREWOS": "BREW"
	    },
	    "uas": {
	        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
	        "Dolfin": "\\bDolfin\\b",
	        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
	        "Skyfire": "Skyfire",
	        "Edge": "Mobile Safari\/[.0-9]* Edge",
	        "IE": "IEMobile|MSIEMobile",
	        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
	        "Bolt": "bolt",
	        "TeaShark": "teashark",
	        "Blazer": "Blazer",
	        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
	        "WeChat": "\\bMicroMessenger\\b",
	        "UCBrowser": "UC.*Browser|UCWEB",
	        "baiduboxapp": "baiduboxapp",
	        "baidubrowser": "baidubrowser",
	        "DiigoBrowser": "DiigoBrowser",
	        "Puffin": "Puffin",
	        "Mercury": "\\bMercury\\b",
	        "ObigoBrowser": "Obigo",
	        "NetFront": "NF-Browser",
	        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
	        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
	    },
	    "props": {
	        "Mobile": "Mobile\/[VER]",
	        "Build": "Build\/[VER]",
	        "Version": "Version\/[VER]",
	        "VendorID": "VendorID\/[VER]",
	        "iPad": "iPad.*CPU[a-z ]+[VER]",
	        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
	        "iPod": "iPod.*CPU[a-z ]+[VER]",
	        "Kindle": "Kindle\/[VER]",
	        "Chrome": [
	            "Chrome\/[VER]",
	            "CriOS\/[VER]",
	            "CrMo\/[VER]"
	        ],
	        "Coast": [
	            "Coast\/[VER]"
	        ],
	        "Dolfin": "Dolfin\/[VER]",
	        "Firefox": [
	            "Firefox\/[VER]",
	            "FxiOS\/[VER]"
	        ],
	        "Fennec": "Fennec\/[VER]",
	        "Edge": "Edge\/[VER]",
	        "IE": [
	            "IEMobile\/[VER];",
	            "IEMobile [VER]",
	            "MSIE [VER];",
	            "Trident\/[0-9.]+;.*rv:[VER]"
	        ],
	        "NetFront": "NetFront\/[VER]",
	        "NokiaBrowser": "NokiaBrowser\/[VER]",
	        "Opera": [
	            " OPR\/[VER]",
	            "Opera Mini\/[VER]",
	            "Version\/[VER]"
	        ],
	        "Opera Mini": "Opera Mini\/[VER]",
	        "Opera Mobi": "Version\/[VER]",
	        "UCBrowser": [
	            "UCWEB[VER]",
	            "UC.*Browser\/[VER]"
	        ],
	        "MQQBrowser": "MQQBrowser\/[VER]",
	        "MicroMessenger": "MicroMessenger\/[VER]",
	        "baiduboxapp": "baiduboxapp\/[VER]",
	        "baidubrowser": "baidubrowser\/[VER]",
	        "SamsungBrowser": "SamsungBrowser\/[VER]",
	        "Iron": "Iron\/[VER]",
	        "Safari": [
	            "Version\/[VER]",
	            "Safari\/[VER]"
	        ],
	        "Skyfire": "Skyfire\/[VER]",
	        "Tizen": "Tizen\/[VER]",
	        "Webkit": "webkit[ \/][VER]",
	        "PaleMoon": "PaleMoon\/[VER]",
	        "Gecko": "Gecko\/[VER]",
	        "Trident": "Trident\/[VER]",
	        "Presto": "Presto\/[VER]",
	        "Goanna": "Goanna\/[VER]",
	        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
	        "Android": "Android [VER]",
	        "BlackBerry": [
	            "BlackBerry[\\w]+\/[VER]",
	            "BlackBerry.*Version\/[VER]",
	            "Version\/[VER]"
	        ],
	        "BREW": "BREW [VER]",
	        "Java": "Java\/[VER]",
	        "Windows Phone OS": [
	            "Windows Phone OS [VER]",
	            "Windows Phone [VER]"
	        ],
	        "Windows Phone": "Windows Phone [VER]",
	        "Windows CE": "Windows CE\/[VER]",
	        "Windows NT": "Windows NT [VER]",
	        "Symbian": [
	            "SymbianOS\/[VER]",
	            "Symbian\/[VER]"
	        ],
	        "webOS": [
	            "webOS\/[VER]",
	            "hpwOS\/[VER];"
	        ]
	    },
	    "utils": {
	        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
	        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
	        "DesktopMode": "WPDesktop",
	        "TV": "SonyDTV|HbbTV",
	        "WebKit": "(webkit)[ \/]([\\w.]+)",
	        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
	        "Watch": "SM-V700"
	    }
	};
	
	    // following patterns come from http://detectmobilebrowsers.com/
	    impl.detectMobileBrowsers = {
	        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        tabletPattern: /android|ipad|playbook|silk/i
	    };
	
	    var hasOwnProp = Object.prototype.hasOwnProperty,
	        isArray;
	
	    impl.FALLBACK_PHONE = 'UnknownPhone';
	    impl.FALLBACK_TABLET = 'UnknownTablet';
	    impl.FALLBACK_MOBILE = 'UnknownMobile';
	
	    isArray = ('isArray' in Array) ?
	        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };
	
	    function equalIC(a, b) {
	        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
	    }
	
	    function containsIC(array, value) {
	        var valueLC, i, len = array.length;
	        if (!len || !value) {
	            return false;
	        }
	        valueLC = value.toLowerCase();
	        for (i = 0; i < len; ++i) {
	            if (valueLC === array[i].toLowerCase()) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function convertPropsToRegExp(object) {
	        for (var key in object) {
	            if (hasOwnProp.call(object, key)) {
	                object[key] = new RegExp(object[key], 'i');
	            }
	        }
	    }
	
	    function prepareUserAgent(userAgent) {
	        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
	    }
	
	    (function init() {
	        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
	        for (key in mobileDetectRules.props) {
	            if (hasOwnProp.call(mobileDetectRules.props, key)) {
	                values = mobileDetectRules.props[key];
	                if (!isArray(values)) {
	                    values = [values];
	                }
	                len = values.length;
	                for (i = 0; i < len; ++i) {
	                    value = values[i];
	                    verPos = value.indexOf('[VER]');
	                    if (verPos >= 0) {
	                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
	                    }
	                    values[i] = new RegExp(value, 'i');
	                }
	                mobileDetectRules.props[key] = values;
	            }
	        }
	        convertPropsToRegExp(mobileDetectRules.oss);
	        convertPropsToRegExp(mobileDetectRules.phones);
	        convertPropsToRegExp(mobileDetectRules.tablets);
	        convertPropsToRegExp(mobileDetectRules.uas);
	        convertPropsToRegExp(mobileDetectRules.utils);
	
	        // copy some patterns to oss0 which are tested first (see issue#15)
	        mobileDetectRules.oss0 = {
	            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
	            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
	        };
	    }());
	
	    /**
	     * Test userAgent string against a set of rules and find the first matched key.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
	     * @private
	     */
	    impl.findMatch = function(rules, userAgent) {
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    return key;
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Test userAgent string against a set of rules and return an array of matched keys.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
	     * @private
	     */
	    impl.findMatches = function(rules, userAgent) {
	        var result = [];
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    result.push(key);
	                }
	            }
	        }
	        return result;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {String} version or <tt>null</tt> if version not found
	     * @private
	     */
	    impl.getVersionStr = function (propertyName, userAgent) {
	        var props = impl.mobileDetectRules.props, patterns, i, len, match;
	        if (hasOwnProp.call(props, propertyName)) {
	            patterns = props[propertyName];
	            len = patterns.length;
	            for (i = 0; i < len; ++i) {
	                match = patterns[i].exec(userAgent);
	                if (match !== null) {
	                    return match[1];
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {Number} version or <tt>NaN</tt> if version not found
	     * @private
	     */
	    impl.getVersion = function (propertyName, userAgent) {
	        var version = impl.getVersionStr(propertyName, userAgent);
	        return version ? impl.prepareVersionNo(version) : NaN;
	    };
	
	    /**
	     * Prepare the version number.
	     *
	     * @param {String} version
	     * @return {Number} the version number as a floating number
	     * @private
	     */
	    impl.prepareVersionNo = function (version) {
	        var numbers;
	
	        numbers = version.split(/[a-z._ \/\-]/i);
	        if (numbers.length === 1) {
	            version = numbers[0];
	        }
	        if (numbers.length > 1) {
	            version = numbers[0] + '.';
	            numbers.shift();
	            version += numbers.join('');
	        }
	        return Number(version);
	    };
	
	    impl.isMobileFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
	            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
	    };
	
	    impl.isTabletFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
	    };
	
	    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
	        if (cache.mobile !== undefined) {
	            return;
	        }
	        var phone, tablet, phoneSized;
	
	        // first check for stronger tablet rules, then phone (see issue#5)
	        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
	        if (tablet) {
	            cache.mobile = cache.tablet = tablet;
	            cache.phone = null;
	            return; // unambiguously identified as tablet
	        }
	
	        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
	        if (phone) {
	            cache.mobile = cache.phone = phone;
	            cache.tablet = null;
	            return; // unambiguously identified as phone
	        }
	
	        // our rules haven't found a match -> try more general fallback rules
	        if (impl.isMobileFallback(userAgent)) {
	            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
	            if (phoneSized === undefined) {
	                cache.mobile = impl.FALLBACK_MOBILE;
	                cache.tablet = cache.phone = null;
	            } else if (phoneSized) {
	                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
	                cache.tablet = null;
	            } else {
	                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	                cache.phone = null;
	            }
	        } else if (impl.isTabletFallback(userAgent)) {
	            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	            cache.phone = null;
	        } else {
	            // not mobile at all!
	            cache.mobile = cache.tablet = cache.phone = null;
	        }
	    };
	
	    // t is a reference to a MobileDetect instance
	    impl.mobileGrade = function (t) {
	        // impl note:
	        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
	        // When changes are made in Mobile_Detect.php, copy this method and replace:
	        //     $this-> / t.
	        //     self::MOBILE_GRADE_(.) / '$1'
	        //     , self::VERSION_TYPE_FLOAT / (nothing)
	        //     isIOS() / os('iOS')
	        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
	        var $isMobile = t.mobile() !== null;
	
	        if (
	            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
	            t.os('iOS') && t.version('iPad')>=4.3 ||
	            t.os('iOS') && t.version('iPhone')>=3.1 ||
	            t.os('iOS') && t.version('iPod')>=3.1 ||
	
	            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
	            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
	            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
	            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
	            ( t.version('Android')>2.1 && t.is('Webkit') ) ||
	
	            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
	            t.version('Windows Phone OS')>=7.0 ||
	
	            // Blackberry 7 - Tested on BlackBerry Torch 9810
	            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
	            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
	            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
	            t.match('Playbook.*Tablet') ||
	
	            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
	            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
	            // Palm WebOS 3.0  - Tested on HP TouchPad
	            t.match('hp.*TouchPad') ||
	
	            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
	            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||
	
	            // Chrome for Android - Tested on Android 4.0, 4.1 device
	            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||
	
	            // Skyfire 4.1 - Tested on Android 2.3 device
	            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||
	
	            // Opera Mobile 11.5-12: Tested on Android 2.3
	            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||
	
	            // Meego 1.2 - Tested on Nokia 950 and N9
	            t.is('MeeGoOS') ||
	
	            // Tizen (pre-release) - Tested on early hardware
	            t.is('Tizen') ||
	
	            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
	            // @todo: more tests here!
	            t.is('Dolfin') && t.version('Bada')>=2.0 ||
	
	            // UC Browser - Tested on Android 2.3 device
	            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||
	
	            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
	            ( t.match('Kindle Fire') ||
	                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||
	
	            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
	            t.is('AndroidOS') && t.is('NookTablet') ||
	
	            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
	            t.version('Chrome')>=11 && !$isMobile ||
	
	            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
	            t.version('Safari')>=5.0 && !$isMobile ||
	
	            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
	            t.version('Firefox')>=4.0 && !$isMobile ||
	
	            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
	            t.version('MSIE')>=7.0 && !$isMobile ||
	
	            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
	            // @reference: http://my.opera.com/community/openweb/idopera/
	            t.version('Opera')>=10 && !$isMobile
	
	            ){
	            return 'A';
	        }
	
	        if (
	            t.os('iOS') && t.version('iPad')<4.3 ||
	            t.os('iOS') && t.version('iPhone')<3.1 ||
	            t.os('iOS') && t.version('iPod')<3.1 ||
	
	            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
	            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||
	
	            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
	            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
	                (t.version('Android')>=2.3 || t.is('iOS')) ) ||
	
	            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
	            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||
	
	            // @todo: report this (tested on Nokia N71)
	            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
	            ){
	            return 'B';
	        }
	
	        if (
	        // Blackberry 4.x - Tested on the Curve 8330
	            t.version('BlackBerry')<5.0 ||
	            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
	            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2
	
	            ){
	            return 'C';
	        }
	
	        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
	        //will receive the basic, C grade experience.
	        return 'C';
	    };
	
	    impl.detectOS = function (ua) {
	        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
	            impl.findMatch(impl.mobileDetectRules.oss, ua);
	    };
	
	    impl.getDeviceSmallerSide = function () {
	        return window.screen.width < window.screen.height ?
	            window.screen.width :
	            window.screen.height;
	    };
	
	    /**
	     * Constructor for MobileDetect object.
	     * <br>
	     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
	     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
	     *     <strong>Find information how to download and install:</strong>
	     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
	     * </div>
	     *
	     * @example <pre>
	     *     var md = new MobileDetect(window.navigator.userAgent);
	     *     if (md.mobile()) {
	     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
	     *     }
	     * </pre>
	     *
	     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
	     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
	     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
	     *        as phone.
	     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
	     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
	     *        for Android</a>.<br>
	     *        If you provide a value < 0, then this "fuzzy" check is disabled.
	     * @constructor
	     * @global
	     */
	    function MobileDetect(userAgent, maxPhoneWidth) {
	        this.ua = prepareUserAgent(userAgent);
	        this._cache = {};
	        //600dp is typical 7" tablet minimum width
	        this.maxPhoneWidth = maxPhoneWidth || 600;
	    }
	
	    MobileDetect.prototype = {
	        constructor: MobileDetect,
	
	        /**
	         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
	         * <br>
	         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
	         * <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
	         * @function MobileDetect#mobile
	         */
	        mobile: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.mobile;
	        },
	
	        /**
	         * Returns the detected phone type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
	         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
	         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
	         * @function MobileDetect#phone
	         */
	        phone: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.phone;
	        },
	
	        /**
	         * Returns the detected tablet type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
	         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
	         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
	         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
	         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
	         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
	         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
	         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
	         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
	         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
	         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
	         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
	         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
	         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
	         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
	         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
	         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
	         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
	         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
	         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
	         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
	         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
	         * GenericTablet</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
	         * @function MobileDetect#tablet
	         */
	        tablet: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.tablet;
	        },
	
	        /**
	         * Returns the (first) detected user-agent string or <tt>null</tt>.
	         * <br>
	         * The returned user-agent is one of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin,
	         * Mercury, ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {String} the key for the detected user-agent or <tt>null</tt>
	         * @function MobileDetect#userAgent
	         */
	        userAgent: function () {
	            if (this._cache.userAgent === undefined) {
	                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgent;
	        },
	
	        /**
	         * Returns all detected user-agent strings.
	         * <br>
	         * The array is empty or contains one or more of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin,
	         * Mercury, ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
	         * @function MobileDetect#userAgents
	         */
	        userAgents: function () {
	            if (this._cache.userAgents === undefined) {
	                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgents;
	        },
	
	        /**
	         * Returns the detected operating system string or <tt>null</tt>.
	         * <br>
	         * The operating system is one of following keys:<br>
	         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
	         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
	         *
	         * @returns {String} the key for the detected operating system.
	         * @function MobileDetect#os
	         */
	        os: function () {
	            if (this._cache.os === undefined) {
	                this._cache.os = impl.detectOS(this.ua);
	            }
	            return this._cache.os;
	        },
	
	        /**
	         * Get the version (as Number) of the given property in the User-Agent.
	         * <br>
	         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
	         *          Be careful when comparing this value with '==' operator!
	         * @function MobileDetect#version
	         */
	        version: function (key) {
	            return impl.getVersion(key, this.ua);
	        },
	
	        /**
	         * Get the version (as String) of the given property in the User-Agent.
	         * <br>
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
	         *
	         * @function MobileDetect#versionStr
	         */
	        versionStr: function (key) {
	            return impl.getVersionStr(key, this.ua);
	        },
	
	        /**
	         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
	         *
	         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
	         *        tablet family.<br>
	         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
	         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
	         *        Additionally you have following keys:<br>
	         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
	         *
	         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
	         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
	         * @function MobileDetect#is
	         */
	        is: function (key) {
	            return containsIC(this.userAgents(), key) ||
	                   equalIC(key, this.os()) ||
	                   equalIC(key, this.phone()) ||
	                   equalIC(key, this.tablet()) ||
	                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
	        },
	
	        /**
	         * Do a quick test against navigator::userAgent.
	         *
	         * @param {String|RegExp} pattern the pattern, either as String or RegExp
	         *                        (a string will be converted to a case-insensitive RegExp).
	         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
	         * @function MobileDetect#match
	         */
	        match: function (pattern) {
	            if (!(pattern instanceof RegExp)) {
	                pattern = new RegExp(pattern, 'i');
	            }
	            return pattern.test(this.ua);
	        },
	
	        /**
	         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
	         * <br>
	         * Obviously this method makes sense in browser environments only (not for Node.js)!
	         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
	         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
	         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
	         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
	         *          Will always return <code>undefined</code> server-side.
	         */
	        isPhoneSized: function (maxPhoneWidth) {
	            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
	        },
	
	        /**
	         * Returns the mobile grade ('A', 'B', 'C').
	         *
	         * @returns {String} one of the mobile grades ('A', 'B', 'C').
	         * @function MobileDetect#mobileGrade
	         */
	        mobileGrade: function () {
	            if (this._cache.grade === undefined) {
	                this._cache.grade = impl.mobileGrade(this);
	            }
	            return this._cache.grade;
	        }
	    };
	
	    // environment-dependent
	    if (typeof window !== 'undefined' && window.screen) {
	        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
	            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
	        };
	    } else {
	        MobileDetect.isPhoneSized = function () {};
	    }
	
	    // should not be replaced by a completely new object - just overwrite existing methods
	    MobileDetect._impl = impl;
	    
	    MobileDetect.version = '1.4.3 2018-09-08';
	
	    return MobileDetect;
	}); // end of call of define()
	})((function (undefined) {
	    if (typeof module !== 'undefined' && module.exports) {
	        return function (factory) { module.exports = factory(); };
	    } else if (true) {
	        return __webpack_require__(235);
	    } else if (typeof window !== 'undefined') {
	        return function (factory) { window.MobileDetect = factory(); };
	    } else {
	        // please file a bug if you get this error!
	        throw new Error('unknown environment');
	    }
	})());

/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * MUI config module
	 * @module config
	 */
	
	/** Define module API */
	module.exports = {
	  /** Use debug mode */
	  debug: true
	};


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React helpers
	 * @module react/_helpers
	 */
	'use strict';
	
	var controlledMessage = 'You provided a `value` prop to a form field ' + 'without an `OnChange` handler. Please see React documentation on ' + 'controlled components';
	/** Module export */
	
	module.exports = {
	  controlledMessage: controlledMessage
	};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React Textfield Helpers
	 * @module react/_textfieldHelpers
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.textfieldWrapper = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	var _reactAddonsShallowCompare = babelHelpers.interopRequireDefault(__webpack_require__(338));
	
	var jqLite = babelHelpers.interopRequireWildcard(__webpack_require__(83));
	var util = babelHelpers.interopRequireWildcard(__webpack_require__(57));
	
	var _helpers = __webpack_require__(331);
	
	/**
	 * Textfield Wrapper
	 * @function
	 */
	var textfieldWrapper = function textfieldWrapper(TextfieldComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_React$Component) {
	    babelHelpers.inherits(_class, _React$Component);
	
	    function _class(props) {
	      var _this;
	
	      babelHelpers.classCallCheck(this, _class);
	      _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class).call(this, props)); // set initial state
	
	      _this.state = {
	        isEmpty: isEmpty('value' in props ? props.value : props.defaultValue),
	        isTouched: false,
	        isPristine: true
	      }; // warn if value defined but onChange is not
	
	      if ('value' in props && !props.onChange) {
	        util.raiseError(_helpers.controlledMessage, true);
	      } // callbacks
	
	
	      var cb = util.callback;
	      _this.onBlurCB = cb(babelHelpers.assertThisInitialized(_this), 'onBlur');
	      _this.onChangeCB = cb(babelHelpers.assertThisInitialized(_this), 'onChange');
	      _this.onLabelClickCB = cb(babelHelpers.assertThisInitialized(_this), 'onLabelClick');
	      return _this;
	    }
	
	    babelHelpers.createClass(_class, [{
	      key: "onBlur",
	      value: function onBlur(ev) {
	        // ignore if event is a window blur
	        if (document.activeElement !== this.controlEl) {
	          this.setState({
	            isTouched: true
	          });
	        } // execute callback
	
	
	        var fn = this.props.onBlur;
	        fn && fn(ev);
	      }
	    }, {
	      key: "onChange",
	      value: function onChange(ev) {
	        this.setState({
	          isEmpty: isEmpty(ev.target.value),
	          isPristine: false
	        }); // execute callback
	
	        var fn = this.props.onChange;
	        fn && fn(ev);
	      }
	    }, {
	      key: "onLabelClick",
	      value: function onLabelClick(ev) {
	        // pointer-events shim
	        if (util.supportsPointerEvents() === false) {
	          ev.target.style.cursor = 'text';
	          this.controlEl.focus();
	        }
	      }
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        if ('value' in nextProps) {
	          this.setState({
	            isEmpty: isEmpty(nextProps.value)
	          });
	        }
	      }
	    }, {
	      key: "shouldComponentUpdate",
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	    }, {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        // disable MUI js
	        this.controlEl._muiTextfield = true;
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var wrapperCls = {},
	            inputCls = {},
	            labelEl;
	        var _this$props = this.props,
	            children = _this$props.children,
	            className = _this$props.className,
	            style = _this$props.style,
	            hint = _this$props.hint,
	            invalid = _this$props.invalid,
	            label = _this$props.label,
	            floatingLabel = _this$props.floatingLabel,
	            other = babelHelpers.objectWithoutProperties(_this$props, ["children", "className", "style", "hint", "invalid", "label", "floatingLabel"]);
	        var labelType = jqLite.type(label);
	
	        if (labelType == 'string' && label.length || labelType == 'object') {
	          labelEl = _react["default"].createElement(Label, {
	            text: label,
	            onClick: this.onClickCB,
	            htmlFor: this.props.id
	          });
	        }
	
	        wrapperCls['mui-textfield'] = true;
	        wrapperCls['mui-textfield--float-label'] = floatingLabel;
	        wrapperCls = util.classNames(wrapperCls);
	        inputCls['mui--is-touched'] = this.state.isTouched;
	        inputCls['mui--is-untouched'] = !this.state.isTouched;
	        inputCls['mui--is-pristine'] = this.state.isPristine;
	        inputCls['mui--is-dirty'] = !this.state.isPristine;
	        inputCls['mui--is-empty'] = this.state.isEmpty;
	        inputCls['mui--is-not-empty'] = !this.state.isEmpty;
	        inputCls['mui--is-invalid'] = invalid;
	        inputCls = util.classNames(inputCls);
	        return _react["default"].createElement("div", {
	          className: wrapperCls + ' ' + className,
	          style: style
	        }, _react["default"].createElement(TextfieldComponent, babelHelpers["extends"]({
	          className: inputCls,
	          inputRef: function inputRef(el) {
	            _this2.controlEl = el;
	          },
	          placeholder: hint
	        }, other, {
	          onBlur: this.onBlurCB,
	          onChange: this.onChangeCB
	        })), labelEl);
	      }
	    }]);
	    return _class;
	  }(_react["default"].Component), babelHelpers.defineProperty(_class, "defaultProps", {
	    className: '',
	    hint: null,
	    invalid: false,
	    label: null,
	    floatingLabel: false
	  }), _temp;
	};
	/**
	 * Label constructor
	 * @class
	 */
	
	
	exports.textfieldWrapper = textfieldWrapper;
	
	var Label =
	/*#__PURE__*/
	function (_React$Component2) {
	  babelHelpers.inherits(Label, _React$Component2);
	
	  function Label() {
	    var _babelHelpers$getProt;
	
	    var _this3;
	
	    babelHelpers.classCallCheck(this, Label);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Label)).call.apply(_babelHelpers$getProt, [this].concat(args)));
	    babelHelpers.defineProperty(babelHelpers.assertThisInitialized(_this3), "state", {
	      style: {}
	    });
	    return _this3;
	  }
	
	  babelHelpers.createClass(Label, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      this.styleTimer = setTimeout(function () {
	        var s = '.15s ease-out';
	        var style;
	        style = {
	          transition: s,
	          WebkitTransition: s,
	          MozTransition: s,
	          OTransition: s,
	          msTransform: s
	        };
	
	        _this4.setState({
	          style: style
	        });
	      }, 150);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // clear timer
	      clearTimeout(this.styleTimer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement("label", {
	        style: this.state.style,
	        onClick: this.props.onClick,
	        htmlFor: this.props.htmlFor,
	        tabIndex: "-1" // firefox bugfix (see #252)
	
	      }, this.props.text);
	    }
	  }]);
	  return Label;
	}(_react["default"].Component);
	/**
	 * isEmpty helper
	 * @function
	 */
	
	
	babelHelpers.defineProperty(Label, "defaultProps", {
	  text: '',
	  onClick: null
	});
	
	function isEmpty(value) {
	  return value === undefined || value === null || value === '';
	}
	/** Define module API */

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React Caret Module
	 * @module react/caret
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	/**
	 * Caret constructor
	 * @class
	 */
	var Caret =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Caret, _React$Component);
	
	  function Caret() {
	    babelHelpers.classCallCheck(this, Caret);
	    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Caret).apply(this, arguments));
	  }
	
	  babelHelpers.createClass(Caret, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          reactProps = babelHelpers.objectWithoutProperties(_this$props, ["children"]);
	      return _react["default"].createElement("span", babelHelpers["extends"]({}, reactProps, {
	        className: 'mui-caret ' + this.props.className
	      }));
	    }
	  }]);
	  return Caret;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Caret, "defaultProps", {
	  className: ''
	});
	var _default = Caret;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React Col Component
	 * @module react/col
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	var util = babelHelpers.interopRequireWildcard(__webpack_require__(57));
	var breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
	/**
	 * Col constructor
	 * @class
	 */
	
	var Col =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Col, _React$Component);
	
	  function Col() {
	    babelHelpers.classCallCheck(this, Col);
	    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Col).apply(this, arguments));
	  }
	
	  babelHelpers.createClass(Col, [{
	    key: "render",
	    value: function render() {
	      var cls = {},
	          i,
	          bk,
	          val,
	          baseCls;
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          reactProps = babelHelpers.objectWithoutProperties(_this$props, ["children", "className"]); // add mui-col classes
	
	      for (i = breakpoints.length - 1; i > -1; i--) {
	        bk = breakpoints[i];
	        baseCls = 'mui-col-' + bk; // add mui-col-{bk}-{val}
	
	        val = this.props[bk];
	        if (val) cls[baseCls + '-' + val] = true; // add mui-col-{bk}-offset-{val}
	
	        val = this.props[bk + '-offset'];
	        if (val) cls[baseCls + '-offset-' + val] = true; // remove from reactProps
	
	        delete reactProps[bk];
	        delete reactProps[bk + '-offset'];
	      }
	
	      cls = util.classNames(cls);
	      return _react["default"].createElement("div", babelHelpers["extends"]({}, reactProps, {
	        className: cls + ' ' + className
	      }), children);
	    }
	  }]);
	  return Col;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Col, "defaultProps", {
	  className: '',
	  xs: null,
	  sm: null,
	  md: null,
	  lg: null,
	  xl: null,
	  'xs-offset': null,
	  'sm-offset': null,
	  'md-offset': null,
	  'lg-offset': null,
	  'xl-offset': null
	});
	var _default = Col;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React container module
	 * @module react/container
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	/**
	 * Container constructor
	 * @class
	 */
	var Container =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Container, _React$Component);
	
	  function Container() {
	    babelHelpers.classCallCheck(this, Container);
	    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Container).apply(this, arguments));
	  }
	
	  babelHelpers.createClass(Container, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          fluid = _this$props.fluid,
	          reactProps = babelHelpers.objectWithoutProperties(_this$props, ["children", "className", "fluid"]);
	      var cls = 'mui-container'; // fluid containers
	
	      if (fluid) cls += '-fluid';
	      return _react["default"].createElement("div", babelHelpers["extends"]({}, reactProps, {
	        className: cls + ' ' + className
	      }), children);
	    }
	  }]);
	  return Container;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Container, "defaultProps", {
	  className: '',
	  fluid: false
	});
	var _default = Container;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React dropdowns module
	 * @module react/dropdowns
	 */
	
	/* jshint quotmark:false */
	// jscs:disable validateQuoteMarks
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	var _button = babelHelpers.interopRequireDefault(__webpack_require__(84));
	
	var _caret = babelHelpers.interopRequireDefault(__webpack_require__(333));
	
	var jqLite = babelHelpers.interopRequireWildcard(__webpack_require__(83));
	var util = babelHelpers.interopRequireWildcard(__webpack_require__(57));
	var dropdownClass = 'mui-dropdown',
	    menuClass = 'mui-dropdown__menu',
	    openClass = 'mui--is-open',
	    rightClass = 'mui-dropdown__menu--right';
	/**
	 * Dropdown constructor
	 * @class
	 */
	
	var Dropdown =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Dropdown, _React$Component);
	
	  function Dropdown(props) {
	    var _this;
	
	    babelHelpers.classCallCheck(this, Dropdown);
	    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Dropdown).call(this, props));
	    _this.state = {
	      opened: false,
	      menuTop: 0
	    };
	    var cb = util.callback;
	    _this.selectCB = cb(babelHelpers.assertThisInitialized(_this), 'select');
	    _this.onClickCB = cb(babelHelpers.assertThisInitialized(_this), 'onClick');
	    _this.onOutsideClickCB = cb(babelHelpers.assertThisInitialized(_this), 'onOutsideClick');
	    _this.onKeyDownCB = cb(babelHelpers.assertThisInitialized(_this), 'onKeyDown');
	    return _this;
	  }
	
	  babelHelpers.createClass(Dropdown, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps, nextState) {
	      var doc = document;
	
	      if (!this.state.opened && nextState.opened) {
	        doc.addEventListener('click', this.onOutsideClickCB);
	        doc.addEventListener('keydown', this.onKeyDownCB);
	      } else if (this.state.opened && !nextState.opened) {
	        doc.removeEventListener('click', this.onOutsideClickCB);
	        doc.removeEventListener('keydown', this.onKeyDownCB);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var doc = document;
	      doc.removeEventListener('click', this.onOutsideClickCB);
	      doc.removeEventListener('keydown', this.onKeyDownCB);
	    }
	  }, {
	    key: "onClick",
	    value: function onClick(ev) {
	      // only left clicks
	      if (ev.button !== 0) return; // exit if toggle button is disabled
	
	      if (this.props.disabled) return;
	
	      if (!ev.defaultPrevented) {
	        this.toggle(); // execute <Dropdown> onClick method
	
	        var fn = this.props.onClick;
	        fn && fn(ev);
	      }
	    }
	  }, {
	    key: "toggle",
	    value: function toggle() {
	      // exit if no menu element
	      if (!this.props.children) {
	        return util.raiseError('Dropdown menu element not found');
	      }
	
	      if (this.state.opened) this.close();else this.open();
	    }
	  }, {
	    key: "open",
	    value: function open() {
	      // position menu element below toggle button
	      var wrapperRect = this.wrapperElRef.getBoundingClientRect(),
	          toggleRect;
	      toggleRect = this.buttonElRef.buttonElRef.getBoundingClientRect();
	      this.setState({
	        opened: true,
	        menuTop: toggleRect.top - wrapperRect.top + toggleRect.height
	      });
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.setState({
	        opened: false
	      });
	    }
	  }, {
	    key: "select",
	    value: function select(ev) {
	      // onSelect callback
	      if (this.props.onSelect && ev.target.tagName === 'A') {
	        this.props.onSelect(ev.target.getAttribute('data-mui-value'));
	      } // close menu
	
	
	      if (!ev.defaultPrevented) this.close();
	    }
	  }, {
	    key: "onOutsideClick",
	    value: function onOutsideClick(ev) {
	      var isClickInside = this.wrapperElRef.contains(ev.target);
	      if (!isClickInside) this.close();
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(ev) {
	      // close menu on escape key
	      var key = ev.key;
	      if (key === 'Escape' || key === 'Esc') this.close();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var buttonEl, menuEl, labelEl;
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          color = _this$props.color,
	          variant = _this$props.variant,
	          size = _this$props.size,
	          label = _this$props.label,
	          alignMenu = _this$props.alignMenu,
	          onClick = _this$props.onClick,
	          onSelect = _this$props.onSelect,
	          disabled = _this$props.disabled,
	          reactProps = babelHelpers.objectWithoutProperties(_this$props, ["children", "className", "color", "variant", "size", "label", "alignMenu", "onClick", "onSelect", "disabled"]); // build label
	
	      if (jqLite.type(label) === 'string') {
	        labelEl = _react["default"].createElement("span", null, label, " ", _react["default"].createElement(_caret["default"], null));
	      } else {
	        labelEl = label;
	      }
	
	      buttonEl = _react["default"].createElement(_button["default"], {
	        ref: function ref(el) {
	          _this2.buttonElRef = el;
	        },
	        type: "button",
	        onClick: this.onClickCB,
	        color: color,
	        variant: variant,
	        size: size,
	        disabled: disabled
	      }, labelEl);
	
	      if (this.state.opened) {
	        var cs = {};
	        cs[menuClass] = true;
	        cs[openClass] = this.state.opened;
	        cs[rightClass] = alignMenu === 'right';
	        cs = util.classNames(cs);
	        menuEl = _react["default"].createElement("ul", {
	          ref: function ref(el) {
	            _this2.menuElRef = el;
	          },
	          className: cs,
	          style: {
	            top: this.state.menuTop
	          },
	          onClick: this.selectCB
	        }, children);
	      } else {
	        menuEl = _react["default"].createElement("div", null);
	      }
	
	      return _react["default"].createElement("div", babelHelpers["extends"]({}, reactProps, {
	        ref: function ref(el) {
	          _this2.wrapperElRef = el;
	        },
	        className: dropdownClass + ' ' + className
	      }), buttonEl, menuEl);
	    }
	  }]);
	  return Dropdown;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Dropdown, "defaultProps", {
	  className: '',
	  color: 'default',
	  variant: 'default',
	  size: 'default',
	  label: '',
	  alignMenu: 'left',
	  onClick: null,
	  onSelect: null,
	  disabled: false
	});
	var _default = Dropdown;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var babelHelpers = __webpack_require__(30);
	/**
	 * MUI React Row Component
	 * @module react/row
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = babelHelpers.interopRequireDefault(__webpack_require__(1));
	
	var util = babelHelpers.interopRequireWildcard(__webpack_require__(57));
	var breakpoints = ['xs', 'sm', 'md', 'lg'];
	/**
	 * Row constructor
	 * @class
	 */
	
	var Row =
	/*#__PURE__*/
	function (_React$Component) {
	  babelHelpers.inherits(Row, _React$Component);
	
	  function Row() {
	    babelHelpers.classCallCheck(this, Row);
	    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Row).apply(this, arguments));
	  }
	
	  babelHelpers.createClass(Row, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          reactProps = babelHelpers.objectWithoutProperties(_this$props, ["children", "className"]);
	      return _react["default"].createElement("div", babelHelpers["extends"]({}, reactProps, {
	        className: 'mui-row ' + className
	      }), children);
	    }
	  }]);
	  return Row;
	}(_react["default"].Component);
	/** Define module API */
	
	
	babelHelpers.defineProperty(Row, "defaultProps", {
	  className: ''
	});
	var _default = Row;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(339);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 339 */
328,
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.15.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(342);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 342 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appendImportantToEachValue;
	
	var _appendPxIfNeeded = __webpack_require__(183);
	
	var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);
	
	var _mapObject = __webpack_require__(188);
	
	var _mapObject2 = _interopRequireDefault(_mapObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function appendImportantToEachValue(style) {
	  return (0, _mapObject2.default)(style, function (result, key) {
	    return (0, _appendPxIfNeeded2.default)(key, style[key]) + ' !important';
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _camelCaseRegex = /([a-z])?([A-Z])/g;
	
	var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
	  return (p1 || '') + '-' + p2.toLowerCase();
	};
	
	var _camelCaseToDashCase = function _camelCaseToDashCase(s) {
	  return s.replace(_camelCaseRegex, _camelCaseReplacer);
	};
	
	var camelCasePropsToDashCase = function camelCasePropsToDashCase(prefixedStyle) {
	  // Since prefix is expected to work on inline style objects, we must
	  // translate the keys to dash case for rendering to CSS.
	  return Object.keys(prefixedStyle).reduce(function (result, key) {
	    var dashCaseKey = _camelCaseToDashCase(key);
	
	    // Fix IE vendor prefix
	    if (/^ms-/.test(dashCaseKey)) {
	      dashCaseKey = '-' + dashCaseKey;
	    }
	
	    result[dashCaseKey] = prefixedStyle[key];
	    return result;
	  }, {});
	};
	
	exports.default = camelCasePropsToDashCase;
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhancer = __webpack_require__(184);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _styleKeeper = __webpack_require__(125);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	var _styleSheet = __webpack_require__(346);
	
	var _styleSheet2 = _interopRequireDefault(_styleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _getStyleKeeper(instance) {
	  if (!instance._radiumStyleKeeper) {
	    var userAgent = instance.props.radiumConfig && instance.props.radiumConfig.userAgent || instance.context._radiumConfig && instance.context._radiumConfig.userAgent;
	    instance._radiumStyleKeeper = new _styleKeeper2.default(userAgent);
	  }
	
	  return instance._radiumStyleKeeper;
	}
	
	var StyleRoot = function (_PureComponent) {
	  _inherits(StyleRoot, _PureComponent);
	
	  function StyleRoot() {
	    _classCallCheck(this, StyleRoot);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	
	    _getStyleKeeper(_this);
	    return _this;
	  }
	
	  StyleRoot.prototype.getChildContext = function getChildContext() {
	    return { _radiumStyleKeeper: _getStyleKeeper(this) };
	  };
	
	  StyleRoot.prototype.render = function render() {
	    /* eslint-disable no-unused-vars */
	    // Pass down all props except config to the rendered div.
	    var _props = this.props,
	        radiumConfig = _props.radiumConfig,
	        otherProps = _objectWithoutProperties(_props, ['radiumConfig']);
	    /* eslint-enable no-unused-vars */
	
	    return _react2.default.createElement(
	      'div',
	      otherProps,
	      this.props.children,
	      _react2.default.createElement(_styleSheet2.default, null)
	    );
	  };
	
	  return StyleRoot;
	}(_react.PureComponent);
	
	StyleRoot.contextTypes = {
	  _radiumConfig: _propTypes2.default.object,
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	};
	
	StyleRoot.childContextTypes = {
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	};
	
	StyleRoot = (0, _enhancer2.default)(StyleRoot);
	
	exports.default = StyleRoot;
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styleKeeper = __webpack_require__(125);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyleSheet = (_temp = _class = function (_PureComponent) {
	  _inherits(StyleSheet, _PureComponent);
	
	  function StyleSheet() {
	    _classCallCheck(this, StyleSheet);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	
	    _this._onChange = function () {
	      setTimeout(function () {
	        _this._isMounted && _this.setState(_this._getCSSState());
	      }, 0);
	    };
	
	    _this.state = _this._getCSSState();
	    return _this;
	  }
	
	  StyleSheet.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._subscription = this.context._radiumStyleKeeper.subscribe(this._onChange);
	    this._onChange();
	  };
	
	  StyleSheet.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    if (this._subscription) {
	      this._subscription.remove();
	    }
	  };
	
	  StyleSheet.prototype._getCSSState = function _getCSSState() {
	    return { css: this.context._radiumStyleKeeper.getCSS() };
	  };
	
	  StyleSheet.prototype.render = function render() {
	    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: this.state.css } });
	  };
	
	  return StyleSheet;
	}(_react.PureComponent), _class.contextTypes = {
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	}, _temp);
	exports.default = StyleSheet;
	module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _class, _temp;
	
	var _cssRuleSetToString = __webpack_require__(123);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Style = (_temp = _class = function (_PureComponent) {
	  _inherits(Style, _PureComponent);
	
	  function Style() {
	    _classCallCheck(this, Style);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Style.prototype._buildStyles = function _buildStyles(styles) {
	    var _this2 = this;
	
	    var userAgent = this.props.radiumConfig && this.props.radiumConfig.userAgent || this.context && this.context._radiumConfig && this.context._radiumConfig.userAgent;
	
	    var scopeSelector = this.props.scopeSelector;
	
	    var rootRules = Object.keys(styles).reduce(function (accumulator, selector) {
	      if (_typeof(styles[selector]) !== 'object') {
	        accumulator[selector] = styles[selector];
	      }
	
	      return accumulator;
	    }, {});
	    var rootStyles = Object.keys(rootRules).length ? (0, _cssRuleSetToString2.default)(scopeSelector || '', rootRules, userAgent) : '';
	
	    return rootStyles + Object.keys(styles).reduce(function (accumulator, selector) {
	      var rules = styles[selector];
	
	      if (selector === 'mediaQueries') {
	        accumulator += _this2._buildMediaQueryString(rules);
	      } else if (_typeof(styles[selector]) === 'object') {
	        var completeSelector = scopeSelector ? selector.split(',').map(function (part) {
	          return scopeSelector + ' ' + part.trim();
	        }).join(',') : selector;
	
	        accumulator += (0, _cssRuleSetToString2.default)(completeSelector, rules, userAgent);
	      }
	
	      return accumulator;
	    }, '');
	  };
	
	  Style.prototype._buildMediaQueryString = function _buildMediaQueryString(stylesByMediaQuery) {
	    var _this3 = this;
	
	    var mediaQueryString = '';
	
	    Object.keys(stylesByMediaQuery).forEach(function (query) {
	      mediaQueryString += '@media ' + query + '{' + _this3._buildStyles(stylesByMediaQuery[query]) + '}';
	    });
	
	    return mediaQueryString;
	  };
	
	  Style.prototype.render = function render() {
	    if (!this.props.rules) {
	      return null;
	    }
	
	    var styles = this._buildStyles(this.props.rules);
	
	    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
	  };
	
	  return Style;
	}(_react.PureComponent), _class.propTypes = {
	  radiumConfig: _propTypes2.default.object,
	  rules: _propTypes2.default.object,
	  scopeSelector: _propTypes2.default.string
	}, _class.contextTypes = {
	  _radiumConfig: _propTypes2.default.object
	}, _class.defaultProps = {
	  scopeSelector: ''
	}, _temp);
	exports.default = Style;
	module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyframes;
	
	var _cssRuleSetToString = __webpack_require__(123);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _hash = __webpack_require__(187);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _prefixer = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function keyframes(keyframeRules, name) {
	  return {
	    __radiumKeyframes: true,
	    __process: function __process(userAgent) {
	      var keyframesPrefixed = (0, _prefixer.getPrefixedKeyframes)(userAgent);
	      var rules = Object.keys(keyframeRules).map(function (percentage) {
	        return (0, _cssRuleSetToString2.default)(percentage, keyframeRules[percentage], userAgent);
	      }).join('\n');
	      var animationName = (name ? name + '-' : '') + 'radium-animation-' + (0, _hash2.default)(rules);
	      var css = '@' + keyframesPrefixed + ' ' + animationName + ' {\n' + rules + '\n}\n';
	      return { css: css, animationName: animationName };
	    }
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 349 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isNestedStyle = isNestedStyle;
	exports.mergeStyles = mergeStyles;
	function isNestedStyle(value) {
	  // Don't merge objects overriding toString, since they should be converted
	  // to string values.
	  return value && value.constructor === Object && value.toString === Object.prototype.toString;
	}
	
	// Merge style objects. Deep merge plain object values.
	function mergeStyles(styles) {
	  var result = {};
	
	  styles.forEach(function (style) {
	    if (!style || (typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') {
	      return;
	    }
	
	    if (Array.isArray(style)) {
	      style = mergeStyles(style);
	    }
	
	    Object.keys(style).forEach(function (key) {
	      // Simple case, nothing nested
	      if (!isNestedStyle(style[key]) || !isNestedStyle(result[key])) {
	        result[key] = style[key];
	        return;
	      }
	
	      // If nested media, don't merge the nested styles, append a space to the
	      // end (benign when converted to CSS). This way we don't end up merging
	      // media queries that appear later in the chain with those that appear
	      // earlier.
	      if (key.indexOf('@media') === 0) {
	        var newKey = key;
	        // eslint-disable-next-line no-constant-condition
	        while (true) {
	          newKey += ' ';
	          if (!result[newKey]) {
	            result[newKey] = style[key];
	            return;
	          }
	        }
	      }
	
	      // Merge all other nested styles recursively
	      result[key] = mergeStyles([result[key], style[key]]);
	    });
	  });
	
	  return result;
	}

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _checkProps = function checkProps() {};
	
	if (false) {
	  // Warn if you use longhand and shorthand properties in the same style
	  // object.
	  // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties
	
	  var shorthandPropertyExpansions = {
	    background: ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
	    border: ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
	    borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
	    borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
	    font: ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
	    listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
	    margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
	    padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
	    transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
	  };
	
	  _checkProps = function checkProps(config) {
	    var componentName = config.componentName,
	        style = config.style;
	
	    if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object' || !style) {
	      return;
	    }
	
	    var styleKeys = Object.keys(style);
	    styleKeys.forEach(function (styleKey) {
	      if (Array.isArray(shorthandPropertyExpansions[styleKey]) && shorthandPropertyExpansions[styleKey].some(function (sp) {
	        return styleKeys.indexOf(sp) !== -1;
	      })) {
	        if (process.env.NODE_ENV !== 'production') {
	          /* eslint-disable no-console */
	          console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
	          /* eslint-enable no-console */
	        }
	      }
	    });
	
	    styleKeys.forEach(function (k) {
	      return _checkProps(_extends({}, config, { style: style[k] }));
	    });
	    return;
	  };
	}
	
	exports.default = _checkProps;
	module.exports = exports['default'];

/***/ },
/* 351 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyframesPlugin;
	function keyframesPlugin(_ref) {
	  var addCSS = _ref.addCSS,
	      config = _ref.config,
	      style = _ref.style;
	
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (key === 'animationName' && value && value.__radiumKeyframes) {
	      var keyframesValue = value;
	
	      var _keyframesValue$__pro = keyframesValue.__process(config.userAgent),
	          animationName = _keyframesValue$__pro.animationName,
	          css = _keyframesValue$__pro.css;
	
	      addCSS(css);
	      value = animationName;
	    }
	
	    newStyleInProgress[key] = value;
	    return newStyleInProgress;
	  }, {});
	  return { style: newStyle };
	}
	module.exports = exports['default'];

/***/ },
/* 352 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
	// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
	var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref) {
	  var style = _ref.style,
	      mergeStyles = _ref.mergeStyles;
	
	  // eslint-disable-line no-shadow
	  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
	  return { style: newStyle };
	};
	
	exports.default = mergeStyleArrayPlugin;
	module.exports = exports['default'];

/***/ },
/* 353 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _callbacks = [];
	var _mouseUpListenerIsActive = false;
	
	function _handleMouseUp() {
	  _callbacks.forEach(function (callback) {
	    callback();
	  });
	}
	
	var subscribe = function subscribe(callback) {
	  if (_callbacks.indexOf(callback) === -1) {
	    _callbacks.push(callback);
	  }
	
	  if (!_mouseUpListenerIsActive) {
	    window.addEventListener('mouseup', _handleMouseUp);
	    _mouseUpListenerIsActive = true;
	  }
	
	  return {
	    remove: function remove() {
	      var index = _callbacks.indexOf(callback);
	      _callbacks.splice(index, 1);
	
	      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
	        window.removeEventListener('mouseup', _handleMouseUp);
	        _mouseUpListenerIsActive = false;
	      }
	    }
	  };
	};
	
	exports.default = {
	  subscribe: subscribe,
	  __triggerForTests: _handleMouseUp
	};
	module.exports = exports['default'];

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixPlugin;
	
	var _prefixer = __webpack_require__(124);
	
	function prefixPlugin(_ref) {
	  var config = _ref.config,
	      style = _ref.style;
	
	  var newStyle = (0, _prefixer.getPrefixedStyle)(style, config.userAgent);
	  return { style: newStyle };
	}
	module.exports = exports['default'];

/***/ },
/* 355 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeNestedStyles;
	function removeNestedStyles(_ref) {
	  var isNestedStyle = _ref.isNestedStyle,
	      style = _ref.style;
	
	  // eslint-disable-line no-shadow
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (!isNestedStyle(value)) {
	      newStyleInProgress[key] = value;
	    }
	    return newStyleInProgress;
	  }, {});
	
	  return {
	    style: newStyle
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mouseUpListener = __webpack_require__(353);
	
	var _mouseUpListener2 = _interopRequireDefault(_mouseUpListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
	  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
	};
	
	var resolveInteractionStyles = function resolveInteractionStyles(config) {
	  var ExecutionEnvironment = config.ExecutionEnvironment,
	      getComponentField = config.getComponentField,
	      getState = config.getState,
	      mergeStyles = config.mergeStyles,
	      props = config.props,
	      setState = config.setState,
	      style = config.style;
	
	
	  var newComponentFields = {};
	  var newProps = {};
	
	  // Only add handlers if necessary
	  if (style[':hover']) {
	    // Always call the existing handler if one is already defined.
	    // This code, and the very similar ones below, could be abstracted a bit
	    // more, but it hurts readability IMO.
	    var existingOnMouseEnter = props.onMouseEnter;
	    newProps.onMouseEnter = function (e) {
	      existingOnMouseEnter && existingOnMouseEnter(e);
	      setState(':hover', true);
	    };
	
	    var existingOnMouseLeave = props.onMouseLeave;
	    newProps.onMouseLeave = function (e) {
	      existingOnMouseLeave && existingOnMouseLeave(e);
	      setState(':hover', false);
	    };
	  }
	
	  if (style[':active']) {
	    var existingOnMouseDown = props.onMouseDown;
	    newProps.onMouseDown = function (e) {
	      existingOnMouseDown && existingOnMouseDown(e);
	      newComponentFields._lastMouseDown = Date.now();
	      setState(':active', 'viamousedown');
	    };
	
	    var existingOnKeyDown = props.onKeyDown;
	    newProps.onKeyDown = function (e) {
	      existingOnKeyDown && existingOnKeyDown(e);
	      if (e.key === ' ' || e.key === 'Enter') {
	        setState(':active', 'viakeydown');
	      }
	    };
	
	    var existingOnKeyUp = props.onKeyUp;
	    newProps.onKeyUp = function (e) {
	      existingOnKeyUp && existingOnKeyUp(e);
	      if (e.key === ' ' || e.key === 'Enter') {
	        setState(':active', false);
	      }
	    };
	  }
	
	  if (style[':focus']) {
	    var existingOnFocus = props.onFocus;
	    newProps.onFocus = function (e) {
	      existingOnFocus && existingOnFocus(e);
	      setState(':focus', true);
	    };
	
	    var existingOnBlur = props.onBlur;
	    newProps.onBlur = function (e) {
	      existingOnBlur && existingOnBlur(e);
	      setState(':focus', false);
	    };
	  }
	
	  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
	    newComponentFields._radiumMouseUpListener = _mouseUpListener2.default.subscribe(function () {
	      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
	        if (getState(':active', key) === 'viamousedown') {
	          setState(':active', false, key);
	        }
	      });
	    });
	  }
	
	  // Merge the styles in the order they were defined
	  var interactionStyles = props.disabled ? [style[':disabled']] : Object.keys(style).filter(function (name) {
	    return _isInteractiveStyleField(name) && getState(name);
	  }).map(function (name) {
	    return style[name];
	  });
	
	  var newStyle = mergeStyles([style].concat(interactionStyles));
	
	  // Remove interactive styles
	  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
	    if (!_isInteractiveStyleField(name) && name !== ':disabled') {
	      styleWithoutInteractions[name] = newStyle[name];
	    }
	    return styleWithoutInteractions;
	  }, {});
	
	  return {
	    componentFields: newComponentFields,
	    props: newProps,
	    style: newStyle
	  };
	};
	
	exports.default = resolveInteractionStyles;
	module.exports = exports['default'];

/***/ },
/* 357 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = resolveMediaQueries;
	var _windowMatchMedia = void 0;
	function _getWindowMatchMedia(ExecutionEnvironment) {
	  if (_windowMatchMedia === undefined) {
	    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
	      return window.matchMedia(mediaQueryString);
	    } || null;
	  }
	  return _windowMatchMedia;
	}
	
	function _filterObject(obj, predicate) {
	  return Object.keys(obj).filter(function (key) {
	    return predicate(obj[key], key);
	  }).reduce(function (result, key) {
	    result[key] = obj[key];
	    return result;
	  }, {});
	}
	
	function _removeMediaQueries(style) {
	  return Object.keys(style).reduce(function (styleWithoutMedia, key) {
	    if (key.indexOf('@media') !== 0) {
	      styleWithoutMedia[key] = style[key];
	    }
	    return styleWithoutMedia;
	  }, {});
	}
	
	function _topLevelRulesToCSS(_ref) {
	  var addCSS = _ref.addCSS,
	      appendImportantToEachValue = _ref.appendImportantToEachValue,
	      cssRuleSetToString = _ref.cssRuleSetToString,
	      hash = _ref.hash,
	      isNestedStyle = _ref.isNestedStyle,
	      style = _ref.style,
	      userAgent = _ref.userAgent;
	
	  var className = '';
	  Object.keys(style).filter(function (name) {
	    return name.indexOf('@media') === 0;
	  }).map(function (query) {
	    var topLevelRules = appendImportantToEachValue(_filterObject(style[query], function (value) {
	      return !isNestedStyle(value);
	    }));
	
	    if (!Object.keys(topLevelRules).length) {
	      return;
	    }
	
	    var ruleCSS = cssRuleSetToString('', topLevelRules, userAgent);
	
	    // CSS classes cannot start with a number
	    var mediaQueryClassName = 'rmq-' + hash(query + ruleCSS);
	    var css = query + '{ .' + mediaQueryClassName + ruleCSS + '}';
	
	    addCSS(css);
	
	    className += (className ? ' ' : '') + mediaQueryClassName;
	  });
	  return className;
	}
	
	function _subscribeToMediaQuery(_ref2) {
	  var listener = _ref2.listener,
	      listenersByQuery = _ref2.listenersByQuery,
	      matchMedia = _ref2.matchMedia,
	      mediaQueryListsByQuery = _ref2.mediaQueryListsByQuery,
	      query = _ref2.query;
	
	  query = query.replace('@media ', '');
	
	  var mql = mediaQueryListsByQuery[query];
	  if (!mql && matchMedia) {
	    mediaQueryListsByQuery[query] = mql = matchMedia(query);
	  }
	
	  if (!listenersByQuery || !listenersByQuery[query]) {
	    mql.addListener(listener);
	
	    listenersByQuery[query] = {
	      remove: function remove() {
	        mql.removeListener(listener);
	      }
	    };
	  }
	  return mql;
	}
	
	function resolveMediaQueries(_ref3) {
	  var ExecutionEnvironment = _ref3.ExecutionEnvironment,
	      addCSS = _ref3.addCSS,
	      appendImportantToEachValue = _ref3.appendImportantToEachValue,
	      config = _ref3.config,
	      cssRuleSetToString = _ref3.cssRuleSetToString,
	      getComponentField = _ref3.getComponentField,
	      getGlobalState = _ref3.getGlobalState,
	      hash = _ref3.hash,
	      isNestedStyle = _ref3.isNestedStyle,
	      mergeStyles = _ref3.mergeStyles,
	      props = _ref3.props,
	      setState = _ref3.setState,
	      style = _ref3.style;
	
	  // eslint-disable-line no-shadow
	  var newStyle = _removeMediaQueries(style);
	  var mediaQueryClassNames = _topLevelRulesToCSS({
	    addCSS: addCSS,
	    appendImportantToEachValue: appendImportantToEachValue,
	    cssRuleSetToString: cssRuleSetToString,
	    hash: hash,
	    isNestedStyle: isNestedStyle,
	    style: style,
	    userAgent: config.userAgent
	  });
	
	  var newProps = mediaQueryClassNames ? {
	    className: mediaQueryClassNames + (props.className ? ' ' + props.className : '')
	  } : null;
	
	  var matchMedia = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);
	
	  if (!matchMedia) {
	    return {
	      props: newProps,
	      style: newStyle
	    };
	  }
	
	  var listenersByQuery = _extends({}, getComponentField('_radiumMediaQueryListenersByQuery'));
	  var mediaQueryListsByQuery = getGlobalState('mediaQueryListsByQuery') || {};
	
	  Object.keys(style).filter(function (name) {
	    return name.indexOf('@media') === 0;
	  }).map(function (query) {
	    var nestedRules = _filterObject(style[query], isNestedStyle);
	
	    if (!Object.keys(nestedRules).length) {
	      return;
	    }
	
	    var mql = _subscribeToMediaQuery({
	      listener: function listener() {
	        return setState(query, mql.matches, '_all');
	      },
	      listenersByQuery: listenersByQuery,
	      matchMedia: matchMedia,
	      mediaQueryListsByQuery: mediaQueryListsByQuery,
	      query: query
	    });
	
	    // Apply media query states
	    if (mql.matches) {
	      newStyle = mergeStyles([newStyle, nestedRules]);
	    }
	  });
	
	  return {
	    componentFields: {
	      _radiumMediaQueryListenersByQuery: listenersByQuery
	    },
	    globalState: { mediaQueryListsByQuery: mediaQueryListsByQuery },
	    props: newProps,
	    style: newStyle
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 358 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = visited;
	function visited(_ref) {
	  var addCSS = _ref.addCSS,
	      appendImportantToEachValue = _ref.appendImportantToEachValue,
	      config = _ref.config,
	      cssRuleSetToString = _ref.cssRuleSetToString,
	      hash = _ref.hash,
	      props = _ref.props,
	      style = _ref.style;
	
	  // eslint-disable-line no-shadow
	  var className = props.className;
	
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (key === ':visited') {
	      value = appendImportantToEachValue(value);
	      var ruleCSS = cssRuleSetToString('', value, config.userAgent);
	      var visitedClassName = 'rad-' + hash(ruleCSS);
	      var css = '.' + visitedClassName + ':visited' + ruleCSS;
	
	      addCSS(css);
	      className = (className ? className + ' ' : '') + visitedClassName;
	    } else {
	      newStyleInProgress[key] = value;
	    }
	
	    return newStyleInProgress;
	  }, {});
	
	  return {
	    props: className === props.className ? null : { className: className },
	    style: newStyle
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(381);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(382);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(383);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(126);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(192);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _prefixProps = __webpack_require__(371);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _position = __webpack_require__(367);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(361);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(370);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(365);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(362);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(368);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(366);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(369);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(363);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(364);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return (0, _sortPrefixedStyle2.default)(styles);
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function position(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(193);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _unprefixProperty = __webpack_require__(385);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(40);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 371 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
	module.exports = exports["default"];

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(86);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(127);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(86);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 374 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 375 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 376 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(86);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(127);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 378 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(86);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(193);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(126);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(127);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(191);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(191);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(126);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(192);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(378);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(372);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(373);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(374);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(379);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(377);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(380);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(375);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(376);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(386);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie: [['msie']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	var browserByInfo = function browserByInfo(info) {
	  if (info.firefox) {
	    return 'firefox';
	  }
	  var name = '';
	
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  return name;
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  info.browser = browserByInfo(info);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	  info.osversion = parseFloat(info.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (info.browser === 'ios_saf' && info.version > info.osversion) {
	    info.version = info.osversion;
	    info.safari = true;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ },
/* 383 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ },
/* 384 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ },
/* 385 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(235)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(75)(module)))

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(389),r=__webpack_require__(391);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
	var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
	function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
	var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
	function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
	return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
	function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
	function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
	function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
	function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
	n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
	function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
	var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
	function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
	function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
	var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
	!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
	function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
	function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
	var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
	60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
	function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
	")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
	function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
	["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
	sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
	function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
	function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
	function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
	function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
	var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
	var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
	else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
	f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
	function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
	function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
	a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
	["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
	var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
	zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
	function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
	function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
	function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
	if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
	function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
	function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
	var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
	case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
	function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
	function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
	function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
	function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
	function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
	!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
	function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
	function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
	function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
	function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
	function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
	function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
	function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
	c.index=a.index;c.ref=a.ref;return c}
	function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
	14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
	function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
	function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
	b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
	function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
	function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
	sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
	function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
	function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
	function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
	function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
	hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
	q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
	for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
	w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
	k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
	""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
	function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
	var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
	function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
	function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
	function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
	function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
	function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
	d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
	var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
	useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
	lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
	b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
	function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
	var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
	typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
	typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
	t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
	function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
	function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
	b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
	function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
	b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
	c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
	e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
	g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
	c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
	(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
	null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
	d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
	function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
	function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
	function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
	function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
	32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
	function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
	function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
	nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
	(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
	var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
	function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
	c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
	function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
	function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
	function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
	2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
	else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
	b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
	function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
	function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
	var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
	function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
	function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
	function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
	e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
	function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
	function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
	f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
	b>c?b:c;0===b&&(Fh=null);$h(a,b)}
	function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
	128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
	{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
	(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
	p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
	m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
	Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
	typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
	b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
	(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
	function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
	function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
	m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
	64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
	" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
	h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
	b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
	function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
	function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
	(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
	function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
	function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
	function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
	function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
	function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
	a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
	function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
	function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
	function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
	function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
	function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
	of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
	function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
	Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
	function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
	Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
	Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
	function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
	function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
	function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
	var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
	x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
	X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ },
/* 389 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 390 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(390);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(393);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 393 */
389,
/* 394 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(396));
	var shallowEqual = _interopDefault(__webpack_require__(397));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 396 */
359,
/* 397 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfiniteScroll = function (_Component) {
	  _inherits(InfiniteScroll, _Component);
	
	  function InfiniteScroll(props) {
	    _classCallCheck(this, InfiniteScroll);
	
	    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));
	
	    _this.scrollListener = _this.scrollListener.bind(_this);
	    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
	    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(InfiniteScroll, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.pageLoaded = this.props.pageStart;
	      this.options = this.eventListenerOptions();
	      this.attachScrollListener();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.isReverse && this.loadMore) {
	        var parentElement = this.getParentElement(this.scrollComponent);
	        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
	        this.loadMore = false;
	      }
	      this.attachScrollListener();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.detachScrollListener();
	      this.detachMousewheelListener();
	    }
	  }, {
	    key: 'isPassiveSupported',
	    value: function isPassiveSupported() {
	      var passive = false;
	
	      var testOptions = {
	        get passive() {
	          passive = true;
	        }
	      };
	
	      try {
	        document.addEventListener('test', null, testOptions);
	        document.removeEventListener('test', null, testOptions);
	      } catch (e) {
	        // ignore
	      }
	      return passive;
	    }
	  }, {
	    key: 'eventListenerOptions',
	    value: function eventListenerOptions() {
	      var options = this.props.useCapture;
	
	      if (this.isPassiveSupported()) {
	        options = {
	          useCapture: this.props.useCapture,
	          passive: true
	        };
	      }
	      return options;
	    }
	
	    // Set a defaut loader for all your `InfiniteScroll` components
	
	  }, {
	    key: 'setDefaultLoader',
	    value: function setDefaultLoader(loader) {
	      this.defaultLoader = loader;
	    }
	  }, {
	    key: 'detachMousewheelListener',
	    value: function detachMousewheelListener() {
	      var scrollEl = window;
	      if (this.props.useWindow === false) {
	        scrollEl = this.scrollComponent.parentNode;
	      }
	
	      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
	    }
	  }, {
	    key: 'detachScrollListener',
	    value: function detachScrollListener() {
	      var scrollEl = window;
	      if (this.props.useWindow === false) {
	        scrollEl = this.getParentElement(this.scrollComponent);
	      }
	
	      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
	      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
	    }
	  }, {
	    key: 'getParentElement',
	    value: function getParentElement(el) {
	      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
	      if (scrollParent != null) {
	        return scrollParent;
	      }
	      return el && el.parentNode;
	    }
	  }, {
	    key: 'filterProps',
	    value: function filterProps(props) {
	      return props;
	    }
	  }, {
	    key: 'attachScrollListener',
	    value: function attachScrollListener() {
	      var parentElement = this.getParentElement(this.scrollComponent);
	
	      if (!this.props.hasMore || !parentElement) {
	        return;
	      }
	
	      var scrollEl = window;
	      if (this.props.useWindow === false) {
	        scrollEl = parentElement;
	      }
	
	      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
	      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
	      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
	
	      if (this.props.initialLoad) {
	        this.scrollListener();
	      }
	    }
	  }, {
	    key: 'mousewheelListener',
	    value: function mousewheelListener(e) {
	      // Prevents Chrome hangups
	      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
	      if (e.deltaY === 1 && !this.isPassiveSupported()) {
	        e.preventDefault();
	      }
	    }
	  }, {
	    key: 'scrollListener',
	    value: function scrollListener() {
	      var el = this.scrollComponent;
	      var scrollEl = window;
	      var parentNode = this.getParentElement(el);
	
	      var offset = void 0;
	      if (this.props.useWindow) {
	        var doc = document.documentElement || document.body.parentNode || document.body;
	        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
	        if (this.props.isReverse) {
	          offset = scrollTop;
	        } else {
	          offset = this.calculateOffset(el, scrollTop);
	        }
	      } else if (this.props.isReverse) {
	        offset = parentNode.scrollTop;
	      } else {
	        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
	      }
	
	      // Here we make sure the element is visible as well as checking the offset
	      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
	        this.detachScrollListener();
	        this.beforeScrollHeight = parentNode.scrollHeight;
	        this.beforeScrollTop = parentNode.scrollTop;
	        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
	        if (typeof this.props.loadMore === 'function') {
	          this.props.loadMore(this.pageLoaded += 1);
	          this.loadMore = true;
	        }
	      }
	    }
	  }, {
	    key: 'calculateOffset',
	    value: function calculateOffset(el, scrollTop) {
	      if (!el) {
	        return 0;
	      }
	
	      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
	    }
	  }, {
	    key: 'calculateTopPosition',
	    value: function calculateTopPosition(el) {
	      if (!el) {
	        return 0;
	      }
	      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderProps = this.filterProps(this.props);
	
	      var children = renderProps.children,
	          element = renderProps.element,
	          hasMore = renderProps.hasMore,
	          initialLoad = renderProps.initialLoad,
	          isReverse = renderProps.isReverse,
	          loader = renderProps.loader,
	          loadMore = renderProps.loadMore,
	          pageStart = renderProps.pageStart,
	          ref = renderProps.ref,
	          threshold = renderProps.threshold,
	          useCapture = renderProps.useCapture,
	          useWindow = renderProps.useWindow,
	          getScrollParent = renderProps.getScrollParent,
	          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);
	
	      props.ref = function (node) {
	        _this2.scrollComponent = node;
	        if (ref) {
	          ref(node);
	        }
	      };
	
	      var childrenArray = [children];
	      if (hasMore) {
	        if (loader) {
	          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
	        } else if (this.defaultLoader) {
	          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
	        }
	      }
	      return _react2.default.createElement(element, props, childrenArray);
	    }
	  }]);
	
	  return InfiniteScroll;
	}(_react.Component);
	
	InfiniteScroll.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  element: _propTypes2.default.node,
	  hasMore: _propTypes2.default.bool,
	  initialLoad: _propTypes2.default.bool,
	  isReverse: _propTypes2.default.bool,
	  loader: _propTypes2.default.node,
	  loadMore: _propTypes2.default.func.isRequired,
	  pageStart: _propTypes2.default.number,
	  ref: _propTypes2.default.func,
	  getScrollParent: _propTypes2.default.func,
	  threshold: _propTypes2.default.number,
	  useCapture: _propTypes2.default.bool,
	  useWindow: _propTypes2.default.bool
	};
	InfiniteScroll.defaultProps = {
	  element: 'div',
	  hasMore: false,
	  initialLoad: true,
	  pageStart: 0,
	  ref: null,
	  threshold: 250,
	  useWindow: true,
	  isReverse: false,
	  useCapture: false,
	  loader: null,
	  getScrollParent: null
	};
	exports.default = InfiniteScroll;
	module.exports = exports['default'];


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(398)


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(402);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 401 */
/***/ function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(401);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 403 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var RelativeTimeFormat;
	// -- Utilities ----------------------------------------------------------------
	function getCacheId(inputs) {
	    return JSON.stringify(inputs.map(function (input) {
	        return input && typeof input === 'object' ? orderedProps(input) : input;
	    }));
	}
	function orderedProps(obj) {
	    return Object.keys(obj)
	        .sort()
	        .map(function (k) {
	        var _a;
	        return (_a = {}, _a[k] = obj[k], _a);
	    });
	}
	var memoizeFormatConstructor = function (FormatConstructor, cache) {
	    if (cache === void 0) { cache = {}; }
	    return function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	        if (!format) {
	            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	        return format;
	    };
	};
	exports.default = memoizeFormatConstructor;
	//# sourceMappingURL=index.js.map

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(403)['default'];
	exports['default'] = exports;


/***/ },
/* 405 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(198), src$es5$$ = __webpack_require__(408), src$compiler$$ = __webpack_require__(405), intl$messageformat$parser$$ = __webpack_require__(410);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	      try {
	        return messageFormat._format(pattern, values);
	      } catch (e) {
	        if (e.variableId) {
	          throw new Error(
	            'The intl string context variable \'' + e.variableId + '\'' +
	            ' was not provided to the string \'' + message + '\''
	          );
	        } else {
	          throw e;
	        }
	      }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value, err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	          err = new Error('A value must be provided for: ' + id);
	          err.variableId = id;
	          throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 407 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(198);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(406), src$en$$ = __webpack_require__(407);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(411)['default'];
	exports['default'] = exports;


/***/ },
/* 411 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.location = location;
	    this.name     = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser  = this,
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements,
	                    location: location()
	                };
	            },
	        peg$c1 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c2 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText,
	                    location: location()
	                };
	            },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2],
	                    location: location()
	                };
	            },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2],
	                    location: location()
	                };
	            },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                };
	            },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                }
	            },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern,
	                    location: location()
	                };
	            },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function(number) {
	                return number;
	            },
	        peg$c34 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function() { return '\\'; },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function() { return '\\#'; },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function() { return '\u007B'; },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function() { return '\u007D'; },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c65 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$savedPos         = 0,
	        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(
	        message,
	        null,
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p, ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line:   details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails   = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line:   startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line:   endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        location
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c4); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c4); }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c6); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c8); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c13); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c15); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c17); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c20); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c37); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c37); }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c42); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c46); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c49); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c51); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c54); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c57); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c60); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(
	        null,
	        peg$maxFailExpected,
	        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	        peg$maxFailPos < input.length
	          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	      );
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse:       peg$parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(417)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(913);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	var intl_messageformat_1 = __webpack_require__(197);
	var diff_1 = __webpack_require__(414);
	var es5_1 = __webpack_require__(416);
	exports.default = RelativeFormat;
	// -----------------------------------------------------------------------------
	var FIELDS = [
	    'second', 'second-short',
	    'minute', 'minute-short',
	    'hour', 'hour-short',
	    'day', 'day-short',
	    'month', 'month-short',
	    'year', 'year-short'
	];
	var STYLES = ['best fit', 'numeric'];
	// -- RelativeFormat -----------------------------------------------------------
	function RelativeFormat(locales, options) {
	    options = options || {};
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (es5_1.isArray(locales)) {
	        locales = locales.concat();
	    }
	    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
	    es5_1.defineProperty(this, '_options', { value: {
	            style: this._resolveStyle(options.style),
	            units: this._isValidUnits(options.units) && options.units
	        } });
	    es5_1.defineProperty(this, '_locales', { value: locales });
	    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
	    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	// Define internal private properties for dealing with locale data.
	es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
	es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
	        for (var i = 0; i < arguments.length; i++) {
	            var datum = arguments[i];
	            if (!(datum && datum.locale)) {
	                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
	                    '`locale` property value');
	            }
	            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
	            // Add data to IntlMessageFormat.
	            intl_messageformat_1.default.__addLocaleData(datum);
	        }
	    } });
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable: true,
	    value: undefined
	});
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	es5_1.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	    value: {
	        second: 45, 'second-short': 45,
	        minute: 45, 'minute-short': 45,
	        hour: 22, 'hour-short': 22,
	        day: 26, 'day-short': 26,
	        month: 11, 'month-short': 11 // months to year
	    }
	});
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style: this._options.style,
	        units: this._options.units
	    };
	};
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales = this._locales;
	    var resolvedLocale = this._locale;
	    var field = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future = '';
	    var past = '';
	    var i;
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	        'past {{0, plural, ' + past + '}}}';
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl_messageformat_1.default(message, locales);
	};
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	    return messages[units];
	};
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data = localeData[locale.toLowerCase()];
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale);
	};
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
	    if (date === undefined) {
	        date = now;
	    }
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.');
	    }
	    if (!isFinite(date)) {
	        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.');
	    }
	    var diffReport = diff_1.default(now, date);
	    var units = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	    return this._getMessage(units).format({
	        '0': Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion);
	        }
	    }
	    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"');
	};
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	            localeParts.pop();
	        }
	    }
	    var defaultLocale = locales.pop();
	    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale);
	};
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"');
	};
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	    var fields = FIELDS.filter(function (field) {
	        return field.indexOf('-short') < 1;
	    });
	    for (i = 0, l = fields.length; i < l; i += 1) {
	        units = fields[i];
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	    return units;
	};
	//# sourceMappingURL=core.js.map

/***/ },
/* 414 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	var round = Math.round;
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	// Thanks to date-fns
	// https://github.com/date-fns/date-fns
	// MIT © Sasha Koss
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_DAY = 86400000;
	function startOfDay(dirtyDate) {
	    var date = new Date(dirtyDate);
	    date.setHours(0, 0, 0, 0);
	    return date;
	}
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	    var startOfDayLeft = startOfDay(dirtyDateLeft);
	    var startOfDayRight = startOfDay(dirtyDateRight);
	    var timestampLeft = startOfDayLeft.getTime() -
	        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	    var timestampRight = startOfDayRight.getTime() -
	        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	    // Round the number of days to the nearest integer
	    // because the number of milliseconds in a day is not constant
	    // (e.g. it's different in the day of the daylight saving time clock shift)
	    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	function default_1(from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to = +to;
	    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
	    // We expect a more precision in rounding when dealing with
	    // days as it feels wrong when something happended 13 hours ago and
	    // is regarded as "yesterday" even if the time was this morning.
	    var day = differenceInCalendarDays(to, from);
	    var week = round(day / 7);
	    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
	    return {
	        millisecond: millisecond,
	        second: second,
	        'second-short': second,
	        minute: minute,
	        'minute-short': minute,
	        hour: hour,
	        'hour-short': hour,
	        day: day,
	        'day-short': day,
	        week: week,
	        'week-short': week,
	        month: month,
	        'month-short': month,
	        year: year,
	        'year-short': year
	    };
	}
	exports.default = default_1;
	//# sourceMappingURL=diff.js.map

/***/ },
/* 415 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* @generated */
	exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
	        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	        if (ord)
	            return (n10 == 1 && n100 != 11) ? 'one'
	                : (n10 == 2 && n100 != 12) ? 'two'
	                    : (n10 == 3 && n100 != 13) ? 'few'
	                        : 'other';
	        return (n == 1 && v0) ? 'one' : 'other';
	    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
	//# sourceMappingURL=en.js.map

/***/ },
/* 416 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	var realDefineProp = (function () {
	    try {
	        return !!Object.defineProperty({}, 'a', {});
	    }
	    catch (e) {
	        return false;
	    }
	})();
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	var defineProperty = realDefineProp ? Object.defineProperty :
	    function (obj, name, desc) {
	        if ('get' in desc && obj.__defineGetter__) {
	            obj.__defineGetter__(name, desc.get);
	        }
	        else if (!hop.call(obj, name) || 'value' in desc) {
	            obj[name] = desc.value;
	        }
	    };
	exports.defineProperty = defineProperty;
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	    function F() { }
	    F.prototype = proto;
	    obj = new F();
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	    return obj;
	};
	exports.objCreate = objCreate;
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	    return -1;
	};
	exports.arrIndexOf = arrIndexOf;
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	exports.isArray = isArray;
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.dateNow = dateNow;
	//# sourceMappingURL=es5.js.map

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/* jslint esnext: true */
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(413);
	var en_1 = __webpack_require__(415);
	core_1.default.__addLocaleData(en_1.default);
	core_1.default.defaultLocale = 'en';
	exports.default = core_1.default;
	//# sourceMappingURL=main.js.map

/***/ },
/* 418 */
46,
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var removeElementByIds = function removeElementByIds(ids) {
	  ids.forEach(function (id) {
	    var element = document.getElementById(id);
	    if (element && element.parentNode) {
	      element.parentNode.removeChild(element);
	    }
	  });
	};
	
	var MessengerCustomerChat = function (_Component) {
	  _inherits(MessengerCustomerChat, _Component);
	
	  function MessengerCustomerChat() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MessengerCustomerChat);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessengerCustomerChat.__proto__ || Object.getPrototypeOf(MessengerCustomerChat)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fbLoaded: false,
	      shouldShowDialog: undefined
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MessengerCustomerChat, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setFbAsyncInit();
	      this.reloadSDKAsynchronously();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.pageId !== this.props.pageId || prevProps.appId !== this.props.appId || prevProps.shouldShowDialog !== this.props.shouldShowDialog || prevProps.htmlRef !== this.props.htmlRef || prevProps.minimized !== this.props.minimized || prevProps.themeColor !== this.props.themeColor || prevProps.loggedInGreeting !== this.props.loggedInGreeting || prevProps.loggedOutGreeting !== this.props.loggedOutGreeting || prevProps.greetingDialogDisplay !== this.props.greetingDialogDisplay || prevProps.greetingDialogDelay !== this.props.greetingDialogDelay || prevProps.autoLogAppEvents !== this.props.autoLogAppEvents || prevProps.xfbml !== this.props.xfbml || prevProps.version !== this.props.version || prevProps.language !== this.props.language) {
	        this.setFbAsyncInit();
	        this.reloadSDKAsynchronously();
	      }
	    }
	  }, {
	    key: 'setFbAsyncInit',
	    value: function setFbAsyncInit() {
	      var _this2 = this;
	
	      var _props = this.props,
	          appId = _props.appId,
	          autoLogAppEvents = _props.autoLogAppEvents,
	          xfbml = _props.xfbml,
	          version = _props.version;
	
	
	      window.fbAsyncInit = function () {
	        window.FB.init({
	          appId: appId,
	          autoLogAppEvents: autoLogAppEvents,
	          xfbml: xfbml,
	          version: 'v' + version
	        });
	
	        _this2.setState({ fbLoaded: true });
	      };
	    }
	  }, {
	    key: 'loadSDKAsynchronously',
	    value: function loadSDKAsynchronously() {
	      var language = this.props.language;
	      /* eslint-disable */
	
	      (function (d, s, id) {
	        var js,
	            fjs = d.getElementsByTagName(s)[0];
	        if (d.getElementById(id)) {
	          return;
	        }
	        js = d.createElement(s);
	        js.id = id;
	        js.src = 'https://connect.facebook.net/' + language + '/sdk/xfbml.customerchat.js';
	        fjs.parentNode.insertBefore(js, fjs);
	      })(document, 'script', 'facebook-jssdk');
	      /* eslint-enable */
	    }
	  }, {
	    key: 'removeFacebookSDK',
	    value: function removeFacebookSDK() {
	      removeElementByIds(['facebook-jssdk', 'fb-root']);
	
	      delete window.FB;
	    }
	  }, {
	    key: 'reloadSDKAsynchronously',
	    value: function reloadSDKAsynchronously() {
	      this.removeFacebookSDK();
	      this.loadSDKAsynchronously();
	    }
	  }, {
	    key: 'controlPlugin',
	    value: function controlPlugin() {
	      var shouldShowDialog = this.props.shouldShowDialog;
	
	
	      if (shouldShowDialog) {
	        window.FB.CustomerChat.showDialog();
	      } else {
	        window.FB.CustomerChat.hideDialog();
	      }
	    }
	  }, {
	    key: 'subscribeEvents',
	    value: function subscribeEvents() {
	      var _props2 = this.props,
	          onCustomerChatDialogShow = _props2.onCustomerChatDialogShow,
	          onCustomerChatDialogHide = _props2.onCustomerChatDialogHide;
	
	
	      if (onCustomerChatDialogShow) {
	        window.FB.Event.subscribe('customerchat.dialogShow', onCustomerChatDialogShow);
	      }
	
	      if (onCustomerChatDialogHide) {
	        window.FB.Event.subscribe('customerchat.dialogHide', onCustomerChatDialogHide);
	      }
	    }
	  }, {
	    key: 'createMarkup',
	    value: function createMarkup() {
	      var _props3 = this.props,
	          pageId = _props3.pageId,
	          htmlRef = _props3.htmlRef,
	          minimized = _props3.minimized,
	          themeColor = _props3.themeColor,
	          loggedInGreeting = _props3.loggedInGreeting,
	          loggedOutGreeting = _props3.loggedOutGreeting,
	          greetingDialogDisplay = _props3.greetingDialogDisplay,
	          greetingDialogDelay = _props3.greetingDialogDelay;
	
	
	      var refAttribute = htmlRef !== undefined ? 'ref="' + htmlRef + '"' : '';
	      var minimizedAttribute = minimized !== undefined ? 'minimized="' + minimized + '"' : '';
	      var themeColorAttribute = themeColor !== undefined ? 'theme_color="' + themeColor + '"' : '';
	      var loggedInGreetingAttribute = loggedInGreeting !== undefined ? 'logged_in_greeting="' + loggedInGreeting + '"' : '';
	      var loggedOutGreetingAttribute = loggedOutGreeting !== undefined ? 'logged_out_greeting="' + loggedOutGreeting + '"' : '';
	      var greetingDialogDisplayAttribute = greetingDialogDisplay !== undefined ? 'greeting_dialog_display="' + greetingDialogDisplay + '"' : '';
	      var greetingDialogDelayAttribute = greetingDialogDelay !== undefined ? 'greeting_dialog_delay="' + greetingDialogDelay + '"' : '';
	
	      return {
	        __html: '<div\n        class="fb-customerchat"\n        page_id="' + pageId + '"\n        ' + refAttribute + '\n        ' + minimizedAttribute + '\n        ' + themeColorAttribute + '\n        ' + loggedInGreetingAttribute + '\n        ' + loggedOutGreetingAttribute + '\n        ' + greetingDialogDisplayAttribute + '\n        ' + greetingDialogDelayAttribute + '\n      ></div>'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          fbLoaded = _state.fbLoaded,
	          shouldShowDialog = _state.shouldShowDialog;
	
	
	      if (fbLoaded && shouldShowDialog !== this.props.shouldShowDialog) {
	        document.addEventListener('DOMNodeInserted', function (event) {
	          var element = event.target;
	          if (element.className && typeof element.className === 'string' && element.className.includes('fb_dialog')) {
	            _this3.controlPlugin();
	          }
	        }, false);
	        this.subscribeEvents();
	      }
	      // Add a random key to rerender. Reference:
	      // https://stackoverflow.com/questions/30242530/dangerouslysetinnerhtml-doesnt-update-during-render
	      return _react2.default.createElement('div', { key: Date(), dangerouslySetInnerHTML: this.createMarkup() });
	    }
	  }]);
	
	  return MessengerCustomerChat;
	}(_react.Component);
	
	MessengerCustomerChat.propTypes = {
	  pageId: _propTypes2.default.string.isRequired,
	  appId: _propTypes2.default.string.isRequired,
	
	  shouldShowDialog: _propTypes2.default.bool,
	  htmlRef: _propTypes2.default.string,
	  minimized: _propTypes2.default.bool,
	  themeColor: _propTypes2.default.string,
	  loggedInGreeting: _propTypes2.default.string,
	  loggedOutGreeting: _propTypes2.default.string,
	  greetingDialogDisplay: _propTypes2.default.oneOf(['show', 'hide', 'fade']),
	  greetingDialogDelay: _propTypes2.default.number,
	  autoLogAppEvents: _propTypes2.default.bool,
	  xfbml: _propTypes2.default.bool,
	  version: _propTypes2.default.string,
	  language: _propTypes2.default.string,
	  onCustomerChatDialogShow: _propTypes2.default.func,
	  onCustomerChatDialogHide: _propTypes2.default.func
	};
	MessengerCustomerChat.defaultProps = {
	  shouldShowDialog: false,
	  htmlRef: undefined,
	  minimized: undefined,
	  themeColor: undefined,
	  loggedInGreeting: undefined,
	  loggedOutGreeting: undefined,
	  greetingDialogDisplay: undefined,
	  greetingDialogDelay: undefined,
	  autoLogAppEvents: true,
	  xfbml: true,
	  version: '2.11',
	  language: 'en_US',
	  onCustomerChatDialogShow: undefined,
	  onCustomerChatDialogHide: undefined
	};
	exports.default = MessengerCustomerChat;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _MessengerCustomerChat = __webpack_require__(419);
	
	var _MessengerCustomerChat2 = _interopRequireDefault(_MessengerCustomerChat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _MessengerCustomerChat2.default;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMinimalistPortal = __webpack_require__(481);
	
	var _reactMinimalistPortal2 = _interopRequireDefault(_reactMinimalistPortal);
	
	var _CSSTransition = __webpack_require__(482);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _classnames = __webpack_require__(423);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _noScroll = __webpack_require__(424);
	
	var _noScroll2 = _interopRequireDefault(_noScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal(props) {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
	
	    _this.onClickOverlay = function (e) {
	      var _this$props = _this.props,
	          classes = _this$props.classes,
	          closeOnOverlayClick = _this$props.closeOnOverlayClick;
	
	      if (!closeOnOverlayClick || typeof e.target.className !== 'string') {
	        return;
	      }
	      var className = e.target.className.split(' ');
	      if (className.indexOf(classes.overlay) !== -1 && !_this.isScrollBarClick(e)) {
	        e.stopPropagation();
	        _this.props.onClose();
	      }
	    };
	
	    _this.onClickCloseIcon = function (e) {
	      e.stopPropagation();
	      _this.props.onClose();
	    };
	
	    _this.isScrollBarClick = function (e) {
	      return e.clientX >= document.documentElement.offsetWidth;
	    };
	
	    _this.handleKeydown = function (e) {
	      if (e.keyCode === 27 && _this.props.open) {
	        _this.props.onClose();
	      }
	    };
	
	    _this.handleExited = function () {
	      if (_this.props.onExited) {
	        _this.props.onExited();
	      }
	
	      _this.setState({ showPortal: false });
	      _this.unblockScroll();
	    };
	
	    _this.unblockScroll = function () {
	      var openedModals = document.getElementsByClassName(_this.props.classes.modal);
	      if (openedModals.length === 1) {
	        _noScroll2.default.off();
	      }
	    };
	
	    _this.state = {
	      showPortal: props.open
	    };
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      // Block scroll when initial prop is open
	      if (this.props.open) {
	        this.blockScroll();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!this.props.open && nextProps.open) {
	        this.setState({
	          showPortal: true
	        }, function () {
	          _this2.blockScroll();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      this.unblockScroll();
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'blockScroll',
	
	
	    // eslint-disable-next-line class-methods-use-this
	    value: function blockScroll() {
	      _noScroll2.default.on();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          little = _props.little,
	          classes = _props.classes,
	          classNames = _props.classNames,
	          styles = _props.styles,
	          showCloseIcon = _props.showCloseIcon,
	          closeIconSize = _props.closeIconSize,
	          closeIconSvgPath = _props.closeIconSvgPath,
	          animationDuration = _props.animationDuration;
	      var showPortal = this.state.showPortal;
	
	      if (!showPortal) return null;
	      return _react2.default.createElement(
	        _reactMinimalistPortal2.default,
	        null,
	        _react2.default.createElement(
	          _CSSTransition2.default,
	          {
	            'in': open,
	            appear: true,
	            classNames: {
	              appear: classNames.transitionEnter || classes.transitionEnter,
	              appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
	              enter: classNames.transitionEnter || classes.transitionEnter,
	              enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
	              exit: classNames.transitionExit || classes.transitionExit,
	              exitActive: classNames.transitionExitActive || classes.transitionExitActive
	            },
	            timeout: animationDuration,
	            onExited: this.handleExited
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(classes.overlay, little ? classes.overlayLittle : null, classNames.overlay),
	              onMouseDown: this.onClickOverlay,
	              style: styles.overlay
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(classes.modal, classNames.modal),
	                style: styles.modal
	              },
	              showCloseIcon ? _react2.default.createElement(
	                'svg',
	                {
	                  className: (0, _classnames2.default)(classes.closeIcon, classNames.closeIcon),
	                  style: styles.closeIcon,
	                  onClick: this.onClickCloseIcon,
	                  xmlns: 'http://www.w3.org/2000/svg',
	                  width: closeIconSize,
	                  height: closeIconSize,
	                  viewBox: '0 0 36 36'
	                },
	                closeIconSvgPath
	              ) : null,
	              this.props.children
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOverlayClick: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func.isRequired,
	  open: _propTypes2.default.bool.isRequired,
	  classNames: _propTypes2.default.object,
	  styles: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  classes: _propTypes2.default.object.isRequired,
	  little: _propTypes2.default.bool,
	  onExited: _propTypes2.default.func,
	  showCloseIcon: _propTypes2.default.bool,
	  closeIconSize: _propTypes2.default.number,
	  closeIconSvgPath: _propTypes2.default.node,
	  animationDuration: _propTypes2.default.number
	};
	
	Modal.defaultProps = {
	  closeOnEsc: true,
	  closeOnOverlayClick: true,
	  showCloseIcon: true,
	  closeIconSize: 28,
	  closeIconSvgPath: _react2.default.createElement('path', { d: 'M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z' }),
	  classNames: {},
	  styles: {},
	  children: null,
	  little: false,
	  onExited: null,
	  animationDuration: 500
	};
	
	exports.default = Modal;

/***/ },
/* 422 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  overlay: {
	    background: 'rgba(0, 0, 0, 0.75)',
	    display: 'flex',
	    alignItems: 'flex-start',
	    justifyContent: 'center',
	    position: 'fixed',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    zIndex: 1000,
	    padding: '1.2rem'
	  },
	  overlayLittle: {
	    alignItems: 'center'
	  },
	  modal: {
	    maxWidth: 800,
	    position: 'relative',
	    padding: '1.2rem',
	    background: '#ffffff',
	    backgroundClip: 'padding-box',
	    boxShadow: '0 12px 15px 0 rgba(0,0,0,0.25)'
	  },
	  closeIcon: {
	    position: 'absolute',
	    top: '14px',
	    right: '14px',
	    cursor: 'pointer'
	  },
	  transitionEnter: {
	    opacity: '0.01'
	  },
	  transitionEnterActive: {
	    opacity: 1,
	    transition: 'opacity 500ms cubic-bezier(0.23, 1, 0.32, 1)'
	  },
	  transitionExit: {
	    opacity: 1
	  },
	  transitionExitActive: {
	    opacity: '0.01',
	    transition: 'opacity 500ms cubic-bezier(0.23, 1, 0.32, 1)'
	  }
	};

/***/ },
/* 423 */
6,
/* 424 */
/***/ function(module, exports) {

	(function(root) {
	  var isOn = false;
	  var scrollbarSize;
	  var scrollTop;
	
	  function getScrollbarSize() {
	    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;
	
	    var doc = document.documentElement;
	    var dummyScroller = document.createElement('div');
	    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
	    doc.appendChild(dummyScroller);
	    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
	    doc.removeChild(dummyScroller);
	    return scrollbarSize;
	  }
	
	  function hasScrollbar() {
	    return document.documentElement.scrollHeight > window.innerHeight;
	  }
	
	  function on(options) {
	    if (typeof document === 'undefined' || isOn) return;
	    var doc = document.documentElement;
	    scrollTop = window.pageYOffset;
	    if (hasScrollbar()) {
	      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
	    } else {
	      doc.style.width = '100%';
	    }
	    doc.style.position = 'fixed';
	    doc.style.top = -scrollTop + 'px';
	    doc.style.overflow = 'hidden';
	    isOn = true;
	  }
	
	  function off() {
	    if (typeof document === 'undefined' || !isOn) return;
	    var doc = document.documentElement;
	    doc.style.width = '';
	    doc.style.position = '';
	    doc.style.top = '';
	    doc.style.overflow = '';
	    window.scroll(0, scrollTop);
	    isOn = false;
	  }
	
	  function toggle() {
	    if (isOn) {
	      off();
	      return;
	    }
	    on();
	  }
	
	  var noScroll = {
	    on: on,
	    off: off,
	    toggle: toggle,
	  };
	
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = noScroll;
	  } else {
	    root.noScroll = noScroll;
	  }
	})(this);


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _jss = __webpack_require__(128);
	
	var _ns = __webpack_require__(129);
	
	var ns = _interopRequireWildcard(_ns);
	
	var _contextTypes = __webpack_require__(199);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _propTypes2 = __webpack_require__(200);
	
	var _propTypes3 = _interopRequireDefault(_propTypes2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JssProvider = function (_Component) {
	  _inherits(JssProvider, _Component);
	
	  function JssProvider() {
	    _classCallCheck(this, JssProvider);
	
	    return _possibleConstructorReturn(this, (JssProvider.__proto__ || Object.getPrototypeOf(JssProvider)).apply(this, arguments));
	  }
	
	  _createClass(JssProvider, [{
	    key: 'getChildContext',
	
	
	    // JssProvider can be nested. We allow to overwrite any context prop at any level.
	    // 1. Check if there is a value passed over props.
	    // 2. If value was passed, we set it on the child context.
	    // 3. If value was not passed, we proxy parent context (default context behaviour).
	    value: function getChildContext() {
	      var _props = this.props,
	          registry = _props.registry,
	          classNamePrefix = _props.classNamePrefix,
	          localJss = _props.jss,
	          generateClassName = _props.generateClassName,
	          disableStylesGeneration = _props.disableStylesGeneration;
	
	      var sheetOptions = this.context[ns.sheetOptions] || {};
	      var context = _defineProperty({}, ns.sheetOptions, sheetOptions);
	
	      if (registry) {
	        context[ns.sheetsRegistry] = registry;
	        // This way we identify a new request on the server, because user will create
	        // a new Registry instance for each.
	        if (registry !== this.registry) {
	          // We reset managers because we have to regenerate all sheets for the new request.
	          this.managers = {};
	          this.registry = registry;
	        }
	      }
	
	      // Make sure we don't loose managers when JssProvider is used inside of a stateful
	      // component which decides to rerender.
	      context[ns.managers] = this.managers;
	
	      if (generateClassName) {
	        sheetOptions.generateClassName = generateClassName;
	      } else if (!sheetOptions.generateClassName) {
	        if (!this.generateClassName) {
	          var createGenerateClassName = _jss.createGenerateClassNameDefault;
	          if (localJss && localJss.options.createGenerateClassName) {
	            createGenerateClassName = localJss.options.createGenerateClassName;
	          }
	          // Make sure we don't loose the generator when JssProvider is used inside of a stateful
	          // component which decides to rerender.
	          this.generateClassName = createGenerateClassName();
	        }
	
	        sheetOptions.generateClassName = this.generateClassName;
	      }
	
	      if (classNamePrefix) sheetOptions.classNamePrefix = classNamePrefix;
	      if (localJss) context[ns.jss] = localJss;
	      if (disableStylesGeneration !== undefined) {
	        sheetOptions.disableStylesGeneration = disableStylesGeneration;
	      }
	
	      return context;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return JssProvider;
	}(_react.Component);
	
	JssProvider.propTypes = _extends({}, _propTypes3['default'], {
	  generateClassName: _propTypes.func,
	  classNamePrefix: _propTypes.string,
	  disableStylesGeneration: _propTypes.bool,
	  children: _propTypes.node.isRequired
	});
	JssProvider.childContextTypes = _contextTypes2['default'];
	JssProvider.contextTypes = _contextTypes2['default'];
	exports['default'] = JssProvider;

/***/ },
/* 426 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Adds `composes` property to each top level rule
	 * in order to have a composed class name for dynamic style sheets.
	 *
	 * It relies on jss-compose and jss-extend plugins.
	 *
	 * Example:
	 * classes:  {left: 'a', button: 'b'}
	 * styles:   {button: {height: () => { ... }}}
	 * composed: {
	 *   button: {
	 *     composes: 'b',
	 *     height: () => { ... }
	 *   },
	 *   left: {
	 *     composes: 'a'
	 *   }
	 * }
	 *
	 * @param {Object} classes static classes map
	 * @param {Object} styles dynamic styles object without static properties
	 * @return {Object|null}
	 */
	exports["default"] = function (staticClasses, dynamicClasses) {
	  var combinedClasses = _extends({}, staticClasses);
	
	  for (var name in dynamicClasses) {
	    combinedClasses[name] = staticClasses[name] ? staticClasses[name] + " " + dynamicClasses[name] : dynamicClasses[name];
	  }
	
	  return combinedClasses;
	};

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _theming = __webpack_require__(208);
	
	var _theming2 = _interopRequireDefault(_theming);
	
	var _jss = __webpack_require__(128);
	
	var _jss2 = _interopRequireDefault(_jss);
	
	var _compose = __webpack_require__(426);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _getDisplayName = __webpack_require__(428);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _ns = __webpack_require__(129);
	
	var ns = _interopRequireWildcard(_ns);
	
	var _contextTypes = __webpack_require__(199);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var env = ("production");
	
	// Like a Symbol
	var dynamicStylesNs = Math.random();
	
	/*
	 * # Use cases
	 *
	 * - Unthemed component accepts styles object
	 * - Themed component accepts styles creator function which takes theme as a single argument
	 * - Multiple instances will re-use the same static sheet via sheets manager
	 * - Sheet manager identifies static sheets by theme as a key
	 * - For unthemed components theme is an empty object
	 * - The very first instance will add static sheet to sheets manager
	 * - Every further instances will get that static sheet from sheet manager
	 * - Every mount of every instance will call method `sheetsManager.manage`,
	 * thus incrementing reference counter.
	 * - Every unmount of every instance will call method `sheetsManager.unmanage`,
	 * thus decrementing reference counter.
	 * - `sheetsManager.unmanage` under the hood will detach static sheet once reference
	 * counter is zero.
	 * - Dynamic styles are not shared between instances
	 *
	 */
	
	var getStyles = function getStyles(stylesOrCreator, theme) {
	  if (typeof stylesOrCreator !== 'function') {
	    return stylesOrCreator;
	  }
	  return stylesOrCreator(theme);
	};
	
	// Returns an object with array property as a key and true as a value.
	var toMap = function toMap(arr) {
	  return arr.reduce(function (map, prop) {
	    map[prop] = true;
	    return map;
	  }, {});
	};
	
	var defaultInjectProps = {
	  sheet: false,
	  classes: true,
	  theme: true
	};
	
	var managersCounter = 0;
	
	/**
	 * Wrap a Component into a JSS Container Component.
	 *
	 * @param {Object|Function} stylesOrCreator
	 * @param {Component} InnerComponent
	 * @param {Object} [options]
	 * @return {Component}
	 */
	
	exports['default'] = function (stylesOrCreator, InnerComponent) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var isThemingEnabled = typeof stylesOrCreator === 'function';
	
	  var _options$theming = options.theming,
	      theming = _options$theming === undefined ? _theming2['default'] : _options$theming,
	      inject = options.inject,
	      optionsJss = options.jss,
	      sheetOptions = _objectWithoutProperties(options, ['theming', 'inject', 'jss']);
	
	  var injectMap = inject ? toMap(inject) : defaultInjectProps;
	  var themeListener = theming.themeListener;
	
	  var displayName = (0, _getDisplayName2['default'])(InnerComponent);
	  var defaultClassNamePrefix = env === 'production' ? undefined : displayName + '-';
	  var noTheme = {};
	  var managerId = managersCounter++;
	  var manager = new _jss.SheetsManager();
	  var defaultProps = _extends({}, InnerComponent.defaultProps);
	  delete defaultProps.classes;
	
	  var Jss = function (_Component) {
	    _inherits(Jss, _Component);
	
	    function Jss(props, context) {
	      _classCallCheck(this, Jss);
	
	      var _this = _possibleConstructorReturn(this, (Jss.__proto__ || Object.getPrototypeOf(Jss)).call(this, props, context));
	
	      _initialiseProps.call(_this);
	
	      var theme = isThemingEnabled ? themeListener.initial(context) : noTheme;
	
	      _this.state = _this.createState({ theme: theme }, props);
	      return _this;
	    }
	
	    _createClass(Jss, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.manage(this.state);
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (isThemingEnabled) {
	          this.unsubscribeId = themeListener.subscribe(this.context, this.setTheme);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps, nextContext) {
	        this.context = nextContext;
	        var dynamicSheet = this.state.dynamicSheet;
	
	        if (dynamicSheet) dynamicSheet.update(nextProps);
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        if (isThemingEnabled && this.state.theme !== nextState.theme) {
	          var newState = this.createState(nextState, nextProps);
	          this.manage(newState);
	          this.manager.unmanage(this.state.theme);
	          this.setState(newState);
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        // We remove previous dynamicSheet only after new one was created to avoid FOUC.
	        if (prevState.dynamicSheet !== this.state.dynamicSheet) {
	          this.jss.removeStyleSheet(prevState.dynamicSheet);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.unsubscribeId) {
	          themeListener.unsubscribe(this.context, this.unsubscribeId);
	        }
	
	        this.manager.unmanage(this.state.theme);
	        if (this.state.dynamicSheet) {
	          this.state.dynamicSheet.detach();
	        }
	      }
	    }, {
	      key: 'createState',
	      value: function createState(_ref, _ref2) {
	        var theme = _ref.theme,
	            dynamicSheet = _ref.dynamicSheet;
	        var userClasses = _ref2.classes;
	
	        var contextSheetOptions = this.context[ns.sheetOptions];
	        if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
	          return { theme: theme, dynamicSheet: dynamicSheet, classes: {} };
	        }
	
	        var classNamePrefix = defaultClassNamePrefix;
	        var staticSheet = this.manager.get(theme);
	
	        if (contextSheetOptions && contextSheetOptions.classNamePrefix) {
	          classNamePrefix = contextSheetOptions.classNamePrefix + classNamePrefix;
	        }
	
	        if (!staticSheet) {
	          var styles = getStyles(stylesOrCreator, theme);
	          staticSheet = this.jss.createStyleSheet(styles, _extends({}, sheetOptions, contextSheetOptions, {
	            meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Static',
	            classNamePrefix: classNamePrefix
	          }));
	          this.manager.add(theme, staticSheet);
	          staticSheet[dynamicStylesNs] = (0, _jss.getDynamicStyles)(styles);
	        }
	
	        var dynamicStyles = staticSheet[dynamicStylesNs];
	
	        if (dynamicStyles) {
	          dynamicSheet = this.jss.createStyleSheet(dynamicStyles, _extends({}, sheetOptions, contextSheetOptions, {
	            meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Dynamic',
	            classNamePrefix: classNamePrefix,
	            link: true
	          }));
	        }
	
	        var defaultClasses = InnerComponent.defaultProps ? InnerComponent.defaultProps.classes : {};
	        var jssClasses = dynamicSheet ? (0, _compose2['default'])(staticSheet.classes, dynamicSheet.classes) : staticSheet.classes;
	        var classes = _extends({}, defaultClasses, jssClasses, userClasses);
	
	        return { theme: theme, dynamicSheet: dynamicSheet, classes: classes };
	      }
	    }, {
	      key: 'manage',
	      value: function manage(_ref3) {
	        var theme = _ref3.theme,
	            dynamicSheet = _ref3.dynamicSheet;
	
	        var contextSheetOptions = this.context[ns.sheetOptions];
	        if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
	          return;
	        }
	        var registry = this.context[ns.sheetsRegistry];
	
	        var staticSheet = this.manager.manage(theme);
	        if (registry) registry.add(staticSheet);
	
	        if (dynamicSheet) {
	          dynamicSheet.update(this.props).attach();
	          if (registry) registry.add(dynamicSheet);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            theme = _state.theme,
	            dynamicSheet = _state.dynamicSheet,
	            classes = _state.classes;
	
	        var _props = this.props,
	            innerRef = _props.innerRef,
	            props = _objectWithoutProperties(_props, ['innerRef']);
	
	        var sheet = dynamicSheet || this.manager.get(theme);
	
	        if (injectMap.sheet && !props.sheet) props.sheet = sheet;
	        if (isThemingEnabled && injectMap.theme && !props.theme) props.theme = theme;
	
	        // We have merged classes already.
	        if (injectMap.classes) props.classes = classes;
	
	        return _react2['default'].createElement(InnerComponent, _extends({ ref: innerRef }, props));
	      }
	    }, {
	      key: 'jss',
	      get: function get() {
	        return this.context[ns.jss] || optionsJss || _jss2['default'];
	      }
	    }, {
	      key: 'manager',
	      get: function get() {
	        var managers = this.context[ns.managers];
	
	        // If `managers` map is present in the context, we use it in order to
	        // let JssProvider reset them when new response has to render server-side.
	        if (managers) {
	          if (!managers[managerId]) {
	            managers[managerId] = new _jss.SheetsManager();
	          }
	          return managers[managerId];
	        }
	
	        return manager;
	      }
	    }]);
	
	    return Jss;
	  }(_react.Component);
	
	  Jss.displayName = 'Jss(' + displayName + ')';
	  Jss.InnerComponent = InnerComponent;
	  Jss.contextTypes = _extends({}, _contextTypes2['default'], isThemingEnabled && themeListener.contextTypes);
	  Jss.propTypes = {
	    innerRef: _propTypes2['default'].func
	  };
	  Jss.defaultProps = defaultProps;
	
	  var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.setTheme = function (theme) {
	      return _this2.setState({ theme: theme });
	    };
	  };
	
	  return Jss;
	};

/***/ },
/* 428 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports['default'] = function (Component) {
	  return Component.displayName || Component.name || 'Component';
	};

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _theming = __webpack_require__(208);
	
	Object.defineProperty(exports, 'ThemeProvider', {
	  enumerable: true,
	  get: function get() {
	    return _theming.ThemeProvider;
	  }
	});
	Object.defineProperty(exports, 'withTheme', {
	  enumerable: true,
	  get: function get() {
	    return _theming.withTheme;
	  }
	});
	Object.defineProperty(exports, 'createTheming', {
	  enumerable: true,
	  get: function get() {
	    return _theming.createTheming;
	  }
	});
	
	var _JssProvider = __webpack_require__(425);
	
	Object.defineProperty(exports, 'JssProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JssProvider)['default'];
	  }
	});
	
	var _jss = __webpack_require__(128);
	
	Object.defineProperty(exports, 'jss', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_jss)['default'];
	  }
	});
	Object.defineProperty(exports, 'SheetsRegistry', {
	  enumerable: true,
	  get: function get() {
	    return _jss.SheetsRegistry;
	  }
	});
	Object.defineProperty(exports, 'createGenerateClassName', {
	  enumerable: true,
	  get: function get() {
	    return _jss.createGenerateClassNameDefault;
	  }
	});
	
	var _injectSheet = __webpack_require__(430);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_injectSheet)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = injectSheet;
	
	var _hoistNonReactStatics = __webpack_require__(431);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _createHoc = __webpack_require__(427);
	
	var _createHoc2 = _interopRequireDefault(_createHoc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Global index counter to preserve source order.
	 * As we create the style sheet during componentWillMount lifecycle,
	 * children are handled after the parents, so the order of style elements would
	 * be parent->child. It is a problem though when a parent passes a className
	 * which needs to override any childs styles. StyleSheet of the child has a higher
	 * specificity, because of the source order.
	 * So our solution is to render sheets them in the reverse order child->sheet, so
	 * that parent has a higher specificity.
	 *
	 * @type {Number}
	 */
	var indexCounter = -100000;
	
	var NoRenderer = function NoRenderer(_ref) {
	  var children = _ref.children;
	  return children || null;
	};
	
	/**
	 * HOC creator function that wrapps the user component.
	 *
	 * `injectSheet(styles, [options])(Component)`
	 *
	 * @api public
	 */
	function injectSheet(stylesOrSheet) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (options.index === undefined) {
	    options.index = indexCounter++;
	  }
	  return function () {
	    var InnerComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NoRenderer;
	
	    var Jss = (0, _createHoc2['default'])(stylesOrSheet, InnerComponent, options);
	    return (0, _hoistNonReactStatics2['default'])(Jss, InnerComponent, { inner: true });
	  };
	}

/***/ },
/* 431 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jssTemplate = __webpack_require__(447);
	
	var _jssTemplate2 = _interopRequireDefault(_jssTemplate);
	
	var _jssGlobal = __webpack_require__(443);
	
	var _jssGlobal2 = _interopRequireDefault(_jssGlobal);
	
	var _jssExtend = __webpack_require__(441);
	
	var _jssExtend2 = _interopRequireDefault(_jssExtend);
	
	var _jssNested = __webpack_require__(444);
	
	var _jssNested2 = _interopRequireDefault(_jssNested);
	
	var _jssCompose = __webpack_require__(435);
	
	var _jssCompose2 = _interopRequireDefault(_jssCompose);
	
	var _jssCamelCase = __webpack_require__(433);
	
	var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);
	
	var _jssDefaultUnit = __webpack_require__(438);
	
	var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);
	
	var _jssExpand = __webpack_require__(439);
	
	var _jssExpand2 = _interopRequireDefault(_jssExpand);
	
	var _jssVendorPrefixer = __webpack_require__(450);
	
	var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);
	
	var _jssPropsSort = __webpack_require__(446);
	
	var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return {
	    plugins: [(0, _jssTemplate2.default)(options.template), (0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
	  };
	};

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = camelCase;
	
	var _hyphenateStyleName = __webpack_require__(434);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Convert camel cased property names to dash separated.
	 *
	 * @param {Object} style
	 * @return {Object}
	 */
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 *
	 * @param {Rule} rule
	 */
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  function onChangeValue(value, prop, rule) {
	    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);
	
	    // There was no camel case in place
	    if (prop === hyphenatedProp) return value;
	
	    rule.prop(hyphenatedProp, value);
	
	    // Core will ignore that property value we set the proper one above.
	    return null;
	  }
	
	  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
	}

/***/ },
/* 434 */
193,
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jssCompose;
	
	var _warning = __webpack_require__(436);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Set selector.
	 *
	 * @param {Object} original rule
	 * @param {String} className class string
	 * @return {Boolean} flag, indicating function was successfull or not
	 */
	function registerClass(rule, className) {
	  // Skip falsy values
	  if (!className) return true;
	
	  // Support array of class names `{composes: ['foo', 'bar']}`
	  if (Array.isArray(className)) {
	    for (var index = 0; index < className.length; index++) {
	      var isSetted = registerClass(rule, className[index]);
	      if (!isSetted) return false;
	    }
	
	    return true;
	  }
	
	  // Support space separated class names `{composes: 'foo bar'}`
	  if (className.indexOf(' ') > -1) {
	    return registerClass(rule, className.split(' '));
	  }
	
	  var parent = rule.options.parent;
	
	  // It is a ref to a local rule.
	
	  if (className[0] === '$') {
	    var refRule = parent.getRule(className.substr(1));
	
	    if (!refRule) {
	      (0, _warning2.default)(false, '[JSS] Referenced rule is not defined. \r\n%s', rule);
	      return false;
	    }
	
	    if (refRule === rule) {
	      (0, _warning2.default)(false, '[JSS] Cyclic composition detected. \r\n%s', rule);
	      return false;
	    }
	
	    parent.classes[rule.key] += ' ' + parent.classes[refRule.key];
	
	    return true;
	  }
	
	  rule.options.parent.classes[rule.key] += ' ' + className;
	
	  return true;
	}
	
	/**
	 * Convert compose property to additional class, remove property from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssCompose() {
	  function onProcessStyle(style, rule) {
	    if (!style.composes) return style;
	    registerClass(rule, style.composes);
	    // Remove composes property to prevent infinite loop.
	    delete style.composes;
	    return style;
	  }
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 436 */
59,
/* 437 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Generated jss-default-unit CSS property units
	 *
	 * @type object
	 */
	exports['default'] = {
	  'animation-delay': 'ms',
	  'animation-duration': 'ms',
	  'background-position': 'px',
	  'background-position-x': 'px',
	  'background-position-y': 'px',
	  'background-size': 'px',
	  border: 'px',
	  'border-bottom': 'px',
	  'border-bottom-left-radius': 'px',
	  'border-bottom-right-radius': 'px',
	  'border-bottom-width': 'px',
	  'border-left': 'px',
	  'border-left-width': 'px',
	  'border-radius': 'px',
	  'border-right': 'px',
	  'border-right-width': 'px',
	  'border-spacing': 'px',
	  'border-top': 'px',
	  'border-top-left-radius': 'px',
	  'border-top-right-radius': 'px',
	  'border-top-width': 'px',
	  'border-width': 'px',
	  'border-after-width': 'px',
	  'border-before-width': 'px',
	  'border-end-width': 'px',
	  'border-horizontal-spacing': 'px',
	  'border-start-width': 'px',
	  'border-vertical-spacing': 'px',
	  bottom: 'px',
	  'box-shadow': 'px',
	  'column-gap': 'px',
	  'column-rule': 'px',
	  'column-rule-width': 'px',
	  'column-width': 'px',
	  'flex-basis': 'px',
	  'font-size': 'px',
	  'font-size-delta': 'px',
	  height: 'px',
	  left: 'px',
	  'letter-spacing': 'px',
	  'logical-height': 'px',
	  'logical-width': 'px',
	  margin: 'px',
	  'margin-after': 'px',
	  'margin-before': 'px',
	  'margin-bottom': 'px',
	  'margin-left': 'px',
	  'margin-right': 'px',
	  'margin-top': 'px',
	  'max-height': 'px',
	  'max-width': 'px',
	  'margin-end': 'px',
	  'margin-start': 'px',
	  'mask-position-x': 'px',
	  'mask-position-y': 'px',
	  'mask-size': 'px',
	  'max-logical-height': 'px',
	  'max-logical-width': 'px',
	  'min-height': 'px',
	  'min-width': 'px',
	  'min-logical-height': 'px',
	  'min-logical-width': 'px',
	  motion: 'px',
	  'motion-offset': 'px',
	  outline: 'px',
	  'outline-offset': 'px',
	  'outline-width': 'px',
	  padding: 'px',
	  'padding-bottom': 'px',
	  'padding-left': 'px',
	  'padding-right': 'px',
	  'padding-top': 'px',
	  'padding-after': 'px',
	  'padding-before': 'px',
	  'padding-end': 'px',
	  'padding-start': 'px',
	  'perspective-origin-x': '%',
	  'perspective-origin-y': '%',
	  perspective: 'px',
	  right: 'px',
	  'shape-margin': 'px',
	  size: 'px',
	  'text-indent': 'px',
	  'text-stroke': 'px',
	  'text-stroke-width': 'px',
	  top: 'px',
	  'transform-origin': '%',
	  'transform-origin-x': '%',
	  'transform-origin-y': '%',
	  'transform-origin-z': '%',
	  'transition-delay': 'ms',
	  'transition-duration': 'ms',
	  'vertical-align': 'px',
	  width: 'px',
	  'word-spacing': 'px',
	  // Not existing properties.
	  // Used to avoid issues with jss-expand intergration.
	  'box-shadow-x': 'px',
	  'box-shadow-y': 'px',
	  'box-shadow-blur': 'px',
	  'box-shadow-spread': 'px',
	  'font-line-height': 'px',
	  'text-shadow-x': 'px',
	  'text-shadow-y': 'px',
	  'text-shadow-blur': 'px'
	};

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports['default'] = defaultUnit;
	
	var _defaultUnits = __webpack_require__(437);
	
	var _defaultUnits2 = _interopRequireDefault(_defaultUnits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	  var newObj = {};
	  for (var key in obj) {
	    newObj[key] = obj[key];
	    newObj[key.replace(regExp, replace)] = obj[key];
	  }
	  return newObj;
	}
	
	var units = addCamelCasedVersion(_defaultUnits2['default']);
	
	/**
	 * Recursive deep style passing function
	 *
	 * @param {String} current property
	 * @param {(Object|Array|Number|String)} property value
	 * @param {Object} options
	 * @return {(Object|Array|Number|String)} resulting value
	 */
	function iterate(prop, value, options) {
	  if (!value) return value;
	
	  var convertedValue = value;
	
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  if (type === 'object' && Array.isArray(value)) type = 'array';
	
	  switch (type) {
	    case 'object':
	      if (prop === 'fallbacks') {
	        for (var innerProp in value) {
	          value[innerProp] = iterate(innerProp, value[innerProp], options);
	        }
	        break;
	      }
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
	      }
	      break;
	    case 'array':
	      for (var i = 0; i < value.length; i++) {
	        value[i] = iterate(prop, value[i], options);
	      }
	      break;
	    case 'number':
	      if (value !== 0) {
	        convertedValue = value + (options[prop] || units[prop] || '');
	      }
	      break;
	    default:
	      break;
	  }
	
	  return convertedValue;
	}
	
	/**
	 * Add unit to numeric values.
	 */
	function defaultUnit() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
	}

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = jssExpand;
	
	var _props = __webpack_require__(440);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Map values by given prop.
	 *
	 * @param {Array} array of values
	 * @param {String} original property
	 * @param {String} original rule
	 * @return {String} mapped values
	 */
	function mapValuesByProp(value, prop, rule) {
	  return value.map(function (item) {
	    return objectToArray(item, prop, rule, false, true);
	  });
	}
	
	/**
	 * Convert array to nested array, if needed
	 *
	 * @param {Array} array of values
	 * @param {String} original property
	 * @param {Object} sheme, for converting arrays in strings
	 * @param {Object} original rule
	 * @return {String} converted string
	 */
	function processArray(value, prop, scheme, rule) {
	  if (scheme[prop] == null) return value;
	  if (value.length === 0) return [];
	  if (Array.isArray(value[0])) return processArray(value[0], prop, scheme);
	  if (_typeof(value[0]) === 'object') {
	    return mapValuesByProp(value, prop, rule);
	  }
	
	  return [value];
	}
	
	/**
	 * Convert object to array.
	 *
	 * @param {Object} object of values
	 * @param {String} original property
	 * @param {Object} original rule
	 * @param {Boolean} is fallback prop
	 * @param {Boolean} object is inside array
	 * @return {String} converted string
	 */
	function objectToArray(value, prop, rule, isFallback, isInArray) {
	  if (!(_props.propObj[prop] || _props.customPropObj[prop])) return [];
	
	  var result = [];
	
	  // Check if exists any non-standart property
	  if (_props.customPropObj[prop]) {
	    value = customPropsToStyle(value, rule, _props.customPropObj[prop], isFallback);
	  }
	
	  // Pass throught all standart props
	  if (Object.keys(value).length) {
	    for (var baseProp in _props.propObj[prop]) {
	      if (value[baseProp]) {
	        if (Array.isArray(value[baseProp])) {
	          result.push(_props.propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(' '));
	        } else result.push(value[baseProp]);
	        continue;
	      }
	
	      // Add default value from props config.
	      if (_props.propObj[prop][baseProp] != null) {
	        result.push(_props.propObj[prop][baseProp]);
	      }
	    }
	  }
	
	  if (!result.length || isInArray) return result;
	  return [result];
	}
	
	/**
	 * Convert custom properties values to styles adding them to rule directly
	 *
	 * @param {Object} object of values
	 * @param {Object} original rule
	 * @param {String} property, that contain partial custom properties
	 * @param {Boolean} is fallback prop
	 * @return {Object} value without custom properties, that was already added to rule
	 */
	function customPropsToStyle(value, rule, customProps, isFallback) {
	  for (var prop in customProps) {
	    var propName = customProps[prop];
	
	    // If current property doesn't exist already in rule - add new one
	    if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
	      var appendedValue = styleDetector(_defineProperty({}, propName, value[prop]), rule)[propName];
	
	      // Add style directly in rule
	      if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
	    }
	    // Delete converted property to avoid double converting
	    delete value[prop];
	  }
	
	  return value;
	}
	
	/**
	 * Detect if a style needs to be converted.
	 *
	 * @param {Object} style
	 * @param {Object} rule
	 * @param {Boolean} is fallback prop
	 * @return {Object} convertedStyle
	 */
	function styleDetector(style, rule, isFallback) {
	  for (var prop in style) {
	    var value = style[prop];
	
	    if (Array.isArray(value)) {
	      // Check double arrays to avoid recursion.
	      if (!Array.isArray(value[0])) {
	        if (prop === 'fallbacks') {
	          for (var index = 0; index < style.fallbacks.length; index++) {
	            style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
	          }
	          continue;
	        }
	
	        style[prop] = processArray(value, prop, _props.propArray);
	        // Avoid creating properties with empty values
	        if (!style[prop].length) delete style[prop];
	      }
	    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      if (prop === 'fallbacks') {
	        style.fallbacks = styleDetector(style.fallbacks, rule, true);
	        continue;
	      }
	
	      style[prop] = objectToArray(value, prop, rule, isFallback);
	      // Avoid creating properties with empty values
	      if (!style[prop].length) delete style[prop];
	    }
	
	    // Maybe a computed value resulting in an empty string
	    else if (style[prop] === '') delete style[prop];
	  }
	
	  return style;
	}
	
	/**
	 * Adds possibility to write expanded styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssExpand() {
	  function onProcessStyle(style, rule) {
	    if (!style || rule.type !== 'style') return style;
	
	    if (Array.isArray(style)) {
	      // Pass rules one by one and reformat them
	      for (var index = 0; index < style.length; index++) {
	        style[index] = styleDetector(style[index], rule);
	      }
	      return style;
	    }
	
	    return styleDetector(style, rule);
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 440 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * A scheme for converting properties from array to regular style.
	 * All properties listed below will be transformed to a string separated by space.
	 */
	var propArray = exports.propArray = {
	  'background-size': true,
	  'background-position': true,
	  border: true,
	  'border-bottom': true,
	  'border-left': true,
	  'border-top': true,
	  'border-right': true,
	  'border-radius': true,
	  'border-image': true,
	  'border-width': true,
	  'border-style': true,
	  'border-color': true,
	  'box-shadow': true,
	  flex: true,
	  margin: true,
	  padding: true,
	  outline: true,
	  'transform-origin': true,
	  transform: true,
	  transition: true
	
	  /**
	   * A scheme for converting arrays to regular styles inside of objects.
	   * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
	   */
	};var propArrayInObj = exports.propArrayInObj = {
	  position: true, // background-position
	  size: true // background-size
	
	
	  /**
	   * A scheme for parsing and building correct styles from passed objects.
	   */
	};var propObj = exports.propObj = {
	  padding: {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  },
	  margin: {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  },
	  background: {
	    attachment: null,
	    color: null,
	    image: null,
	    position: null,
	    repeat: null
	  },
	  border: {
	    width: null,
	    style: null,
	    color: null
	  },
	  'border-top': {
	    width: null,
	    style: null,
	    color: null
	  },
	  'border-right': {
	    width: null,
	    style: null,
	    color: null
	  },
	  'border-bottom': {
	    width: null,
	    style: null,
	    color: null
	  },
	  'border-left': {
	    width: null,
	    style: null,
	    color: null
	  },
	  outline: {
	    width: null,
	    style: null,
	    color: null
	  },
	  'list-style': {
	    type: null,
	    position: null,
	    image: null
	  },
	  transition: {
	    property: null,
	    duration: null,
	    'timing-function': null,
	    timingFunction: null, // Needed for avoiding comilation issues with jss-camel-case
	    delay: null
	  },
	  animation: {
	    name: null,
	    duration: null,
	    'timing-function': null,
	    timingFunction: null, // Needed to avoid compilation issues with jss-camel-case
	    delay: null,
	    'iteration-count': null,
	    iterationCount: null, // Needed to avoid compilation issues with jss-camel-case
	    direction: null,
	    'fill-mode': null,
	    fillMode: null, // Needed to avoid compilation issues with jss-camel-case
	    'play-state': null,
	    playState: null // Needed to avoid compilation issues with jss-camel-case
	  },
	  'box-shadow': {
	    x: 0,
	    y: 0,
	    blur: 0,
	    spread: 0,
	    color: null,
	    inset: null
	  },
	  'text-shadow': {
	    x: 0,
	    y: 0,
	    blur: null,
	    color: null
	  }
	
	  /**
	   * A scheme for converting non-standart properties inside object.
	   * For e.g.: include 'border-radius' property inside 'border' object.
	   */
	};var customPropObj = exports.customPropObj = {
	  border: {
	    radius: 'border-radius',
	    image: 'border-image',
	    width: 'border-width',
	    style: 'border-style',
	    color: 'border-color'
	  },
	  background: {
	    size: 'background-size',
	    image: 'background-image'
	  },
	  font: {
	    style: 'font-style',
	    variant: 'font-variant',
	    weight: 'font-weight',
	    stretch: 'font-stretch',
	    size: 'font-size',
	    family: 'font-family',
	    lineHeight: 'line-height', // Needed to avoid compilation issues with jss-camel-case
	    'line-height': 'line-height'
	  },
	  flex: {
	    grow: 'flex-grow',
	    basis: 'flex-basis',
	    direction: 'flex-direction',
	    wrap: 'flex-wrap',
	    flow: 'flex-flow',
	    shrink: 'flex-shrink'
	  },
	  align: {
	    self: 'align-self',
	    items: 'align-items',
	    content: 'align-content'
	  },
	  grid: {
	    'template-columns': 'grid-template-columns',
	    templateColumns: 'grid-template-columns',
	
	    'template-rows': 'grid-template-rows',
	    templateRows: 'grid-template-rows',
	
	    'template-areas': 'grid-template-areas',
	    templateAreas: 'grid-template-areas',
	
	    template: 'grid-template',
	
	    'auto-columns': 'grid-auto-columns',
	    autoColumns: 'grid-auto-columns',
	
	    'auto-rows': 'grid-auto-rows',
	    autoRows: 'grid-auto-rows',
	
	    'auto-flow': 'grid-auto-flow',
	    autoFlow: 'grid-auto-flow',
	
	    row: 'grid-row',
	    column: 'grid-column',
	
	    'row-start': 'grid-row-start',
	    rowStart: 'grid-row-start',
	    'row-end': 'grid-row-end',
	    rowEnd: 'grid-row-end',
	
	    'column-start': 'grid-column-start',
	    columnStart: 'grid-column-start',
	    'column-end': 'grid-column-end',
	    columnEnd: 'grid-column-end',
	
	    area: 'grid-area',
	    gap: 'grid-gap',
	
	    'row-gap': 'grid-row-gap',
	    rowGap: 'grid-row-gap',
	
	    'column-gap': 'grid-column-gap',
	    columnGap: 'grid-column-gap'
	  }
	};

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports['default'] = jssExtend;
	
	var _warning = __webpack_require__(442);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isObject = function isObject(obj) {
	  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
	};
	var valueNs = 'extendCurrValue' + Date.now();
	
	function mergeExtend(style, rule, sheet, newStyle) {
	  var extendType = _typeof(style.extend);
	  // Extend using a rule name.
	  if (extendType === 'string') {
	    if (!sheet) return;
	    var refRule = sheet.getRule(style.extend);
	    if (!refRule) return;
	    if (refRule === rule) {
	      (0, _warning2['default'])(false, '[JSS] A rule tries to extend itself \r\n%s', rule);
	      return;
	    }
	    var parent = refRule.options.parent;
	
	    if (parent) {
	      var originalStyle = parent.rules.raw[style.extend];
	      extend(originalStyle, rule, sheet, newStyle);
	    }
	    return;
	  }
	
	  // Extend using an array of objects.
	  if (Array.isArray(style.extend)) {
	    for (var index = 0; index < style.extend.length; index++) {
	      extend(style.extend[index], rule, sheet, newStyle);
	    }
	    return;
	  }
	
	  // Extend is a style object.
	  for (var prop in style.extend) {
	    if (prop === 'extend') {
	      extend(style.extend.extend, rule, sheet, newStyle);
	      continue;
	    }
	    if (isObject(style.extend[prop])) {
	      if (!(prop in newStyle)) newStyle[prop] = {};
	      extend(style.extend[prop], rule, sheet, newStyle[prop]);
	      continue;
	    }
	    newStyle[prop] = style.extend[prop];
	  }
	}
	
	function mergeRest(style, rule, sheet, newStyle) {
	  // Copy base style.
	  for (var prop in style) {
	    if (prop === 'extend') continue;
	    if (isObject(newStyle[prop]) && isObject(style[prop])) {
	      extend(style[prop], rule, sheet, newStyle[prop]);
	      continue;
	    }
	
	    if (isObject(style[prop])) {
	      newStyle[prop] = extend(style[prop], rule, sheet);
	      continue;
	    }
	
	    newStyle[prop] = style[prop];
	  }
	}
	
	/**
	 * Recursively extend styles.
	 */
	function extend(style, rule, sheet) {
	  var newStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  mergeExtend(style, rule, sheet, newStyle);
	  mergeRest(style, rule, sheet, newStyle);
	  return newStyle;
	}
	
	/**
	 * Handle `extend` property.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssExtend() {
	  function onProcessStyle(style, rule, sheet) {
	    if ('extend' in style) return extend(style, rule, sheet);
	    return style;
	  }
	
	  function onChangeValue(value, prop, rule) {
	    if (prop !== 'extend') return value;
	
	    // Value is empty, remove properties set previously.
	    if (value == null || value === false) {
	      for (var key in rule[valueNs]) {
	        rule.prop(key, null);
	      }
	      rule[valueNs] = null;
	      return null;
	    }
	
	    for (var _key in value) {
	      rule.prop(_key, value[_key]);
	    }
	    rule[valueNs] = value;
	
	    // Make sure we don't set the value in the core.
	    return null;
	  }
	
	  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
	}

/***/ },
/* 442 */
59,
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = jssGlobal;
	
	var _jss = __webpack_require__(203);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var propKey = '@global';
	var prefixKey = '@global ';
	
	var GlobalContainerRule = function () {
	  function GlobalContainerRule(key, styles, options) {
	    _classCallCheck(this, GlobalContainerRule);
	
	    this.type = 'global';
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _jss.RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector], { selector: selector });
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Get a rule.
	   */
	
	
	  _createClass(GlobalContainerRule, [{
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Create and register rule, run plugins.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, style, options) {
	      var rule = this.rules.add(name, style, options);
	      this.options.jss.plugins.onProcessRule(rule);
	      return rule;
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.rules.toString();
	    }
	  }]);
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule = function () {
	  function GlobalPrefixedRule(name, style, options) {
	    _classCallCheck(this, GlobalPrefixedRule);
	
	    this.name = name;
	    this.options = options;
	    var selector = name.substr(prefixKey.length);
	    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
	      parent: this,
	      selector: selector
	    }));
	  }
	
	  _createClass(GlobalPrefixedRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      return this.rule.toString(options);
	    }
	  }]);
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + ' ' + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  var rules = style[propKey];
	
	  if (!rules) return;
	
	  for (var name in rules) {
	    options.sheet.addRule(name, rules[name], _extends({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[propKey];
	}
	
	function handlePrefixedGlobalRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop.substr(0, propKey.length) !== propKey) continue;
	
	    var selector = addScope(prop.substr(propKey.length), rule.selector);
	    options.sheet.addRule(selector, style[prop], _extends({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (name === propKey) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent.type === 'global') {
	        options.global = true;
	      }
	    }
	
	    if (options.global) options.selector = name;
	
	    return null;
	  }
	
	  function onProcessRule(rule) {
	    if (rule.type !== 'style') return;
	
	    handleNestedGlobalContainerRule(rule);
	    handlePrefixedGlobalRule(rule);
	  }
	
	  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
	}

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = jssNested;
	
	var _warning = __webpack_require__(445);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container) {
	    return function (match, key) {
	      var rule = container.getRule(key);
	      if (rule) return rule.selector;
	      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
	      return key;
	    };
	  }
	
	  var hasAnd = function hasAnd(str) {
	    return str.indexOf('&') !== -1;
	  };
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', ';
	        // Replace all & by the parent or prefix & with the parent.
	        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, options) {
	    // Options has been already created, now we only increase index.
	    if (options) return _extends({}, options, { index: options.index + 1 });
	
	    var nestingLevel = rule.options.nestingLevel;
	
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    return _extends({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1
	    });
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    var container = rule.options.parent;
	    var options = void 0;
	    var replaceRef = void 0;
	    for (var prop in style) {
	      var isNested = hasAnd(prop);
	      var isNestedConditional = prop[0] === '@';
	
	      if (!isNested && !isNestedConditional) continue;
	
	      options = getOptions(rule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, rule.selector
	        // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	        );if (!replaceRef) replaceRef = getReplaceRef(container
	        // Replace all $refs.
	        );selector = selector.replace(refRegExp, replaceRef);
	
	        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
	      } else if (isNestedConditional) {
	        container
	        // Place conditional right after the parent rule to ensure right ordering.
	        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 445 */
59,
/* 446 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = jssPropsSort;
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  function sort(prop0, prop1) {
	    return prop0.length - prop1.length;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    var newStyle = {};
	    var props = Object.keys(style).sort(sort);
	    for (var prop in props) {
	      newStyle[props[prop]] = style[props[prop]];
	    }
	    return newStyle;
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parse = __webpack_require__(448);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var onProcessRule = function onProcessRule(rule) {
	  if (typeof rule.style === 'string') {
	    rule.style = (0, _parse2['default'])(rule.style);
	  }
	};
	
	exports['default'] = function () {
	  return { onProcessRule: onProcessRule };
	};

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warning = __webpack_require__(449);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var semiWithNl = /;\n/;
	
	/**
	 * Naive CSS parser.
	 * - Supports only rule body (no selectors)
	 * - Requires semicolon and new line after the value (except of last line)
	 * - No nested rules support
	 */
	
	exports['default'] = function (cssText) {
	  var style = {};
	  var split = cssText.split(semiWithNl);
	  for (var i = 0; i < split.length; i++) {
	    var decl = (split[i] || '').trim();
	
	    if (!decl) continue;
	    var colonIndex = decl.indexOf(':');
	    if (colonIndex === -1) {
	      (0, _warning2['default'])(false, 'Malformed CSS string "%s"', decl);
	      continue;
	    }
	    var prop = decl.substr(0, colonIndex).trim();
	    var value = decl.substr(colonIndex + 1).trim();
	    style[prop] = value;
	  }
	  return style;
	};

/***/ },
/* 449 */
59,
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = jssVendorPrefixer;
	
	var _cssVendor = __webpack_require__(452);
	
	var vendor = _interopRequireWildcard(_cssVendor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 * Add vendor prefix to a property name when needed.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
	    }
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      var value = style[prop];
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, value);
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, value);
	  }
	
	  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
	}

/***/ },
/* 451 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = camelize;
	var regExp = /[-\s]+(.)?/g;
	
	/**
	 * Convert dash separated strings to camel cased.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;
	
	var _prefix = __webpack_require__(130);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _supportedProperty = __webpack_require__(453);
	
	var _supportedProperty2 = _interopRequireDefault(_supportedProperty);
	
	var _supportedValue = __webpack_require__(454);
	
	var _supportedValue2 = _interopRequireDefault(_supportedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  prefix: _prefix2['default'],
	  supportedProperty: _supportedProperty2['default'],
	  supportedValue: _supportedValue2['default']
	}; /**
	    * CSS Vendor prefix detection and property feature testing.
	    *
	    * @copyright Oleg Slobodskoi 2015
	    * @website https://github.com/jsstyles/css-vendor
	    * @license MIT
	    */
	
	exports.prefix = _prefix2['default'];
	exports.supportedProperty = _supportedProperty2['default'];
	exports.supportedValue = _supportedValue2['default'];

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = supportedProperty;
	
	var _isInBrowser = __webpack_require__(131);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _prefix = __webpack_require__(130);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _camelize = __webpack_require__(451);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var el = void 0;
	var cache = {};
	
	if (_isInBrowser2['default']) {
	  el = document.createElement('p');
	
	  /**
	   * We test every property on vendor prefix requirement.
	   * Once tested, result is cached. It gives us up to 70% perf boost.
	   * http://jsperf.com/element-style-object-access-vs-plain-object
	   *
	   * Prefill cache with known css properties to reduce amount of
	   * properties we need to feature test at runtime.
	   * http://davidwalsh.name/vendor-prefix
	   */
	  var computed = window.getComputedStyle(document.documentElement, '');
	  for (var key in computed) {
	    if (!isNaN(key)) cache[computed[key]] = computed[key];
	  }
	}
	
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @return {String|Boolean}
	 * @api public
	 */
	function supportedProperty(prop) {
	  // For server-side rendering.
	  if (!el) return prop;
	
	  // We have not tested this prop yet, lets do the test.
	  if (cache[prop] != null) return cache[prop];
	
	  // Camelization is required because we can't test using
	  // css syntax for e.g. in FF.
	  // Test if property is supported as it is.
	  if ((0, _camelize2['default'])(prop) in el.style) {
	    cache[prop] = prop;
	  }
	  // Test if property is supported with vendor prefix.
	  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
	      cache[prop] = _prefix2['default'].css + prop;
	    } else {
	      cache[prop] = false;
	    }
	
	  return cache[prop];
	}

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = supportedValue;
	
	var _isInBrowser = __webpack_require__(131);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _prefix = __webpack_require__(130);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var cache = {};
	var el = void 0;
	
	if (_isInBrowser2['default']) el = document.createElement('p');
	
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	function supportedValue(property, value) {
	  // For server-side rendering.
	  if (!el) return value;
	
	  // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;
	
	  var cacheKey = property + value;
	
	  if (cache[cacheKey] != null) return cache[cacheKey];
	
	  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
	  try {
	    // Test value as it is.
	    el.style[property] = value;
	  } catch (err) {
	    cache[cacheKey] = false;
	    return false;
	  }
	
	  // Value is supported as it is.
	  if (el.style[property] !== '') {
	    cache[cacheKey] = value;
	  } else {
	    // Test value with vendor prefix.
	    value = _prefix2['default'].css + value;
	
	    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	    if (value === '-ms-flex') value = '-ms-flexbox';
	
	    el.style[property] = value;
	
	    // Value is supported with vendor prefix.
	    if (el.style[property] !== '') cache[cacheKey] = value;
	  }
	
	  if (!cache[cacheKey]) cache[cacheKey] = false;
	
	  // Reset style value.
	  el.style[property] = '';
	
	  return cache[cacheKey];
	}

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isInBrowser = __webpack_require__(472);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _StyleSheet = __webpack_require__(202);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _PluginsRegistry = __webpack_require__(456);
	
	var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);
	
	var _rules = __webpack_require__(460);
	
	var _rules2 = _interopRequireDefault(_rules);
	
	var _observables = __webpack_require__(459);
	
	var _observables2 = _interopRequireDefault(_observables);
	
	var _functions = __webpack_require__(458);
	
	var _functions2 = _interopRequireDefault(_functions);
	
	var _sheets = __webpack_require__(132);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	var _StyleRule = __webpack_require__(58);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _createGenerateClassName = __webpack_require__(204);
	
	var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);
	
	var _createRule2 = __webpack_require__(87);
	
	var _createRule3 = _interopRequireDefault(_createRule2);
	
	var _DomRenderer = __webpack_require__(461);
	
	var _DomRenderer2 = _interopRequireDefault(_DomRenderer);
	
	var _VirtualRenderer = __webpack_require__(462);
	
	var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);
	
	var instanceCounter = 0;
	
	var Jss = function () {
	  function Jss(options) {
	    _classCallCheck(this, Jss);
	
	    this.id = instanceCounter++;
	    this.version = "9.8.7";
	    this.plugins = new _PluginsRegistry2['default']();
	    this.options = {
	      createGenerateClassName: _createGenerateClassName2['default'],
	      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
	      plugins: []
	    };
	    this.generateClassName = (0, _createGenerateClassName2['default'])();
	
	    // eslint-disable-next-line prefer-spread
	    this.use.apply(this, defaultPlugins);
	    this.setup(options);
	  }
	
	  _createClass(Jss, [{
	    key: 'setup',
	    value: function setup() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (options.createGenerateClassName) {
	        this.options.createGenerateClassName = options.createGenerateClassName;
	        // $FlowFixMe
	        this.generateClassName = options.createGenerateClassName();
	      }
	
	      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	      if (options.virtual || options.Renderer) {
	        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
	      }
	
	      // eslint-disable-next-line prefer-spread
	      if (options.plugins) this.use.apply(this, options.plugins);
	
	      return this;
	    }
	
	    /**
	     * Create a Style Sheet.
	     */
	
	  }, {
	    key: 'createStyleSheet',
	    value: function createStyleSheet(styles) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var index = options.index;
	      if (typeof index !== 'number') {
	        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
	      }
	      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
	        jss: this,
	        generateClassName: options.generateClassName || this.generateClassName,
	        insertionPoint: this.options.insertionPoint,
	        Renderer: this.options.Renderer,
	        index: index
	      }));
	      this.plugins.onProcessSheet(sheet);
	
	      return sheet;
	    }
	
	    /**
	     * Detach the Style Sheet and remove it from the registry.
	     */
	
	  }, {
	    key: 'removeStyleSheet',
	    value: function removeStyleSheet(sheet) {
	      sheet.detach();
	      _sheets2['default'].remove(sheet);
	      return this;
	    }
	
	    /**
	     * Create a rule without a Style Sheet.
	     */
	
	  }, {
	    key: 'createRule',
	    value: function createRule(name) {
	      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      // Enable rule without name for inline styles.
	      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	        options = style;
	        style = name;
	        name = undefined;
	      }
	
	      // Cast from RuleFactoryOptions to RuleOptions
	      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	      var ruleOptions = options;
	
	      ruleOptions.jss = this;
	      ruleOptions.Renderer = this.options.Renderer;
	      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
	      if (!ruleOptions.classes) ruleOptions.classes = {};
	      var rule = (0, _createRule3['default'])(name, style, ruleOptions);
	
	      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
	        rule.selector = '.' + ruleOptions.generateClassName(rule);
	      }
	
	      this.plugins.onProcessRule(rule);
	
	      return rule;
	    }
	
	    /**
	     * Register plugin. Passed function will be invoked with a rule instance.
	     */
	
	  }, {
	    key: 'use',
	    value: function use() {
	      var _this = this;
	
	      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
	        plugins[_key] = arguments[_key];
	      }
	
	      plugins.forEach(function (plugin) {
	        // Avoids applying same plugin twice, at least based on ref.
	        if (_this.options.plugins.indexOf(plugin) === -1) {
	          _this.options.plugins.push(plugin);
	          _this.plugins.use(plugin);
	        }
	      });
	
	      return this;
	    }
	  }]);
	
	  return Jss;
	}();
	
	exports['default'] = Jss;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PluginsRegistry = function () {
	  function PluginsRegistry() {
	    _classCallCheck(this, PluginsRegistry);
	
	    this.hooks = {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	
	      /**
	       * Call `onCreateRule` hooks and return an object if returned by a hook.
	       */
	    };
	  }
	
	  _createClass(PluginsRegistry, [{
	    key: 'onCreateRule',
	    value: function onCreateRule(name, decl, options) {
	      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
	        var rule = this.hooks.onCreateRule[i](name, decl, options);
	        if (rule) return rule;
	      }
	      return null;
	    }
	
	    /**
	     * Call `onProcessRule` hooks.
	     */
	
	  }, {
	    key: 'onProcessRule',
	    value: function onProcessRule(rule) {
	      if (rule.isProcessed) return;
	      var sheet = rule.options.sheet;
	
	      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
	        this.hooks.onProcessRule[i](rule, sheet);
	      }
	
	      // $FlowFixMe
	      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	
	      rule.isProcessed = true;
	    }
	
	    /**
	     * Call `onProcessStyle` hooks.
	     */
	
	  }, {
	    key: 'onProcessStyle',
	    value: function onProcessStyle(style, rule, sheet) {
	      var nextStyle = style;
	
	      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
	        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
	        // $FlowFixMe
	        rule.style = nextStyle;
	      }
	    }
	
	    /**
	     * Call `onProcessSheet` hooks.
	     */
	
	  }, {
	    key: 'onProcessSheet',
	    value: function onProcessSheet(sheet) {
	      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
	        this.hooks.onProcessSheet[i](sheet);
	      }
	    }
	
	    /**
	     * Call `onUpdate` hooks.
	     */
	
	  }, {
	    key: 'onUpdate',
	    value: function onUpdate(data, rule, sheet) {
	      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
	        this.hooks.onUpdate[i](data, rule, sheet);
	      }
	    }
	
	    /**
	     * Call `onChangeValue` hooks.
	     */
	
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(value, prop, rule) {
	      var processedValue = value;
	      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
	        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
	      }
	      return processedValue;
	    }
	
	    /**
	     * Register a plugin.
	     * If function is passed, it is a shortcut for `{onProcessRule}`.
	     */
	
	  }, {
	    key: 'use',
	    value: function use(plugin) {
	      for (var name in plugin) {
	        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
	      }
	    }
	  }]);
	
	  return PluginsRegistry;
	}();
	
	exports['default'] = PluginsRegistry;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 */
	var SheetsManager = function () {
	  function SheetsManager() {
	    _classCallCheck(this, SheetsManager);
	
	    this.sheets = [];
	    this.refs = [];
	    this.keys = [];
	  }
	
	  _createClass(SheetsManager, [{
	    key: 'get',
	    value: function get(key) {
	      var index = this.keys.indexOf(key);
	      return this.sheets[index];
	    }
	  }, {
	    key: 'add',
	    value: function add(key, sheet) {
	      var sheets = this.sheets,
	          refs = this.refs,
	          keys = this.keys;
	
	      var index = sheets.indexOf(sheet);
	
	      if (index !== -1) return index;
	
	      sheets.push(sheet);
	      refs.push(0);
	      keys.push(key);
	
	      return sheets.length - 1;
	    }
	  }, {
	    key: 'manage',
	    value: function manage(key) {
	      var index = this.keys.indexOf(key);
	      var sheet = this.sheets[index];
	      if (this.refs[index] === 0) sheet.attach();
	      this.refs[index]++;
	      if (!this.keys[index]) this.keys.splice(index, 0, key);
	      return sheet;
	    }
	  }, {
	    key: 'unmanage',
	    value: function unmanage(key) {
	      var index = this.keys.indexOf(key);
	      if (index === -1) {
	        // eslint-ignore-next-line no-console
	        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
	        return;
	      }
	      if (this.refs[index] > 0) {
	        this.refs[index]--;
	        if (this.refs[index] === 0) this.sheets[index].detach();
	      }
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return this.keys.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	exports['default'] = SheetsManager;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RuleList = __webpack_require__(70);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	var _StyleRule = __webpack_require__(58);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _createRule = __webpack_require__(87);
	
	var _createRule2 = _interopRequireDefault(_createRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// A symbol replacement.
	var now = Date.now();
	
	var fnValuesNs = 'fnValues' + now;
	var fnStyleNs = 'fnStyle' + ++now;
	
	exports['default'] = {
	  onCreateRule: function onCreateRule(name, decl, options) {
	    if (typeof decl !== 'function') return null;
	    var rule = (0, _createRule2['default'])(name, {}, options);
	    rule[fnStyleNs] = decl;
	    return rule;
	  },
	  onProcessStyle: function onProcessStyle(style, rule) {
	    var fn = {};
	    for (var prop in style) {
	      var value = style[prop];
	      if (typeof value !== 'function') continue;
	      delete style[prop];
	      fn[prop] = value;
	    }
	    rule = rule;
	    rule[fnValuesNs] = fn;
	    return style;
	  },
	  onUpdate: function onUpdate(data, rule) {
	    // It is a rules container like for e.g. ConditionalRule.
	    if (rule.rules instanceof _RuleList2['default']) {
	      rule.rules.update(data);
	      return;
	    }
	    if (!(rule instanceof _StyleRule2['default'])) return;
	
	    rule = rule;
	
	    // If we have a fn values map, it is a rule with function values.
	    if (rule[fnValuesNs]) {
	      for (var prop in rule[fnValuesNs]) {
	        rule.prop(prop, rule[fnValuesNs][prop](data));
	      }
	    }
	
	    rule = rule;
	
	    var fnStyle = rule[fnStyleNs];
	
	    // If we have a style function, the entire rule is dynamic and style object
	    // will be returned from that function.
	    if (fnStyle) {
	      var style = fnStyle(data);
	      for (var _prop in style) {
	        rule.prop(_prop, style[_prop]);
	      }
	    }
	  }
	};

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StyleRule = __webpack_require__(58);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _createRule = __webpack_require__(87);
	
	var _createRule2 = _interopRequireDefault(_createRule);
	
	var _isObservable = __webpack_require__(205);
	
	var _isObservable2 = _interopRequireDefault(_isObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  onCreateRule: function onCreateRule(name, decl, options) {
	    if (!(0, _isObservable2['default'])(decl)) return null;
	
	    // Cast `decl` to `Observable`, since it passed the type guard.
	    var style$ = decl;
	
	    var rule = (0, _createRule2['default'])(name, {}, options);
	
	    // TODO
	    // Call `stream.subscribe()` returns a subscription, which should be explicitly
	    // unsubscribed from when we know this sheet is no longer needed.
	    style$.subscribe(function (style) {
	      for (var prop in style) {
	        rule.prop(prop, style[prop]);
	      }
	    });
	
	    return rule;
	  },
	  onProcessRule: function onProcessRule(rule) {
	    if (!(rule instanceof _StyleRule2['default'])) return;
	    var styleRule = rule;
	    var style = styleRule.style;
	
	    var _loop = function _loop(prop) {
	      var value = style[prop];
	      if (!(0, _isObservable2['default'])(value)) return 'continue';
	      delete style[prop];
	      value.subscribe({
	        next: function next(nextValue) {
	          styleRule.prop(prop, nextValue);
	        }
	      });
	    };
	
	    for (var prop in style) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	  }
	};

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleRule = __webpack_require__(466);
	
	var _SimpleRule2 = _interopRequireDefault(_SimpleRule);
	
	var _KeyframesRule = __webpack_require__(465);
	
	var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);
	
	var _ConditionalRule = __webpack_require__(463);
	
	var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);
	
	var _FontFaceRule = __webpack_require__(464);
	
	var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);
	
	var _ViewportRule = __webpack_require__(467);
	
	var _ViewportRule2 = _interopRequireDefault(_ViewportRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var classes = {
	  '@charset': _SimpleRule2['default'],
	  '@import': _SimpleRule2['default'],
	  '@namespace': _SimpleRule2['default'],
	  '@keyframes': _KeyframesRule2['default'],
	  '@media': _ConditionalRule2['default'],
	  '@supports': _ConditionalRule2['default'],
	  '@font-face': _FontFaceRule2['default'],
	  '@viewport': _ViewportRule2['default'],
	  '@-ms-viewport': _ViewportRule2['default']
	
	  /**
	   * Generate plugins which will register all rules.
	   */
	};
	var plugins = Object.keys(classes).map(function (key) {
	  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
	  var re = new RegExp('^' + key);
	  var RuleClass = classes[key];
	  var onCreateRule = function onCreateRule(name, decl, options) {
	    return re.test(name) ? new RuleClass(name, decl, options) : null;
	  };
	  return { onCreateRule: onCreateRule };
	});
	
	exports['default'] = plugins;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(59);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _sheets = __webpack_require__(132);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	var _StyleRule = __webpack_require__(58);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _toCssValue = __webpack_require__(88);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	var memoize = function memoize(fn) {
	  var value = void 0;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	
	/**
	 * Get a style property value.
	 */
	function getPropertyValue(cssRule, prop) {
	  try {
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	}
	
	/**
	 * Set a style property.
	 */
	function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = (0, _toCssValue2['default'])(value, true);
	
	      if (value[value.length - 1] === '!important') {
	        cssRule.style.setProperty(prop, cssValue, 'important');
	        return true;
	      }
	    }
	
	    cssRule.style.setProperty(prop, cssValue);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	  return true;
	}
	
	/**
	 * Remove a style property.
	 */
	function removeProperty(cssRule, prop) {
	  try {
	    cssRule.style.removeProperty(prop);
	  } catch (err) {
	    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
	  }
	}
	
	var CSSRuleTypes = {
	  STYLE_RULE: 1,
	  KEYFRAMES_RULE: 7
	
	  /**
	   * Get the CSS Rule key.
	   */
	
	};var getKey = function () {
	  var extractKey = function extractKey(cssText) {
	    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return cssText.substr(from, cssText.indexOf('{') - 1);
	  };
	
	  return function (cssRule) {
	    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
	    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
	      var name = cssRule.name;
	
	      if (name) return '@keyframes ' + name;
	
	      // There is no rule.name in the following browsers:
	      // - IE 9
	      // - Safari 7.1.8
	      // - Mobile Safari 9.0.0
	      var cssText = cssRule.cssText;
	
	      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
	    }
	
	    // Conditionals.
	    return extractKey(cssRule.cssText);
	  };
	}();
	
	/**
	 * Set the selector.
	 */
	function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText;
	
	  // Return false if setter was not successful.
	  // Currently works in chrome only.
	  return cssRule.selectorText === selectorText;
	}
	
	/**
	 * Gets the `head` element upon the first call and caches it.
	 */
	var getHead = memoize(function () {
	  return document.head || document.getElementsByTagName('head')[0];
	});
	
	/**
	 * Gets a map of rule keys, where the property is an unescaped key and value
	 * is a potentially escaped one.
	 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
	 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
	 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
	 * and so CSS rule's `selectorText` won't match JSS rule selector.
	 *
	 * https://www.w3.org/International/questions/qa-escapes#cssescapes
	 */
	var getUnescapedKeysMap = function () {
	  var style = void 0;
	  var isAttached = false;
	
	  return function (rules) {
	    var map = {};
	    // https://github.com/facebook/flow/issues/2696
	    if (!style) style = document.createElement('style');
	    for (var i = 0; i < rules.length; i++) {
	      var rule = rules[i];
	      if (!(rule instanceof _StyleRule2['default'])) continue;
	      var selector = rule.selector;
	      // Only unescape selector over CSSOM if it contains a back slash.
	
	      if (selector && selector.indexOf('\\') !== -1) {
	        // Lazilly attach when needed.
	        if (!isAttached) {
	          getHead().appendChild(style);
	          isAttached = true;
	        }
	        style.textContent = selector + ' {}';
	        var _style = style,
	            sheet = _style.sheet;
	
	        if (sheet) {
	          var cssRules = sheet.cssRules;
	
	          if (cssRules) map[cssRules[0].selectorText] = rule.key;
	        }
	      }
	    }
	    if (isAttached) {
	      getHead().removeChild(style);
	      isAttached = false;
	    }
	    return map;
	  };
	}();
	
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find attached sheet with the highest index.
	 */
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find a comment with "jss" inside.
	 */
	function findCommentNode(text) {
	  var head = getHead();
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry = _sheets2['default'].registry;
	
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	    if (sheet) return sheet.renderer.element;
	
	    // Otherwise insert after the last attached.
	    sheet = findHighestSheet(registry, options);
	    if (sheet) return sheet.renderer.element.nextElementSibling;
	  }
	
	  // Try to find a comment placeholder if registry is empty.
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	    if (comment) return comment.nextSibling;
	    // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
	  }
	
	  return null;
	}
	
	/**
	 * Insert style element into the DOM.
	 */
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	
	  var prevNode = findPrevNode(options);
	
	  if (prevNode) {
	    var parentNode = prevNode.parentNode;
	
	    if (parentNode) parentNode.insertBefore(style, prevNode);
	    return;
	  }
	
	  // Works with iframes and any node types.
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	    var insertionPointElement = insertionPoint;
	    var _parentNode = insertionPointElement.parentNode;
	
	    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
	    return;
	  }
	
	  getHead().insertBefore(style, prevNode);
	}
	
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var DomRenderer = function () {
	  function DomRenderer(sheet) {
	    _classCallCheck(this, DomRenderer);
	
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.getKey = getKey;
	    this.getUnescapedKeysMap = getUnescapedKeysMap;
	    this.hasInsertedRules = false;
	
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) _sheets2['default'].add(sheet);
	
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || document.createElement('style');
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	
	
	  _createClass(DomRenderer, [{
	    key: 'attach',
	    value: function attach() {
	      // In the case the element node is external and it is already in the DOM.
	      if (this.element.parentNode || !this.sheet) return;
	
	      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	      // browsers remove those rules.
	      // TODO figure out if its a bug and if it is known.
	      // Workaround is to redeploy the sheet before attaching as a string.
	      if (this.hasInsertedRules) {
	        this.deploy();
	        this.hasInsertedRules = false;
	      }
	
	      insertStyle(this.element, this.sheet.options);
	    }
	
	    /**
	     * Remove style element from render tree.
	     */
	
	  }, {
	    key: 'detach',
	    value: function detach() {
	      this.element.parentNode.removeChild(this.element);
	    }
	
	    /**
	     * Inject CSS string into element.
	     */
	
	  }, {
	    key: 'deploy',
	    value: function deploy() {
	      if (!this.sheet) return;
	      this.element.textContent = '\n' + this.sheet.toString() + '\n';
	    }
	
	    /**
	     * Insert a rule into element.
	     */
	
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule, index) {
	      var sheet = this.element.sheet;
	      var cssRules = sheet.cssRules;
	
	      var str = rule.toString();
	      if (!index) index = cssRules.length;
	
	      if (!str) return false;
	
	      try {
	        sheet.insertRule(str, index);
	      } catch (err) {
	        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
	        return false;
	      }
	      this.hasInsertedRules = true;
	
	      return cssRules[index];
	    }
	
	    /**
	     * Delete a rule.
	     */
	
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(cssRule) {
	      var sheet = this.element.sheet;
	
	      var index = this.indexOf(cssRule);
	      if (index === -1) return false;
	      sheet.deleteRule(index);
	      return true;
	    }
	
	    /**
	     * Get index of a CSS Rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(cssRule) {
	      var cssRules = this.element.sheet.cssRules;
	
	      for (var _index = 0; _index < cssRules.length; _index++) {
	        if (cssRule === cssRules[_index]) return _index;
	      }
	      return -1;
	    }
	
	    /**
	     * Generate a new CSS rule and replace the existing one.
	     */
	
	  }, {
	    key: 'replaceRule',
	    value: function replaceRule(cssRule, rule) {
	      var index = this.indexOf(cssRule);
	      var newCssRule = this.insertRule(rule, index);
	      this.element.sheet.deleteRule(index);
	      return newCssRule;
	    }
	
	    /**
	     * Get all rules elements.
	     */
	
	  }, {
	    key: 'getRules',
	    value: function getRules() {
	      return this.element.sheet.cssRules;
	    }
	  }]);
	
	  return DomRenderer;
	}();
	
	exports['default'] = DomRenderer;

/***/ },
/* 462 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable class-methods-use-this */
	
	/**
	 * Rendering backend to do nothing in nodejs.
	 */
	var VirtualRenderer = function () {
	  function VirtualRenderer() {
	    _classCallCheck(this, VirtualRenderer);
	  }
	
	  _createClass(VirtualRenderer, [{
	    key: 'setProperty',
	    value: function setProperty() {
	      return true;
	    }
	  }, {
	    key: 'getPropertyValue',
	    value: function getPropertyValue() {
	      return '';
	    }
	  }, {
	    key: 'removeProperty',
	    value: function removeProperty() {}
	  }, {
	    key: 'setSelector',
	    value: function setSelector() {
	      return true;
	    }
	  }, {
	    key: 'getKey',
	    value: function getKey() {
	      return '';
	    }
	  }, {
	    key: 'attach',
	    value: function attach() {}
	  }, {
	    key: 'detach',
	    value: function detach() {}
	  }, {
	    key: 'deploy',
	    value: function deploy() {}
	  }, {
	    key: 'insertRule',
	    value: function insertRule() {
	      return false;
	    }
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule() {
	      return true;
	    }
	  }, {
	    key: 'replaceRule',
	    value: function replaceRule() {
	      return false;
	    }
	  }, {
	    key: 'getRules',
	    value: function getRules() {}
	  }, {
	    key: 'indexOf',
	    value: function indexOf() {
	      return -1;
	    }
	  }]);
	
	  return VirtualRenderer;
	}();
	
	exports['default'] = VirtualRenderer;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RuleList = __webpack_require__(70);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Conditional rule for @media, @supports
	 */
	var ConditionalRule = function () {
	  function ConditionalRule(key, styles, options) {
	    _classCallCheck(this, ConditionalRule);
	
	    this.type = 'conditional';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Get a rule.
	   */
	
	
	  _createClass(ConditionalRule, [{
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Create and register rule, run plugins.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, style, options) {
	      var rule = this.rules.add(name, style, options);
	      this.options.jss.plugins.onProcessRule(rule);
	      return rule;
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };
	
	      var inner = this.rules.toString(options);
	      return inner ? this.key + ' {\n' + inner + '\n}' : '';
	    }
	  }]);
	
	  return ConditionalRule;
	}();
	
	exports['default'] = ConditionalRule;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(133);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FontFaceRule = function () {
	  function FontFaceRule(key, style, options) {
	    _classCallCheck(this, FontFaceRule);
	
	    this.type = 'font-face';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(FontFaceRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      if (Array.isArray(this.style)) {
	        var str = '';
	        for (var index = 0; index < this.style.length; index++) {
	          str += (0, _toCss2['default'])(this.key, this.style[index]);
	          if (this.style[index + 1]) str += '\n';
	        }
	        return str;
	      }
	
	      return (0, _toCss2['default'])(this.key, this.style, options);
	    }
	  }]);
	
	  return FontFaceRule;
	}();
	
	exports['default'] = FontFaceRule;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RuleList = __webpack_require__(70);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Rule for @keyframes
	 */
	var KeyframesRule = function () {
	  function KeyframesRule(key, frames, options) {
	    _classCallCheck(this, KeyframesRule);
	
	    this.type = 'keyframes';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends({}, this.options, {
	        parent: this,
	        selector: name
	      }));
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(KeyframesRule, [{
	    key: 'toString',
	    value: function toString() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };
	
	      var inner = this.rules.toString(options);
	      if (inner) inner += '\n';
	      return this.key + ' {\n' + inner + '}';
	    }
	  }]);
	
	  return KeyframesRule;
	}();
	
	exports['default'] = KeyframesRule;

/***/ },
/* 466 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SimpleRule = function () {
	  function SimpleRule(key, value, options) {
	    _classCallCheck(this, SimpleRule);
	
	    this.type = 'simple';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  _createClass(SimpleRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      if (Array.isArray(this.value)) {
	        var str = '';
	        for (var index = 0; index < this.value.length; index++) {
	          str += this.key + ' ' + this.value[index] + ';';
	          if (this.value[index + 1]) str += '\n';
	        }
	        return str;
	      }
	
	      return this.key + ' ' + this.value + ';';
	    }
	  }]);
	
	  return SimpleRule;
	}();
	
	exports['default'] = SimpleRule;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(133);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ViewportRule = function () {
	  function ViewportRule(key, style, options) {
	    _classCallCheck(this, ViewportRule);
	
	    this.type = 'viewport';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(ViewportRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      return (0, _toCss2['default'])(this.key, this.style, options);
	    }
	  }]);
	
	  return ViewportRule;
	}();
	
	exports['default'] = ViewportRule;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports['default'] = cloneStyle;
	
	var _isObservable = __webpack_require__(205);
	
	var _isObservable2 = _interopRequireDefault(_isObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isArray = Array.isArray;
	function cloneStyle(style) {
	  // Support empty values in case user ends up with them by accident.
	  if (style == null) return style;
	
	  // Support string value for SimpleRule.
	  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);
	
	  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
	    return style;
	  }
	
	  // Support array for FontFaceRule.
	  if (isArray(style)) return style.map(cloneStyle);
	
	  // Support Observable styles.  Observables are immutable, so we don't need to
	  // copy them.
	  if ((0, _isObservable2['default'])(style)) return style;
	
	  var newStyle = {};
	  for (var name in style) {
	    var value = style[name];
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      newStyle[name] = cloneStyle(value);
	      continue;
	    }
	    newStyle[name] = value;
	  }
	
	  return newStyle;
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CSS = global.CSS;
	
	var env = ("production");
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;
	
	exports['default'] = function (str) {
	  // We don't need to escape it in production, because we are not using user's
	  // input for selectors, we are generating a valid selector.
	  if (env === 'production') return str;
	
	  if (!CSS || !CSS.escape) {
	    return str.replace(escapeRegex, '\\$1');
	  }
	
	  return CSS.escape(str);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 470 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports['default'] = getDynamicStyles;
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	function getDynamicStyles(styles) {
	  var to = null;
	
	  for (var key in styles) {
	    var value = styles[key];
	    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	    if (type === 'function') {
	      if (!to) to = {};
	      to[key] = value;
	    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	      var extracted = getDynamicStyles(value);
	      if (extracted) {
	        if (!to) to = {};
	        to[key] = extracted;
	      }
	    }
	  }
	
	  return to;
	}

/***/ },
/* 471 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (global[ns] == null) global[ns] = 0;
	
	// Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	exports['default'] = global[ns]++;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 472 */
131,
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(474);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(75)(module)))

/***/ },
/* 474 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createThemeProvider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isFunction = __webpack_require__(478);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(479);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _channel = __webpack_require__(89);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _brcast = __webpack_require__(477);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Provide a theme to an entire react component tree via context
	 * and event listeners (have to do both context
	 * and event emitter as pure components block context updates)
	 */
	
	function createThemeProvider() {
	  var _class, _temp2;
	
	  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel2.default;
	
	  return _temp2 = _class = function (_React$Component) {
	    _inherits(ThemeProvider, _React$Component);
	
	    function ThemeProvider() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ThemeProvider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.broadcast = (0, _brcast2.default)(_this.getTheme()), _this.setOuterTheme = function (theme) {
	        _this.outerTheme = theme;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ThemeProvider, [{
	      key: 'getTheme',
	
	
	      // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	      value: function getTheme(passedTheme) {
	        var theme = passedTheme || this.props.theme;
	        if ((0, _isFunction2.default)(theme)) {
	          var mergedTheme = theme(this.outerTheme);
	          if (!(0, _isPlainObject2.default)(mergedTheme)) {
	            throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	          }
	          return mergedTheme;
	        }
	        if (!(0, _isPlainObject2.default)(theme)) {
	          throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	        }
	
	        if (!this.outerTheme) {
	          return theme;
	        }
	
	        return _extends({}, this.outerTheme, theme);
	      }
	    }, {
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return _defineProperty({}, CHANNEL, this.broadcast);
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // create a new subscription for keeping track of outer theme, if present
	        if (this.context[CHANNEL]) {
	          this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
	        }
	      }
	
	      // set broadcast state by merging outer theme with own
	
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (this.context[CHANNEL]) {
	          this.setOuterTheme(this.context[CHANNEL].getState());
	          this.broadcast.setState(this.getTheme());
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.theme !== nextProps.theme) {
	          this.broadcast.setState(this.getTheme(nextProps.theme));
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.subscriptionId !== undefined) {
	          this.context[CHANNEL].unsubscribe(this.subscriptionId);
	          delete this.subscriptionId;
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        if (!this.props.children) {
	          return null;
	        }
	        return _react2.default.Children.only(this.props.children);
	      }
	    }]);
	
	    return ThemeProvider;
	  }(_react2.default.Component), _class.propTypes = {
	    children: _propTypes2.default.element,
	    theme: _propTypes2.default.oneOfType([_propTypes2.default.shape({}), _propTypes2.default.func]).isRequired
	  }, _class.childContextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.object.isRequired), _class.contextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.object), _temp2;
	}

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createWithTheme;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _channel = __webpack_require__(89);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _createThemeListener = __webpack_require__(207);
	
	var _createThemeListener2 = _interopRequireDefault(_createThemeListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(Component) {
	  return Component.displayName || Component.name || 'Component';
	};
	
	function createWithTheme() {
	  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel2.default;
	
	  var themeListener = (0, _createThemeListener2.default)(CHANNEL);
	  return function (Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	      _inherits(WithTheme, _React$Component);
	
	      function WithTheme(props, context) {
	        _classCallCheck(this, WithTheme);
	
	        var _this = _possibleConstructorReturn(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));
	
	        _this.state = { theme: themeListener.initial(context) };
	        _this.setTheme = function (theme) {
	          return _this.setState({ theme: theme });
	        };
	        return _this;
	      }
	
	      _createClass(WithTheme, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.unsubscribe = themeListener.subscribe(this.context, this.setTheme);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (typeof this.unsubscribe === 'function') {
	            this.unsubscribe();
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var theme = this.state.theme;
	
	
	          return _react2.default.createElement(Component, _extends({ theme: theme }, this.props));
	        }
	      }]);
	
	      return WithTheme;
	    }(_react2.default.Component), _class.displayName = 'WithTheme(' + getDisplayName(Component) + ')', _class.contextTypes = themeListener.contextTypes, _temp;
	  };
	}

/***/ },
/* 477 */
/***/ function(module, exports) {

	function createBroadcast (initialState) {
	  var listeners = {};
	  var id = 1;
	  var _state = initialState;
	
	  function getState () {
	    return _state
	  }
	
	  function setState (state) {
	    _state = state;
	    var keys = Object.keys(listeners);
	    var i = 0;
	    var len = keys.length;
	    for (; i < len; i++) {
	      // if a listener gets unsubscribed during setState we just skip it
	      if (listeners[keys[i]]) { listeners[keys[i]](state); }
	    }
	  }
	
	  // subscribe to changes and return the subscriptionId
	  function subscribe (listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('listener must be a function.')
	    }
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    return currentId
	  }
	
	  // remove subscription by removing the listener function
	  function unsubscribe (id) {
	    listeners[id] = undefined;
	  }
	
	  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
	}
	
	module.exports = createBroadcast;


/***/ },
/* 478 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(480);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ },
/* 480 */
/***/ function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
	var isBrowser = typeof window !== 'undefined';
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (isBrowser) {
	        if (!this.props.container) {
	          this.container = document.createElement('div');
	          document.body.appendChild(this.container);
	        } else {
	          this.container = this.props.container;
	        }
	        this.renderLayer();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!useCreatePortal) {
	        _reactDom2.default.unmountComponentAtNode(this.container);
	      }
	      if (!this.props.container) {
	        document.body.removeChild(this.container);
	      }
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      if (!useCreatePortal) {
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (useCreatePortal) {
	        return _reactDom2.default.createPortal(this.props.children, this.container);
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node, // eslint-disable-line
	  container: _propTypes2.default.object // eslint-disable-line
	};
	
	exports.default = Portal;

/***/ },
/* 482 */
[914, 484, 486, 483, 209],
/* 483 */
[915, 488, 209],
/* 484 */
[916, 487, 485],
/* 485 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 486 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 487 */
3,
/* 488 */
149,
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(60);
	
	var _Router = __webpack_require__(134);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(60);
	
	var _Router = __webpack_require__(134);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(["hashbang", "noslash", "slash"]),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(504);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(211);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(210);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref["aria-current"],
	      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);
	
	  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;
	
	  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	
	  return _react2.default.createElement(_Route2.default, {
	    path: escapedPath,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(" ") : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        "aria-current": isActive && ariaCurrent || null
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  "aria-current": _propTypes2.default.oneOf(["page", "step", "location", "date", "time", "true"])
	};
	
	NavLink.defaultProps = {
	  activeClassName: "active",
	  "aria-current": "page"
	};
	
	exports.default = NavLink;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(505);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(506);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(507);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(508);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _generatePath = __webpack_require__(213);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(136);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(n){return n&&"object"==typeof n&&"default"in n?n.default:n}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(500)),valueEqual=_interopDefault(__webpack_require__(503));__webpack_require__(502);var invariant=_interopDefault(__webpack_require__(501));function _extends(){return(_extends=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(n[a]=e[a])}return n}).apply(this,arguments)}function addLeadingSlash(n){return"/"===n.charAt(0)?n:"/"+n}function stripLeadingSlash(n){return"/"===n.charAt(0)?n.substr(1):n}function hasBasename(n,t){return new RegExp("^"+t+"(\\/|\\?|#|$)","i").test(n)}function stripBasename(n,t){return hasBasename(n,t)?n.substr(t.length):n}function stripTrailingSlash(n){return"/"===n.charAt(n.length-1)?n.slice(0,-1):n}function parsePath(n){var t=n||"/",e="",a="",o=t.indexOf("#");-1!==o&&(a=t.substr(o),t=t.substr(0,o));var r=t.indexOf("?");return-1!==r&&(e=t.substr(r),t=t.substr(0,r)),{pathname:t,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(n){var t=n.pathname,e=n.search,a=n.hash,o=t||"/";return e&&"?"!==e&&(o+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(o+="#"===a.charAt(0)?a:"#"+a),o}function createLocation(n,t,e,a){var o;"string"==typeof n?(o=parsePath(n)).state=t:(void 0===(o=_extends({},n)).pathname&&(o.pathname=""),o.search?"?"!==o.search.charAt(0)&&(o.search="?"+o.search):o.search="",o.hash?"#"!==o.hash.charAt(0)&&(o.hash="#"+o.hash):o.hash="",void 0!==t&&void 0===o.state&&(o.state=t));try{o.pathname=decodeURI(o.pathname)}catch(n){throw n instanceof URIError?new URIError('Pathname "'+o.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):n}return e&&(o.key=e),a?o.pathname?"/"!==o.pathname.charAt(0)&&(o.pathname=resolvePathname(o.pathname,a.pathname)):o.pathname=a.pathname:o.pathname||(o.pathname="/"),o}function locationsAreEqual(n,t){return n.pathname===t.pathname&&n.search===t.search&&n.hash===t.hash&&n.key===t.key&&valueEqual(n.state,t.state)}function createTransitionManager(){var r=null;var a=[];return{setPrompt:function(n){return r=n,function(){r===n&&(r=null)}},confirmTransitionTo:function(n,t,e,a){if(null!=r){var o="function"==typeof r?r(n,t):r;"string"==typeof o?"function"==typeof e?e(o,a):a(!0):a(!1!==o)}else a(!0)},appendListener:function(n){var t=!0;function e(){t&&n.apply(void 0,arguments)}return a.push(e),function(){t=!1,a=a.filter(function(n){return n!==e})}},notifyListeners:function(){for(var n=arguments.length,t=new Array(n),e=0;e<n;e++)t[e]=arguments[e];a.forEach(function(n){return n.apply(void 0,t)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(n,t){t(window.confirm(n))}function supportsHistory(){var n=window.navigator.userAgent;return(-1===n.indexOf("Android 2.")&&-1===n.indexOf("Android 4.0")||-1===n.indexOf("Mobile Safari")||-1!==n.indexOf("Chrome")||-1!==n.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(n){void 0===n.state&&navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(n){return{}}}function createBrowserHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var c=window.history,s=supportsHistory(),t=!supportsPopStateOnHashChange(),e=n,a=e.forceRefresh,h=void 0!==a&&a,o=e.getUserConfirmation,u=void 0===o?getConfirmation:o,r=e.keyLength,i=void 0===r?6:r,f=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"";function l(n){var t=n||{},e=t.key,a=t.state,o=window.location,r=o.pathname+o.search+o.hash;return f&&(r=stripBasename(r,f)),createLocation(r,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(n){_extends(T,n),T.length=c.length,v.notifyListeners(T.location,T.action)}function g(n){isExtraneousPopstateEvent(n)||w(l(n.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(t){if(m)m=!1,p();else{v.confirmTransitionTo(t,"POP",u,function(n){n?p({action:"POP",location:t}):function(n){var t=T.location,e=H.indexOf(t.key);-1===e&&(e=0);var a=H.indexOf(n.key);-1===a&&(a=0);var o=e-a;o&&(m=!0,L(o))}(t)})}}var y=l(getHistoryState()),H=[y.key];function x(n){return f+createPath(n)}function L(n){c.go(n)}var O=0;function E(n){1===(O+=n)&&1===n?(window.addEventListener(PopStateEvent,g),t&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),t&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:c.length,action:"POP",location:y,createHref:x,push:function(n,t){var i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.pushState({key:e,state:a},null,t),h)window.location.href=t;else{var o=H.indexOf(T.location.key),r=H.slice(0,-1===o?0:o+1);r.push(i.key),H=r,p({action:"PUSH",location:i})}else window.location.href=t}})},replace:function(n,t){var r="REPLACE",i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,r,u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.replaceState({key:e,state:a},null,t),h)window.location.replace(t);else{var o=H.indexOf(T.location.key);-1!==o&&(H[o]=i.key),p({action:r,location:i})}else window.location.replace(t)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(n){void 0===n&&(n=!1);var t=v.setPrompt(n);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),t()}},listen:function(n){var t=v.appendListener(n);return E(1),function(){E(-1),t()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(n){return"!"===n.charAt(0)?n:"!/"+stripLeadingSlash(n)},decodePath:function(n){return"!"===n.charAt(0)?n.substr(1):n}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function getHashPath(){var n=window.location.href,t=n.indexOf("#");return-1===t?"":n.substring(t+1)}function pushHashPath(n){window.location.hash=n}function replaceHashPath(n){var t=window.location.href.indexOf("#");window.location.replace(window.location.href.slice(0,0<=t?t:0)+"#"+n)}function createHashHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var t=window.history,e=(supportsGoWithoutReloadUsingHash(),n),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,o=e.hashType,r=void 0===o?"slash":o,c=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"",s=HashPathCoders[r],h=s.encodePath,u=s.decodePath;function f(){var n=u(getHashPath());return c&&(n=stripBasename(n,c)),createLocation(n)}var l=createTransitionManager();function d(n){_extends(E,n),E.length=t.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var n=getHashPath(),t=h(n);if(n!==t)replaceHashPath(t);else{var e=f(),a=E.location;if(!v&&locationsAreEqual(a,e))return;if(p===createPath(e))return;p=null,function(t){if(v)v=!1,d();else{l.confirmTransitionTo(t,"POP",i,function(n){n?d({action:"POP",location:t}):function(n){var t=E.location,e=y.lastIndexOf(createPath(t));-1===e&&(e=0);var a=y.lastIndexOf(createPath(n));-1===a&&(a=0);var o=e-a;o&&(v=!0,H(o))}(t)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(n){t.go(n)}var x=0;function L(n){1===(x+=n)&&1===n?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:t.length,action:"POP",location:w,createHref:function(n){return"#"+h(c+createPath(n))},push:function(n,t){var r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,"PUSH",i,function(n){if(n){var t=createPath(r),e=h(c+t);if(getHashPath()!==e){p=t,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),o=y.slice(0,-1===a?0:a+1);o.push(t),y=o,d({action:"PUSH",location:r})}else d()}})},replace:function(n,t){var o="REPLACE",r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,o,i,function(n){if(n){var t=createPath(r),e=h(c+t);getHashPath()!==e&&(p=t,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=t),d({action:o,location:r})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(n){void 0===n&&(n=!1);var t=l.setPrompt(n);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),t()}},listen:function(n){var t=l.appendListener(n);return L(1),function(){L(-1),t()}}};return E}function clamp(n,t,e){return Math.min(Math.max(n,t),e)}function createMemoryHistory(n){void 0===n&&(n={});var t=n,o=t.getUserConfirmation,e=t.initialEntries,a=void 0===e?["/"]:e,r=t.initialIndex,i=void 0===r?0:r,c=t.keyLength,s=void 0===c?6:c,h=createTransitionManager();function u(n){_extends(g,n),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,s)}var l=clamp(i,0,a.length-1),d=a.map(function(n){return createLocation(n,void 0,"string"==typeof n?f():n.key||f())}),v=createPath;function p(n){var t=clamp(g.index+n,0,g.entries.length-1),e=g.entries[t];h.confirmTransitionTo(e,"POP",o,function(n){n?u({action:"POP",location:e,index:t}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(n,t){var a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,"PUSH",o,function(n){if(n){var t=g.index+1,e=g.entries.slice(0);e.length>t?e.splice(t,e.length-t,a):e.push(a),u({action:"PUSH",location:a,index:t,entries:e})}})},replace:function(n,t){var e="REPLACE",a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,e,o,function(n){n&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(n){var t=g.index+n;return 0<=t&&t<g.entries.length},block:function(n){return void 0===n&&(n=!1),h.setPrompt(n)},listen:function(n){return h.appendListener(n)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 500 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 503 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(60);
	
	var _Router = __webpack_require__(135);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(60);
	
	var _generatePath = __webpack_require__(213);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(60);
	
	var _Router = __webpack_require__(135);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(46);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(136);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 509 */
431,
/* 510 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(509);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(212);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(511);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(621).enable();
	  window.Promise = __webpack_require__(620);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(623);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(619);


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	            value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(71);
	
	var _HomePage = __webpack_require__(535);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _DesignerPage = __webpack_require__(533);
	
	var _DesignerPage2 = _interopRequireDefault(_DesignerPage);
	
	var _AllStoresPage = __webpack_require__(528);
	
	var _AllStoresPage2 = _interopRequireDefault(_AllStoresPage);
	
	var _AllArtistPage = __webpack_require__(527);
	
	var _AllArtistPage2 = _interopRequireDefault(_AllArtistPage);
	
	var _StorePage = __webpack_require__(545);
	
	var _StorePage2 = _interopRequireDefault(_StorePage);
	
	var _SubmitDesignPage = __webpack_require__(546);
	
	var _SubmitDesignPage2 = _interopRequireDefault(_SubmitDesignPage);
	
	var _AddSubProductPage = __webpack_require__(561);
	
	var _AddSubProductPage2 = _interopRequireDefault(_AddSubProductPage);
	
	var _LogoutPage = __webpack_require__(536);
	
	var _LogoutPage2 = _interopRequireDefault(_LogoutPage);
	
	var _AccountVerificationPage = __webpack_require__(526);
	
	var _AccountVerificationPage2 = _interopRequireDefault(_AccountVerificationPage);
	
	var _ChangePasswordPage = __webpack_require__(531);
	
	var _ChangePasswordPage2 = _interopRequireDefault(_ChangePasswordPage);
	
	var _DesignerDashboardPage = __webpack_require__(532);
	
	var _DesignerDashboardPage2 = _interopRequireDefault(_DesignerDashboardPage);
	
	var _DiscountedProductsPage = __webpack_require__(534);
	
	var _DiscountedProductsPage2 = _interopRequireDefault(_DiscountedProductsPage);
	
	var _ProductDetailPage = __webpack_require__(540);
	
	var _ProductDetailPage2 = _interopRequireDefault(_ProductDetailPage);
	
	var _OrdersDashboardPage = __webpack_require__(549);
	
	var _OrdersDashboardPage2 = _interopRequireDefault(_OrdersDashboardPage);
	
	var _MyOrdersPage = __webpack_require__(538);
	
	var _MyOrdersPage2 = _interopRequireDefault(_MyOrdersPage);
	
	var _RedeemHistoryPage = __webpack_require__(543);
	
	var _RedeemHistoryPage2 = _interopRequireDefault(_RedeemHistoryPage);
	
	var _ProductsDashboardPage = __webpack_require__(550);
	
	var _ProductsDashboardPage2 = _interopRequireDefault(_ProductsDashboardPage);
	
	var _UserSettingsPage = __webpack_require__(547);
	
	var _UserSettingsPage2 = _interopRequireDefault(_UserSettingsPage);
	
	var _OrderSettingsPage = __webpack_require__(539);
	
	var _OrderSettingsPage2 = _interopRequireDefault(_OrderSettingsPage);
	
	var _ProductsByTagPage = __webpack_require__(541);
	
	var _ProductsByTagPage2 = _interopRequireDefault(_ProductsByTagPage);
	
	var _ProductsByTypePage = __webpack_require__(542);
	
	var _ProductsByTypePage2 = _interopRequireDefault(_ProductsByTypePage);
	
	var _ = __webpack_require__(524);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(523);
	
	var _4 = _interopRequireDefault(_3);
	
	var _AnalyticsOptOutPage = __webpack_require__(529);
	
	var _AnalyticsOptOutPage2 = _interopRequireDefault(_AnalyticsOptOutPage);
	
	var _AgreementsPage = __webpack_require__(557);
	
	var _AgreementsPage2 = _interopRequireDefault(_AgreementsPage);
	
	var _HowToMakeMoney = __webpack_require__(560);
	
	var _HowToMakeMoney2 = _interopRequireDefault(_HowToMakeMoney);
	
	var _HowMuchCanIMake = __webpack_require__(559);
	
	var _HowMuchCanIMake2 = _interopRequireDefault(_HowMuchCanIMake);
	
	var _FAQ = __webpack_require__(558);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	var _DashainFrame = __webpack_require__(554);
	
	var _DashainFrame2 = _interopRequireDefault(_DashainFrame);
	
	var _BuyOneDonateOne = __webpack_require__(216);
	
	var _BuyOneDonateOne2 = _interopRequireDefault(_BuyOneDonateOne);
	
	var _StockDashboardPage = __webpack_require__(551);
	
	var _StockDashboardPage2 = _interopRequireDefault(_StockDashboardPage);
	
	var _SearchResultPage = __webpack_require__(544);
	
	var _SearchResultPage2 = _interopRequireDefault(_SearchResultPage);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _MusicPlaqueMaker = __webpack_require__(537);
	
	var _MusicPlaqueMaker2 = _interopRequireDefault(_MusicPlaqueMaker);
	
	var _PhotoFramePage = __webpack_require__(562);
	
	var _PhotoFramePage2 = _interopRequireDefault(_PhotoFramePage);
	
	var _ChetanCamper = __webpack_require__(552);
	
	var _ChetanCamper2 = _interopRequireDefault(_ChetanCamper);
	
	var _CodersCampaign = __webpack_require__(553);
	
	var _CodersCampaign2 = _interopRequireDefault(_CodersCampaign);
	
	var _NepalThemeMerch = __webpack_require__(556);
	
	var _NepalThemeMerch2 = _interopRequireDefault(_NepalThemeMerch);
	
	var _CheckoutPage = __webpack_require__(215);
	
	var _CheckoutPage2 = _interopRequireDefault(_CheckoutPage);
	
	var _HGADesignCampaign = __webpack_require__(555);
	
	var _HGADesignCampaign2 = _interopRequireDefault(_HGADesignCampaign);
	
	var _AccountDeactivatePage = __webpack_require__(525);
	
	var _AccountDeactivatePage2 = _interopRequireDefault(_AccountDeactivatePage);
	
	var _ArtistRegisterPage = __webpack_require__(530);
	
	var _ArtistRegisterPage2 = _interopRequireDefault(_ArtistRegisterPage);
	
	var _AllUsersDashboardPage = __webpack_require__(548);
	
	var _AllUsersDashboardPage2 = _interopRequireDefault(_AllUsersDashboardPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRODUCT_URLS = Object.keys(_AppConstants2.default.PRODUCT_TYPES).map(function (k) {
	            return _AppConstants2.default.PRODUCT_TYPES[k].url;
	}).join("|");
	
	var AppRouter = function AppRouter() {
	            _AppUtil2.default.scrollToTop();
	            return _react2.default.createElement(
	                        _reactRouterDom.Switch,
	                        null,
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _HomePage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/logout', component: _LogoutPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/user/change-password/:token', component: _ChangePasswordPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/user/verify/:token', component: _AccountVerificationPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/designer/:userId/dashboard', component: _DesignerDashboardPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/designer/dashboard', component: _DesignerDashboardPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/designer/:userId/coupons', component: _DiscountedProductsPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/designer/coupons', component: _DiscountedProductsPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/designer/:designerName/:userId', component: _DesignerPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/photographer/:designerName/:userId', component: _DesignerPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/fashion-designer/:designerName/:userId', component: _DesignerPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/store/:storeName', component: _StorePage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/artist/signup', component: _ArtistRegisterPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/artist/all', component: _AllArtistPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/artist/browse/:prefix', component: _AllArtistPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/stores/all', component: _AllStoresPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/stores/:storeName', component: _StorePage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/design/submit', component: _SubmitDesignPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/custom-order/music-plaque", component: _MusicPlaqueMaker2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/custom-order/photo-frame", component: _PhotoFramePage2.default }),
	                        '//Added name in the url for SEO purpose only',
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/(" + PRODUCT_URLS + ")/edit/:name/:productId", component: _ProductDetailPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/(" + PRODUCT_URLS + ")/addSub/:name/:productId", component: _AddSubProductPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: "/(" + PRODUCT_URLS + ")/:name/:productId", component: _ProductDetailPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: "/shop/:name/:productId", component: _ProductDetailPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/order/dashboard', component: _OrdersDashboardPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/orders', component: _MyOrdersPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/orders/checkout', component: _CheckoutPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/order/:orderId/settings', component: _OrderSettingsPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/settings', component: _UserSettingsPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/:userId/settings', component: _UserSettingsPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/product/dashboard', component: _ProductsDashboardPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/tag/:tagName', component: _ProductsByTagPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/shop/(" + PRODUCT_URLS + ")", component: _ProductsByTypePage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/search', component: _SearchResultPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/search/:keyword', component: _SearchResultPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/withdrawals', component: _RedeemHistoryPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/401', component: _4.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/404', component: _2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/terms-of-use-and-privacy-policy', component: _AgreementsPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/how-to-make-money', component: _HowToMakeMoney2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/how-much-can-i-make', component: _HowMuchCanIMake2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/faq', component: _FAQ2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/analytics/optout', component: _AnalyticsOptOutPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/stock/dashboard', component: _StockDashboardPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/stock/:stockOwner', component: _StockDashboardPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/dashain/photoframe', component: _DashainFrame2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/coders-merch', component: _CodersCampaign2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/nepal-merch', component: _NepalThemeMerch2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/chetan-vlog-camper', component: _ChetanCamper2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/dashain/buyonedonateone', component: _BuyOneDonateOne2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/dashain/buy-one-donate-one', component: _BuyOneDonateOne2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/high-ground-adventure-design', component: _HGADesignCampaign2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/deactivate', component: _AccountDeactivatePage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/deactivate/:userId', component: _AccountDeactivatePage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/all-users/dashboard', component: _AllUsersDashboardPage2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { component: _2.default })
	            );
	};
	
	exports.default = AppRouter;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _DesignerStore = __webpack_require__(91);
	
	var _DesignerStore2 = _interopRequireDefault(_DesignerStore);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _reactTable = __webpack_require__(50);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	var _OrdersList = __webpack_require__(225);
	
	var _OrdersList2 = _interopRequireDefault(_OrdersList);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _PaymentModal = __webpack_require__(576);
	
	var _PaymentModal2 = _interopRequireDefault(_PaymentModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WithdrawStat = (0, _radium2.default)(function (props) {
	
		var redeemRequested = props.redeemRequested;
		var redeemed = props.redeemed;
		var hasRedeemRequest = redeemRequested !== null && redeemRequested > 0;
		var hasRedeemedBefore = redeemed !== null && redeemed > 0;
	
		if (!hasRedeemRequest && !hasRedeemedBefore) return null;
	
		return _react2.default.createElement(
			'span',
			{ style: { fontSize: '160%', display: 'block', textAlign: 'right', color: '#807979', background: 'white', padding: '5px' } },
			hasRedeemRequest && _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(
					'b',
					null,
					'Withdrawal Requested: '
				),
				'Rs. ',
				_AppUtil2.default.formatNumber(redeemRequested),
				' '
			),
			hasRedeemedBefore && _react2.default.createElement(
				'span',
				{ style: { marginLeft: '15px' } },
				_react2.default.createElement(
					'b',
					null,
					'Withdrawn: '
				),
				'Rs. ',
				_AppUtil2.default.formatNumber(redeemed)
			),
			_react2.default.createElement(
				_AppElements.Button,
				{ style: { marginLeft: '15px' }, mui: 'true', href: '/withdrawals' },
				_react2.default.createElement('i', { className: 'fa fa-history', 'aria-hidden': 'true' }),
				' View History'
			)
		);
	});
	
	var Balance = function Balance(props) {
		var currentBalance = props.currentBalance;
		var lockedBalance = props.lockedBalance;
		var productStats = props.productStats;
	
		var _useState = (0, _react.useState)(false),
		    _useState2 = _slicedToArray(_useState, 2),
		    openPaymentModal = _useState2[0],
		    setOpenPaymentModel = _useState2[1];
	
		return _react2.default.createElement(
			'div',
			{ style: props.style },
			_react2.default.createElement('br', null),
			_react2.default.createElement(
				'span',
				{ style: { color: 'gray' } },
				'Your Current Balance'
			),
			_react2.default.createElement('br', null),
			_react2.default.createElement(
				'span',
				null,
				'Rs. ',
				_AppUtil2.default.formatNumber(currentBalance)
			),
			currentBalance > 0 && _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement('br', null),
				openPaymentModal && _react2.default.createElement(_PaymentModal2.default, { productStats: productStats, currentBalance: currentBalance,
					open: openPaymentModal,
					onClose: function onClose() {
						setOpenPaymentModel(false);
					} }),
				_react2.default.createElement(
					_AppElements.Button,
					{ mui: 'true', variant: 'primary', color: 'raised',
						onClick: function onClick() {
							return setOpenPaymentModel(true);
						}
					},
					'Withdraw'
				)
			),
			_react2.default.createElement('hr', null),
			_react2.default.createElement(
				'span',
				{ style: { color: 'gray' } },
				_react2.default.createElement('i', { className: 'fa fa-lock', 'aria-hidden': 'true' }),
				' Locked Balance'
			),
			_react2.default.createElement('br', null),
			_react2.default.createElement(
				'span',
				null,
				'Rs. ',
				_AppUtil2.default.formatNumber(lockedBalance)
			)
		);
	};
	
	var SalesTargetList = (0, _radium2.default)(function (props) {
	
		var completedProductStats = props.completedProductStats;
	
		var productCol = { Header: 'Product', accessor: 'currentTarget.product', Cell: function Cell(props) {
				var product = props.value;
				var detailUrl = _AppUtil2.default.getProductURL(product);
	
				return _react2.default.createElement(
					_AppElements.A,
					{ href: detailUrl },
					_AppUtil2.default.getProductTitle(product)
				);
			} };
	
		var targetColumns = [{ Header: 'Quantity Sold', accessor: 'targetAchieved',
			Cell: function Cell(props) {
				return _AppUtil2.default.formatNumber(props.value);
			} }, { Header: 'Commission', accessor: 'currentTarget',
			Cell: function Cell(props) {
				var commissionAmount = props.value.commissionPct * props.value.product.margin / 100.0;
				return "Rs. " + _AppUtil2.default.formatNumber(commissionAmount);
			} }, { Header: 'Amount Earned', accessor: 'amountEarned', Cell: function Cell(props) {
				var productStat = props.original;
	
				var amount = "Rs. " + _AppUtil2.default.formatNumber(props.value);
	
				if (productStat.targetAchieved < productStat.currentTarget.salesTarget) return _react2.default.createElement(
					'span',
					{ style: { color: 'gray' } },
					_react2.default.createElement('i', { className: 'fa fa-lock', 'aria-hidden': 'true' }),
					' ',
					amount
				);else return amount;
			} }];
	
		var columns = [productCol].concat(targetColumns);
	
		var showLoading = completedProductStats ? false : true;
	
		var style = [];
	
		if (props.style) style.push(props.style);
	
		return _react2.default.createElement(
			'div',
			{ style: style },
			_react2.default.createElement(
				'h2',
				null,
				'Your Earnings Info ',
				_react2.default.createElement('i', { className: 'fa fa-money', 'aria-hidden': 'true' })
			),
			_react2.default.createElement(_reactTable2.default, { data: completedProductStats ? completedProductStats : [], columns: columns, minRows: 5,
				noDataText: 'You have not made any sales.', loading: showLoading })
		);
	});
	
	var DesignerDashboardContainer = function (_React$Component) {
		_inherits(DesignerDashboardContainer, _React$Component);
	
		function DesignerDashboardContainer() {
			_classCallCheck(this, DesignerDashboardContainer);
	
			return _possibleConstructorReturn(this, (DesignerDashboardContainer.__proto__ || Object.getPrototypeOf(DesignerDashboardContainer)).apply(this, arguments));
		}
	
		_createClass(DesignerDashboardContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.state.session === null) {
					_Dispatcher2.default.dispatchAlertWithAction(_AppConstants2.default.LOGIN_TO_CONTINUE_MSG, "WARN");
					return;
				}
	
				this.loadDashboardData();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState, snapshot) {
				if (prevState.session === null && this.state.session !== null) {
					this.loadDashboardData();
				}
			}
		}, {
			key: 'loadDashboardData',
			value: function loadDashboardData() {
				var userId = this.props.userId;
	
				if (this.state.balance === null) _HttpService2.default.getDesignerBalance(userId);
	
				if (this.state.allPendingOrders === null) _HttpService2.default.getDesignerPendingOrders(userId);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.session === null) return null;
	
				var currentBalance = this.state.balance ? this.state.balance.unlockedBalance : 0;
				var lockedBalance = this.state.balance ? this.state.balance.lockedBalance : 0;
	
				var redeemRequested = this.state.balance ? this.state.balance.redeemRequestedAmount : null;
				var redeemed = this.state.balance ? this.state.balance.redeemedAmount : null;
	
				return _react2.default.createElement(
					'div',
					{ style: { margin: '0', padding: '10px 0' } },
					_react2.default.createElement(WithdrawStat, { redeemRequested: redeemRequested, redeemed: redeemed }),
					_react2.default.createElement(
						'div',
						{ className: 'mainContainer' },
						_react2.default.createElement(
							'div',
							{ className: 'flexRow' },
							_react2.default.createElement(Balance, { currentBalance: currentBalance,
								lockedBalance: lockedBalance,
								productStats: this.state.balance ? this.state.balance.productStats : [],
								style: { flexGrow: '1', padding: '10px', textAlign: 'center', fontSize: '200%', alignSelf: 'center' } }),
							_react2.default.createElement(SalesTargetList, { style: { flexGrow: "3", '@media (max-width: 770px)': { flexGrow: '1', width: '100%' } },
								completedProductStats: this.state.balance ? this.state.balance.productStats : null })
						),
						_react2.default.createElement('hr', null),
						_react2.default.createElement(_OrdersList2.default, { orders: this.state.allPendingOrders,
							title: 'Your Pending Orders', showPaymentOption: false, showProductInfo: true })
					)
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_DesignerStore2.default, _SessionStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState) {
				return {
					balance: _DesignerStore2.default.getDesignerBalance(),
					session: _SessionStore2.default.getCurrentSession(),
					allPendingOrders: _DesignerStore2.default.getAllPendingOrders()
				};
			}
		}]);
	
		return DesignerDashboardContainer;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(_utils.Container.create(DesignerDashboardContainer));

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(15);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _reactRouterDom = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogoutContainer = function (_React$Component) {
		_inherits(LogoutContainer, _React$Component);
	
		function LogoutContainer() {
			_classCallCheck(this, LogoutContainer);
	
			return _possibleConstructorReturn(this, (LogoutContainer.__proto__ || Object.getPrototypeOf(LogoutContainer)).apply(this, arguments));
		}
	
		_createClass(LogoutContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				_HttpService2.default.logout();
			}
		}, {
			key: 'render',
			value: function render() {
				var currentSession = this.state.session;
	
				if (currentSession !== null) {
					return null;
				}
	
				return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/', push: true });
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_SessionStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState) {
				var newState = {
					session: _SessionStore2.default.getCurrentSession()
				};
				return newState;
			}
		}]);
	
		return LogoutContainer;
	}(_react2.default.Component);
	
	exports.default = _utils.Container.create(LogoutContainer);

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _OrderListContainer = __webpack_require__(137);
	
	var _OrderListContainer2 = _interopRequireDefault(_OrderListContainer);
	
	var _OrderStore = __webpack_require__(61);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	var _AdminDashboardTabs = __webpack_require__(95);
	
	var _AdminDashboardTabs2 = _interopRequireDefault(_AdminDashboardTabs);
	
	var _reactSelect = __webpack_require__(144);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
		statContainer: { justifyContent: 'space-around', margin: '20px' },
		rowBox: { margin: "10px", cursor: 'pointer', flexGrow: '1',
			textAlign: 'center', display: 'flex', flexDirection: 'column', background: '#eee',
			padding: '10px',
			':hover': { background: '#e0dede', color: 'white' },
			'@media (max-width: 700px)': { flex: '0 0 auto', padding: '0 5px' }
		}
	};
	
	var ORDER_STATE = _AppConstants2.default.ORDER_STATE;
	
	var ORDER_STATES_DROPDOWN = [ORDER_STATE.ORDER_PLACED, ORDER_STATE.ORDER_CONFIRMED, ORDER_STATE.SHIPPING, ORDER_STATE.DELIVERED, ORDER_STATE.CANCELLED, ORDER_STATE.DELIVERED_CLOSED];
	
	var EachBox = function (_React$Component) {
		_inherits(EachBox, _React$Component);
	
		function EachBox() {
			_classCallCheck(this, EachBox);
	
			return _possibleConstructorReturn(this, (EachBox.__proto__ || Object.getPrototypeOf(EachBox)).apply(this, arguments));
		}
	
		_createClass(EachBox, [{
			key: 'onBoxClick',
			value: function onBoxClick() {
				this.props.onClick(this.props.orderState);
			}
		}, {
			key: 'render',
			value: function render() {
				var title = this.props.title;
				var value = this.props.value;
	
				var boxStyle = [styles.rowBox];
	
				if (this.props.style) boxStyle.push(this.props.style);
	
				var valueStyle = [{ margin: '0px', color: '#555', fontSize: '125%' }];
	
				if (this.props.highlightValue && value > 0) valueStyle.push({ color: '#f89319', fontWeight: 'bolder' });
	
				return _react2.default.createElement(
					'span',
					{ style: boxStyle, onClick: this.onBoxClick.bind(this) },
					_react2.default.createElement(
						'span',
						{ style: { margin: '5px', color: '#999', fontSize: '120%' } },
						title
					),
					_react2.default.createElement(
						'span',
						{ style: valueStyle },
						value
					)
				);
			}
		}]);
	
		return EachBox;
	}(_react2.default.Component);
	
	EachBox = (0, _radium2.default)(EachBox);
	
	var LAST_FETCHED_ORDER = "last_fetched_order";
	
	var OrderDashboardContainer = function (_React$Component2) {
		_inherits(OrderDashboardContainer, _React$Component2);
	
		_createClass(OrderDashboardContainer, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_OrderStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState) {
				return {
					orderStat: _OrderStore2.default.getOrderStat()
				};
			}
		}]);
	
		function OrderDashboardContainer(props) {
			_classCallCheck(this, OrderDashboardContainer);
	
			var _this2 = _possibleConstructorReturn(this, (OrderDashboardContainer.__proto__ || Object.getPrototypeOf(OrderDashboardContainer)).call(this, props));
	
			var currentSession = _SessionStore2.default.getCurrentSession();
			var defaultOrderType = _AppConstants2.default.ORDER_STATE.ORDER_PLACED.value;
	
			if (currentSession && currentSession.user.permissions && currentSession.user.permissions.indexOf("shipping_orders_only") >= 0) defaultOrderType = _AppConstants2.default.ORDER_STATE.SHIPPING.value;
	
			if (_CacheService2.default.get(LAST_FETCHED_ORDER)) defaultOrderType = _CacheService2.default.get(LAST_FETCHED_ORDER);
	
			_this2.state = { orderState: defaultOrderType };
			_this2.onOrderStateChange = _this2.onOrderStateChange.bind(_this2);
			return _this2;
		}
	
		_createClass(OrderDashboardContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var session = _SessionStore2.default.getCurrentSession();
	
				if (session) {
					var user = session.user;
					var userType = user.userType;
					if (userType === _AppConstants2.default.USER_TYPE.ADMIN || userType === _AppConstants2.default.USER_TYPE.SALES) _HttpService2.default.getOrderStat();
				}
			}
		}, {
			key: 'onOrderStateChange',
			value: function onOrderStateChange(newState) {
				if (newState) {
					_CacheService2.default.save(LAST_FETCHED_ORDER, newState.value);
					this.setState({ orderState: newState.value });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var orderStat = this.state.orderStat;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							'Order Dashboard | Seto Canvas'
						)
					),
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(
						_AdminDashboardTabs2.default,
						{ active: 'orders' },
						orderStat && _react2.default.createElement(
							'div',
							{ style: { margin: '20px' } },
							_react2.default.createElement(
								'div',
								{ className: 'flexRow', style: styles.statContainer },
								_react2.default.createElement(EachBox, { title: 'Order Placed', highlightValue: true, value: orderStat.placed || 0, orderState: ORDER_STATE.ORDER_PLACED, onClick: this.onOrderStateChange }),
								_react2.default.createElement(EachBox, { title: 'Order Confirmed', value: orderStat.confirmed || 0, orderState: ORDER_STATE.ORDER_CONFIRMED, onClick: this.onOrderStateChange }),
								_react2.default.createElement(EachBox, { title: 'Order Shipping', value: orderStat.shipping || 0, orderState: ORDER_STATE.SHIPPING, onClick: this.onOrderStateChange }),
								_react2.default.createElement(EachBox, { title: 'Order Delivered', value: orderStat.delivered || 0, orderState: ORDER_STATE.DELIVERED, onClick: this.onOrderStateChange }),
								_react2.default.createElement(EachBox, { title: 'Order Cancelled', value: orderStat.cancelled || 0, orderState: ORDER_STATE.CANCELLED, onClick: this.onOrderStateChange })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'mainContainer' },
							_react2.default.createElement(
								'div',
								{ style: { width: '40%', '@media (max-width: 770px)': { width: '100%' } } },
								_react2.default.createElement(
									'h3',
									{ style: { margin: '0 10px 0 0' } },
									'Order Type'
								),
								_react2.default.createElement(_reactSelect2.default, { onChange: this.onOrderStateChange, value: this.state.orderState,
									options: ORDER_STATES_DROPDOWN, clearable: false,
									style: { flexGrow: '1', margin: '0' } })
							),
							_react2.default.createElement(_OrderListContainer2.default, { showPaymentOption: false, orderState: this.state.orderState, showProductInfo: true, changeOrderState: true, showExportAsCSV: true })
						)
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return OrderDashboardContainer;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(_utils.Container.create(OrderDashboardContainer));

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _OrderStore = __webpack_require__(61);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DELIVERY_TYPE = _AppConstants2.default.DELIVERY_TYPE;
	var DELIVERY_LOCATION_TYPE = _AppConstants2.default.DELIVERY_LOCATION_TYPE;
	
	var OUTSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY;
	var INSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.INSIDE_KTM_VALLEY;
	
	var INSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.INSIDE_RING_ROAD;
	var OUTSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD;
	
	var OrderSettingsForm = function (_React$Component) {
		_inherits(OrderSettingsForm, _React$Component);
	
		function OrderSettingsForm(props) {
			_classCallCheck(this, OrderSettingsForm);
	
			var _this = _possibleConstructorReturn(this, (OrderSettingsForm.__proto__ || Object.getPrototypeOf(OrderSettingsForm)).call(this, props));
	
			var order = props.order;
			_this.INIT_VALUES = { productPrice: order.productPrice,
				productMargin: order.productMargin,
				quantity: order.quantity,
				productSizes: order.productSizes,
				locationType: order.locationType,
				deliveryType: order.deliveryType,
				phone: order.phone,
				orderedProductImage: order.orderedProductImage,
				streetAddress: order.streetAddress,
				additionalNote: order.additionalNote,
				paid: order.paid === true ? "true" : "false",
				orderMetaData: order.orderMetaData ? JSON.stringify(order.orderMetaData) : '',
				sizeMetaData: order.sizeMetaData ? JSON.stringify(order.sizeMetaData) : ''
			};
	
			_this.handleSubmission = _this.handleSubmission.bind(_this);
			return _this;
		}
	
		_createClass(OrderSettingsForm, [{
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					productPrice: _yup2.default.string().required('Please enter a price.'),
					productMargin: _yup2.default.string().required('Please enter a margin.'),
					quantity: _yup2.default.number().required('Enter a quantity').min(1, "Enter a positive quantity"),
					productSizes: _yup2.default.array().min(1, "Select a preferrable size"),
					locationType: _yup2.default.string().required("Where is customer located?"),
					deliveryType: _yup2.default.string().when('locationType', function (locationType, schema) {
						return locationType === INSIDE_KTM_VALLEY.val ? _yup2.default.string().required("Specify how customer would like to get it delivered.") : _yup2.default.string();
					}),
					phone: _AppUtil2.default.phoneNumberValidation(),
					orderedProductImage: _yup2.default.string().required('Please select an image'),
					streetAddress: _yup2.default.string().required('Please enter a street address.')
				});
			}
		}, {
			key: 'handleSubmission',
			value: function handleSubmission(values, _ref) {
				var setSubmitting = _ref.setSubmitting;
	
				var order = this.props.order;
	
				var updateReq = Object.assign({}, values);
				updateReq.paid = values.paid === "true";
				updateReq.orderMetaData = values.orderMetaData ? JSON.parse(values.orderMetaData) : null;
				updateReq.sizeMetaData = values.sizeMetaData ? JSON.parse(values.sizeMetaData) : null;
	
				_HttpService2.default.updateOrder(order.orderId, updateReq, function (success) {
					setSubmitting(false);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var order = this.props.order;
				var productSizes = _AppUtil2.default.getProductSizeOptions(order.product);
				var hasOutsideRingroadCharge = order.product.outsideRingRoadCharge || false;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'h3',
						null,
						_react2.default.createElement(
							_AppElements.A,
							{ href: '/order/dashboard' },
							'Go Back to Orders'
						)
					),
					_react2.default.createElement(
						'h1',
						null,
						'Order Id: ',
						order.orderId
					),
					_react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: this.INIT_VALUES, onSubmit: this.handleSubmission,
						validationSchema: this.validationScheme, render: function render(_ref2) {
							var values = _ref2.values,
							    setFieldValue = _ref2.setFieldValue,
							    isSubmitting = _ref2.isSubmitting;
	
							var submitBtn = "Update";
	
							if (isSubmitting === true) submitBtn = _react2.default.createElement(
								'span',
								null,
								'Updating ',
								_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
							);
	
							var productImages = order.product.productImages.map(function (i) {
								var style = { marginRight: '10px', cursor: 'pointer' };
	
								if (i === values.orderedProductImage) {
									style.opacity = "1.0";
									style.border = "1px solid black";
								} else {
									style.opacity = "0.3";
								}
	
								return _react2.default.createElement('img', { key: "order_" + order.orderId + "_image_" + i, src: i,
									className: 'miniImg', style: style,
									alt: "Ordered Product",
									onClick: function onClick() {
										setFieldValue('orderedProductImage', i);
									} });
							});
	
							return _react2.default.createElement(
								_FormElements.RGForm,
								null,
								_react2.default.createElement(_FormElements.Input, { name: 'productPrice', type: 'text', label: 'Product Price: ' }),
								_react2.default.createElement(_FormElements.Input, { name: 'productMargin', type: 'text', label: 'Product Margin: ' }),
								_react2.default.createElement(_FormElements.Input, { label: 'Quantity: ', name: 'quantity', type: 'text' }),
								_react2.default.createElement(
									'div',
									{ className: 'flexRow' },
									_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'paid', value: "true",
										label: _react2.default.createElement(
											'span',
											{ style: { color: '#596161' } },
											'Paid'
										),
										checked: values.paid === "true" }),
									_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'paid', value: "false",
										label: _react2.default.createElement(
											'span',
											{ style: { color: '#596161' } },
											'UnPaid'
										),
										checked: values.paid === "false" })
								),
								_react2.default.createElement(_FormElements.ComboBox, { name: 'productSizes', value: values.productSizes,
									options: productSizes, placeholder: 'Select Size', multi: true }),
								_react2.default.createElement(
									'h2',
									{ style: { color: 'gray' } },
									'Delivery Detail'
								),
								_react2.default.createElement(
									'label',
									{ style: { fontSize: '12px', color: 'rgba(0,0,0,.54)', marginBottom: '10px' } },
									'Where are you located?'
								),
								_react2.default.createElement(
									'div',
									{ className: 'flexColumn' },
									!hasOutsideRingroadCharge && _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'locationType', value: INSIDE_KTM_VALLEY.val,
										label: _react2.default.createElement(
											'span',
											{ style: { color: '#596161' } },
											INSIDE_KTM_VALLEY.label
										),
										checked: values.locationType === INSIDE_KTM_VALLEY.val
									}),
									hasOutsideRingroadCharge && _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'locationType', value: INSIDE_RING_ROAD.val,
										label: _react2.default.createElement(
											'span',
											{ style: { color: '#596161' } },
											INSIDE_RING_ROAD.label
										),
										checked: values.locationType === INSIDE_RING_ROAD.val
									}),
									hasOutsideRingroadCharge && _react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'locationType', value: OUTSIDE_RING_ROAD.val,
										label: _react2.default.createElement(
											'span',
											{ style: { color: '#596161' } },
											OUTSIDE_RING_ROAD.label
										),
										checked: values.locationType === OUTSIDE_RING_ROAD.val
									}),
									_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'locationType', value: OUTSIDE_KTM_VALLEY.val,
										label: _react2.default.createElement(
											'span',
											{ style: { color: '#596161' } },
											OUTSIDE_KTM_VALLEY.label
										),
										checked: values.locationType === OUTSIDE_KTM_VALLEY.val
									})
								),
								_react2.default.createElement(_FormElements.Input, { label: 'Phone: ', name: 'phone', type: 'text', placeholder: 'E.g. 9862441133' }),
								_react2.default.createElement(_FormElements.Input, { label: 'Street Address: ', name: 'streetAddress', type: 'text', placeholder: 'E.g. GopiKrishna Nagar, Chabahil, KTM' }),
								_react2.default.createElement(_FormElements.TextArea, { placeholder: "Extra note for your delivery or any landmark detail (Optional)", name: 'additionalNote', rows: '3' }),
								(values.locationType === INSIDE_KTM_VALLEY.val || values.locationType === OUTSIDE_RING_ROAD.val || values.locationType === INSIDE_RING_ROAD.val) && _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'h2',
										{ style: { color: 'gray' } },
										'Delivery Option'
									),
									_react2.default.createElement(
										'div',
										{ className: 'flexRow' },
										_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'deliveryType', value: DELIVERY_TYPE.REGULAR.val,
											label: DELIVERY_TYPE.REGULAR.label,
											checked: values.deliveryType === DELIVERY_TYPE.REGULAR.val }),
										_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'deliveryType', value: DELIVERY_TYPE.IMMEDIATE.val,
											label: DELIVERY_TYPE.IMMEDIATE.label,
											checked: values.deliveryType === DELIVERY_TYPE.IMMEDIATE.val })
									)
								),
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'h2',
										{ style: { color: 'gray' } },
										'Order MetaData'
									),
									_react2.default.createElement(_FormElements.TextArea, { placeholder: "Order MetaData json string", name: 'orderMetaData', rows: '3' })
								),
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'h2',
										{ style: { color: 'gray' } },
										'Size MetaData'
									),
									_react2.default.createElement(_FormElements.TextArea, { placeholder: "Size meta data json string", name: 'sizeMetaData', rows: '3' })
								),
								_react2.default.createElement(_FormElements.Input, { name: 'orderedProductImage', type: 'hidden', disabled: true }),
								_react2.default.createElement(
									'div',
									{ className: 'flexRow' },
									productImages
								),
								_react2.default.createElement(
									_FormElements.SubmitButton,
									{ style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting },
									submitBtn
								)
							);
						} })
				);
			}
		}]);
	
		return OrderSettingsForm;
	}(_react2.default.Component);
	
	var OrderSettingsContainer = function (_React$Component2) {
		_inherits(OrderSettingsContainer, _React$Component2);
	
		function OrderSettingsContainer() {
			_classCallCheck(this, OrderSettingsContainer);
	
			return _possibleConstructorReturn(this, (OrderSettingsContainer.__proto__ || Object.getPrototypeOf(OrderSettingsContainer)).apply(this, arguments));
		}
	
		_createClass(OrderSettingsContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.state.order === null || !this.state.order.product) {
					_HttpService2.default.getOrder(this.props.orderId);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var order = this.state.order;
	
				if (order === null) return null;
	
				return _react2.default.createElement(
					'div',
					{ className: 'mainContainer', style: { width: '50%', margin: '20px auto',
							'@media (max-width: 500px)': { width: 'auto', padding: '20px', margin: '0' } } },
					_react2.default.createElement(OrderSettingsForm, { order: order })
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_OrderStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState, props) {
				var orderId = props.orderId;
				var newState = {
					order: _OrderStore2.default.getOrder(orderId)
				};
				return newState;
			}
		}]);
	
		return OrderSettingsContainer;
	}(_react2.default.Component);
	
	exports.default = _utils.Container.create((0, _radium2.default)(OrderSettingsContainer), { withProps: true });

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(15);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _ProductDetail = __webpack_require__(589);
	
	var _ProductDetail2 = _interopRequireDefault(_ProductDetail);
	
	var _ProductSettings = __webpack_require__(590);
	
	var _ProductSettings2 = _interopRequireDefault(_ProductSettings);
	
	var _AppElements = __webpack_require__(9);
	
	var _HeaderBanner = __webpack_require__(47);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	var _BuyOneDonateOne = __webpack_require__(216);
	
	var _SuggestedProducts = __webpack_require__(143);
	
	var _SuggestedProducts2 = _interopRequireDefault(_SuggestedProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductDetailContainer = function (_React$Component) {
		_inherits(ProductDetailContainer, _React$Component);
	
		function ProductDetailContainer() {
			_classCallCheck(this, ProductDetailContainer);
	
			return _possibleConstructorReturn(this, (ProductDetailContainer.__proto__ || Object.getPrototypeOf(ProductDetailContainer)).apply(this, arguments));
		}
	
		_createClass(ProductDetailContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var product = this.state.product;
	
				if (product === null) _HttpService2.default.getProduct(this.props.productId);else this.onProductAvailable(product);
	
				_AppUtil2.default.scrollToTop();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState, snapshot) {
				var product = this.state.product;
	
				var productChanged = prevProps.productId !== this.props.productId;
				if (product === null) {
					//check if new product link is clicked or not
					if (productChanged === true) _HttpService2.default.getProduct(this.props.productId);
				} else {
					this.onProductAvailable(product);
				}
	
				if (productChanged === true) _AppUtil2.default.scrollToTop();
			}
	
			/**this fills up product stat and suggested products**/
	
		}, {
			key: 'onProductAvailable',
			value: function onProductAvailable(product) {
				var currentUser = _SessionStore2.default.getCurrentSession() ? _SessionStore2.default.getCurrentSession().user : null;
				var isAuthorized = _AppUtil2.default.isAuthorizedForProduct(currentUser, product);
	
				if (isAuthorized) {
					var productId = product.id;
					if (!_ProductStore2.default.getProductStat(productId)) _HttpService2.default.getProductStat(productId);
				}
	
				if (!_ProductStore2.default.getCreatorProducts(product.creator)) {
					_HttpService2.default.getCreatorProducts(product.creator);
				}
	
				if (this.state.creatorProducts && !this.state.suggestedProducts) _HttpService2.default.getRecentProducts();
			}
		}, {
			key: 'render',
			value: function render() {
				var editMode = this.props.editMode;
	
				var product = this.state.product;
	
				var creatorTitle = null;
	
				if (product) creatorTitle = _react2.default.createElement(
					_AppElements.A,
					{ href: _AppUtil2.default.getDesignerURL(product.creator) },
					'More From ',
					_AppUtil2.default.getCreaterName(product.creator)
				);
	
				return _react2.default.createElement(
					'div',
					{ className: 'mainContainer' },
					!editMode && _react2.default.createElement(_ProductDetail2.default, { product: product,
						productStat: this.state.productStat, selectedImage: this.props.selectedImage }),
					editMode && _react2.default.createElement(_ProductSettings2.default, { product: product }),
					_BuyOneDonateOne.DCUtil.isCampaignActive() && _react2.default.createElement(
						'div',
						{ style: { paddingTop: "30px", marginTop: "30px", borderTop: "1px solid gray" } },
						_react2.default.createElement(_HeaderBanner2.default, { bannerImages: [_BuyOneDonateOne.DCUtil.getDashainCampaignBanner().sort(function () {
								return .5 - Math.random();
							})[0]] })
					),
					product && _react2.default.createElement(_SuggestedProducts2.default, { products: this.state.creatorProducts, filterProduct: product,
						title: creatorTitle, autoplay: false, navigator: 'arrows' }),
					this.state.suggestedProducts && _react2.default.createElement(_SuggestedProducts2.default, { products: this.state.suggestedProducts, filterProduct: product,
						autoplay: true, navigator: 'arrows' })
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_ProductStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState, props) {
				var productId = props.productId;
	
				var product = _ProductStore2.default.getProduct(productId);
				product = product && product.creator ? product : null;
	
				var creatorProducts = product ? _ProductStore2.default.getCreatorProducts(product.creator) : null;
				var recentProducts = _ProductStore2.default.getRecentProducts();
	
				if (product && product.creator && recentProducts) {
					recentProducts = recentProducts.filter(function (p) {
						return p.creator.username !== product.creator.username;
					});
				}
	
				var newState = {
					product: product,
					productStat: _ProductStore2.default.getProductStat(productId),
	
					creatorProducts: creatorProducts,
					suggestedProducts: recentProducts
				};
				return newState;
			}
		}]);
	
		return ProductDetailContainer;
	}(_react2.default.Component);
	
	exports.default = _utils.Container.create(ProductDetailContainer, { withProps: true });

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(15);
	
	var _RedeemStore = __webpack_require__(565);
	
	var _RedeemStore2 = _interopRequireDefault(_RedeemStore);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _RedeemHistoryList = __webpack_require__(578);
	
	var _RedeemHistoryList2 = _interopRequireDefault(_RedeemHistoryList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedeemHistoryContainer = function (_React$Component) {
		_inherits(RedeemHistoryContainer, _React$Component);
	
		function RedeemHistoryContainer() {
			_classCallCheck(this, RedeemHistoryContainer);
	
			return _possibleConstructorReturn(this, (RedeemHistoryContainer.__proto__ || Object.getPrototypeOf(RedeemHistoryContainer)).apply(this, arguments));
		}
	
		_createClass(RedeemHistoryContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.state.redeemHistory === null || this.state.redeemHistory.size === 0) {
					_HttpService2.default.getRedeemHistory();
					return;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'mainContainer' },
					_react2.default.createElement(_RedeemHistoryList2.default, { redeemHistory: this.state.redeemHistory })
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_RedeemStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState) {
				var newState = {
					redeemHistory: _RedeemStore2.default.getReedemHistory()
				};
				return newState;
			}
		}]);
	
		return RedeemHistoryContainer;
	}(_react2.default.Component);
	
	exports.default = _utils.Container.create(RedeemHistoryContainer);

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useUserActiveOrders = undefined;
	
	var _ReduceStoreHook = __webpack_require__(45);
	
	var _ReduceStoreHook2 = _interopRequireDefault(_ReduceStoreHook);
	
	var _OrderStore = __webpack_require__(61);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useUserActiveOrders = exports.useUserActiveOrders = function useUserActiveOrders() {
	    var orders = (0, _ReduceStoreHook2.default)(_OrderStore2.default, function (store) {
	        return store.getUserOrders();
	    }, function () {
	        return _HttpService2.default.getMyOrders();
	    }, []);
	
	    return orders;
	};

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _radium = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(71);
	
	var _reactIntl = __webpack_require__(196);
	
	var _AppRouter = __webpack_require__(514);
	
	var _AppRouter2 = _interopRequireDefault(_AppRouter);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	__webpack_require__(603);
	
	__webpack_require__(611);
	
	__webpack_require__(616);
	
	__webpack_require__(612);
	
	__webpack_require__(608);
	
	__webpack_require__(604);
	
	__webpack_require__(607);
	
	__webpack_require__(606);
	
	__webpack_require__(601);
	
	__webpack_require__(605);
	
	__webpack_require__(617);
	
	__webpack_require__(602);
	
	__webpack_require__(618);
	
	__webpack_require__(615);
	
	__webpack_require__(613);
	
	__webpack_require__(614);
	
	var _reactSticky = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*global FB*/
	
	
	var appStyle = {
	  minHeight: "500px",
	  background: "#f5f5f5"
	};
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.initFbSDK();
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'initFbSDK',
	    value: function initFbSDK() {
	      window.fbAsyncInit = function () {
	        FB.init({
	          appId: _AppConstants2.default.FB_APP_ID,
	          autoLogAppEvents: true,
	          xfbml: true,
	          version: 'v2.11'
	        });
	      };
	
	      //Load the SDK asynchronously
	      (function (d, s, id) {
	        var js,
	            fjs = d.getElementsByTagName(s)[0];
	        if (d.getElementById(id)) {
	          return;
	        }
	        js = d.createElement(s);js.id = id;
	        js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
	        fjs.parentNode.insertBefore(js, fjs);
	      })(document, 'script', 'facebook-jssdk');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactIntl.IntlProvider,
	        { locale: 'en' },
	        _react2.default.createElement(
	          _reactSticky.StickyContainer,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: appStyle },
	            _react2.default.createElement(
	              _radium.StyleRoot,
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.BrowserRouter,
	                null,
	                _react2.default.createElement(_AppRouter2.default, null)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	var ErrorBoundary = function (_React$Component2) {
	  _inherits(ErrorBoundary, _React$Component2);
	
	  function ErrorBoundary(props) {
	    _classCallCheck(this, ErrorBoundary);
	
	    var _this2 = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));
	
	    _this2.state = { error: null };
	    return _this2;
	  }
	
	  _createClass(ErrorBoundary, [{
	    key: 'componentDidCatch',
	    value: function componentDidCatch(error, errorInfo) {
	      this.setState({ error: error });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.error) {
	
	        // You can render any custom fallback UI
	        return _react2.default.createElement(
	          'div',
	          { style: { background: "#eee", padding: "10px 0", textAlign: "center" } },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Opps! Something went wrong.'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { style: { fontWeight: 'bold', margin: '10px 0' } },
	            'Please DM us in Messenger to resolve the issue or to place your order.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { margin: '20px' } },
	            _react2.default.createElement(
	              'a',
	              { style: { padding: '10px', background: 'orange', color: 'white', border: "1px", fontSize: '130%' },
	                target: '_blank', href: 'https://m.me/setocanvascom' },
	              'Open Messenger'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { background: "#e45959" } },
	            _react2.default.createElement(
	              'h2',
	              { style: { background: '#c7c7c775', color: 'white', padding: '10px' } },
	              'Error Stack - ',
	              this.state.error.toString()
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { color: "white", padding: "10px", whiteSpace: "pre-line" } },
	              this.state.error.stack
	            )
	          )
	        );
	      }
	
	      return this.props.children;
	    }
	  }], [{
	    key: 'getDerivedStateFromError',
	    value: function getDerivedStateFromError(error) {
	      // Update state so the next render will show the fallback UI.
	      return { error: error };
	    }
	  }]);
	
	  return ErrorBoundary;
	}(_react2.default.Component);
	
	_reactDom2.default.render(_react2.default.createElement(
	  ErrorBoundary,
	  null,
	  _react2.default.createElement(App, null)
	), document.getElementById('root'));

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _401 = function (_React$Component) {
		_inherits(_401, _React$Component);
	
		function _401() {
			_classCallCheck(this, _401);
	
			return _possibleConstructorReturn(this, (_401.__proto__ || Object.getPrototypeOf(_401)).apply(this, arguments));
		}
	
		_createClass(_401, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_SetoCanvasPage2.default,
					{ id: '_401Page', title: 'Your session has expired | Seto Canvas' },
					_react2.default.createElement(
						'h1',
						{ style: { textAlign: "center", color: "gray" } },
						'Your session has expired. Please login again.'
					)
				);
			}
		}]);
	
		return _401;
	}(_react2.default.Component);
	
	exports.default = _401;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _SearchInput = __webpack_require__(94);
	
	var _SearchInput2 = _interopRequireDefault(_SearchInput);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _404 = function (_React$Component) {
		_inherits(_404, _React$Component);
	
		function _404() {
			_classCallCheck(this, _404);
	
			return _possibleConstructorReturn(this, (_404.__proto__ || Object.getPrototypeOf(_404)).apply(this, arguments));
		}
	
		_createClass(_404, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_SetoCanvasPage2.default,
					{ id: '_404Page', title: '404 Not Found | Seto Canvas' },
					_react2.default.createElement(
						'h1',
						{ style: { textAlign: "center", color: "gray" } },
						_react2.default.createElement('i', { className: 'fa fa-cloud', 'aria-hidden': 'true', style: { color: "#949699" } }),
						' 404 Not Found'
					),
					_react2.default.createElement(_AppElements.Separator, null),
					_react2.default.createElement(_SearchInput2.default, { title: 'Try Searching Below' })
				);
			}
		}]);
	
		return _404;
	}(_react2.default.Component);
	
	exports.default = _404;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _AppElements = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountDeactivatePage = function AccountDeactivatePage(props, context) {
	    var history = props.history;
	    var urlId = props.match.params.userId;
	    var userId = urlId ? urlId : _SessionStore2.default.getCurrentSession().user.id;
	
	    var validationScheme = function validationScheme() {
	        return _yup2.default.object().shape({
	            userInput: _yup2.default.string().required('Please enter the text "deactivate".').oneOf(['deactivate'], 'Please enter the text "deactivate".')
	        });
	    };
	
	    var handleSubmission = function handleSubmission() {
	        _UserAPI2.default.deactivateAccount(userId, function () {
	            history.push("/");
	        });
	    };
	
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'allArtistPage', title: "Nepals' Creative Artists Premium Hub | Seto Canvas", metaDescription: "Get your favourite artist merch, T-shirt, Hoodies and all kinds of merchandise at SetoCanvas.com" },
	        _react2.default.createElement(_AppElements.Title, { title: 'We are sad to see you go :(', style: { textAlign: 'center' }, separatorPosition: 'bottom' }),
	        _react2.default.createElement(
	            'h4',
	            { style: { lineHeight: '30px' } },
	            'Deactivating your account will delete all of your designs, except the ones that have made some earnings. Once deactivated, your account and designs will no longer be visible in ',
	            _react2.default.createElement(
	                'b',
	                null,
	                _AppConstants2.default.WEBSITE
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { style: { lineHeight: '30px' } },
	            'The designs that have made any earnings, will be ',
	            _react2.default.createElement(
	                'b',
	                null,
	                'archived'
	            ),
	            ' and will no longer be able to accept any orders.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { style: { lineHeight: '30px' } },
	            'Your earnings, if any, will be frozen too and you can always get it back logging in again.'
	        ),
	        _react2.default.createElement(_AppElements.Separator, null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: { userInput: '' }, onSubmit: handleSubmission,
	            validationSchema: validationScheme, render: function render(_ref) {
	                var isSubmitting = _ref.isSubmitting;
	
	                var submitBtn = "Submit";
	
	                if (isSubmitting === true) submitBtn = _react2.default.createElement(
	                    'span',
	                    null,
	                    'Submitting ',
	                    _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
	                );
	
	                return _react2.default.createElement(
	                    _FormElements.RGForm,
	                    null,
	                    _react2.default.createElement(_FormElements.Input, { name: 'userInput', type: 'text', label: _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'i',
	                                null,
	                                'Enter the text ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'deactivate'
	                                ),
	                                ' below to confirm deactivating your account:'
	                            )
	                        ), style: { marginBottom: "0px" } }),
	                    _react2.default.createElement(
	                        _FormElements.SubmitButton,
	                        { style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting },
	                        submitBtn
	                    )
	                );
	            } })
	    );
	};
	
	exports.default = AccountDeactivatePage;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppElements = __webpack_require__(9);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountVerificationPage = function (_React$Component) {
		_inherits(AccountVerificationPage, _React$Component);
	
		function AccountVerificationPage(props) {
			_classCallCheck(this, AccountVerificationPage);
	
			var _this = _possibleConstructorReturn(this, (AccountVerificationPage.__proto__ || Object.getPrototypeOf(AccountVerificationPage)).call(this, props));
	
			_this.state = { verified: null };
			return _this;
		}
	
		_createClass(AccountVerificationPage, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var match = this.props.match;
				var token = match.params.token;
				_UserAPI2.default.verifyAccount(token, function (verified) {
					this.setState({ verified: verified });
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				var verified = this.state.verified;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							'Verify your Seto Canvas Account | Seto Canvas'
						),
						_react2.default.createElement('meta', { name: 'description', content: 'Seto Canvas is a marketplace for Designers to sell their art printed on merchandise like TShirts, Mugs, Pillows and more.' })
					),
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(
						'h3',
						{ style: { textAlign: "center", margin: "40px 0" } },
						verified === null && _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' }),
							' Verifying your account'
						),
						verified === true && _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement('i', { className: 'fa fa-check-circle-o', style: { color: "#1e8910" }, 'aria-hidden': 'true' }),
							' Your account has been verified successfully. Click ',
							_react2.default.createElement(
								'b',
								null,
								_react2.default.createElement(
									_AppElements.A,
									{ href: '/' },
									'here'
								)
							),
							' to continue using ',
							_AppConstants2.default.APP_NAME,
							'.'
						),
						verified === false && _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement('i', { className: 'fa fa-exclamation-triangle', style: { color: "rgb(158, 56, 50)" }, 'aria-hidden': 'true' }),
							' We could not verify your account. Please request another verification link.'
						)
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return AccountVerificationPage;
	}(_react2.default.Component);
	
	exports.default = AccountVerificationPage;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserHook = __webpack_require__(72);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _AppElements = __webpack_require__(9);
	
	var _ArtistSlider = __webpack_require__(219);
	
	var _ArtistSlider2 = _interopRequireDefault(_ArtistSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALPHABETS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
	
	var AllArtistPage = function AllArtistPage(props) {
	    var urlPrefix = props.match.params.prefix;
	    var prefix = urlPrefix ? urlPrefix : 'A';
	
	    var browseLetters = ALPHABETS.map(function (a) {
	        return _react2.default.createElement(
	            _AppElements.A,
	            { key: "letter_" + a, className: prefix === a ? 'activeLetter' : '', href: "/artist/browse/" + a },
	            a
	        );
	    });
	
	    var allArtists = (0, _UserHook.useAllArtist)(prefix.toUpperCase());
	    var avatars = null;
	
	    if (allArtists !== null && allArtists.size > 0) {
	        avatars = allArtists.map(function (user) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'artistAvatarContainer', key: "EachArtist_" + user.username + "_" + user.id },
	                _react2.default.createElement(_ArtistSlider.ArtistAvatar, { user: user })
	            );
	        });
	    } else if (allArtists === null) {
	        avatars = [1, 2, 3].map(function (i) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'artistAvatarContainer', key: "ArtistContainerLoader_" + i },
	                _react2.default.createElement(_ArtistSlider.ArtistAvatar, { user: null })
	            );
	        });
	    } else if (allArtists.size === 0) {
	        avatars = _react2.default.createElement(
	            'h1',
	            { style: { textAlign: "center", color: "gray", width: '100%', alignSelf: 'center' } },
	            _react2.default.createElement('i', { className: 'fa fa-cloud', 'aria-hidden': 'true', style: { color: "#949699" } }),
	            ' No Artists Found'
	        );
	    }
	
	    var activeArtist = (0, _UserHook.useActiveArtist)();
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'allArtistPage', title: "Nepals' Creative Artists Premium Hub | Seto Canvas", metaDescription: "Get your favourite artist merch, T-shirt, Hoodies and all kinds of merchandise at SetoCanvas.com" },
	        _react2.default.createElement(_AppElements.Title, { title: 'BROWSE ARTISTS' }),
	        _react2.default.createElement(
	            'div',
	            { id: 'browseLetters', className: 'flexRow' },
	            browseLetters
	        ),
	        _react2.default.createElement(_AppElements.Separator, null),
	        _react2.default.createElement(
	            'div',
	            { id: 'browseArtists', className: 'flexRow', style: { margin: '20px 0' } },
	            avatars
	        ),
	        _react2.default.createElement(_ArtistSlider2.default, { users: activeArtist })
	    );
	};
	
	exports.default = AllArtistPage;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserHook = __webpack_require__(72);
	
	var _StorePreview = __webpack_require__(221);
	
	var _StorePreview2 = _interopRequireDefault(_StorePreview);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllStoresPage = function AllStoresPage() {
	    var allStores = (0, _UserHook.useAllStores)();
	    var storePreviews = !allStores ? [] : allStores.map(function (store) {
	        return _react2.default.createElement(_StorePreview2.default, { key: store.storeName, store: store });
	    }).toArray();
	
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'allStoresPage', title: "Favourite artist's official Merch, T-shirt, Hoodies and all kinds of merchandise | Seto Canvas", metaDescription: "Get your favourite artist merch, T-shirt, Hoodies and all kinds of merchandise at SetoCanvas.com" },
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow', style: { margin: '10px 0' } },
	            storePreviews
	        )
	    );
	};
	
	exports.default = AllStoresPage;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnalyticsOptOutPage = function (_React$Component) {
		_inherits(AnalyticsOptOutPage, _React$Component);
	
		function AnalyticsOptOutPage(props) {
			_classCallCheck(this, AnalyticsOptOutPage);
	
			var _this = _possibleConstructorReturn(this, (AnalyticsOptOutPage.__proto__ || Object.getPrototypeOf(AnalyticsOptOutPage)).call(this, props));
	
			_this.CACHE_KEY = "analytics-opt-out";
			_this.handleCheckBoxClick = _this.handleCheckBoxClick.bind(_this);
			_this.state = { optedOut: Boolean(_CacheService2.default.get(_this.CACHE_KEY)) === true };
			return _this;
		}
	
		_createClass(AnalyticsOptOutPage, [{
			key: 'handleCheckBoxClick',
			value: function handleCheckBoxClick(event) {
				var target = event.target;
				var isChecked = target.checked;
	
				if (isChecked) _CacheService2.default.save(this.CACHE_KEY, isChecked, true);else _CacheService2.default.remove(this.CACHE_KEY);
	
				this.setState({ optedOut: isChecked });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							'Opt Out from Analytics | Seto Canvas'
						)
					),
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(
						'div',
						{ style: { textAlign: 'center', padding: '20px', fontSize: '150%' } },
						this.state.optedOut && _react2.default.createElement(
							'h3',
							{ style: { background: 'gray', color: 'white', padding: '5px' } },
							'You have opted out from analytics!'
						),
						_react2.default.createElement('input', { style: { cursor: 'pointer' }, checked: this.state.optedOut, type: 'checkbox', id: 'optout', name: 'optout', onChange: this.handleCheckBoxClick }),
						' Opt Out from Analytics'
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return AnalyticsOptOutPage;
	}(_react2.default.Component);
	
	exports.default = AnalyticsOptOutPage;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _AppElements = __webpack_require__(9);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserTypeInfo = { "DESIGNER": "You are an independent artists and have digital designs that can be printed on various merchandise.",
		"INFLUENCER": "You are an influencer with at least 5k+ followers in any of the popular social media platform.",
		"MERCHANT": "You are an independent seller with various designs or items." };
	
	var Form = function Form(_ref) {
		var isSubmitting = _ref.isSubmitting,
		    values = _ref.values;
	
		var submitBtn = "Create Account";
	
		if (isSubmitting === true) submitBtn = _react2.default.createElement(
			'span',
			null,
			'Creating ',
			_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
		);
	
		var setupStore = values.userType === "INFLUENCER" || values.userType === "MERCHANT";
		return _react2.default.createElement(
			_FormElements.RGForm,
			null,
			_react2.default.createElement(
				'h3',
				{ style: { fontStyle: "italic", margin: "10px 0 25px 0", textAlign: "center", color: 'gray' } },
				'Please fill in the form below to register.'
			),
			_react2.default.createElement(_AppElements.Separator, { style: { margin: '20px auto', width: '30%' } }),
			_react2.default.createElement(_FormElements.Input, { name: 'username', placeholder: 'E.g: Ram Prasad Jhilke', type: 'text', label: 'Fullname: ', style: { marginBottom: "0px", marginTop: "10px" } }),
			_react2.default.createElement(
				'div',
				{ style: { marginBottom: '10px' } },
				_react2.default.createElement(
					'label',
					null,
					'Join As:'
				),
				_react2.default.createElement(
					'div',
					{ className: 'flexRow', style: { marginBottom: '0px' }, id: 'joinAsRadioBtnGroup' },
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'userType', value: "DESIGNER",
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							'Artist '
						),
						checked: values.userType === "DESIGNER" }),
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'userType', value: "INFLUENCER",
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							'Influencer'
						),
						checked: values.userType === "INFLUENCER" }),
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'userType', value: "MERCHANT",
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							'Merchant'
						),
						checked: values.userType === "MERCHANT" })
				),
				values.userType && _react2.default.createElement(
					'div',
					{ id: 'artistTypeInfo', className: 'flexRow' },
					_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', style: { marginRight: '5px' }, 'aria-hidden': 'true' }),
					_react2.default.createElement(
						'label',
						null,
						UserTypeInfo[values.userType]
					)
				)
			),
			setupStore && _react2.default.createElement(_FormElements.Input, { name: 'storeName', placeholder: 'Name of your store', type: 'text', label: 'Store Name: ', style: { marginBottom: "0px" } }),
			_react2.default.createElement(_FormElements.TextArea, { placeholder: "Max 100 characaters", label: setupStore ? "About Store:" : "About you:", name: 'about', rows: '3' }),
			_react2.default.createElement(_AppElements.Separator, { style: { margin: '40px auto', width: '30%' } }),
			_react2.default.createElement(_FormElements.Input, { name: 'phoneNumber', type: 'number', label: 'Phone Number (10 digit):', placeholder: 'E.g. 9862441133', style: { marginBottom: "0px" } }),
			_react2.default.createElement(_FormElements.Input, { name: 'email', placeholder: 'E.g: somename@example.com', type: 'text', label: 'Email: ', style: { marginBottom: "0px" } }),
			_react2.default.createElement(_FormElements.Input, { name: 'password', placeholder: 'E.g: 123456789 :)', type: 'password', label: 'Password: ', style: { marginBottom: "0px", marginTop: "10px" } }),
			_react2.default.createElement(_AppElements.Separator, { style: { margin: '50px auto', width: '30%' } }),
			_react2.default.createElement(
				'h3',
				null,
				'Social Media Accounts: ',
				_react2.default.createElement(
					'span',
					{ style: { fontSize: "70%" } },
					'(Provide at least one)'
				),
				' '
			),
			_react2.default.createElement(_FormElements.Input, { name: 'facebookUrl', label: 'Facebook:', type: 'text', placeholder: 'Enter your Facebook URL', style: { marginTop: '5px' } }),
			_react2.default.createElement(_FormElements.Input, { name: 'instaUrl', label: 'Instagram:', type: 'text', placeholder: 'Enter your Instagram URL', style: { marginTop: '5px' } }),
			_react2.default.createElement(_FormElements.Input, { name: 'tiktokUrl', label: 'Tiktok:', type: 'text', placeholder: 'Enter your Tiktok URL', style: { marginTop: '5px' } }),
			_react2.default.createElement(_FormElements.Input, { name: 'ytUrl', label: 'Youtube:', type: 'text', placeholder: 'Enter your Youtube URL', style: { marginTop: '5px' } }),
			_react2.default.createElement(
				_FormElements.SubmitButton,
				{ style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting },
				submitBtn
			)
		);
	};
	
	var ArtistRegisterPage = function (_React$Component) {
		_inherits(ArtistRegisterPage, _React$Component);
	
		function ArtistRegisterPage(props) {
			_classCallCheck(this, ArtistRegisterPage);
	
			var _this = _possibleConstructorReturn(this, (ArtistRegisterPage.__proto__ || Object.getPrototypeOf(ArtistRegisterPage)).call(this, props));
	
			_this.INIT_VALUES = { username: '', password: '', email: '', userType: '',
				storeName: '', about: '', phoneNumber: '',
				facebookUrl: '',
				instaUrl: '',
				ytUrl: '',
				tiktokUrl: ''
			};
	
			_this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
			return _this;
		}
	
		_createClass(ArtistRegisterPage, [{
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					username: _yup2.default.string().required('Enter your name'),
					email: _yup2.default.string().email('Invalid Email address').required("Enter your email address"),
					userType: _yup2.default.string().required('Select what kind of artist you are'),
					phoneNumber: _yup2.default.string().required('Enter your phone').max(10, "Enter your 10 digit number"),
					password: _yup2.default.string().required('Enter a password').min(6, "Password cannot be less than 8 characters"),
					about: _yup2.default.string().max(100, 'Max. 100 characters'),
					tiktokUrl: _yup2.default.string(),
					instaUrl: _yup2.default.string(),
					facebookUrl: _yup2.default.string(),
					ytUrl: _yup2.default.string().when(['tiktokUrl', 'instaUrl', 'facebookUrl'], function (tiktokUrl, instaUrl, facebookUrl, schema) {
						if (!tiktokUrl && !instaUrl && !facebookUrl) return _yup2.default.string().required('Provide at least your one social media account');
	
						return _yup2.default.string();
					})
				});
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(values, _ref2) {
				var setSubmitting = _ref2.setSubmitting,
				    resetForm = _ref2.resetForm;
	
				var registerRequest = { username: values.username, emailAddress: values.email,
					password: btoa(values.password),
					userType: values.userType,
					phoneNumber: values.phoneNumber,
					storeName: values.storeName ? values.storeName.replace(/-/g, " ") : '',
					about: values.about
				};
	
				var socialMediaAccounts = {};
	
				if (values.facebookUrl) socialMediaAccounts['FB'] = values.facebookUrl;
				if (values.instaUrl) socialMediaAccounts['INSTA'] = values.instaUrl;
				if (values.ytUrl) socialMediaAccounts['YOUTUBE'] = values.ytUrl;
				if (values.tiktokUrl) socialMediaAccounts['TIKTOK'] = values.tiktokUrl;
	
				registerRequest['socialMediaAccounts'] = socialMediaAccounts;
	
				_UserAPI2.default.register(registerRequest, function (success) {
					setSubmitting(false);
	
					if (success === true) resetForm(this.INIT_VALUES);
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ id: 'artistSignUpPage' },
					_react2.default.createElement(
						_SetoCanvasPage2.default,
						{ id: 'artistRegisterPage', title: "Nepals' Creative Artists Premium Hub | Seto Canvas",
							metaDescription: "Sign up as an Artist, Influencer or a Merchant today and get started with selling your merchandise online at SetoCanvas.com" },
						_react2.default.createElement(
							'div',
							{ id: 'artistSignUpForm' },
							_react2.default.createElement(_formik.Formik, { initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
								validationSchema: this.validationScheme, component: Form })
						)
					)
				);
			}
		}]);
	
		return ArtistRegisterPage;
	}(_react2.default.Component);
	
	exports.default = ArtistRegisterPage;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function Form(_ref) {
	    var isSubmitting = _ref.isSubmitting;
	
	    var submitBtn = "Change Password";
	    if (isSubmitting === true) submitBtn = _react2.default.createElement(
	        'span',
	        null,
	        'Change Password ',
	        _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
	    );
	
	    return _react2.default.createElement(
	        _FormElements.RGForm,
	        null,
	        _react2.default.createElement(
	            'h4',
	            { style: { fontStyle: "italic", margin: "10px 0", textAlign: "center" } },
	            'Enter your new password:'
	        ),
	        _react2.default.createElement(_FormElements.Input, { name: 'password', type: 'password', label: 'Password: ', style: { marginBottom: "0px", marginTop: "10px" } }),
	        _react2.default.createElement(_FormElements.Input, { name: 'confirmPassword', type: 'password', label: 'Confirm Password: ', style: { marginBottom: "0px", marginTop: "10px" } }),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow', style: { justifyContent: "space-between", alignItems: "flex-end" } },
	            _react2.default.createElement(
	                _FormElements.SubmitButton,
	                { style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting },
	                submitBtn
	            )
	        )
	    );
	};
	
	var ChangePasswordPage = function (_React$Component) {
	    _inherits(ChangePasswordPage, _React$Component);
	
	    function ChangePasswordPage(props) {
	        _classCallCheck(this, ChangePasswordPage);
	
	        var _this = _possibleConstructorReturn(this, (ChangePasswordPage.__proto__ || Object.getPrototypeOf(ChangePasswordPage)).call(this, props));
	
	        _this.INIT_VALUES = { password: '', confirmPassword: '' };
	        _this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
	
	        _this.state = { passwordChanged: false };
	        return _this;
	    }
	
	    _createClass(ChangePasswordPage, [{
	        key: 'validationScheme',
	        value: function validationScheme() {
	            return _yup2.default.object().shape({
	                password: _yup2.default.string().required('Enter your password.').min(6, "Password cannot be less than 6 chars."),
	                confirmPassword: _yup2.default.string().test('passwords-match', 'Passwords must match', function (value) {
	                    return this.parent.password === value;
	                })
	            });
	        }
	    }, {
	        key: 'handleFormSubmission',
	        value: function handleFormSubmission(value, _ref2) {
	            var setSubmitting = _ref2.setSubmitting,
	                setFieldValue = _ref2.setFieldValue;
	
	            var match = this.props.match;
	            var token = match.params.token;
	
	            _UserAPI2.default.changePassword(token, value.password, function (success) {
	                setSubmitting(false);
	
	                if (success) {
	                    this.setState({ passwordChanged: true });
	                }
	            }.bind(this));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _SetoCanvasPage2.default,
	                { id: 'changePasswordPage', title: 'Change Password | Seto Canvas' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { width: '50%', margin: '30px auto', padding: '30px', border: '1px solid #dcd6d6', borderRadius: '10px' } },
	                    this.state.passwordChanged === true && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { style: { textAlign: 'center' } },
	                            _react2.default.createElement('i', { className: 'fa fa-check-circle-o', style: { color: "#1e8910" }, 'aria-hidden': 'true' }),
	                            ' Your password has been changed successfully.'
	                        )
	                    ),
	                    this.state.passwordChanged === false && _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
	                        validationSchema: this.validationScheme, render: function render(formikProps) {
	                            return _react2.default.createElement(Form, Object.assign({}, formikProps, { forgetPasswordLink: _this2.props.forgetPasswordLink }));
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return ChangePasswordPage;
	}(_react2.default.Component);
	
	exports.default = ChangePasswordPage;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _DesignerDashboardContainer = __webpack_require__(515);
	
	var _DesignerDashboardContainer2 = _interopRequireDefault(_DesignerDashboardContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DesignerDashboardPage = function (_React$Component) {
		_inherits(DesignerDashboardPage, _React$Component);
	
		function DesignerDashboardPage() {
			_classCallCheck(this, DesignerDashboardPage);
	
			return _possibleConstructorReturn(this, (DesignerDashboardPage.__proto__ || Object.getPrototypeOf(DesignerDashboardPage)).apply(this, arguments));
		}
	
		_createClass(DesignerDashboardPage, [{
			key: 'render',
			value: function render() {
				var userId = this.props.match.params.userId;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(_DesignerDashboardContainer2.default, { userId: userId }),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return DesignerDashboardPage;
	}(_react2.default.Component);
	
	exports.default = DesignerDashboardPage;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tabs = __webpack_require__(122);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _tab = __webpack_require__(85);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _AppElements = __webpack_require__(9);
	
	var _ProductHook = __webpack_require__(138);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _UserAvatar = __webpack_require__(48);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _UserHook = __webpack_require__(72);
	
	var _ProductTabsByType = __webpack_require__(232);
	
	var _ProductTabsByType2 = _interopRequireDefault(_ProductTabsByType);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Loader = __webpack_require__(63);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ARTWORK_TYPES = _AppConstants2.default.ARTWORK_TYPES;
	
	var DesignerHeader = function DesignerHeader(_ref) {
		var user = _ref.user,
		    productImages = _ref.productImages;
	
		var radialBg = 'radial-gradient(circle at 100%, rgba(228, 228, 228, 0.32) 72%, rgb(68, 67, 66) 137%)';
		var bgImage = productImages ? { backgroundImage: radialBg + ", url(" + productImages[0] + ")" } : {};
		return _react2.default.createElement(
			'div',
			{ id: 'designerPageHeader' },
			_react2.default.createElement('div', { id: 'designerBg', style: bgImage }),
			_react2.default.createElement(
				'div',
				{ className: 'designerAvatar flexColumn' },
				_react2.default.createElement(_UserAvatar2.default, { user: user })
			)
		);
	};
	
	var DesignerInfo = function DesignerInfo(_ref2) {
		var user = _ref2.user;
	
		var currentSession = _SessionStore2.default.getCurrentSession();
		var isCurrentUser = currentSession && user && currentSession.user.id === user.id;
	
		var isCurrentAdmin = _AppUtil2.default.isAdminUser(currentSession ? currentSession.user : null);
		var isAdmin = _AppUtil2.default.isAdminUser(user);
	
		var editUrl = null;
		if (isCurrentAdmin && !isAdmin && user !== null) editUrl = "/" + user.id + "/settings";else editUrl = "/settings";
	
		var editIcon = isCurrentUser || isCurrentAdmin ? _react2.default.createElement(
			_AppElements.A,
			{ href: editUrl, id: 'userEditIcon' },
			_react2.default.createElement('i', { className: 'fa fa-pencil-square-o', 'aria-hidden': 'true' })
		) : null;
		var dashboardIcon = user !== null && isCurrentAdmin ? _react2.default.createElement(
			'a',
			{ href: "/designer/" + user.id + "/dashboard", id: 'userDashboardIcon' },
			_react2.default.createElement('i', { className: 'fa fa-dashboard', 'aria-hidden': 'true' })
		) : null;
	
		var designerName = null;
		var userBio = null;
	
		if (user) {
			var about = user.about;
			if (!about && isCurrentUser) about = _react2.default.createElement(
				_AppElements.A,
				{ href: '/settings' },
				'Add Bio'
			);
	
			designerName = _react2.default.createElement(
				'h2',
				{ className: 'userTitle' },
				user.username.toUpperCase(),
				' ',
				editIcon,
				' ',
				dashboardIcon
			);
			userBio = _react2.default.createElement(
				'span',
				{ className: 'userBio' },
				about
			);
		} else {
			designerName = _react2.default.createElement(_Loader2.default, { className: 'userTitleLoader' });
			userBio = _react2.default.createElement(_Loader2.default, { className: 'userBioLoader' });
		}
	
		return _react2.default.createElement(
			'div',
			{ id: 'designerInfo', className: 'flexColumn' },
			designerName,
			userBio
		);
	};
	
	var DesignerPage = function DesignerPage(props) {
		var userId = parseInt(props.match.params.userId, 10);
		var userProducts = (0, _ProductHook.useDesignerProducts)(userId);
		var featuredProducts = (0, _ProductHook.useFeaturedProducts)();
	
		var artWorkProducts = userProducts ? userProducts.filter(function (v, i, a) {
			return a.indexOf(v) === i;
		}).filter(function (p) {
			return p.artworkType === ARTWORK_TYPES.DIGITAL_ART.val;
		}) : null;
		var photographProducts = userProducts ? userProducts.filter(function (p) {
			return p.artworkType === ARTWORK_TYPES.PHOTOGRAPH.val;
		}) : null;
		var productImages = artWorkProducts ? artWorkProducts.map(function (p) {
			return p.previewImage;
		}) : null;
		var designerInfo = (0, _UserHook.userDesignerInfo)(userId);
		var designerName = props.match.params.designerName;
	
		return _react2.default.createElement(
			_SetoCanvasPage2.default,
			{ id: 'designerPage', title: designerName + " Artworks, Merchandise, T-Shirt, Hoodies and more | Seto Canvas",
				metaDescription: "Purchase " + designerName + " arts and many more at SetoCanvas.com" },
			_react2.default.createElement(DesignerHeader, { user: designerInfo, productImages: productImages }),
			_react2.default.createElement(DesignerInfo, { user: designerInfo }),
			_react2.default.createElement(
				_tabs2.default,
				{ id: 'designerMainTab', defaultSelectedIndex: 0, key: designerName + "-maintab", style: { minHeight: '300px' } },
				_react2.default.createElement(
					_tab2.default,
					{ key: designerName + "-shop", value: 'shop', label: 'Shop' },
					userProducts && userProducts.length > 10 && _react2.default.createElement(_ProductTabsByType2.default, { products: userProducts,
						ownerName: designerName, productViewMode: 'both' }),
					(!userProducts || userProducts.length <= 10) && _react2.default.createElement(_ProductList2.default, { products: userProducts, viewProductTags: true, flattenProductImages: true,
						productViewMode: 'productOnly', emptyMsg: 'No Products Found' })
				),
				artWorkProducts && artWorkProducts.length > 0 && _react2.default.createElement(
					_tab2.default,
					{ key: designerName + "-artworks", value: 'artworks', label: 'ArtWorks' },
					_react2.default.createElement(_ProductList2.default, { id: 'artworksList', products: artWorkProducts, viewProductTags: true,
						productViewMode: 'designOnly', emptyMsg: 'No Artworks Found' })
				),
				photographProducts && photographProducts.length > 0 && _react2.default.createElement(
					_tab2.default,
					{ key: designerName + "-photographs", value: 'photographs', label: 'Photographs' },
					_react2.default.createElement(_ProductList2.default, { id: 'photographsList', products: photographProducts, viewProductTags: true,
						productViewMode: 'designOnly', emptyMsg: 'No Photographs Found' })
				)
			),
			_react2.default.createElement(_AppElements.Separator, null),
			_react2.default.createElement(_ProductList2.default, { products: featuredProducts, showSlider: true,
				title: "FEATURED ARTWORKS", productViewMode: 'designOnly' })
		);
	};
	
	exports.default = DesignerPage;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTable = __webpack_require__(50);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	var _ReduceStoreHook = __webpack_require__(45);
	
	var _ReduceStoreHook2 = _interopRequireDefault(_ReduceStoreHook);
	
	var _DateComponent = __webpack_require__(62);
	
	var _DateComponent2 = _interopRequireDefault(_DateComponent);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DiscountedProductsTable(_ref) {
	    var discountedProducts = _ref.discountedProducts;
	
	    var productInfoCols = [{ Header: 'Name', accessor: 'product', width: 220,
	        Cell: function Cell(props) {
	            var product = props.value;
	            var url = _AppUtil2.default.getProductURL(product);
	            return _react2.default.createElement(
	                _AppElements.A,
	                { href: url, style: { marginLeft: '10px' } },
	                product.title
	            );
	        }
	    }, { Header: 'Type', accessor: 'product', width: 130,
	        Cell: function Cell(props) {
	            var product = props.value;
	            return _AppConstants2.default.PRODUCT_TYPES[product.productType].label;
	        }
	    }];
	
	    var discountedCouponCols = [{ Header: 'Coupon Code', accessor: 'discountCoupon', width: 200,
	        Cell: function Cell(props) {
	            var discountCoupon = props.value;
	            return _react2.default.createElement(
	                'div',
	                { className: 'couponCode' },
	                discountCoupon.couponCode
	            );
	        }
	    }, { Header: 'Amount', accessor: 'discountCoupon', width: 220,
	        Cell: function Cell(props) {
	            var discountCoupon = props.value;
	            return _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center' } },
	                "Rs. " + discountCoupon.discountAmount
	            );
	        }
	    }, { Header: 'Orders Limit', accessor: 'discountCoupon', width: 150,
	        Cell: function Cell(props) {
	            var ordersLimit = props.value.ordersLimit ? "First " + props.value.ordersLimit + " Orders!" : "-";
	            return _react2.default.createElement(
	                'div',
	                null,
	                ordersLimit
	            );
	        }
	    }, { Header: 'Validity', accessor: 'discountCoupon', width: 150,
	        Cell: function Cell(props) {
	            var discountCoupon = props.value;
	            var now = new Date().getTime();
	
	            if (now < discountCoupon.startTime) {
	                var from = _react2.default.createElement(_DateComponent2.default, { date: discountCoupon.startTime, relative: true, showTime: true });
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'Valid ',
	                    from
	                );
	            }
	
	            var to = _react2.default.createElement(_DateComponent2.default, { date: discountCoupon.expiryTime, relative: true, showTime: true });
	            return _react2.default.createElement(
	                'div',
	                null,
	                'Expires ',
	                to
	            );
	        }
	    }];
	
	    var showLoading = discountedProducts ? false : true;
	
	    var columns = [{ Header: 'Product', columns: productInfoCols }];
	    columns.push({ Header: 'Discount', columns: discountedCouponCols });
	
	    return _react2.default.createElement(_reactTable2.default, { data: discountedProducts ? discountedProducts : [], columns: columns, minRows: 5,
	        noDataText: 'No Discounts Found.', loading: showLoading,
	        className: '-highlight', defaultPageSize: 15
	    });
	}
	
	function DiscountedProductsPage(props) {
	    var session = (0, _react.useState)(_SessionStore2.default.getCurrentSession())[0];
	
	    var userId = props.match.params.userId;
	
	    if (!userId) userId = session.user.id;
	
	    var discountedProducts = (0, _ReduceStoreHook2.default)(_ProductStore2.default, function (store) {
	        return store.getDiscountedProducts(userId);
	    }, function () {
	        return _ProductAPI2.default.getDiscountedProducts(userId);
	    }, [userId]);
	
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'discountedProductsPage', title: 'Discounted Products | Seto Canvas' },
	        _react2.default.createElement(
	            'h2',
	            { style: { margin: '10px 0' } },
	            'Discounts and Coupons ',
	            _react2.default.createElement('i', { className: 'fa fa-tags', 'aria-hidden': 'true' })
	        ),
	        _react2.default.createElement(DiscountedProductsTable, { discountedProducts: discountedProducts })
	    );
	}
	
	exports.default = DiscountedProductsPage;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _AppElements = __webpack_require__(9);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _DesignerStore = __webpack_require__(91);
	
	var _DesignerStore2 = _interopRequireDefault(_DesignerStore);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _StoreList = __webpack_require__(220);
	
	var _StoreList2 = _interopRequireDefault(_StoreList);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _HeaderBanner = __webpack_require__(47);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	var _SearchInput = __webpack_require__(94);
	
	var _SearchInput2 = _interopRequireDefault(_SearchInput);
	
	__webpack_require__(609);
	
	var _ArtistSlider = __webpack_require__(219);
	
	var _ArtistSlider2 = _interopRequireDefault(_ArtistSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BATCH_SIZE = 4;
	
	var ProductsBatchContainer = function (_React$Component) {
		_inherits(ProductsBatchContainer, _React$Component);
	
		function ProductsBatchContainer() {
			_classCallCheck(this, ProductsBatchContainer);
	
			return _possibleConstructorReturn(this, (ProductsBatchContainer.__proto__ || Object.getPrototypeOf(ProductsBatchContainer)).apply(this, arguments));
		}
	
		_createClass(ProductsBatchContainer, [{
			key: 'getBatches',
			value: function getBatches(number, products) {
				if (!products) return _react2.default.createElement(_ProductList2.default, Object.assign({}, this.props, { showSlider: true }));
	
				var batches = [];
	
				for (var i = 0; i < number; i++) {
					var startIndex = i * BATCH_SIZE;
					var endIndex = i === number - 1 ? products.length : startIndex + BATCH_SIZE;
	
					var productList = _react2.default.createElement(_ProductList2.default, { key: "store_batch_" + i, showSlider: true, productViewMode: 'productOnly', autoplay: false,
						products: products.slice(startIndex, endIndex), title: i === 0 ? this.props.title : null, navigator: 'arrows' });
					batches.push(productList);
				}
	
				return batches;
			}
		}, {
			key: 'render',
			value: function render() {
				var products = this.props.products;
	
				var numberOfBatches = products ? Math.ceil(products.length / BATCH_SIZE) : 1;
				var productBatches = this.getBatches(numberOfBatches, products);
				return _react2.default.createElement(
					'div',
					{ id: 'populaProducts' },
					productBatches
				);
			}
		}]);
	
		return ProductsBatchContainer;
	}(_react2.default.Component);
	
	var EachShopThumbnail = function EachShopThumbnail(props) {
		var productType = props.productType;
		var products = null;
	
		if (props.products !== null) products = props.products[productType.val] || [];
	
		var thumbnails = products ? products.map(function (p) {
			return _react2.default.createElement(_AppElements.Img, { src: p.productImages[0], className: 'shopProductImg', key: p.id, alt: p.title });
		}) : null;
	
		var img = props.img;
		var url = props.url;
		var id = props.id;
		var btnLabel = props.btnLabel;
	
		return _react2.default.createElement(
			_AppElements.A,
			{ href: url },
			_react2.default.createElement(
				'div',
				{ id: id, className: 'shopDiv' },
				thumbnails !== null && thumbnails.length === 4 && _react2.default.createElement(
					'div',
					{ className: 'flexRow' },
					thumbnails
				),
				thumbnails !== null && thumbnails.length !== 4 && _react2.default.createElement(_AppElements.Img, { src: img }),
				_react2.default.createElement(
					'span',
					{ className: 'shopBtn' },
					btnLabel
				)
			)
		);
	};
	
	var ShopSection = function ShopSection(props) {
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_AppElements.Title, { title: 'SHOP' }),
			_react2.default.createElement(
				'div',
				{ id: 'shopList', className: 'flexRow' },
				_react2.default.createElement(EachShopThumbnail, { id: 'shopFrame', url: '/shop/frame',
					img: '/images/products/FRAME.jpg', btnLabel: 'Shop Frame',
					productType: _AppConstants2.default.PRODUCT_TYPES.PHOTO_FRAME,
					products: [] }),
				_react2.default.createElement(EachShopThumbnail, { id: 'shopJacket', url: '/shop/jacket',
					img: '/images/products/JACKET.jpg', btnLabel: 'Shop Jacket',
					productType: _AppConstants2.default.PRODUCT_TYPES.JACKET,
					products: [] }),
				_react2.default.createElement(EachShopThumbnail, { id: 'shopSweatshirts', url: '/shop/sweatshirt',
					img: '/images/products/SWEATSHIRT.jpg', btnLabel: 'Shop Sweatshirts',
					productType: _AppConstants2.default.PRODUCT_TYPES.SWEAT_SHIRT,
					products: [] }),
				_react2.default.createElement(EachShopThumbnail, { id: 'shopHoodies', url: '/shop/hoodies',
					img: '/images/products/HOODIES.jpg', btnLabel: 'Shop Hoodies',
					productType: _AppConstants2.default.PRODUCT_TYPES.HOODIES,
					products: [] }),
				_react2.default.createElement(EachShopThumbnail, { id: 'shopTshirt', url: '/shop/tshirt',
					img: '/images/products/TSHIRT.jpg', btnLabel: 'Shop T-Shirt',
					productType: _AppConstants2.default.PRODUCT_TYPES.T_SHIRT,
					products: [] })
			)
		);
	};
	
	var HomePage = function (_React$Component2) {
		_inherits(HomePage, _React$Component2);
	
		function HomePage() {
			_classCallCheck(this, HomePage);
	
			return _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).apply(this, arguments));
		}
	
		_createClass(HomePage, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.state.popularProducts === null) _ProductAPI2.default.getPopularProducts();
	
				// if(this.state.activeArtists === null)
				// 	UserAPI.getActiveArtists();
	
				this.paginateAndfetchRecentProducts();
			}
		}, {
			key: 'paginateAndfetchRecentProducts',
			value: function paginateAndfetchRecentProducts() {
				if (this.state.loading === false) {
					this.setState({ loading: true });
					var pagination = this.state.recentProductsPagination;
					_HttpService2.default.getRecentProducts(pagination.nextPageNumber, _AppConstants2.default.DEFAULT_PRODUCT_PAGE_SIZE, function (products) {
						this.setState({ loading: false });
					}.bind(this));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var popularTags = _AppConstants2.default.TOP_TAGS.map(function (t) {
					return _react2.default.createElement(
						'span',
						{ key: "search_tag_" + t.name, className: 'tags' },
						_react2.default.createElement(
							_AppElements.A,
							{ href: "/search/" + t.name },
							t.value
						)
					);
				});
	
				var influencers = this.state.influencersAndStores ? this.state.influencersAndStores.filter(function (u) {
					return u.userType === "INFLUENCER";
				}).sort(function () {
					return .5 - Math.random();
				}) : [];
				// const stores = this.state.influencersAndStores? this.state.influencersAndStores.filter(u => u.userType !== "INFLUENCER"): [];
				return _react2.default.createElement(
					'div',
					{ id: 'homePage' },
					_react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							'Seto Canvas is a marketplace for creative heads like you to sell your art/design printed on different merchandise such as TShirts, Sweatshirts, Wall Frame, Mugs, Pillows and Make Money from Home at your own convenience. | Seto Canvas'
						),
						_react2.default.createElement('meta', { name: 'description', content: 'Seto Canvas is a marketplace for Designers to sell their art printed on merchandise like TShirts, Sweatshirts, Wall Frame, Mugs, Pillows and more.' })
					),
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(
						'div',
						{ id: 'homeSearchBanner' },
						_react2.default.createElement(_SearchInput2.default, { keyword: "", title: 'SEARCH FROM 1,000+ UNIQUE DESIGNS' }),
						_react2.default.createElement(
							'div',
							{ className: 'searchResTags flexRow' },
							popularTags
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'mainContainer', id: 'influencerList' },
						_react2.default.createElement(_StoreList2.default, { stores: influencers, title: "Influencers", appendViewAll: false })
					),
					_react2.default.createElement(
						'div',
						{ id: 'scBanners' },
						_react2.default.createElement(_HeaderBanner2.default, { bannerImages: [
							// {"img": "/images/banners/plain-tshirt/plain-tshirt-large-banner.jpg",
							// "mobileImg": "/images/banners/plain-tshirt/plain-tshirt-small-banner.jpg",
							// "title": "Plain T-Shirt available in Nepal at setocanvas.com", "url": "/tag/plain-tshirt"},
	
							{ "img": "/images/banners/home-page/custom tee banner.png?v=1.2",
								"title": "Custom T-Shirts for everyone at SetoCanvas.com" }, { "img": "/images/banners/home-page/Influencer banner.png?v=1.2",
								"title": "Your favorite influencer merchandise at SetoCanvas.com" }, { "img": "/images/banners/home-page/Photoframe_banner.png?v=1.2",
								"title": "Photo Frames with SetoCanvas.com" }, { "img": "/images/banners/home-page/Bulk print banner.png?v=1.2",
								"title": "Bulk Custom T-Shirts at SetoCanvas.com" }], autoplay: true })
					),
					_react2.default.createElement(
						'div',
						{ className: 'mainContainer' },
						_react2.default.createElement(ProductsBatchContainer, { products: this.state.popularProducts,
							title: 'Popular Products' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'mainContainer', id: 'shopSection' },
						_react2.default.createElement(_ProductList2.default, { title: "Shop", viewProductTags: true,
							products: this.state.recentProducts, productViewMode: 'both',
							loadMore: this.paginateAndfetchRecentProducts.bind(this),
							hasMore: this.state.recentProductsPagination.hasMore })
					)
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_ProductStore2.default, _DesignerStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState) {
				var newState = {
					popularProducts: _ProductStore2.default.getPopularProducts(),
	
					recentProducts: _ProductStore2.default.getRecentProducts(),
					recentProductsPagination: _ProductStore2.default.getRecentProductsPagination(),
	
					// activeArtists: DesignerStore.getActiveArtists(),
					influencersAndStores: _DesignerStore2.default.getAllPopularStores(),
	
					loading: prevState ? prevState.loading : false
				};
				return newState;
			}
		}]);
	
		return HomePage;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(_utils.Container.create(HomePage));

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LogoutContainer = __webpack_require__(516);
	
	var _LogoutContainer2 = _interopRequireDefault(_LogoutContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogoutPage = function (_React$Component) {
		_inherits(LogoutPage, _React$Component);
	
		function LogoutPage() {
			_classCallCheck(this, LogoutPage);
	
			return _possibleConstructorReturn(this, (LogoutPage.__proto__ || Object.getPrototypeOf(LogoutPage)).apply(this, arguments));
		}
	
		_createClass(LogoutPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_LogoutContainer2.default, { history: this.props.history });
			}
		}]);
	
		return LogoutPage;
	}(_react2.default.Component);
	
	exports.default = LogoutPage;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _PriceLabel = __webpack_require__(142);
	
	var _PriceLabel2 = _interopRequireDefault(_PriceLabel);
	
	var _AppElements = __webpack_require__(9);
	
	var _MusicPlaqueForm = __webpack_require__(223);
	
	var _MusicPlaqueForm2 = _interopRequireDefault(_MusicPlaqueForm);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _input = __webpack_require__(182);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _ProductHook = __webpack_require__(138);
	
	var _SuggestedProducts = __webpack_require__(143);
	
	var _SuggestedProducts2 = _interopRequireDefault(_SuggestedProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	
	var MusicPlaqueStyleForm = function MusicPlaqueStyleForm(_ref) {
	    var selectedProduct = _ref.selectedProduct,
	        availableProducts = _ref.availableProducts,
	        onProductSelect = _ref.onProductSelect,
	        onCustomizeNow = _ref.onCustomizeNow,
	        onChangeQuantity = _ref.onChangeQuantity;
	
	
	    var productLabels = availableProducts.filter(function (p) {
	        return p !== null;
	    }).map(function (p, index) {
	        var checkedLabel = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-square-o', 'aria-hidden': 'true' }),
	            ' '
	        );
	        var checked = selectedProduct !== null && selectedProduct.id === p.id;
	        if (checked) checkedLabel = _react2.default.createElement(
	            'span',
	            { className: 'checkedlabel' },
	            _react2.default.createElement('i', { className: 'fa fa-check-square', 'aria-hidden': 'true' }),
	            ' '
	        );
	
	        return _react2.default.createElement(
	            _AppElements.Button,
	            { key: "productLabel_" + index, className: checked ? "checkedLabelBtn" : "", onClick: function onClick() {
	                    return onProductSelect(p, index);
	                }, mui: 'true' },
	            checkedLabel,
	            p.title
	        );
	    });
	
	    var displayProduct = selectedProduct === null ? availableProducts[0] : selectedProduct;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexColumn', id: 'musicPlaqueStyleForm' },
	        _react2.default.createElement(
	            'h1',
	            { className: 'flexColumn productTitle' },
	            _react2.default.createElement(
	                'span',
	                null,
	                'CUSTOM MUSIC PLAQUE'
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            { style: { display: 'block', color: 'gray', margin: '15px 0px 0 0', fontSize: '120%', whiteSpace: 'pre-line' } },
	            '- Design your own Music Plaque. Gift something personal and express your sentiment through your favourite Music/Song.'
	        ),
	        displayProduct && _react2.default.createElement(_PriceLabel2.default, { style: { margin: '15px 0px 25px 0', fontWeight: 'bold', fontSize: '26px', display: 'block', color: '#f8951b' },
	            price: displayProduct.price,
	            aliasPrice: displayProduct.aliasPrice,
	            productType: displayProduct.productType, invertColor: true, discountFont: '65%' }),
	        _react2.default.createElement(
	            'h4',
	            { style: { margin: 0 } },
	            'Quantity:'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_input2.default, { defaultValue: 1, onChange: function onChange(event) {
	                    onChangeQuantity(event.target.value);
	                } })
	        ),
	        _react2.default.createElement(
	            'h4',
	            { style: { margin: '10px 0 0 0' } },
	            'Plaque Size:'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_input2.default, { style: { color: 'gray' }, disabled: true, defaultValue: PRODUCT_TYPES.MUSIC_PLAQUE.SIZE.A4.label })
	        ),
	        _react2.default.createElement(
	            'h4',
	            { style: { margin: '10px 0 0 0' } },
	            'Select Style:'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow', style: { margin: '10px 0' }, id: 'productLabels' },
	            productLabels
	        ),
	        _react2.default.createElement(
	            _AppElements.Button,
	            { mui: 'true', variant: 'primary', disabled: selectedProduct === null, onClick: onCustomizeNow },
	            'Customize Now'
	        ),
	        _react2.default.createElement(_AppElements.Separator, { style: { margin: '20px auto' } }),
	        _react2.default.createElement(
	            'ul',
	            { id: 'plaqueFormInfo' },
	            _react2.default.createElement(
	                'li',
	                null,
	                'Select your style of Music Plaque: Acryclic or Framed.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Enter Song and Artist of your choice.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Upload the image you want on your Music Plaque.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Place your order and get it delivered on your Doorstep.'
	            )
	        )
	    );
	};
	
	var MusicPlaquePreview = function MusicPlaquePreview(_ref2) {
	    var product = _ref2.product;
	
	    if (product === null) return _react2.default.createElement(_AppElements.Img, { className: 'largeImg', src: null });
	
	    return _react2.default.createElement(_AppElements.Img, { className: 'largeImg', src: product ? product.previewImage : null });
	};
	
	function MusicPlaqueMaker(props) {
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        selectedProduct = _useState2[0],
	        setSelectedProduct = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(1),
	        _useState4 = _slicedToArray(_useState3, 2),
	        quantity = _useState4[0],
	        setQuantity = _useState4[1];
	
	    var previewSliderRef = (0, _react.useRef)();
	    var componentSliderRef = (0, _react.useRef)();
	    var customProductIds = _AppConstants2.default.CUSTOM_PRODUCTS[PRODUCT_TYPES.MUSIC_PLAQUE.val];
	
	    var products = customProductIds.map(function (id) {
	        return (0, _ProductHook.useProduct)(id);
	    });
	    var photoFrameUrl = PRODUCT_TYPES.PHOTO_FRAME.url;
	
	    var _useState5 = (0, _react.useState)(_ProductStore2.default.getProductsByType(photoFrameUrl)),
	        _useState6 = _slicedToArray(_useState5, 2),
	        suggestedProducts = _useState6[0],
	        setSuggestedProducts = _useState6[1];
	
	    (0, _react.useEffect)(function () {
	        var listener = _ProductStore2.default.addListener(function () {
	            setSuggestedProducts(_ProductStore2.default.getProductsByType(photoFrameUrl));
	        });
	
	        if (suggestedProducts === null) {
	            _ProductAPI2.default.getProductsByType(PRODUCT_TYPES.PHOTO_FRAME, 0, _AppConstants2.default.DEFAULT_PRODUCT_PAGE_SIZE);
	        }
	
	        return function () {
	            return listener.remove();
	        };
	    }, []);
	
	    var previewSliderSettings = {
	        customPaging: function customPaging(i) {
	            if (products[i] === null) return _react2.default.createElement('div', null);
	
	            return _react2.default.createElement('img', { src: products[i].previewImage, alt: 'Order your custom Music Plaque in Nepal from setocanvas.com' });
	        },
	        beforeChange: function beforeChange(current, next) {
	            return setSelectedProduct(products[next]);
	        },
	        dotsClass: "slick-dots slick-thumb",
	        responsive: [{
	            breakpoint: 600,
	            settings: {
	                arrows: false
	            }
	        }]
	    };
	
	    var componentSliderSettings = {
	        dots: false,
	        arrows: false,
	        swipe: false
	    };
	
	    var onProductSelect = function onProductSelect(product, index) {
	        previewSliderRef.current.slickGoTo(index);
	        setSelectedProduct(product);
	    };
	
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'musicplaqueMaker',
	            title: 'Custom Music Plaque, Order yours in Nepal | Seto Canvas',
	            metaDescription: 'Create your custom music plaque, a perfect gift for your loved one with your choice of song and image. Not available in Nepal.',
	            turnOffSticky: true },
	        _react2.default.createElement(
	            _AppElements.SCSlider,
	            { sliderRef: componentSliderRef, sliderSettings: componentSliderSettings },
	            _react2.default.createElement(
	                'div',
	                { className: 'flexRow', id: 'musicPlaqueStyleContainer' },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'musicPlaquePreviews' },
	                    _react2.default.createElement(
	                        _AppElements.SCSlider,
	                        { sliderRef: previewSliderRef, sliderSettings: previewSliderSettings },
	                        _react2.default.createElement(MusicPlaquePreview, { product: products[0] }),
	                        _react2.default.createElement(MusicPlaquePreview, { product: products[1] })
	                    )
	                ),
	                _react2.default.createElement(MusicPlaqueStyleForm, { selectedProduct: selectedProduct, availableProducts: products,
	                    onProductSelect: onProductSelect,
	                    onCustomizeNow: function onCustomizeNow() {
	                        return componentSliderRef.current.slickGoTo(1);
	                    },
	                    onChangeQuantity: function onChangeQuantity(quantity) {
	                        return setQuantity(quantity);
	                    } })
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'musicPlaqueFormContainer' },
	                _react2.default.createElement(
	                    _AppElements.Button,
	                    { mui: 'true', id: 'goBackBtn', onClick: function onClick() {
	                            return componentSliderRef.current.slickGoTo(0);
	                        } },
	                    _react2.default.createElement('i', { className: 'fa fa-arrow-left', 'aria-hidden': 'true' })
	                ),
	                _react2.default.createElement(_MusicPlaqueForm2.default, { product: selectedProduct, quantity: quantity })
	            )
	        ),
	        suggestedProducts && _react2.default.createElement(_SuggestedProducts2.default, { products: suggestedProducts,
	            autoplay: true, navigator: 'arrows' })
	    );
	}
	
	exports.default = MusicPlaqueMaker;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _OrderListContainer = __webpack_require__(137);
	
	var _OrderListContainer2 = _interopRequireDefault(_OrderListContainer);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyOrdersPage = function (_React$Component) {
		_inherits(MyOrdersPage, _React$Component);
	
		function MyOrdersPage() {
			_classCallCheck(this, MyOrdersPage);
	
			return _possibleConstructorReturn(this, (MyOrdersPage.__proto__ || Object.getPrototypeOf(MyOrdersPage)).apply(this, arguments));
		}
	
		_createClass(MyOrdersPage, [{
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					{ id: 'myOrdersPage' },
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'mainContainer' },
						_react2.default.createElement(_OrderListContainer2.default, { session: _SessionStore2.default.getCurrentSession(), showPaymentOption: true, showProductInfo: true })
					),
					_react2.default.createElement(
						'div',
						{ style: { padding: '10px', textAlign: 'right' } },
						_react2.default.createElement(
							'small',
							null,
							'To cancel any active orders, please call us at ',
							_react2.default.createElement('i', { style: { color: "#f8941c" }, className: 'fa fa-phone-square', 'aria-hidden': 'true' }),
							' ',
							_AppConstants2.default.CONTACT_NUMBER,
							' or WhatsApp at ',
							_react2.default.createElement('i', { style: { color: "green" }, className: 'fa fa-whatsapp', 'aria-hidden': 'true' }),
							' ',
							_AppConstants2.default.WHATS_APP
						)
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return MyOrdersPage;
	}(_react2.default.Component);
	
	exports.default = MyOrdersPage;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _OrderSettingsContainer = __webpack_require__(518);
	
	var _OrderSettingsContainer2 = _interopRequireDefault(_OrderSettingsContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderSettingsPage = function (_React$Component) {
		_inherits(OrderSettingsPage, _React$Component);
	
		function OrderSettingsPage() {
			_classCallCheck(this, OrderSettingsPage);
	
			return _possibleConstructorReturn(this, (OrderSettingsPage.__proto__ || Object.getPrototypeOf(OrderSettingsPage)).apply(this, arguments));
		}
	
		_createClass(OrderSettingsPage, [{
			key: 'render',
			value: function render() {
				var orderId = this.props.match.params.orderId;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(_OrderSettingsContainer2.default, { orderId: orderId }),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return OrderSettingsPage;
	}(_react2.default.Component);
	
	exports.default = OrderSettingsPage;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _ProductDetailContainer = __webpack_require__(519);
	
	var _ProductDetailContainer2 = _interopRequireDefault(_ProductDetailContainer);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductDetailPage = function (_React$Component) {
		_inherits(ProductDetailPage, _React$Component);
	
		function ProductDetailPage() {
			_classCallCheck(this, ProductDetailPage);
	
			return _possibleConstructorReturn(this, (ProductDetailPage.__proto__ || Object.getPrototypeOf(ProductDetailPage)).apply(this, arguments));
		}
	
		_createClass(ProductDetailPage, [{
			key: 'render',
			value: function render() {
				//for other product type, it's not displayed in the URL
				var producTypeURLStr = this.props.match.params[0] || "OTHER";
				var productType = _AppUtil2.default.findProductTypeFromURL(producTypeURLStr);
	
				var productId = this.props.match.params.productId;
				var name = decodeURIComponent(this.props.match.params.name);
	
				var pathURL = this.props.match.path;
				var query = new URLSearchParams(this.props.location.search);
				var selectedImage = query.get("sc_img");
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							name.toUpperCase(),
							' - ',
							productType.label,
							' | Seto Canvas'
						),
						_react2.default.createElement('meta', { name: 'description', content: "Purchase " + name + " " + productType.label + " and many more at SetoCanvas.com" })
					),
					_react2.default.createElement(_HeaderContainer2.default, { turnOffSticky: true }),
					_react2.default.createElement(_ProductDetailContainer2.default, { productId: productId, name: name, editMode: pathURL.indexOf("edit") >= 0,
						selectedImage: selectedImage }),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return ProductDetailPage;
	}(_react2.default.Component);
	
	exports.default = ProductDetailPage;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReduceStoreHook = __webpack_require__(45);
	
	var _ReduceStoreHook2 = _interopRequireDefault(_ReduceStoreHook);
	
	var _ProductHook = __webpack_require__(138);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProductsByTagPage(props) {
		var tagName = props.match.params.tagName;
		var tagProducts = (0, _ReduceStoreHook2.default)(_ProductStore2.default, function (store) {
			return store.getTagProducts(tagName);
		}, function () {
			return _ProductAPI2.default.searchProductsByTag(tagName);
		}, [tagName]);
	
		var featuredProducts = (0, _ProductHook.useFeaturedProducts)();
	
		var title = tagName.toUpperCase() + " T-Shirts, SweatShirts | Seto Canvas";
		var metaDescription = "Purchase " + tagName + " T-Shirts, Sweatshirts, Hoodies and many more at SetoCanvas.com";
	
		return _react2.default.createElement(
			_SetoCanvasPage2.default,
			{ id: 'tagProducts', title: title, metaDescription: metaDescription },
			_react2.default.createElement(_ProductList2.default, { products: tagProducts }),
			_react2.default.createElement(_AppElements.Separator, null),
			_react2.default.createElement(_ProductList2.default, { products: featuredProducts, showSlider: true,
				title: "FEATURED ARTWORKS", productViewMode: 'designOnly' })
		);
	}
	
	exports.default = ProductsByTagPage;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _HeaderBanner = __webpack_require__(47);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BANNERS = { "tshirt": ["/images/banners/shop_tshirt.jpg", "/images/banners/shop_tshirt2.jpg"],
		"hoodies": ["/images/banners/shop_hoodies.jpg"],
		"sweatshirt": ["/images/banners/shop_sweatshirt.jpg"] };
	
	function ProductsByTypePage(props) {
		var productTypeUrl = props.match.params[0].toLowerCase();
	
		var _useState = (0, _react.useState)(true),
		    _useState2 = _slicedToArray(_useState, 2),
		    loadMore = _useState2[0],
		    setLoadMore = _useState2[1];
	
		var _useState3 = (0, _react.useState)(_ProductStore2.default.getProductsByType(productTypeUrl)),
		    _useState4 = _slicedToArray(_useState3, 2),
		    products = _useState4[0],
		    setProducts = _useState4[1];
	
		var pagination = _ProductStore2.default.getProductsByTypePagination(productTypeUrl);
	
		var onLoadMore = function onLoadMore() {
			if (loadMore === false) setLoadMore(true);
		};
	
		(0, _react.useEffect)(function () {
			var recentProducts = _ProductStore2.default.getProductsByType(productTypeUrl);
			setProducts(recentProducts);
	
			var recentPagination = _ProductStore2.default.getProductsByTypePagination(productTypeUrl);
			if (recentPagination.nextPageNumber === 0 && loadMore === false) setLoadMore(true);
		}, [productTypeUrl]);
	
		(0, _react.useEffect)(function () {
			var listener = _ProductStore2.default.addListener(function () {
				setProducts(_ProductStore2.default.getProductsByType(productTypeUrl));
			});
	
			if (loadMore === true) {
				var productType = _AppUtil2.default.findProductTypeFromURL(productTypeUrl);
				_ProductAPI2.default.getProductsByType(productType, pagination.nextPageNumber, _AppConstants2.default.DEFAULT_PRODUCT_PAGE_SIZE, function () {
					setLoadMore(false);
				});
			}
	
			return function () {
				return listener.remove();
			};
		}, [productTypeUrl, loadMore]);
	
		var headerImg = BANNERS[productTypeUrl] ? BANNERS[productTypeUrl].sort(function () {
			return .5 - Math.random();
		})[0] : null;
	
		return _react2.default.createElement(
			_SetoCanvasPage2.default,
			{ id: 'typeProducts', title: productTypeUrl.toUpperCase() + " | Seto Canvas",
				metaDescription: "Purchase " + productTypeUrl + " and many more at SetoCanvas.com" },
			headerImg && _react2.default.createElement(_HeaderBanner2.default, { bannerImages: [{ img: headerImg, title: "Shop " + productTypeUrl.toUpperCase() + " at setocanvas.com" }] }),
			_react2.default.createElement(_ProductList2.default, { products: products, flattenProductImages: true,
				emptyMsg: 'Coming Soon!!!',
				loadMore: onLoadMore,
				hasMore: pagination.hasMore })
		);
	}
	
	exports.default = ProductsByTypePage;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _RedeemHistoryContainer = __webpack_require__(520);
	
	var _RedeemHistoryContainer2 = _interopRequireDefault(_RedeemHistoryContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedeemHistoryPage = function (_React$Component) {
		_inherits(RedeemHistoryPage, _React$Component);
	
		function RedeemHistoryPage() {
			_classCallCheck(this, RedeemHistoryPage);
	
			return _possibleConstructorReturn(this, (RedeemHistoryPage.__proto__ || Object.getPrototypeOf(RedeemHistoryPage)).apply(this, arguments));
		}
	
		_createClass(RedeemHistoryPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(_RedeemHistoryContainer2.default, null),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return RedeemHistoryPage;
	}(_react2.default.Component);
	
	exports.default = RedeemHistoryPage;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _AppElements = __webpack_require__(9);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _SearchInput = __webpack_require__(94);
	
	var _SearchInput2 = _interopRequireDefault(_SearchInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchResultPage = function (_React$Component) {
	    _inherits(SearchResultPage, _React$Component);
	
	    function SearchResultPage() {
	        _classCallCheck(this, SearchResultPage);
	
	        return _possibleConstructorReturn(this, (SearchResultPage.__proto__ || Object.getPrototypeOf(SearchResultPage)).apply(this, arguments));
	    }
	
	    _createClass(SearchResultPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var keyword = SearchResultPage.fetchSearchKeyword(this.props);
	
	            if (this.state.products === null) _ProductAPI2.default.searchProducts(keyword);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var prevKeyword = SearchResultPage.fetchSearchKeyword(prevProps);
	            var currentKeyword = SearchResultPage.fetchSearchKeyword(this.props);
	
	            if (prevKeyword.toLowerCase() !== currentKeyword.toLowerCase()) {
	                if (!_ProductStore2.default.getSearchProducts(currentKeyword)) _ProductAPI2.default.searchProducts(currentKeyword);
	            }
	        }
	    }, {
	        key: 'getEmptyMsg',
	        value: function getEmptyMsg(keyword) {
	            var words = keyword.split(" ");
	
	            var eachWordSearch = null;
	            if (words.length > 1) {
	                eachWordSearch = _react2.default.createElement(
	                    'span',
	                    null,
	                    'Try searching for ',
	                    words.map(function (w) {
	                        return _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(
	                                _AppElements.A,
	                                { href: "/search/" + w },
	                                '\'',
	                                w,
	                                '\''
	                            ),
	                            ', '
	                        );
	                    })
	                );
	            } else {
	                eachWordSearch = _react2.default.createElement(
	                    'span',
	                    null,
	                    'Try using other words'
	                );
	            }
	            return _react2.default.createElement(
	                'small',
	                null,
	                'Nothing found. ',
	                eachWordSearch,
	                _react2.default.createElement('br', null),
	                ' ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    'OR'
	                ),
	                ' ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: 'https://m.me/setocanvas.com' },
	                        'DM US'
	                    ),
	                    ' to help you find it.'
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var keyword = SearchResultPage.fetchSearchKeyword(this.props);
	
	            var emptyMsg = this.getEmptyMsg(keyword);
	            var popularTags = _AppConstants2.default.TOP_TAGS.map(function (t) {
	                return _react2.default.createElement(
	                    'span',
	                    { key: "search_tag_" + t.name, className: 'tags' },
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: "/search/" + t.name },
	                        t.value
	                    )
	                );
	            });
	            return _react2.default.createElement(
	                'div',
	                { id: 'searchResultPage' },
	                _react2.default.createElement(
	                    _reactHelmet.Helmet,
	                    null,
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        keyword.toUpperCase(),
	                        ' Search Results | Seto Canvas'
	                    ),
	                    _react2.default.createElement('meta', { name: 'description', content: "Purchase T-Shirts, Sweatshirts, Hoodies and many more at SetoCanvas.com" })
	                ),
	                _react2.default.createElement(_HeaderContainer2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mainContainer' },
	                    _react2.default.createElement(_SearchInput2.default, { keyword: keyword, title: 'SEARCH FROM 1,000+ UNIQUE SELECTIONS' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'searchResTags flexRow' },
	                        popularTags
	                    ),
	                    keyword && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_AppElements.Separator, { style: { margin: '40px auto 20px auto' } }),
	                        _react2.default.createElement(_ProductList2.default, { products: this.state.products,
	                            flattenProductImages: true,
	                            viewProductTags: true,
	                            emptyMsg: emptyMsg })
	                    )
	                ),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }], [{
	        key: 'getStores',
	        value: function getStores() {
	            return [_ProductStore2.default];
	        }
	    }, {
	        key: 'calculateState',
	        value: function calculateState(prevState, props) {
	            var keyword = SearchResultPage.fetchSearchKeyword(props);
	
	            var newState = {
	                products: _ProductStore2.default.getSearchProducts(keyword)
	            };
	            return newState;
	        }
	    }, {
	        key: 'fetchSearchKeyword',
	        value: function fetchSearchKeyword(props) {
	            var keyword = props.match.params.keyword;
	            return keyword ? keyword : '';
	        }
	    }]);
	
	    return SearchResultPage;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(_utils.Container.create(SearchResultPage, { withProps: true }));

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _AppElements = __webpack_require__(9);
	
	var _ReduceStoreHook = __webpack_require__(45);
	
	var _ReduceStoreHook2 = _interopRequireDefault(_ReduceStoreHook);
	
	var _UserHook = __webpack_require__(72);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _UserAvatar = __webpack_require__(48);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _StoreList = __webpack_require__(220);
	
	var _StoreList2 = _interopRequireDefault(_StoreList);
	
	var _HeaderBanner = __webpack_require__(47);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _Loader = __webpack_require__(63);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _ProductTabsByType = __webpack_require__(232);
	
	var _ProductTabsByType2 = _interopRequireDefault(_ProductTabsByType);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getBannerImages(storeInfo) {
		if (!storeInfo || !storeInfo.bannerImages) return null;
	
		var bannerImages = storeInfo.bannerImages.map(function (i) {
			return { "img": i, "title": storeInfo.storeName + " - Merchandise" };
		});
		return bannerImages;
	}
	
	var StorePendingMsg = function StorePendingMsg() {
	
		return _react2.default.createElement(
			'div',
			{ style: { padding: '2px 10px', fontSize: '120%', fontWeight: 'bold',
					textAlign: 'center', margin: '10px 0', background: '#f8931b', color: 'white' } },
			'Your account is pending approval! Our moderator will review and get back to you as soon as possible.'
		);
	};
	
	var StoreAvatar = function StoreAvatar(_ref) {
		var user = _ref.user;
	
		var currentSession = _SessionStore2.default.getCurrentSession();
		var isCurrentUser = currentSession && user && currentSession.user.id === user.id;
	
		var isCurrentAdmin = _AppUtil2.default.isAdminUser(currentSession ? currentSession.user : null);
		var isAdmin = _AppUtil2.default.isAdminUser(user);
	
		var editUrl = null;
		if (isCurrentAdmin && !isAdmin && user !== null) editUrl = "/" + user.id + "/settings";else editUrl = "/settings";
	
		var editIcon = isCurrentUser || isCurrentAdmin ? _react2.default.createElement(
			_AppElements.A,
			{ href: editUrl, id: 'userEditIcon' },
			_react2.default.createElement('i', { className: 'fa fa-pencil-square-o', 'aria-hidden': 'true' })
		) : null;
		var dashboardIcon = user !== null && isCurrentAdmin ? _react2.default.createElement(
			'a',
			{ href: "/designer/" + user.id + "/dashboard", id: 'userDashboardIcon' },
			_react2.default.createElement('i', { className: 'fa fa-dashboard', 'aria-hidden': 'true' })
		) : null;
	
		var storeTitle = user ? _react2.default.createElement(
			'h2',
			{ className: 'userTitle' },
			user.storeName.toUpperCase(),
			' ',
			editIcon,
			' ',
			dashboardIcon
		) : _react2.default.createElement(_Loader2.default, { className: 'userTitleLoader' });
		var storeBio = user ? _react2.default.createElement(
			'span',
			{ className: 'userBio' },
			user.about
		) : _react2.default.createElement(_Loader2.default, { className: 'userBioLoader' });
		return _react2.default.createElement(
			'div',
			{ className: 'storeAvatar flexRow' },
			_react2.default.createElement(_UserAvatar2.default, { user: user }),
			_react2.default.createElement(
				'div',
				{ className: 'storeBio flexColumn' },
				storeTitle,
				storeBio
			)
		);
	};
	
	var StorePage = function StorePage(props) {
		var storeName = props.match.params.storeName.replace(/-/g, " ");
		if (storeName === 'MMA Merch Nepal') storeName = "MMA Fan Nepal";
	
		var storeProducts = (0, _ReduceStoreHook2.default)(_ProductStore2.default, function (store) {
			return store.getStoreProducts(storeName);
		}, function () {
			return _HttpService2.default.getStoreProducts(storeName);
		}, [storeName]);
	
		var storeInfo = (0, _UserHook.userStoreInfo)(storeName);
		var bannerImages = getBannerImages(storeInfo);
	
		var currentSession = _SessionStore2.default.getCurrentSession();
		var currentUser = currentSession ? currentSession.user : null;
		var popularStores = (0, _UserHook.useStoresAndInfluencers)();
		popularStores = popularStores ? popularStores.filter(function (s) {
			return s.storeName && s.storeName !== storeName;
		}) : null;
	
		var isAuthorized = storeInfo && currentUser && storeInfo.id === currentUser.id && storeInfo.userStatus === "PENDING_APPROVAL";
		return _react2.default.createElement(
			_SetoCanvasPage2.default,
			{ title: storeName.toUpperCase() + " Merchandise | Seto Canvas",
				metaDescription: "Purchase " + storeName + " merchandise and many more at SetoCanvas.com" },
			isAuthorized && _react2.default.createElement(StorePendingMsg, null),
			_react2.default.createElement(_HeaderBanner2.default, { bannerImages: bannerImages, title: storeName }),
			_react2.default.createElement(StoreAvatar, { user: storeInfo }),
			storeProducts && storeProducts.length > 20 && _react2.default.createElement(_ProductTabsByType2.default, { products: storeProducts,
				ownerName: storeName }),
			(!storeProducts || storeProducts.length <= 20) && _react2.default.createElement(_ProductList2.default, { products: storeProducts, viewProductTags: true, flattenProductImages: true,
				productViewMode: 'productOnly', emptyMsg: 'No Products Found' }),
			_react2.default.createElement(_AppElements.Separator, null),
			_react2.default.createElement(_StoreList2.default, { stores: popularStores, title: 'More Stores', appendViewAll: true })
		);
	};
	
	exports.default = StorePage;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SubmitProductForm = __webpack_require__(222);
	
	var _SubmitProductForm2 = _interopRequireDefault(_SubmitProductForm);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _HeaderBanner = __webpack_require__(47);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmitDesignPage = function (_React$Component) {
		_inherits(SubmitDesignPage, _React$Component);
	
		function SubmitDesignPage() {
			_classCallCheck(this, SubmitDesignPage);
	
			return _possibleConstructorReturn(this, (SubmitDesignPage.__proto__ || Object.getPrototypeOf(SubmitDesignPage)).apply(this, arguments));
		}
	
		_createClass(SubmitDesignPage, [{
			key: 'render',
			value: function render() {
				var productTypes = _AppConstants2.default.PRODUCT_TYPES;
	
				var psdTemplates = Object.keys(productTypes).map(function (k) {
					return productTypes[k];
				}).filter(function (p) {
					return p.available === true && p.psdTemplateUrl !== undefined && p.psdTemplateUrl !== null && p.psdTemplateUrl.length > 0;
				}).map(function (p) {
					return _react2.default.createElement(
						'li',
						{ key: p.label + "-psd-template" },
						_react2.default.createElement(
							_AppElements.A,
							{ href: p.psdTemplateUrl },
							p.label,
							'.psd'
						)
					);
				});
	
				return _react2.default.createElement(
					_SetoCanvasPage2.default,
					{ id: 'submitDesignPage', title: 'Submit your Design and Start Earning From Home | Seto Canvas',
						metaDescription: 'Seto Canvas is a marketplace for Designers to sell their art printed on merchandise like TShirts, Mugs, Pillows and more.' },
					_react2.default.createElement(_HeaderBanner2.default, { bannerImages: [{ "img": "/images/banners/hga-campaign/HGA Contest Banner.jpeg", "title": "High Ground Adventure Design Contest at setocanvas.com", "url": "/high-ground-adventure-design" }, { img: "/images/banners/submit_design_banner.jpg", title: "Submit your design at setocanvas.com" }, { img: "/images/banners/photographer_banner.png", title: "Submit your photograph at setocanvas.com" }] }),
					_react2.default.createElement(
						'div',
						{ className: 'flexRow', style: { margin: '10px 0 20px 0px', justifyContent: 'space-evenly' } },
						_react2.default.createElement(_SubmitProductForm2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'flexColumn' },
							_react2.default.createElement(
								'div',
								{ id: 'designTemplates' },
								_react2.default.createElement(
									'h3',
									null,
									'Product Templates'
								),
								_react2.default.createElement(
									'span',
									null,
									'Use the template to put your design on a T-Shirt or a Hoodie.'
								),
								_react2.default.createElement(
									'ul',
									null,
									psdTemplates
								)
							),
							_react2.default.createElement(_AppElements.Separator, null),
							_react2.default.createElement(
								'div',
								{ id: 'designerDocs' },
								_react2.default.createElement(
									'h3',
									null,
									'Documents'
								),
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_AppElements.A,
											{ href: '/how-to-make-money' },
											'How does Seto Canvas works?'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_AppElements.A,
											{ href: '/how-much-can-i-make' },
											'How much can I make?'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_AppElements.A,
											{ href: '/faq#tshirtDesignLimitation' },
											'What kind of designs are supported on Tshirts?'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_AppElements.A,
											{ href: '/faq#hoodiesDesignLimitation' },
											'What kind of designs are supported on Hoodies?'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_AppElements.A,
											{ href: '/faq#designerFAQ' },
											'FAQ For Designers'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_AppElements.A,
											{ href: '/faq#photographerFAQ' },
											'FAQ For Photographers'
										)
									)
								)
							),
							_react2.default.createElement(_AppElements.Separator, null),
							_react2.default.createElement(
								'div',
								{ id: 'fbGroup' },
								_react2.default.createElement(
									'h3',
									null,
									'Design Heroes Group'
								),
								_react2.default.createElement(
									'div',
									{ className: 'flexColumn' },
									_react2.default.createElement(
										_AppElements.A,
										{ id: 'joinFBGroupBtn', href: _AppConstants2.default.FB_GROUP },
										_react2.default.createElement('i', { className: 'fa fa-facebook-official', 'aria-hidden': 'true' }),
										' Join our Facebook Group of Artist'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return SubmitDesignPage;
	}(_react2.default.Component);
	
	exports.default = SubmitDesignPage;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProfilePicForm = __webpack_require__(596);
	
	var _ProfilePicForm2 = _interopRequireDefault(_ProfilePicForm);
	
	var _BannersForm = __webpack_require__(592);
	
	var _BannersForm2 = _interopRequireDefault(_BannersForm);
	
	var _UserSettingsForm = __webpack_require__(599);
	
	var _UserSettingsForm2 = _interopRequireDefault(_UserSettingsForm);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _UserHook = __webpack_require__(72);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserSettingsPage = function UserSettingsPage(props) {
		var readOnly = false;
		var user = null;
		if (props.match.params.userId) {
			var userId = props.match.params.userId;
			user = (0, _UserHook.userDesignerInfo)(userId);
			readOnly = true;
		} else {
			var session = (0, _UserHook.useCurrentSession)();
			user = session ? session.user : null;
		}
	
		var pageUrl = user ? _AppUtil2.default.getDesignerURL(user) : null;
		return _react2.default.createElement(
			_SetoCanvasPage2.default,
			{ id: 'userSettingsPage', title: 'User Settings | Seto Canvas' },
			_react2.default.createElement(
				'div',
				{ style: { width: '50%', margin: '20px auto',
						'@media (max-width: 500px)': { width: 'auto', padding: '20px', margin: '0' } } },
				user !== null && _react2.default.createElement(
					'div',
					null,
					pageUrl && pageUrl !== "#" && _react2.default.createElement(
						_AppElements.A,
						{ href: pageUrl },
						_react2.default.createElement(
							'h2',
							null,
							'Go To My Page'
						)
					),
					_react2.default.createElement(_ProfilePicForm2.default, { user: user, readOnly: readOnly }),
					_react2.default.createElement(_UserSettingsForm2.default, { user: user, readOnly: readOnly }),
					user.storeName && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_BannersForm2.default, { bannerImages: user.bannerImages, storeName: user.storeName })
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_AppElements.Title, { title: 'Deactivate Your Account !!!', style: { textAlign: 'left' }, separatorPosition: 'bottom' }),
						_react2.default.createElement(
							_AppElements.Button,
							{ href: "/deactivate" + (props.match.params.userId ? "/" + props.match.params.userId : ""), mui: 'true', color: 'secondary', style: { width: '100%' } },
							_react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' }),
							' Deactivate'
						)
					)
				)
			)
		);
	};
	
	exports.default = UserSettingsPage;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminDashboardTabs = __webpack_require__(95);
	
	var _AdminDashboardTabs2 = _interopRequireDefault(_AdminDashboardTabs);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	var _reactTable = __webpack_require__(50);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMediaLink = function SocialMediaLink(_ref) {
	    var link = _ref.link,
	        label = _ref.label;
	
	    if (!link) return null;
	
	    var url = link;
	    if (!url.startsWith("http")) {
	        url = "https://" + url;
	    }
	
	    return _react2.default.createElement(
	        _AppElements.A,
	        { href: url, target: '_blank' },
	        label
	    );
	};
	
	var AllUsersDashboardPage = function AllUsersDashboardPage() {
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        users = _useState2[0],
	        setUsers = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        showLoading = _useState4[0],
	        setShowLoading = _useState4[1];
	
	    (0, _react.useEffect)(function () {
	        _UserAPI2.default.getAllUsers(0, 100, ["INFLUENCER", "MERCHANT"], "PENDING_APPROVAL", function (allUsers) {
	            console.log("allUsers", allUsers);
	            setUsers(allUsers);
	            setShowLoading(false);
	        });
	    }, []);
	
	    var approveUser = function approveUser(user) {
	        var res = confirm("Are you sure you want to approve '" + user.username + "' account?");
	
	        if (res === true) {
	            setShowLoading(true);
	            _UserAPI2.default.updateUserStatus(user.id, "ACTIVE", function () {
	                var updatedUsers = users.map(function (u) {
	                    if (u.id === user.id) {
	                        u.userStatus = 'ACTIVE';
	                    }
	                    return u;
	                });
	                setUsers(updatedUsers);
	                setShowLoading(false);
	            });
	        }
	    };
	
	    var columns = [{ Header: 'Name', accessor: 'username', Cell: function Cell(props) {
	            var u = props.original;
	            var url = _AppUtil2.default.getDesignerURL(u);
	            return _react2.default.createElement(
	                _AppElements.A,
	                { href: url, target: '_blank' },
	                props.value
	            );
	        } }, { Header: 'Email', accessor: 'emailAddress', Cell: function Cell(props) {
	            var u = props.original;
	            var emailVerified = u.verified;
	            return _react2.default.createElement(
	                'div',
	                { className: 'flexColumn', style: { alignItems: 'center' } },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    props.value
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { style: { color: emailVerified ? 'green' : 'red' } },
	                    emailVerified === true ? 'Verified' : 'Not Verified'
	                )
	            );
	        } }, { Header: 'Phone', accessor: 'phoneNumber' }, { Header: 'User Type', accessor: 'userType' }, { Header: 'Social Media', accessor: 'socialMediaAccounts', Cell: function Cell(props) {
	            var socialMediaAccounts = props.value;
	            var fbUrl = socialMediaAccounts ? socialMediaAccounts['FB'] : null;
	            var instaUrl = socialMediaAccounts ? socialMediaAccounts['INSTA'] : null;
	            var tiktokUrl = socialMediaAccounts ? socialMediaAccounts['TIKTOK'] : null;
	            var youtubeUrl = socialMediaAccounts ? socialMediaAccounts['YOUTUBE'] : null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flexColumn', style: { justifyContent: 'space-around', fontSize: '110%', flexWrap: 'nowrap' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexRow', style: { justifyContent: 'space-around' } },
	                    _react2.default.createElement(SocialMediaLink, { link: fbUrl, label: 'FB' }),
	                    _react2.default.createElement(SocialMediaLink, { link: instaUrl, label: 'Instagram' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexRow', style: { justifyContent: 'space-around' } },
	                    _react2.default.createElement(SocialMediaLink, { link: youtubeUrl, label: 'Youtube' }),
	                    _react2.default.createElement(SocialMediaLink, { link: tiktokUrl, label: 'TikTok' })
	                )
	            );
	        } }, { Header: 'Action', Cell: function Cell(props) {
	            var u = props.original;
	            return _react2.default.createElement(
	                'div',
	                { className: 'flexColumn', style: { alignItems: 'center' } },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    u.userStatus
	                ),
	                u.userStatus === 'PENDING_APPROVAL' && _react2.default.createElement(
	                    _AppElements.Button,
	                    { disabled: showLoading, style: { marginTop: '10px', background: '#f8f8ff', padding: '5px', borderRadius: '5px', cursor: 'pointer' },
	                        onClick: function onClick() {
	                            approveUser(u);
	                        } },
	                    'Approve Account'
	                )
	            );
	        } }];
	
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { title: 'Users Dashboard | Seto Canvas', id: 'usersDashboardPage' },
	        _react2.default.createElement(
	            _AdminDashboardTabs2.default,
	            { active: 'users' },
	            _react2.default.createElement(
	                'div',
	                { className: 'mainContainer', style: { padding: '30px 0' } },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Pending Users'
	                ),
	                _react2.default.createElement(_reactTable2.default, { data: users ? users : [], columns: columns, minRows: 5,
	                    noDataText: 'No Pending Users Found.', loading: showLoading,
	                    className: '-pending-users-highlight', defaultPageSize: 15
	                })
	            )
	        )
	    );
	};
	
	exports.default = AllUsersDashboardPage;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrderDashboardContainer = __webpack_require__(517);
	
	var _OrderDashboardContainer2 = _interopRequireDefault(_OrderDashboardContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrdersDashboardPage = function (_React$Component) {
		_inherits(OrdersDashboardPage, _React$Component);
	
		function OrdersDashboardPage() {
			_classCallCheck(this, OrdersDashboardPage);
	
			return _possibleConstructorReturn(this, (OrdersDashboardPage.__proto__ || Object.getPrototypeOf(OrdersDashboardPage)).apply(this, arguments));
		}
	
		_createClass(OrdersDashboardPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_OrderDashboardContainer2.default, null);
			}
		}]);
	
		return OrdersDashboardPage;
	}(_react2.default.Component);
	
	exports.default = OrdersDashboardPage;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReduceStoreHook = __webpack_require__(45);
	
	var _ReduceStoreHook2 = _interopRequireDefault(_ReduceStoreHook);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _formik = __webpack_require__(21);
	
	var _FormElements = __webpack_require__(13);
	
	var _AdminDashboardTabs = __webpack_require__(95);
	
	var _AdminDashboardTabs2 = _interopRequireDefault(_AdminDashboardTabs);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMOBO_OPTIONS = [{ label: 'Pending Approval', value: _AppConstants2.default.PRODUCT_STATE.PENDING_APPROVAL }, { label: 'Approved', value: _AppConstants2.default.PRODUCT_STATE.APPROVED }, { label: 'Unpublished', value: _AppConstants2.default.PRODUCT_STATE.UNPUBLISHED }];
	
	var Form = (0, _radium2.default)(function (props) {
		return _react2.default.createElement(
			'div',
			{ style: { width: '40%', '@media (max-width: 770px)': { width: '100%' } } },
			_react2.default.createElement(
				_FormElements.RGForm,
				{ style: { display: 'flex', flexDirection: 'row', padding: '15px 20px' } },
				_react2.default.createElement(
					'h3',
					{ style: { margin: '0 10px 0 0' } },
					'Design State'
				),
				_react2.default.createElement(_FormElements.ComboBox, { name: 'productState', value: props.values.productState,
					options: COMOBO_OPTIONS, clearable: false,
					style: { flexGrow: '1', margin: '0' } })
			)
		);
	});
	
	function FormikForm(formikProps) {
		var productState = formikProps.values.productState;
		var allProducts = (0, _ReduceStoreHook2.default)(_ProductStore2.default, function (store) {
			return store.getAllProducts(productState);
		}, function () {
			return _HttpService2.default.getAllProducts(productState);
		}, [productState]);
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(Form, formikProps),
			_react2.default.createElement(_ProductList2.default, { products: allProducts, productViewMode: "both" })
		);
	}
	
	function ProductsDashboardPage(props) {
		return _react2.default.createElement(
			_SetoCanvasPage2.default,
			{ title: 'Products Dashboard | Seto Canvas', id: 'productsDashboardPage' },
			_react2.default.createElement(
				_AdminDashboardTabs2.default,
				{ active: 'products' },
				_react2.default.createElement(_formik.Formik, { initialValues: { productState: _AppConstants2.default.PRODUCT_STATE.PENDING_APPROVAL },
					onSubmit: function onSubmit() {},
					render: function render(formikProps) {
						return _react2.default.createElement(FormikForm, formikProps);
					} })
			)
		);
	}
	
	exports.default = (0, _radium2.default)(ProductsDashboardPage);

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppElements = __webpack_require__(9);
	
	var _StockOwnerAPI = __webpack_require__(217);
	
	var _StockOwnerAPI2 = _interopRequireDefault(_StockOwnerAPI);
	
	var _StockAPI = __webpack_require__(73);
	
	var _StockAPI2 = _interopRequireDefault(_StockAPI);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _StockStore = __webpack_require__(92);
	
	var _StockStore2 = _interopRequireDefault(_StockStore);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _EachStockOwner = __webpack_require__(572);
	
	var _EachStockOwner2 = _interopRequireDefault(_EachStockOwner);
	
	var _AdminDashboardTabs = __webpack_require__(95);
	
	var _AdminDashboardTabs2 = _interopRequireDefault(_AdminDashboardTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LAST_FETCHED_OWNER = "last_fetched_owner";
	
	var StockDashboardPage = function (_React$Component) {
	    _inherits(StockDashboardPage, _React$Component);
	
	    function StockDashboardPage() {
	        _classCallCheck(this, StockDashboardPage);
	
	        return _possibleConstructorReturn(this, (StockDashboardPage.__proto__ || Object.getPrototypeOf(StockDashboardPage)).apply(this, arguments));
	    }
	
	    _createClass(StockDashboardPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var stockOwnerName = StockDashboardPage.getStockOwnerFromPath(this.props) || _CacheService2.default.get(LAST_FETCHED_OWNER);
	
	            if (stockOwnerName) {
	                _CacheService2.default.save(LAST_FETCHED_OWNER, stockOwnerName);
	                this.fetchStockOwnerInfo(stockOwnerName);
	            }
	
	            if (this.state.stockOwners === null && this.state.isAdmin) _StockOwnerAPI2.default.getAllOwners();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var stockOwnerName = StockDashboardPage.getStockOwnerFromPath(nextProps);
	
	            if (stockOwnerName) {
	                _CacheService2.default.save(LAST_FETCHED_OWNER, stockOwnerName);
	                this.fetchStockOwnerInfo(stockOwnerName);
	            }
	        }
	    }, {
	        key: 'fetchStockOwnerInfo',
	        value: function fetchStockOwnerInfo(stockOwnerName) {
	            if (!_StockStore2.default.getStockOwner(stockOwnerName)) _StockOwnerAPI2.default.getStockOwner(stockOwnerName);
	
	            if (!_StockStore2.default.getStocks(stockOwnerName)) _StockAPI2.default.getStocks(stockOwnerName);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stockOwner = this.state.stockOwner;
	
	            var stockOwners = this.state.stockOwners;
	            var ownerButtons = stockOwners ? stockOwners.map(function (o) {
	                return _react2.default.createElement(
	                    _AppElements.A,
	                    { style: { padding: '10px', margin: '10px' },
	                        href: "/stock/" + o.ownerAlias, className: stockOwner && o.ownerAlias === stockOwner.ownerAlias ? 'active-owner' : 'inactive-owner', key: o.ownerAlias },
	                    o.ownerAlias
	                );
	            }) : null;
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'stockDashboard' },
	                _react2.default.createElement(
	                    _reactHelmet.Helmet,
	                    null,
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        'Inventory Dashboard | Seto Canvas'
	                    )
	                ),
	                _react2.default.createElement(_HeaderContainer2.default, null),
	                this.state.isAdmin === true && _react2.default.createElement(
	                    _AdminDashboardTabs2.default,
	                    { active: 'stocks' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mainContainer', style: { padding: '30px 0' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flexRow' },
	                            ownerButtons
	                        ),
	                        stockOwner && _react2.default.createElement(_EachStockOwner2.default, { stockOwner: stockOwner, stocks: this.state.stocks, allOwners: stockOwners, isAdmin: true })
	                    )
	                ),
	                this.state.isAdmin === false && _react2.default.createElement(
	                    'div',
	                    { className: 'mainContainer', style: { padding: '30px 0' } },
	                    stockOwner && _react2.default.createElement(_EachStockOwner2.default, { stockOwner: stockOwner, stocks: this.state.stocks, allOwners: stockOwners, isAdmin: false })
	                ),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }], [{
	        key: 'getStores',
	        value: function getStores() {
	            return [_StockStore2.default];
	        }
	    }, {
	        key: 'calculateState',
	        value: function calculateState(prevState, props) {
	            var stockOwnerName = StockDashboardPage.getStockOwnerFromPath(props);
	
	            if (!stockOwnerName) stockOwnerName = _CacheService2.default.get(LAST_FETCHED_OWNER);
	
	            var currentSession = _SessionStore2.default.getCurrentSession();
	            var newState = {
	                stockOwners: _StockStore2.default.getStockOwners(),
	                stockOwner: stockOwnerName ? _StockStore2.default.getStockOwner(stockOwnerName) : null,
	                stocks: stockOwnerName ? _StockStore2.default.getStocks(stockOwnerName) : null,
	                isAdmin: currentSession && currentSession.user.userType === _AppConstants2.default.USER_TYPE.ADMIN
	            };
	
	            return newState;
	        }
	    }, {
	        key: 'getStockOwnerFromPath',
	        value: function getStockOwnerFromPath(props) {
	            var stockOwner = props.match.params.stockOwner;
	            return stockOwner;
	        }
	    }]);
	
	    return StockDashboardPage;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(_utils.Container.create(StockDashboardPage, { withProps: true }));

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DCUtil = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _OrderStore = __webpack_require__(61);
	
	var _OrderStore2 = _interopRequireDefault(_OrderStore);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactSticky = __webpack_require__(103);
	
	var _DateComponent = __webpack_require__(62);
	
	var _DateComponent2 = _interopRequireDefault(_DateComponent);
	
	var _copyToClipboard = __webpack_require__(121);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _AdAPI = __webpack_require__(139);
	
	var _AdAPI2 = _interopRequireDefault(_AdAPI);
	
	var _AppAction = __webpack_require__(22);
	
	__webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CAMPAIGN_URL = _AppConstants2.default.WEBSITE + "/chetan-vlog-camper";
	
	var CHETAN_STORE = "Chetan Vlog";
	
	var TOTAL_ORDERS_TARGET = 100;
	
	var DCUtil = exports.DCUtil = {
	    isCampaignActive: function isCampaignActive() {
	        var today = new Date();
	        var endDate = this.campaignEndDate();
	        return today.getTime() < endDate.getTime();
	    },
	
	    campaignStartDate: function campaignStartDate() {
	        //Aug 29
	        return new Date(2021, 1, 19);
	    },
	    campaignEndDate: function campaignEndDate() {
	        //Sep 30
	        return new Date(2022, 1, 19);
	    }
	};
	
	var ContributersList = function ContributersList(props) {
	    var contributers = props.contributers;
	
	    if (contributers === null || contributers.size === 0) return _react2.default.createElement(
	        'div',
	        { id: 'firstToContribute' },
	        '- Be the First to Contribute!'
	    );
	
	    console.log("contributers", contributers);
	    //Ram hari Bought one Gorkhali Hustle Tshirt
	    var contributersLi = contributers.map(function (c) {
	        var productURL = _AppUtil2.default.getProductURL(c.product);
	        var delivered = c.orderState === _AppConstants2.default.ORDER_STATE.DELIVERED.value;
	
	        var donationInfo = null;
	        if (delivered) {
	            donationInfo = _react2.default.createElement(
	                'span',
	                { className: 'donatedInfo deliveredInfo' },
	                _react2.default.createElement('i', { className: 'fa fa-check-circle', 'aria-hidden': 'true' }),
	                ' ',
	                c.quantity,
	                ' order profit donated to campaign.'
	            );
	        } else {
	            donationInfo = _react2.default.createElement(
	                'span',
	                { className: 'donatedInfo pendingDeliveryInfo' },
	                _react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
	                ' Pending Delivery.'
	            );
	        }
	
	        var productStr = _react2.default.createElement(
	            _AppElements.A,
	            { href: productURL },
	            c.product.title
	        );
	        return _react2.default.createElement(
	            'li',
	            { key: c.orderId, className: 'eachContributer' },
	            _react2.default.createElement(
	                'b',
	                null,
	                c.user.username
	            ),
	            ' bought ',
	            c.quantity,
	            ' ',
	            productStr,
	            ' ',
	            _AppConstants2.default.PRODUCT_TYPES[c.product.productType].label,
	            ' ',
	            _react2.default.createElement(
	                'small',
	                null,
	                'on ',
	                _react2.default.createElement(_DateComponent2.default, { date: c.createdDate, relative: false })
	            ),
	            _react2.default.createElement('br', null),
	            donationInfo
	        );
	    });
	    return _react2.default.createElement(
	        'ul',
	        { id: 'contributersList' },
	        contributersLi
	    );
	};
	
	var FeaturedProductsModal = function FeaturedProductsModal(props) {
	    var products = props.products;
	
	    return _react2.default.createElement(
	        _reactResponsiveModal2.default,
	        { closeOnOverlayClick: false, open: props.open,
	            onClose: props.onClose,
	            classNames: { modal: 'dashain-campaign-modal', closeIcon: 'dashain-campaign-close-icon' } },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_ProductList2.default, { products: products, showSlider: true,
	                title: CHETAN_STORE + " Merchandise",
	                productViewMode: 'productOnly', navigator: 'arrows',
	                infinite: true,
	                autoplay: false, id: 'featuredProducts', flattenProductImages: true }),
	            _react2.default.createElement(_AppElements.Separator, { style: { margin: '25px auto', width: '50%' } }),
	            _react2.default.createElement(
	                'p',
	                { id: 'chetanCamperSupportMsg' },
	                'Support Chetan Vlog by Purchasing one of his Merchandise. ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Every Profit made will go directly to help him build his Camper.'
	                )
	            )
	        )
	    );
	};
	
	var CampaignStat = (0, _radium2.default)(function (props) {
	    var campaignStat = props.campaignStat;
	
	    return _react2.default.createElement(
	        'div',
	        { style: props.style, id: 'campaignStat' },
	        DCUtil.isCampaignActive() && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h1',
	                { id: 'tshirtRemaining' },
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    campaignStat.totalRemaining
	                ),
	                ' Orders Remaining'
	            ),
	            _react2.default.createElement(_AppElements.Separator, { style: { margin: '0px auto 25px auto', width: '100%' } }),
	            _react2.default.createElement(
	                'h4',
	                { id: 'tshirtFulfilled' },
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    campaignStat.totalFulfilled,
	                    '/',
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        '100'
	                    ),
	                    ' Orders Fulfilled'
	                )
	            )
	        ),
	        !DCUtil.isCampaignActive() && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h1',
	                { id: 'tshirtFulfilled' },
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    campaignStat.totalFulfilled,
	                    '/',
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        '100'
	                    ),
	                    ' Orders Fulfilled'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _AppElements.Button,
	            { onClick: props.onContributeNowClick, mui: 'true', color: 'primary', style: { width: '100%' }, className: 'contributeNowBtn' },
	            'Contribute Now'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(
	                'b',
	                null,
	                'You Can Also Help by Sharing!'
	            )
	        ),
	        _react2.default.createElement(_AppElements.Separator, { style: { margin: '0px auto 25px auto', width: '100%' } }),
	        _react2.default.createElement(
	            'h4',
	            { style: { fontSize: '90%', color: 'gray' } },
	            _react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
	            ' Use the link below to share on Facebook, Twitter, Blog and other platforms.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow' },
	            _react2.default.createElement('input', { id: 'campaignLinkInput', type: 'text', value: CAMPAIGN_URL, readOnly: true, style: { flexGrow: '1', padding: '5px 10px' } }),
	            _react2.default.createElement(
	                _AppElements.Button,
	                { id: 'copyLinkBtn', onClick: props.onCopy },
	                _react2.default.createElement('i', { className: 'fa fa-files-o', 'aria-hidden': 'true' }),
	                ' Copy'
	            )
	        ),
	        props.copied && _react2.default.createElement(
	            'small',
	            null,
	            'Copied. You can paste it now.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'socialShareBtns', className: 'flexRow' },
	            _react2.default.createElement(
	                _AppElements.A,
	                { className: 'fbLink', href: 'https://www.facebook.com/', mui: 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-facebook', 'aria-hidden': 'true' }),
	                ' Facebook'
	            ),
	            _react2.default.createElement(
	                _AppElements.A,
	                { className: 'fbLink', href: 'https://twitter.com/home', mui: 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-twitter', 'aria-hidden': 'true' }),
	                ' Twitter'
	            )
	        )
	    );
	});
	
	var ChetanCamper = function (_React$Component) {
	    _inherits(ChetanCamper, _React$Component);
	
	    _createClass(ChetanCamper, null, [{
	        key: 'getStores',
	        value: function getStores() {
	            return [_OrderStore2.default, _ProductStore2.default];
	        }
	    }, {
	        key: 'calculateState',
	        value: function calculateState(prevState) {
	            var newState = {
	                orders: _OrderStore2.default.getActionOrders(_AppAction.OrderAction.LOAD_CHETAN_CAMPAGIN_ORDERS),
	                featuredProducts: _ProductStore2.default.getStoreProducts(CHETAN_STORE),
	                openFeaturedProducts: prevState ? prevState.openFeaturedProducts : false
	            };
	            return newState;
	        }
	    }]);
	
	    function ChetanCamper(props) {
	        _classCallCheck(this, ChetanCamper);
	
	        var _this = _possibleConstructorReturn(this, (ChetanCamper.__proto__ || Object.getPrototypeOf(ChetanCamper)).call(this, props));
	
	        _this.state = { copied: false, openFeaturedProducts: false };
	        _this.onCopy = _this.onCopy.bind(_this);
	        _this.onContributeNowClick = _this.onContributeNowClick.bind(_this);
	        _this.onFeaturedProductsModalClose = _this.onFeaturedProductsModalClose.bind(_this);
	
	        _this.getCampaignStat = _this.getCampaignStat.bind(_this);
	        return _this;
	    }
	
	    _createClass(ChetanCamper, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.state.orders) {
	                _AdAPI2.default.getChetanCampaignOrders();
	            }
	        }
	    }, {
	        key: 'onCopy',
	        value: function onCopy() {
	            this.setState({ copied: (0, _copyToClipboard2.default)(CAMPAIGN_URL) });
	        }
	    }, {
	        key: 'onContributeNowClick',
	        value: function onContributeNowClick() {
	            this.setState({ openFeaturedProducts: true });
	
	            if (!this.state.featuredProducts) {
	                _HttpService2.default.getStoreProducts(CHETAN_STORE);
	            }
	        }
	    }, {
	        key: 'onFeaturedProductsModalClose',
	        value: function onFeaturedProductsModalClose() {
	            this.setState({ openFeaturedProducts: false });
	        }
	    }, {
	        key: 'getCampaignStat',
	        value: function getCampaignStat() {
	            if (this.state.orders) {
	                var totalFulfilled = this.state.orders.size;
	                return { totalFulfilled: totalFulfilled,
	                    totalRemaining: TOTAL_ORDERS_TARGET - totalFulfilled };
	            }
	
	            return { totalFulfilled: "-", totalRemaining: "-" };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var campaignStat = this.getCampaignStat();
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'chetanCampaignPage' },
	                _react2.default.createElement(
	                    _reactHelmet.Helmet,
	                    null,
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        'Purchase Chetan Vlog Merch and You can help him build his Camper Project | Seto Canvas'
	                    ),
	                    _react2.default.createElement('meta', { name: 'description', content: 'Support Chetan Vlog by purchasing any one of his Merch. All profits made from the Merch. will go directly to help him build his Camper.' })
	                ),
	                _react2.default.createElement(_HeaderContainer2.default, null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mainContainer' },
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'campaignHeader', className: 'flexRow', style: { "@media (max-width: 884px)": { height: 'auto' } } },
	                        _react2.default.createElement(_AppElements.Img, { src: '/images/banners/chetan-camper/Camper Small Banner.png', id: 'camperImg', style: { width: '720px' } }),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { '@media (min-width: 884px)': { display: 'none' } }, id: 'mobileStat' },
	                            _react2.default.createElement(CampaignStat, { campaignStat: campaignStat,
	                                onContributeNowClick: this.onContributeNowClick,
	                                copied: this.state.copied, onCopy: this.onCopy })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { '@media (max-width: 884px)': { display: 'none' } }, id: 'webStat' },
	                            _react2.default.createElement(
	                                _reactSticky.Sticky,
	                                { topOffset: 128 },
	                                function (_ref) {
	                                    var style = _ref.style,
	                                        isSticky = _ref.isSticky;
	
	                                    style.margin = '0 10px';
	                                    style.width = 'inherit';
	                                    style.top = '60px';
	
	                                    return _react2.default.createElement(CampaignStat, { style: style, campaignStat: campaignStat,
	                                        onContributeNowClick: _this2.onContributeNowClick,
	                                        copied: _this2.state.copied, onCopy: _this2.onCopy });
	                                }
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'campaignBody', className: 'flexColumn' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: "60%", "@media (max-width: 884px)": { width: '100%' } } },
	                            _react2.default.createElement(
	                                'p',
	                                { id: 'campaignInfo' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { id: 'highlightedMsg' },
	                                    'Our beloved Chetan Raj Karki a.k.a Chetan Vlog has been embarking on a project that seems to be one of its Kind in Nepal.'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'To help him build this project, we, Seto Canvas, will be donating all the profit made on the purchase of ',
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'Chetan Vlog Merchandise.'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'We aim to target ',
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        '100 orders'
	                                    ),
	                                    ' and we need ',
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'YOUR HELP to reach that target'
	                                    ),
	                                    '. Simply purchase any Merchandise from ',
	                                    _react2.default.createElement(
	                                        _AppElements.A,
	                                        { href: "/store/" + CHETAN_STORE },
	                                        'Chetan Vlog Store'
	                                    ),
	                                    ' and for every orders delivered, the profit made will go directly to Chetan Vlog Camper project.'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Contributers List ',
	                                    _react2.default.createElement('i', { className: 'fa fa-thumbs-o-up', 'aria-hidden': 'true' })
	                                )
	                            ),
	                            _react2.default.createElement(_AppElements.Separator, { style: { margin: '0px auto 25px auto', width: '100%' } }),
	                            _react2.default.createElement(ContributersList, { contributers: this.state.orders }),
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'contributeNowSecondBtn' },
	                                _react2.default.createElement(
	                                    _AppElements.Button,
	                                    { onClick: this.onContributeNowClick, mui: 'true', color: 'primary' },
	                                    'Contribute Now'
	                                )
	                            ),
	                            _react2.default.createElement('br', null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(FeaturedProductsModal, { open: this.state.openFeaturedProducts, products: this.state.featuredProducts, onClose: this.onFeaturedProductsModalClose }),
	                _react2.default.createElement(_Footer2.default, null)
	            );
	        }
	    }]);
	
	    return ChetanCamper;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(_utils.Container.create(ChetanCamper));

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _AdAPI = __webpack_require__(139);
	
	var _AdAPI2 = _interopRequireDefault(_AdAPI);
	
	var _input = __webpack_require__(182);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _button = __webpack_require__(84);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _reactCountdownNow = __webpack_require__(194);
	
	var _reactCountdownNow2 = _interopRequireDefault(_reactCountdownNow);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _AppElements = __webpack_require__(9);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _CacheService = __webpack_require__(41);
	
	var _CacheService2 = _interopRequireDefault(_CacheService);
	
	__webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CODERS_MERCH_END_DATE = "CODERS_MERCH_END_DATE";
	
	function isValidEmail(email) {
	    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) return true;
	
	    return false;
	}
	
	var CountDownRenderer = function CountDownRenderer(props) {
	    var isPlural = function isPlural(num) {
	        return num > 1;
	    };
	
	    var hoursLabel = _react2.default.createElement(
	        'div',
	        { className: 'flexColumn eachTimerBox' },
	        _react2.default.createElement(
	            'span',
	            { className: 'timer' },
	            props.formatted.hours
	        ),
	        ' ',
	        _react2.default.createElement(
	            'span',
	            { className: 'timerLabel' },
	            'hour',
	            isPlural(props.hours) ? 's' : ''
	        )
	    );
	    var minutesLabel = _react2.default.createElement(
	        'div',
	        { className: 'flexColumn eachTimerBox' },
	        _react2.default.createElement(
	            'span',
	            { className: 'timer' },
	            props.formatted.minutes
	        ),
	        ' ',
	        _react2.default.createElement(
	            'span',
	            { className: 'timerLabel' },
	            'minute',
	            isPlural(props.minutes) ? 's' : ''
	        )
	    );
	    var secondsLabel = _react2.default.createElement(
	        'div',
	        { className: 'flexColumn eachTimerBox' },
	        _react2.default.createElement(
	            'span',
	            { className: 'timer' },
	            props.formatted.seconds
	        ),
	        ' ',
	        _react2.default.createElement(
	            'span',
	            { className: 'timerLabel' },
	            'second',
	            isPlural(props.seconds) ? 's' : ''
	        )
	    );
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexColumn', id: 'codersCouponCountDown' },
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow timerBox' },
	            hoursLabel,
	            minutesLabel,
	            secondsLabel
	        )
	    );
	};
	
	var EmailForm = function EmailForm() {
	    var _useState = (0, _react.useState)(''),
	        _useState2 = _slicedToArray(_useState, 2),
	        email = _useState2[0],
	        setEmail = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isSubmitting = _useState4[0],
	        setIsSubmitting = _useState4[1];
	
	    var handleInputChange = function handleInputChange(event) {
	        setEmail(event.target.value);
	    };
	
	    var handleFormSubmit = (0, _react.useCallback)(function (event) {
	        event.preventDefault();
	
	        _Dispatcher2.default.dispatchClearAlert();
	        if (!isValidEmail(email)) {
	            _Dispatcher2.default.dispatchAnAlert({ message: "Invalid Email Address", type: "ERROR" });
	            return;
	        }
	
	        setIsSubmitting(true);
	
	        _AdAPI2.default.subscribeToCodersMerchCoupon(email.toLowerCase().trim(), function (success) {
	            console.log("Success", success);
	            setIsSubmitting(false);
	
	            if (success) setEmail('');
	        });
	    }, [email]);
	
	    var endDate = _CacheService2.default.get(CODERS_MERCH_END_DATE);
	
	    if (!endDate) {
	        //add 24 hour to current time;
	        var expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000;
	        endDate = new Date(expiryTime);
	
	        _CacheService2.default.save(CODERS_MERCH_END_DATE, endDate.getTime(), true);
	    } else {
	        endDate = new Date(parseInt(endDate, 10));
	    }
	
	    var hasExpired = endDate.getTime() < new Date().getTime();
	    return _react2.default.createElement(
	        'div',
	        { id: 'codersEmailForm' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            'MERCH FOR CODERS'
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'couponCodeTitle' },
	            'GET AN EXCLUSIVE COUPON CODE FOR',
	            _react2.default.createElement(
	                'h5',
	                { id: 'discountPct' },
	                '15% OFF'
	            )
	        ),
	        _react2.default.createElement(
	            'form',
	            { id: 'couponEmailForm', onSubmit: handleFormSubmit },
	            _react2.default.createElement(_input2.default, { type: 'email', placeholder: 'ENTER YOUR E-MAIL', onChange: handleInputChange, value: email, id: 'couponSubscriberEmailTxt', name: 'couponSubscriberEmailTxt' }),
	            _react2.default.createElement(
	                _button2.default,
	                { type: 'submit', id: 'couponSubscriberSubmitBtn', disabled: isSubmitting || email === '' || hasExpired, onClick: handleFormSubmit },
	                isSubmitting === false && _react2.default.createElement(
	                    'span',
	                    null,
	                    'SUBMIT'
	                ),
	                isSubmitting === true && _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' }),
	                    ' SUBMIT'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            hasExpired ? "OFFER EXPIRED" : "OFFER ENDS IN"
	        ),
	        _react2.default.createElement(_reactCountdownNow2.default, { date: endDate, renderer: CountDownRenderer })
	    );
	};
	
	var CodersCampaign = function CodersCampaign(props) {
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        products = _useState6[0],
	        setProducts = _useState6[1];
	
	    (0, _react.useEffect)(function () {
	        _AdAPI2.default.getCodersMerch(function (products) {
	            setProducts(products);
	        });
	    }, []);
	    return _react2.default.createElement(
	        'div',
	        { id: 'codersCampaign' },
	        _react2.default.createElement(
	            _reactHelmet.Helmet,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                '15% OFF Discount Coupon on Coders Merch, Sweatshirt, Frame For Limited Time | Seto Canvas'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Get 15% off discount coupon on Coders Merch, Sweatshirt, Frame for limited time.' })
	        ),
	        _react2.default.createElement(_HeaderContainer2.default, null),
	        _react2.default.createElement(
	            'div',
	            { id: 'codersCampaignHeader', className: 'flexRow' },
	            _react2.default.createElement(
	                'div',
	                { className: 'merchBannerImg' },
	                _react2.default.createElement(_AppElements.Img, { src: '/images/banners/coders-campaign/sweatshirt-left.jpg', alt: 'May the Stackoverflow be with you Sweatshirt | Coders Merch Available on SetoCanvas.com' })
	            ),
	            _react2.default.createElement(EmailForm, null),
	            _react2.default.createElement(
	                'div',
	                { className: 'merchBannerImg' },
	                _react2.default.createElement(_AppElements.Img, { src: '/images/banners/coders-campaign/sweatshirt-right.jpg', alt: 'There is no place like 127.0.0.1 Sweatshirt | Coders Merch Available on SetoCanvas.com' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'mainContainer' },
	            _react2.default.createElement(_ProductList2.default, { title: "MOST POPULAR", products: products, viewProductTags: true, flattenProductImages: true,
	                productViewMode: 'productOnly', emptyMsg: 'No Coding Merch Found' })
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	    );
	};
	
	exports.default = CodersCampaign;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppElements = __webpack_require__(9);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var photoframe = _AppConstants2.default.PRODUCT_TYPES.PHOTO_FRAME.url;
	
	function DashainFramePage(props) {
	    var _useState = (0, _react.useState)(_ProductStore2.default.getProductsByType(photoframe)),
	        _useState2 = _slicedToArray(_useState, 2),
	        products = _useState2[0],
	        setProducts = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        var listener = _ProductStore2.default.addListener(function () {
	            setProducts(_ProductStore2.default.getProductsByType(photoframe));
	        });
	
	        if (!products) {
	            var productType = _AppUtil2.default.findProductTypeFromURL(photoframe);
	            _ProductAPI2.default.getProductsByType(productType, 0, _AppConstants2.default.DEFAULT_PRODUCT_PAGE_SIZE);
	        }
	
	        return function () {
	            return listener.remove();
	        };
	    }, []);
	
	    var shuffledProducts = products ? products.sort(function () {
	        return .5 - Math.random();
	    }) : products;
	
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'dashainFramePage', title: 'Get your Family Picture Framed at 30% Discount | Seto Canvas', metaDescription: 'Get your Family Picture Framed at 40% Discount at setocanvas.com' },
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow campaignContainer' },
	            _react2.default.createElement(
	                'div',
	                { id: 'discountInfo' },
	                _react2.default.createElement(
	                    'h4',
	                    { style: { margin: '20px 0' } },
	                    'Upload your picture and apply coupon code ',
	                    _react2.default.createElement(
	                        'span',
	                        { style: { color: '#f89516', fontWeight: 'bold', textDecoration: 'underline', fontSize: '120%', margin: '0 5px' } },
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'DASHAIN_TIHAR_79'
	                        )
	                    ),
	                    ' to get 30% discount on frames of all sizes.'
	                ),
	                _react2.default.createElement(
	                    _AppElements.Button,
	                    { id: 'uploadPicBtn', href: '/custom-order/photo-frame', mui: 'true', color: 'primary' },
	                    _react2.default.createElement('i', { className: 'fa fa-cloud-upload', 'aria-hidden': 'true' }),
	                    ' Upload Your Picture'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        'Offer Valid until Nov 16, 2022 / Karthik 30, 2079'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_AppElements.Separator, null),
	        _react2.default.createElement(_AppElements.Img, { src: '/images/banners/dashain/Dashain-PhotoFrame.jpg?v=1.1' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'mainContainer' },
	            _react2.default.createElement(
	                'h2',
	                { style: { color: 'darkcyan', paddingTop: '10px', borderTop: '1px solid gray' } },
	                'Popular Frames! ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: '/shop/photoframe' },
	                        'View All ',
	                        _react2.default.createElement('i', { className: 'fa fa-external-link', 'aria-hidden': 'true' })
	                    )
	                )
	            ),
	            _react2.default.createElement(_ProductList2.default, { products: shuffledProducts, showSlider: true,
	                autoplay: true, navigator: 'arrows',
	                flattenProductImages: true })
	        )
	    );
	}
	
	exports.default = DashainFramePage;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppElements = __webpack_require__(9);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	__webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeafBanner = function LeafBanner(_ref) {
	    var text = _ref.text,
	        id = _ref.id;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexRow leafBanner', id: id || "" },
	        _react2.default.createElement(_AppElements.Img, { src: '/images/banners/hga-campaign/banner-leaf.png' }),
	        _react2.default.createElement(
	            'span',
	            null,
	            text
	        ),
	        _react2.default.createElement(_AppElements.Img, { src: '/images/banners/hga-campaign/banner-leaf.png', className: 'invertedLeaf' })
	    );
	};
	
	var HGADesignCampaign = function HGADesignCampaign(props) {
	    var tshirtProduct = _AppConstants2.default.PRODUCT_TYPES['T_SHIRT'];
	    return _react2.default.createElement(
	        'div',
	        { id: 'hgaCampaign' },
	        _react2.default.createElement(
	            _reactHelmet.Helmet,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'High Ground Adventure Design Contest | Seto Canvas'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Design a T-Shirt for High Ground Adventure and Get a Chance to Win a Bunjee Jump.' })
	        ),
	        _react2.default.createElement(_HeaderContainer2.default, null),
	        _react2.default.createElement(
	            'div',
	            { id: 'hgaCampaignHeader', className: 'flexRow' },
	            _react2.default.createElement(
	                'div',
	                { id: 'hgaCampaignInfo', className: 'flexColumn' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '#adventureoncanvas'
	                ),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'DESIGN A T-SHIRT'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'FOR HIGH GROUND ADVENTURES'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'AND GET A CHANCE TO'
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'WIN A BUNJEE JUMP'
	                ),
	                _react2.default.createElement(
	                    _AppElements.Button,
	                    { href: '/design/submit', mui: 'true', color: 'primary', id: 'uploadHGADesignBtn' },
	                    'Upload your Design'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'hgaTshirt' },
	                _react2.default.createElement(_AppElements.Img, { src: '/images/banners/hga-campaign/HGA Tshirt.png', alt: 'High Ground Adventure T-Shirt at setocanvas.com' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'mainContainer flexRow', id: 'hgaContestRequirements' },
	            _react2.default.createElement(
	                'div',
	                { className: 'flexColumn eachColumn borderColumn' },
	                _react2.default.createElement(LeafBanner, { id: 'designRequirement', text: 'Requirement for the Design' }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { textAlign: 'center' } },
	                    _react2.default.createElement(_AppElements.Img, { src: '/images/banners/hga-campaign/star.png' })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { style: { margin: '10px 0', color: '#6d6a6a' } },
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        'Must have one of the following text in your design'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hgaTag', id: 'hgaTag1' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'DREAM IT'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'DARE IT'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'DO IT'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hgaTag' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'WHERE'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'NATURE MEETS'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'ADVENTURE'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'flexColumn eachColumn borderColumn', id: 'hgaTnC' },
	                _react2.default.createElement(LeafBanner, { id: 'designTermsNCon', text: 'Terms & Conditions' }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'It\'s summertime, T-shirt time! Design a T-shirt for High Ground Adventure Nepal and Get a chance to win a Bungee Jump worth. '
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'It\'s time to stop dreaming about adventure and it\'s time to take leap of faith!'
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Get into nature while doing something you always wanted to do.'
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Winning design will be picked by the Seto Canvas Team and High Ground Adventure Nepal Team and will be announced in our Social Media Page.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexColumn', id: 'downloadMedias' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'DOWNNLOAD NOW'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flexRow', id: 'downloadLinks' },
	                        _react2.default.createElement(
	                            _AppElements.A,
	                            { href: tshirtProduct.psdTemplateUrl },
	                            'MOCKUP'
	                        ),
	                        _react2.default.createElement(
	                            _AppElements.A,
	                            { href: 'https://drive.google.com/drive/folders/1Y0DFKr35eSaxXeHiY64TMVFuQrdBwoMk?usp=sharing' },
	                            'LOGOS'
	                        ),
	                        _react2.default.createElement(
	                            _AppElements.A,
	                            { href: 'https://drive.google.com/drive/folders/1yoaFD9tdkRVcbfCsG_1iqfP-tSl07O__?usp=sharing' },
	                            'PHOTOS'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'flexColumn eachColumn' },
	                _react2.default.createElement(LeafBanner, { text: 'Theme for Tee design' }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { textAlign: 'center' } },
	                    _react2.default.createElement(_AppElements.Img, { src: '/images/banners/hga-campaign/star.png' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'hgaTheme' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'BUNGEE'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'ATV RIDE'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'ZIP LINE'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'SWING'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	    );
	};
	
	exports.default = HGADesignCampaign;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProductList = __webpack_require__(28);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _AdAPI = __webpack_require__(139);
	
	var _AdAPI2 = _interopRequireDefault(_AdAPI);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _HeaderBanner = __webpack_require__(47);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	__webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NepalThemeMerch = function NepalThemeMerch(props) {
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        products = _useState2[0],
	        setProducts = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        _AdAPI2.default.getNepalThemeMerch(function (products) {
	            setProducts(products);
	        });
	    }, []);
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'themeMerchPage', title: 'Nepal T-Shirts, Sweatshirts, Frame and other Nepal Theme Merch available only on setocanvas.com | Seto Canvas',
	            metaDescription: 'Purchase Nepal Theme T-Shirts, Sweatshirts, Frame and more Nepal Theme Merch on setocanvas.com' },
	        _react2.default.createElement(_HeaderBanner2.default, { bannerImages: [{ "img": "/images/banners/nepal-merch/nepal_theme_banner.jpg?v=1.1",
	                "mobileImg": "/images/banners/nepal-merch/nepal_theme_mobile_banner.jpg?v=1.1",
	                "title": "Nepal Theme T-Shirts, Sweatshirts, Frame and more Nepal Merchandise" }], autoplay: false }),
	        _react2.default.createElement(_ProductList2.default, { products: products, viewProductTags: true, flattenProductImages: true,
	            productViewMode: 'productOnly', emptyMsg: 'No T-Shirts or Sweatshirts Found.' })
	    );
	};
	
	exports.default = NepalThemeMerch;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppName = _react2.default.createElement(
		'b',
		null,
		_AppConstants2.default.APP_NAME
	);
	var SITE_URL = _react2.default.createElement(
		'b',
		null,
		_AppConstants2.default.WEBSITE
	);
	
	var PrivacyPolicy = _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			'h2',
			null,
			'Privacy Policy Statement'
		),
		_react2.default.createElement(
			'p',
			null,
			'The collection and retention of user',
			"'",
			's personal information will be used to authenticate user from programmed bot. And is used when user want to purchase a product or upload a design in ',
			SITE_URL,
			'. The user information will not be disseminated to others.'
		),
		_react2.default.createElement(
			'p',
			null,
			'User contact information, however, including the delivery address and contact number will be made available to the delivery personnel and respective designers whose ArtWork was purchased by the user.'
		)
	);
	
	var TermsAndConditions = _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			'h2',
			null,
			'Seto Canvas Terms and conditions'
		),
		_react2.default.createElement(
			'p',
			null,
			'Please read these Terms of Service completely before using ',
			SITE_URL,
			' which is owned and operated by ',
			AppName,
			'. This Agreement documents the legally binding terms and conditions attached to the use of the Site ',
			SITE_URL,
			'.'
		),
		_react2.default.createElement(
			'p',
			null,
			'By using the Site, a designer, herein known as the "Artist", agrees to the following Terms of Service. The work of the Artist will be referred to as the "Artwork" in this document.'
		),
		_react2.default.createElement(
			'p',
			null,
			'By submitting the Artwork to ',
			AppName,
			', the Artist accepts the following terms and conditions:'
		),
		_react2.default.createElement(
			'h4',
			null,
			_react2.default.createElement(
				'b',
				null,
				_AppConstants2.default.APP_NAME,
				' will:'
			)
		),
		_react2.default.createElement(
			'ul',
			null,
			_react2.default.createElement(
				'li',
				null,
				'Provide its expertise on designing (if need be), marketing, and promotion of the Artwork.'
			),
			_react2.default.createElement(
				'li',
				null,
				'Manufacture, distribute, and sell the Artwork on merchandises.'
			),
			_react2.default.createElement(
				'li',
				null,
				'Manage the inventory and bear all the cost and risk associated with it.'
			),
			_react2.default.createElement(
				'li',
				null,
				'Promote the Artwork under the co-branding of Seto Canvas and the Artist\u2019s chosen brand name.'
			),
			_react2.default.createElement(
				'li',
				null,
				'Communicate and consult with the Artist to settle the final look of the Artwork on the planned merchandises.'
			)
		),
		_react2.default.createElement(
			'h4',
			null,
			_react2.default.createElement(
				'b',
				null,
				'Artist will:'
			)
		),
		_react2.default.createElement(
			'ul',
			null,
			_react2.default.createElement(
				'li',
				null,
				'Be an active member of ',
				_AppConstants2.default.APP_NAME,
				' community and provide the Artwork(s).'
			),
			_react2.default.createElement(
				'li',
				null,
				'Give ',
				_AppConstants2.default.APP_NAME,
				' his/her guarantee that the submitted Artwork(s) will be his/her original work.'
			),
			_react2.default.createElement(
				'li',
				null,
				'When given any project assignment by ',
				_AppConstants2.default.APP_NAME,
				', the Artist will respect the requirements and timeline and fulfill their assigned responsibilities.'
			),
			_react2.default.createElement(
				'li',
				null,
				'Be responsible for the payment of any tax that arises as a result of receiving any payment from ',
				_AppConstants2.default.APP_NAME,
				' and/or any of its partners.'
			),
			_react2.default.createElement(
				'li',
				null,
				'Promote his/her association with ',
				_AppConstants2.default.APP_NAME,
				' through social media and any other channels that Artist finds suitable.'
			)
		),
		_react2.default.createElement(
			'h4',
			null,
			_react2.default.createElement(
				'b',
				null,
				'Artwork:'
			)
		),
		_react2.default.createElement(
			'ul',
			null,
			_react2.default.createElement(
				'li',
				null,
				'The Artist will maintain the ownership of the Artwork. ',
				_AppConstants2.default.APP_NAME,
				' will not claim ownership of any Artworks submitted to the platform.'
			),
			_react2.default.createElement(
				'li',
				null,
				'The Artwork will not infringe any rights of the third party.'
			),
			_react2.default.createElement(
				'li',
				null,
				'In any case of such copyright infringement, ',
				_AppConstants2.default.APP_NAME,
				' holds the right to reject Artwork and/or terminate this contract with the Artist, depending on the frequency of such infringement.'
			),
			_react2.default.createElement(
				'li',
				null,
				'The Artwork must not disparage any person; it must not be indecent, obscene, hateful, tortious, untruthful, inaccurate, defamatory, slanderous or libelous; it must not promote bigotry, racism, hatred or harm against any group or individual or promote discrimination based on race, gender, religion, nationality, disability, sexual orientation or age.'
			),
			_react2.default.createElement(
				'li',
				null,
				'By submitting the Artwork, the Artist hereby grants ',
				_AppConstants2.default.APP_NAME,
				' a worldwide, irrevocable, ',
				_react2.default.createElement(
					'b',
					null,
					'EXCLUSIVE'
				),
				', right and license to use, upload, modify, reproduce, copy, exhibit, distribute, sell, advertise, and display the Artwork, in any manner now known or hereafter devised.'
			),
			_react2.default.createElement(
				'li',
				null,
				'The Artist also grants ',
				_AppConstants2.default.APP_NAME,
				' a worldwide, irrevocable, non-exclusive, right and license to use, portray, display and publish your name, appearance, voice, likeness, photographic image, and biographical information alongside the Artwork, in any and all media now known or hereafter devised.'
			),
			_react2.default.createElement(
				'li',
				null,
				_AppConstants2.default.APP_NAME,
				' reserves all the rights to include the Artworks in miscellaneous items such as, but not limited to calendars, posters, books, banners, etc. to promote ',
				_AppConstants2.default.APP_NAME,
				', its community, and the Artist. If the Artist has any moral reservations for such, you can request it to ',
				_react2.default.createElement(
					'b',
					null,
					_AppConstants2.default.CONTACT_EMAIL
				)
			),
			_react2.default.createElement(
				'li',
				null,
				'In any circumstances, where you need to revoke the license provided to the ',
				_AppConstants2.default.APP_NAME,
				', you can do so by sending a revoke request to ',
				_react2.default.createElement(
					'b',
					null,
					_AppConstants2.default.CONTACT_EMAIL
				)
			)
		),
		_react2.default.createElement('br', null),
		_react2.default.createElement(
			'p',
			null,
			AppName,
			' reserves the right to modify these Terms of Service at any time. We do so by posting and drawing attention to the updated terms on the Site. Your decision to continue to visit and make use of the Site after such changes have been made constitutes your formal acceptance of the new Terms of Service.'
		),
		_react2.default.createElement(
			'p',
			null,
			'Therefore, we ask that you check and review this Agreement for such changes on an occasional basis. Should you not agree to any provision of this Agreement or any changes we make to this Agreement, we ask and advise that you do not use or continue to access the ',
			AppName,
			' site immediately.'
		),
		_react2.default.createElement(
			'h2',
			null,
			'Account Termination'
		),
		_react2.default.createElement(
			'p',
			null,
			AppName,
			' reserves the right to terminate your access to the Site, without any advance notice.'
		),
		_react2.default.createElement(
			'h2',
			null,
			'Contact Information'
		),
		_react2.default.createElement(
			'p',
			null,
			'If you have any questions about this Agreement, please feel free to contact us at ',
			_react2.default.createElement(
				'b',
				null,
				_AppConstants2.default.CONTACT_EMAIL
			),
			'.'
		)
	);
	
	var AgreementsPage = function (_React$Component) {
		_inherits(AgreementsPage, _React$Component);
	
		function AgreementsPage() {
			_classCallCheck(this, AgreementsPage);
	
			return _possibleConstructorReturn(this, (AgreementsPage.__proto__ || Object.getPrototypeOf(AgreementsPage)).apply(this, arguments));
		}
	
		_createClass(AgreementsPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							'Terms & conditions - Privacy Policy | Seto Canvas'
						)
					),
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'scWidth' },
						PrivacyPolicy,
						TermsAndConditions
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return AgreementsPage;
	}(_react2.default.Component);
	
	exports.default = AgreementsPage;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DesignerFAQ = function DesignerFAQ() {
	    return _react2.default.createElement(
	        'div',
	        { id: 'designerFAQ' },
	        _react2.default.createElement(
	            'h2',
	            null,
	            'FAQ For Designers'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'How do I join as a designer?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- Sign Up and start uploading your designs ',
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: 'design/submit', target: '_blank' },
	                        'here'
	                    ),
	                    '.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Can I upload same design on T-Shirt, Hoodie, PhotoFrame?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- Yes, you can. Multiple Uploads of same design on various merchandise are allowed.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Do I get commission on design or on sales?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- The commission is based on sales. Your one design may make multiple sales or no sales at all. So you\'ll be paid according to the number of orders made by a particular design.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'How much commission do I get?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- The commission amount varies per merchandise. On T-Shirt, the commission amount ranges from Rs. 50-100, on Hoodies it starts at Rs. 100 and on PhotoFrame, it starts at Rs. 250.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'On which format should I submit my designs?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- We accept ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        '.jpg'
	                    ),
	                    ' format.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { id: 'tshirtDesignLimitation' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'What kind of designs are supported on Tshirts?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- In case of White Tshirts, any colorful designs can be printed on a A4 size canvas. Large images such as A3 designs are not supported.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        's',
	                        null,
	                        '- In case of Black Tshirts, however, only mono-color or at most 2 colors are supported. Only Flat Designs (designs without much details) such as Text and Geometrical figures are supported. Visit ',
	                        _react2.default.createElement(
	                            _AppElements.A,
	                            { href: '/shop/tshirt', target: '_blank' },
	                            'T-Shirt Shop'
	                        ),
	                        ' to view all supported designs on a Black T-Shirt.'
	                    ),
	                    _react2.default.createElement('br', null),
	                    '- We now support multi-color prints in Black T-Shirt too.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { id: 'hoodiesDesignLimitation' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'What kind of designs are supported on Hoodies?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- Same as Black Tshirt. Read above to know limitations for Black Tshirts.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Do you have any Tutorials on how to upload designs?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- Yes, we do. You can visit our ',
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: _AppConstants2.default.YT_CHANNEL },
	                        'Youtube Page'
	                    ),
	                    ' to view all tutorials.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { id: 'designPendingApproval' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Why is my Design Pending Approval?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- Our moderator takes a period of max 1 week to approve your design. But you must also email a 300 resolution A4 size .png version (background less) of your design only (not the one with Tshirt or Hoodie) to ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'setocanvas@gmail.com'
	                    ),
	                    '. Only after the design file is available, our moderator can then approve your design. And also make sure to meet the above mentioned design guidelines for Tshirt and Hoodies. Your design won\'t be approved, if it does not meet those guidelines.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        'Check the following image file as an example: ',
	                        _react2.default.createElement(
	                            _AppElements.A,
	                            { href: 'https://drive.google.com/file/d/1tRj0Yo0kb7N4Vl4sA_MGw7IGh8ifXU5c/view?usp=sharing' },
	                            'Sample PNG File'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var PhotographerFAQ = function PhotographerFAQ() {
	    return _react2.default.createElement(
	        'div',
	        { id: 'photographerFAQ' },
	        _react2.default.createElement(
	            'h2',
	            null,
	            'FAQ For Photographers'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'How do I join as a photographer?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- Sign Up and start uploading your photographs ',
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: 'design/submit' },
	                        'here'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'What kind of photographs can I upload?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- There is no specific kind of photos that we require but a visually good looking photos are encouraged to upload since it will motivate our users to order.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'How many photos can I upload?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- There is no limit to the number of photos you can upload.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'How much commission will I receive?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- The commission is based on sales. On every order your photograph frame, you\'ll receive certain commission starting at Rs. 250 for the smallest size frame. The commission per different frame size varies and you can see it in your dashboard, when an order is made.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Can I use watermarks on the photos?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- If you are using a watermark, do make sure it is minimal and doesn\'t hamper the aestheic of the image. Additionally we don\'t have control over which photograph gets sold and its purely the decision of the buyer so please make sure that aspect is taken care of.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'On which format should I submit my photos?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- We accept ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        '.jpg'
	                    ),
	                    ' format.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Do you have any Tutorials on how to upload designs?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- Yes, we do. You can watch this ',
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: 'https://www.youtube.com/watch?v=0APtVvBBUpI' },
	                        'Video Tutorial'
	                    ),
	                    '  to learn about it.'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { id: 'photographPendingApproval' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Why is my Photograph Pending Approval?'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '- Our moderator takes a period of max 1 week to approve your photograph. But you must also email your original photograph image to ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'setocanvas@gmail.com'
	                    ),
	                    '. Only after the image file is available, our moderator can then approve your photograph.'
	                )
	            )
	        )
	    );
	};
	
	var FAQ = function FAQ() {
	
	    (0, _react.useEffect)(function () {
	        _AppUtil2.default.scrollToHashTagIfAny(45);
	    }, []);
	
	    return _react2.default.createElement(
	        _SetoCanvasPage2.default,
	        { id: 'faqPage', title: "Seto Canvas Frequently Asked Question" },
	        _react2.default.createElement(DesignerFAQ, null),
	        _react2.default.createElement(PhotographerFAQ, null)
	    );
	};
	
	exports.default = FAQ;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppName = _react2.default.createElement(
		'b',
		null,
		_AppConstants2.default.APP_NAME
	);
	var SITE_URL = _react2.default.createElement(
		'b',
		null,
		_AppConstants2.default.WEBSITE
	);
	
	var HowMuchCanIMake = function (_React$Component) {
		_inherits(HowMuchCanIMake, _React$Component);
	
		function HowMuchCanIMake() {
			_classCallCheck(this, HowMuchCanIMake);
	
			return _possibleConstructorReturn(this, (HowMuchCanIMake.__proto__ || Object.getPrototypeOf(HowMuchCanIMake)).apply(this, arguments));
		}
	
		_createClass(HowMuchCanIMake, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				_AppUtil2.default.scrollToTop();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							'How much can I Make on Seto Canvas? | Seto Canvas'
						)
					),
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(
						'div',
						{ style: { margin: '20px auto', padding: '0 10px' }, id: 'howMuchCanIInfo', className: 'scWidth' },
						_react2.default.createElement(
							'h2',
							{ style: { textAlign: 'center', margin: '20px 0' } },
							_react2.default.createElement(
								'u',
								null,
								'How much can I Make on ',
								AppName,
								'?'
							)
						),
						_react2.default.createElement(
							'p',
							null,
							'Once you upload your design, our moderators will review your design and based on the number of colors used, the size of the design and various other factors, the price of the product will be determined. And, along with it the commission that you\u2019ll earn per sales.'
						),
						_react2.default.createElement(
							'p',
							null,
							'An artist can expect to earn ',
							_react2.default.createElement(
								'b',
								null,
								'at least Rs. 50'
							),
							' per sales. The amount will vary based on the price of the product. Higher the price of the product, higher will be your commission and vice-versa. Once you start generating sales, you can view your earned amount in your Dashboard and after the earned amount reaches ',
							_react2.default.createElement(
								'b',
								null,
								'Rs. 2,000'
							),
							', you can then request to withdraw it. '
						),
						_react2.default.createElement(
							'h4',
							{ style: { textAlign: 'center' } },
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
								' Tip: Try making on average 1 sale per day and you should be able to earn Rs.2,000 every month conveniently.'
							)
						),
						_react2.default.createElement(
							'p',
							null,
							'All these numbers ',
							_react2.default.createElement(
								'i',
								null,
								'(the number of product sold, the number of pending orders, amount earned per quantity sold, total amount earned)'
							),
							', will be made transparently visible to the Artist on ',
							SITE_URL,
							'.'
						)
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return HowMuchCanIMake;
	}(_react2.default.Component);
	
	exports.default = HowMuchCanIMake;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _HeaderContainer = __webpack_require__(23);
	
	var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);
	
	var _Footer = __webpack_require__(24);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppName = _react2.default.createElement(
		'b',
		null,
		_AppConstants2.default.APP_NAME
	);
	var SITE_URL = _react2.default.createElement(
		'b',
		null,
		_AppConstants2.default.WEBSITE
	);
	
	
	var ImageIcon = (0, _radium2.default)(function (props) {
	
		return _react2.default.createElement(
			'div',
			{ className: 'flexRow', style: { alignItems: 'center', width: '80%', margin: '0 auto 30px auto', flexWrap: 'nowrap',
					'@media (max-width: 500px)': { flexWrap: 'wrap' },
					'@media (max-width: 770px)': { width: '100%', margin: '0 auto 20px auto' } } },
			_react2.default.createElement('img', { src: props.src, alt: props.title, style: { marginRight: '30px', maxWidth: '364px',
					'@media (max-width: 364px)': { width: '100%' },
					'@media (max-width: 500px)': { maxWidth: '300px' },
					'@media (max-width: 770px)': { margin: 'auto' } } }),
			_react2.default.createElement(
				'h1',
				{ style: { color: '#f8941c', margin: '20px 0', fontSize: '220%',
						'@media (max-width: 770px)': { fontSize: '210%', textAlign: 'center', flexGrow: '1' } } },
				props.title
			)
		);
	});
	
	var WhatIsSC = (0, _radium2.default)(function (props) {
	
		return _react2.default.createElement(
			'div',
			{ style: { margin: '20px auto', padding: '0 10px' }, id: 'howtoMakeMoney', className: 'scWidth' },
			_react2.default.createElement(
				'h4',
				null,
				AppName,
				' is a marketplace for creative heads like you to sell your art/design printed on different merchandise such as T-Shirts, Mugs, Pillows and ',
				_react2.default.createElement(
					'b',
					null,
					'Make Money from Home'
				),
				' at your own convenience.'
			),
			_react2.default.createElement(
				'p',
				null,
				_react2.default.createElement(
					'i',
					null,
					'Currently, ',
					_AppConstants2.default.APP_NAME,
					' only entertain production of T-Shirts but we will expand it to other merchandise in the near future.'
				)
			),
			_react2.default.createElement('img', { src: '/images/about_us/how_does_it_work.png', alt: 'How Does SetoCanvas.com works',
				style: { margin: '40px auto 20px auto', display: 'block', width: '460px',
					'@media (max-width: 600px)': { width: '100%' } } }),
			_react2.default.createElement(
				'div',
				{ className: 'flexColumn', style: { marginTop: '40px' } },
				_react2.default.createElement(ImageIcon, { src: '/images/about_us/design.png', title: '1. Design a Beautiful Graphic Art.' }),
				_react2.default.createElement(ImageIcon, { src: '/images/about_us/upload.png', title: '2. Submit your designs.' }),
				_react2.default.createElement(
					'h4',
					{ style: { marginTop: '0' } },
					'An artist can submit their art/design, along with a print on a merchandise (such as a T-Shirt) on ',
					_react2.default.createElement(
						_AppElements.A,
						{ href: _AppConstants2.default.WEBSITE },
						SITE_URL
					),
					'. Our Team will then review your art/design and confirm if it abides to our ',
					_react2.default.createElement(
						_AppElements.A,
						{ target: '_blank', href: '/terms-of-use-and-privacy-policy' },
						'Term & Conditions'
					),
					'. Once the design is approved, the price of the product will be determined based on the number of colors your design has, the size of the design and few other variables, and the product will be made available for sale on ',
					_react2.default.createElement(
						_AppElements.A,
						{ href: _AppConstants2.default.WEBSITE },
						SITE_URL
					)
				),
				_react2.default.createElement('br', null),
				_react2.default.createElement(ImageIcon, { src: '/images/about_us/sell.png', title: '3. Promote your designs.' }),
				_react2.default.createElement(ImageIcon, { src: '/images/about_us/make_money.png', title: '4. Make money of each sale.' }),
				_react2.default.createElement(
					'h4',
					{ style: { marginTop: '0' } },
					AppName,
					' will then take complete responsibility of production, packaging and delivery of the merchandise. For every quantity sold, you (the Artist) will earn a certain amount of commission ',
					_react2.default.createElement(
						'i',
						null,
						'(as described ',
						_react2.default.createElement(
							_AppElements.A,
							{ href: '/how-much-can-i-make' },
							'here'
						),
						')'
					),
					'. We will also further promote and market your merchandise ',
					_react2.default.createElement(
						'b',
						null,
						_react2.default.createElement(
							'i',
							null,
							'but, it should be the primary responsibility of the Artist to promote his/her merchandise rather than depend on ',
							_react2.default.createElement(
								_AppElements.A,
								{ href: _AppConstants2.default.WEBSITE },
								AppName
							),
							' to market it.'
						)
					)
				)
			)
		);
	});
	
	var HowToMakeMoney = function (_React$Component) {
		_inherits(HowToMakeMoney, _React$Component);
	
		function HowToMakeMoney() {
			_classCallCheck(this, HowToMakeMoney);
	
			return _possibleConstructorReturn(this, (HowToMakeMoney.__proto__ || Object.getPrototypeOf(HowToMakeMoney)).apply(this, arguments));
		}
	
		_createClass(HowToMakeMoney, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				_AppUtil2.default.scrollToTop();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_reactHelmet.Helmet,
						null,
						_react2.default.createElement(
							'title',
							null,
							'How to make Money on Seto Canvas? | Seto Canvas'
						)
					),
					_react2.default.createElement(_HeaderContainer2.default, null),
					_react2.default.createElement(WhatIsSC, null),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return HowToMakeMoney;
	}(_react2.default.Component);
	
	exports.default = HowToMakeMoney;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _SubmitSubProductForm = __webpack_require__(580);
	
	var _SubmitSubProductForm2 = _interopRequireDefault(_SubmitSubProductForm);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _utils = __webpack_require__(15);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddSubProductPage = function (_React$Component) {
		_inherits(AddSubProductPage, _React$Component);
	
		function AddSubProductPage() {
			_classCallCheck(this, AddSubProductPage);
	
			return _possibleConstructorReturn(this, (AddSubProductPage.__proto__ || Object.getPrototypeOf(AddSubProductPage)).apply(this, arguments));
		}
	
		_createClass(AddSubProductPage, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var productId = this.props.match.params.productId;
	
				var product = this.state.product;
	
				if (product === null) _HttpService2.default.getProduct(productId);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState, snapshot) {
				var product = this.state.product;
	
				var productChanged = prevProps.productId !== this.props.productId;
				if (product === null) {
					//check if new product link is clicked or not
					if (productChanged === true) _HttpService2.default.getProduct(this.props.productId);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var product = this.state.product;
	
				return _react2.default.createElement(
					_SetoCanvasPage2.default,
					{ id: 'submitDesignPage', title: 'Submit your Design and Start Earning From Home | Seto Canvas',
						metaDescription: 'Seto Canvas is a marketplace for Designers to sell their art printed on merchandise like TShirts, Mugs, Pillows and more.' },
					product && _react2.default.createElement(_SubmitSubProductForm2.default, { product: product })
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_ProductStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState, props) {
				var productId = props.match.params.productId;
	
				var product = _ProductStore2.default.getProduct(productId);
	
				var newState = {
					product: product
				};
				return newState;
			}
		}]);
	
		return AddSubProductPage;
	}(_react2.default.Component);
	
	exports.default = _utils.Container.create(AddSubProductPage, { withProps: true });

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(15);
	
	var _ProductStore = __webpack_require__(27);
	
	var _ProductStore2 = _interopRequireDefault(_ProductStore);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _ProductAPI = __webpack_require__(37);
	
	var _ProductAPI2 = _interopRequireDefault(_ProductAPI);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _SetoCanvasPage = __webpack_require__(16);
	
	var _SetoCanvasPage2 = _interopRequireDefault(_SetoCanvasPage);
	
	var _PhotoFrameForm = __webpack_require__(227);
	
	var _PhotoFrameForm2 = _interopRequireDefault(_PhotoFrameForm);
	
	var _SuggestedProducts = __webpack_require__(143);
	
	var _SuggestedProducts2 = _interopRequireDefault(_SuggestedProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var productId = _AppConstants2.default.CUSTOM_FRAME_PRODUCT;
	
	var frameProduct = _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'];
	
	var PhotoFramePage = function (_React$Component) {
		_inherits(PhotoFramePage, _React$Component);
	
		function PhotoFramePage() {
			_classCallCheck(this, PhotoFramePage);
	
			return _possibleConstructorReturn(this, (PhotoFramePage.__proto__ || Object.getPrototypeOf(PhotoFramePage)).apply(this, arguments));
		}
	
		_createClass(PhotoFramePage, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var product = this.state.product;
	
				if (product === null) _HttpService2.default.getProduct(productId);
	
				if (this.state.suggestedProducts === null) {
					_ProductAPI2.default.getProductsByType(frameProduct, 0, _AppConstants2.default.DEFAULT_PRODUCT_PAGE_SIZE);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var product = this.state.product;
				return _react2.default.createElement(
					_SetoCanvasPage2.default,
					{ id: 'photoFramePage', title: "Custom Photo Frame", turnOffSticky: true },
					_react2.default.createElement(_PhotoFrameForm2.default, { product: product }),
					this.state.suggestedProducts && _react2.default.createElement(_SuggestedProducts2.default, { products: this.state.suggestedProducts,
						autoplay: true, navigator: 'arrows' })
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_ProductStore2.default];
			}
		}, {
			key: 'calculateState',
			value: function calculateState(prevState, props) {
				var product = _ProductStore2.default.getProduct(productId);
				var suggestedProducts = _ProductStore2.default.getProductsByType(frameProduct.url);
				var newState = {
					product: product,
					suggestedProducts: suggestedProducts
				};
				return newState;
			}
		}]);
	
		return PhotoFramePage;
	}(_react2.default.Component);
	
	exports.default = _utils.Container.create(PhotoFramePage, { withProps: true });

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HttpService2 = __webpack_require__(12);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BASE_URL = _AppConstants2.default.BASE_API_URL + "/payment";
	
	var PaymentAPI = function (_HttpService) {
					_inherits(PaymentAPI, _HttpService);
	
					function PaymentAPI() {
									_classCallCheck(this, PaymentAPI);
	
									return _possibleConstructorReturn(this, (PaymentAPI.__proto__ || Object.getPrototypeOf(PaymentAPI)).apply(this, arguments));
					}
	
					_createClass(PaymentAPI, [{
									key: 'signPaymentReq',
									value: function signPaymentReq(orderIdList, amount, callback) {
													var _this2 = this;
	
													this.post("/cybersource/sign?amount=" + amount, orderIdList, function (response) {
																	var res = response.data;
																	callback(true, res);
													}, function (error) {
																	_this2.defaultErrorHandler(error);
																	callback(false, null);
													});
									}
					}]);
	
					return PaymentAPI;
	}(_HttpService2.HttpService);
	
	exports.default = new PaymentAPI(BASE_URL);

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(15);
	
	var _immutable = __webpack_require__(43);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _AppAction = __webpack_require__(22);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertMessage = new _immutable2.default.Record({
		message: null,
		type: null,
		alertAction: null,
		actionData: null
	});
	
	var MessageStore = function (_ReduceStore) {
		_inherits(MessageStore, _ReduceStore);
	
		function MessageStore() {
			_classCallCheck(this, MessageStore);
	
			return _possibleConstructorReturn(this, (MessageStore.__proto__ || Object.getPrototypeOf(MessageStore)).call(this, _Dispatcher2.default));
		}
	
		_createClass(MessageStore, [{
			key: 'getInitialState',
			value: function getInitialState() {
				return new AlertMessage();
			}
		}, {
			key: 'getAlertMessage',
			value: function getAlertMessage() {
				return this.getState().message === null ? null : this.getState();
			}
		}, {
			key: 'reduce',
			value: function reduce(state, action) {
				_Dispatcher2.default.waitFor([_SessionStore2.default.getDispatchToken()]);
				switch (action.type) {
					case _AppAction.MessageAction.MESSAGE:
						var message = action.message;
	
						if (typeof message === 'string') return new AlertMessage({ message: message, type: "INFO" });
	
						return new AlertMessage(message);
	
					case _AppAction.MessageAction.CLEAR_MESSAGE:
						return new AlertMessage();
	
					case _AppAction.UserAction.LOGOUT:
						return state;
					case _AppAction.MessageAction.MESSAGE_WITH_ACTION:
						return new AlertMessage(action.message);
	
					case _AppAction.DesignerAction.LOAD_CACHABLE_SALES_TARGET:
						return state;
	
					case _AppAction.RedeemAction.LOAD_REDEEM_HISTORY:
						return state;
	
					case _AppAction.DesignerAction.LOAD_BALANCE:
						return state;
	
					case _AppAction.StockAction.LOAD_OWNER_STOCKS:
						return state;
	
					case _AppAction.StockAction.CLEAR_OWNER_STOCKS:
						return state;
	
					case _AppAction.StockAction.LOAD_STOCK_HISTORY:
						return state;
	
					default:
						break;
				}
	
				//for all other action type, clear the alert message if any
				if (action.type) return new AlertMessage();
	
				return state;
			}
		}]);
	
		return MessageStore;
	}(_utils.ReduceStore);
	
	exports.default = new MessageStore();

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(43);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(15);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _AppAction = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedeemStore = function (_ReduceStore) {
		_inherits(RedeemStore, _ReduceStore);
	
		function RedeemStore() {
			_classCallCheck(this, RedeemStore);
	
			return _possibleConstructorReturn(this, (RedeemStore.__proto__ || Object.getPrototypeOf(RedeemStore)).call(this, _Dispatcher2.default));
		}
	
		_createClass(RedeemStore, [{
			key: 'getInitialState',
			value: function getInitialState() {
				return _immutable2.default.List();
			}
		}, {
			key: 'getReedemHistory',
			value: function getReedemHistory() {
				return this.getState();
			}
		}, {
			key: 'reduce',
			value: function reduce(state, action) {
				switch (action.type) {
					case _AppAction.RedeemAction.LOAD_REDEEM_HISTORY:
						var redeemHistory = action.redeemHistory;
						return _immutable2.default.List(redeemHistory);
	
					case _AppAction.RedeemAction.REDEEMED:
						return state.clear();
	
					case _AppAction.UserAction.LOGOUT:
						return state.clear();
	
					default:
						break;
				}
	
				return state;
			}
		}]);
	
		return RedeemStore;
	}(_utils.ReduceStore);
	
	exports.default = new RedeemStore();

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertMessageBox = function (_React$Component) {
		_inherits(AlertMessageBox, _React$Component);
	
		function AlertMessageBox() {
			_classCallCheck(this, AlertMessageBox);
	
			return _possibleConstructorReturn(this, (AlertMessageBox.__proto__ || Object.getPrototypeOf(AlertMessageBox)).apply(this, arguments));
		}
	
		_createClass(AlertMessageBox, [{
			key: 'clearMessageAlert',
			value: function clearMessageAlert() {
				_Dispatcher2.default.dispatchClearAlert();
			}
		}, {
			key: 'render',
			value: function render() {
				var message = this.props.message;
	
				if (message) {
					var messageType = message.type;
	
					var alertMessageClass = "alertMessage" + messageType.charAt(0).toUpperCase() + messageType.slice(1).toLowerCase();
	
					return _react2.default.createElement(
						'div',
						{ className: "alertMessage " + alertMessageClass },
						message["message"],
						_react2.default.createElement('i', { onClick: this.clearMessageAlert.bind(this), className: 'fa fa-times alertMessageClose', 'aria-hidden': 'true' })
					);
				}
	
				return null;
			}
		}]);
	
		return AlertMessageBox;
	}(_react2.default.Component);
	
	AlertMessageBox = (0, _radium2.default)(AlertMessageBox);
	
	exports.default = AlertMessageBox;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AppSideBar = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSidebar = __webpack_require__(628);
	
	var _reactSidebar2 = _interopRequireDefault(_reactSidebar);
	
	var _AppMenu = __webpack_require__(218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppSideBar = exports.AppSideBar = function AppSideBar(_ref) {
		var influencers = _ref.influencers,
		    popularStores = _ref.popularStores,
		    openSideBar = _ref.openSideBar,
		    toogleSideBar = _ref.toogleSideBar;
	
	
		return _react2.default.createElement(
			_reactSidebar2.default,
			{
				sidebar: _react2.default.createElement(_AppMenu.NavBarContent, { influencers: influencers,
					popularStores: popularStores, onCloseClick: toogleSideBar }),
				open: openSideBar,
				onSetOpen: toogleSideBar,
				rootClassName: 'scSideBarRoot',
				contentClassName: 'scSideBarContent',
				sidebarClassName: 'scSideBar',
				overlayClassName: 'scSideOverlay' },
			_react2.default.createElement('span', null)
		);
	};
	
	exports.default = AppSideBar;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppElements = __webpack_require__(9);
	
	var _LoginSignUpBox = __webpack_require__(595);
	
	var _LoginSignUpBox2 = _interopRequireDefault(_LoginSignUpBox);
	
	var _AppMenu = __webpack_require__(218);
	
	var _AppMenu2 = _interopRequireDefault(_AppMenu);
	
	var _reactSticky = __webpack_require__(103);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppSideBar = __webpack_require__(567);
	
	var _AppSideBar2 = _interopRequireDefault(_AppSideBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
		header: { background: "rgb(245, 245, 245)", alignItems: 'center', paddingTop: '10px' }
	};
	
	var Header = function (_React$Component) {
		_inherits(Header, _React$Component);
	
		function Header(props) {
			_classCallCheck(this, Header);
	
			var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
			_this.openLoginModal = _this.openLoginModal.bind(_this);
			_this.openSideBar = _this.openSideBar.bind(_this);
			_this.toogleSideBar = _this.toogleSideBar.bind(_this);
	
			var forceOpenLogin = _this.props.forceOpenLogin;
			_this.state = { openLoginModal: forceOpenLogin !== null && forceOpenLogin.selectedForm !== null,
				openSideBar: false };
			return _this;
		}
	
		_createClass(Header, [{
			key: 'openLoginModal',
			value: function openLoginModal() {
				this.setState({ openLoginModal: true });
			}
		}, {
			key: 'toogleSideBar',
			value: function toogleSideBar() {
				this.setState({ openSideBar: !this.state.openSideBar });
			}
		}, {
			key: 'openSideBar',
			value: function openSideBar() {
				this.setState({ openSideBar: true });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var session = this.props.session;
				var forceOpenLogin = this.props.forceOpenLogin;
				var popularStores = this.props.popularStores;
				var influencers = this.props.influencers;
	
				var logoImg = _AppUtil2.default.getAppLogo();
	
				return _react2.default.createElement(
					'div',
					{ style: [styles.header], id: 'header' },
					_react2.default.createElement(
						'div',
						{ className: 'scWidth flexRow', style: { justifyContent: 'space-between' } },
						_react2.default.createElement(
							_AppElements.A,
							{ href: '/', style: { margin: '5px 0', '@media (max-width: 770px)': { margin: '5px auto' } } },
							_react2.default.createElement('img', { src: logoImg, alt: 'Seto Canvas', style: { width: '300px', cursor: 'pointer',
									'@media (max-width: 770px)': { display: 'none' } } })
						),
						_react2.default.createElement(
							'div',
							{ className: 'flexColumn', style: { '@media (max-width: 500px)': { width: '100%' } } },
							_react2.default.createElement(
								'div',
								{ id: 'specialButtons', className: 'flexRow', style: { margin: '10px 0' } },
								session === null && _react2.default.createElement(
									'div',
									{ style: { flexGrow: '1', margin: '0 10px' }, key: 'leftAligned' },
									_react2.default.createElement(
										_AppElements.Button,
										{ href: '/artist/signup', mui: 'true', color: 'primary',
											style: { width: '100%' } },
										_react2.default.createElement('i', { className: 'fa fa-user-circle', 'aria-hidden': 'true' }),
										' Join Seto Canvas'
									)
								),
								session !== null && _react2.default.createElement(
									'div',
									{ style: { flexGrow: '1', margin: '0 10px' }, key: 'leftAligned' },
									_react2.default.createElement(
										_AppElements.Button,
										{ href: '/design/submit', mui: 'true', color: 'primary', style: { width: '100%' } },
										_react2.default.createElement('i', { className: 'fa fa-cloud-upload', 'aria-hidden': 'true' }),
										' Submit Artwork'
									)
								),
								_react2.default.createElement(
									'div',
									{ style: { flexGrow: '1', textAlign: 'center',
											'@media (max-width: 770px)': { margin: '0 10px' } }, key: 'rightAligned' },
									session === null && _react2.default.createElement(
										_AppElements.Button,
										{ onClick: this.openLoginModal, mui: 'true', style: { width: '100%' } },
										_react2.default.createElement('i', { className: 'fa fa-lock', 'aria-hidden': 'true' }),
										' Sign In'
									),
									session !== null && _react2.default.createElement(_AppMenu.DropDownNav, { session: session })
								)
							)
						),
						_react2.default.createElement(_LoginSignUpBox2.default, { openLoginModal: this.state.openLoginModal,
							selectedForm: forceOpenLogin !== null ? forceOpenLogin.selectedForm : null,
							formData: forceOpenLogin !== null ? forceOpenLogin.formData : null })
					),
					_react2.default.createElement(_AppSideBar2.default, { influencers: influencers, popularStores: popularStores,
						openSideBar: this.state.openSideBar, toogleSideBar: this.toogleSideBar
					}),
					_react2.default.createElement(
						_reactSticky.Sticky,
						{ topOffset: this.props.turnOffSticky === true ? 1100000000 : 110 },
						function (_ref) {
							var style = _ref.style,
							    isSticky = _ref.isSticky;
	
							if (isSticky) style = Object.assign({}, style, { borderBottom: '1px dashed rgb(61, 61, 61)' });
							return _react2.default.createElement(_AppMenu2.default, { style: style, isSticky: isSticky,
								influencers: influencers,
								popularStores: popularStores,
								onNavBarToggle: _this2.openSideBar });
						}
					)
				);
			}
		}], [{
			key: 'getDerivedStateFromProps',
			value: function getDerivedStateFromProps(props, currentState) {
				if (props.forceOpenLogin !== null && props.forceOpenLogin.selectedForm !== null) {
					currentState.openLoginModal = true;
					return currentState;
				}
	
				if (props.session) currentState.openLoginModal = false;
	
				return currentState;
			}
		}]);
	
		return Header;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(Header);

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DesignApprovalMessage = exports.OrderProcessMessage = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderProcessMessage = exports.OrderProcessMessage = function OrderProcessMessage() {
	    return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("i", { className: "fa fa-exclamation-circle", "aria-hidden": "true" }),
	        " We are not processing any orders during the lockdown. All orders placed will be processed once the lockdown is over in KTM Valley."
	    );
	};
	
	var DesignApprovalMessage = exports.DesignApprovalMessage = function DesignApprovalMessage() {
	    return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("i", { className: "fa fa-exclamation-circle", "aria-hidden": "true" }),
	        " All uploaded designs will be approved once Seto Canvas office resumes after lockdown is over in KTM Valley."
	    );
	};
	
	var NoticeBanner = function NoticeBanner(_ref) {
	    var children = _ref.children;
	
	
	    return _react2.default.createElement(
	        "div",
	        { className: "noticeBanner" },
	        children
	    );
	};
	
	exports.default = NoticeBanner;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _CheckoutPage = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QRCodeForm = function QRCodeForm(_ref) {
	    var amount = _ref.amount;
	
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'qrCodeForm', className: 'paymentForm' },
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Scan the QR Code below using ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'eSewa'
	                ),
	                '/',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'IME Pay'
	                ),
	                ' or any ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Mobile Banking'
	                ),
	                ' application.'
	            ),
	            amount !== null && amount !== undefined && amount > 0 && _react2.default.createElement(
	                'li',
	                null,
	                'Enter Amount: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    "Rs. " + _AppUtil2.default.formatNumber(amount)
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Enter Remarks: ',
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Your Name'
	                ),
	                ' ',
	                _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        '(same as in your order)'
	                    )
	                ),
	                '.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'After finishing your payment, DM Us it\'s screenshot and our operator shall confirm and update your order. You can send the screenshot in:'
	            ),
	            _react2.default.createElement(_CheckoutPage.PaymentConfirmationDM, null)
	        ),
	        _react2.default.createElement(_AppElements.Separator, null),
	        _react2.default.createElement(_AppElements.Img, { className: 'qrCodeImg', src: '/images/merchant_qr_code.jpg', title: 'Seto Canvas Merchant QR Code for payment',
	            style: { maxWidth: '100%' } })
	    );
	};
	
	exports.default = QRCodeForm;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppAction = __webpack_require__(22);
	
	var _StockStore = __webpack_require__(92);
	
	var _StockStore2 = _interopRequireDefault(_StockStore);
	
	var _OrderAPI = __webpack_require__(90);
	
	var _OrderAPI2 = _interopRequireDefault(_OrderAPI);
	
	var _StockAPI = __webpack_require__(73);
	
	var _StockAPI2 = _interopRequireDefault(_StockAPI);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORDER_STATE = _AppConstants2.default.ORDER_STATE;
	
	var VALIDATE_TO_ORDER_STATES = { "ORDER_PLACED": [ORDER_STATE.ORDER_CONFIRMED, ORDER_STATE.CANCELLED],
	    "ORDER_CONFIRMED": [ORDER_STATE.CANCELLED, ORDER_STATE.SHIPPING, ORDER_STATE.DELIVERED],
	    "SHIPPING": [ORDER_STATE.CANCELLED, ORDER_STATE.DELIVERED],
	    "CANCELLED": [ORDER_STATE.SHIPPING],
	    "DELIVERED": [ORDER_STATE.DELIVERED_CLOSED]
	};
	
	var ChangeOrderStateModalForm = function (_React$Component) {
	    _inherits(ChangeOrderStateModalForm, _React$Component);
	
	    function ChangeOrderStateModalForm(props) {
	        _classCallCheck(this, ChangeOrderStateModalForm);
	
	        var _this = _possibleConstructorReturn(this, (ChangeOrderStateModalForm.__proto__ || Object.getPrototypeOf(ChangeOrderStateModalForm)).call(this, props));
	
	        _this.state = { openModal: true };
	
	        _this.getInitValues = _this.getInitValues.bind(_this);
	        _this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
	        _this.showStockProductInputs = _this.showStockProductInputs.bind(_this);
	        _this.validationScheme = _this.validationScheme.bind(_this);
	        return _this;
	    }
	
	    _createClass(ChangeOrderStateModalForm, [{
	        key: 'getInitValues',
	        value: function getInitValues() {
	            var order = this.props.order;
	            return { orderId: order.orderId,
	                orderState: order.orderState,
	                cancelledReason: order.cancelledReason ? order.cancelledReason : '',
	
	                productSize: order.productSizes.map(function (s) {
	                    var sizeMetaData = order.sizeMetaData || _AppUtil2.default.getSizeInfo(order.product);
	                    var size = sizeMetaData[s];
	                    if (!size) return s;
	
	                    return size.label;
	                }).toString(),
	                stockOwner: '',
	                stockProduct: '',
	                noStockDeduction: false
	            };
	        }
	    }, {
	        key: 'showStockProductInputs',
	        value: function showStockProductInputs() {
	            var order = this.props.order;
	            return order.orderState !== ORDER_STATE.ORDER_PLACED.value && order.orderState !== ORDER_STATE.CANCELLED.value && !order.stockProductId;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ openModal: true });
	        }
	    }, {
	        key: 'validationScheme',
	        value: function validationScheme() {
	            var _this2 = this;
	
	            var validation = {
	                orderState: _yup2.default.string().required("Select New State"),
	                cancelledReason: _yup2.default.string().when('orderState', function (orderState, schema) {
	                    return orderState === ORDER_STATE.CANCELLED.value ? _yup2.default.string().required("Specify cancelled reason.") : _yup2.default.string();
	                }),
	                noStockDeduction: _yup2.default.boolean(),
	                stockProduct: _yup2.default.boolean().when('noStockDeduction', function (noStockDeduction, schema) {
	                    if (noStockDeduction === false) {
	                        if (_this2.showStockProductInputs()) return _yup2.default.string().required("Select Stock Product to update");
	                    }
	
	                    return _yup2.default.string();
	                })
	            };
	
	            return _yup2.default.object().shape(validation);
	        }
	    }, {
	        key: 'handleFormSubmission',
	        value: function handleFormSubmission(formValue, _ref) {
	            var setSubmitting = _ref.setSubmitting,
	                resetForm = _ref.resetForm;
	
	            var newState = formValue.orderState;
	            var order = this.props.order;
	
	            var stockProductId = formValue.stockProduct;
	
	            var confirmRes = confirm("Are you sure you want to update this order state to " + newState + "?");
	
	            if (confirmRes === false) {
	                setSubmitting(false);
	                resetForm();
	                return;
	            }
	
	            if (newState === ORDER_STATE.CANCELLED.value) {
	                _OrderAPI2.default.cancelOrder(order, formValue.cancelledReason, stockProductId, function (success) {
	                    //on success the row is removed
	                    if (success === false) {
	                        setSubmitting(false);
	                        resetForm();
	                    } else {
	                        if (stockProductId) {
	                            _Dispatcher2.default.dispatch({
	                                type: _AppAction.StockAction.CLEAR_OWNER_STOCKS,
	                                stockOwner: formValue.stockOwner
	                            });
	                        }
	
	                        this.props.onClose();
	                    }
	                }.bind(this));
	            } else {
	                _OrderAPI2.default.updateOrderState(order, newState, stockProductId, function (success) {
	                    //on success the row is removed
	                    if (success === false) {
	                        setSubmitting(false);
	                        resetForm();
	                    } else {
	                        if (stockProductId) {
	                            _Dispatcher2.default.dispatch({
	                                type: _AppAction.StockAction.CLEAR_OWNER_STOCKS,
	                                stockOwner: formValue.stockOwner
	                            });
	                        }
	
	                        this.props.onClose();
	                    }
	                }.bind(this));
	            }
	        }
	    }, {
	        key: 'onStockOwnerChange',
	        value: function onStockOwnerChange(owner, setFieldValue) {
	            if (!_StockStore2.default.getStocks(owner)) _StockAPI2.default.getStocks(owner, function (stocks) {
	                //after receiving stocks set owner value again to build the form
	                setFieldValue('stockOwner', owner);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var initValues = this.getInitValues();
	            var order = this.props.order;
	
	            var validToStates = VALIDATE_TO_ORDER_STATES[order.orderState];
	
	            return _react2.default.createElement(
	                _reactResponsiveModal2.default,
	                { closeOnOverlayClick: false, open: this.state.openModal, onClose: this.props.onClose, little: true,
	                    classNames: { overlay: 'add-stock-overlay', modal: 'add-stock-modal' } },
	                _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: initValues, onSubmit: this.handleFormSubmission,
	                    validationSchema: this.validationScheme,
	                    render: function render(_ref2) {
	                        var values = _ref2.values,
	                            isSubmitting = _ref2.isSubmitting;
	
	
	                        var stockOwners = _StockStore2.default.getStockOwners();
	                        var stockOwnerOptions = stockOwners ? stockOwners.map(function (o) {
	                            return { 'value': o.ownerAlias, 'label': o.ownerAlias };
	                        }) : [];
	
	                        var stockProducts = values.stockOwner ? _StockStore2.default.getStocks(values.stockOwner) : [];
	
	                        var productSizes = _AppUtil2.default.getSizeInfo(order.product);
	
	                        var stockProductOptions = stockProducts ? stockProducts.filter(function (sp) {
	                            return sp.product.productType === order.product.productType;
	                        }).filter(function (sp) {
	                            return productSizes[sp.productSize] !== undefined;
	                        }).filter(function (sp) {
	                            return productSizes[sp.productSize].label === values.productSize;
	                        }).filter(function (sp) {
	                            return sp.quantity > 0;
	                        }).map(function (sp) {
	
	                            var label = _react2.default.createElement(
	                                'div',
	                                { className: 'flexRow stockProductionOption' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    sp.product.title + " - " + sp.productSize + " [" + sp.quantity + "]",
	                                    ' '
	                                ),
	                                _react2.default.createElement('img', { alt: sp.product.title, src: sp.product.previewImage, style: { height: '40px', width: '40px' } })
	                            );
	                            return { 'value': sp.stockProductId,
	                                'label': label };
	                        }) : [];
	
	                        var showStockProductInputs = _this3.showStockProductInputs() && values.noStockDeduction === false;
	                        var sizeLabel = _AppUtil2.default.getOrderSizeString(order, order.product);
	                        return _react2.default.createElement(
	                            _FormElements.RGForm,
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                order.product.title,
	                                ' - ',
	                                sizeLabel
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { style: { margin: '20px 0 0 0', borderBottom: '1px solid gray',
	                                        display: 'block', fontSize: '120%' } },
	                                'Order Id ',
	                                values.orderId
	                            ),
	                            _react2.default.createElement(_FormElements.Input, { type: 'hidden', name: 'orderId', disabled: true }),
	                            _react2.default.createElement(_FormElements.ComboBox, { placeholder: 'Select New State', name: 'orderState', value: values.orderState,
	                                options: validToStates, clearable: false,
	                                style: { flexGrow: '1', margin: '0' } }),
	                            _react2.default.createElement('br', null),
	                            values.orderState === ORDER_STATE.CANCELLED.value && _react2.default.createElement(_FormElements.TextArea, { placeholder: 'Please Specify why the order was cancelled.', name: 'cancelledReason',
	                                rows: '2', style: { width: '100%', marginTop: '10px' } }),
	                            _this3.props.order.orderState !== ORDER_STATE.ORDER_PLACED.value && !_this3.props.order.stockProductId && _react2.default.createElement(_FormElements.Checkbox, { name: 'noStockDeduction', label: 'No stock deduction' }),
	                            showStockProductInputs && _react2.default.createElement(
	                                'div',
	                                { id: 'stockProductInputs' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { style: { color: 'gray' } },
	                                    'Deduct Order Stock'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'flexRow', style: { flexWrap: 'nowrap' } },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { flexGrow: 1 } },
	                                        _react2.default.createElement(_FormElements.Input, { type: 'text', label: 'Order Size', name: 'productSize', disabled: true }),
	                                        _react2.default.createElement(_FormElements.ComboBox, { name: 'stockOwner', value: values.stockOwner,
	                                            options: stockOwnerOptions, placeholder: _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                '@ Select Stock Owner'
	                                            ),
	                                            closeOnSelect: true,
	                                            onComboChange: _this3.onStockOwnerChange }),
	                                        _react2.default.createElement(_FormElements.ComboBox, { name: 'stockProduct', value: values.stockProduct,
	                                            options: stockProductOptions,
	                                            placeholder: 'Select Stock Product',
	                                            closeOnSelect: true
	                                        })
	                                    ),
	                                    _react2.default.createElement(_AppElements.Img, { className: 'stockUpdateImg', src: order.orderedProductImage })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _FormElements.SubmitButton,
	                                { color: 'primary', disabled: isSubmitting },
	                                'Update'
	                            )
	                        );
	                    } })
	            );
	        }
	    }]);
	
	    return ChangeOrderStateModalForm;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(ChangeOrderStateModalForm);

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _divider = __webpack_require__(69);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppElements = __webpack_require__(9);
	
	var _StockAddModalForm = __webpack_require__(573);
	
	var _StockAddModalForm2 = _interopRequireDefault(_StockAddModalForm);
	
	var _StockMoveModalForm = __webpack_require__(575);
	
	var _StockMoveModalForm2 = _interopRequireDefault(_StockMoveModalForm);
	
	var _StockHistoryModal = __webpack_require__(574);
	
	var _StockHistoryModal2 = _interopRequireDefault(_StockHistoryModal);
	
	var _reactTable = __webpack_require__(50);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STOCK_OPERATION = { ADD: "ADD", MOVE: "MOVE", REMOVE: "REMOVE", VIEW_HISTORY: "VIEW_HISTORY" };
	
	var EachProductStocks = (0, _radium2.default)(function (props) {
	
	    var previewImage = props.previewImage;
	    var stocks = props.stocks;
	    var showLoading = stocks ? false : true;
	
	    var isAdmin = props.isAdmin;
	
	    var columns = [{ Header: 'Size', accessor: 'productSize',
	        Cell: function Cell(rowData) {
	            return _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center' } },
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    rowData.value
	                )
	            );
	        } }, { Header: 'Quantity', accessor: 'quantity',
	        Cell: function Cell(rowData) {
	            var quantity = rowData.value;
	            var quantityClass = "stockquantity sufficientQuantity";
	            if (quantity <= 0) quantityClass = "stockquantity lowQuantity";else if (quantity < 5) quantityClass = "stockquantity belowAverageQuantity";
	
	            return _react2.default.createElement(
	                'div',
	                { className: quantityClass },
	                quantity
	            );
	        } }, { Header: 'History', accessor: 'stockProductId', width: 200,
	        Cell: function Cell(rowData) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _AppElements.Button,
	                    { mui: 'true', style: { background: "gray", color: 'white' }, onClick: function onClick() {
	                            return props.onShowStockProductHistory(rowData.original);
	                        } },
	                    'View History'
	                )
	            );
	        } }];
	
	    if (isAdmin === true) {
	        var actionCol = { Header: 'Action', accessor: 'stockProductId', width: 200,
	            Cell: function Cell(rowData) {
	
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _AppElements.Button,
	                        { mui: 'true', color: 'primary', style: { background: "#60af60" }, onClick: function onClick() {
	                                return props.onShowAddStockProduct(rowData.original);
	                            } },
	                        '+'
	                    ),
	                    _react2.default.createElement(
	                        _AppElements.Button,
	                        { mui: 'true', disabled: rowData.original.quantity <= 0, onClick: function onClick() {
	                                return props.onShowMoveStockProduct(rowData.original);
	                            } },
	                        'Move'
	                    )
	                );
	            } };
	        columns.push(actionCol);
	    }
	
	    var title = stocks ? stocks[0].product.title : null;
	    var productUrl = stocks ? _AppUtil2.default.getProductURL(stocks[0].product) : "#";
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexRow eachProductStocks' },
	        _react2.default.createElement(
	            'div',
	            { className: 'flexColumn stockPreviewContainer' },
	            _react2.default.createElement(_AppElements.Img, { src: previewImage, className: 'stockPreview' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'stockProductTitle' },
	                _react2.default.createElement(
	                    _AppElements.A,
	                    { href: productUrl, target: '_blank' },
	                    title
	                )
	            )
	        ),
	        _react2.default.createElement(_reactTable2.default, { data: stocks ? stocks : [], columns: columns, minRows: 5,
	            noDataText: 'No Stocks Found.', loading: showLoading,
	            defaultPageSize: 10,
	            className: 'stocks-table'
	        })
	    );
	});
	
	var EachStockOwner = function (_React$Component) {
	    _inherits(EachStockOwner, _React$Component);
	
	    function EachStockOwner(props) {
	        _classCallCheck(this, EachStockOwner);
	
	        var _this = _possibleConstructorReturn(this, (EachStockOwner.__proto__ || Object.getPrototypeOf(EachStockOwner)).call(this, props));
	
	        _this.state = { selectedStockProduct: null, operation: null };
	        _this.onSuccess = _this.onSuccess.bind(_this);
	
	        _this.onShowAddStockProduct = _this.onShowAddStockProduct.bind(_this);
	        _this.onShowMoveStockProduct = _this.onShowMoveStockProduct.bind(_this);
	        _this.onShowStockProductHistory = _this.onShowStockProductHistory.bind(_this);
	        return _this;
	    }
	
	    _createClass(EachStockOwner, [{
	        key: 'onShowAddStockProduct',
	        value: function onShowAddStockProduct(stockProduct) {
	            this.setState({ selectedStockProduct: stockProduct, operation: STOCK_OPERATION.ADD });
	        }
	    }, {
	        key: 'onShowMoveStockProduct',
	        value: function onShowMoveStockProduct(stockProduct) {
	            this.setState({ selectedStockProduct: stockProduct, operation: STOCK_OPERATION.MOVE });
	        }
	    }, {
	        key: 'onShowStockProductHistory',
	        value: function onShowStockProductHistory(stockProduct) {
	            this.setState({ selectedStockProduct: stockProduct, operation: STOCK_OPERATION.VIEW_HISTORY });
	        }
	    }, {
	        key: 'onSuccess',
	        value: function onSuccess() {
	            this.setState({ selectedStockProduct: null, operation: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var owner = this.props.stockOwner;
	            var stocks = this.props.stocks;
	
	            var productStocks = stocks ? stocks.reduce(function (h, stock) {
	                h[stock.product.previewImage] = (h[stock.product.previewImage] || []).concat(stock);
	                return h;
	            }, {}) : [];
	
	            var stockList = Object.keys(productStocks).map(function (previewImage) {
	                return _react2.default.createElement(EachProductStocks, { key: "stock_product_preview_" + previewImage,
	                    previewImage: previewImage, stocks: productStocks[previewImage],
	                    stockOwner: _this2.props.stockOwner,
	                    onShowAddStockProduct: _this2.onShowAddStockProduct,
	                    onShowMoveStockProduct: _this2.onShowMoveStockProduct,
	                    onShowStockProductHistory: _this2.onShowStockProductHistory,
	                    isAdmin: _this2.props.isAdmin });
	            });
	
	            var hasCredit = owner.creditBalance && owner.creditBalance > 0;
	            return _react2.default.createElement(
	                'div',
	                { style: { marginTop: '20px' } },
	                _react2.default.createElement(_divider2.default, null),
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'flexRow', style: { justifyContent: "space-between", textAlign: 'center' } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'ownerName', style: { flexGrow: 1 } },
	                        owner.ownerAlias,
	                        ' Stocks'
	                    ),
	                    hasCredit === true && _react2.default.createElement(
	                        'span',
	                        { className: 'ownerCredit' },
	                        'Credit: ',
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Rs. ',
	                            owner.creditBalance
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'stockList', className: 'flexColumn' },
	                    stockList
	                ),
	                this.state.selectedStockProduct && this.state.operation === STOCK_OPERATION.ADD && _react2.default.createElement(_StockAddModalForm2.default, { stockProduct: this.state.selectedStockProduct, stockOwner: owner, onSuccess: this.onSuccess }),
	                this.state.selectedStockProduct && this.state.operation === STOCK_OPERATION.MOVE && _react2.default.createElement(_StockMoveModalForm2.default, { stockProduct: this.state.selectedStockProduct, stockOwner: owner, allOwners: this.props.allOwners, onSuccess: this.onSuccess }),
	                this.state.selectedStockProduct && this.state.operation === STOCK_OPERATION.VIEW_HISTORY && _react2.default.createElement(_StockHistoryModal2.default, { stockProduct: this.state.selectedStockProduct, onSuccess: this.onSuccess })
	            );
	        }
	    }]);
	
	    return EachStockOwner;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(EachStockOwner);

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _StockAPI = __webpack_require__(73);
	
	var _StockAPI2 = _interopRequireDefault(_StockAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StockAddModalForm = function (_React$Component) {
	    _inherits(StockAddModalForm, _React$Component);
	
	    function StockAddModalForm(props) {
	        _classCallCheck(this, StockAddModalForm);
	
	        var _this = _possibleConstructorReturn(this, (StockAddModalForm.__proto__ || Object.getPrototypeOf(StockAddModalForm)).call(this, props));
	
	        _this.state = { openModal: true };
	
	        _this.getInitValues = _this.getInitValues.bind(_this);
	        _this.onAddStockProduct = _this.onAddStockProduct.bind(_this);
	        _this.handleModalClose = _this.handleModalClose.bind(_this);
	        return _this;
	    }
	
	    _createClass(StockAddModalForm, [{
	        key: 'getInitValues',
	        value: function getInitValues() {
	            var stockProduct = this.props.stockProduct;
	
	            return { productSize: stockProduct.productSize, quantity: 0, comment: '' };
	        }
	    }, {
	        key: 'validationScheme',
	        value: function validationScheme() {
	            return _yup2.default.object().shape({
	                quantity: _yup2.default.number().required('Enter a quantity'),
	                comment: _yup2.default.string()
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ openModal: true });
	        }
	    }, {
	        key: 'onAddStockProduct',
	        value: function onAddStockProduct(value, _ref) {
	            var setSubmitting = _ref.setSubmitting,
	                resetForm = _ref.resetForm;
	
	            var stockProduct = this.props.stockProduct;
	            var addRequest = { stockProductId: stockProduct.stockProductId, quantity: value.quantity, comment: value.comment };
	
	            var stockOwner = this.props.stockOwner;
	            _StockAPI2.default.refillStock(addRequest, function (success) {
	                _StockAPI2.default.getStocks(stockOwner.ownerAlias);
	                this.props.onSuccess();
	            }.bind(this));
	        }
	    }, {
	        key: 'handleModalClose',
	        value: function handleModalClose() {
	            this.props.onSuccess();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stockProduct = this.props.stockProduct;
	            var initValues = this.getInitValues();
	            return _react2.default.createElement(
	                _reactResponsiveModal2.default,
	                { closeOnOverlayClick: false, open: this.state.openModal, onClose: this.handleModalClose, little: true,
	                    classNames: { overlay: 'add-stock-overlay', modal: 'add-stock-modal' } },
	                _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: initValues, onSubmit: this.onAddStockProduct,
	                    validationSchema: this.validationScheme,
	                    render: function render(_ref2) {
	                        var isSubmitting = _ref2.isSubmitting;
	
	
	                        return _react2.default.createElement(
	                            _FormElements.RGForm,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { style: { margin: '10px 0px 20px 0' } },
	                                'Add ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    stockProduct.productSize
	                                ),
	                                ' ',
	                                stockProduct.product.title,
	                                '!'
	                            ),
	                            _react2.default.createElement(_FormElements.Input, { type: 'text', label: 'Product Size', name: 'productSize', disabled: true }),
	                            _react2.default.createElement(_FormElements.Input, { type: 'text', label: _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Quantity ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { color: 'gray' } },
	                                        '(User negative number to reduce)'
	                                    )
	                                ), name: 'quantity' }),
	                            _react2.default.createElement(_FormElements.TextArea, { name: 'comment', placeholder: 'Comment' }),
	                            _react2.default.createElement(
	                                _FormElements.SubmitButton,
	                                { color: 'primary', disabled: isSubmitting },
	                                'Update'
	                            )
	                        );
	                    } })
	            );
	        }
	    }]);
	
	    return StockAddModalForm;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(StockAddModalForm);

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _utils = __webpack_require__(15);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _StockAPI = __webpack_require__(73);
	
	var _StockAPI2 = _interopRequireDefault(_StockAPI);
	
	var _StockStore = __webpack_require__(92);
	
	var _StockStore2 = _interopRequireDefault(_StockStore);
	
	var _DateComponent = __webpack_require__(62);
	
	var _DateComponent2 = _interopRequireDefault(_DateComponent);
	
	var _reactTable = __webpack_require__(50);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StockHistoryModal = function (_React$Component) {
	    _inherits(StockHistoryModal, _React$Component);
	
	    _createClass(StockHistoryModal, null, [{
	        key: 'getStores',
	        value: function getStores() {
	            return [_StockStore2.default];
	        }
	    }, {
	        key: 'calculateState',
	        value: function calculateState(prevState, props) {
	            var stockProductId = props.stockProduct.stockProductId;
	
	            var newState = {
	                histories: _StockStore2.default.getStockProductHistory(stockProductId)
	            };
	
	            return newState;
	        }
	    }]);
	
	    function StockHistoryModal(props) {
	        _classCallCheck(this, StockHistoryModal);
	
	        var _this = _possibleConstructorReturn(this, (StockHistoryModal.__proto__ || Object.getPrototypeOf(StockHistoryModal)).call(this, props));
	
	        _this.state = { openModal: true };
	
	        _this.handleModalClose = _this.handleModalClose.bind(_this);
	        return _this;
	    }
	
	    _createClass(StockHistoryModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var stockProductId = this.props.stockProduct.stockProductId;
	            _StockAPI2.default.getStockHistories(stockProductId);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ openModal: true });
	        }
	    }, {
	        key: 'handleModalClose',
	        value: function handleModalClose() {
	            this.props.onSuccess();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stockProduct = this.props.stockProduct;
	            var histories = this.state.histories;
	            var showLoading = histories ? false : true;
	
	            var columns = [{ Header: 'Date', accessor: 'createdDate', width: 180,
	                Cell: function Cell(props) {
	                    return _react2.default.createElement(_DateComponent2.default, { date: props.value, showTime: true });
	                }
	            }, { Header: 'Type', accessor: 'actionType', width: 150 }, { Header: 'Quantity', accessor: 'quantity', width: 70 }, { Header: 'Comment', accessor: 'comment', className: 'stock-history-comment-col' }];
	
	            return _react2.default.createElement(
	                _reactResponsiveModal2.default,
	                { closeOnOverlayClick: false, open: this.state.openModal, onClose: this.handleModalClose, little: true,
	                    classNames: { overlay: 'stock-history-overlay', modal: 'stock-history-modal', closeIcon: 'stock-history-modal-close' } },
	                _react2.default.createElement(
	                    'h1',
	                    { style: { color: '#444141' } },
	                    stockProduct.product.title,
	                    ' - ',
	                    stockProduct.productSize,
	                    ' = ',
	                    stockProduct.quantity
	                ),
	                _react2.default.createElement(_reactTable2.default, { data: histories ? histories : [], columns: columns, minRows: 5,
	                    noDataText: 'No Histories Found.', loading: showLoading,
	                    className: 'stock-history-table', defaultPageSize: 10,
	                    sorted: [{ // the sorting model for the table
	                        id: 'createdDate',
	                        desc: true
	                    }] })
	            );
	        }
	    }]);
	
	    return StockHistoryModal;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(_utils.Container.create(StockHistoryModal, { withProps: true }));

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _StockAPI = __webpack_require__(73);
	
	var _StockAPI2 = _interopRequireDefault(_StockAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StockMoveModalForm = function (_React$Component) {
	    _inherits(StockMoveModalForm, _React$Component);
	
	    function StockMoveModalForm(props) {
	        _classCallCheck(this, StockMoveModalForm);
	
	        var _this = _possibleConstructorReturn(this, (StockMoveModalForm.__proto__ || Object.getPrototypeOf(StockMoveModalForm)).call(this, props));
	
	        _this.state = { openModal: true };
	
	        _this.getInitValues = _this.getInitValues.bind(_this);
	        _this.onMoveStockProduct = _this.onMoveStockProduct.bind(_this);
	        _this.handleModalClose = _this.handleModalClose.bind(_this);
	        _this.validationScheme = _this.validationScheme.bind(_this);
	        return _this;
	    }
	
	    _createClass(StockMoveModalForm, [{
	        key: 'getInitValues',
	        value: function getInitValues() {
	            var stockProduct = this.props.stockProduct;
	
	            return { productSize: stockProduct.productSize, quantity: 0, toOwnerAlias: '', comment: '' };
	        }
	    }, {
	        key: 'validationScheme',
	        value: function validationScheme() {
	            var stockProduct = this.props.stockProduct;
	            return _yup2.default.object().shape({
	                toOwnerAlias: _yup2.default.string().required("Select which Stock Owner to Move to"),
	                quantity: _yup2.default.number().required('Enter a quantity').min(1, "Enter a positive quantity.").max(stockProduct.quantity, "Max quantity is " + stockProduct.quantity),
	                comment: _yup2.default.string()
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ openModal: true });
	        }
	    }, {
	        key: 'onMoveStockProduct',
	        value: function onMoveStockProduct(value, _ref) {
	            var setSubmitting = _ref.setSubmitting,
	                resetForm = _ref.resetForm;
	
	            var stockProduct = this.props.stockProduct;
	
	            var trasferRequest = { stockProductId: stockProduct.stockProductId, quantity: value.quantity, toOwnerAlias: value.toOwnerAlias, comment: value.comment };
	            var currentOwner = this.props.stockOwner;
	            _StockAPI2.default.transferStock(trasferRequest, function (success) {
	                _StockAPI2.default.getStocks(value.toOwnerAlias);
	                _StockAPI2.default.getStocks(currentOwner.ownerAlias);
	                this.props.onSuccess();
	            }.bind(this));
	        }
	    }, {
	        key: 'handleModalClose',
	        value: function handleModalClose() {
	            this.props.onSuccess();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stockProduct = this.props.stockProduct;
	            var currentOwner = this.props.stockOwner;
	            var allOwners = this.props.allOwners;
	
	            var comboxValues = allOwners.filter(function (o) {
	                return o.userId !== currentOwner.userId;
	            }).map(function (o) {
	                var optJson = { label: o.ownerAlias, value: o.ownerAlias };
	                return optJson;
	            });
	
	            var initValues = this.getInitValues();
	            return _react2.default.createElement(
	                _reactResponsiveModal2.default,
	                { closeOnOverlayClick: false, open: this.state.openModal, onClose: this.handleModalClose, little: true,
	                    classNames: { overlay: 'add-stock-overlay', modal: 'add-stock-modal' } },
	                _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: initValues, onSubmit: this.onMoveStockProduct,
	                    validationSchema: this.validationScheme,
	                    render: function render(_ref2) {
	                        var values = _ref2.values,
	                            isSubmitting = _ref2.isSubmitting;
	
	
	                        return _react2.default.createElement(
	                            _FormElements.RGForm,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { style: { margin: '10px 0px 20px 0' } },
	                                'Move ',
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    stockProduct.productSize
	                                ),
	                                ' ',
	                                stockProduct.product.title,
	                                ' to!'
	                            ),
	                            _react2.default.createElement(_FormElements.ComboBox, { name: 'toOwnerAlias', value: values.toOwnerAlias,
	                                options: comboxValues, placeholder: 'Select Another Stock Owner', multi: false }),
	                            _react2.default.createElement(_FormElements.Input, { type: 'text', label: 'Product Size', name: 'productSize', disabled: true }),
	                            _react2.default.createElement(_FormElements.Input, { type: 'text', label: 'Quantity', name: 'quantity' }),
	                            _react2.default.createElement(_FormElements.TextArea, { name: 'comment', placeholder: 'Comment' }),
	                            _react2.default.createElement(
	                                _FormElements.SubmitButton,
	                                { color: 'primary', disabled: isSubmitting },
	                                'Update'
	                            )
	                        );
	                    } })
	            );
	        }
	    }]);
	
	    return StockMoveModalForm;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(StockMoveModalForm);

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _AppElements = __webpack_require__(9);
	
	var _FormElements = __webpack_require__(13);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MIN_WITHDRAWAL_AMOUNT = 2000;
	
	var Form = function Form(_ref) {
		var isSubmitting = _ref.isSubmitting,
		    values = _ref.values;
	
		var submitBtn = "Submit";
	
		if (isSubmitting === true) submitBtn = _react2.default.createElement(
			'span',
			null,
			'Submitting ',
			_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
		);
	
		return _react2.default.createElement(
			_FormElements.RGForm,
			null,
			_react2.default.createElement(_AppElements.Separator, { style: { margin: '20px auto', width: '30%' } }),
			_react2.default.createElement(_FormElements.Input, { name: 'amount', type: 'text', disabled: true, label: 'Amount: Rs.',
				value: values.amount, style: { marginBottom: "0px" } }),
			_react2.default.createElement(
				'div',
				{ style: { marginBottom: '10px' } },
				_react2.default.createElement(
					'label',
					null,
					'Select Payment Method:'
				),
				_react2.default.createElement(
					'div',
					{ className: 'flexRow', style: { marginBottom: '0px' }, id: 'joinAsRadioBtnGroup' },
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'paymentVia', value: "eSewa",
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							'eSewa '
						),
						checked: values.paymentVia === "eSewa" }),
					_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'paymentVia', value: "bank",
						label: _react2.default.createElement(
							'span',
							{ style: { color: '#596161' } },
							'Bank Transfer'
						),
						checked: values.paymentVia === "bank" })
				)
			),
			values.paymentVia === "eSewa" && _react2.default.createElement(_FormElements.Input, { name: 'esewaId', type: 'number', label: 'eSewa Id (10 digit):', placeholder: 'E.g. 9862441133', style: { marginBottom: "0px" } }),
			values.paymentVia === "bank" && _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					'div',
					{ style: { margin: '0 0 20px 0', color: 'gray', fontWeight: 'bold' } },
					'Note: Bank Transfer charges will be deducted from the requested amount.'
				),
				_react2.default.createElement(_FormElements.Input, { name: 'bankAccountNo', type: 'text', label: 'Account No: ', style: { marginBottom: "0px", marginTop: "10px" } }),
				_react2.default.createElement(_FormElements.Input, { name: 'bankAccountName', type: 'text', label: 'Account Name: ', style: { marginBottom: "0px", marginTop: "10px" } }),
				_react2.default.createElement(_FormElements.Input, { name: 'bankName', type: 'text', label: 'Bank Name', style: { marginBottom: "0px" } }),
				_react2.default.createElement(_FormElements.Input, { name: 'bankBranch', type: 'text', label: 'Bank Branch', style: { marginBottom: "0px" } })
			),
			_react2.default.createElement(
				_FormElements.SubmitButton,
				{ style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting },
				submitBtn
			)
		);
	};
	
	var PaymentModal = function (_React$Component) {
		_inherits(PaymentModal, _React$Component);
	
		function PaymentModal(props) {
			_classCallCheck(this, PaymentModal);
	
			var _this = _possibleConstructorReturn(this, (PaymentModal.__proto__ || Object.getPrototypeOf(PaymentModal)).call(this, props));
	
			_this.INIT_VALUES = { paymentVia: '', esewaId: '',
				bankAccountNo: '', bankAccountName: '',
				bankName: '', bankBranch: '',
				amount: _this.props.currentBalance
			};
	
			_this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
			return _this;
		}
	
		_createClass(PaymentModal, [{
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					amount: _yup2.default.number().min(MIN_WITHDRAWAL_AMOUNT, 'Min withdrawal amount is Rs. ' + _AppUtil2.default.formatNumber(MIN_WITHDRAWAL_AMOUNT)),
					paymentVia: _yup2.default.string().required('Select your payment method'),
					esewaId: _yup2.default.string().when(['paymentVia'], function (paymentVia, schema) {
						if (paymentVia === 'eSewa') return _yup2.default.string().required('Provide your eSewa Id');
	
						return _yup2.default.string();
					}),
					bankAccountNo: _yup2.default.string().when(['paymentVia'], function (paymentVia, schema) {
						if (paymentVia === 'bank') return _yup2.default.string().required('Enter your Account No.');
	
						return _yup2.default.string();
					}),
					bankAccountName: _yup2.default.string().when(['paymentVia'], function (paymentVia, schema) {
						if (paymentVia === 'bank') return _yup2.default.string().required('Enter your Account Name');
	
						return _yup2.default.string();
					}),
					bankName: _yup2.default.string().when(['paymentVia'], function (paymentVia, schema) {
						if (paymentVia === 'bank') return _yup2.default.string().required('Enter your Bank Name');
	
						return _yup2.default.string();
					}),
					bankBranch: _yup2.default.string().when(['paymentVia'], function (paymentVia, schema) {
						if (paymentVia === 'bank') return _yup2.default.string().required('Enter your Bank Branch');
	
						return _yup2.default.string();
					})
				});
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(values, _ref2) {
				var setSubmitting = _ref2.setSubmitting,
				    resetForm = _ref2.resetForm;
	
				var sendToDetail = {};
	
				if (values.paymentVia === "eSewa") {
					sendToDetail["eSewa"] = values.esewaId;
				} else if (values.paymentVia === "bank") {
					sendToDetail["Bank Account No"] = values.bankAccountNo;
					sendToDetail["Bank Account Name"] = values.bankAccountName;
					sendToDetail["Bank Name"] = values.bankName;
					sendToDetail["Bank Branch"] = values.bankBranch;
				}
				var confirmRest = confirm("Are you sure you want to withdraw Rs. " + this.props.currentBalance + " amount?");
	
				if (confirmRest === true) {
					var targetIds = this.props.productStats.filter(function (t) {
						return t.targetAchieved >= t.currentTarget.salesTarget;
					}).map(function (t) {
						return t.currentTarget.id;
					});
					_HttpService2.default.redeem(targetIds, sendToDetail, function (success) {
						setSubmitting(false);
	
						//on success, reload cashable targets and redeem history
						if (success) {
							_HttpService2.default.getDesignerBalance();
							resetForm(this.INIT_VALUES);
							this.props.onClose();
						}
					}.bind(this));
				} else {
					setSubmitting(false);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    open = _props.open,
				    onClose = _props.onClose;
	
				return _react2.default.createElement(
					_reactResponsiveModal2.default,
					{ closeOnOverlayClick: false, open: open, onClose: onClose,
						classNames: { modal: 'withdraw-payment-modal', closeIcon: 'withdraw-payment-close-icon' } },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h2',
							null,
							'Send Withdraw Request'
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 0 20px 0', color: 'orange', fontSize: '90%' } },
							'Your amount will be transferred within 7 days of request.'
						),
						_react2.default.createElement(_formik.Formik, { initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
							validationSchema: this.validationScheme, component: Form })
					)
				);
			}
		}]);
	
		return PaymentModal;
	}(_react2.default.Component);
	
	exports.default = PaymentModal;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormElements = __webpack_require__(13);
	
	var _AppElements = __webpack_require__(9);
	
	var _reactSelect = __webpack_require__(144);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AVAILABLE_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'A1', 'A2', 'A3', 'A4', 'A5', 'NA'];
	
	var ReadOnlySizeInput = function ReadOnlySizeInput(_ref) {
	    var selectedSize = _ref.selectedSize,
	        selectedLabel = _ref.selectedLabel,
	        onRemoveSize = _ref.onRemoveSize;
	
	    var onCancel = function onCancel(event) {
	        event.preventDefault();
	        onRemoveSize(selectedSize);
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexRow readOnlyProductSize' },
	        _react2.default.createElement(
	            'div',
	            null,
	            selectedSize
	        ),
	        _react2.default.createElement('input', { type: 'text', value: selectedLabel, readOnly: true }),
	        _react2.default.createElement(
	            _AppElements.Button,
	            { mui: 'true', onClick: onCancel },
	            'X'
	        )
	    );
	};
	
	var EditableSizeInput = function EditableSizeInput(_ref2) {
	    var sizeOptions = _ref2.sizeOptions,
	        onSetSize = _ref2.onSetSize;
	
	    var _useState = (0, _react.useState)(''),
	        _useState2 = _slicedToArray(_useState, 2),
	        selectedSize = _useState2[0],
	        setSelectedSize = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(''),
	        _useState4 = _slicedToArray(_useState3, 2),
	        sizeLabel = _useState4[0],
	        setSizeLabel = _useState4[1];
	
	    var onOK = function onOK(event) {
	        event.preventDefault();
	        onSetSize(selectedSize, sizeLabel);
	        setSelectedSize('');
	        setSizeLabel('');
	    };
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'flexRow editProductSize' },
	            _react2.default.createElement(
	                'div',
	                { className: 'flexColumn selectSizeInput' },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    'Select Size:'
	                ),
	                _react2.default.createElement(_reactSelect2.default, { value: selectedSize, options: sizeOptions,
	                    style: { flexGrow: '1', minWidth: '50%' },
	                    onChange: function onChange(opt) {
	                        if (opt) setSelectedSize(opt.value);
	                    } })
	            ),
	            _react2.default.createElement(_FormElements.Input, { name: 'sizeLabel', className: 'sizeLabelInput', type: 'text', value: sizeLabel, label: 'Enter Label: ', placeholder: 'Eg. Medium (12" x 14")',
	                onChange: function onChange(event) {
	                    setSizeLabel(event.target.value);
	                } }),
	            _react2.default.createElement(
	                _AppElements.Button,
	                { mui: 'true', style: { marginRight: ' 10px' }, onClick: onOK },
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' })
	            )
	        )
	    );
	};
	
	var ProductSizeInput = function ProductSizeInput(_ref3) {
	    var values = _ref3.values,
	        setFieldValue = _ref3.setFieldValue;
	
	    var sizes = values.productSizes ? values.productSizes : {};
	    var sizeKeys = Object.keys(sizes);
	    var sizeOptions = AVAILABLE_SIZES.filter(function (s) {
	        return sizeKeys.indexOf(s) < 0;
	    }).map(function (s) {
	        return { label: s, value: s };
	    });
	
	    var onRemoveSize = function onRemoveSize(size) {
	        var sizesClone = Object.assign({}, sizes);
	        delete sizesClone[size];
	        setFieldValue('productSizes', Object.keys(sizesClone).length === 0 ? '' : sizesClone);
	    };
	
	    var onSetSize = function onSetSize(selectedSize, sizeLabel) {
	        var sizesClone = Object.assign({}, sizes);
	        sizesClone[selectedSize] = { label: sizeLabel, shortLabel: selectedSize, priceAddition: 0.0 };
	        setFieldValue('productSizes', sizesClone);
	    };
	
	    var selectedSizes = sizeKeys.map(function (k) {
	        var s = sizes[k];
	        return _react2.default.createElement(ReadOnlySizeInput, { key: "readonlyInput-" + k, onRemoveSize: onRemoveSize, selectedSize: k, selectedLabel: s.label });
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'productSizeInput' },
	        _react2.default.createElement(
	            'label',
	            null,
	            'Artwork Size: '
	        ),
	        _react2.default.createElement(EditableSizeInput, { sizeOptions: sizeOptions, onSetSize: onSetSize }),
	        _react2.default.createElement(_FormElements.Input, { type: 'hidden', mui: 'off', name: 'productSizes' }),
	        selectedSizes
	    );
	};
	
	exports.default = ProductSizeInput;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactTable = __webpack_require__(50);
	
	var _reactTable2 = _interopRequireDefault(_reactTable);
	
	var _DateComponent = __webpack_require__(62);
	
	var _DateComponent2 = _interopRequireDefault(_DateComponent);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedeemHistoryList = function (_React$Component) {
		_inherits(RedeemHistoryList, _React$Component);
	
		function RedeemHistoryList() {
			_classCallCheck(this, RedeemHistoryList);
	
			return _possibleConstructorReturn(this, (RedeemHistoryList.__proto__ || Object.getPrototypeOf(RedeemHistoryList)).apply(this, arguments));
		}
	
		_createClass(RedeemHistoryList, [{
			key: 'render',
			value: function render() {
				var redeemHistory = this.props.redeemHistory;
	
				var columns = [{ Header: 'Amount', accessor: 'amount',
					Cell: function Cell(props) {
						return _react2.default.createElement(
							'b',
							null,
							"Rs. " + _AppUtil2.default.formatNumber(props.value)
						);
					}
				}, { Header: 'Withdraw State', accessor: 'state' }, { Header: 'Withdraw Requested On', accessor: 'createdDate',
					Cell: function Cell(props) {
						return _react2.default.createElement(_DateComponent2.default, { date: props.value });
					}
				}, { Header: 'Withdrawn On', accessor: 'redeemedDate',
					Cell: function Cell(props) {
						return props.value ? _react2.default.createElement(_DateComponent2.default, { date: props.value }) : "-";
					}
				}];
	
				var showLoading = redeemHistory ? false : true;
	
				var style = [];
	
				if (this.props.style) style.push(this.props.style);
	
				return _react2.default.createElement(
					'div',
					{ style: style },
					_react2.default.createElement(
						'h2',
						null,
						_react2.default.createElement(
							'u',
							null,
							'Withdrawal History'
						)
					),
					_react2.default.createElement(_reactTable2.default, { data: redeemHistory ? redeemHistory.toArray() : [], columns: columns, minRows: 5,
						noDataText: 'You have no withdrawal history.', loading: showLoading })
				);
			}
		}]);
	
		return RedeemHistoryList;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(RedeemHistoryList);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SalesTargetForm = function (_React$Component) {
		_inherits(SalesTargetForm, _React$Component);
	
		function SalesTargetForm(props) {
			_classCallCheck(this, SalesTargetForm);
	
			var _this = _possibleConstructorReturn(this, (SalesTargetForm.__proto__ || Object.getPrototypeOf(SalesTargetForm)).call(this, props));
	
			var product = props.product;
			var currentTarget = _this.props.currentTarget;
	
			_this.TARGET_OPTIONS = Object.keys(product.salesTargetCommissionConfig).filter(function (k) {
				return k > currentTarget.salesTarget;
			}).map(function (k) {
				return { label: k, value: k };
			});
	
			_this.INIT_VALUES = { salesTarget: _this.TARGET_OPTIONS.length > 0 ? _this.TARGET_OPTIONS[0].label : '' };
	
			_this.validationScheme = _this.validationScheme.bind(_this);
			_this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
			return _this;
		}
	
		_createClass(SalesTargetForm, [{
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					salesTarget: _yup2.default.string().required("Select a sales target")
				});
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(value, _ref) {
				var setSubmitting = _ref.setSubmitting,
				    resetForm = _ref.resetForm;
	
				var selectedTarget = value.salesTarget;
	
				var productId = this.props.product.id;
	
				_HttpService2.default.increaseCurrentTarget(productId, selectedTarget, function (success) {
					setSubmitting(false);
	
					if (success) {
						resetForm();
						_HttpService2.default.getProductStat(productId);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var product = this.props.product;
				if (this.TARGET_OPTIONS.length === 0) return _react2.default.createElement(
					'h4',
					null,
					'You have completed your sales targets. Click ',
					_react2.default.createElement(
						_AppElements.A,
						{ href: '/designer/dashboard' },
						'here'
					),
					' to withdraw it.'
				);
	
				return _react2.default.createElement(
					'div',
					{ id: 'salesTargetForm' },
					_react2.default.createElement(
						'h4',
						null,
						'You can either ',
						_react2.default.createElement(
							_AppElements.A,
							{ href: '/designer/dashboard' },
							'withdraw'
						),
						' it or increase your target to earn more.'
					),
					_react2.default.createElement(
						'div',
						{ style: { width: '30%', margin: '0 auto', '@media (max-width: 770px)': { width: '100%' } } },
						_react2.default.createElement(_formik.Formik, { initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
							validationSchema: this.validationScheme,
							render: function render(_ref2) {
								var values = _ref2.values,
								    setFieldValue = _ref2.setFieldValue,
								    isSubmitting = _ref2.isSubmitting;
	
	
								var submitBtn = 'Submit';
	
								if (isSubmitting === true) submitBtn = _react2.default.createElement(
									'span',
									null,
									'Submitting ',
									_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
								);
	
								var commission = values.salesTarget ? product.salesTargetCommissionConfig[values.salesTarget] / 100.0 * product.margin : null;
								return _react2.default.createElement(
									_FormElements.RGForm,
									null,
									_react2.default.createElement(_FormElements.ComboBox, { name: 'salesTarget', value: values.salesTarget,
										options: _this2.TARGET_OPTIONS, placeholder: 'Select Target',
										clearable: false }),
									commission && _react2.default.createElement(
										'h4',
										null,
										'You can earn ',
										_react2.default.createElement(
											'b',
											null,
											'Rs. ',
											commission
										),
										' per quantity sold.'
									),
									_react2.default.createElement(
										_FormElements.SubmitButton,
										{ color: 'primary', disabled: isSubmitting, style: { width: '100%' } },
										submitBtn
									)
								);
							} })
					)
				);
			}
		}]);
	
		return SalesTargetForm;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(SalesTargetForm);

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _SubmitProductForm = __webpack_require__(222);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _SelectedImagePreview = __webpack_require__(64);
	
	var _SelectedImagePreview2 = _interopRequireDefault(_SelectedImagePreview);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PRODUCT_IMAGES_LMT = 2;
	var DIGITAL_ART_IMG_CONSTRAINT = "At least 600px x 600px, Max 50-200 Kb";
	var PHOTOGRAPH_IMG_CONSTRAINT = "At least 800px in height or width, Max 50-200 Kb";
	
	var ARTWORK_TYPES = _AppConstants2.default.ARTWORK_TYPES;
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	
	var StepOne = function StepOne(_ref) {
		var values = _ref.values,
		    baseProduct = _ref.baseProduct;
	
		var baseProductType = baseProduct.productType;
		var artworkType = ARTWORK_TYPES[values.artworkType];
		var productTypeOptions = Object.keys(PRODUCT_TYPES).map(function (k) {
			return PRODUCT_TYPES[k];
		}).filter(function (p) {
			return p.available === true;
		}).filter(function (p) {
			return p.val !== baseProductType && artworkType.supportedProductTypes.indexOf(p.val) >= 0;
		}).map(function (p) {
			return { 'label': p.label,
				'value': p.val };
		});
	
		var productType = PRODUCT_TYPES[values.productType];
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'submitStep flexRow' },
				_react2.default.createElement(
					'span',
					null,
					'Step'
				),
				' ',
				_react2.default.createElement(
					'span',
					{ className: 'stepCount' },
					'1'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'flexColumn' },
				_react2.default.createElement(
					'label',
					{ style: { margin: '0 0 10px 0', display: 'block' } },
					'Select Product Type:'
				),
				_react2.default.createElement(_FormElements.ComboBox, { name: 'productType', value: values.productType,
					options: productTypeOptions,
					style: { flexGrow: '1', minWidth: '50%' } }),
				productType && _react2.default.createElement(
					'span',
					{ style: { background: '#f8921d', padding: '5px 10px', color: 'white', borderBottom: '2px solid rgb(61, 61, 61)' } },
					productType.psdTemplateUrl && _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
						' Use ',
						_react2.default.createElement(
							_AppElements.A,
							{ href: productType.psdTemplateUrl, style: { textDecoration: 'underline', fontWeight: 'bold', color: '#3d3d3d' } },
							productType.label,
							'.psd'
						),
						' to put your ',
						artworkType.label,
						' on a ',
						productType.label,
						'.'
					)
				)
			),
			_react2.default.createElement(_AppElements.Separator, null)
		);
	};
	
	var StepTwo = function StepTwo(_ref2) {
		var values = _ref2.values,
		    previewImage = _ref2.previewImage,
		    productImages = _ref2.productImages,
		    onProductImgsUpdate = _ref2.onProductImgsUpdate;
	
		if (!values.productType || !values.artworkType) return null;
	
		function onProductImgUpload(inputId) {
			var files = document.getElementById(inputId).files;
	
			var filesArr = [];
			for (var i = 0; i < files.length; i++) {
				filesArr[i] = files[i];
			} //the productImages state is read only
			var newProductImages = filesArr.concat(productImages);
			newProductImages.reverse();
			onProductImgsUpdate(newProductImages);
		}
	
		function clearProductImage(index) {
			//the productImages state is read only
			var newProductImages = productImages.concat([]);
			newProductImages.splice(index, 1);
			onProductImgsUpdate(newProductImages);
		}
	
		var imgConstraint = values.artworkType === ARTWORK_TYPES["PHOTOGRAPH"].val ? PHOTOGRAPH_IMG_CONSTRAINT : DIGITAL_ART_IMG_CONSTRAINT;
		var productImgConstraintInfo = _react2.default.createElement(
			'span',
			{ style: { fontSize: '70%', color: 'black' } },
			'(',
			imgConstraint + ", at least 1",
			')'
		);
	
		var productImagesPreview = productImages.map(function (img, i) {
			var preview = _react2.default.createElement(_SubmitProductForm.AddedImagePreview, { key: "productImage_" + i, id: "productImage_" + i, file: img, onRemove: function onRemove() {
					return clearProductImage(i);
				} });
			return preview;
		});
	
		var productUploaderSize = productImagesPreview ? PRODUCT_IMAGES_LMT - productImagesPreview.length : PRODUCT_IMAGES_LMT;
		var productImgUploaders = [].concat(_toConsumableArray(Array(productUploaderSize).keys())).map(function (i) {
			var inputId = "productImageFile_" + i;
			return _react2.default.createElement(_SubmitProductForm.ImgUploadForm, { inputId: inputId, key: inputId, onChange: function onChange() {
					return onProductImgUpload(inputId);
				} });
		});
	
		var productType = _AppConstants2.default.PRODUCT_TYPES[values.productType];
	
		var learnMore = null;
		if (productType === _AppConstants2.default.PRODUCT_TYPES.T_SHIRT) learnMore = _react2.default.createElement(
			'small',
			{ style: { fontSize: '90%' } },
			_react2.default.createElement(
				_AppElements.A,
				{ href: '/faq#tshirtDesignLimitation' },
				'Learn More!'
			)
		);else if (productType === _AppConstants2.default.PRODUCT_TYPES.HOODIES) learnMore = _react2.default.createElement(
			'small',
			{ style: { fontSize: '90%' } },
			_react2.default.createElement(
				_AppElements.A,
				{ href: '/faq#hoodiesDesignLimitation' },
				'Learn More!'
			)
		);
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'submitStep flexRow' },
				_react2.default.createElement(
					'span',
					null,
					'Step'
				),
				' ',
				_react2.default.createElement(
					'span',
					{ className: 'stepCount' },
					'2'
				)
			),
			_react2.default.createElement(
				'div',
				{ id: 'designImgUploader', style: { minWidth: '100px', minHeight: '150px' } },
				_react2.default.createElement(
					'div',
					{ className: 'flexRow', style: { marginBottom: '20px' } },
					_react2.default.createElement(_SelectedImagePreview2.default, { id: 'designImagePreview', src: previewImage })
				)
			),
			_react2.default.createElement(
				'div',
				{ id: 'productImgUploader', style: { minWidth: '100px', minHeight: '150px' } },
				_react2.default.createElement(
					'label',
					null,
					_react2.default.createElement(
						'span',
						null,
						'Add ',
						productType.label,
						' Image: ',
						learnMore
					),
					productImgConstraintInfo
				),
				_react2.default.createElement(
					'div',
					{ className: 'flexRow' },
					productImagesPreview && _react2.default.createElement(
						'div',
						{ className: 'flexRow' },
						productImagesPreview
					),
					productImgUploaders && _react2.default.createElement(
						'div',
						{ className: 'flexRow' },
						productImgUploaders
					)
				),
				_react2.default.createElement(_FormElements.Input, { id: 'productImage', name: 'productImage', mui: 'off', type: 'hidden' })
			)
		);
	};
	
	var StepThree = function StepThree(_ref3) {
		var values = _ref3.values,
		    productTagOptions = _ref3.productTagOptions,
		    isSubmitting = _ref3.isSubmitting;
	
		if (!values.productType || !values.artworkType) return null;
	
		var submitBtn = _react2.default.createElement(
			'span',
			null,
			_react2.default.createElement('i', { className: 'fa fa-cloud-upload', 'aria-hidden': 'true' }),
			' Submit'
		);
	
		if (isSubmitting === true) submitBtn = _react2.default.createElement(
			'span',
			null,
			_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' }),
			' Submitting'
		);
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'submitStep flexRow' },
				_react2.default.createElement(
					'span',
					null,
					'Step'
				),
				' ',
				_react2.default.createElement(
					'span',
					{ className: 'stepCount' },
					'3'
				)
			),
			_react2.default.createElement(_FormElements.Input, { label: 'Title: ', name: 'title', type: 'text' }),
			_react2.default.createElement(
				'label',
				{ style: { margin: '0 0 10px 0', display: 'block' } },
				'Select Tags or Enter new:'
			),
			_react2.default.createElement(_FormElements.ComboBox, { name: 'productTags', value: values.productTags,
				options: productTagOptions, placeholder: 'Select Tags or Enter new (Optional)',
				multi: true,
				closeOnSelect: true,
				creatable: true
			}),
			_react2.default.createElement(
				'label',
				{ style: { margin: '0 0 10px 0', display: 'block' } },
				'Description:'
			),
			_react2.default.createElement(_FormElements.TextArea, { placeholder: "Add a short info of your design (Optional)", name: 'description', rows: '1' }),
			_react2.default.createElement(
				_FormElements.SubmitButton,
				{ color: 'primary', disabled: isSubmitting },
				submitBtn
			),
			values.artworkType === ARTWORK_TYPES.PHOTOGRAPH.val && _react2.default.createElement(
				'div',
				{ className: 'highlightInfo' },
				_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
				' You must also email your original photograph image at: ',
				_react2.default.createElement(
					'b',
					null,
					'setocanvas@gmail.com'
				),
				'.'
			),
			values.artworkType === ARTWORK_TYPES.DIGITAL_ART.val && _react2.default.createElement(
				'div',
				{ className: 'highlightInfo' },
				_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
				' You must also email a ',
				_react2.default.createElement(
					'b',
					null,
					'300 resolution A4 size .png file (background less)'
				),
				' of your design at: ',
				_react2.default.createElement(
					'b',
					null,
					'setocanvas@gmail.com'
				),
				'.'
			)
		);
	};
	
	var SubmitSubProductForm = function (_React$Component) {
		_inherits(SubmitSubProductForm, _React$Component);
	
		function SubmitSubProductForm(props) {
			_classCallCheck(this, SubmitSubProductForm);
	
			var _this = _possibleConstructorReturn(this, (SubmitSubProductForm.__proto__ || Object.getPrototypeOf(SubmitSubProductForm)).call(this, props));
	
			_this.validationScheme = _this.validationScheme.bind(_this);
			_this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
			_this.INIT_VALUES = _this.initializeValues();
	
			_this.PRODUCT_IMAGES = [];
	
			_this.state = {};
			_this.handleOnProductImagesUpload = _this.handleOnProductImagesUpload.bind(_this);
			return _this;
		}
	
		_createClass(SubmitSubProductForm, [{
			key: 'initializeValues',
			value: function initializeValues() {
				var product = this.props.product;
				var productType = '';
	
				//set photograph and frame by default for Photographer user
				return { title: product.title, description: product.description, artworkType: product.artworkType, productType: productType,
					productImage: '', productTags: product.productTags || []
				};
			}
		}, {
			key: 'clearUploadedFiles',
			value: function clearUploadedFiles() {
				this.PRODUCT_IMAGES = [];
			}
		}, {
			key: 'handleOnProductImagesUpload',
			value: function handleOnProductImagesUpload(productImages, setFieldValue) {
				this.PRODUCT_IMAGES = productImages;
				setFieldValue('productImage', productImages.length > 0 ? '1' : ''); //set a non-empty string to indicate the value has been set
			}
		}, {
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					title: _yup2.default.string().required("Enter a title that defines your design"),
					productType: _yup2.default.string().required("Select a product type"),
					productTags: _yup2.default.array().max(5, "Maximum 5 tags allowed"),
					productImage: _yup2.default.string().required("Add product image with your design")
				});
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(value, _ref4) {
				var setSubmitting = _ref4.setSubmitting,
				    resetForm = _ref4.resetForm;
	
				var product = this.props.product;
				var selectedProductType = value.productType;
	
				var addSubProductRequest = { baseProductId: product.id, title: value.title, description: value.description,
					productType: selectedProductType,
					productTags: value.productTags };
	
				_HttpService2.default.addSubProduct(addSubProductRequest, this.PRODUCT_IMAGES, function (success) {
					setSubmitting(false);
					if (!success) {
						return;
					}
					resetForm();
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var productTagOptions = _AppConstants2.default.DEFAULT_PRODUCT_TAGS.map(function (v) {
					return { 'label': v.toUpperCase(), 'value': v.toLowerCase() };
				});
	
				var product = this.props.product;
				var productUrl = product ? _AppUtil2.default.getProductURL(product) : "#";
				return _react2.default.createElement(
					'div',
					{ id: 'submitProductForm' },
					_react2.default.createElement(
						'h3',
						null,
						_react2.default.createElement(
							_AppElements.A,
							{ href: productUrl },
							'Go Back'
						)
					),
					_react2.default.createElement(_formik.Formik, { initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
						validationSchema: this.validationScheme,
						render: function render(_ref5) {
							var values = _ref5.values,
							    setFieldValue = _ref5.setFieldValue,
							    isSubmitting = _ref5.isSubmitting;
	
							return _react2.default.createElement(
								_FormElements.RGForm,
								null,
								_react2.default.createElement(StepOne, { values: values, baseProduct: product }),
								_react2.default.createElement(StepTwo, { values: values, previewImage: product.previewImage, productImages: _this2.PRODUCT_IMAGES,
									onProductImgsUpdate: function onProductImgsUpdate(productImages) {
										_this2.handleOnProductImagesUpload(productImages, setFieldValue);
									} }),
								_react2.default.createElement(StepThree, { values: values, productTagOptions: productTagOptions, isSubmitting: isSubmitting })
							);
						} })
				);
			}
		}]);
	
		return SubmitSubProductForm;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(SubmitSubProductForm);

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _ProductOrderForm2 = __webpack_require__(96);
	
	var _ProductOrderForm3 = _interopRequireDefault(_ProductOrderForm2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CoupleProductOrderForm = function (_ProductOrderForm) {
	    _inherits(CoupleProductOrderForm, _ProductOrderForm);
	
	    function CoupleProductOrderForm(props) {
	        _classCallCheck(this, CoupleProductOrderForm);
	
	        var _this = _possibleConstructorReturn(this, (CoupleProductOrderForm.__proto__ || Object.getPrototypeOf(CoupleProductOrderForm)).call(this, props));
	
	        _this.initialValues = _this.initialValues.bind(_this);
	        _this.validationScheme = _this.validationScheme.bind(_this);
	        _this.createOrderRequest = _this.createOrderRequest.bind(_this);
	        return _this;
	    }
	
	    _createClass(CoupleProductOrderForm, [{
	        key: 'initialValues',
	        value: function initialValues() {
	            var initValues = _get(CoupleProductOrderForm.prototype.__proto__ || Object.getPrototypeOf(CoupleProductOrderForm.prototype), 'initialValues', this).call(this);
	            delete initValues.productSize;
	
	            initValues.maleSize = '';
	            initValues.femaleSize = '';
	            return initValues;
	        }
	    }, {
	        key: 'validationScheme',
	        value: function validationScheme() {
	            var validation = _get(CoupleProductOrderForm.prototype.__proto__ || Object.getPrototypeOf(CoupleProductOrderForm.prototype), 'validationScheme', this).call(this);
	            delete validation.productSize;
	
	            validation.maleSize = _yup2.default.string().required("Select a preferrable male size.");
	            validation.femaleSize = _yup2.default.string().required("Select a preferrable female size.");
	
	            return validation;
	        }
	    }, {
	        key: 'createOrderRequest',
	        value: function createOrderRequest(formValue) {
	            var order = _get(CoupleProductOrderForm.prototype.__proto__ || Object.getPrototypeOf(CoupleProductOrderForm.prototype), 'createOrderRequest', this).call(this, formValue);
	
	            order.productSizes = [];
	            order.productSizes.push(formValue.maleSize);
	            order.productSizes.push(formValue.femaleSize);
	            return order;
	        }
	    }, {
	        key: 'displayDeliveryInputs',
	        value: function displayDeliveryInputs(formValue) {
	            var quantity = formValue.quantity;
	            var maleSize = formValue.maleSize;
	            var femaleSize = formValue.femaleSize;
	
	            return !isNaN(quantity) && maleSize !== '' && femaleSize !== '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _get(CoupleProductOrderForm.prototype.__proto__ || Object.getPrototypeOf(CoupleProductOrderForm.prototype), 'render', this).call(this);
	        }
	    }]);
	
	    return CoupleProductOrderForm;
	}(_ProductOrderForm3.default);
	
	exports.default = CoupleProductOrderForm;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Thumbnail = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _FormElements = __webpack_require__(13);
	
	var _ProductTags = __webpack_require__(233);
	
	var _ProductTags2 = _interopRequireDefault(_ProductTags);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _OrderFormLoader = __webpack_require__(140);
	
	var _OrderForm = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	
	var selectedThumbnailStyle = { cursor: "pointer", filter: "opacity(100%)" };
	var styles = {
		selectedThumbnail: selectedThumbnailStyle,
	
		smallThumbnailImg: { filter: "opacity(50%)",
			boxSizing: "border-box", marginRight: "10px", border: "1px #c1c1c1 solid",
			alignItems: 'center', justifyContent: 'center', display: 'flex',
			overflow: 'hidden',
			":hover": selectedThumbnailStyle },
	
		largeThumbnail: { cursor: 'pointer', marginBottom: '10px', background: 'white', alignItems: 'center', justifyContent: 'center', display: 'flex', overflow: 'hidden' }
	};
	
	var Thumbnail = exports.Thumbnail = function Thumbnail(_ref) {
		var image = _ref.image,
		    title = _ref.title,
		    style = _ref.style,
		    onImageLoad = _ref.onImageLoad;
	
		var thumbnailStyle = Object.assign({}, styles.largeThumbnail);
	
		var _useState = (0, _react.useState)(false),
		    _useState2 = _slicedToArray(_useState, 2),
		    openModal = _useState2[0],
		    setOpenModal = _useState2[1];
	
		if (style) thumbnailStyle = Object.assign(thumbnailStyle, style);
	
		return _react2.default.createElement(
			'div',
			{ style: thumbnailStyle, className: 'extraLargeImg thumbnailHolder' },
			_react2.default.createElement('img', { src: image, onLoad: onImageLoad, onClick: function onClick() {
					return setOpenModal(true);
				}, alt: title + " on SetoCanvas.com", className: 'extraLargeImg' }),
			_react2.default.createElement(
				_reactResponsiveModal2.default,
				{ closeOnOverlayClick: true, open: openModal, onClose: function onClose() {
						return setOpenModal(false);
					},
					classNames: { modal: 'product-image-modal', closeIcon: 'product-image-close-icon' } },
				_react2.default.createElement('img', { src: image, alt: title + " on SetoCanvas.com" })
			)
		);
	};
	
	var EachPreview = (0, _radium2.default)(function (_ref2) {
		var onImgClick = _ref2.onImgClick,
		    imgSrc = _ref2.imgSrc,
		    imgStyle = _ref2.imgStyle,
		    imgTitle = _ref2.imgTitle;
	
	
		return _react2.default.createElement(
			'div',
			{ className: 'miniImgContainer', style: imgStyle },
			_react2.default.createElement('img', { className: 'miniImg', src: imgSrc, alt: imgTitle,
				onClick: function onClick() {
					return onImgClick();
				} })
		);
	});
	
	var OrderProductImage = function OrderProductImage() {
		var _useState3 = (0, _react.useState)(false),
		    _useState4 = _slicedToArray(_useState3, 2),
		    imageLoaded = _useState4[0],
		    setImageLoaded = _useState4[1];
	
		var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
		    product = _useContext.product,
		    values = _useContext.values,
		    setFieldValue = _useContext.setFieldValue;
	
		var defaultProductImage = _AppUtil2.default.getDefaultProductImage(product);
	
		var handleSelectProduct = (0, _react.useCallback)(function (imgSrc) {
			setFieldValue('selectedImage', imgSrc);
	
			if (imgSrc === product.previewImage) {
				setFieldValue('productImage', defaultProductImage);
			} else {
				setFieldValue('productImage', imgSrc);
			}
		}, []);
	
		var getProductPreviews = (0, _react.useCallback)(function (selectedImage) {
			var previews = [];
	
			var productType = PRODUCT_TYPES[product.productType].label;
	
			var images = product.productImages;
	
			//Note: preview image may not be available and only product image can be available.
			if (product.previewImage) images = images.concat(product.previewImage);
	
			var _loop = function _loop() {
				var imgSrc = images[i];
	
				var imgStyle = [styles.smallThumbnailImg];
	
				if (selectedImage && selectedImage === imgSrc) imgStyle.push(styles.selectedThumbnail);
	
				var imgTitle = product.title;
	
				if (i === 1) imgTitle += " " + productType + " on SetoCanvas.com";else if (i > 1) imgTitle += " " + productType + " " + i + " on SetoCanvas.com";
	
				var preview = _react2.default.createElement(EachPreview, { onImgClick: function onImgClick() {
						return handleSelectProduct(imgSrc);
					},
					imgSrc: imgSrc,
					imgTitle: imgTitle,
					imgStyle: imgStyle, key: i + "-img-" + imgTitle });
				previews.push(preview);
			};
	
			for (var i = 0; i < images.length; i++) {
				_loop();
			}
	
			return previews;
		}, [product]);
	
		(0, _react.useEffect)(function () {
			return function () {
				return setImageLoaded(false);
			};
		}, [defaultProductImage]);
	
		var productPreviews = (0, _react.useMemo)(function () {
			return getProductPreviews(values.selectedImage);
		}, [values.selectedImage, product]);
	
		return _react2.default.createElement(
			_react2.default.Fragment,
			null,
			imageLoaded === false && _react2.default.createElement(_OrderFormLoader.ThumbnailLoader, null),
			_react2.default.createElement(Thumbnail, { style: imageLoaded === false ? { display: 'none' } : {}, image: values.selectedImage, title: product.title, onImageLoad: function onImageLoad() {
					return setImageLoaded(true);
				} }),
			_react2.default.createElement(
				'div',
				null,
				productPreviews.length > 0 && _react2.default.createElement(
					'div',
					{ className: 'flexRow' },
					productPreviews
				),
				_react2.default.createElement(_ProductTags2.default, { productTags: product.productTags }),
				_react2.default.createElement(_FormElements.Input, { name: 'productImage', type: 'hidden', mui: 'off' })
			)
		);
	};
	
	exports.default = OrderProductImage;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PaymentAPI = __webpack_require__(563);
	
	var _PaymentAPI2 = _interopRequireDefault(_PaymentAPI);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VisaCheckoutForm = function VisaCheckoutForm(_ref) {
	    var amount = _ref.amount,
	        orderIds = _ref.orderIds;
	
	    var _useState = (0, _react.useState)({}),
	        _useState2 = _slicedToArray(_useState, 2),
	        signRes = _useState2[0],
	        setSignRe = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(""),
	        _useState4 = _slicedToArray(_useState3, 2),
	        signature = _useState4[0],
	        setSignature = _useState4[1];
	
	    var visaForm = (0, _react.useRef)();
	
	    var onVisaFormSubmit = function onVisaFormSubmit(event) {
	        event.preventDefault();
	
	        //cal api to sign the pay request and 
	        _PaymentAPI2.default.signPaymentReq(orderIds, amount, function (success, res) {
	
	            if (success === true) {
	                setSignRe(res.signReq);
	                setSignature(res.signature);
	
	                visaForm.current.submit();
	            }
	        });
	    };
	
	    return _react2.default.createElement(
	        'form',
	        { id: 'cardPaymentConfirmation', action: _AppConstants2.default.CYBERSOURCE_FORM_URL,
	            method: 'post', onSubmit: onVisaFormSubmit, ref: visaForm },
	        _react2.default.createElement('input', { type: 'hidden', id: 'profile_id', name: 'profile_id', value: signRes.profileId || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'transaction_uuid', name: 'transaction_uuid', value: signRes.transactionUUID || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'signed_field_names', name: 'signed_field_names', value: signRes.signedFieldNames || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'unsigned_field_names', name: 'unsigned_field_names', value: signRes.unsignedFieldNames || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'signed_date_time', name: 'signed_date_time', value: signRes.signedDateTime || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'locale', name: 'locale', value: signRes.locale || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'amount', name: 'amount', value: signRes.amount || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'transaction_type', name: 'transaction_type', value: signRes.transactionType || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'reference_number', name: 'reference_number', value: signRes.referenceNumber || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'currency', name: 'currency', value: signRes.currency || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'access_key', name: 'access_key', value: signRes.accessKey || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'payment_method', name: 'payment_method', value: signRes.paymentMethod || '' }),
	        _react2.default.createElement('input', { type: 'hidden', id: 'signature', name: 'signature', value: signature || '' }),
	        _react2.default.createElement(
	            _AppElements.Button,
	            { mui: 'true', variant: 'primary', type: 'submit', disabled: !amount || !orderIds },
	            'Continue'
	        )
	    );
	};
	
	exports.default = VisaCheckoutForm;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppElements = __webpack_require__(9);
	
	var _UserAvatar = __webpack_require__(48);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _ImgUploadForm = __webpack_require__(93);
	
	var _ImgUploadForm2 = _interopRequireDefault(_ImgUploadForm);
	
	var _OrderForm = __webpack_require__(36);
	
	var _PhotoFrameImg = __webpack_require__(141);
	
	var _PhotoFrameImg2 = _interopRequireDefault(_PhotoFrameImg);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FrameImageUploader = function FrameImageUploader(_ref) {
	    var isCustomProduct = _ref.isCustomProduct,
	        imgSrc = _ref.imgSrc;
	
	    var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
	        product = _useContext.product,
	        values = _useContext.values,
	        setFieldValue = _useContext.setFieldValue;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        loadedImg = _useState2[0],
	        setLoadedImg = _useState2[1]; //the actual image object
	
	    var creatorURL = _AppUtil2.default.getDesignerURL(product.creator);
	    var createrName = product.creator ? _AppUtil2.default.getCreaterName(product.creator) : null;
	    (0, _react.useEffect)(function () {
	        if (loadedImg && isCustomProduct) {
	            var imgWidthPixel = loadedImg ? loadedImg.naturalWidth || loadedImg.width : 0,
	                imgHeightPixel = loadedImg ? loadedImg.naturalHeight || loadedImg.height : 0;
	
	            setFieldValue('imgWidth', imgWidthPixel);
	            setFieldValue('imgHeight', imgHeightPixel);
	        }
	    }, [loadedImg]);
	
	    var resetImg = (0, _react.useCallback)(function () {
	        setFieldValue('customerUploadedImage', null);
	        setLoadedImg(null);
	        setFieldValue("productSizeMetaData", '');
	        setFieldValue("productSize", '');
	        setFieldValue('imgWidth', '');
	        setFieldValue('imgHeight', '');
	
	        setFieldValue('isCustomSize', '');
	        setFieldValue('customWidth', '');
	        setFieldValue('customHeight', '');
	    });
	
	    var borderClassName = values.borderColor || "blackBorder";
	    return _react2.default.createElement(
	        'div',
	        { className: 'flexColumn', id: 'photoUploadSection' },
	        isCustomProduct && _react2.default.createElement(
	            'h2',
	            { style: { textAlign: 'center', margin: '0 0 20px 0', color: '#1c1c1e', fontSize: '2.5rem', fontWeight: '600' } },
	            '[ ',
	            _react2.default.createElement(
	                'span',
	                { style: { fontSize: '90%', textDecoration: 'underline' } },
	                'Frame Your Photo'
	            ),
	            ' ]'
	        ),
	        !isCustomProduct && _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' }, className: 'flexColumn' },
	            _react2.default.createElement(
	                'h1',
	                { className: 'flexColumn productTitle' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    product.title
	                )
	            ),
	            product.creator && _react2.default.createElement(
	                'div',
	                { className: 'flexRow', style: { alignItems: "center", justifyContent: "center" } },
	                _react2.default.createElement(
	                    _AppElements.A,
	                    { href: creatorURL },
	                    _react2.default.createElement(_UserAvatar2.default, { user: product.creator })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { style: { color: '#5b5b5b', fontSize: '90%' } },
	                    'from ',
	                    _react2.default.createElement(
	                        _AppElements.A,
	                        { href: creatorURL, style: { color: '#f8931b', textTransform: 'capitalize', fontWeight: 'bold' } },
	                        createrName
	                    )
	                )
	            ),
	            _react2.default.createElement(_AppElements.Separator, null)
	        ),
	        values.customerUploadedImage === null && isCustomProduct && _react2.default.createElement(
	            'div',
	            { id: 'photoFrameImgUploader', className: borderClassName },
	            _react2.default.createElement(
	                'span',
	                { id: 'uploadText' },
	                'Upload Your Image'
	            ),
	            _react2.default.createElement(_ImgUploadForm2.default, { previewId: 'customerImageFile', className: 'cutomOrderImageForm',
	                imgWidth: '100px', imgHeight: '100px',
	                onImgChange: function onImgChange(uploadedImgFile) {
	                    setFieldValue('customerUploadedImage', uploadedImgFile);
	                },
	
	                onImgReset: resetImg
	            })
	        ),
	        (values.customerUploadedImage !== null || isCustomProduct !== true && imgSrc !== null) && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(_PhotoFrameImg2.default, { id: 'customFrameImgPreview',
	                imgUrl: imgSrc,
	                imgFile: values.customerUploadedImage,
	                matting: values.matting,
	                borderColor: values.borderColor,
	                onImgLoad: function onImgLoad(img) {
	                    setLoadedImg(img);
	                } }),
	            isCustomProduct && _react2.default.createElement(
	                _AppElements.Button,
	                { mui: 'true', variant: 'danger', id: 'removePhotoImg', onClick: resetImg },
	                'Remove Image'
	            )
	        ),
	        !isCustomProduct && product.description && _react2.default.createElement(
	            'span',
	            { style: { display: 'block', color: 'gray', textAlign: 'center', margin: '5px 0 10px 0', fontSize: '100%', whiteSpace: 'pre-line' } },
	            '- ',
	            product.description
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'customFrameInfo', style: { margin: '10px auto' } },
	            _react2.default.createElement(
	                'ul',
	                { style: { marginTop: '5px' } },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Photo Frame border is 1" in Width.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Made up of Light Fiber Frame.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Fiber glass used for maximum durability and quality.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(_AppElements.Img, { src: '/images/nepal flag.png', title: 'Nepal Flag', alt: 'Nepal Flag', style: { height: "12px", marginLeft: "3px" } }),
	                    ' Made in Nepal'
	                )
	            )
	        )
	    );
	};
	
	exports.default = FrameImageUploader;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrderForm = __webpack_require__(36);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppElements = __webpack_require__(9);
	
	var _FormElements = __webpack_require__(13);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	
	//include quanity per size
	var BulkOrderInput = function BulkOrderInput(_ref) {
	    var sizeOptions = _ref.sizeOptions,
	        openModal = _ref.openModal,
	        setOpenModal = _ref.setOpenModal;
	
	    var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
	        setBulkOrderFormType = _useContext.setBulkOrderFormType,
	        setFieldValue = _useContext.setFieldValue,
	        values = _useContext.values;
	
	    var _useState = (0, _react.useState)(values.sizeQuantity),
	        _useState2 = _slicedToArray(_useState, 2),
	        sizeQuantity = _useState2[0],
	        setSizeQuantity = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(''),
	        _useState4 = _slicedToArray(_useState3, 2),
	        errorMessage = _useState4[0],
	        setErrorMessage = _useState4[1];
	
	    var onClose = function onClose() {
	        setOpenModal(false);
	    };
	
	    var applyBulkOrder = function applyBulkOrder() {
	        var totalSum = Object.values(sizeQuantity).reduce(function (a, b) {
	            return parseInt(a) + parseInt(b);
	        }, 0);
	
	        if (totalSum < _AppConstants2.default.BULK_MINMUM_QUANTITY) {
	            setErrorMessage("Please provide at least " + _AppConstants2.default.BULK_MINMUM_QUANTITY + " quantities.");
	        } else {
	            setBulkOrderFormType(true);
	            setOpenModal(false);
	            setFieldValue('sizeQuantity', sizeQuantity);
	        }
	    };
	
	    var cancelBulkOrder = function cancelBulkOrder() {
	        setBulkOrderFormType(false);
	        setOpenModal(false);
	    };
	
	    var quantities = sizeOptions.map(function (s) {
	        return _react2.default.createElement(
	            'div',
	            { className: 'mui-textfield', key: "bulk_order_" + s.value },
	            _react2.default.createElement(
	                'label',
	                null,
	                s.label
	            ),
	            _react2.default.createElement('input', { type: 'number', value: sizeQuantity[s.value] || '', onChange: function onChange(e) {
	                    sizeQuantity[s.value] = e.target.value;
	                    setSizeQuantity(Object.assign({}, sizeQuantity));
	                    setErrorMessage('');
	                } })
	        );
	    });
	
	    return _react2.default.createElement(
	        _reactResponsiveModal2.default,
	        { closeOnOverlayClick: false, open: openModal,
	            onClose: onClose,
	            classNames: { modal: 'bulk-order-modal', closeIcon: 'bulk-order-close-icon' } },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h2',
	                { style: { margin: '0 0 20px 0' } },
	                'Bulk Order Quantities'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'highlightInfo' },
	                _react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
	                ' Receive ',
	                _AppConstants2.default.BULK_ORDER_DISCOUNT_PCT * 100.0,
	                '% discount with minimum of ',
	                _AppConstants2.default.BULK_MINMUM_QUANTITY,
	                ' orders.'
	            ),
	            quantities,
	            errorMessage && _react2.default.createElement(
	                'div',
	                { className: 'errorMessage' },
	                errorMessage
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'flexRow', style: { justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                    _AppElements.Button,
	                    { mui: 'true', color: 'primary', onClick: applyBulkOrder },
	                    'Submit'
	                ),
	                values.isBulkOrderForm === true && _react2.default.createElement(
	                    _AppElements.Button,
	                    { mui: 'true', color: 'danger', onClick: cancelBulkOrder },
	                    'Cancel Bulk Order'
	                )
	            )
	        )
	    );
	};
	
	var OrderSizeInput = function OrderSizeInput() {
	    var _useContext2 = (0, _react.useContext)(_OrderForm.OrderContext),
	        product = _useContext2.product,
	        values = _useContext2.values,
	        productSizes = _useContext2.productSizes,
	        setBulkOrderFormType = _useContext2.setBulkOrderFormType;
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        openBulkOrderModal = _useState6[0],
	        setOpenBulkOrderModal = _useState6[1];
	
	    var isBulkOrderForm = values.isBulkOrderForm;
	    var isCoupleProduct = _AppUtil2.default.isCoupleProduct(product);
	    var isSizeProvided = values.productSize || values.maleSize && values.femaleSize;
	
	    var sizeOptions = _AppUtil2.default.getProductSizeOptions(product);
	
	    var isOutofStock = product.outofStock;
	
	    var hasPricePerSize = false;
	    Object.keys(productSizes).forEach(function (s) {
	        if (productSizes[s].priceAddition > 0) hasPricePerSize = true;
	    });
	
	    if (hasPricePerSize) {
	        sizeOptions.forEach(function (s) {
	            var pricePerSize = product.price + productSizes[s.value].priceAddition;
	            s.label = s.label + " - Rs. " + _AppUtil2.default.formatNumber(pricePerSize);
	        });
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        isCoupleProduct === true && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_FormElements.ComboBox, { label: 'Male Size: ', name: 'maleSize', value: values.maleSize,
	                options: sizeOptions, placeholder: 'Select Male Size' }),
	            _react2.default.createElement(_FormElements.ComboBox, { label: 'Female Size: ', name: 'femaleSize', value: values.femaleSize,
	                options: sizeOptions, placeholder: 'Select Female Size' })
	        ),
	        isCoupleProduct === false && _react2.default.createElement(
	            'div',
	            null,
	            !isBulkOrderForm && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FormElements.ComboBox, { name: 'productSize', value: values.productSize,
	                    options: sizeOptions, placeholder: 'Select Size' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mui-btn mui-btn--primary mui-btn--flat mui-btn--small', style: { marginLeft: 'auto', display: 'block', width: 'fit-content' } },
	                    _react2.default.createElement(
	                        'span',
	                        { onClick: function onClick() {
	                                setOpenBulkOrderModal(true);
	                            } },
	                        _react2.default.createElement('i', { className: 'fa fa-opencart' }),
	                        ' Buy in Bulk'
	                    )
	                )
	            ),
	            _react2.default.createElement(BulkOrderInput, { sizeOptions: sizeOptions,
	                openModal: openBulkOrderModal,
	                setOpenModal: setOpenBulkOrderModal }),
	            isBulkOrderForm && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mui-textfield', style: { marginBottom: '5px' } },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        'Bulk Quantities:'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexRow' },
	                    sizeOptions.map(function (s) {
	                        var label = s.label;
	                        var quantity = values.sizeQuantity[s.value];
	                        if (!quantity) return null;
	
	                        return _react2.default.createElement(
	                            _AppElements.Button,
	                            { mui: 'true', size: 'small', variant: 'flat', key: "bulkOrder-" + s.value },
	                            label,
	                            ' : ',
	                            quantity
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexColumn' },
	                    _react2.default.createElement(
	                        _AppElements.Button,
	                        { mui: 'true', size: 'small', color: 'primary', onClick: function onClick() {
	                                return setOpenBulkOrderModal(true);
	                            } },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil', 'aria-hidden': 'true' }),
	                        ' Edit Bulk Quantities'
	                    )
	                )
	            ),
	            product.productType === PRODUCT_TYPES.PHOTO_FRAME.val && !isSizeProvided && _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '10px', color: 'gray' } },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
	                    ' To order frames with sizes not listed above, please '
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://m.me/setocanvascom' },
	                    'DM US'
	                )
	            )
	        ),
	        isOutofStock === true && _react2.default.createElement(
	            'span',
	            { style: { color: 'red', fontWeight: 'bold', fontSize: '1.1em' } },
	            _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle', 'aria-hidden': 'true' }),
	            ' Out of Stock'
	        )
	    );
	};
	
	exports.default = OrderSizeInput;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormElements = __webpack_require__(13);
	
	var _OrderForm = __webpack_require__(36);
	
	var _ProductUtil = __webpack_require__(74);
	
	var _ProductUtil2 = _interopRequireDefault(_ProductUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoFrameSizeInput = function PhotoFrameSizeInput(_ref) {
	    var imgWidth = _ref.imgWidth,
	        imgHeight = _ref.imgHeight;
	
	    var aspectRatio = (0, _react.useMemo)(function () {
	        return imgHeight / imgWidth;
	    }, [imgWidth, imgHeight]);
	
	    var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
	        values = _useContext.values,
	        setFieldValue = _useContext.setFieldValue;
	
	    var imageUploaded = values.customerUploadedImage !== null && imgWidth && imgHeight;
	    var sizeData = values.productSizeMetaData;
	    var sizeKeys = Object.keys(sizeData);
	    var selectedSize = values.productSize;
	    var selectedSizeData = selectedSize ? sizeData[selectedSize] : null;
	    var customWidth = values.customWidth;
	    var isCustomSizeChecked = values.isCustomSize;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        customSizError = _useState2[0],
	        setCustomSizeError = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        if (imgWidth && imgHeight) {
	            var possibleSizes = _ProductUtil2.default.computeFrameAvailableSizes(imgWidth, imgHeight);
	            setFieldValue("productSizeMetaData", possibleSizes);
	        }
	    }, [imgWidth, imgHeight]);
	
	    (0, _react.useEffect)(function () {
	        if (isCustomSizeChecked && customWidth) {
	            var customH = customWidth * aspectRatio;
	            var dpi = imgWidth / customWidth;
	
	            if (dpi < 100) {
	                setCustomSizeError('Size too big. Can yield poor print quality.');
	                setFieldValue('customHeight', customH.toFixed(2));
	                setFieldValue('productSize', '');
	            } else {
	                sizeData['NA'] = _ProductUtil2.default.createFrameSizeObject(customWidth, customH, dpi.toFixed(2));
	                setFieldValue('customHeight', customH.toFixed(2));
	                setFieldValue("productSizeMetaData", sizeData);
	                setFieldValue('productSize', 'NA');
	                setCustomSizeError(null);
	            }
	        } else if (isCustomSizeChecked && !customWidth) {
	            setFieldValue('customHeight', '');
	            setFieldValue('productSize', '');
	        }
	    }, [customWidth, isCustomSizeChecked]);
	
	    var sizeBoxes = sizeKeys.filter(function (k) {
	        return k !== 'NA';
	    }).map(function (k) {
	        var isSelected = selectedSize && selectedSize === k;
	        return _react2.default.createElement(
	            'div',
	            { key: "customSize_" + k, className: (isSelected ? "selectedFrameSize" : "") + " eachFrameSize",
	                onClick: function onClick() {
	                    setFieldValue('isCustomSize', '');
	                    setFieldValue('productSize', k);
	                } },
	            sizeData[k].label
	        );
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'frameSizeOptions' },
	        _react2.default.createElement(
	            'h3',
	            { style: { margin: '5px 0' } },
	            'Photo Size ',
	            selectedSizeData ? _react2.default.createElement(
	                'span',
	                { className: 'dpiInfo' },
	                '- ',
	                selectedSizeData.dpi,
	                ' DPI'
	            ) : null
	        ),
	        sizeBoxes.length === 0 && _react2.default.createElement(
	            'div',
	            { className: 'flexColumn' },
	            _react2.default.createElement(
	                'div',
	                { className: "eachFrameSize", style: { maxWidth: '90px', textAlign: 'center', color: "gray" } },
	                'NA'
	            ),
	            imageUploaded && _react2.default.createElement(
	                'span',
	                { style: { color: "red" } },
	                _react2.default.createElement('i', { className: 'fa fa-exclamation', 'aria-hidden': 'true' }),
	                ' Photo is too small. No printing size available.'
	            ),
	            !imageUploaded && _react2.default.createElement(
	                'span',
	                { style: { color: "gray" } },
	                _react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
	                ' Upload a photo to view it\'s available printable sizes.'
	            )
	        ),
	        sizeBoxes.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'flexColumn' },
	            _react2.default.createElement(
	                'div',
	                { className: 'flexRow' },
	                sizeBoxes
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { fontSize: "120%", color: 'gray', margin: '10px 0' } },
	                _react2.default.createElement(_FormElements.Checkbox, { name: 'isCustomSize', label: 'Enter a Custom Size', onChange: function onChange(event) {
	                        setFieldValue('productSize', '');
	                    } })
	            ),
	            isCustomSizeChecked && _react2.default.createElement(
	                'div',
	                { className: 'flexColumn' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flexRow', id: 'customSizeInput' },
	                    _react2.default.createElement(_FormElements.Input, { label: 'Enter Width in (Inches)', name: 'customWidth', type: 'number', placeholder: 'E.g: 8.27' }),
	                    _react2.default.createElement(_FormElements.Input, { label: 'Height (Inches)', disabled: true, name: 'customHeight', placeholder: 'E.g: 11.7' })
	                ),
	                customSizError && _react2.default.createElement(
	                    'span',
	                    { style: { fontSize: '12px', color: 'red' } },
	                    customSizError
	                )
	            )
	        )
	    );
	};
	
	exports.default = PhotoFrameSizeInput;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrderForm = __webpack_require__(36);
	
	var _FormElements = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuantityInput = function QuantityInput() {
	    var _useContext = (0, _react.useContext)(_OrderForm.OrderContext),
	        values = _useContext.values;
	
	    var isBulkOrderForm = values.isBulkOrderForm;
	
	    if (isBulkOrderForm) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_FormElements.Input, { label: 'Quantity: ', name: 'quantity', type: 'number' })
	    );
	};
	
	exports.default = QuantityInput;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _Loader = __webpack_require__(63);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _PriceLabel = __webpack_require__(142);
	
	var _PriceLabel2 = _interopRequireDefault(_PriceLabel);
	
	var _UserAvatar = __webpack_require__(48);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _ProductTags = __webpack_require__(233);
	
	var _ProductTags2 = _interopRequireDefault(_ProductTags);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ARTWORK_TYPES = _AppConstants2.default.ARTWORK_TYPES;
	var PRODUCT_TYPES = _AppConstants2.default.PRODUCT_TYPES;
	
	var styles = {
		containerStyle: { flexWrap: 'nowrap' },
		imgContainer: { position: 'relative', boxSizing: 'border-box', '@media (max-width: 600px)': { width: '-webkit-fill-available' } },
		previewImgContainer: { position: 'relative', boxSizing: 'border-box', flexWrap: 'nowrap' },
	
		productInfoContainer: { position: 'absolute', bottom: '0', background: 'white',
			width: 'inherit', borderTop: '1px solid #eee',
			fontSize: '100%',
			'@media (max-width: 884px)': { fontSize: '95%' },
			'@media (max-width: 600px)': { fontSize: '110%', minWidth: '285px' }
		},
	
		productTitle: { color: 'black', paddingLeft: '10px', paddingTop: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%' },
	
		creatorContainer: { margin: '5px 0', alignItems: 'center', paddingLeft: '10px', '@media (max-width: 884px)': { marginBottom: '5px' } },
	
		productTags: { '@media (min-width: 500px)': { display: 'none' }, margin: '-5px 5px 0px 5px' }
	};
	
	var ProductDesignLoader = (0, _radium2.default)(function (props) {
		var customStyles = [styles.containerStyle, { border: '1px solid rgb(238, 238, 238)',
			boxSizing: 'border-box', '@media (max-width: 600px)': { width: '100%' } }];
	
		if (props.style) customStyles.push(props.style);
	
		var viewMode = props.productViewMode || 'productOnly';
		var showPreview = viewMode === 'designOnly' || viewMode === 'both';
		var showProduct = viewMode === 'productOnly' || viewMode === 'both';
	
		var imageSizeClass = props.imageSizeClass;
	
		var previewImgContainer = [styles.previewImgContainer];
	
		if (viewMode === 'both') previewImgContainer.push({ '@media (max-width: 500px)': { display: 'none' } });
	
		return _react2.default.createElement(
			'div',
			{ className: 'productDesignThumbnail flexRow', style: customStyles },
			showPreview && _react2.default.createElement(
				'div',
				{ className: imageSizeClass, style: previewImgContainer },
				_react2.default.createElement(_AppElements.Img, null)
			),
			showProduct && _react2.default.createElement(
				'div',
				{ className: 'flexColumn ' + imageSizeClass, style: [styles.imgContainer] },
				_react2.default.createElement(_AppElements.Img, null),
				_react2.default.createElement(
					'div',
					{ className: 'flexColumn productInfo', style: [styles.productInfoContainer, { height: '20%' }] },
					_react2.default.createElement(_Loader2.default, { style: { width: '30%', height: '30%', marginTop: '5px', paddingLeft: '10px' } }),
					_react2.default.createElement(
						'div',
						{ className: 'flexRow', style: { marginBottom: '5px',
								height: '30%', marginTop: 'auto',
								'@media (max-width: 884px)': { marginBottom: '5px' } } },
						_react2.default.createElement(_Loader2.default, { style: { width: '50%', paddingLeft: '10px' } }),
						_react2.default.createElement(_Loader2.default, { style: { width: '30%', paddingRight: '10px', marginLeft: 'auto' } })
					)
				)
			)
		);
	});
	
	var ProductDesignThumbnail = function (_React$Component) {
		_inherits(ProductDesignThumbnail, _React$Component);
	
		function ProductDesignThumbnail(props) {
			_classCallCheck(this, ProductDesignThumbnail);
	
			var _this = _possibleConstructorReturn(this, (ProductDesignThumbnail.__proto__ || Object.getPrototypeOf(ProductDesignThumbnail)).call(this, props));
	
			_this.state = { imageLoaded: false };
			return _this;
		}
	
		_createClass(ProductDesignThumbnail, [{
			key: 'onImageLoad',
			value: function onImageLoad() {
				this.setState({ imageLoaded: true });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var imageSizeClass = this.props.imageSizeClass || 'largeImg';
				var product = this.props.product;
	
				if (product === null) return _react2.default.createElement(ProductDesignLoader, Object.assign({}, this.props, { imageSizeClass: imageSizeClass }));
	
				var detailUrl = product ? _AppUtil2.default.getProductURL(product) : null;
	
				var designerUrl = product && product.creator ? _AppUtil2.default.getDesignerURL(product.creator) : "#";
				var createrName = product && product.creator ? _AppUtil2.default.getCreaterName(product.creator) : null;
				var profilePic = _react2.default.createElement(
					_AppElements.A,
					{ href: designerUrl },
					_react2.default.createElement(_UserAvatar2.default, { user: product && product.creator ? product.creator : null })
				);
				var productType = product ? PRODUCT_TYPES[product.productType].label : null;
	
				var productState = product.productState;
	
				var mainContainerClass = 'productDesignThumbnail flexRow ' + productState.toLowerCase();
				if (product.artworkType === ARTWORK_TYPES['PHOTOGRAPH'].val) mainContainerClass += " photographDesignThumbnail";
	
				var containerStyles = [styles.containerStyle];
	
				if (this.props.style) containerStyles.push(this.props.style);
	
				var mainWrapperStyle = this.state.imageLoaded === false ? { '@media (max-width: 600px)': { width: '100%', height: '100%' } } : { marginRight: '15px' };
	
				var viewMode = this.props.productViewMode || 'productOnly';
	
				var showPreview = viewMode === 'designOnly' || viewMode === 'both';
	
				var previewImage = "";
				if (showPreview) {
					styles.imgContainer.borderLeft = '1px solid #e1e1e1';
					styles.imgContainer.borderRight = '1px solid #e1e1e1';
	
					if (product.previewImage) {
						previewImage = _react2.default.createElement(_AppElements.Img, { src: product.previewImage, alt: product.title + " " + productType, className: imageSizeClass });
					} else {
						if (viewMode === 'designOnly' || product.productImages.length > 1) previewImage = _react2.default.createElement(_AppElements.Img, { src: product.productImages[product.productImages.length - 1], alt: product.title + " " + productType, className: imageSizeClass });else {
							previewImage = _react2.default.createElement(
								'div',
								{ className: 'previewImageAvatar' },
								_react2.default.createElement(_UserAvatar2.default, { user: product.creator })
							);
						}
					};
				}
	
				var previewImgContainer = [styles.previewImgContainer];
	
				if (viewMode === 'both') previewImgContainer.push({ '@media (max-width: 500px)': { display: 'none' } });
	
				var showProduct = viewMode === 'productOnly' || viewMode === 'both';
				var productTags = this.props.viewProductTags && product.productTags ? _react2.default.createElement(_ProductTags2.default, { productTags: product.productTags }) : null;
	
				var urlQueryParams = this.props.hrefParams ? Object.keys(this.props.hrefParams).map(function (k) {
					return k + "=" + _this2.props.hrefParams[k];
				}).join("&") : null;
				var productUrl = detailUrl + (urlQueryParams ? "?" + urlQueryParams : "");
				return _react2.default.createElement(
					'div',
					{ style: mainWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: mainContainerClass, style: containerStyles },
						showPreview && _react2.default.createElement(
							'div',
							{ style: previewImgContainer, className: 'flexColumn' },
							_react2.default.createElement(
								'div',
								{ className: imageSizeClass },
								_react2.default.createElement(
									_AppElements.A,
									{ href: detailUrl },
									previewImage
								)
							),
							viewMode === "designOnly" && product.creator && _react2.default.createElement(
								'div',
								{ className: 'flexColumn', style: { paddingBottom: '5px', background: 'white',
										borderTop: '1px solid #e1e1e1', boxSizing: 'border-box', flexWrap: 'nowrap' } },
								_react2.default.createElement(
									'div',
									{ style: { textOverflow: 'ellipsis', overflow: 'hidden',
											'@media (min-width: 500px)': { whiteSpace: 'nowrap', maxWidth: '280px' } } },
									_react2.default.createElement(
										_AppElements.A,
										{ href: detailUrl, style: styles.productTitle },
										product.title
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'flexRow', style: { paddingLeft: '10px', marginTop: '5px', alignItems: 'center' } },
									profilePic,
									_react2.default.createElement(
										_AppElements.A,
										{ href: designerUrl, style: { paddingLeft: '10px', textDecoration: 'none', color: '#999', fontSize: '90%',
												':hover': { color: 'black' } } },
										'Art by ',
										_react2.default.createElement(
											'span',
											{ style: { textTransform: 'capitalize' } },
											createrName
										)
									)
								)
							)
						),
						showProduct && _react2.default.createElement(
							'div',
							{ className: 'flexColumn ' + imageSizeClass, style: [styles.imgContainer] },
							_react2.default.createElement(
								_AppElements.A,
								{ href: productUrl, style: { display: 'inline-flex' } },
								_react2.default.createElement(_AppElements.Img, { src: product.productImages[0], alt: product.title + " " + productType, className: imageSizeClass })
							),
							_react2.default.createElement(
								'div',
								{ className: 'flexColumn productInfo', style: styles.productInfoContainer },
								_react2.default.createElement(
									_AppElements.A,
									{ href: productUrl, style: styles.productTitle },
									product.title
								),
								_react2.default.createElement(
									'div',
									{ className: 'flexRow', style: styles.creatorContainer },
									profilePic,
									product.creator && _react2.default.createElement(
										_AppElements.A,
										{ href: designerUrl, style: { paddingLeft: '10px', textDecoration: 'none', color: '#999',
												':hover': { color: 'black' } } },
										_react2.default.createElement(
											'span',
											null,
											'by ',
											_react2.default.createElement(
												'span',
												{ style: { textTransform: 'capitalize' } },
												createrName
											)
										)
									),
									_react2.default.createElement(_PriceLabel2.default, { style: { textAlign: 'right', paddingRight: '10px', marginLeft: 'auto' },
										price: product.price,
										aliasPrice: product.aliasPrice,
										productType: product.productType })
								)
							)
						)
					),
					productTags && _react2.default.createElement(
						'div',
						{ style: styles.productTags },
						productTags
					)
				);
			}
		}]);
	
		return ProductDesignThumbnail;
	}(_react2.default.Component);
	
	;
	
	exports.default = (0, _radium2.default)(ProductDesignThumbnail);

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppElements = __webpack_require__(9);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _CoupleProductOrderForm = __webpack_require__(581);
	
	var _CoupleProductOrderForm2 = _interopRequireDefault(_CoupleProductOrderForm);
	
	var _ProductOrderForm = __webpack_require__(96);
	
	var _ProductOrderForm2 = _interopRequireDefault(_ProductOrderForm);
	
	var _ProductStat = __webpack_require__(591);
	
	var _ProductStat2 = _interopRequireDefault(_ProductStat);
	
	var _PhotoFrameForm = __webpack_require__(227);
	
	var _PhotoFrameForm2 = _interopRequireDefault(_PhotoFrameForm);
	
	var _OrderListContainer = __webpack_require__(137);
	
	var _OrderListContainer2 = _interopRequireDefault(_OrderListContainer);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _MusicPlaqueForm = __webpack_require__(223);
	
	var _MusicPlaqueForm2 = _interopRequireDefault(_MusicPlaqueForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRODUCT_STATE = _AppConstants2.default.PRODUCT_STATE;
	
	var styles = {
		productStateMsgBox: { padding: '2px 10px', fontSize: '120%', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px' },
		pendingApprovalMsg: { background: '#f8931b', color: 'white' },
		notPublishedMsg: { background: 'gray', color: 'white' },
		archievedMsg: { background: '#de3a3a', color: 'white' },
	
		toolBarLink: { marginLeft: '5px', background: '#cc7a18', padding: '5px',
			borderRadius: '5px', color: 'white', cursor: 'pointer',
			'@media (max-width: 770px)': { flexGrow: '1' } },
		editLink: { background: 'darkcyan', color: 'white' }
	};
	
	var ProductStateMsg = (0, _radium2.default)(function (props) {
		var productState = props.productState;
		if (!productState) return null;
	
		var isAuthorized = props.isAuthorized;
		var style = [styles.productStateMsgBox];
		var message = null;
		var artworkType = props.artworkType;
	
		if (productState === PRODUCT_STATE.PENDING_APPROVAL && isAuthorized) {
			style.push(styles.pendingApprovalMsg);
			message = _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' }),
				' This design is pending approval. ',
				_react2.default.createElement(
					_AppElements.A,
					{ href: artworkType === _AppConstants2.default.ARTWORK_TYPES.PHOTOGRAPH.val ? "/faq#photographPendingApproval" : "/faq#designPendingApproval", style: { color: "#3a3837" } },
					'Learn Why?'
				)
			);
		} else if (productState === PRODUCT_STATE.UNPUBLISHED) {
			style.push(styles.notPublishedMsg);
			message = _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement('i', { className: 'fa fa-window-close', 'aria-hidden': 'true' }),
				' This design is not published.'
			);
		} else if (productState === PRODUCT_STATE.ARCHIVED) {
			style.push(styles.archievedMsg);
			message = _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement('i', { className: 'fa fa-window-close', 'aria-hidden': 'true' }),
				' The design has been archived. It cannot take any order. Please contact us for more info.'
			);
		} else {
			return null;
		}
		return _react2.default.createElement(
			'div',
			{ style: style },
			message
		);
	});
	
	var ToolBar = function (_React$Component) {
		_inherits(ToolBar, _React$Component);
	
		function ToolBar(props) {
			_classCallCheck(this, ToolBar);
	
			var _this = _possibleConstructorReturn(this, (ToolBar.__proto__ || Object.getPrototypeOf(ToolBar)).call(this, props));
	
			_this.publishProduct = _this.publishProduct.bind(_this);
			_this.unPublishProduct = _this.unPublishProduct.bind(_this);
			_this.publishUnpublishProduct = _this.publishUnpublishProduct.bind(_this);
			_this.deleteProduct = _this.deleteProduct.bind(_this);
			_this.state = { updatingState: false };
			return _this;
		}
	
		_createClass(ToolBar, [{
			key: 'publishProduct',
			value: function publishProduct() {
				var confirmRes = confirm("Are you sure you want publish the product?");
	
				if (confirmRes) this.publishUnpublishProduct(true);
			}
		}, {
			key: 'unPublishProduct',
			value: function unPublishProduct() {
				var confirmRes = confirm("Are you sure you want unpublish the product?");
	
				if (confirmRes) this.publishUnpublishProduct(false);
			}
		}, {
			key: 'publishUnpublishProduct',
			value: function publishUnpublishProduct(publish) {
				this.setState({ updatingState: true });
				_HttpService2.default.publishUnpublishProduct(this.props.product.id, publish, function () {
					this.setState({ updatingState: false });
				}.bind(this));
			}
		}, {
			key: 'deleteProduct',
			value: function deleteProduct() {
				var confirmRes = confirm("Are you sure you want delete the product?");
	
				if (confirmRes) {
					var productId = this.props.product.id;
					_HttpService2.default.deleteProduct(productId);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var product = this.props.product;
	
				var productState = product.productState;
	
				var productEditURL = _AppUtil2.default.getProductEditURL(product);
				var addSubproductURL = _AppUtil2.default.getAddSubProductURL(product);
	
				var isAdmin = this.props.currentUser.userType === _AppConstants2.default.USER_TYPE.ADMIN;
				return _react2.default.createElement(
					'div',
					{ style: { margin: '5px 0', textAlign: 'center', flexWrap: 'nowrap', justifyContent: 'flex-end' }, className: 'flexRow' },
					isAdmin && _react2.default.createElement(
						'div',
						{ style: { padding: '5px', marginRight: 'auto' } },
						_react2.default.createElement(
							'span',
							{ style: { cursor: 'pointer', color: '#bb2626' }, onClick: this.deleteProduct },
							_react2.default.createElement('i', { className: 'fa fa-trash', 'aria-hidden': 'true' })
						),
						_react2.default.createElement(
							_AppElements.A,
							{ href: addSubproductURL, style: [styles.toolBarLink, styles.editLink] },
							_react2.default.createElement('i', { className: 'fa fa-plus-circle', 'aria-hidden': 'true' }),
							' Add Sub Product'
						)
					),
					productState === PRODUCT_STATE.UNPUBLISHED && _react2.default.createElement(
						_AppElements.Button,
						{ style: [styles.toolBarLink, { background: 'green' }], onClick: this.publishProduct, disabled: this.state.updatingState },
						this.state.updatingState === true && _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' }),
							' Publishing'
						),
						this.state.updatingState === false && _react2.default.createElement(
							'span',
							null,
							'Publish'
						)
					),
					productState === PRODUCT_STATE.APPROVED && _react2.default.createElement(
						_AppElements.Button,
						{ style: [styles.toolBarLink, { background: '#eee', color: '#9c0f0f' }], onClick: this.unPublishProduct, disabled: this.state.updatingState },
						this.state.updatingState === true && _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' }),
							' Unpublishing'
						),
						this.state.updatingState === false && _react2.default.createElement(
							'span',
							null,
							'Unpublish'
						)
					),
					_react2.default.createElement(
						_AppElements.A,
						{ href: productEditURL, style: [styles.toolBarLink, styles.editLink],
							disabled: productState === PRODUCT_STATE.ARCHIVED && !isAdmin ? true : false },
						_react2.default.createElement('i', { className: 'fa fa-pencil-square-o', 'aria-hidden': 'true' }),
						' Edit'
					),
					_react2.default.createElement(
						'span',
						{ href: '#', onClick: this.props.onViewOrders, style: styles.toolBarLink },
						_react2.default.createElement('i', { className: 'fa fa-shopping-cart', 'aria-hidden': 'true' }),
						' ',
						product.title,
						' Orders'
					)
				);
			}
		}]);
	
		return ToolBar;
	}(_react2.default.Component);
	
	ToolBar = (0, _radium2.default)(ToolBar);
	
	var ProductDetail = function (_React$Component2) {
		_inherits(ProductDetail, _React$Component2);
	
		function ProductDetail(props) {
			_classCallCheck(this, ProductDetail);
	
			var _this2 = _possibleConstructorReturn(this, (ProductDetail.__proto__ || Object.getPrototypeOf(ProductDetail)).call(this, props));
	
			_this2.state = { viewOrders: false, viewSalesTargets: false };
	
			_this2.viewOrders = _this2.viewOrders.bind(_this2);
	
			_this2.getOrderFormToDisplay = _this2.getOrderFormToDisplay.bind(_this2);
			return _this2;
		}
	
		_createClass(ProductDetail, [{
			key: 'viewOrders',
			value: function viewOrders() {
				this.setState({ viewOrders: true });
			}
		}, {
			key: 'onCloseOrdersModal',
			value: function onCloseOrdersModal() {
				this.setState({ viewOrders: false });
			}
		}, {
			key: 'getOrderFormToDisplay',
			value: function getOrderFormToDisplay(product) {
				var isCustomProduct = _AppUtil2.default.isCustomProduct(product);
	
				if (isCustomProduct && product.productType === _AppConstants2.default.PRODUCT_TYPES['MUSIC_PLAQUE'].val) return _react2.default.createElement(_MusicPlaqueForm2.default, { product: product, selectedImage: this.props.selectedImage });
	
				if (product && product.productType === _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val) {
					if (product.imgWidthPx && product.imgHeightPx) return _react2.default.createElement(_PhotoFrameForm2.default, { product: product });
				}
	
				var isCoupleProduct = _AppUtil2.default.isCoupleProduct(product);
				if (isCoupleProduct) return _react2.default.createElement(_CoupleProductOrderForm2.default, { product: product, selectedImage: this.props.selectedImage });
	
				return _react2.default.createElement(_ProductOrderForm2.default, { product: product, selectedImage: this.props.selectedImage });
			}
		}, {
			key: 'render',
			value: function render() {
				var product = this.props.product;
	
				var currentSession = _SessionStore2.default.getCurrentSession();
				var currentUser = currentSession ? currentSession.user : null;
	
				var isAuthorized = product !== null ? _AppUtil2.default.isAuthorizedForProduct(currentUser, product) : false;
	
				var orderForm = this.getOrderFormToDisplay(product);
	
				return _react2.default.createElement(
					'div',
					{ className: 'flexColumn' },
					_react2.default.createElement(ProductStateMsg, { productState: product ? product.productState : null, artworkType: product ? product.artworkType : null, isAuthorized: isAuthorized }),
					isAuthorized && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(ToolBar, { currentUser: currentUser, product: product, onViewOrders: this.viewOrders, onViewSalesTargets: this.viewSalesTargets }),
						_react2.default.createElement(_ProductStat2.default, { stat: this.props.productStat, product: product })
					),
					orderForm,
					this.state.viewOrders && _react2.default.createElement(
						_reactResponsiveModal2.default,
						{ closeOnOverlayClick: false, open: this.state.viewOrders, onClose: this.onCloseOrdersModal.bind(this),
							classNames: { modal: 'order-modal' } },
						_react2.default.createElement(_OrderListContainer2.default, { product: product, showPaymentOption: false, showProductInfo: false })
					)
				);
			}
		}]);
	
		return ProductDetail;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(ProductDetail);

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	var _AppElements = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(20);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _SelectedImagePreview = __webpack_require__(64);
	
	var _SelectedImagePreview2 = _interopRequireDefault(_SelectedImagePreview);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _AppAction = __webpack_require__(22);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var USER_TYPE = _AppConstants2.default.USER_TYPE;
	
	var AddNewImageForm = function (_React$Component) {
		_inherits(AddNewImageForm, _React$Component);
	
		function AddNewImageForm(props) {
			_classCallCheck(this, AddNewImageForm);
	
			var _this = _possibleConstructorReturn(this, (AddNewImageForm.__proto__ || Object.getPrototypeOf(AddNewImageForm)).call(this, props));
	
			_this.onImageSelect = _this.onImageSelect.bind(_this);
			_this.onUpload = _this.onUpload.bind(_this);
			_this.state = { NEW_IMAGE: null, submitting: false };
			_this.INPUT_FIELD_ID = "addNewProductImage";
			return _this;
		}
	
		_createClass(AddNewImageForm, [{
			key: 'onImageSelect',
			value: function onImageSelect() {
				var imageFiles = document.getElementById(this.INPUT_FIELD_ID).files;
	
				if (imageFiles && imageFiles.length > 0) this.setState({ NEW_IMAGE: imageFiles[0] });else this.setState({ NEW_IMAGE: null });
			}
		}, {
			key: 'onUpload',
			value: function onUpload() {
				var confirmRes = confirm("Are you sure you want upload this image?");
	
				if (confirmRes === false) return;
	
				var productId = this.props.product.id;
	
				this.setState({ submitting: true });
				_HttpService2.default.addNewProductImage(productId, this.state.NEW_IMAGE, function (success) {
					if (success) {
						document.getElementById(this.INPUT_FIELD_ID).value = null;
						this.setState({ NEW_IMAGE: null, submitting: false });
					} else {
						this.setState({ submitting: false });
					}
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.props.product === null) return null;
	
				var uploadText = this.state.submitting ? "Uploading..." : "Upload";
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						'h1',
						null,
						'Add New Product Image'
					),
					_react2.default.createElement('input', { id: this.INPUT_FIELD_ID, type: 'file', accept: '.png, .jpg, .jpeg', onChange: this.onImageSelect }),
					_react2.default.createElement('br', null),
					_react2.default.createElement(_SelectedImagePreview2.default, { style: { marginRight: '10px' }, id: 'newImagePreview', file: this.state.NEW_IMAGE }),
					this.state.NEW_IMAGE && _react2.default.createElement(
						_AppElements.Button,
						{ style: { width: 'fit-content' }, onClick: this.onUpload, disabled: this.state.submitting },
						uploadText
					)
				);
			}
		}]);
	
		return AddNewImageForm;
	}(_react2.default.Component);
	
	var PreviewImageEditForm = function PreviewImageEditForm(props) {
		if (props.product === null) return null;
	
		var previewImage = props.product.previewImage;
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('hr', null),
			_react2.default.createElement(
				'h1',
				null,
				'Edit Preview Image'
			),
			_react2.default.createElement(ImageEditForm, { product: props.product,
				id: "updloadPreviewImageFile_" + props.product.id,
				productImage: previewImage, previewImage: true })
		);
	};
	
	var ProductImageEditForm = function ProductImageEditForm(props) {
		if (props.product === null) return null;
	
		var productImages = props.product.productImages;
		var editImages = productImages.map(function (url, i) {
			return _react2.default.createElement(ImageEditForm, { product: props.product, id: "updloadImageFile_" + i, productImage: url, key: "Product_Edit_" + i });
		});
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('hr', null),
			_react2.default.createElement(
				'h1',
				null,
				'Edit Your Images'
			),
			editImages
		);
	};
	
	var ImageEditForm = function (_React$Component2) {
		_inherits(ImageEditForm, _React$Component2);
	
		function ImageEditForm(props) {
			_classCallCheck(this, ImageEditForm);
	
			var _this2 = _possibleConstructorReturn(this, (ImageEditForm.__proto__ || Object.getPrototypeOf(ImageEditForm)).call(this, props));
	
			_this2.onImageSelect = _this2.onImageSelect.bind(_this2);
			_this2.onReplace = _this2.onReplace.bind(_this2);
			_this2.onRemove = _this2.onRemove.bind(_this2);
			_this2.state = { UPDATE_IMAGE: null, submitting: false };
			return _this2;
		}
	
		_createClass(ImageEditForm, [{
			key: 'onReplace',
			value: function onReplace() {
				var productId = this.props.product.id;
	
				this.setState({ submitting: true });
	
				if (this.props.previewImage) {
					_HttpService2.default.updatePreviewImage(productId, this.state.UPDATE_IMAGE, function (success) {
						if (success) {
							document.getElementById(this.props.id + "_input").value = null;
							this.setState({ UPDATE_IMAGE: null, submitting: false });
						} else {
							this.setState({ submitting: false });
						}
					}.bind(this));
				} else {
					_HttpService2.default.updateProductImage(productId, this.props.productImage, this.state.UPDATE_IMAGE, function (success) {
						if (success) {
							document.getElementById(this.props.id + "_input").value = null;
							this.setState({ UPDATE_IMAGE: null, submitting: false });
						} else {
							this.setState({ submitting: false });
						}
					}.bind(this));
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove() {
				var confirmRes = confirm("Are you sure you want delete this image?");
	
				if (confirmRes) {
					var productId = this.props.product.id;
	
					this.setState({ submitting: true });
					_HttpService2.default.deleteProductImage(productId, this.props.productImage, function (success) {
						this.setState({ submitting: false });
					}.bind(this));
				}
			}
		}, {
			key: 'onImageSelect',
			value: function onImageSelect() {
				var imageFiles = document.getElementById(this.props.id + "_input").files;
	
				if (imageFiles && imageFiles.length > 0) this.setState({ UPDATE_IMAGE: imageFiles[0] });else this.setState({ UPDATE_IMAGE: null });
			}
		}, {
			key: 'render',
			value: function render() {
				var submitBtnText = this.state.submitting ? "Replacing..." : "Replace";
				var deleteBtnText = this.state.submitting ? "Deleting..." : "X";
	
				return _react2.default.createElement(
					'div',
					{ className: 'flexRow', style: { margin: '20px 0', padding: '5px', width: 'fit-content', border: '1px dotted gray' } },
					_react2.default.createElement('img', { src: this.props.productImage, alt: this.props.product.title, className: 'miniImg' }),
					_react2.default.createElement(
						'div',
						{ className: 'flexColumn', style: { marginLeft: '10px' } },
						_react2.default.createElement('input', { id: this.props.id + "_input", type: 'file', accept: '.png, .jpg, .jpeg', onChange: this.onImageSelect }),
						_react2.default.createElement('br', null),
						_react2.default.createElement(_SelectedImagePreview2.default, { style: { marginRight: '10px' }, id: this.props.id, file: this.state.UPDATE_IMAGE }),
						_react2.default.createElement('br', null),
						this.state.UPDATE_IMAGE && _react2.default.createElement(
							_AppElements.Button,
							{ style: { width: 'fit-content' }, onClick: this.onReplace, disabled: this.state.submitting },
							submitBtnText
						)
					),
					this.state.UPDATE_IMAGE === null && !this.props.previewImage && _react2.default.createElement(
						_AppElements.Button,
						{ style: { height: 'fit-content', cursor: 'pointer' }, onClick: this.onRemove, disabled: this.state.submitting },
						deleteBtnText
					)
				);
			}
		}]);
	
		return ImageEditForm;
	}(_react2.default.Component);
	
	var ProductEditForm = function (_React$Component3) {
		_inherits(ProductEditForm, _React$Component3);
	
		function ProductEditForm(props) {
			_classCallCheck(this, ProductEditForm);
	
			var _this3 = _possibleConstructorReturn(this, (ProductEditForm.__proto__ || Object.getPrototypeOf(ProductEditForm)).call(this, props));
	
			_this3.validationScheme = _this3.validationScheme.bind(_this3);
			_this3.handleFormSubmission = _this3.handleFormSubmission.bind(_this3);
	
			_this3.PRODUCT_STATES = Object.keys(_AppConstants2.default.PRODUCT_STATE).map(function (k) {
				var optJson = { label: _AppConstants2.default.PRODUCT_STATE[k], value: k };
	
				return optJson;
			});
	
			_this3.DEFAULT_PRODUCT_TAGS = _AppConstants2.default.DEFAULT_PRODUCT_TAGS;
			return _this3;
		}
	
		_createClass(ProductEditForm, [{
			key: 'getInitialValues',
			value: function getInitialValues() {
				var product = this.props.product;
	
				return {
					title: product ? product.title : '',
					description: product && product.description ? product.description : '',
					productState: product ? product.productState : '',
					price: product ? product.price : '',
					aliasPrice: product ? product.aliasPrice : '',
					margin: product ? product.margin : '',
					priority: product && product.priority ? product.priority : '',
					productMetaData: product && product.productMetaData ? product.productMetaData : '',
					productTags: product && product.productTags ? product.productTags : [],
					outsideRingRoadCharge: product && product.outsideRingRoadCharge ? 'true' : 'false',
					outofStock: product && product.outofStock ? 'true' : 'false',
					imgWidthPx: product && product.imgWidthPx ? product.imgWidthPx : '',
					imgHeightPx: product && product.imgHeightPx ? product.imgHeightPx : ''
				};
			}
		}, {
			key: 'validationScheme',
			value: function validationScheme() {
				var validation = {
					title: _yup2.default.string().required("Enter a title that defines your image")
				};
	
				var currentUser = this.props.currentUser;
	
				if (currentUser.userType === USER_TYPE.ADMIN) {
					validation['productState'] = _yup2.default.string().required('Select a state');
					validation['price'] = _yup2.default.number().required('Enter a price').min(500, "Enter price above 500.0");
					validation['margin'] = _yup2.default.number().required('Enter a margin').min(100, "Enter margin above 100.0");
				}
	
				return _yup2.default.object().shape(validation);
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(value, _ref) {
				var setSubmitting = _ref.setSubmitting,
				    resetForm = _ref.resetForm;
	
				var productId = this.props.product.id;
				var isProductStateUpdated = value.productState !== this.props.product.productState;
	
				var isMarginUpdated = value.margin !== this.props.product.margin;
	
				_HttpService2.default.updateProductInfo(productId, value, function (success) {
					setSubmitting(false);
	
					if (success && isProductStateUpdated) {
	
						if (isProductStateUpdated) {
							_Dispatcher2.default.dispatch({
								type: _AppAction.ProductAction.UPDATE_PRODUCT_STATE
							});
						}
	
						if (isMarginUpdated) {
							_HttpService2.default.getProductStat(productId);
						}
					}
				});
			}
		}, {
			key: 'getProductTagOptions',
			value: function getProductTagOptions() {
				var product = this.props.product;
	
				if (product && product.productTags) {
					return this.DEFAULT_PRODUCT_TAGS.concat(product.productTags.filter(function (item) {
						return this.DEFAULT_PRODUCT_TAGS.indexOf(item) < 0;
					}.bind(this)));
				}
	
				return this.DEFAULT_PRODUCT_TAGS;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var currentUser = this.props.currentUser;
				var initialValues = this.getInitialValues();
	
				var productTagOptions = this.getProductTagOptions().map(function (v) {
					return { 'label': v.toUpperCase(), 'value': v.toLowerCase() };
				});
	
				var productType = this.props.product ? this.props.product.productType : '';
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'h1',
						null,
						'Edit Info'
					),
					_react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: initialValues, onSubmit: this.handleFormSubmission,
						validationSchema: this.validationScheme,
						render: function render(_ref2) {
							var values = _ref2.values,
							    setFieldValue = _ref2.setFieldValue,
							    isSubmitting = _ref2.isSubmitting;
	
	
							var submitBtn = 'Update';
	
							if (isSubmitting === true) submitBtn = _react2.default.createElement(
								'span',
								null,
								'Updating ',
								_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
							);
	
							return _react2.default.createElement(
								_FormElements.RGForm,
								null,
								_react2.default.createElement(_FormElements.Input, { label: 'Title: ', name: 'title', type: 'text' }),
								_react2.default.createElement(_FormElements.TextArea, { placeholder: "Add a short info of your design (Optional)", name: 'description', rows: '5' }),
								_react2.default.createElement(_FormElements.ComboBox, { name: 'productTags', value: values.productTags,
									options: productTagOptions, placeholder: 'Select a Tag or Enter new',
									multi: true,
									closeOnSelect: false,
									creatable: true }),
								currentUser.userType === USER_TYPE.ADMIN && _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(_FormElements.Input, { label: 'Price: ', name: 'price', type: 'number' }),
									_react2.default.createElement(_FormElements.Input, { label: 'Margin: ', name: 'margin', type: 'number' }),
									_react2.default.createElement(_FormElements.ComboBox, { name: 'productState', value: values.productState,
										options: _this4.PRODUCT_STATES, placeholder: 'Select State', clearable: false }),
									_react2.default.createElement(_FormElements.Input, { label: 'Priority: ', name: 'priority', type: 'number' }),
									_react2.default.createElement(_FormElements.Input, { label: 'MetaData: ', name: 'productMetaData', type: 'text' }),
									_react2.default.createElement(
										'h2',
										null,
										_react2.default.createElement(
											'b',
											null,
											'Others'
										)
									),
									_react2.default.createElement(_FormElements.Input, { label: 'Alias Price: ', name: 'aliasPrice', type: 'number' }),
									_react2.default.createElement(
										'h4',
										null,
										_react2.default.createElement(
											'b',
											null,
											'Ringroad Charge'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'flexRow' },
										_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'outsideRingRoadCharge', value: 'true',
											label: 'Apply Outside RingRoad Charge',
											checked: values.outsideRingRoadCharge === 'true' }),
										_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'outsideRingRoadCharge', value: 'false',
											label: 'No Outside RingRoad Charge',
											checked: values.outsideRingRoadCharge !== 'true' })
									),
									_react2.default.createElement('hr', null),
									_react2.default.createElement(
										'h4',
										null,
										_react2.default.createElement(
											'b',
											null,
											'Stock Info'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'flexRow' },
										_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'outofStock', value: 'true',
											label: 'Out of Stock',
											checked: values.outofStock === 'true' }),
										_react2.default.createElement(_FormElements.RadioButton, { style: { flexGrow: '1' }, name: 'outofStock', value: 'false',
											label: 'In Stock',
											checked: values.outofStock !== 'true' })
									),
									productType === _AppConstants2.default.PRODUCT_TYPES['PHOTO_FRAME'].val && _react2.default.createElement(
										_react2.default.Fragment,
										null,
										_react2.default.createElement(
											'h4',
											null,
											_react2.default.createElement(
												'b',
												null,
												'Image Dimension'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'flexRow' },
											_react2.default.createElement(
												'div',
												{ style: { marginRight: '10px' } },
												_react2.default.createElement(_FormElements.Input, { label: 'Img Width in Pixel: ', name: 'imgWidthPx', type: 'number' })
											),
											_react2.default.createElement(_FormElements.Input, { label: 'Img Height in Pixel: ', name: 'imgHeightPx', type: 'number' })
										)
									)
								),
								_react2.default.createElement(
									_FormElements.SubmitButton,
									{ color: 'primary', disabled: isSubmitting || _this4.props.product === null },
									submitBtn
								)
							);
						} })
				);
			}
		}]);
	
		return ProductEditForm;
	}(_react2.default.Component);
	
	var ProductSettings = function (_React$Component4) {
		_inherits(ProductSettings, _React$Component4);
	
		function ProductSettings() {
			_classCallCheck(this, ProductSettings);
	
			return _possibleConstructorReturn(this, (ProductSettings.__proto__ || Object.getPrototypeOf(ProductSettings)).apply(this, arguments));
		}
	
		_createClass(ProductSettings, [{
			key: 'showLogin',
			value: function showLogin() {
				_Dispatcher2.default.dispatchAlertWithAction(_AppConstants2.default.LOGIN_TO_CONTINUE_MSG, "WARN");
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				_AppUtil2.default.scrollToHashTagIfAny();
			}
		}, {
			key: 'render',
			value: function render() {
				var currentSession = _SessionStore2.default.getCurrentSession();
	
				if (currentSession === null) return _react2.default.createElement(
					'h2',
					{ style: { textAlign: "center" } },
					'Click ',
					_react2.default.createElement(
						_AppElements.A,
						{ href: '#', onClick: this.showLogin.bind(this) },
						'here'
					),
					' to login.'
				);
	
				var currentUser = currentSession.user;
				if (currentUser.userType === USER_TYPE.REGULAR) return _react2.default.createElement(
					'h1',
					{ style: { textAlign: "center" } },
					'You seem to have lost. Go ',
					_react2.default.createElement(
						_AppElements.A,
						{ href: '/' },
						'here'
					),
					' to find what you are looking for.'
				);
	
				var product = this.props.product;
	
				var productUrl = product ? _AppUtil2.default.getProductURL(product) : "#";
	
				return _react2.default.createElement(
					'div',
					{ style: { width: "50%", margin: "10px auto", '@media (max-width: 770px)': { width: 'auto' } }, id: 'productSettingsPage' },
					_react2.default.createElement(
						'h3',
						null,
						_react2.default.createElement(
							_AppElements.A,
							{ href: productUrl },
							'Go Back To Product'
						)
					),
					_react2.default.createElement(ProductEditForm, { product: product, currentUser: currentUser }),
					currentUser.userType === USER_TYPE.ADMIN && _react2.default.createElement(PreviewImageEditForm, { product: product }),
					_react2.default.createElement(ProductImageEditForm, { product: product }),
					_react2.default.createElement(AddNewImageForm, { product: product })
				);
			}
		}]);
	
		return ProductSettings;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(ProductSettings);

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	var _reactTooltip = __webpack_require__(660);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _SalesTargetForm = __webpack_require__(579);
	
	var _SalesTargetForm2 = _interopRequireDefault(_SalesTargetForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
		rowContainer: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap',
			border: '1px solid #eee', background: 'white' },
	
		rowBox: { margin: "10px", cursor: 'pointer', flexGrow: '1', borderRight: '2px solid #eee',
			textAlign: 'center', display: 'flex', flexDirection: 'column',
			padding: '10px',
			'@media (max-width: 700px)': { padding: '0 5px', borderRight: 'none' }
		}
	};
	
	var EachBox = (0, _radium2.default)(function (props) {
	
		var title = props.title;
		var value = props.value;
	
		var boxStyle = [style.rowBox];
	
		if (props.style) boxStyle.push(props.style);
	
		var toolTip = props.toolTip;
		return _react2.default.createElement(
			'span',
			{ style: boxStyle },
			_react2.default.createElement(
				'span',
				{ style: { margin: '5px', color: '#999', fontSize: '120%' }, 'data-tip': true, 'data-for': props.toolTipId },
				title
			),
			_react2.default.createElement(
				'span',
				{ style: { margin: '0px', color: '#555', fontSize: '125%' } },
				value
			),
			toolTip && _react2.default.createElement(
				_reactTooltip2.default,
				{ id: props.toolTipId, place: 'top', type: 'info',
					effect: 'solid', className: 'productStatToolTip' },
				_react2.default.createElement(
					'span',
					null,
					toolTip
				)
			)
		);
	});
	
	var TargetAchieved = function (_React$Component) {
		_inherits(TargetAchieved, _React$Component);
	
		function TargetAchieved() {
			_classCallCheck(this, TargetAchieved);
	
			return _possibleConstructorReturn(this, (TargetAchieved.__proto__ || Object.getPrototypeOf(TargetAchieved)).apply(this, arguments));
		}
	
		_createClass(TargetAchieved, [{
			key: 'render',
			value: function render() {
				var product = this.props.product;
				var currentTarget = this.props.currentTarget;
	
				return _react2.default.createElement(
					'div',
					{ style: { fontWeight: 'bold', textAlign: 'center', margin: '0 0 20px 0', padding: '10px', border: '1px solid #c1bebe' } },
					_react2.default.createElement(
						'h3',
						{ style: { margin: '10px 0' } },
						"CONGRATULATION! You've unlocked the earned amount."
					),
					_react2.default.createElement(_SalesTargetForm2.default, { product: product, currentTarget: currentTarget,
						style: { width: '50%', margin: '0 auto', '@media (max-width: 770px)': { width: '100%' } } })
				);
			}
		}]);
	
		return TargetAchieved;
	}(_react2.default.Component);
	
	var ProductStat = function (_React$Component2) {
		_inherits(ProductStat, _React$Component2);
	
		function ProductStat() {
			_classCallCheck(this, ProductStat);
	
			return _possibleConstructorReturn(this, (ProductStat.__proto__ || Object.getPrototypeOf(ProductStat)).apply(this, arguments));
		}
	
		_createClass(ProductStat, [{
			key: 'calculateCommission',
			value: function calculateCommission(currentTarget, margin) {
				return currentTarget.commissionPct * margin / 100.0 || 0;
			}
		}, {
			key: 'getCommissionStr',
			value: function getCommissionStr(stat) {
				var currentTarget = stat.currentTarget;
				var product = stat.product;
	
				if (stat.marginRange) {
					var margins = stat.marginRange.split("-");
					var minCommission = this.calculateCommission(currentTarget, margins[0]);
					// const maxCommission = this.calculateCommission(currentTarget, margins[1]);
					return _AppUtil2.default.formatNumber(minCommission) + "+";
				}
	
				return _AppUtil2.default.formatNumber(this.calculateCommission(currentTarget, product.margin));
			}
		}, {
			key: 'render',
			value: function render() {
				var stat = this.props.stat;
				var product = this.props.product;
	
				if (!stat || !product) return null;
	
				var currentTarget = stat.currentTarget;
	
				if (!currentTarget) return null;
	
				var targetAchieved = stat.targetAchieved >= currentTarget.salesTarget;
	
				var amountEarned = stat.amountEarned;
	
				var amountEarnedTitle = _react2.default.createElement(
					'span',
					null,
					'Amount Earned'
				);
				var amountEarnedToolTip = null;
				var showTargetOption = currentTarget.salesTarget > 1;
	
				if (targetAchieved) {
					amountEarnedTitle = _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('i', { className: 'fa fa-unlock', 'aria-hidden': 'true', style: { color: '#31ad31' } }),
						' Amount Earned'
					);
					amountEarnedToolTip = showTargetOption ? "Amount has been unlocked. You have completed the target." : null;
				} else {
					amountEarnedTitle = _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('i', { className: 'fa fa-lock', 'aria-hidden': 'true' }),
						' Amount Earned'
					);
					amountEarnedToolTip = showTargetOption ? "Amount is locked and cannot be withdrawn." : null;
				}
	
				var hasPendingOrders = stat.pendingOrdersCount > 0;
	
				var pendingTitle = _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement('i', { style: hasPendingOrders ? { color: '#31ad31' } : {},
						className: 'fa fa-truck', 'aria-hidden': 'true' }),
					' Pending Orders'
				);
	
				return _react2.default.createElement(
					'div',
					{ className: 'flexColumn', style: { margin: "20px auto" }, id: 'productStat' },
					showTargetOption && !targetAchieved && _react2.default.createElement(
						'div',
						{ className: 'flexRow',
							style: { fontSize: '130%', justifyContent: 'space-evenly', color: '#555', width: '50%',
								margin: '0 auto 10px auto', '@media (max-width: 770px)': { width: '100%' }
							} },
						_react2.default.createElement(
							'span',
							{ style: { marginRight: '15px' } },
							_react2.default.createElement(
								'b',
								null,
								'Target: '
							),
							currentTarget.salesTarget
						),
						_react2.default.createElement(
							'span',
							null,
							_react2.default.createElement(
								'b',
								null,
								'Remaining: '
							),
							currentTarget.salesTarget - stat.targetAchieved
						)
					),
					showTargetOption && targetAchieved && _react2.default.createElement(TargetAchieved, { product: product, currentTarget: currentTarget }),
					_react2.default.createElement(
						'div',
						{ style: style.rowContainer },
						_react2.default.createElement(EachBox, { title: pendingTitle, value: stat.pendingOrdersCount || 0 }),
						_react2.default.createElement(EachBox, { title: 'Fulfilled Orders', value: stat.targetAchieved || 0 }),
						_react2.default.createElement(EachBox, { title: 'Commission', value: "Rs. " + this.getCommissionStr(stat),
							toolTipId: 'commissionToolTip', toolTip: 'This is the amount you can earn per quantity sold.' }),
						_react2.default.createElement(EachBox, { title: amountEarnedTitle, value: "Rs. " + _AppUtil2.default.formatNumber(amountEarned), style: { borderRight: 'none' },
							toolTipId: 'amountEarnedToolTip', toolTip: amountEarnedToolTip })
					)
				);
			}
		}]);
	
		return ProductStat;
	}(_react2.default.Component);
	
	exports.default = (0, _radium2.default)(ProductStat);

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImgUploadForm = __webpack_require__(93);
	
	var _ImgUploadForm2 = _interopRequireDefault(_ImgUploadForm);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	var _AppElements = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerForm = function BannerForm(_ref) {
	    var id = _ref.id,
	        bannerImg = _ref.bannerImg;
	
	    var deleteBtn = (0, _react.useRef)(null);
	
	    var onUpload = function onUpload(uploadedImgFile) {
	        _UserAPI2.default.addBanner(uploadedImgFile);
	    };
	
	    var onDelete = function onDelete() {
	        deleteBtn.current.setAttribute("disabled", true);
	        deleteBtn.current.innerHTML = "<i class='fa fa-circle-o-notch fa-spin' aria-hidden='true'></i>";
	        _UserAPI2.default.removeBanner(bannerImg);
	    };
	    return _react2.default.createElement(
	        'div',
	        null,
	        bannerImg && _react2.default.createElement(
	            'button',
	            { onClick: onDelete, style: { cursor: "pointer", backgroundColor: "#cccccc", color: "white", borderRadius: "5px", fontSize: "80%" }, key: bannerImg, ref: deleteBtn },
	            'X'
	        ),
	        _react2.default.createElement(_ImgUploadForm2.default, { previewId: id, className: 'bannerPicForm',
	            defaultPreviewImg: bannerImg,
	            imgWidth: '800px', imgHeight: '209px',
	            imgInfo: '1196 x 312, Less than 2Mb',
	            onUpload: onUpload, addOnly: true })
	    );
	};
	
	var BannersForm = function BannersForm(_ref2) {
	    var bannerImages = _ref2.bannerImages,
	        storeName = _ref2.storeName;
	
	    var bannerImageForms = [];
	    for (var i = 0; i < 3; i++) {
	        var key = storeName + "Banner" + i;
	        var img = bannerImages ? bannerImages[i] : null;
	        bannerImageForms[i] = _react2.default.createElement(BannerForm, { key: key, id: key, bannerImg: img });
	
	        if (!img) break;
	    }
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AppElements.Title, { title: 'Store Banners', style: { textAlign: 'left' }, separatorPosition: 'top' }),
	        bannerImageForms
	    );
	};
	
	exports.default = BannersForm;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function Form(_ref) {
		var isSubmitting = _ref.isSubmitting;
	
		var submitBtn = "Forgot Password";
	
		if (isSubmitting === true) submitBtn = _react2.default.createElement(
			'span',
			null,
			'Forgot Password ',
			_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
		);
	
		return _react2.default.createElement(
			_FormElements.RGForm,
			null,
			_react2.default.createElement(_FormElements.Input, { name: 'email', type: 'text', label: 'Email: ', style: { marginBottom: "0px" } }),
			_react2.default.createElement(
				_FormElements.SubmitButton,
				{ style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting },
				submitBtn
			)
		);
	};
	
	var ForgotPassword = function (_React$Component) {
		_inherits(ForgotPassword, _React$Component);
	
		function ForgotPassword(props) {
			_classCallCheck(this, ForgotPassword);
	
			var _this = _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this, props));
	
			_this.INIT_VALUES = { email: '' };
			_this.handleSubmission = _this.handleSubmission.bind(_this);
			return _this;
		}
	
		_createClass(ForgotPassword, [{
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					email: _yup2.default.string().email('Email address is invalid').required('Email is required!')
				});
			}
		}, {
			key: 'handleSubmission',
			value: function handleSubmission(values, _ref2) {
				var setSubmitting = _ref2.setSubmitting;
	
				_UserAPI2.default.sendForgetPasswordEmail(values.email, function (success) {
					setSubmitting(false);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_formik.Formik, { initialValues: this.INIT_VALUES, onSubmit: this.handleSubmission,
					validationSchema: this.validationScheme, component: Form });
			}
		}]);
	
		return ForgotPassword;
	}(_react2.default.Component);
	
	exports.default = ForgotPassword;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function Form(_ref) {
		var isSubmitting = _ref.isSubmitting,
		    values = _ref.values,
		    forgetPasswordLink = _ref.forgetPasswordLink;
	
	
		var btnTxt = "";
		var mode = values.mode;
	
		if (mode === "VERIFY_EMAIL") btnTxt = "Send Verification Email";else btnTxt = "Log In";
	
		var submitBtn = btnTxt;
		if (isSubmitting === true) submitBtn = _react2.default.createElement(
			'span',
			null,
			btnTxt,
			' ',
			_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
		);
	
		return _react2.default.createElement(
			_FormElements.RGForm,
			null,
			_react2.default.createElement(
				'h4',
				{ style: { fontStyle: "italic", margin: "10px 0", textAlign: "center" } },
				'Login with your email address'
			),
			_react2.default.createElement(_FormElements.Input, { name: 'email', type: 'text', label: 'Email: ', style: { marginBottom: "0px" } }),
			mode === "LOGIN" && _react2.default.createElement(_FormElements.Input, { name: 'password', type: 'password', label: 'Password: ', style: { marginBottom: "0px", marginTop: "10px" } }),
			_react2.default.createElement(_FormElements.Input, { name: 'mode', type: 'hidden' }),
			_react2.default.createElement(
				'div',
				{ className: 'flexRow', style: { justifyContent: "space-between", alignItems: "flex-end" } },
				_react2.default.createElement(
					_FormElements.SubmitButton,
					{ style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting },
					submitBtn
				),
				forgetPasswordLink
			)
		);
	};
	
	var LoginForm = function (_React$Component) {
		_inherits(LoginForm, _React$Component);
	
		function LoginForm(props) {
			_classCallCheck(this, LoginForm);
	
			var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));
	
			_this.INIT_VALUES = { email: '', password: '', mode: "LOGIN" };
	
			if (_this.props.formData) Object.assign(_this.INIT_VALUES, _this.props.formData);
	
			_this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
			return _this;
		}
	
		_createClass(LoginForm, [{
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					email: _yup2.default.string().required('Enter your email address.').email('Email address is invalid.'),
					password: _yup2.default.string().required('Enter your password.').min(6, "Password cannot be less than 6 chars.")
				});
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(value, _ref2) {
				var setSubmitting = _ref2.setSubmitting,
				    setFieldValue = _ref2.setFieldValue;
	
	
				if (value.mode === 'VERIFY_EMAIL') {
					_UserAPI2.default.sendVerificationEmail(value.email, function (success) {
						setSubmitting(false);
					});
				} else {
					_HttpService2.default.login(value.email, value.password, function (success, error) {
						if (success === false) {
							setSubmitting(false);
	
							if (error.message.toLowerCase().indexOf("verify your email") >= 0) {
								setFieldValue('mode', 'VERIFY_EMAIL');
							}
						}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
					validationSchema: this.validationScheme, render: function render(formikProps) {
						return _react2.default.createElement(Form, Object.assign({}, formikProps, { forgetPasswordLink: _this2.props.forgetPasswordLink }));
					} });
			}
		}]);
	
		return LoginForm;
	}(_react2.default.Component);
	
	exports.default = LoginForm;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(11);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactResponsiveModal = __webpack_require__(32);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _AppElements = __webpack_require__(9);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _LoginForm = __webpack_require__(594);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _RegisterForm = __webpack_require__(597);
	
	var _RegisterForm2 = _interopRequireDefault(_RegisterForm);
	
	var _ForgotPassword = __webpack_require__(593);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _SocialMediaLogin = __webpack_require__(598);
	
	var _SocialMediaLogin2 = _interopRequireDefault(_SocialMediaLogin);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
		box: { padding: "5px 25px 15px 25px", borderRadius: "5px", margin: "auto" },
	
		blurLink: { color: "#a28348" },
	
		floatLeft: { float: "left" },
		floatRight: { float: "right" },
		clearFix: { clear: "both" }
	};
	
	var TERMS_OF_USE = _react2.default.createElement(
		'div',
		{ style: { fontSize: "72%", color: "#a28348", marginTop: "15px", textAlign: "left" } },
		'By logging into ',
		_AppConstants2.default.WEBSITE,
		', you agree to the ',
		_AppConstants2.default.APP_NAME,
		' ',
		_react2.default.createElement(
			_AppElements.A,
			{ href: '/terms-of-use-and-privacy-policy', target: '_blank', style: { color: "gray" } },
			'Terms & Conditions'
		),
		' and ',
		_react2.default.createElement(
			_AppElements.A,
			{ href: '/terms-of-use-and-privacy-policy', target: '_blank', style: { color: "gray" } },
			'Privacy Policy'
		),
		'.'
	);
	
	var LoginSignUpFooter = (0, _radium2.default)(function (props) {
	
		var leftComponent = props.left;
		var rightComponent = props.right;
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ style: [{ padding: "15px 0", fontSize: "13px", '@media (max-width: 768px)': { fontSize: '12px' } }] },
				_react2.default.createElement(
					'span',
					{ style: { float: "left" } },
					leftComponent
				),
				_react2.default.createElement(
					'span',
					{ style: { float: "right" } },
					rightComponent
				)
			),
			_react2.default.createElement('div', { style: { clear: "both" } }),
			TERMS_OF_USE
		);
	});
	
	var LoginSignUpBox = function (_React$Component) {
		_inherits(LoginSignUpBox, _React$Component);
	
		function LoginSignUpBox(props) {
			_classCallCheck(this, LoginSignUpBox);
	
			var _this = _possibleConstructorReturn(this, (LoginSignUpBox.__proto__ || Object.getPrototypeOf(LoginSignUpBox)).call(this, props));
	
			_this.LOGIN_FORM = _AppConstants2.default.SIGN_UP_FORMS.LOGIN_FORM;
			_this.REGISTER_FORM = _AppConstants2.default.SIGN_UP_FORMS.REGISTER_FORM;
			_this.FORGOT_PASSWORD = _AppConstants2.default.SIGN_UP_FORMS.FORGOT_PASSWORD;
			_this.SOCIAL_LOGIN = _AppConstants2.default.SIGN_UP_FORMS.SOCIAL_LOGIN;
	
			//by default, we always show SOCIAL_LOGIN
			var selectedForm = _this.props.selectedForm ? _this.props.selectedForm : _this.SOCIAL_LOGIN;
			_this.state = { openModal: _this.props.openLoginModal, selectedForm: selectedForm };
			_this.handleModalClose = _this.handleModalClose.bind(_this);
			return _this;
		}
	
		_createClass(LoginSignUpBox, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var newState = { openModal: nextProps.openLoginModal };
	
				if (nextProps.selectedForm && this.props.selectedForm !== nextProps.selectedForm) newState["selectedForm"] = nextProps.selectedForm;
	
				this.setState(newState);
			}
		}, {
			key: 'selectForm',
			value: function selectForm(form) {
				this.setState({ selectedForm: form });
			}
		}, {
			key: 'handleModalClose',
			value: function handleModalClose() {
				//reset to default social login form on modal close
				this.setState({ openModal: false, selectedForm: this.SOCIAL_LOGIN });
			}
		}, {
			key: 'getSocialMediaLogin',
			value: function getSocialMediaLogin() {
				var leftDiv = _react2.default.createElement(
					_AppElements.A,
					{ href: '#', style: [style.blurLink],
						onClick: this.selectForm.bind(this, this.LOGIN_FORM) },
					'Log In'
				);
	
				var rightDiv = _react2.default.createElement(
					_AppElements.A,
					{ href: '#', style: [style.blurLink],
						onClick: this.selectForm.bind(this, this.REGISTER_FORM) },
					'Sign Up'
				);
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_SocialMediaLogin2.default, null),
					_react2.default.createElement(LoginSignUpFooter, { left: leftDiv, right: rightDiv })
				);
			}
		}, {
			key: 'getLoginForm',
			value: function getLoginForm() {
	
				var leftDiv = _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(
						_AppElements.A,
						{ href: '#', onClick: this.selectForm.bind(this, this.REGISTER_FORM) },
						"Don't have an account?"
					)
				);
	
				var rightDiv = _react2.default.createElement(
					_AppElements.A,
					{ href: '#', style: [style.blurLink],
						onClick: this.selectForm.bind(this, this.SOCIAL_LOGIN) },
					'Login via Social Media'
				);
	
				var forgetPasswordLink = _react2.default.createElement(
					_AppElements.A,
					{ href: '#', style: [style.blurLink, { fontSize: '13px' }],
						onClick: this.selectForm.bind(this, this.FORGOT_PASSWORD) },
					'Forgot Password?'
				);
	
				var formData = this.props.formData && this.props.selectedForm === this.LOGIN_FORM ? this.props.formData : null;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_LoginForm2.default, { formData: formData, forgetPasswordLink: forgetPasswordLink }),
					_react2.default.createElement(LoginSignUpFooter, { left: leftDiv, right: rightDiv })
				);
			}
		}, {
			key: 'getRegisterForm',
			value: function getRegisterForm() {
				var leftDiv = _react2.default.createElement(
					_AppElements.A,
					{ href: '#', onClick: this.selectForm.bind(this, this.LOGIN_FORM) },
					'Already have an account?'
				);
				var rightDiv = _react2.default.createElement(
					_AppElements.A,
					{ href: '#', style: [style.blurLink],
						onClick: this.selectForm.bind(this, this.SOCIAL_LOGIN) },
					'Register via Social Media'
				);
	
				var formData = this.props.formData && this.props.selectedForm === this.REGISTER_FORM ? this.props.formData : null;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_RegisterForm2.default, { formData: formData }),
					_react2.default.createElement(LoginSignUpFooter, { left: leftDiv, right: rightDiv })
				);
			}
		}, {
			key: 'getForgotPasswordForm',
			value: function getForgotPasswordForm() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_ForgotPassword2.default, null),
					_react2.default.createElement(
						_AppElements.A,
						{ href: '#', onClick: this.selectForm.bind(this, this.LOGIN_FORM) },
						'Go Back'
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var selectedForm = this.state.selectedForm;
	
				var form = null;
	
				if (selectedForm === this.LOGIN_FORM) form = this.getLoginForm();else if (selectedForm === this.REGISTER_FORM) form = this.getRegisterForm();else if (selectedForm === this.FORGOT_PASSWORD) form = this.getForgotPasswordForm();else if (selectedForm === this.SOCIAL_LOGIN) form = this.getSocialMediaLogin();
	
				var logoImg = _AppUtil2.default.getAppLogo();
				return _react2.default.createElement(
					_reactResponsiveModal2.default,
					{ closeOnOverlayClick: false, open: this.state.openModal, onClose: this.handleModalClose, little: true,
						classNames: { overlay: 'login-overlay', modal: 'login-modal' } },
					_react2.default.createElement(
						'div',
						{ style: [style.box] },
						_react2.default.createElement(
							'div',
							{ style: { textAlign: "center" } },
							_react2.default.createElement('img', { src: logoImg, style: { width: "60%" }, alt: _AppConstants2.default.APP_NAME, title: _AppConstants2.default.APP_NAME })
						),
						form
					)
				);
			}
		}]);
	
		return LoginSignUpBox;
	}(_react2.default.Component);
	
	LoginSignUpBox = (0, _radium2.default)(LoginSignUpBox);
	exports.default = LoginSignUpBox;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImgUploadForm = __webpack_require__(93);
	
	var _ImgUploadForm2 = _interopRequireDefault(_ImgUploadForm);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilePicForm = function ProfilePicForm(_ref) {
	    var user = _ref.user,
	        readOnly = _ref.readOnly;
	
	
	    var onUpload = function onUpload(uploadedImgFile) {
	        if (readOnly === true) {
	            alert("You are not authorized to perform this action!");
	            return;
	        }
	        _UserAPI2.default.updateProfilePic(uploadedImgFile);
	    };
	
	    return _react2.default.createElement(_ImgUploadForm2.default, { previewId: 'profilePicturePreview', className: 'profilePicForm',
	        defaultPreviewImg: user.profilePicture,
	        imgWidth: '100px', imgHeight: '100px', imgInfo: '600 x 600, Less than 1Mb',
	        onUpload: onUpload });
	};
	exports.default = ProfilePicForm;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _UserAPI = __webpack_require__(33);
	
	var _UserAPI2 = _interopRequireDefault(_UserAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function Form(_ref) {
		var isSubmitting = _ref.isSubmitting,
		    values = _ref.values;
	
	
		var submitBtn = "Create Account";
	
		if (isSubmitting === true) submitBtn = _react2.default.createElement(
			'span',
			null,
			'Creating ',
			_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
		);
	
		return _react2.default.createElement(
			_FormElements.RGForm,
			null,
			_react2.default.createElement(
				'h4',
				{ style: { fontStyle: "italic", margin: "10px 0 25px 0", textAlign: "center" } },
				'Please fill in the form below to register.'
			),
			_react2.default.createElement(_FormElements.Input, { name: 'username', placeholder: 'E.g: Ram Prasad Jhilke', type: 'text', label: 'Fullname: ', style: { marginBottom: "0px", marginTop: "10px" } }),
			_react2.default.createElement(_FormElements.Input, { name: 'email', placeholder: 'E.g: somename@example.com', type: 'email', label: 'Email: ', style: { marginBottom: "0px" } }),
			_react2.default.createElement(_FormElements.Input, { name: 'password', placeholder: 'E.g: 123456789 :)', type: 'password', label: 'Password: ', style: { marginBottom: "0px", marginTop: "10px" } }),
			_react2.default.createElement(
				_FormElements.SubmitButton,
				{ style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting },
				submitBtn
			)
		);
	};
	
	var RegisterForm = function (_React$Component) {
		_inherits(RegisterForm, _React$Component);
	
		function RegisterForm(props) {
			_classCallCheck(this, RegisterForm);
	
			var _this = _possibleConstructorReturn(this, (RegisterForm.__proto__ || Object.getPrototypeOf(RegisterForm)).call(this, props));
	
			_this.INIT_VALUES = { username: '', password: '', email: '' };
	
			if (_this.props.formData) Object.assign(_this.INIT_VALUES, _this.props.formData);
	
			_this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
			return _this;
		}
	
		_createClass(RegisterForm, [{
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					email: _yup2.default.string().email('Invalid Email address'),
					username: _yup2.default.string().required('Enter your name'),
					password: _yup2.default.string().required('Enter a password').min(6, "Password cannot be less than 8 characters")
				});
			}
		}, {
			key: 'handleFormSubmission',
			value: function handleFormSubmission(value, _ref2) {
				var setSubmitting = _ref2.setSubmitting,
				    resetForm = _ref2.resetForm;
	
	
				_UserAPI2.default.register(value.username, value.email, value.password, function (success) {
					setSubmitting(false);
	
					if (success === true) resetForm(this.INIT_VALUES);
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_formik.Formik, { initialValues: this.INIT_VALUES, onSubmit: this.handleFormSubmission,
					validationSchema: this.validationScheme, component: Form });
			}
		}]);
	
		return RegisterForm;
	}(_react2.default.Component);
	
	exports.default = RegisterForm;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppConstants = __webpack_require__(8);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _AppElements = __webpack_require__(9);
	
	var _divider = __webpack_require__(69);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _Dispatcher = __webpack_require__(18);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*global FB*/
	/*global gapi*/
	
	
	var style = {
		socialLogin: { margin: "10px", cursor: "pointer", width: "191px", height: "46px", border: "none" },
		fbConnect: { background: '#4267b2', borderRadius: "0px", display: "flex", flexDirection: "row", flexWrap: 'nowrap', margin: '10px auto', padding: '0px', bordeRadius: '2px' },
		fbIcon: { background: "white", color: "#4267b2", padding: "3px 10px", margin: "2px", border: "2px white solid",
			borderRadius: "2px", fontSize: "200%" },
		fbText: { color: 'white', justifyContent: "center", alignItems: "center", display: "flex",
			height: "46px", width: "100%" },
		gmailSignIn: { background: "url('/images/login_signup/google_sign_in.png')" }
	
	};
	
	var FB_APP_SCOPE = 'public_profile, email';
	
	var SocialMediaLogin = function (_React$Component) {
		_inherits(SocialMediaLogin, _React$Component);
	
		function SocialMediaLogin(props) {
			_classCallCheck(this, SocialMediaLogin);
	
			var _this = _possibleConstructorReturn(this, (SocialMediaLogin.__proto__ || Object.getPrototypeOf(SocialMediaLogin)).call(this, props));
	
			_this.handleFBClick = _this.handleFBClick.bind(_this);
			_this.state = { submitting: false };
			return _this;
		}
	
		_createClass(SocialMediaLogin, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.initGoogleSDK();
			}
		}, {
			key: 'initGoogleSDK',
			value: function initGoogleSDK() {
				var handleGoogleLogin = this.handleGoogleLogin.bind(this);
	
				if (gapi === undefined) {
					console.log("Error: Could not download google sign in sdk");
					return;
				}
	
				gapi.load('auth2', function () {
					// Retrieve the singleton for the GoogleAuth library and set up the client.
					var auth2 = gapi.auth2.init({
						client_id: _AppConstants2.default.GOOGLE_CLIENT_ID,
						cookiepolicy: 'single_host_origin'
					});
	
					var gmailSignInButton = document.getElementById("gmailSignIn");
	
					auth2.attachClickHandler(gmailSignInButton, {}, handleGoogleLogin, function (error) {
						console.log("Error Gmail", error);
					});
				});
			}
		}, {
			key: 'handleFBClick',
			value: function handleFBClick() {
				this.setState({ submitting: true });
	
				FB.login(function (response) {
					console.log("FB Login response", response);
					//this means some error occurred
					if (!response.authResponse) {
						this.setState({ submitting: false });
						_Dispatcher2.default.dispatchAnAlert({ message: "FB Login didn't work. Try logging in manually.", type: "ERROR" });
						return;
					}
	
					var accessToken = response.authResponse.accessToken;
	
					_HttpService2.default.loginWithFB(accessToken, function (loggedIn) {
						this.setState({ submitting: false });
					}.bind(this));
				}.bind(this), { scope: FB_APP_SCOPE });
			}
		}, {
			key: 'handleGoogleLogin',
			value: function handleGoogleLogin(googleUser) {
				this.setState({ submitting: true });
	
				var idToken = googleUser.getAuthResponse().id_token;
				_HttpService2.default.loginWithGEmail(idToken, function (loggedIn) {
					this.setState({ submitting: false });
				}.bind(this));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ style: { textAlign: "center" } },
					_react2.default.createElement(
						'h4',
						{ style: { fontStyle: "italic", margin: "10px 0" } },
						'Choose one of the options below.'
					),
					this.state.submitting && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
					),
					_react2.default.createElement(
						_AppElements.Button,
						{ id: 'fbLogin', style: [style.socialLogin, style.fbConnect, { 'display': 'none' }], disabled: this.state.submitting, onClick: this.handleFBClick },
						_react2.default.createElement(
							'span',
							{ style: style.fbIcon },
							_react2.default.createElement('i', { className: 'fa fa-facebook', 'aria-hidden': 'true' }),
							' '
						),
						_react2.default.createElement(
							'span',
							{ style: style.fbText },
							'Login with Facebook'
						)
					),
					_react2.default.createElement(_divider2.default, null),
					_react2.default.createElement(_AppElements.Button, { id: 'gmailSignIn', style: [style.gmailSignIn, style.socialLogin], disabled: this.state.submitting })
				);
			}
		}]);
	
		return SocialMediaLogin;
	}(_react2.default.Component);
	
	exports.default = SocialMediaLogin;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(21);
	
	var _yup = __webpack_require__(19);
	
	var _yup2 = _interopRequireDefault(_yup);
	
	var _FormElements = __webpack_require__(13);
	
	var _AppElements = __webpack_require__(9);
	
	var _HttpService = __webpack_require__(12);
	
	var _HttpService2 = _interopRequireDefault(_HttpService);
	
	var _AppUtil = __webpack_require__(10);
	
	var _AppUtil2 = _interopRequireDefault(_AppUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSettingsForm = function (_React$Component) {
		_inherits(UserSettingsForm, _React$Component);
	
		function UserSettingsForm(props) {
			_classCallCheck(this, UserSettingsForm);
	
			var _this = _possibleConstructorReturn(this, (UserSettingsForm.__proto__ || Object.getPrototypeOf(UserSettingsForm)).call(this, props));
	
			_this.handleSubmission = _this.handleSubmission.bind(_this);
			return _this;
		}
	
		_createClass(UserSettingsForm, [{
			key: 'getInitValues',
			value: function getInitValues(user) {
				var socialMediaAccounts = user.socialMediaAccounts ? user.socialMediaAccounts : {};
				var initValues = { username: user.username,
					emailAddress: user.emailAddress ? user.emailAddress : '',
					phoneNumber: user.phoneNumber ? user.phoneNumber : '',
					storeName: user.storeName ? user.storeName : '',
					about: user.about ? user.about : '',
					address: user.address ? user.address : '',
	
					facebookUrl: socialMediaAccounts['FB'] ? socialMediaAccounts['FB'] : '',
					instaUrl: socialMediaAccounts['INSTA'] ? socialMediaAccounts['INSTA'] : '',
					ytUrl: socialMediaAccounts['YOUTUBE'] ? socialMediaAccounts['YOUTUBE'] : '',
					tiktokUrl: socialMediaAccounts['TIKTOK'] ? socialMediaAccounts['TIKTOK'] : ''
				};
				return initValues;
			}
		}, {
			key: 'validationScheme',
			value: function validationScheme() {
				return _yup2.default.object().shape({
					username: _yup2.default.string().required('Please enter a Username.'),
					phoneNumber: _AppUtil2.default.phoneNumberValidation(),
					emailAddress: _yup2.default.string().email('Email address is invalid.').required('Please provide your Email Address.'),
					about: _yup2.default.string().max(100, 'Max. 100 characters'),
					tiktokUrl: _yup2.default.string(),
					instaUrl: _yup2.default.string(),
					facebookUrl: _yup2.default.string(),
					ytUrl: _yup2.default.string().when(['tiktokUrl', 'instaUrl', 'facebookUrl'], function (tiktokUrl, instaUrl, facebookUrl, schema) {
						if (!tiktokUrl && !instaUrl && !facebookUrl) return _yup2.default.string().required('Provide at least your one social media account');
	
						return _yup2.default.string();
					})
				});
			}
		}, {
			key: 'handleSubmission',
			value: function handleSubmission(values, _ref) {
				var setSubmitting = _ref.setSubmitting;
	
				if (this.props.readOnly === true) {
					alert("You are not authorized to perform this action!");
					return;
				}
	
				var udpateUser = { username: values.username, emailAddress: values.emailAddress,
					phoneNumber: values.phoneNumber, storeName: values.storeName,
					about: values.about, address: values.address
				};
	
				var socialMediAccounts = {};
	
				if (values.facebookUrl) socialMediAccounts['FB'] = values.facebookUrl;
				if (values.instaUrl) socialMediAccounts['INSTA'] = values.instaUrl;
				if (values.ytUrl) socialMediAccounts['YOUTUBE'] = values.ytUrl;
				if (values.tiktokUrl) socialMediAccounts['TIKTOK'] = values.tiktokUrl;
	
				udpateUser['socialMediaAccounts'] = socialMediAccounts;
	
				_HttpService2.default.updateUserInfo(udpateUser, function (success) {
					setSubmitting(false);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var user = this.props.user;
				if (!user) return null;
	
				var isStore = user.storeName !== null && user.storeName !== undefined;
				var initValues = this.getInitValues(user);
				return _react2.default.createElement(_formik.Formik, { enableReinitialize: true, initialValues: initValues, onSubmit: this.handleSubmission,
					validationSchema: this.validationScheme, render: function render(_ref2) {
						var isSubmitting = _ref2.isSubmitting,
						    values = _ref2.values;
	
						var submitBtn = "Update";
	
						if (isSubmitting === true) submitBtn = _react2.default.createElement(
							'span',
							null,
							'Updating ',
							_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin', 'aria-hidden': 'true' })
						);
	
						return _react2.default.createElement(
							_FormElements.RGForm,
							null,
							_react2.default.createElement(_AppElements.Title, { title: 'About You', style: { textAlign: 'left' }, separatorPosition: 'top' }),
							_react2.default.createElement(_FormElements.Input, { name: 'username', type: 'text', label: 'Username: ', style: { marginBottom: "0px" } }),
							_react2.default.createElement(_FormElements.Input, { name: 'phoneNumber', type: 'text', label: 'Phone Number: ',
								style: { marginBottom: "0px" }, placeholder: 'E.g. 9862441133', disabled: user.phoneNumber ? true : false }),
							_react2.default.createElement(_FormElements.Input, { name: 'emailAddress', type: 'text', label: 'Email: ', style: { marginBottom: "0px" }, disabled: user.emailAddress ? true : false }),
							_react2.default.createElement(_FormElements.Input, { name: 'address', type: 'text', label: 'Address: ', style: { marginBottom: "0px" } }),
							isStore && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(_AppElements.Separator, { style: { margin: '30px auto' } }),
								_react2.default.createElement(_FormElements.Input, { name: 'storeName', type: 'text', label: 'Store Name: ', style: { marginBottom: "0px" }, disabled: true })
							),
							_react2.default.createElement(_FormElements.TextArea, { placeholder: "Max 100 characaters", label: isStore ? "Store Info:" : "About you:", name: 'about', rows: '3' }),
							_react2.default.createElement(
								'h3',
								null,
								'Social Media Accounts: '
							),
							_react2.default.createElement(_FormElements.Input, { name: 'facebookUrl', label: 'Facebook:', type: 'text', placeholder: 'Enter your Facebook URL', style: { marginTop: '5px' } }),
							_react2.default.createElement(_FormElements.Input, { name: 'instaUrl', label: 'Instagram:', type: 'text', placeholder: 'Enter your Instagram URL', style: { marginTop: '5px' } }),
							_react2.default.createElement(_FormElements.Input, { name: 'tiktokUrl', label: 'Tiktok:', type: 'text', placeholder: 'Enter your Tiktok URL', style: { marginTop: '5px' } }),
							_react2.default.createElement(_FormElements.Input, { name: 'ytUrl', label: 'Youtube:', type: 'text', placeholder: 'Enter your Youtube URL', style: { marginTop: '5px' } }),
							_react2.default.createElement(
								_FormElements.SubmitButton,
								{ style: { marginTop: "10px" }, color: 'primary', disabled: isSubmitting || _this2.props.readOnly === true },
								submitBtn
							)
						);
					} });
			}
		}]);
	
		return UserSettingsForm;
	}(_react2.default.Component);
	
	exports.default = UserSettingsForm;

/***/ },
/* 600 */
97,
/* 601 */
97,
/* 602 */
97,
/* 603 */
97,
/* 604 */
97,
/* 605 */
97,
/* 606 */
97,
/* 607 */
97,
/* 608 */
97,
/* 609 */
97,
/* 610 */
97,
/* 611 */
97,
/* 612 */
97,
/* 613 */
97,
/* 614 */
97,
/* 615 */
97,
/* 616 */
97,
/* 617 */
97,
/* 618 */
97,
/* 619 */
389,
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(234);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(234);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 622 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 623 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(236);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(237);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(99);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 625 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 626 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sidebar = __webpack_require__(629);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _sidebar2.default;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CANCEL_DISTANCE_ON_SCROLL = 20;
	
	var defaultStyles = {
	  root: {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflow: 'hidden'
	  },
	  sidebar: {
	    zIndex: 2,
	    position: 'absolute',
	    top: 0,
	    bottom: 0,
	    transition: 'transform .3s ease-out',
	    WebkitTransition: '-webkit-transform .3s ease-out',
	    willChange: 'transform',
	    overflowY: 'auto'
	  },
	  content: {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflowY: 'scroll',
	    WebkitOverflowScrolling: 'touch',
	    transition: 'left .3s ease-out, right .3s ease-out'
	  },
	  overlay: {
	    zIndex: 1,
	    position: 'fixed',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    opacity: 0,
	    visibility: 'hidden',
	    transition: 'opacity .3s ease-out, visibility .3s ease-out',
	    backgroundColor: 'rgba(0,0,0,.3)'
	  },
	  dragHandle: {
	    zIndex: 1,
	    position: 'fixed',
	    top: 0,
	    bottom: 0
	  }
	};
	
	var Sidebar = function (_Component) {
	  _inherits(Sidebar, _Component);
	
	  function Sidebar(props) {
	    _classCallCheck(this, Sidebar);
	
	    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));
	
	    _this.state = {
	      // the detected width of the sidebar in pixels
	      sidebarWidth: props.defaultSidebarWidth,
	
	      // keep track of touching params
	      touchIdentifier: null,
	      touchStartX: null,
	      touchStartY: null,
	      touchCurrentX: null,
	      touchCurrentY: null,
	
	      // if touch is supported by the browser
	      dragSupported: false
	    };
	
	    _this.overlayClicked = _this.overlayClicked.bind(_this);
	    _this.onTouchStart = _this.onTouchStart.bind(_this);
	    _this.onTouchMove = _this.onTouchMove.bind(_this);
	    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
	    _this.onScroll = _this.onScroll.bind(_this);
	    _this.saveSidebarRef = _this.saveSidebarRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(Sidebar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        dragSupported: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && 'ontouchstart' in window
	      });
	      this.saveSidebarWidth();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // filter out the updates when we're touching
	      if (!this.isTouching()) {
	        this.saveSidebarWidth();
	      }
	    }
	  }, {
	    key: 'onTouchStart',
	    value: function onTouchStart(ev) {
	      // filter out if a user starts swiping with a second finger
	      if (!this.isTouching()) {
	        var touch = ev.targetTouches[0];
	        this.setState({
	          touchIdentifier: touch.identifier,
	          touchStartX: touch.clientX,
	          touchStartY: touch.clientY,
	          touchCurrentX: touch.clientX,
	          touchCurrentY: touch.clientY
	        });
	      }
	    }
	  }, {
	    key: 'onTouchMove',
	    value: function onTouchMove(ev) {
	      if (this.isTouching()) {
	        for (var ind = 0; ind < ev.targetTouches.length; ind++) {
	          // we only care about the finger that we are tracking
	          if (ev.targetTouches[ind].identifier === this.state.touchIdentifier) {
	            this.setState({
	              touchCurrentX: ev.targetTouches[ind].clientX,
	              touchCurrentY: ev.targetTouches[ind].clientY
	            });
	            break;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'onTouchEnd',
	    value: function onTouchEnd() {
	      if (this.isTouching()) {
	        // trigger a change to open if sidebar has been dragged beyond dragToggleDistance
	        var touchWidth = this.touchSidebarWidth();
	
	        if (this.props.open && touchWidth < this.state.sidebarWidth - this.props.dragToggleDistance || !this.props.open && touchWidth > this.props.dragToggleDistance) {
	          this.props.onSetOpen(!this.props.open);
	        }
	
	        this.setState({
	          touchIdentifier: null,
	          touchStartX: null,
	          touchStartY: null,
	          touchCurrentX: null,
	          touchCurrentY: null
	        });
	      }
	    }
	
	    // This logic helps us prevents the user from sliding the sidebar horizontally
	    // while scrolling the sidebar vertically. When a scroll event comes in, we're
	    // cancelling the ongoing gesture if it did not move horizontally much.
	
	  }, {
	    key: 'onScroll',
	    value: function onScroll() {
	      if (this.isTouching() && this.inCancelDistanceOnScroll()) {
	        this.setState({
	          touchIdentifier: null,
	          touchStartX: null,
	          touchStartY: null,
	          touchCurrentX: null,
	          touchCurrentY: null
	        });
	      }
	    }
	
	    // True if the on going gesture X distance is less than the cancel distance
	
	  }, {
	    key: 'inCancelDistanceOnScroll',
	    value: function inCancelDistanceOnScroll() {
	      var cancelDistanceOnScroll = void 0;
	
	      if (this.props.pullRight) {
	        cancelDistanceOnScroll = Math.abs(this.state.touchCurrentX - this.state.touchStartX) < CANCEL_DISTANCE_ON_SCROLL;
	      } else {
	        cancelDistanceOnScroll = Math.abs(this.state.touchStartX - this.state.touchCurrentX) < CANCEL_DISTANCE_ON_SCROLL;
	      }
	      return cancelDistanceOnScroll;
	    }
	  }, {
	    key: 'isTouching',
	    value: function isTouching() {
	      return this.state.touchIdentifier !== null;
	    }
	  }, {
	    key: 'overlayClicked',
	    value: function overlayClicked() {
	      if (this.props.open) {
	        this.props.onSetOpen(false);
	      }
	    }
	  }, {
	    key: 'saveSidebarWidth',
	    value: function saveSidebarWidth() {
	      var width = this.sidebar.offsetWidth;
	
	      if (width !== this.state.sidebarWidth) {
	        this.setState({ sidebarWidth: width });
	      }
	    }
	  }, {
	    key: 'saveSidebarRef',
	    value: function saveSidebarRef(node) {
	      this.sidebar = node;
	    }
	
	    // calculate the sidebarWidth based on current touch info
	
	  }, {
	    key: 'touchSidebarWidth',
	    value: function touchSidebarWidth() {
	      // if the sidebar is open and start point of drag is inside the sidebar
	      // we will only drag the distance they moved their finger
	      // otherwise we will move the sidebar to be below the finger.
	      if (this.props.pullRight) {
	        if (this.props.open && window.innerWidth - this.state.touchStartX < this.state.sidebarWidth) {
	          if (this.state.touchCurrentX > this.state.touchStartX) {
	            return this.state.sidebarWidth + this.state.touchStartX - this.state.touchCurrentX;
	          }
	          return this.state.sidebarWidth;
	        }
	        return Math.min(window.innerWidth - this.state.touchCurrentX, this.state.sidebarWidth);
	      }
	
	      if (this.props.open && this.state.touchStartX < this.state.sidebarWidth) {
	        if (this.state.touchCurrentX > this.state.touchStartX) {
	          return this.state.sidebarWidth;
	        }
	        return this.state.sidebarWidth - this.state.touchStartX + this.state.touchCurrentX;
	      }
	      return Math.min(this.state.touchCurrentX, this.state.sidebarWidth);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var sidebarStyle = _extends({}, defaultStyles.sidebar, this.props.styles.sidebar);
	      var contentStyle = _extends({}, defaultStyles.content, this.props.styles.content);
	      var overlayStyle = _extends({}, defaultStyles.overlay, this.props.styles.overlay);
	      var useTouch = this.state.dragSupported && this.props.touch;
	      var isTouching = this.isTouching();
	      var rootProps = {
	        className: this.props.rootClassName,
	        style: _extends({}, defaultStyles.root, this.props.styles.root),
	        role: "navigation"
	      };
	      var dragHandle = void 0;
	
	      // sidebarStyle right/left
	      if (this.props.pullRight) {
	        sidebarStyle.right = 0;
	        sidebarStyle.transform = 'translateX(100%)';
	        sidebarStyle.WebkitTransform = 'translateX(100%)';
	        if (this.props.shadow) {
	          sidebarStyle.boxShadow = '-2px 2px 4px rgba(0, 0, 0, 0.15)';
	        }
	      } else {
	        sidebarStyle.left = 0;
	        sidebarStyle.transform = 'translateX(-100%)';
	        sidebarStyle.WebkitTransform = 'translateX(-100%)';
	        if (this.props.shadow) {
	          sidebarStyle.boxShadow = '2px 2px 4px rgba(0, 0, 0, 0.15)';
	        }
	      }
	
	      if (isTouching) {
	        var percentage = this.touchSidebarWidth() / this.state.sidebarWidth;
	
	        // slide open to what we dragged
	        if (this.props.pullRight) {
	          sidebarStyle.transform = 'translateX(' + (1 - percentage) * 100 + '%)';
	          sidebarStyle.WebkitTransform = 'translateX(' + (1 - percentage) * 100 + '%)';
	        } else {
	          sidebarStyle.transform = 'translateX(-' + (1 - percentage) * 100 + '%)';
	          sidebarStyle.WebkitTransform = 'translateX(-' + (1 - percentage) * 100 + '%)';
	        }
	
	        // fade overlay to match distance of drag
	        overlayStyle.opacity = percentage;
	        overlayStyle.visibility = 'visible';
	      } else if (this.props.docked) {
	        // show sidebar
	        if (this.state.sidebarWidth !== 0) {
	          sidebarStyle.transform = 'translateX(0%)';
	          sidebarStyle.WebkitTransform = 'translateX(0%)';
	        }
	
	        // make space on the left/right side of the content for the sidebar
	        if (this.props.pullRight) {
	          contentStyle.right = this.state.sidebarWidth + 'px';
	        } else {
	          contentStyle.left = this.state.sidebarWidth + 'px';
	        }
	      } else if (this.props.open) {
	        // slide open sidebar
	        sidebarStyle.transform = 'translateX(0%)';
	        sidebarStyle.WebkitTransform = 'translateX(0%)';
	
	        // show overlay
	        overlayStyle.opacity = 1;
	        overlayStyle.visibility = 'visible';
	      }
	
	      if (isTouching || !this.props.transitions) {
	        sidebarStyle.transition = 'none';
	        sidebarStyle.WebkitTransition = 'none';
	        contentStyle.transition = 'none';
	        overlayStyle.transition = 'none';
	      }
	
	      if (useTouch) {
	        if (this.props.open) {
	          rootProps.onTouchStart = this.onTouchStart;
	          rootProps.onTouchMove = this.onTouchMove;
	          rootProps.onTouchEnd = this.onTouchEnd;
	          rootProps.onTouchCancel = this.onTouchEnd;
	          rootProps.onScroll = this.onScroll;
	        } else {
	          var dragHandleStyle = _extends({}, defaultStyles.dragHandle, this.props.styles.dragHandle);
	          dragHandleStyle.width = this.props.touchHandleWidth;
	
	          // dragHandleStyle right/left
	          if (this.props.pullRight) {
	            dragHandleStyle.right = 0;
	          } else {
	            dragHandleStyle.left = 0;
	          }
	
	          dragHandle = _react2.default.createElement('div', { style: dragHandleStyle,
	            onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove,
	            onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd });
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        rootProps,
	        _react2.default.createElement(
	          'div',
	          { className: this.props.sidebarClassName, style: sidebarStyle, ref: this.saveSidebarRef },
	          this.props.sidebar
	        ),
	        _react2.default.createElement('div', { className: this.props.overlayClassName,
	          style: overlayStyle,
	          role: 'presentation',
	          tabIndex: '0',
	          onClick: this.overlayClicked
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.contentClassName, style: contentStyle },
	          dragHandle,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(_react.Component);
	
	Sidebar.propTypes = {
	  // main content to render
	  children: _propTypes2.default.node.isRequired,
	
	  // styles
	  styles: _propTypes2.default.shape({
	    root: _propTypes2.default.object,
	    sidebar: _propTypes2.default.object,
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object,
	    dragHandle: _propTypes2.default.object
	  }),
	
	  // root component optional class
	  rootClassName: _propTypes2.default.string,
	
	  // sidebar optional class
	  sidebarClassName: _propTypes2.default.string,
	
	  // content optional class
	  contentClassName: _propTypes2.default.string,
	
	  // overlay optional class
	  overlayClassName: _propTypes2.default.string,
	
	  // sidebar content to render
	  sidebar: _propTypes2.default.node.isRequired,
	
	  // boolean if sidebar should be docked
	  docked: _propTypes2.default.bool,
	
	  // boolean if sidebar should slide open
	  open: _propTypes2.default.bool,
	
	  // boolean if transitions should be disabled
	  transitions: _propTypes2.default.bool,
	
	  // boolean if touch gestures are enabled
	  touch: _propTypes2.default.bool,
	
	  // max distance from the edge we can start touching
	  touchHandleWidth: _propTypes2.default.number,
	
	  // Place the sidebar on the right
	  pullRight: _propTypes2.default.bool,
	
	  // Enable/Disable sidebar shadow
	  shadow: _propTypes2.default.bool,
	
	  // distance we have to drag the sidebar to toggle open state
	  dragToggleDistance: _propTypes2.default.number,
	
	  // callback called when the overlay is clicked
	  onSetOpen: _propTypes2.default.func,
	
	  // Intial sidebar width when page loads
	  defaultSidebarWidth: _propTypes2.default.number
	};
	
	Sidebar.defaultProps = {
	  docked: false,
	  open: false,
	  transitions: true,
	  touch: true,
	  touchHandleWidth: 20,
	  pullRight: false,
	  shadow: true,
	  dragToggleDistance: 30,
	  onSetOpen: function onSetOpen() {},
	  styles: {},
	  defaultSidebarWidth: 0
	};
	
	exports.default = Sidebar;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(102);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "0", type: "button" }, prevArrowProps),
	        " ",
	        "Previous"
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "1", type: "button" }, nextArrowProps),
	        " ",
	        "Next"
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement(
	      "ul",
	      { style: { display: "block" } },
	      dots
	    );
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement(
	      "button",
	      null,
	      i + 1
	    );
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(102);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement(
	        "li",
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ },
/* 633 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(633);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(643);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(102);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(101);
	
	var _track = __webpack_require__(636);
	
	var _dots = __webpack_require__(632);
	
	var _arrows = __webpack_require__(630);
	
	var _resizeObserverPolyfill = __webpack_require__(644);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	      // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement(
	        "div",
	        innerSliderProps,
	        !_this.props.unslick ? prevArrow : "",
	        _react2.default.createElement(
	          "div",
	          _extends({ ref: _this.listRefHandler }, listProps),
	          _react2.default.createElement(
	            _track.Track,
	            _extends({ ref: _this.trackRefHandler }, trackProps),
	            _this.props.children
	          )
	        ),
	        !_this.props.unslick ? nextArrow : "",
	        !_this.props.unslick ? dots : ""
	      );
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(634);
	
	var _json2mq = __webpack_require__(641);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(631);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(640);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement(
	          "div",
	          { key: 10 * i + j },
	          row
	        ));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i, style: { width: currentWidth } },
	          newSlide
	        ));
	      } else {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i },
	          newSlide
	        ));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        newChildren
	      );
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(
	      _innerSlider.InnerSlider,
	      _extends({ ref: this.innerSliderRefHandler }, settings),
	      newChildren
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(102);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement(
	      "div",
	      _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents),
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(639);
	var each = __webpack_require__(243).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(637);
	var Util = __webpack_require__(243);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 639 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(638);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(642);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 642 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 643 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _raf = __webpack_require__(647);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_PureComponent) {
	  _inherits(Container, _PureComponent);
	
	  function Container() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Container);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.events = ["resize", "scroll", "touchstart", "touchmove", "touchend", "pageshow", "load"], _this.subscribers = [], _this.rafHandle = null, _this.subscribe = function (handler) {
	      _this.subscribers = _this.subscribers.concat(handler);
	    }, _this.unsubscribe = function (handler) {
	      _this.subscribers = _this.subscribers.filter(function (current) {
	        return current !== handler;
	      });
	    }, _this.notifySubscribers = function (evt) {
	      if (!_this.framePending) {
	        var currentTarget = evt.currentTarget;
	
	
	        _this.rafHandle = (0, _raf2.default)(function () {
	          _this.framePending = false;
	
	          var _this$node$getBoundin = _this.node.getBoundingClientRect(),
	              top = _this$node$getBoundin.top,
	              bottom = _this$node$getBoundin.bottom;
	
	          _this.subscribers.forEach(function (handler) {
	            return handler({
	              distanceFromTop: top,
	              distanceFromBottom: bottom,
	              eventSource: currentTarget === window ? document.body : _this.node
	            });
	          });
	        });
	        _this.framePending = true;
	      }
	    }, _this.getParent = function () {
	      return _this.node;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Container, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        subscribe: this.subscribe,
	        unsubscribe: this.unsubscribe,
	        getParent: this.getParent
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.events.forEach(function (event) {
	        return window.addEventListener(event, _this2.notifySubscribers);
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (this.rafHandle) {
	        _raf2.default.cancel(this.rafHandle);
	        this.rafHandle = null;
	      }
	
	      this.events.forEach(function (event) {
	        return window.removeEventListener(event, _this3.notifySubscribers);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement("div", _extends({}, this.props, {
	        ref: function ref(node) {
	          return _this4.node = node;
	        },
	        onScroll: this.notifySubscribers,
	        onTouchStart: this.notifySubscribers,
	        onTouchMove: this.notifySubscribers,
	        onTouchEnd: this.notifySubscribers
	      }));
	    }
	  }]);
	
	  return Container;
	}(_react.PureComponent);
	
	Container.childContextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Container;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sticky = function (_Component) {
	  _inherits(Sticky, _Component);
	
	  function Sticky() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Sticky);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isSticky: false,
	      wasSticky: false,
	      style: {}
	    }, _this.handleContainerEvent = function (_ref2) {
	      var distanceFromTop = _ref2.distanceFromTop,
	          distanceFromBottom = _ref2.distanceFromBottom,
	          eventSource = _ref2.eventSource;
	
	      var parent = _this.context.getParent();
	
	      var preventingStickyStateChanges = false;
	      if (_this.props.relative) {
	        preventingStickyStateChanges = eventSource !== parent;
	        distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this.placeholder.offsetTop;
	      }
	
	      var placeholderClientRect = _this.placeholder.getBoundingClientRect();
	      var contentClientRect = _this.content.getBoundingClientRect();
	      var calculatedHeight = contentClientRect.height;
	
	      var bottomDifference = distanceFromBottom - _this.props.bottomOffset - calculatedHeight;
	
	      var wasSticky = !!_this.state.isSticky;
	      var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this.props.topOffset && distanceFromBottom > -_this.props.bottomOffset;
	
	      distanceFromBottom = (_this.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;
	
	      var style = !isSticky ? {} : {
	        position: "fixed",
	        top: bottomDifference > 0 ? _this.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference,
	        left: placeholderClientRect.left,
	        width: placeholderClientRect.width
	      };
	
	      if (!_this.props.disableHardwareAcceleration) {
	        style.transform = "translateZ(0)";
	      }
	
	      _this.setState({
	        isSticky: isSticky,
	        wasSticky: wasSticky,
	        distanceFromTop: distanceFromTop,
	        distanceFromBottom: distanceFromBottom,
	        calculatedHeight: calculatedHeight,
	        style: style
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sticky, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");
	
	      this.context.subscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.context.unsubscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + "px";
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var element = _react2.default.cloneElement(this.props.children({
	        isSticky: this.state.isSticky,
	        wasSticky: this.state.wasSticky,
	        distanceFromTop: this.state.distanceFromTop,
	        distanceFromBottom: this.state.distanceFromBottom,
	        calculatedHeight: this.state.calculatedHeight,
	        style: this.state.style
	      }), {
	        ref: function ref(content) {
	          _this2.content = _reactDom2.default.findDOMNode(content);
	        }
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement("div", { ref: function ref(placeholder) {
	            return _this2.placeholder = placeholder;
	          } }),
	        element
	      );
	    }
	  }]);
	
	  return Sticky;
	}(_react.Component);
	
	Sticky.propTypes = {
	  topOffset: _propTypes2.default.number,
	  bottomOffset: _propTypes2.default.number,
	  relative: _propTypes2.default.bool,
	  children: _propTypes2.default.func.isRequired
	};
	Sticky.defaultProps = {
	  relative: false,
	  topOffset: 0,
	  bottomOffset: 0,
	  disableCompensation: false,
	  disableHardwareAcceleration: false
	};
	Sticky.contextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Sticky;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(648)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)))

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(104);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(147);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _pagination = __webpack_require__(652);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	//
	
	
	var emptyObj = function emptyObj() {
	  return {};
	};
	
	exports.default = {
	  // General
	  data: [],
	  resolveData: function resolveData(data) {
	    return data;
	  },
	  loading: false,
	  showPagination: true,
	  showPaginationTop: false,
	  showPaginationBottom: true,
	  showPageSizeOptions: true,
	  pageSizeOptions: [5, 10, 20, 25, 50, 100],
	  defaultPage: 0,
	  defaultPageSize: 20,
	  showPageJump: true,
	  collapseOnSortingChange: true,
	  collapseOnPageChange: true,
	  collapseOnDataChange: true,
	  freezeWhenExpanded: false,
	  sortable: true,
	  multiSort: true,
	  resizable: true,
	  filterable: false,
	  defaultSortDesc: false,
	  defaultSorted: [],
	  defaultFiltered: [],
	  defaultResized: [],
	  defaultExpanded: {},
	  // eslint-disable-next-line no-unused-vars
	  defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
	    var id = filter.pivotId || filter.id;
	    return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
	  },
	  // eslint-disable-next-line no-unused-vars
	  defaultSortMethod: function defaultSortMethod(a, b, desc) {
	    // force null and undefined to the bottom
	    a = a === null || a === undefined ? '' : a;
	    b = b === null || b === undefined ? '' : b;
	    // force any string values to lowercase
	    a = typeof a === 'string' ? a.toLowerCase() : a;
	    b = typeof b === 'string' ? b.toLowerCase() : b;
	    // Return either 1 or -1 to indicate a sort priority
	    if (a > b) {
	      return 1;
	    }
	    if (a < b) {
	      return -1;
	    }
	    // returning 0, undefined or any falsey value will use subsequent sorts or
	    // the index as a tiebreaker
	    return 0;
	  },
	
	  // Controlled State Props
	  // page: undefined,
	  // pageSize: undefined,
	  // sorted: [],
	  // filtered: [],
	  // resized: [],
	  // expanded: {},
	
	  // Controlled State Callbacks
	  onPageChange: undefined,
	  onPageSizeChange: undefined,
	  onSortedChange: undefined,
	  onFilteredChange: undefined,
	  onResizedChange: undefined,
	  onExpandedChange: undefined,
	
	  // Pivoting
	  pivotBy: undefined,
	
	  // Key Constants
	  pivotValKey: '_pivotVal',
	  pivotIDKey: '_pivotID',
	  subRowsKey: '_subRows',
	  aggregatedKey: '_aggregated',
	  nestingLevelKey: '_nestingLevel',
	  originalKey: '_original',
	  indexKey: '_index',
	  groupedByPivotKey: '_groupedByPivot',
	
	  // Server-side Callbacks
	  onFetchData: function onFetchData() {
	    return null;
	  },
	
	  // Classes
	  className: '',
	  style: {},
	
	  // Component decorators
	  getProps: emptyObj,
	  getTableProps: emptyObj,
	  getTheadGroupProps: emptyObj,
	  getTheadGroupTrProps: emptyObj,
	  getTheadGroupThProps: emptyObj,
	  getTheadProps: emptyObj,
	  getTheadTrProps: emptyObj,
	  getTheadThProps: emptyObj,
	  getTheadFilterProps: emptyObj,
	  getTheadFilterTrProps: emptyObj,
	  getTheadFilterThProps: emptyObj,
	  getTbodyProps: emptyObj,
	  getTrGroupProps: emptyObj,
	  getTrProps: emptyObj,
	  getTdProps: emptyObj,
	  getTfootProps: emptyObj,
	  getTfootTrProps: emptyObj,
	  getTfootTdProps: emptyObj,
	  getPaginationProps: emptyObj,
	  getLoadingProps: emptyObj,
	  getNoDataProps: emptyObj,
	  getResizerProps: emptyObj,
	
	  // Global Column Defaults
	  column: {
	    // Renderers
	    Cell: undefined,
	    Header: undefined,
	    Footer: undefined,
	    Aggregated: undefined,
	    Pivot: undefined,
	    PivotValue: undefined,
	    Expander: undefined,
	    Filter: undefined,
	    Placeholder: undefined,
	    // All Columns
	    sortable: undefined, // use table default
	    resizable: undefined, // use table default
	    filterable: undefined, // use table default
	    show: true,
	    minWidth: 100,
	    minResizeWidth: 11,
	    // Cells only
	    className: '',
	    style: {},
	    getProps: emptyObj,
	    // Pivot only
	    aggregate: undefined,
	    // Headers only
	    headerClassName: '',
	    headerStyle: {},
	    getHeaderProps: emptyObj,
	    // Footers only
	    footerClassName: '',
	    footerStyle: {},
	    getFooterProps: emptyObj,
	    filterMethod: undefined,
	    filterAll: false,
	    sortMethod: undefined
	  },
	
	  // Global Expander Column Defaults
	  expanderDefaults: {
	    sortable: false,
	    resizable: false,
	    filterable: false,
	    width: 35
	  },
	
	  pivotDefaults: {
	    // extend the defaults for pivoted columns here
	  },
	
	  // Text
	  previousText: 'Previous',
	  nextText: 'Next',
	  loadingText: 'Loading...',
	  noDataText: 'No rows found',
	  pageText: 'Page',
	  ofText: 'of',
	  rowsText: 'rows',
	  pageJumpText: 'jump to page',
	  rowsSelectorText: 'rows per page',
	
	  // Components
	  TableComponent: function TableComponent(_ref) {
	    var children = _ref.children,
	        className = _ref.className,
	        rest = _objectWithoutProperties(_ref, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({
	        className: (0, _classnames2.default)('rt-table', className),
	        role: 'grid'
	        // tabIndex='0'
	      }, rest),
	      children
	    );
	  },
	  TheadComponent: _utils2.default.makeTemplateComponent('rt-thead', 'Thead'),
	  TbodyComponent: _utils2.default.makeTemplateComponent('rt-tbody', 'Tbody'),
	  TrGroupComponent: function TrGroupComponent(_ref2) {
	    var children = _ref2.children,
	        className = _ref2.className,
	        rest = _objectWithoutProperties(_ref2, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-tr-group', className), role: 'rowgroup' }, rest),
	      children
	    );
	  },
	  TrComponent: function TrComponent(_ref3) {
	    var children = _ref3.children,
	        className = _ref3.className,
	        rest = _objectWithoutProperties(_ref3, ['children', 'className']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-tr', className), role: 'row' }, rest),
	      children
	    );
	  },
	  ThComponent: function ThComponent(_ref4) {
	    var toggleSort = _ref4.toggleSort,
	        className = _ref4.className,
	        children = _ref4.children,
	        rest = _objectWithoutProperties(_ref4, ['toggleSort', 'className', 'children']);
	
	    return (
	      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
	      _react2.default.createElement(
	        'div',
	        _extends({
	          className: (0, _classnames2.default)('rt-th', className),
	          onClick: function onClick(e) {
	            return toggleSort && toggleSort(e);
	          },
	          role: 'columnheader',
	          tabIndex: '-1' // Resolves eslint issues without implementing keyboard navigation incorrectly
	        }, rest),
	        children
	      )
	    );
	  },
	  TdComponent: function TdComponent(_ref5) {
	    var toggleSort = _ref5.toggleSort,
	        className = _ref5.className,
	        children = _ref5.children,
	        rest = _objectWithoutProperties(_ref5, ['toggleSort', 'className', 'children']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('rt-td', className), role: 'gridcell' }, rest),
	      children
	    );
	  },
	  TfootComponent: _utils2.default.makeTemplateComponent('rt-tfoot', 'Tfoot'),
	  FilterComponent: function FilterComponent(_ref6) {
	    var filter = _ref6.filter,
	        _onChange = _ref6.onChange,
	        column = _ref6.column;
	    return _react2.default.createElement('input', {
	      type: 'text',
	      style: {
	        width: '100%'
	      },
	      placeholder: column.Placeholder,
	      value: filter ? filter.value : '',
	      onChange: function onChange(event) {
	        return _onChange(event.target.value);
	      }
	    });
	  },
	  ExpanderComponent: function ExpanderComponent(_ref7) {
	    var isExpanded = _ref7.isExpanded;
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('rt-expander', isExpanded && '-open') },
	      '\u2022'
	    );
	  },
	  PivotValueComponent: function PivotValueComponent(_ref8) {
	    var subRows = _ref8.subRows,
	        value = _ref8.value;
	    return _react2.default.createElement(
	      'span',
	      null,
	      value,
	      ' ',
	      subRows && '(' + subRows.length + ')'
	    );
	  },
	  AggregatedComponent: function AggregatedComponent(_ref9) {
	    var subRows = _ref9.subRows,
	        column = _ref9.column;
	
	    var previewValues = subRows.filter(function (d) {
	      return typeof d[column.id] !== 'undefined';
	    }).map(function (row, i) {
	      return (
	        // eslint-disable-next-line react/no-array-index-key
	        _react2.default.createElement(
	          'span',
	          { key: i },
	          row[column.id],
	          i < subRows.length - 1 ? ', ' : ''
	        )
	      );
	    });
	    return _react2.default.createElement(
	      'span',
	      null,
	      previewValues
	    );
	  },
	  PivotComponent: undefined, // this is a computed default generated using
	  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
	  PaginationComponent: _pagination2.default,
	  PreviousComponent: undefined,
	  NextComponent: undefined,
	  LoadingComponent: function LoadingComponent(_ref10) {
	    var className = _ref10.className,
	        loading = _ref10.loading,
	        loadingText = _ref10.loadingText,
	        rest = _objectWithoutProperties(_ref10, ['className', 'loading', 'loadingText']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('-loading', { '-active': loading }, className) }, rest),
	      _react2.default.createElement(
	        'div',
	        { className: '-loading-inner' },
	        loadingText
	      )
	    );
	  },
	  NoDataComponent: _utils2.default.makeTemplateComponent('rt-noData', 'NoData'),
	  ResizerComponent: _utils2.default.makeTemplateComponent('rt-resizer', 'Resizer'),
	  PadRowComponent: function PadRowComponent() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      '\xA0'
	    );
	  }
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 650 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Base) {
	  return function (_Base) {
	    _inherits(_class, _Base);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.setStateWithData(this.getDataModel(this.getResolvedState(), true));
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.fireFetchData();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps, nextState) {
	        var oldState = this.getResolvedState();
	        var newState = this.getResolvedState(nextProps, nextState);
	
	        // Do a deep compare of new and old `defaultOption` and
	        // if they are different reset `option = defaultOption`
	        var defaultableOptions = ['sorted', 'filtered', 'resized', 'expanded'];
	        defaultableOptions.forEach(function (x) {
	          var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));
	          if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) {
	            newState[x] = newState[defaultName];
	          }
	        });
	
	        // If they change these table options, we need to reset defaults
	        // or else we could get into a state where the user has changed the UI
	        // and then disabled the ability to change it back.
	        // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
	        var resettableOptions = ['sortable', 'filterable', 'resizable'];
	        resettableOptions.forEach(function (x) {
	          if (oldState[x] !== newState[x]) {
	            var baseName = x.replace('able', '');
	            var optionName = baseName + 'ed';
	            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
	            newState[optionName] = newState[defaultName];
	          }
	        });
	
	        // Props that trigger a data update
	        if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) {
	          this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
	        }
	      }
	    }, {
	      key: 'setStateWithData',
	      value: function setStateWithData(newState, cb) {
	        var _this2 = this;
	
	        var oldState = this.getResolvedState();
	        var newResolvedState = this.getResolvedState({}, newState);
	        var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;
	
	        // Default to unfrozen state
	
	        newResolvedState.frozen = false;
	
	        // If freezeWhenExpanded is set, check for frozen conditions
	        if (freezeWhenExpanded) {
	          // if any rows are expanded, freeze the existing data and sorting
	          var keys = Object.keys(newResolvedState.expanded);
	          for (var i = 0; i < keys.length; i += 1) {
	            if (newResolvedState.expanded[keys[i]]) {
	              newResolvedState.frozen = true;
	              break;
	            }
	          }
	        }
	
	        // If the data isn't frozen and either the data or
	        // sorting model has changed, update the data
	        if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
	          // Handle collapseOnsortedChange & collapseOnDataChange
	          if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) {
	            newResolvedState.expanded = {};
	          }
	
	          Object.assign(newResolvedState, this.getSortedData(newResolvedState));
	        }
	
	        // Set page to 0 if filters change
	        if (oldState.filtered !== newResolvedState.filtered) {
	          newResolvedState.page = 0;
	        }
	
	        // Calculate pageSize all the time
	        if (newResolvedState.sortedData) {
	          newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
	          newResolvedState.page = newResolvedState.manual ? newResolvedState.page : Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
	        }
	
	        return this.setState(newResolvedState, function () {
	          if (cb) {
	            cb();
	          }
	          if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) {
	            _this2.fireFetchData();
	          }
	        });
	      }
	    }]);
	
	    return _class;
	  }(Base);
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(147);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (Base) {
	  return function (_Base) {
	    _inherits(_class, _Base);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'getResolvedState',
	      value: function getResolvedState(props, state) {
	        var resolvedState = _extends({}, _utils2.default.compactObject(this.state), _utils2.default.compactObject(this.props), _utils2.default.compactObject(state), _utils2.default.compactObject(props));
	        return resolvedState;
	      }
	    }, {
	      key: 'getDataModel',
	      value: function getDataModel(newState, dataChanged) {
	        var _this2 = this;
	
	        var columns = newState.columns,
	            _newState$pivotBy = newState.pivotBy,
	            pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy,
	            data = newState.data,
	            resolveData = newState.resolveData,
	            pivotIDKey = newState.pivotIDKey,
	            pivotValKey = newState.pivotValKey,
	            subRowsKey = newState.subRowsKey,
	            aggregatedKey = newState.aggregatedKey,
	            nestingLevelKey = newState.nestingLevelKey,
	            originalKey = newState.originalKey,
	            indexKey = newState.indexKey,
	            groupedByPivotKey = newState.groupedByPivotKey,
	            SubComponent = newState.SubComponent;
	
	        // Determine Header Groups
	
	        var hasHeaderGroups = false;
	        columns.forEach(function (column) {
	          if (column.columns) {
	            hasHeaderGroups = true;
	          }
	        });
	
	        var columnsWithExpander = [].concat(_toConsumableArray(columns));
	
	        var expanderColumn = columns.find(function (col) {
	          return col.expander || col.columns && col.columns.some(function (col2) {
	            return col2.expander;
	          });
	        });
	        // The actual expander might be in the columns field of a group column
	        if (expanderColumn && !expanderColumn.expander) {
	          expanderColumn = expanderColumn.columns.find(function (col) {
	            return col.expander;
	          });
	        }
	
	        // If we have SubComponent's we need to make sure we have an expander column
	        if (SubComponent && !expanderColumn) {
	          expanderColumn = { expander: true };
	          columnsWithExpander = [expanderColumn].concat(_toConsumableArray(columnsWithExpander));
	        }
	
	        var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
	          var dcol = void 0;
	          if (column.expander) {
	            dcol = _extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
	          } else {
	            dcol = _extends({}, _this2.props.column, column);
	          }
	
	          // Ensure minWidth is not greater than maxWidth if set
	          if (dcol.maxWidth < dcol.minWidth) {
	            dcol.minWidth = dcol.maxWidth;
	          }
	
	          if (parentColumn) {
	            dcol.parentColumn = parentColumn;
	          }
	
	          // First check for string accessor
	          if (typeof dcol.accessor === 'string') {
	            dcol.id = dcol.id || dcol.accessor;
	            var accessorString = dcol.accessor;
	            dcol.accessor = function (row) {
	              return _utils2.default.get(row, accessorString);
	            };
	            return dcol;
	          }
	
	          // Fall back to functional accessor (but require an ID)
	          if (dcol.accessor && !dcol.id) {
	            console.warn(dcol);
	            throw new Error('A column id is required if using a non-string accessor for column above.');
	          }
	
	          // Fall back to an undefined accessor
	          if (!dcol.accessor) {
	            dcol.accessor = function () {
	              return undefined;
	            };
	          }
	
	          return dcol;
	        };
	
	        var allDecoratedColumns = [];
	
	        // Decorate the columns
	        var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
	          var decoratedColumn = makeDecoratedColumn(column, parentColumn);
	          allDecoratedColumns.push(decoratedColumn);
	          return decoratedColumn;
	        };
	
	        var decoratedColumns = columnsWithExpander.map(function (column) {
	          if (column.columns) {
	            return _extends({}, column, {
	              columns: column.columns.map(function (d) {
	                return decorateAndAddToAll(d, column);
	              })
	            });
	          }
	          return decorateAndAddToAll(column);
	        });
	
	        // Build the visible columns, headers and flat column list
	        var visibleColumns = decoratedColumns.slice();
	        var allVisibleColumns = [];
	
	        visibleColumns = visibleColumns.map(function (column) {
	          if (column.columns) {
	            var visibleSubColumns = column.columns.filter(function (d) {
	              return pivotBy.indexOf(d.id) > -1 ? false : _utils2.default.getFirstDefined(d.show, true);
	            });
	            return _extends({}, column, {
	              columns: visibleSubColumns
	            });
	          }
	          return column;
	        });
	
	        visibleColumns = visibleColumns.filter(function (column) {
	          return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : _utils2.default.getFirstDefined(column.show, true);
	        });
	
	        // Find any custom pivot location
	        var pivotIndex = visibleColumns.findIndex(function (col) {
	          return col.pivot;
	        });
	
	        // Handle Pivot Columns
	        if (pivotBy.length) {
	          // Retrieve the pivot columns in the correct pivot order
	          var pivotColumns = [];
	          pivotBy.forEach(function (pivotID) {
	            var found = allDecoratedColumns.find(function (d) {
	              return d.id === pivotID;
	            });
	            if (found) {
	              pivotColumns.push(found);
	            }
	          });
	
	          var PivotParentColumn = pivotColumns.reduce(function (prev, current) {
	            return prev && prev === current.parentColumn && current.parentColumn;
	          }, pivotColumns[0].parentColumn);
	
	          var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
	          PivotGroupHeader = PivotGroupHeader || function () {
	            return _react2.default.createElement(
	              'strong',
	              null,
	              'Pivoted'
	            );
	          };
	
	          var pivotColumnGroup = {
	            Header: PivotGroupHeader,
	            columns: pivotColumns.map(function (col) {
	              return _extends({}, _this2.props.pivotDefaults, col, {
	                pivoted: true
	              });
	            })
	
	            // Place the pivotColumns back into the visibleColumns
	          };if (pivotIndex >= 0) {
	            pivotColumnGroup = _extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
	            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
	          } else {
	            visibleColumns.unshift(pivotColumnGroup);
	          }
	        }
	
	        // Build Header Groups
	        var headerGroups = [];
	        var currentSpan = [];
	
	        // A convenience function to add a header and reset the currentSpan
	        var addHeader = function addHeader(columns, column) {
	          headerGroups.push(_extends({}, _this2.props.column, column, {
	            columns: columns
	          }));
	          currentSpan = [];
	        };
	
	        // Build flast list of allVisibleColumns and HeaderGroups
	        visibleColumns.forEach(function (column) {
	          if (column.columns) {
	            allVisibleColumns = allVisibleColumns.concat(column.columns);
	            if (currentSpan.length > 0) {
	              addHeader(currentSpan);
	            }
	            addHeader(column.columns, column);
	            return;
	          }
	          allVisibleColumns.push(column);
	          currentSpan.push(column);
	        });
	        if (hasHeaderGroups && currentSpan.length > 0) {
	          addHeader(currentSpan);
	        }
	
	        // Access the data
	        var accessRow = function accessRow(d, i) {
	          var _row;
	
	          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	          var row = (_row = {}, _defineProperty(_row, originalKey, d), _defineProperty(_row, indexKey, i), _defineProperty(_row, subRowsKey, d[subRowsKey]), _defineProperty(_row, nestingLevelKey, level), _row);
	          allDecoratedColumns.forEach(function (column) {
	            if (column.expander) return;
	            row[column.id] = column.accessor(d);
	          });
	          if (row[subRowsKey]) {
	            row[subRowsKey] = row[subRowsKey].map(function (d, i) {
	              return accessRow(d, i, level + 1);
	            });
	          }
	          return row;
	        };
	
	        // // If the data hasn't changed, just use the cached data
	        var resolvedData = this.resolvedData;
	        // If the data has changed, run the data resolver and cache the result
	        if (!this.resolvedData || dataChanged) {
	          resolvedData = resolveData(data);
	          this.resolvedData = resolvedData;
	        }
	        // Use the resolved data
	        resolvedData = resolvedData.map(function (d, i) {
	          return accessRow(d, i);
	        });
	
	        // TODO: Make it possible to fabricate nested rows without pivoting
	        var aggregatingColumns = allVisibleColumns.filter(function (d) {
	          return !d.expander && d.aggregate;
	        });
	
	        // If pivoting, recursively group the data
	        var aggregate = function aggregate(rows) {
	          var aggregationValues = {};
	          aggregatingColumns.forEach(function (column) {
	            var values = rows.map(function (d) {
	              return d[column.id];
	            });
	            aggregationValues[column.id] = column.aggregate(values, rows);
	          });
	          return aggregationValues;
	        };
	        if (pivotBy.length) {
	          var groupRecursively = function groupRecursively(rows, keys) {
	            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	            // This is the last level, just return the rows
	            if (i === keys.length) {
	              return rows;
	            }
	            // Group the rows together for this level
	            var groupedRows = Object.entries(_utils2.default.groupBy(rows, keys[i])).map(function (_ref) {
	              var _ref3;
	
	              var _ref2 = _slicedToArray(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];
	
	              return _ref3 = {}, _defineProperty(_ref3, pivotIDKey, keys[i]), _defineProperty(_ref3, pivotValKey, key), _defineProperty(_ref3, keys[i], key), _defineProperty(_ref3, subRowsKey, value), _defineProperty(_ref3, nestingLevelKey, i), _defineProperty(_ref3, groupedByPivotKey, true), _ref3;
	            });
	            // Recurse into the subRows
	            groupedRows = groupedRows.map(function (rowGroup) {
	              var _extends2;
	
	              var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
	              return _extends({}, rowGroup, (_extends2 = {}, _defineProperty(_extends2, subRowsKey, subRows), _defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
	            });
	            return groupedRows;
	          };
	          resolvedData = groupRecursively(resolvedData, pivotBy);
	        }
	
	        return _extends({}, newState, {
	          resolvedData: resolvedData,
	          allVisibleColumns: allVisibleColumns,
	          headerGroups: headerGroups,
	          allDecoratedColumns: allDecoratedColumns,
	          hasHeaderGroups: hasHeaderGroups
	        });
	      }
	    }, {
	      key: 'getSortedData',
	      value: function getSortedData(resolvedState) {
	        var manual = resolvedState.manual,
	            sorted = resolvedState.sorted,
	            filtered = resolvedState.filtered,
	            defaultFilterMethod = resolvedState.defaultFilterMethod,
	            resolvedData = resolvedState.resolvedData,
	            allDecoratedColumns = resolvedState.allDecoratedColumns;
	
	
	        var sortMethodsByColumnID = {};
	
	        allDecoratedColumns.filter(function (col) {
	          return col.sortMethod;
	        }).forEach(function (col) {
	          sortMethodsByColumnID[col.id] = col.sortMethod;
	        });
	
	        // Resolve the data from either manual data or sorted data
	        return {
	          sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allDecoratedColumns), sorted, sortMethodsByColumnID)
	        };
	      }
	    }, {
	      key: 'fireFetchData',
	      value: function fireFetchData() {
	        // determine the current state, preferring certain state values over props
	        var currentState = _extends({}, this.getResolvedState(), {
	          page: this.getStateOrProp('page'),
	          pageSize: this.getStateOrProp('pageSize'),
	          filter: this.getStateOrProp('filter')
	        });
	
	        this.props.onFetchData(currentState, this);
	      }
	    }, {
	      key: 'getPropOrState',
	      value: function getPropOrState(key) {
	        return _utils2.default.getFirstDefined(this.props[key], this.state[key]);
	      }
	    }, {
	      key: 'getStateOrProp',
	      value: function getStateOrProp(key) {
	        return _utils2.default.getFirstDefined(this.state[key], this.props[key]);
	      }
	    }, {
	      key: 'filterData',
	      value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
	        var _this3 = this;
	
	        var filteredData = data;
	
	        if (filtered.length) {
	          filteredData = filtered.reduce(function (filteredSoFar, nextFilter) {
	            var column = allVisibleColumns.find(function (x) {
	              return x.id === nextFilter.id;
	            });
	
	            // Don't filter hidden columns or columns that have had their filters disabled
	            if (!column || column.filterable === false) {
	              return filteredSoFar;
	            }
	
	            var filterMethod = column.filterMethod || defaultFilterMethod;
	
	            // If 'filterAll' is set to true, pass the entire dataset to the filter method
	            if (column.filterAll) {
	              return filterMethod(nextFilter, filteredSoFar, column);
	            }
	            return filteredSoFar.filter(function (row) {
	              return filterMethod(nextFilter, row, column);
	            });
	          }, filteredData);
	
	          // Apply the filter to the subrows if we are pivoting, and then
	          // filter any rows without subcolumns because it would be strange to show
	          filteredData = filteredData.map(function (row) {
	            if (!row[_this3.props.subRowsKey]) {
	              return row;
	            }
	            return _extends({}, row, _defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
	          }).filter(function (row) {
	            if (!row[_this3.props.subRowsKey]) {
	              return true;
	            }
	            return row[_this3.props.subRowsKey].length > 0;
	          });
	        }
	
	        return filteredData;
	      }
	    }, {
	      key: 'sortData',
	      value: function sortData(data, sorted) {
	        var _this4 = this;
	
	        var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        if (!sorted.length) {
	          return data;
	        }
	
	        var sortedData = (this.props.orderByMethod || _utils2.default.orderBy)(data, sorted.map(function (sort) {
	          // Support custom sorting methods for each column
	          if (sortMethodsByColumnID[sort.id]) {
	            return function (a, b) {
	              return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
	            };
	          }
	          return function (a, b) {
	            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
	          };
	        }), sorted.map(function (d) {
	          return !d.desc;
	        }), this.props.indexKey);
	
	        sortedData.forEach(function (row) {
	          if (!row[_this4.props.subRowsKey]) {
	            return;
	          }
	          row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
	        });
	
	        return sortedData;
	      }
	    }, {
	      key: 'getMinRows',
	      value: function getMinRows() {
	        return _utils2.default.getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
	      }
	
	      // User actions
	
	    }, {
	      key: 'onPageChange',
	      value: function onPageChange(page) {
	        var _props = this.props,
	            onPageChange = _props.onPageChange,
	            collapseOnPageChange = _props.collapseOnPageChange;
	
	
	        var newState = { page: page };
	        if (collapseOnPageChange) {
	          newState.expanded = {};
	        }
	        this.setStateWithData(newState, function () {
	          return onPageChange && onPageChange(page);
	        });
	      }
	    }, {
	      key: 'onPageSizeChange',
	      value: function onPageSizeChange(newPageSize) {
	        var onPageSizeChange = this.props.onPageSizeChange;
	
	        var _getResolvedState = this.getResolvedState(),
	            pageSize = _getResolvedState.pageSize,
	            page = _getResolvedState.page;
	
	        // Normalize the page to display
	
	
	        var currentRow = pageSize * page;
	        var newPage = Math.floor(currentRow / newPageSize);
	
	        this.setStateWithData({
	          pageSize: newPageSize,
	          page: newPage
	        }, function () {
	          return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
	        });
	      }
	    }, {
	      key: 'sortColumn',
	      value: function sortColumn(column, additive) {
	        var _getResolvedState2 = this.getResolvedState(),
	            sorted = _getResolvedState2.sorted,
	            skipNextSort = _getResolvedState2.skipNextSort,
	            defaultSortDesc = _getResolvedState2.defaultSortDesc;
	
	        var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
	        var secondSortDirection = !firstSortDirection;
	
	        // we can't stop event propagation from the column resize move handlers
	        // attached to the document because of react's synthetic events
	        // so we have to prevent the sort function from actually sorting
	        // if we click on the column resize element within a header.
	        if (skipNextSort) {
	          this.setStateWithData({
	            skipNextSort: false
	          });
	          return;
	        }
	
	        var onSortedChange = this.props.onSortedChange;
	
	
	        var newSorted = _utils2.default.clone(sorted || []).map(function (d) {
	          d.desc = _utils2.default.isSortingDesc(d);
	          return d;
	        });
	        if (!_utils2.default.isArray(column)) {
	          // Single-Sort
	          var existingIndex = newSorted.findIndex(function (d) {
	            return d.id === column.id;
	          });
	          if (existingIndex > -1) {
	            var existing = newSorted[existingIndex];
	            if (existing.desc === secondSortDirection) {
	              if (additive) {
	                newSorted.splice(existingIndex, 1);
	              } else {
	                existing.desc = firstSortDirection;
	                newSorted = [existing];
	              }
	            } else {
	              existing.desc = secondSortDirection;
	              if (!additive) {
	                newSorted = [existing];
	              }
	            }
	          } else if (additive) {
	            newSorted.push({
	              id: column.id,
	              desc: firstSortDirection
	            });
	          } else {
	            newSorted = [{
	              id: column.id,
	              desc: firstSortDirection
	            }];
	          }
	        } else {
	          // Multi-Sort
	          var _existingIndex = newSorted.findIndex(function (d) {
	            return d.id === column[0].id;
	          });
	          // Existing Sorted Column
	          if (_existingIndex > -1) {
	            var _existing = newSorted[_existingIndex];
	            if (_existing.desc === secondSortDirection) {
	              if (additive) {
	                newSorted.splice(_existingIndex, column.length);
	              } else {
	                column.forEach(function (d, i) {
	                  newSorted[_existingIndex + i].desc = firstSortDirection;
	                });
	              }
	            } else {
	              column.forEach(function (d, i) {
	                newSorted[_existingIndex + i].desc = secondSortDirection;
	              });
	            }
	            if (!additive) {
	              newSorted = newSorted.slice(_existingIndex, column.length);
	            }
	            // New Sort Column
	          } else if (additive) {
	            newSorted = newSorted.concat(column.map(function (d) {
	              return {
	                id: d.id,
	                desc: firstSortDirection
	              };
	            }));
	          } else {
	            newSorted = column.map(function (d) {
	              return {
	                id: d.id,
	                desc: firstSortDirection
	              };
	            });
	          }
	        }
	
	        this.setStateWithData({
	          page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
	          sorted: newSorted
	        }, function () {
	          return onSortedChange && onSortedChange(newSorted, column, additive);
	        });
	      }
	    }, {
	      key: 'filterColumn',
	      value: function filterColumn(column, value) {
	        var _getResolvedState3 = this.getResolvedState(),
	            filtered = _getResolvedState3.filtered;
	
	        var onFilteredChange = this.props.onFilteredChange;
	
	        // Remove old filter first if it exists
	
	        var newFiltering = (filtered || []).filter(function (x) {
	          return x.id !== column.id;
	        });
	
	        if (value !== '') {
	          newFiltering.push({
	            id: column.id,
	            value: value
	          });
	        }
	
	        this.setStateWithData({
	          filtered: newFiltering
	        }, function () {
	          return onFilteredChange && onFilteredChange(newFiltering, column, value);
	        });
	      }
	    }, {
	      key: 'resizeColumnStart',
	      value: function resizeColumnStart(event, column, isTouch) {
	        var _this5 = this;
	
	        event.stopPropagation();
	        var parentWidth = event.target.parentElement.getBoundingClientRect().width;
	
	        var pageX = void 0;
	        if (isTouch) {
	          pageX = event.changedTouches[0].pageX;
	        } else {
	          pageX = event.pageX;
	        }
	
	        this.trapEvents = true;
	        this.setStateWithData({
	          currentlyResizing: {
	            id: column.id,
	            startX: pageX,
	            parentWidth: parentWidth
	          }
	        }, function () {
	          if (isTouch) {
	            document.addEventListener('touchmove', _this5.resizeColumnMoving);
	            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
	            document.addEventListener('touchend', _this5.resizeColumnEnd);
	          } else {
	            document.addEventListener('mousemove', _this5.resizeColumnMoving);
	            document.addEventListener('mouseup', _this5.resizeColumnEnd);
	            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
	          }
	        });
	      }
	    }, {
	      key: 'resizeColumnMoving',
	      value: function resizeColumnMoving(event) {
	        event.stopPropagation();
	        var _props2 = this.props,
	            onResizedChange = _props2.onResizedChange,
	            column = _props2.column;
	
	        var _getResolvedState4 = this.getResolvedState(),
	            resized = _getResolvedState4.resized,
	            currentlyResizing = _getResolvedState4.currentlyResizing,
	            columns = _getResolvedState4.columns;
	
	        var currentColumn = columns.find(function (c) {
	          return c.accessor === currentlyResizing.id || c.id === currentlyResizing.id;
	        });
	        var minResizeWidth = currentColumn && currentColumn.minResizeWidth != null ? currentColumn.minResizeWidth : column.minResizeWidth;
	
	        // Delete old value
	        var newResized = resized.filter(function (x) {
	          return x.id !== currentlyResizing.id;
	        });
	
	        var pageX = void 0;
	
	        if (event.type === 'touchmove') {
	          pageX = event.changedTouches[0].pageX;
	        } else if (event.type === 'mousemove') {
	          pageX = event.pageX;
	        }
	
	        var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, minResizeWidth);
	
	        newResized.push({
	          id: currentlyResizing.id,
	          value: newWidth
	        });
	
	        this.setStateWithData({
	          resized: newResized
	        }, function () {
	          return onResizedChange && onResizedChange(newResized, event);
	        });
	      }
	    }, {
	      key: 'resizeColumnEnd',
	      value: function resizeColumnEnd(event) {
	        event.stopPropagation();
	        var isTouch = event.type === 'touchend' || event.type === 'touchcancel';
	
	        if (isTouch) {
	          document.removeEventListener('touchmove', this.resizeColumnMoving);
	          document.removeEventListener('touchcancel', this.resizeColumnEnd);
	          document.removeEventListener('touchend', this.resizeColumnEnd);
	        }
	
	        // If its a touch event clear the mouse one's as well because sometimes
	        // the mouseDown event gets called as well, but the mouseUp event doesn't
	        document.removeEventListener('mousemove', this.resizeColumnMoving);
	        document.removeEventListener('mouseup', this.resizeColumnEnd);
	        document.removeEventListener('mouseleave', this.resizeColumnEnd);
	
	        // The touch events don't propagate up to the sorting's onMouseDown event so
	        // no need to prevent it from happening or else the first click after a touch
	        // event resize will not sort the column.
	        if (!isTouch) {
	          this.setStateWithData({
	            skipNextSort: true,
	            currentlyResizing: false
	          });
	        }
	      }
	    }]);
	
	    return _class;
	  }(Base);
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(104);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultButton = function defaultButton(props) {
	  return _react2.default.createElement(
	    'button',
	    _extends({ type: 'button' }, props, { className: '-btn' }),
	    props.children
	  );
	};
	
	var ReactTablePagination = function (_Component) {
	  _inherits(ReactTablePagination, _Component);
	
	  function ReactTablePagination(props) {
	    _classCallCheck(this, ReactTablePagination);
	
	    var _this = _possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this, props));
	
	    _this.getSafePage = _this.getSafePage.bind(_this);
	    _this.changePage = _this.changePage.bind(_this);
	    _this.applyPage = _this.applyPage.bind(_this);
	
	    _this.state = {
	      page: props.page
	    };
	    return _this;
	  }
	
	  _createClass(ReactTablePagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.page !== nextProps.page) {
	        this.setState({ page: nextProps.page });
	      }
	    }
	  }, {
	    key: 'getSafePage',
	    value: function getSafePage(page) {
	      if (Number.isNaN(page)) {
	        page = this.props.page;
	      }
	      return Math.min(Math.max(page, 0), this.props.pages - 1);
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(page) {
	      page = this.getSafePage(page);
	      this.setState({ page: page });
	      if (this.props.page !== page) {
	        this.props.onPageChange(page);
	      }
	    }
	  }, {
	    key: 'applyPage',
	    value: function applyPage(e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var page = this.state.page;
	      this.changePage(page === '' ? this.props.page : page);
	    }
	  }, {
	    key: 'getPageJumpProperties',
	    value: function getPageJumpProperties() {
	      var _this2 = this;
	
	      return {
	        onKeyPress: function onKeyPress(e) {
	          if (e.which === 13 || e.keyCode === 13) {
	            _this2.applyPage();
	          }
	        },
	        onBlur: this.applyPage,
	        value: this.state.page === '' ? '' : this.state.page + 1,
	        onChange: function onChange(e) {
	          var val = e.target.value;
	          var page = val - 1;
	          if (val === '') {
	            return _this2.setState({ page: val });
	          }
	          _this2.setState({ page: _this2.getSafePage(page) });
	        },
	        inputType: this.state.page === '' ? 'text' : 'number',
	        pageJumpText: this.props.pageJumpText
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          pages = _props.pages,
	          page = _props.page,
	          showPageSizeOptions = _props.showPageSizeOptions,
	          pageSizeOptions = _props.pageSizeOptions,
	          pageSize = _props.pageSize,
	          showPageJump = _props.showPageJump,
	          canPrevious = _props.canPrevious,
	          canNext = _props.canNext,
	          onPageSizeChange = _props.onPageSizeChange,
	          className = _props.className,
	          PreviousComponent = _props.PreviousComponent,
	          NextComponent = _props.NextComponent,
	          renderPageJump = _props.renderPageJump,
	          renderCurrentPage = _props.renderCurrentPage,
	          renderTotalPagesCount = _props.renderTotalPagesCount,
	          renderPageSizeOptions = _props.renderPageSizeOptions;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, '-pagination'), style: this.props.style },
	        _react2.default.createElement(
	          'div',
	          { className: '-previous' },
	          _react2.default.createElement(
	            PreviousComponent,
	            {
	              onClick: function onClick() {
	                if (!canPrevious) return;
	                _this3.changePage(page - 1);
	              },
	              disabled: !canPrevious
	            },
	            this.props.previousText
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '-center' },
	          _react2.default.createElement(
	            'span',
	            { className: '-pageInfo' },
	            this.props.pageText,
	            ' ',
	            showPageJump ? renderPageJump(this.getPageJumpProperties()) : renderCurrentPage(page),
	            ' ',
	            this.props.ofText,
	            ' ',
	            renderTotalPagesCount(pages)
	          ),
	          showPageSizeOptions && renderPageSizeOptions({
	            pageSize: pageSize,
	            rowsSelectorText: this.props.rowsSelectorText,
	            pageSizeOptions: pageSizeOptions,
	            onPageSizeChange: onPageSizeChange,
	            rowsText: this.props.rowsText
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '-next' },
	          _react2.default.createElement(
	            NextComponent,
	            {
	              onClick: function onClick() {
	                if (!canNext) return;
	                _this3.changePage(page + 1);
	              },
	              disabled: !canNext
	            },
	            this.props.nextText
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReactTablePagination;
	}(_react.Component);
	
	ReactTablePagination.defaultProps = {
	  PreviousComponent: defaultButton,
	  NextComponent: defaultButton,
	  renderPageJump: function renderPageJump(_ref) {
	    var onChange = _ref.onChange,
	        value = _ref.value,
	        onBlur = _ref.onBlur,
	        onKeyPress = _ref.onKeyPress,
	        inputType = _ref.inputType,
	        pageJumpText = _ref.pageJumpText;
	    return _react2.default.createElement(
	      'div',
	      { className: '-pageJump' },
	      _react2.default.createElement('input', {
	        'aria-label': pageJumpText,
	        type: inputType,
	        onChange: onChange,
	        value: value,
	        onBlur: onBlur,
	        onKeyPress: onKeyPress
	      })
	    );
	  },
	  renderCurrentPage: function renderCurrentPage(page) {
	    return _react2.default.createElement(
	      'span',
	      { className: '-currentPage' },
	      page + 1
	    );
	  },
	  renderTotalPagesCount: function renderTotalPagesCount(pages) {
	    return _react2.default.createElement(
	      'span',
	      { className: '-totalPages' },
	      pages || 1
	    );
	  },
	  renderPageSizeOptions: function renderPageSizeOptions(_ref2) {
	    var pageSize = _ref2.pageSize,
	        pageSizeOptions = _ref2.pageSizeOptions,
	        rowsSelectorText = _ref2.rowsSelectorText,
	        onPageSizeChange = _ref2.onPageSizeChange,
	        rowsText = _ref2.rowsText;
	    return _react2.default.createElement(
	      'span',
	      { className: 'select-wrap -pageSizeOptions' },
	      _react2.default.createElement(
	        'select',
	        {
	          'aria-label': rowsSelectorText,
	          onChange: function onChange(e) {
	            return onPageSizeChange(Number(e.target.value));
	          },
	          value: pageSize
	        },
	        pageSizeOptions.map(function (option, i) {
	          return (
	            // eslint-disable-next-line react/no-array-index-key
	            _react2.default.createElement(
	              'option',
	              { key: i, value: option },
	              option + ' ' + rowsText
	            )
	          );
	        })
	      )
	    );
	  }
	};
	exports.default = ReactTablePagination;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  // General
	  data: _propTypes2.default.any,
	  loading: _propTypes2.default.bool,
	  showPagination: _propTypes2.default.bool,
	  showPaginationTop: _propTypes2.default.bool,
	  showPaginationBottom: _propTypes2.default.bool,
	  showPageSizeOptions: _propTypes2.default.bool,
	  pageSizeOptions: _propTypes2.default.array,
	  defaultPageSize: _propTypes2.default.number,
	  showPageJump: _propTypes2.default.bool,
	  collapseOnSortingChange: _propTypes2.default.bool,
	  collapseOnPageChange: _propTypes2.default.bool,
	  collapseOnDataChange: _propTypes2.default.bool,
	  freezeWhenExpanded: _propTypes2.default.bool,
	  sortable: _propTypes2.default.bool,
	  resizable: _propTypes2.default.bool,
	  filterable: _propTypes2.default.bool,
	  defaultSortDesc: _propTypes2.default.bool,
	  defaultSorted: _propTypes2.default.array,
	  defaultFiltered: _propTypes2.default.array,
	  defaultResized: _propTypes2.default.array,
	  defaultExpanded: _propTypes2.default.object,
	  defaultFilterMethod: _propTypes2.default.func,
	  defaultSortMethod: _propTypes2.default.func,
	
	  // Controlled State Callbacks
	  onPageChange: _propTypes2.default.func,
	  onPageSizeChange: _propTypes2.default.func,
	  onSortedChange: _propTypes2.default.func,
	  onFilteredChange: _propTypes2.default.func,
	  onResizedChange: _propTypes2.default.func,
	  onExpandedChange: _propTypes2.default.func,
	
	  // Pivoting
	  pivotBy: _propTypes2.default.array,
	
	  // Key Constants
	  pivotValKey: _propTypes2.default.string,
	  pivotIDKey: _propTypes2.default.string,
	  subRowsKey: _propTypes2.default.string,
	  aggregatedKey: _propTypes2.default.string,
	  nestingLevelKey: _propTypes2.default.string,
	  originalKey: _propTypes2.default.string,
	  indexKey: _propTypes2.default.string,
	  groupedByPivotKey: _propTypes2.default.string,
	
	  // Server-side Callbacks
	  onFetchData: _propTypes2.default.func,
	
	  // Classes
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  // Component decorators
	  getProps: _propTypes2.default.func,
	  getTableProps: _propTypes2.default.func,
	  getTheadGroupProps: _propTypes2.default.func,
	  getTheadGroupTrProps: _propTypes2.default.func,
	  getTheadGroupThProps: _propTypes2.default.func,
	  getTheadProps: _propTypes2.default.func,
	  getTheadTrProps: _propTypes2.default.func,
	  getTheadThProps: _propTypes2.default.func,
	  getTheadFilterProps: _propTypes2.default.func,
	  getTheadFilterTrProps: _propTypes2.default.func,
	  getTheadFilterThProps: _propTypes2.default.func,
	  getTbodyProps: _propTypes2.default.func,
	  getTrGroupProps: _propTypes2.default.func,
	  getTrProps: _propTypes2.default.func,
	  getTdProps: _propTypes2.default.func,
	  getTfootProps: _propTypes2.default.func,
	  getTfootTrProps: _propTypes2.default.func,
	  getTfootTdProps: _propTypes2.default.func,
	  getPaginationProps: _propTypes2.default.func,
	  getLoadingProps: _propTypes2.default.func,
	  getNoDataProps: _propTypes2.default.func,
	  getResizerProps: _propTypes2.default.func,
	
	  // Global Column Defaults
	  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    // Renderers
	    Cell: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Header: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Footer: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Aggregated: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Pivot: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    PivotValue: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Expander: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
	    Filter: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	
	    // All Columns
	    sortable: _propTypes2.default.bool, // use table default
	    resizable: _propTypes2.default.bool, // use table default
	    filterable: _propTypes2.default.bool, // use table default
	    show: _propTypes2.default.bool,
	    minWidth: _propTypes2.default.number,
	    minResizeWidth: _propTypes2.default.number,
	
	    // Cells only
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    getProps: _propTypes2.default.func,
	
	    // Pivot only
	    aggregate: _propTypes2.default.func,
	
	    // Headers only
	    headerClassName: _propTypes2.default.string,
	    headerStyle: _propTypes2.default.object,
	    getHeaderProps: _propTypes2.default.func,
	
	    // Footers only
	    footerClassName: _propTypes2.default.string,
	    footerStyle: _propTypes2.default.object,
	    getFooterProps: _propTypes2.default.func,
	    filterMethod: _propTypes2.default.func,
	    filterAll: _propTypes2.default.bool,
	    sortMethod: _propTypes2.default.func
	  })),
	
	  // Global Expander Column Defaults
	  expanderDefaults: _propTypes2.default.shape({
	    sortable: _propTypes2.default.bool,
	    resizable: _propTypes2.default.bool,
	    filterable: _propTypes2.default.bool,
	    width: _propTypes2.default.number
	  }),
	
	  pivotDefaults: _propTypes2.default.object,
	
	  // Text
	  previousText: _propTypes2.default.node,
	  nextText: _propTypes2.default.node,
	  loadingText: _propTypes2.default.node,
	  noDataText: _propTypes2.default.node,
	  pageText: _propTypes2.default.node,
	  ofText: _propTypes2.default.node,
	  rowsText: _propTypes2.default.node,
	  pageJumpText: _propTypes2.default.node,
	  rowsSelectorText: _propTypes2.default.node,
	
	  // Components
	  TableComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TheadComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TbodyComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TrGroupComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TrComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  ThComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TdComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  TfootComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  FilterComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  ExpanderComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  PivotValueComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  AggregatedComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  // this is a computed default generated using
	  PivotComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
	  PaginationComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  PreviousComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  NextComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  LoadingComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  NoDataComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  ResizerComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  PadRowComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	};
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 654 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
	  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListeners = {
	  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};

/***/ },
/* 655 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ },
/* 656 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
	  };
	};

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__(244);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatibale with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ },
/* 658 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	            return;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's nessesary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__(244);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decoraters */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(666);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__(657);
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__(659);
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__(654);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__(656);
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__(655);
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _trackRemoval = __webpack_require__(658);
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__(663);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__(664);
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__(662);
	
	var _nodeListToArray = __webpack_require__(665);
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__(661);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: props.place || 'top', // Direction of tooltip
	      desiredPlace: props.place || 'top',
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var ariaProps = this.state.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(props);
	
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (isChanged) {
	        this.setState({ ariaProps: newAriaProps });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: 'mouseOnToolTip',
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	        return this.tooltipRef.matches(':hover');
	      }
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff,
	          isCapture = _props2.isCapture;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        var isCaptureMode = _this3.isCapture(target);
	        var effect = _this3.getEffect(target);
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customBindListener(target);
	          return;
	        }
	
	        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	        if (effect === 'float') {
	          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	        }
	        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	      });
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        _this4.unbindBasicListener(target);
	        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	      });
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and ummount the compont
	     * it is necessary to invloke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent() {
	      var _props4 = this.props,
	          getContent = _props4.getContent,
	          children = _props4.children;
	
	      // Generate tooltip content
	
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: 'isEmptyTip',
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props5 = this.props,
	          multiline = _props5.multiline,
	          getContent = _props5.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it needs to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // Make sure the correct place is set
	      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
	      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
	      var result = (0, _getPosition2.default)(e, e.currentTarget, _reactDom2.default.findDOMNode(this), desiredPlace, desiredPlace, effect, offset);
	      var place = result.isNewState ? result.newState.place : desiredPlace;
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      var target = e.currentTarget;
	
	      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
	
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute('data-type') || self.props.type || 'dark',
	          effect: effect,
	          offset: offset,
	          html: target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html || false,
	          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
	          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
	          border: target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border || false,
	          extraClass: target.getAttribute('data-class') || self.props.class || self.props.className || '',
	          disable: target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) self.addScrollListener(self.state.currentTarget);
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	
	                var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      };
	
	      // If there is no delay call immediately, don't allow events to get in first.
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse hover, updatetooltip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target;
	
	      // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	            if (isInvisible && afterShow) afterShow(e);
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /*
	    * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: 'listenForTooltipExit',
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	  }, {
	    key: 'removeListenerForTooltipExit',
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          delayHide = _state2.delayHide,
	          disable = _state2.disable;
	      var afterHide = this.props.afterHide;
	
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show;
	        // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	          return;
	        }
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener();
	          if (isVisible && afterHide) afterHide(e);
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * Add scroll eventlistener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltip);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _state3 = this.state,
	          currentEvent = _state3.currentEvent,
	          currentTarget = _state3.currentTarget,
	          place = _state3.place,
	          desiredPlace = _state3.desiredPlace,
	          effect = _state3.effect,
	          offset = _state3.offset;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      var head = document.getElementsByTagName('head')[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        /* eslint-disable */
	        if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
	          tag.setAttribute('nonce', __webpack_nonce__);
	        }
	        /* eslint-enable */
	        head.insertBefore(tag, head.firstChild);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state4 = this.state,
	          extraClass = _state4.extraClass,
	          html = _state4.html,
	          ariaProps = _state4.ariaProps,
	          disable = _state4.disable;
	
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' }, { 'allow_hover': this.props.delayUpdate }, { 'allow_click': this.props.clickable });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this8.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: tooltipClass + ' ' + extraClass,
	            id: this.props.id
	          }, ariaProps, {
	            ref: function ref(_ref2) {
	              return _this8.tooltipRef = _ref2;
	            },
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react2.default.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayUpdate: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string,
	  clickable: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div',
	  clickable: false
	}, _class2.supportedWrappers = ['div', 'span'], _class2.displayName = 'ReactTooltip', _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ },
/* 661 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip.allow_hover,.__react_component_tooltip.allow_click{pointer-events:auto}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ },
/* 662 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ },
/* 663 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  };
	
	  // Check whether the tooltip with orientation p is completely inside the client window
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ['top', 'bottom', 'left', 'right'];
	  var insideList = [];
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace = void 0;
	  if (inside(desiredPlace) && desiredPlace !== place) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: { place: newPlace }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	};
	
	// Get current mouse offset
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and childern is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 665 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ },
/* 666 */
6,
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _fastDeepEqual = _interopRequireDefault(__webpack_require__(668));
	
	var _youtubePlayer = _interopRequireDefault(__webpack_require__(674));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Check whether a `props` change should result in the video being updated.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdateVideo(prevProps, props) {
	  // A changing video should always trigger an update
	  if (prevProps.videoId !== props.videoId) {
	    return true;
	  } // Otherwise, a change in the start/end time playerVars also requires a player
	  // update.
	
	
	  var prevVars = prevProps.opts.playerVars || {};
	  var vars = props.opts.playerVars || {};
	  return prevVars.start !== vars.start || prevVars.end !== vars.end;
	}
	/**
	 * Neutralize API options that only require a video update, leaving only options
	 * that require a player reset. The results can then be compared to see if a
	 * player reset is necessary.
	 *
	 * @param {Object} opts
	 */
	
	
	function filterResetOptions(opts) {
	  return _objectSpread({}, opts, {
	    playerVars: _objectSpread({}, opts.playerVars, {
	      autoplay: 0,
	      start: 0,
	      end: 0
	    })
	  });
	}
	/**
	 * Check whether a `props` change should result in the player being reset.
	 * The player is reset when the `props.opts` change, except if the only change
	 * is in the `start` and `end` playerVars, because a video update can deal with
	 * those.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	
	
	function shouldResetPlayer(prevProps, props) {
	  return !(0, _fastDeepEqual.default)(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
	}
	/**
	 * Check whether a props change should result in an id or className update.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	
	
	function shouldUpdatePlayer(prevProps, props) {
	  return prevProps.id !== props.id || prevProps.className !== props.className;
	}
	
	var YouTube = /*#__PURE__*/function (_React$Component) {
	  _inherits(YouTube, _React$Component);
	
	  var _super = _createSuper(YouTube);
	
	  /**
	   * Expose PlayerState constants for convenience. These constants can also be
	   * accessed through the global YT object after the YouTube IFrame API is instantiated.
	   * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	   */
	  function YouTube(props) {
	    var _this;
	
	    _classCallCheck(this, YouTube);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerReady", function (event) {
	      return _this.props.onReady(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerError", function (event) {
	      return _this.props.onError(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerStateChange", function (event) {
	      _this.props.onStateChange(event);
	
	      switch (event.data) {
	        case YouTube.PlayerState.ENDED:
	          _this.props.onEnd(event);
	
	          break;
	
	        case YouTube.PlayerState.PLAYING:
	          _this.props.onPlay(event);
	
	          break;
	
	        case YouTube.PlayerState.PAUSED:
	          _this.props.onPause(event);
	
	          break;
	
	        default:
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackRateChange", function (event) {
	      return _this.props.onPlaybackRateChange(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackQualityChange", function (event) {
	      return _this.props.onPlaybackQualityChange(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "createPlayer", function () {
	      // do not attempt to create a player server-side, it won't work
	      if (typeof document === 'undefined') return; // create player
	
	      var playerOpts = _objectSpread({}, _this.props.opts, {
	        // preload the `videoId` video if one is already given
	        videoId: _this.props.videoId
	      });
	
	      _this.internalPlayer = (0, _youtubePlayer.default)(_this.container, playerOpts); // attach event handlers
	
	      _this.internalPlayer.on('ready', _this.onPlayerReady);
	
	      _this.internalPlayer.on('error', _this.onPlayerError);
	
	      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
	
	      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
	
	      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resetPlayer", function () {
	      return _this.internalPlayer.destroy().then(_this.createPlayer);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updatePlayer", function () {
	      _this.internalPlayer.getIframe().then(function (iframe) {
	        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
	        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateVideo", function () {
	      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
	        _this.internalPlayer.stopVideo();
	
	        return;
	      } // set queueing options
	
	
	      var autoplay = false;
	      var opts = {
	        videoId: _this.props.videoId
	      };
	
	      if ('playerVars' in _this.props.opts) {
	        autoplay = _this.props.opts.playerVars.autoplay === 1;
	
	        if ('start' in _this.props.opts.playerVars) {
	          opts.startSeconds = _this.props.opts.playerVars.start;
	        }
	
	        if ('end' in _this.props.opts.playerVars) {
	          opts.endSeconds = _this.props.opts.playerVars.end;
	        }
	      } // if autoplay is enabled loadVideoById
	
	
	      if (autoplay) {
	        _this.internalPlayer.loadVideoById(opts);
	
	        return;
	      } // default behaviour just cues the video
	
	
	      _this.internalPlayer.cueVideoById(opts);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "refContainer", function (container) {
	      _this.container = container;
	    });
	
	    _this.container = null;
	    _this.internalPlayer = null;
	    return _this;
	  }
	
	  _createClass(YouTube, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.createPlayer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (shouldUpdatePlayer(prevProps, this.props)) {
	        this.updatePlayer();
	      }
	
	      if (shouldResetPlayer(prevProps, this.props)) {
	        this.resetPlayer();
	      }
	
	      if (shouldUpdateVideo(prevProps, this.props)) {
	        this.updateVideo();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      /**
	       * Note: The `youtube-player` package that is used promisifies all YouTube
	       * Player API calls, which introduces a delay of a tick before it actually
	       * gets destroyed. Since React attempts to remove the element instantly
	       * this method isn't quick enough to reset the container element.
	       */
	      this.internalPlayer.destroy();
	    }
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onReady
	     *
	     * @param {Object} event
	     *   @param {Object} target - player object
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: this.props.containerClassName
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.refContainer
	      }));
	    }
	  }]);
	
	  return YouTube;
	}(_react.default.Component);
	
	_defineProperty(YouTube, "PlayerState", {
	  UNSTARTED: -1,
	  ENDED: 0,
	  PLAYING: 1,
	  PAUSED: 2,
	  BUFFERING: 3,
	  CUED: 5
	});
	
	YouTube.propTypes = {
	  videoId: _propTypes.default.string,
	  // custom ID for player element
	  id: _propTypes.default.string,
	  // custom class name for player element
	  className: _propTypes.default.string,
	  // custom class name for player container element
	  containerClassName: _propTypes.default.string,
	  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	  opts: _propTypes.default.objectOf(_propTypes.default.any),
	  // event subscriptions
	  onReady: _propTypes.default.func,
	  onError: _propTypes.default.func,
	  onPlay: _propTypes.default.func,
	  onPause: _propTypes.default.func,
	  onEnd: _propTypes.default.func,
	  onStateChange: _propTypes.default.func,
	  onPlaybackRateChange: _propTypes.default.func,
	  onPlaybackQualityChange: _propTypes.default.func
	};
	YouTube.defaultProps = {
	  videoId: null,
	  id: null,
	  className: null,
	  opts: {},
	  containerClassName: '',
	  onReady: function onReady() {},
	  onError: function onError() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onEnd: function onEnd() {},
	  onStateChange: function onStateChange() {},
	  onPlaybackRateChange: function onPlaybackRateChange() {},
	  onPlaybackQualityChange: function onPlaybackQualityChange() {}
	};
	var _default = YouTube;
	exports.default = _default;


/***/ },
/* 668 */
/***/ function(module, exports) {

	'use strict';
	
	// do not edit .js files directly - edit src/index.jst
	
	
	
	module.exports = function equal(a, b) {
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;
	
	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	
	
	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
	
	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;
	
	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	
	    for (i = length; i-- !== 0;) {
	      var key = keys[i];
	
	      if (!equal(a[key], b[key])) return false;
	    }
	
	    return true;
	  }
	
	  // true if both NaN, false otherwise
	  return a!==a && b!==b;
	};


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlayerStates = __webpack_require__(671);
	
	var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  pauseVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: false
	  },
	  playVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
	    stateChangeRequired: false
	  },
	  seekTo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: true,
	
	    // TRICKY: `seekTo` may not cause a state change if no buffering is
	    // required.
	    timeout: 3000
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debug = __webpack_require__(677);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _functionNames = __webpack_require__(673);
	
	var _functionNames2 = _interopRequireDefault(_functionNames);
	
	var _eventNames = __webpack_require__(672);
	
	var _eventNames2 = _interopRequireDefault(_eventNames);
	
	var _FunctionStateMap = __webpack_require__(669);
	
	var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable promise/prefer-await-to-then */
	
	var debug = (0, _debug2.default)('youtube-player');
	
	var YouTubePlayer = {};
	
	/**
	 * Construct an object that defines an event handler for all of the YouTube
	 * player events. Proxy captured events through an event emitter.
	 *
	 * @todo Capture event parameters.
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 */
	YouTubePlayer.proxyEvents = function (emitter) {
	  var events = {};
	
	  var _loop = function _loop(eventName) {
	    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
	
	    events[onEventName] = function (event) {
	      debug('event "%s"', onEventName, event);
	
	      emitter.trigger(eventName, event);
	    };
	  };
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var eventName = _step.value;
	
	      _loop(eventName);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return events;
	};
	
	/**
	 * Delays player API method execution until player state is ready.
	 *
	 * @todo Proxy all of the methods using Object.keys.
	 * @todo See TRICKY below.
	 * @param playerAPIReady Promise that resolves when player is ready.
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions.
	 * @returns {Object}
	 */
	YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
	  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var functions = {};
	
	  var _loop2 = function _loop2(functionName) {
	    if (strictState && _FunctionStateMap2.default[functionName]) {
	      functions[functionName] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return playerAPIReady.then(function (player) {
	          var stateInfo = _FunctionStateMap2.default[functionName];
	          var playerState = player.getPlayerState();
	
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          var value = player[functionName].apply(player, args);
	
	          // TRICKY: For functions like `seekTo`, a change in state must be
	          // triggered given that the resulting state could match the initial
	          // state.
	          if (stateInfo.stateChangeRequired ||
	
	          // eslint-disable-next-line no-extra-parens
	          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
	            return new Promise(function (resolve) {
	              var onPlayerStateChange = function onPlayerStateChange() {
	                var playerStateAfterChange = player.getPlayerState();
	
	                var timeout = void 0;
	
	                if (typeof stateInfo.timeout === 'number') {
	                  timeout = setTimeout(function () {
	                    player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                    resolve();
	                  }, stateInfo.timeout);
	                }
	
	                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
	                  player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                  clearTimeout(timeout);
	
	                  resolve();
	                }
	              };
	
	              player.addEventListener('onStateChange', onPlayerStateChange);
	            }).then(function () {
	              return value;
	            });
	          }
	
	          return value;
	        });
	      };
	    } else {
	      functions[functionName] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return playerAPIReady.then(function (player) {
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          return player[functionName].apply(player, args);
	        });
	      };
	    }
	  };
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var functionName = _step2.value;
	
	      _loop2(functionName);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return functions;
	};
	
	exports.default = YouTubePlayer;
	module.exports = exports['default'];

/***/ },
/* 671 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  BUFFERING: 3,
	  ENDED: 0,
	  PAUSED: 2,
	  PLAYING: 1,
	  UNSTARTED: -1,
	  VIDEO_CUED: 5
	};
	module.exports = exports["default"];

/***/ },
/* 672 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 * `volumeChange` is not officially supported but seems to work
	 * it emits an object: `{volume: 82.6923076923077, muted: false}`
	 */
	exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
	module.exports = exports['default'];

/***/ },
/* 673 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
	 */
	exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
	module.exports = exports['default'];

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _sister = __webpack_require__(680);
	
	var _sister2 = _interopRequireDefault(_sister);
	
	var _loadYouTubeIframeApi = __webpack_require__(675);
	
	var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
	
	var _YouTubePlayer = __webpack_require__(670);
	
	var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef YT.Player
	 * @see https://developers.google.com/youtube/iframe_api_reference
	 * */
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	 */
	var youtubeIframeAPI = void 0;
	
	/**
	 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
	 *
	 * @param maybeElementId Either An existing YT.Player instance,
	 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
	 * @param options See `options` (Ignored when using an existing YT.Player instance).
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions. Default: `false`.
	 * See `FunctionStateMap.js` for supported functions and acceptable states.
	 */
	
	exports.default = function (maybeElementId) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var emitter = (0, _sister2.default)();
	
	  if (!youtubeIframeAPI) {
	    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
	  }
	
	  if (options.events) {
	    throw new Error('Event handlers cannot be overwritten.');
	  }
	
	  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
	    throw new Error('Element "' + maybeElementId + '" does not exist.');
	  }
	
	  options.events = _YouTubePlayer2.default.proxyEvents(emitter);
	
	  var playerAPIReady = new Promise(function (resolve) {
	    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
	      var player = maybeElementId;
	
	      resolve(player);
	    } else {
	      // asume maybeElementId can be rendered inside
	      // eslint-disable-next-line promise/catch-or-return
	      youtubeIframeAPI.then(function (YT) {
	        // eslint-disable-line promise/prefer-await-to-then
	        var player = new YT.Player(maybeElementId, options);
	
	        emitter.on('ready', function () {
	          resolve(player);
	        });
	
	        return null;
	      });
	    }
	  });
	
	  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
	
	  playerApi.on = emitter.on;
	  playerApi.off = emitter.off;
	
	  return playerApi;
	};
	
	module.exports = exports['default'];

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loadScript = __webpack_require__(679);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (emitter) {
	  /**
	   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
	   * The promise is resolved with a reference to window.YT object.
	   */
	  var iframeAPIReady = new Promise(function (resolve) {
	    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
	      resolve(window.YT);
	
	      return;
	    } else {
	      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
	
	      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
	        if (error) {
	          emitter.trigger('error', error);
	        }
	      });
	    }
	
	    var previous = window.onYouTubeIframeAPIReady;
	
	    // The API will call this function when page has finished downloading
	    // the JavaScript for the player API.
	    window.onYouTubeIframeAPIReady = function () {
	      if (previous) {
	        previous();
	      }
	
	      resolve(window.YT);
	    };
	  });
	
	  return iframeAPIReady;
	};
	
	module.exports = exports['default'];

/***/ },
/* 676 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(678);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENV":"prod"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)))

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(676);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 679 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 680 */
/***/ function(module, exports) {

	'use strict';
	
	var Sister;
	
	/**
	* @link https://github.com/gajus/sister for the canonical source repository
	* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
	*/
	Sister = function () {
	    var sister = {},
	        events = {};
	
	    /**
	     * @name handler
	     * @function
	     * @param {Object} data Event data.
	     */
	
	    /**
	     * @param {String} name Event name.
	     * @param {handler} handler
	     * @return {listener}
	     */
	    sister.on = function (name, handler) {
	        var listener = {name: name, handler: handler};
	        events[name] = events[name] || [];
	        events[name].unshift(listener);
	        return listener;
	    };
	
	    /**
	     * @param {listener}
	     */
	    sister.off = function (listener) {
	        var index = events[listener.name].indexOf(listener);
	
	        if (index !== -1) {
	            events[listener.name].splice(index, 1);
	        }
	    };
	
	    /**
	     * @param {String} name Event name.
	     * @param {Object} data Event data.
	     */
	    sister.trigger = function (name, data) {
	        var listeners = events[name],
	            i;
	
	        if (listeners) {
	            i = listeners.length;
	            while (i--) {
	                listeners[i].handler(data);
	            }
	        }
	    };
	
	    return sister;
	};
	
	module.exports = Sister;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(682),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
	60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
	b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
	unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 682 */
389,
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  color: _propTypes.default.string,
	  pill: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  color: 'secondary',
	  pill: false,
	  tag: 'span'
	};
	
	var Badge = function Badge(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      color = props.color,
	      innerRef = props.innerRef,
	      pill = props.pill,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "color", "innerRef", "pill", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);
	
	  if (attributes.href && Tag === 'span') {
	    Tag = 'a';
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	var _default = Badge;
	exports.default = _default;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  listTag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  listClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  'aria-label': _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'nav',
	  listTag: 'ol',
	  'aria-label': 'breadcrumb'
	};
	
	var Breadcrumb = function Breadcrumb(props) {
	  var className = props.className,
	      listClassName = props.listClassName,
	      cssModule = props.cssModule,
	      children = props.children,
	      Tag = props.tag,
	      ListTag = props.listTag,
	      label = props['aria-label'],
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className), cssModule);
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('breadcrumb', listClassName), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-label": label
	  }), _react.default.createElement(ListTag, {
	    className: listClasses
	  }, children));
	};
	
	Breadcrumb.propTypes = propTypes;
	Breadcrumb.defaultProps = defaultProps;
	var _default = Breadcrumb;
	exports.default = _default;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var BreadcrumbItem = function BreadcrumbItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "active", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-current": active ? 'page' : undefined
	  }));
	};
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	var _default = BreadcrumbItem;
	exports.default = _default;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  role: _propTypes.default.string,
	  size: _propTypes.default.string,
	  vertical: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  role: 'group'
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      size = props.size,
	      vertical = props.vertical,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "size", "vertical", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	var _default = ButtonGroup;
	exports.default = _default;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  role: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  role: 'toolbar'
	};
	
	var ButtonToolbar = function ButtonToolbar(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'btn-toolbar'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ButtonToolbar.propTypes = propTypes;
	ButtonToolbar.defaultProps = defaultProps;
	var _default = ButtonToolbar;
	exports.default = _default;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  inverse: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  body: _propTypes.default.bool,
	  outline: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Card = function Card(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      color = props.color,
	      body = props.body,
	      inverse = props.inverse,
	      outline = props.outline,
	      Tag = props.tag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "color", "body", "inverse", "outline", "tag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card', inverse ? 'text-white' : false, body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	Card.propTypes = propTypes;
	Card.defaultProps = defaultProps;
	var _default = Card;
	exports.default = _default;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardBody = function CardBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      innerRef = props.innerRef,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "innerRef", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-body'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	CardBody.propTypes = propTypes;
	CardBody.defaultProps = defaultProps;
	var _default = CardBody;
	exports.default = _default;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardColumns = function CardColumns(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-columns'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardColumns.propTypes = propTypes;
	CardColumns.defaultProps = defaultProps;
	var _default = CardColumns;
	exports.default = _default;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardDeck = function CardDeck(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-deck'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardDeck.propTypes = propTypes;
	CardDeck.defaultProps = defaultProps;
	var _default = CardDeck;
	exports.default = _default;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardFooter = function CardFooter(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-footer'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardFooter.propTypes = propTypes;
	CardFooter.defaultProps = defaultProps;
	var _default = CardFooter;
	exports.default = _default;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardGroup = function CardGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-group'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardGroup.propTypes = propTypes;
	CardGroup.defaultProps = defaultProps;
	var _default = CardGroup;
	exports.default = _default;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardHeader = function CardHeader(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-header'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardHeader.propTypes = propTypes;
	CardHeader.defaultProps = defaultProps;
	var _default = CardHeader;
	exports.default = _default;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  top: _propTypes.default.bool,
	  bottom: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'img'
	};
	
	var CardImg = function CardImg(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      top = props.top,
	      bottom = props.bottom,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "top", "bottom", "tag"]);
	  var cardImgClassName = 'card-img';
	
	  if (top) {
	    cardImgClassName = 'card-img-top';
	  }
	
	  if (bottom) {
	    cardImgClassName = 'card-img-bottom';
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, cardImgClassName), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardImg.propTypes = propTypes;
	CardImg.defaultProps = defaultProps;
	var _default = CardImg;
	exports.default = _default;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardImgOverlay = function CardImgOverlay(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-img-overlay'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardImgOverlay.propTypes = propTypes;
	CardImgOverlay.defaultProps = defaultProps;
	var _default = CardImgOverlay;
	exports.default = _default;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var CardLink = function CardLink(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-link'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    ref: innerRef,
	    className: classes
	  }));
	};
	
	CardLink.propTypes = propTypes;
	CardLink.defaultProps = defaultProps;
	var _default = CardLink;
	exports.default = _default;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardSubtitle = function CardSubtitle(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-subtitle'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardSubtitle.propTypes = propTypes;
	CardSubtitle.defaultProps = defaultProps;
	var _default = CardSubtitle;
	exports.default = _default;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'p'
	};
	
	var CardText = function CardText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-text'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardText.propTypes = propTypes;
	CardText.defaultProps = defaultProps;
	var _default = CardText;
	exports.default = _default;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var CardTitle = function CardTitle(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'card-title'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	CardTitle.propTypes = propTypes;
	CardTitle.defaultProps = defaultProps;
	var _default = CardTitle;
	exports.default = _default;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _lodash = _interopRequireDefault(__webpack_require__(259));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var columnProps = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	  size: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string]),
	  order: stringOrNumberProp,
	  offset: stringOrNumberProp
	})]);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  xs: columnProps,
	  sm: columnProps,
	  md: columnProps,
	  lg: columnProps,
	  xl: columnProps,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  widths: _propTypes.default.array
	};
	var defaultProps = {
	  tag: 'div',
	  widths: colWidths
	};
	
	var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
	  if (colSize === true || colSize === '') {
	    return isXs ? 'col' : "col-" + colWidth;
	  } else if (colSize === 'auto') {
	    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
	  }
	
	  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
	};
	
	var Col = function Col(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      widths = props.widths,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "widths", "tag"]);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var columnProp = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!columnProp && columnProp !== '') {
	      return;
	    }
	
	    var isXs = !i;
	
	    if ((0, _lodash.default)(columnProp)) {
	      var _classNames;
	
	      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
	      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
	      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
	    } else {
	      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
	
	      colClasses.push(_colClass);
	    }
	  });
	
	  if (!colClasses.length) {
	    colClasses.push('col');
	  }
	
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, colClasses), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	var _default = Col;
	exports.default = _default;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  fluid: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Container = function Container(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      fluid = props.fluid,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "fluid", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, fluid ? 'container-fluid' : 'container'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Container.propTypes = propTypes;
	Container.defaultProps = defaultProps;
	var _default = Container;
	exports.default = _default;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  className: _propTypes.default.string,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	  type: _propTypes.default.string.isRequired,
	  label: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  bsSize: _propTypes.default.string,
	  htmlFor: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array, _propTypes.default.func]),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	
	function CustomInput(props) {
	  var className = props.className,
	      label = props.label,
	      inline = props.inline,
	      valid = props.valid,
	      invalid = props.invalid,
	      cssModule = props.cssModule,
	      children = props.children,
	      bsSize = props.bsSize,
	      innerRef = props.innerRef,
	      htmlFor = props.htmlFor,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "label", "inline", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef", "htmlFor"]);
	  var type = attributes.type;
	  var customClass = (0, _utils.mapToCssModules)((0, _classnames.default)(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
	  var validationClassNames = (0, _utils.mapToCssModules)((0, _classnames.default)(invalid && 'is-invalid', valid && 'is-valid'), cssModule);
	  var labelHtmlFor = htmlFor || attributes.id;
	
	  if (type === 'select') {
	    return _react.default.createElement("select", (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: (0, _classnames.default)(validationClassNames, customClass)
	    }), children);
	  }
	
	  if (type === 'file') {
	    return _react.default.createElement("div", {
	      className: customClass
	    }, _react.default.createElement("input", (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: (0, _classnames.default)(validationClassNames, (0, _utils.mapToCssModules)('custom-file-input', cssModule))
	    })), _react.default.createElement("label", {
	      className: (0, _utils.mapToCssModules)('custom-file-label', cssModule),
	      htmlFor: labelHtmlFor
	    }, label || 'Choose file'));
	  }
	
	  if (type !== 'checkbox' && type !== 'radio' && type !== 'switch') {
	    return _react.default.createElement("input", (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: (0, _classnames.default)(validationClassNames, customClass)
	    }));
	  }
	
	  var wrapperClasses = (0, _classnames.default)(customClass, (0, _utils.mapToCssModules)((0, _classnames.default)('custom-control', {
	    'custom-control-inline': inline
	  }), cssModule));
	  return _react.default.createElement("div", {
	    className: wrapperClasses
	  }, _react.default.createElement("input", (0, _extends2.default)({}, attributes, {
	    type: type === 'switch' ? 'checkbox' : type,
	    ref: innerRef,
	    className: (0, _classnames.default)(validationClassNames, (0, _utils.mapToCssModules)('custom-control-input', cssModule))
	  })), _react.default.createElement("label", {
	    className: (0, _utils.mapToCssModules)('custom-control-label', cssModule),
	    htmlFor: labelHtmlFor
	  }, label), children);
	}
	
	CustomInput.propTypes = propTypes;
	var _default = CustomInput;
	exports.default = _default;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _DropdownContext = __webpack_require__(106);
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  divider: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  header: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  toggle: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'button',
	  toggle: true
	};
	
	var DropdownItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownItem, _React$Component);
	
	  function DropdownItem(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getTabIndex = _this.getTabIndex.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = DropdownItem.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled || this.props.header || this.props.divider) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    if (this.props.toggle) {
	      this.context.toggle(e);
	    }
	  };
	
	  _proto.getTabIndex = function getTabIndex() {
	    if (this.props.disabled || this.props.header || this.props.divider) {
	      return '-1';
	    }
	
	    return '0';
	  };
	
	  _proto.render = function render() {
	    var tabIndex = this.getTabIndex();
	    var role = tabIndex > -1 ? 'menuitem' : undefined;
	
	    var _omit = (0, _utils.omit)(this.props, ['toggle']),
	        className = _omit.className,
	        cssModule = _omit.cssModule,
	        divider = _omit.divider,
	        Tag = _omit.tag,
	        header = _omit.header,
	        active = _omit.active,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_omit, ["className", "cssModule", "divider", "tag", "header", "active"]);
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      disabled: props.disabled,
	      'dropdown-item': !divider && !header,
	      active: active,
	      'dropdown-header': header,
	      'dropdown-divider': divider
	    }), cssModule);
	
	    if (Tag === 'button') {
	      if (header) {
	        Tag = 'h6';
	      } else if (divider) {
	        Tag = 'div';
	      } else if (props.href) {
	        Tag = 'a';
	      }
	    }
	
	    return _react.default.createElement(Tag, (0, _extends2.default)({
	      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
	    }, props, {
	      tabIndex: tabIndex,
	      role: role,
	      className: classes,
	      onClick: this.onClick
	    }));
	  };
	
	  return DropdownItem;
	}(_react.default.Component);
	
	DropdownItem.propTypes = propTypes;
	DropdownItem.defaultProps = defaultProps;
	DropdownItem.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownItem;
	exports.default = _default;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _reactPopper = __webpack_require__(108);
	
	var _DropdownContext = __webpack_require__(106);
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  children: _propTypes.default.node.isRequired,
	  right: _propTypes.default.bool,
	  flip: _propTypes.default.bool,
	  modifiers: _propTypes.default.object,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  persist: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  flip: true
	};
	var noFlipModifier = {
	  flip: {
	    enabled: false
	  }
	};
	var directionPositionMap = {
	  up: 'top',
	  left: 'left',
	  right: 'right',
	  down: 'bottom'
	};
	
	var DropdownMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = DropdownMenu.prototype;
	
	  _proto.render = function render() {
	    var _this = this;
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        right = _this$props.right,
	        tag = _this$props.tag,
	        flip = _this$props.flip,
	        modifiers = _this$props.modifiers,
	        persist = _this$props.persist,
	        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'dropdown-menu', {
	      'dropdown-menu-right': right,
	      show: this.context.isOpen
	    }), cssModule);
	    var Tag = tag;
	
	    if (persist || this.context.isOpen && !this.context.inNavbar) {
	      var position1 = directionPositionMap[this.context.direction] || 'bottom';
	      var position2 = right ? 'end' : 'start';
	      var poperPlacement = position1 + "-" + position2;
	      var poperModifiers = !flip ? (0, _objectSpread2.default)({}, modifiers, noFlipModifier) : modifiers;
	      return _react.default.createElement(_reactPopper.Popper, {
	        placement: poperPlacement,
	        modifiers: poperModifiers
	      }, function (_ref) {
	        var ref = _ref.ref,
	            style = _ref.style,
	            placement = _ref.placement;
	        return _react.default.createElement(Tag, (0, _extends2.default)({
	          tabIndex: "-1",
	          role: "menu",
	          ref: ref,
	          style: style
	        }, attrs, {
	          "aria-hidden": !_this.context.isOpen,
	          className: classes,
	          "x-placement": placement
	        }));
	      });
	    }
	
	    return _react.default.createElement(Tag, (0, _extends2.default)({
	      tabIndex: "-1",
	      role: "menu"
	    }, attrs, {
	      "aria-hidden": !this.context.isOpen,
	      className: classes,
	      "x-placement": attrs.placement
	    }));
	  };
	
	  return DropdownMenu;
	}(_react.default.Component);
	
	;
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	DropdownMenu.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownMenu;
	exports.default = _default;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _reactPopper = __webpack_require__(108);
	
	var _DropdownContext = __webpack_require__(106);
	
	var _utils = __webpack_require__(5);
	
	var _Button = _interopRequireDefault(__webpack_require__(246));
	
	var propTypes = {
	  caret: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  'aria-haspopup': _propTypes.default.bool,
	  split: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  nav: _propTypes.default.bool
	};
	var defaultProps = {
	  'aria-haspopup': true,
	  color: 'secondary'
	};
	
	var DropdownToggle =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = DropdownToggle.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.nav && !this.props.tag) {
	      e.preventDefault();
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	
	    this.context.toggle(e);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        className = _this$props.className,
	        color = _this$props.color,
	        cssModule = _this$props.cssModule,
	        caret = _this$props.caret,
	        split = _this$props.split,
	        nav = _this$props.nav,
	        tag = _this$props.tag,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "color", "cssModule", "caret", "split", "nav", "tag"]);
	    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	      'dropdown-toggle': caret || split,
	      'dropdown-toggle-split': split,
	      'nav-link': nav
	    }), cssModule);
	
	    var children = props.children || _react.default.createElement("span", {
	      className: "sr-only"
	    }, ariaLabel);
	
	    var Tag;
	
	    if (nav && !tag) {
	      Tag = 'a';
	      props.href = '#';
	    } else if (!tag) {
	      Tag = _Button.default;
	      props.color = color;
	      props.cssModule = cssModule;
	    } else {
	      Tag = tag;
	    }
	
	    if (this.context.inNavbar) {
	      return _react.default.createElement(Tag, (0, _extends2.default)({}, props, {
	        className: classes,
	        onClick: this.onClick,
	        "aria-expanded": this.context.isOpen,
	        children: children
	      }));
	    }
	
	    return _react.default.createElement(_reactPopper.Reference, null, function (_ref) {
	      var _ref2;
	
	      var ref = _ref.ref;
	      return _react.default.createElement(Tag, (0, _extends2.default)({}, props, (_ref2 = {}, _ref2[typeof Tag === 'string' ? 'ref' : 'innerRef'] = ref, _ref2), {
	        className: classes,
	        onClick: _this2.onClick,
	        "aria-expanded": _this2.context.isOpen,
	        children: children
	      }));
	    });
	  };
	
	  return DropdownToggle;
	}(_react.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	DropdownToggle.contextType = _DropdownContext.DropdownContext;
	var _default = DropdownToggle;
	exports.default = _default;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'form'
	};
	
	var Form =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(Form, _Component);
	
	  function Form(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.submit = _this.submit.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.getRef = function getRef(ref) {
	    if (this.props.innerRef) {
	      this.props.innerRef(ref);
	    }
	
	    this.ref = ref;
	  };
	
	  _proto.submit = function submit() {
	    if (this.ref) {
	      this.ref.submit();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        inline = _this$props.inline,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "inline", "tag", "innerRef"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, inline ? 'form-inline' : false), cssModule);
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: classes
	    }));
	  };
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	var _default = Form;
	exports.default = _default;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  valid: _propTypes.default.bool,
	  tooltip: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div',
	  valid: undefined
	};
	
	var FormFeedback = function FormFeedback(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      valid = props.valid,
	      tooltip = props.tooltip,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "valid", "tooltip", "tag"]);
	  var validMode = tooltip ? 'tooltip' : 'feedback';
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormFeedback.propTypes = propTypes;
	FormFeedback.defaultProps = defaultProps;
	var _default = FormFeedback;
	exports.default = _default;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  row: _propTypes.default.bool,
	  check: _propTypes.default.bool,
	  inline: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var FormGroup = function FormGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      row = props.row,
	      disabled = props.disabled,
	      check = props.check,
	      inline = props.inline,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "row", "disabled", "check", "inline", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormGroup.propTypes = propTypes;
	FormGroup.defaultProps = defaultProps;
	var _default = FormGroup;
	exports.default = _default;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  inline: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'small',
	  color: 'muted'
	};
	
	var FormText = function FormText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      inline = props.inline,
	      color = props.color,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "inline", "color", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, !inline ? 'form-text' : false, color ? "text-" + color : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	FormText.propTypes = propTypes;
	FormText.defaultProps = defaultProps;
	var _default = FormText;
	exports.default = _default;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	/* eslint react/prefer-stateless-function: 0 */
	var propTypes = {
	  children: _propTypes.default.node,
	  type: _propTypes.default.string,
	  size: _propTypes.default.string,
	  bsSize: _propTypes.default.string,
	  valid: _propTypes.default.bool,
	  invalid: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  plaintext: _propTypes.default.bool,
	  addon: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  type: 'text'
	};
	
	var Input =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Input, _React$Component);
	
	  function Input(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2.default)(_this));
	    _this.focus = _this.focus.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = Input.prototype;
	
	  _proto.getRef = function getRef(ref) {
	    if (this.props.innerRef) {
	      this.props.innerRef(ref);
	    }
	
	    this.ref = ref;
	  };
	
	  _proto.focus = function focus() {
	    if (this.ref) {
	      this.ref.focus();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        type = _this$props.type,
	        bsSize = _this$props.bsSize,
	        valid = _this$props.valid,
	        invalid = _this$props.invalid,
	        tag = _this$props.tag,
	        addon = _this$props.addon,
	        plaintext = _this$props.plaintext,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"]);
	    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
	    var isNotaNumber = new RegExp('\\D', 'g');
	    var fileInput = type === 'file';
	    var textareaInput = type === 'textarea';
	    var selectInput = type === 'select';
	    var Tag = tag || (selectInput || textareaInput ? type : 'input');
	    var formControlClass = 'form-control';
	
	    if (plaintext) {
	      formControlClass = formControlClass + "-plaintext";
	      Tag = tag || 'input';
	    } else if (fileInput) {
	      formControlClass = formControlClass + "-file";
	    } else if (checkInput) {
	      if (addon) {
	        formControlClass = null;
	      } else {
	        formControlClass = 'form-check-input';
	      }
	    }
	
	    if (attributes.size && isNotaNumber.test(attributes.size)) {
	      (0, _utils.warnOnce)('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
	      bsSize = attributes.size;
	      delete attributes.size;
	    }
	
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);
	
	    if (Tag === 'input' || tag && typeof tag === 'function') {
	      attributes.type = type;
	    }
	
	    if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
	      (0, _utils.warnOnce)("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
	      delete attributes.children;
	    }
	
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      className: classes
	    }));
	  };
	
	  return Input;
	}(_react.default.Component);
	
	Input.propTypes = propTypes;
	Input.defaultProps = defaultProps;
	var _default = Input;
	exports.default = _default;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  size: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var InputGroup = function InputGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      size = props.size,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "size"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group', size ? "input-group-" + size : null), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	InputGroup.propTypes = propTypes;
	InputGroup.defaultProps = defaultProps;
	var _default = InputGroup;
	exports.default = _default;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var _InputGroupText = _interopRequireDefault(__webpack_require__(253));
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  addonType: _propTypes.default.oneOf(['prepend', 'append']).isRequired,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var InputGroupAddon = function InputGroupAddon(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      addonType = props.addonType,
	      children = props.children,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "addonType", "children"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition
	
	  if (typeof children === 'string') {
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: classes
	    }), _react.default.createElement(_InputGroupText.default, {
	      children: children
	    }));
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    children: children
	  }));
	};
	
	InputGroupAddon.propTypes = propTypes;
	InputGroupAddon.defaultProps = defaultProps;
	var _default = InputGroupAddon;
	exports.default = _default;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(105));
	
	var propTypes = {
	  addonType: _propTypes.default.oneOf(['prepend', 'append']).isRequired,
	  children: _propTypes.default.node
	};
	
	var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
	  return _react.default.createElement(_Dropdown.default, props);
	};
	
	InputGroupButtonDropdown.propTypes = propTypes;
	var _default = InputGroupButtonDropdown;
	exports.default = _default;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  fluid: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Jumbotron = function Jumbotron(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      fluid = props.fluid,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "fluid"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	var _default = Jumbotron;
	exports.default = _default;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _lodash = _interopRequireDefault(__webpack_require__(259));
	
	var _utils = __webpack_require__(5);
	
	var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);
	
	var columnProps = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape({
	  size: stringOrNumberProp,
	  order: stringOrNumberProp,
	  offset: stringOrNumberProp
	})]);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  hidden: _propTypes.default.bool,
	  check: _propTypes.default.bool,
	  size: _propTypes.default.string,
	  for: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  xs: columnProps,
	  sm: columnProps,
	  md: columnProps,
	  lg: columnProps,
	  xl: columnProps,
	  widths: _propTypes.default.array
	};
	var defaultProps = {
	  tag: 'label',
	  widths: colWidths
	};
	
	var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
	  if (colSize === true || colSize === '') {
	    return isXs ? 'col' : "col-" + colWidth;
	  } else if (colSize === 'auto') {
	    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
	  }
	
	  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
	};
	
	var Label = function Label(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      hidden = props.hidden,
	      widths = props.widths,
	      Tag = props.tag,
	      check = props.check,
	      size = props.size,
	      htmlFor = props.for,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"]);
	  var colClasses = [];
	  widths.forEach(function (colWidth, i) {
	    var columnProp = props[colWidth];
	    delete attributes[colWidth];
	
	    if (!columnProp && columnProp !== '') {
	      return;
	    }
	
	    var isXs = !i;
	    var colClass;
	
	    if ((0, _lodash.default)(columnProp)) {
	      var _classNames;
	
	      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
	      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
	      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
	    } else {
	      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
	      colClasses.push(colClass);
	    }
	  });
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({
	    htmlFor: htmlFor
	  }, attributes, {
	    className: classes
	  }));
	};
	
	Label.propTypes = propTypes;
	Label.defaultProps = defaultProps;
	var _default = Label;
	exports.default = _default;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  flush: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'ul'
	};
	
	var ListGroup = function ListGroup(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      flush = props.flush,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "flush"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroup.propTypes = propTypes;
	ListGroup.defaultProps = defaultProps;
	var _default = ListGroup;
	exports.default = _default;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  action: _propTypes.default.bool,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var handleDisabledOnClick = function handleDisabledOnClick(e) {
	  e.preventDefault();
	};
	
	var ListGroupItem = function ListGroupItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      active = props.active,
	      disabled = props.disabled,
	      action = props.action,
	      color = props.color,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "active", "disabled", "action", "color"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.
	
	  if (disabled) {
	    attributes.onClick = handleDisabledOnClick;
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	var _default = ListGroupItem;
	exports.default = _default;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h5'
	};
	
	var ListGroupItemHeading = function ListGroupItemHeading(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group-item-heading'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItemHeading.propTypes = propTypes;
	ListGroupItemHeading.defaultProps = defaultProps;
	var _default = ListGroupItemHeading;
	exports.default = _default;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.any,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'p'
	};
	
	var ListGroupItemText = function ListGroupItemText(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'list-group-item-text'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ListGroupItemText.propTypes = propTypes;
	ListGroupItemText.defaultProps = defaultProps;
	var _default = ListGroupItemText;
	exports.default = _default;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  body: _propTypes.default.bool,
	  bottom: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  heading: _propTypes.default.bool,
	  left: _propTypes.default.bool,
	  list: _propTypes.default.bool,
	  middle: _propTypes.default.bool,
	  object: _propTypes.default.bool,
	  right: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  top: _propTypes.default.bool
	};
	
	var Media = function Media(props) {
	  var body = props.body,
	      bottom = props.bottom,
	      className = props.className,
	      cssModule = props.cssModule,
	      heading = props.heading,
	      left = props.left,
	      list = props.list,
	      middle = props.middle,
	      object = props.object,
	      right = props.right,
	      tag = props.tag,
	      top = props.top,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["body", "bottom", "className", "cssModule", "heading", "left", "list", "middle", "object", "right", "tag", "top"]);
	  var defaultTag;
	
	  if (heading) {
	    defaultTag = 'h4';
	  } else if (attributes.href) {
	    defaultTag = 'a';
	  } else if (attributes.src || object) {
	    defaultTag = 'img';
	  } else if (list) {
	    defaultTag = 'ul';
	  } else {
	    defaultTag = 'div';
	  }
	
	  var Tag = tag || defaultTag;
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
	    'media-body': body,
	    'media-heading': heading,
	    'media-left': left,
	    'media-right': right,
	    'media-top': top,
	    'media-bottom': bottom,
	    'media-middle': middle,
	    'media-object': object,
	    'media-list': list,
	    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
	  }), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Media.propTypes = propTypes;
	var _default = Media;
	exports.default = _default;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _Portal = _interopRequireDefault(__webpack_require__(738));
	
	var _Fade = _interopRequireDefault(__webpack_require__(76));
	
	var _utils = __webpack_require__(5);
	
	function noop() {}
	
	var FadePropTypes = _propTypes.default.shape(_Fade.default.propTypes);
	
	var propTypes = {
	  isOpen: _propTypes.default.bool,
	  autoFocus: _propTypes.default.bool,
	  centered: _propTypes.default.bool,
	  scrollable: _propTypes.default.bool,
	  size: _propTypes.default.string,
	  toggle: _propTypes.default.func,
	  keyboard: _propTypes.default.bool,
	  role: _propTypes.default.string,
	  labelledBy: _propTypes.default.string,
	  backdrop: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['static'])]),
	  onEnter: _propTypes.default.func,
	  onExit: _propTypes.default.func,
	  onOpened: _propTypes.default.func,
	  onClosed: _propTypes.default.func,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  wrapClassName: _propTypes.default.string,
	  modalClassName: _propTypes.default.string,
	  backdropClassName: _propTypes.default.string,
	  contentClassName: _propTypes.default.string,
	  external: _propTypes.default.node,
	  fade: _propTypes.default.bool,
	  cssModule: _propTypes.default.object,
	  zIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  backdropTransition: FadePropTypes,
	  modalTransition: FadePropTypes,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func]),
	  unmountOnClose: _propTypes.default.bool,
	  returnFocusAfterClose: _propTypes.default.bool
	};
	var propsToOmit = Object.keys(propTypes);
	var defaultProps = {
	  isOpen: false,
	  autoFocus: true,
	  centered: false,
	  scrollable: false,
	  role: 'dialog',
	  backdrop: true,
	  keyboard: true,
	  zIndex: 1050,
	  fade: true,
	  onOpened: noop,
	  onClosed: noop,
	  modalTransition: {
	    timeout: _utils.TransitionTimeouts.Modal
	  },
	  backdropTransition: {
	    mountOnEnter: true,
	    timeout: _utils.TransitionTimeouts.Fade // uses standard fade transition
	
	  },
	  unmountOnClose: true,
	  returnFocusAfterClose: true
	};
	
	var Modal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Modal, _React$Component);
	
	  function Modal(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this._element = null;
	    _this._originalBodyPadding = null;
	    _this.getFocusableChildren = _this.getFocusableChildren.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleBackdropClick = _this.handleBackdropClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onOpened = _this.onOpened.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onClosed = _this.onClosed.bind((0, _assertThisInitialized2.default)(_this));
	    _this.manageFocusAfterClose = _this.manageFocusAfterClose.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.isOpen
	    };
	
	    if (props.isOpen) {
	      _this.init();
	    }
	
	    return _this;
	  }
	
	  var _proto = Modal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    if (this.props.onEnter) {
	      this.props.onEnter();
	    }
	
	    if (this.state.isOpen && this.props.autoFocus) {
	      this.setFocus();
	    }
	
	    this._isMounted = true;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (this.props.isOpen && !prevProps.isOpen) {
	      this.init();
	      this.setState({
	        isOpen: true
	      }); // let render() renders Modal Dialog first
	
	      return;
	    } // now Modal Dialog is rendered and we can refer this._element and this._dialog
	
	
	    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
	      this.setFocus();
	    }
	
	    if (this._element && prevProps.zIndex !== this.props.zIndex) {
	      this._element.style.zIndex = this.props.zIndex;
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.props.onExit) {
	      this.props.onExit();
	    }
	
	    if (this._element) {
	      this.destroy();
	
	      if (this.state.isOpen) {
	        this.close();
	      }
	    }
	
	    this._isMounted = false;
	  };
	
	  _proto.onOpened = function onOpened(node, isAppearing) {
	    this.props.onOpened();
	    (this.props.modalTransition.onEntered || noop)(node, isAppearing);
	  };
	
	  _proto.onClosed = function onClosed(node) {
	    var unmountOnClose = this.props.unmountOnClose; // so all methods get called before it is unmounted
	
	    this.props.onClosed();
	    (this.props.modalTransition.onExited || noop)(node);
	
	    if (unmountOnClose) {
	      this.destroy();
	    }
	
	    this.close();
	
	    if (this._isMounted) {
	      this.setState({
	        isOpen: false
	      });
	    }
	  };
	
	  _proto.setFocus = function setFocus() {
	    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
	      this._dialog.parentNode.focus();
	    }
	  };
	
	  _proto.getFocusableChildren = function getFocusableChildren() {
	    return this._element.querySelectorAll(_utils.focusableElements.join(', '));
	  };
	
	  _proto.getFocusedChild = function getFocusedChild() {
	    var currentFocus;
	    var focusableChildren = this.getFocusableChildren();
	
	    try {
	      currentFocus = document.activeElement;
	    } catch (err) {
	      currentFocus = focusableChildren[0];
	    }
	
	    return currentFocus;
	  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
	  ;
	
	  _proto.handleBackdropClick = function handleBackdropClick(e) {
	    if (e.target === this._mouseDownElement) {
	      e.stopPropagation();
	      if (!this.props.isOpen || this.props.backdrop !== true) return;
	      var backdrop = this._dialog ? this._dialog.parentNode : null;
	
	      if (backdrop && e.target === backdrop && this.props.toggle) {
	        this.props.toggle(e);
	      }
	    }
	  };
	
	  _proto.handleTab = function handleTab(e) {
	    if (e.which !== 9) return;
	    var focusableChildren = this.getFocusableChildren();
	    var totalFocusable = focusableChildren.length;
	    if (totalFocusable === 0) return;
	    var currentFocus = this.getFocusedChild();
	    var focusedIndex = 0;
	
	    for (var i = 0; i < totalFocusable; i += 1) {
	      if (focusableChildren[i] === currentFocus) {
	        focusedIndex = i;
	        break;
	      }
	    }
	
	    if (e.shiftKey && focusedIndex === 0) {
	      e.preventDefault();
	      focusableChildren[totalFocusable - 1].focus();
	    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
	      e.preventDefault();
	      focusableChildren[0].focus();
	    }
	  };
	
	  _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
	    this._mouseDownElement = e.target;
	  };
	
	  _proto.handleEscape = function handleEscape(e) {
	    if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.props.toggle(e);
	    }
	  };
	
	  _proto.init = function init() {
	    try {
	      this._triggeringElement = document.activeElement;
	    } catch (err) {
	      this._triggeringElement = null;
	    }
	
	    if (!this._element) {
	      this._element = document.createElement('div');
	
	      this._element.setAttribute('tabindex', '-1');
	
	      this._element.style.position = 'relative';
	      this._element.style.zIndex = this.props.zIndex;
	      document.body.appendChild(this._element);
	    }
	
	    this._originalBodyPadding = (0, _utils.getOriginalBodyPadding)();
	    (0, _utils.conditionallyUpdateScrollbar)();
	
	    if (Modal.openCount === 0) {
	      document.body.className = (0, _classnames.default)(document.body.className, (0, _utils.mapToCssModules)('modal-open', this.props.cssModule));
	    }
	
	    Modal.openCount += 1;
	  };
	
	  _proto.destroy = function destroy() {
	    if (this._element) {
	      document.body.removeChild(this._element);
	      this._element = null;
	    }
	
	    this.manageFocusAfterClose();
	  };
	
	  _proto.manageFocusAfterClose = function manageFocusAfterClose() {
	    if (this._triggeringElement) {
	      var returnFocusAfterClose = this.props.returnFocusAfterClose;
	      if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
	      this._triggeringElement = null;
	    }
	  };
	
	  _proto.close = function close() {
	    if (Modal.openCount <= 1) {
	      var modalOpenClassName = (0, _utils.mapToCssModules)('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
	
	      var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
	      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
	    }
	
	    this.manageFocusAfterClose();
	    Modal.openCount = Math.max(0, Modal.openCount - 1);
	    (0, _utils.setScrollbarWidth)(this._originalBodyPadding);
	  };
	
	  _proto.renderModalDialog = function renderModalDialog() {
	    var _classNames,
	        _this2 = this;
	
	    var attributes = (0, _utils.omit)(this.props, propsToOmit);
	    var dialogBaseClass = 'modal-dialog';
	    return _react.default.createElement("div", (0, _extends2.default)({}, attributes, {
	      className: (0, _utils.mapToCssModules)((0, _classnames.default)(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames[dialogBaseClass + "-scrollable"] = this.props.scrollable, _classNames)), this.props.cssModule),
	      role: "document",
	      ref: function ref(c) {
	        _this2._dialog = c;
	      }
	    }), _react.default.createElement("div", {
	      className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-content', this.props.contentClassName), this.props.cssModule)
	    }, this.props.children));
	  };
	
	  _proto.render = function render() {
	    var unmountOnClose = this.props.unmountOnClose;
	
	    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
	      var isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
	      this._element.style.display = isModalHidden ? 'none' : 'block';
	      var _this$props = this.props,
	          wrapClassName = _this$props.wrapClassName,
	          modalClassName = _this$props.modalClassName,
	          backdropClassName = _this$props.backdropClassName,
	          cssModule = _this$props.cssModule,
	          isOpen = _this$props.isOpen,
	          backdrop = _this$props.backdrop,
	          role = _this$props.role,
	          labelledBy = _this$props.labelledBy,
	          external = _this$props.external,
	          innerRef = _this$props.innerRef;
	      var modalAttributes = {
	        onClick: this.handleBackdropClick,
	        onMouseDown: this.handleBackdropMouseDown,
	        onKeyUp: this.handleEscape,
	        onKeyDown: this.handleTab,
	        style: {
	          display: 'block'
	        },
	        'aria-labelledby': labelledBy,
	        role: role,
	        tabIndex: '-1'
	      };
	      var hasTransition = this.props.fade;
	      var modalTransition = (0, _objectSpread2.default)({}, _Fade.default.defaultProps, this.props.modalTransition, {
	        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
	        timeout: hasTransition ? this.props.modalTransition.timeout : 0
	      });
	      var backdropTransition = (0, _objectSpread2.default)({}, _Fade.default.defaultProps, this.props.backdropTransition, {
	        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
	        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
	      });
	      var Backdrop = backdrop && (hasTransition ? _react.default.createElement(_Fade.default, (0, _extends2.default)({}, backdropTransition, {
	        in: isOpen && !!backdrop,
	        cssModule: cssModule,
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-backdrop', backdropClassName), cssModule)
	      })) : _react.default.createElement("div", {
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal-backdrop', 'show', backdropClassName), cssModule)
	      }));
	      return _react.default.createElement(_Portal.default, {
	        node: this._element
	      }, _react.default.createElement("div", {
	        className: (0, _utils.mapToCssModules)(wrapClassName)
	      }, _react.default.createElement(_Fade.default, (0, _extends2.default)({}, modalAttributes, modalTransition, {
	        in: isOpen,
	        onEntered: this.onOpened,
	        onExited: this.onClosed,
	        cssModule: cssModule,
	        className: (0, _utils.mapToCssModules)((0, _classnames.default)('modal', modalClassName), cssModule),
	        innerRef: innerRef
	      }), external, this.renderModalDialog()), Backdrop));
	    }
	
	    return null;
	  };
	
	  return Modal;
	}(_react.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.openCount = 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ModalBody = function ModalBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-body'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	var _default = ModalBody;
	exports.default = _default;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ModalFooter = function ModalFooter(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-footer'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	var _default = ModalFooter;
	exports.default = _default;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  wrapTag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  closeAriaLabel: _propTypes.default.string,
	  charCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  close: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h5',
	  wrapTag: 'div',
	  closeAriaLabel: 'Close',
	  charCode: 215
	};
	
	var ModalHeader = function ModalHeader(props) {
	  var closeButton;
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      toggle = props.toggle,
	      Tag = props.tag,
	      WrapTag = props.wrapTag,
	      closeAriaLabel = props.closeAriaLabel,
	      charCode = props.charCode,
	      close = props.close,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'modal-header'), cssModule);
	
	  if (!close && toggle) {
	    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
	    closeButton = _react.default.createElement("button", {
	      type: "button",
	      onClick: toggle,
	      className: (0, _utils.mapToCssModules)('close', cssModule),
	      "aria-label": closeAriaLabel
	    }, _react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, closeIcon));
	  }
	
	  return _react.default.createElement(WrapTag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), _react.default.createElement(Tag, {
	    className: (0, _utils.mapToCssModules)('modal-title', cssModule)
	  }, children), close || closeButton);
	};
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	var _default = ModalHeader;
	exports.default = _default;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tabs: _propTypes.default.bool,
	  pills: _propTypes.default.bool,
	  vertical: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  horizontal: _propTypes.default.string,
	  justified: _propTypes.default.bool,
	  fill: _propTypes.default.bool,
	  navbar: _propTypes.default.bool,
	  card: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'ul',
	  vertical: false
	};
	
	var getVerticalClass = function getVerticalClass(vertical) {
	  if (vertical === false) {
	    return false;
	  } else if (vertical === true || vertical === 'xs') {
	    return 'flex-column';
	  }
	
	  return "flex-" + vertical + "-column";
	};
	
	var Nav = function Nav(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      tabs = props.tabs,
	      pills = props.pills,
	      vertical = props.vertical,
	      horizontal = props.horizontal,
	      justified = props.justified,
	      fill = props.fill,
	      navbar = props.navbar,
	      card = props.card,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
	    'nav-tabs': tabs,
	    'card-header-tabs': card && tabs,
	    'nav-pills': pills,
	    'card-header-pills': card && pills,
	    'nav-justified': justified,
	    'nav-fill': fill
	  }), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	var _default = Nav;
	exports.default = _default;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var NavItem = function NavItem(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      active = props.active,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "active", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'nav-item', active ? 'active' : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	var _default = NavItem;
	exports.default = _default;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  disabled: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  onClick: _propTypes.default.func,
	  href: _propTypes.default.any
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var NavLink =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(NavLink, _React$Component);
	
	  function NavLink(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = NavLink.prototype;
	
	  _proto.onClick = function onClick(e) {
	    if (this.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	
	    if (this.props.href === '#') {
	      e.preventDefault();
	    }
	
	    if (this.props.onClick) {
	      this.props.onClick(e);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        active = _this$props.active,
	        Tag = _this$props.tag,
	        innerRef = _this$props.innerRef,
	        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "active", "tag", "innerRef"]);
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'nav-link', {
	      disabled: attributes.disabled,
	      active: active
	    }), cssModule);
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      ref: innerRef,
	      onClick: this.onClick,
	      className: classes
	    }));
	  };
	
	  return NavLink;
	}(_react.default.Component);
	
	NavLink.propTypes = propTypes;
	NavLink.defaultProps = defaultProps;
	var _default = NavLink;
	exports.default = _default;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  light: _propTypes.default.bool,
	  dark: _propTypes.default.bool,
	  full: _propTypes.default.bool,
	  fixed: _propTypes.default.string,
	  sticky: _propTypes.default.string,
	  color: _propTypes.default.string,
	  role: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  expand: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
	};
	var defaultProps = {
	  tag: 'nav',
	  expand: false
	};
	
	var getExpandClass = function getExpandClass(expand) {
	  if (expand === false) {
	    return false;
	  } else if (expand === true || expand === 'xs') {
	    return 'navbar-expand';
	  }
	
	  return "navbar-expand-" + expand;
	};
	
	var Navbar = function Navbar(props) {
	  var _classNames;
	
	  var expand = props.expand,
	      className = props.className,
	      cssModule = props.cssModule,
	      light = props.light,
	      dark = props.dark,
	      fixed = props.fixed,
	      sticky = props.sticky,
	      color = props.color,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["expand", "className", "cssModule", "light", "dark", "fixed", "sticky", "color", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar', getExpandClass(expand), (_classNames = {
	    'navbar-light': light,
	    'navbar-dark': dark
	  }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	var _default = Navbar;
	exports.default = _default;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var NavbarBrand = function NavbarBrand(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-brand'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	NavbarBrand.propTypes = propTypes;
	NavbarBrand.defaultProps = defaultProps;
	var _default = NavbarBrand;
	exports.default = _default;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  type: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node
	};
	var defaultProps = {
	  tag: 'button',
	  type: 'button'
	};
	
	var NavbarToggler = function NavbarToggler(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'navbar-toggler'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), children || _react.default.createElement("span", {
	    className: (0, _utils.mapToCssModules)('navbar-toggler-icon', cssModule)
	  }));
	};
	
	NavbarToggler.propTypes = propTypes;
	NavbarToggler.defaultProps = defaultProps;
	var _default = NavbarToggler;
	exports.default = _default;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  listClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  size: _propTypes.default.string,
	  tag: _utils.tagPropType,
	  listTag: _utils.tagPropType,
	  'aria-label': _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'nav',
	  listTag: 'ul',
	  'aria-label': 'pagination'
	};
	
	var Pagination = function Pagination(props) {
	  var _classNames;
	
	  var className = props.className,
	      listClassName = props.listClassName,
	      cssModule = props.cssModule,
	      size = props.size,
	      Tag = props.tag,
	      ListTag = props.listTag,
	      label = props['aria-label'],
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "listClassName", "cssModule", "size", "tag", "listTag", "aria-label"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className), cssModule);
	  var listClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(listClassName, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
	  return _react.default.createElement(Tag, {
	    className: classes,
	    "aria-label": label
	  }, _react.default.createElement(ListTag, (0, _extends2.default)({}, attributes, {
	    className: listClasses
	  })));
	};
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	var _default = Pagination;
	exports.default = _default;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  active: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  tag: _utils.tagPropType
	};
	var defaultProps = {
	  tag: 'li'
	};
	
	var PaginationItem = function PaginationItem(props) {
	  var active = props.active,
	      className = props.className,
	      cssModule = props.cssModule,
	      disabled = props.disabled,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["active", "className", "cssModule", "disabled", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'page-item', {
	    active: active,
	    disabled: disabled
	  }), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PaginationItem.propTypes = propTypes;
	PaginationItem.defaultProps = defaultProps;
	var _default = PaginationItem;
	exports.default = _default;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  'aria-label': _propTypes.default.string,
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  next: _propTypes.default.bool,
	  previous: _propTypes.default.bool,
	  first: _propTypes.default.bool,
	  last: _propTypes.default.bool,
	  tag: _utils.tagPropType
	};
	var defaultProps = {
	  tag: 'a'
	};
	
	var PaginationLink = function PaginationLink(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      next = props.next,
	      previous = props.previous,
	      first = props.first,
	      last = props.last,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "next", "previous", "first", "last", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'page-link'), cssModule);
	  var defaultAriaLabel;
	
	  if (previous) {
	    defaultAriaLabel = 'Previous';
	  } else if (next) {
	    defaultAriaLabel = 'Next';
	  } else if (first) {
	    defaultAriaLabel = 'First';
	  } else if (last) {
	    defaultAriaLabel = 'Last';
	  }
	
	  var ariaLabel = props['aria-label'] || defaultAriaLabel;
	  var defaultCaret;
	
	  if (previous) {
	    defaultCaret = "\u2039";
	  } else if (next) {
	    defaultCaret = "\u203A";
	  } else if (first) {
	    defaultCaret = "\xAB";
	  } else if (last) {
	    defaultCaret = "\xBB";
	  }
	
	  var children = props.children;
	
	  if (children && Array.isArray(children) && children.length === 0) {
	    children = null;
	  }
	
	  if (!attributes.href && Tag === 'a') {
	    Tag = 'button';
	  }
	
	  if (previous || next || first || last) {
	    children = [_react.default.createElement("span", {
	      "aria-hidden": "true",
	      key: "caret"
	    }, children || defaultCaret), _react.default.createElement("span", {
	      className: "sr-only",
	      key: "sr"
	    }, ariaLabel)];
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    "aria-label": ariaLabel
	  }), children);
	};
	
	PaginationLink.propTypes = propTypes;
	PaginationLink.defaultProps = defaultProps;
	var _default = PaginationLink;
	exports.default = _default;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var PopoverBody = function PopoverBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'popover-body'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PopoverBody.propTypes = propTypes;
	PopoverBody.defaultProps = defaultProps;
	var _default = PopoverBody;
	exports.default = _default;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'h3'
	};
	
	var PopoverHeader = function PopoverHeader(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'popover-header'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	PopoverHeader.propTypes = propTypes;
	PopoverHeader.defaultProps = defaultProps;
	var _default = PopoverHeader;
	exports.default = _default;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(5);
	
	var PopperTargetHelper = function PopperTargetHelper(props, context) {
	  context.popperManager.setTargetNode((0, _utils.getTarget)(props.target));
	  return null;
	};
	
	PopperTargetHelper.contextTypes = {
	  popperManager: _propTypes.default.object.isRequired
	};
	PopperTargetHelper.propTypes = {
	  target: _utils.targetPropType.isRequired
	};
	var _default = PopperTargetHelper;
	exports.default = _default;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  children: _propTypes.default.node.isRequired,
	  node: _propTypes.default.any
	};
	
	var Portal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Portal, _React$Component);
	
	  function Portal() {
	    return _React$Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Portal.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.defaultNode) {
	      document.body.removeChild(this.defaultNode);
	    }
	
	    this.defaultNode = null;
	  };
	
	  _proto.render = function render() {
	    if (!_utils.canUseDOM) {
	      return null;
	    }
	
	    if (!this.props.node && !this.defaultNode) {
	      this.defaultNode = document.createElement('div');
	      document.body.appendChild(this.defaultNode);
	    }
	
	    return _reactDom.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	  };
	
	  return Portal;
	}(_react.default.Component);
	
	Portal.propTypes = propTypes;
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _lodash = _interopRequireDefault(__webpack_require__(757));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  children: _propTypes.default.node,
	  bar: _propTypes.default.bool,
	  multi: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  max: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  animated: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  barClassName: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div',
	  value: 0,
	  max: 100
	};
	
	var Progress = function Progress(props) {
	  var children = props.children,
	      className = props.className,
	      barClassName = props.barClassName,
	      cssModule = props.cssModule,
	      value = props.value,
	      max = props.max,
	      animated = props.animated,
	      striped = props.striped,
	      color = props.color,
	      bar = props.bar,
	      multi = props.multi,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["children", "className", "barClassName", "cssModule", "value", "max", "animated", "striped", "color", "bar", "multi", "tag"]);
	  var percent = (0, _lodash.default)(value) / (0, _lodash.default)(max) * 100;
	  var progressClasses = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'progress'), cssModule);
	  var progressBarClasses = (0, _utils.mapToCssModules)((0, _classnames.default)('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? "bg-" + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);
	  var ProgressBar = multi ? children : _react.default.createElement("div", {
	    className: progressBarClasses,
	    style: {
	      width: percent + "%"
	    },
	    role: "progressbar",
	    "aria-valuenow": value,
	    "aria-valuemin": "0",
	    "aria-valuemax": max,
	    children: children
	  });
	
	  if (bar) {
	    return ProgressBar;
	  }
	
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: progressClasses,
	    children: ProgressBar
	  }));
	};
	
	Progress.propTypes = propTypes;
	Progress.defaultProps = defaultProps;
	var _default = Progress;
	exports.default = _default;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  noGutters: _propTypes.default.bool,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  form: _propTypes.default.bool
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var Row = function Row(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      noGutters = props.noGutters,
	      Tag = props.tag,
	      form = props.form,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "noGutters", "tag", "form"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }));
	};
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	var _default = Row;
	exports.default = _default;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  type: _propTypes.default.string,
	  size: _propTypes.default.string,
	  color: _propTypes.default.string,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.string
	};
	var defaultProps = {
	  tag: 'div',
	  type: 'border',
	  children: 'Loading...'
	};
	
	var Spinner = function Spinner(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      type = props.type,
	      size = props.size,
	      color = props.color,
	      children = props.children,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "type", "size", "color", "children", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, size ? "spinner-" + type + "-" + size : false, "spinner-" + type, color ? "text-" + color : false), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({
	    role: "status"
	  }, attributes, {
	    className: classes
	  }), children && _react.default.createElement("span", {
	    className: (0, _utils.mapToCssModules)('sr-only', cssModule)
	  }, children));
	};
	
	Spinner.propTypes = propTypes;
	Spinner.defaultProps = defaultProps;
	var _default = Spinner;
	exports.default = _default;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(149);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _TabContext = __webpack_require__(256);
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  activeTab: _propTypes.default.any,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var TabContent =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(TabContent, _Component);
	
	  TabContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	    if (prevState.activeTab !== nextProps.activeTab) {
	      return {
	        activeTab: nextProps.activeTab
	      };
	    }
	
	    return null;
	  };
	
	  function TabContent(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      activeTab: _this.props.activeTab
	    };
	    return _this;
	  }
	
	  var _proto = TabContent.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        cssModule = _this$props.cssModule,
	        Tag = _this$props.tag;
	    var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
	    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)('tab-content', className), cssModule);
	    return _react.default.createElement(_TabContext.TabContext.Provider, {
	      value: {
	        activeTabId: this.state.activeTab
	      }
	    }, _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: classes
	    })));
	  };
	
	  return TabContent;
	}(_react.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(TabContent);
	var _default = TabContent;
	exports.default = _default;
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = TabPane;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _TabContext = __webpack_require__(256);
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  tabId: _propTypes.default.any
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	function TabPane(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      tabId = props.tabId,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tabId", "tag"]);
	
	  var getClasses = function getClasses(activeTabId) {
	    return (0, _utils.mapToCssModules)((0, _classnames.default)('tab-pane', className, {
	      active: tabId === activeTabId
	    }), cssModule);
	  };
	
	  return _react.default.createElement(_TabContext.TabContext.Consumer, null, function (_ref) {
	    var activeTabId = _ref.activeTabId;
	    return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	      className: getClasses(activeTabId)
	    }));
	  });
	}
	
	TabPane.propTypes = propTypes;
	TabPane.defaultProps = defaultProps;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  size: _propTypes.default.string,
	  bordered: _propTypes.default.bool,
	  borderless: _propTypes.default.bool,
	  striped: _propTypes.default.bool,
	  dark: _propTypes.default.bool,
	  hover: _propTypes.default.bool,
	  responsive: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  tag: _utils.tagPropType,
	  responsiveTag: _utils.tagPropType,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
	};
	var defaultProps = {
	  tag: 'table',
	  responsiveTag: 'div'
	};
	
	var Table = function Table(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      size = props.size,
	      bordered = props.bordered,
	      borderless = props.borderless,
	      striped = props.striped,
	      dark = props.dark,
	      hover = props.hover,
	      responsive = props.responsive,
	      Tag = props.tag,
	      ResponsiveTag = props.responsiveTag,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "size", "bordered", "borderless", "striped", "dark", "hover", "responsive", "tag", "responsiveTag", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);
	
	  var table = _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    ref: innerRef,
	    className: classes
	  }));
	
	  if (responsive) {
	    var responsiveClassName = (0, _utils.mapToCssModules)(responsive === true ? 'table-responsive' : "table-responsive-" + responsive, cssModule);
	    return _react.default.createElement(ResponsiveTag, {
	      className: responsiveClassName
	    }, table);
	  }
	
	  return table;
	};
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	var _default = Table;
	exports.default = _default;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var _Fade = _interopRequireDefault(__webpack_require__(76));
	
	var propTypes = {
	  children: _propTypes.default.node,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  fade: _propTypes.default.bool,
	  isOpen: _propTypes.default.bool,
	  tag: _utils.tagPropType,
	  transition: _propTypes.default.shape(_Fade.default.propTypes),
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  isOpen: true,
	  tag: 'div',
	  fade: true,
	  transition: (0, _objectSpread2.default)({}, _Fade.default.defaultProps, {
	    unmountOnExit: true
	  })
	};
	
	function Toast(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      Tag = props.tag,
	      isOpen = props.isOpen,
	      children = props.children,
	      transition = props.transition,
	      fade = props.fade,
	      innerRef = props.innerRef,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "tag", "isOpen", "children", "transition", "fade", "innerRef"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast'), cssModule);
	  var toastTransition = (0, _objectSpread2.default)({}, _Fade.default.defaultProps, transition, {
	    baseClass: fade ? transition.baseClass : '',
	    timeout: fade ? transition.timeout : 0
	  });
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, attributes, toastTransition, {
	    tag: Tag,
	    className: classes,
	    in: isOpen,
	    role: "alert",
	    innerRef: innerRef
	  }), children);
	}
	
	Toast.propTypes = propTypes;
	Toast.defaultProps = defaultProps;
	var _default = Toast;
	exports.default = _default;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.func])
	};
	var defaultProps = {
	  tag: 'div'
	};
	
	var ToastBody = function ToastBody(props) {
	  var className = props.className,
	      cssModule = props.cssModule,
	      innerRef = props.innerRef,
	      Tag = props.tag,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "innerRef", "tag"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast-body'), cssModule);
	  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
	    className: classes,
	    ref: innerRef
	  }));
	};
	
	ToastBody.propTypes = propTypes;
	ToastBody.defaultProps = defaultProps;
	var _default = ToastBody;
	exports.default = _default;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(5);
	
	var propTypes = {
	  tag: _utils.tagPropType,
	  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
	  wrapTag: _utils.tagPropType,
	  toggle: _propTypes.default.func,
	  className: _propTypes.default.string,
	  cssModule: _propTypes.default.object,
	  children: _propTypes.default.node,
	  closeAriaLabel: _propTypes.default.string,
	  charCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  close: _propTypes.default.object
	};
	var defaultProps = {
	  tag: 'strong',
	  wrapTag: 'div',
	  tagClassName: 'mr-auto',
	  closeAriaLabel: 'Close',
	  charCode: 215
	};
	
	var ToastHeader = function ToastHeader(props) {
	  var closeButton;
	  var icon;
	  var className = props.className,
	      cssModule = props.cssModule,
	      children = props.children,
	      toggle = props.toggle,
	      Tag = props.tag,
	      WrapTag = props.wrapTag,
	      closeAriaLabel = props.closeAriaLabel,
	      charCode = props.charCode,
	      close = props.close,
	      tagClassName = props.tagClassName,
	      iconProp = props.icon,
	      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close", "tagClassName", "icon"]);
	  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'toast-header'), cssModule);
	
	  if (!close && toggle) {
	    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
	    closeButton = _react.default.createElement("button", {
	      type: "button",
	      onClick: toggle,
	      className: (0, _utils.mapToCssModules)('close', cssModule),
	      "aria-label": closeAriaLabel
	    }, _react.default.createElement("span", {
	      "aria-hidden": "true"
	    }, closeIcon));
	  }
	
	  if (typeof iconProp === "string") {
	    icon = _react.default.createElement("svg", {
	      className: (0, _utils.mapToCssModules)("rounded text-" + iconProp),
	      width: "20",
	      height: "20",
	      xmlns: "http://www.w3.org/2000/svg",
	      preserveAspectRatio: "xMidYMid slice",
	      focusable: "false",
	      role: "img"
	    }, _react.default.createElement("rect", {
	      fill: "currentColor",
	      width: "100%",
	      height: "100%"
	    }));
	  } else if (iconProp) {
	    icon = iconProp;
	  }
	
	  return _react.default.createElement(WrapTag, (0, _extends2.default)({}, attributes, {
	    className: classes
	  }), icon, _react.default.createElement(Tag, {
	    className: (0, _utils.mapToCssModules)((0, _classnames.default)(tagClassName, {
	      "ml-2": icon != null
	    }), cssModule)
	  }, children), close || closeButton);
	};
	
	ToastHeader.propTypes = propTypes;
	ToastHeader.defaultProps = defaultProps;
	var _default = ToastHeader;
	exports.default = _default;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _Alert = _interopRequireDefault(__webpack_require__(245));
	
	var UncontrolledAlert =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledAlert, _Component);
	
	  function UncontrolledAlert(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: true
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledAlert.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Alert.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, this.props));
	  };
	
	  return UncontrolledAlert;
	}(_react.Component);
	
	var _default = UncontrolledAlert;
	exports.default = _default;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ButtonDropdown = _interopRequireDefault(__webpack_require__(247));
	
	var _utils = __webpack_require__(5);
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledButtonDropdown =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledButtonDropdown, _Component);
	
	  function UncontrolledButtonDropdown(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledButtonDropdown.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_ButtonDropdown.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledButtonDropdown;
	}(_react.Component);
	
	exports.default = UncontrolledButtonDropdown;
	UncontrolledButtonDropdown.propTypes = (0, _objectSpread2.default)({
	  defaultOpen: _propTypes.default.bool
	}, _ButtonDropdown.default.propTypes);

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Carousel = _interopRequireDefault(__webpack_require__(248));
	
	var _CarouselItem = _interopRequireDefault(__webpack_require__(148));
	
	var _CarouselControl = _interopRequireDefault(__webpack_require__(250));
	
	var _CarouselIndicators = _interopRequireDefault(__webpack_require__(251));
	
	var _CarouselCaption = _interopRequireDefault(__webpack_require__(249));
	
	var propTypes = {
	  items: _propTypes.default.array.isRequired,
	  indicators: _propTypes.default.bool,
	  controls: _propTypes.default.bool,
	  autoPlay: _propTypes.default.bool,
	  defaultActiveIndex: _propTypes.default.number,
	  activeIndex: _propTypes.default.number,
	  next: _propTypes.default.func,
	  previous: _propTypes.default.func,
	  goToIndex: _propTypes.default.func
	};
	
	var UncontrolledCarousel =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledCarousel, _Component);
	
	  function UncontrolledCarousel(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.animating = false;
	    _this.state = {
	      activeIndex: props.defaultActiveIndex || 0
	    };
	    _this.next = _this.next.bind((0, _assertThisInitialized2.default)(_this));
	    _this.previous = _this.previous.bind((0, _assertThisInitialized2.default)(_this));
	    _this.goToIndex = _this.goToIndex.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExiting = _this.onExiting.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onExited = _this.onExited.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledCarousel.prototype;
	
	  _proto.onExiting = function onExiting() {
	    this.animating = true;
	  };
	
	  _proto.onExited = function onExited() {
	    this.animating = false;
	  };
	
	  _proto.next = function next() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
	    this.setState({
	      activeIndex: nextIndex
	    });
	  };
	
	  _proto.previous = function previous() {
	    if (this.animating) return;
	    var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
	    this.setState({
	      activeIndex: nextIndex
	    });
	  };
	
	  _proto.goToIndex = function goToIndex(newIndex) {
	    if (this.animating) return;
	    this.setState({
	      activeIndex: newIndex
	    });
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        defaultActiveIndex = _this$props.defaultActiveIndex,
	        autoPlay = _this$props.autoPlay,
	        indicators = _this$props.indicators,
	        controls = _this$props.controls,
	        items = _this$props.items,
	        goToIndex = _this$props.goToIndex,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"]);
	    var activeIndex = this.state.activeIndex;
	    var slides = items.map(function (item) {
	      return _react.default.createElement(_CarouselItem.default, {
	        onExiting: _this2.onExiting,
	        onExited: _this2.onExited,
	        key: item.src
	      }, _react.default.createElement("img", {
	        className: "d-block w-100",
	        src: item.src,
	        alt: item.altText
	      }), _react.default.createElement(_CarouselCaption.default, {
	        captionText: item.caption,
	        captionHeader: item.header || item.caption
	      }));
	    });
	    return _react.default.createElement(_Carousel.default, (0, _extends2.default)({
	      activeIndex: activeIndex,
	      next: this.next,
	      previous: this.previous,
	      ride: autoPlay ? 'carousel' : undefined
	    }, props), indicators && _react.default.createElement(_CarouselIndicators.default, {
	      items: items,
	      activeIndex: props.activeIndex || activeIndex,
	      onClickHandler: goToIndex || this.goToIndex
	    }), slides, controls && _react.default.createElement(_CarouselControl.default, {
	      direction: "prev",
	      directionText: "Previous",
	      onClickHandler: props.previous || this.previous
	    }), controls && _react.default.createElement(_CarouselControl.default, {
	      direction: "next",
	      directionText: "Next",
	      onClickHandler: props.next || this.next
	    }));
	  };
	
	  return UncontrolledCarousel;
	}(_react.Component);
	
	UncontrolledCarousel.propTypes = propTypes;
	UncontrolledCarousel.defaultProps = {
	  controls: true,
	  indicators: true,
	  autoPlay: true
	};
	var _default = UncontrolledCarousel;
	exports.default = _default;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(252));
	
	var _utils = __webpack_require__(5);
	
	var omitKeys = ['toggleEvents', 'defaultOpen'];
	var propTypes = {
	  defaultOpen: _propTypes.default.bool,
	  toggler: _propTypes.default.string.isRequired,
	  toggleEvents: _propTypes.default.arrayOf(_propTypes.default.string)
	};
	var defaultProps = {
	  toggleEvents: _utils.defaultToggleEvents
	};
	
	var UncontrolledCollapse =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledCollapse, _Component);
	
	  function UncontrolledCollapse(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.togglers = null;
	    _this.removeEventListeners = null;
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    return _this;
	  }
	
	  var _proto = UncontrolledCollapse.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.togglers = (0, _utils.findDOMElements)(this.props.toggler);
	
	    if (this.togglers.length) {
	      this.removeEventListeners = (0, _utils.addMultipleEventListeners)(this.togglers, this.toggle, this.props.toggleEvents);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.togglers.length && this.removeEventListeners) {
	      this.removeEventListeners();
	    }
	  };
	
	  _proto.toggle = function toggle(e) {
	    this.setState(function (_ref) {
	      var isOpen = _ref.isOpen;
	      return {
	        isOpen: !isOpen
	      };
	    });
	    e.preventDefault();
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledCollapse;
	}(_react.Component);
	
	UncontrolledCollapse.propTypes = propTypes;
	UncontrolledCollapse.defaultProps = defaultProps;
	var _default = UncontrolledCollapse;
	exports.default = _default;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(105));
	
	var _utils = __webpack_require__(5);
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledDropdown =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledDropdown, _Component);
	
	  function UncontrolledDropdown(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledDropdown.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledDropdown;
	}(_react.Component);
	
	exports.default = UncontrolledDropdown;
	UncontrolledDropdown.propTypes = (0, _objectSpread2.default)({
	  defaultOpen: _propTypes.default.bool
	}, _Dropdown.default.propTypes);

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Popover = _interopRequireDefault(__webpack_require__(254));
	
	var _utils = __webpack_require__(5);
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledPopover =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledPopover, _Component);
	
	  function UncontrolledPopover(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledPopover.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Popover.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledPopover;
	}(_react.Component);
	
	exports.default = UncontrolledPopover;
	UncontrolledPopover.propTypes = (0, _objectSpread2.default)({
	  defaultOpen: _propTypes.default.bool
	}, _Popover.default.propTypes);

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(257));
	
	var _utils = __webpack_require__(5);
	
	var omitKeys = ['defaultOpen'];
	
	var UncontrolledTooltip =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inheritsLoose2.default)(UncontrolledTooltip, _Component);
	
	  function UncontrolledTooltip(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	    _this.state = {
	      isOpen: props.defaultOpen || false
	    };
	    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	
	  var _proto = UncontrolledTooltip.prototype;
	
	  _proto.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement(_Tooltip.default, (0, _extends2.default)({
	      isOpen: this.state.isOpen,
	      toggle: this.toggle
	    }, (0, _utils.omit)(this.props, omitKeys)));
	  };
	
	  return UncontrolledTooltip;
	}(_react.Component);
	
	exports.default = UncontrolledTooltip;
	UncontrolledTooltip.propTypes = (0, _objectSpread2.default)({
	  defaultOpen: _propTypes.default.bool
	}, _Tooltip.default.propTypes);

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.Util = void 0;
	
	var _Container2 = _interopRequireDefault(__webpack_require__(702));
	
	exports.Container = _Container2.default;
	
	var _Row2 = _interopRequireDefault(__webpack_require__(740));
	
	exports.Row = _Row2.default;
	
	var _Col2 = _interopRequireDefault(__webpack_require__(701));
	
	exports.Col = _Col2.default;
	
	var _Navbar2 = _interopRequireDefault(__webpack_require__(729));
	
	exports.Navbar = _Navbar2.default;
	
	var _NavbarBrand2 = _interopRequireDefault(__webpack_require__(730));
	
	exports.NavbarBrand = _NavbarBrand2.default;
	
	var _NavbarToggler2 = _interopRequireDefault(__webpack_require__(731));
	
	exports.NavbarToggler = _NavbarToggler2.default;
	
	var _Nav2 = _interopRequireDefault(__webpack_require__(726));
	
	exports.Nav = _Nav2.default;
	
	var _NavItem2 = _interopRequireDefault(__webpack_require__(727));
	
	exports.NavItem = _NavItem2.default;
	
	var _NavLink2 = _interopRequireDefault(__webpack_require__(728));
	
	exports.NavLink = _NavLink2.default;
	
	var _Breadcrumb2 = _interopRequireDefault(__webpack_require__(684));
	
	exports.Breadcrumb = _Breadcrumb2.default;
	
	var _BreadcrumbItem2 = _interopRequireDefault(__webpack_require__(685));
	
	exports.BreadcrumbItem = _BreadcrumbItem2.default;
	
	var _Button2 = _interopRequireDefault(__webpack_require__(246));
	
	exports.Button = _Button2.default;
	
	var _ButtonDropdown2 = _interopRequireDefault(__webpack_require__(247));
	
	exports.ButtonDropdown = _ButtonDropdown2.default;
	
	var _ButtonGroup2 = _interopRequireDefault(__webpack_require__(686));
	
	exports.ButtonGroup = _ButtonGroup2.default;
	
	var _ButtonToolbar2 = _interopRequireDefault(__webpack_require__(687));
	
	exports.ButtonToolbar = _ButtonToolbar2.default;
	
	var _Dropdown2 = _interopRequireDefault(__webpack_require__(105));
	
	exports.Dropdown = _Dropdown2.default;
	
	var _DropdownItem2 = _interopRequireDefault(__webpack_require__(704));
	
	exports.DropdownItem = _DropdownItem2.default;
	
	var _DropdownMenu2 = _interopRequireDefault(__webpack_require__(705));
	
	exports.DropdownMenu = _DropdownMenu2.default;
	
	var _DropdownToggle2 = _interopRequireDefault(__webpack_require__(706));
	
	exports.DropdownToggle = _DropdownToggle2.default;
	
	var _Fade2 = _interopRequireDefault(__webpack_require__(76));
	
	exports.Fade = _Fade2.default;
	
	var _Badge2 = _interopRequireDefault(__webpack_require__(683));
	
	exports.Badge = _Badge2.default;
	
	var _Card2 = _interopRequireDefault(__webpack_require__(688));
	
	exports.Card = _Card2.default;
	
	var _CardGroup2 = _interopRequireDefault(__webpack_require__(693));
	
	exports.CardGroup = _CardGroup2.default;
	
	var _CardDeck2 = _interopRequireDefault(__webpack_require__(691));
	
	exports.CardDeck = _CardDeck2.default;
	
	var _CardColumns2 = _interopRequireDefault(__webpack_require__(690));
	
	exports.CardColumns = _CardColumns2.default;
	
	var _CardBody2 = _interopRequireDefault(__webpack_require__(689));
	
	exports.CardBody = _CardBody2.default;
	
	var _CardLink2 = _interopRequireDefault(__webpack_require__(697));
	
	exports.CardLink = _CardLink2.default;
	
	var _CardFooter2 = _interopRequireDefault(__webpack_require__(692));
	
	exports.CardFooter = _CardFooter2.default;
	
	var _CardHeader2 = _interopRequireDefault(__webpack_require__(694));
	
	exports.CardHeader = _CardHeader2.default;
	
	var _CardImg2 = _interopRequireDefault(__webpack_require__(695));
	
	exports.CardImg = _CardImg2.default;
	
	var _CardImgOverlay2 = _interopRequireDefault(__webpack_require__(696));
	
	exports.CardImgOverlay = _CardImgOverlay2.default;
	
	var _Carousel2 = _interopRequireDefault(__webpack_require__(248));
	
	exports.Carousel = _Carousel2.default;
	
	var _UncontrolledCarousel2 = _interopRequireDefault(__webpack_require__(750));
	
	exports.UncontrolledCarousel = _UncontrolledCarousel2.default;
	
	var _CarouselControl2 = _interopRequireDefault(__webpack_require__(250));
	
	exports.CarouselControl = _CarouselControl2.default;
	
	var _CarouselItem2 = _interopRequireDefault(__webpack_require__(148));
	
	exports.CarouselItem = _CarouselItem2.default;
	
	var _CarouselIndicators2 = _interopRequireDefault(__webpack_require__(251));
	
	exports.CarouselIndicators = _CarouselIndicators2.default;
	
	var _CarouselCaption2 = _interopRequireDefault(__webpack_require__(249));
	
	exports.CarouselCaption = _CarouselCaption2.default;
	
	var _CardSubtitle2 = _interopRequireDefault(__webpack_require__(698));
	
	exports.CardSubtitle = _CardSubtitle2.default;
	
	var _CardText2 = _interopRequireDefault(__webpack_require__(699));
	
	exports.CardText = _CardText2.default;
	
	var _CardTitle2 = _interopRequireDefault(__webpack_require__(700));
	
	exports.CardTitle = _CardTitle2.default;
	
	var _CustomInput2 = _interopRequireDefault(__webpack_require__(703));
	
	exports.CustomInput = _CustomInput2.default;
	
	var _PopperContent2 = _interopRequireDefault(__webpack_require__(255));
	
	exports.PopperContent = _PopperContent2.default;
	
	var _PopperTargetHelper2 = _interopRequireDefault(__webpack_require__(737));
	
	exports.PopperTargetHelper = _PopperTargetHelper2.default;
	
	var _Popover2 = _interopRequireDefault(__webpack_require__(254));
	
	exports.Popover = _Popover2.default;
	
	var _UncontrolledPopover2 = _interopRequireDefault(__webpack_require__(753));
	
	exports.UncontrolledPopover = _UncontrolledPopover2.default;
	
	var _PopoverHeader2 = _interopRequireDefault(__webpack_require__(736));
	
	exports.PopoverHeader = _PopoverHeader2.default;
	
	var _PopoverBody2 = _interopRequireDefault(__webpack_require__(735));
	
	exports.PopoverBody = _PopoverBody2.default;
	
	var _Progress2 = _interopRequireDefault(__webpack_require__(739));
	
	exports.Progress = _Progress2.default;
	
	var _Modal2 = _interopRequireDefault(__webpack_require__(722));
	
	exports.Modal = _Modal2.default;
	
	var _ModalHeader2 = _interopRequireDefault(__webpack_require__(725));
	
	exports.ModalHeader = _ModalHeader2.default;
	
	var _ModalBody2 = _interopRequireDefault(__webpack_require__(723));
	
	exports.ModalBody = _ModalBody2.default;
	
	var _ModalFooter2 = _interopRequireDefault(__webpack_require__(724));
	
	exports.ModalFooter = _ModalFooter2.default;
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(257));
	
	exports.Tooltip = _Tooltip2.default;
	
	var _Table2 = _interopRequireDefault(__webpack_require__(744));
	
	exports.Table = _Table2.default;
	
	var _ListGroup2 = _interopRequireDefault(__webpack_require__(717));
	
	exports.ListGroup = _ListGroup2.default;
	
	var _Form2 = _interopRequireDefault(__webpack_require__(707));
	
	exports.Form = _Form2.default;
	
	var _FormFeedback2 = _interopRequireDefault(__webpack_require__(708));
	
	exports.FormFeedback = _FormFeedback2.default;
	
	var _FormGroup2 = _interopRequireDefault(__webpack_require__(709));
	
	exports.FormGroup = _FormGroup2.default;
	
	var _FormText2 = _interopRequireDefault(__webpack_require__(710));
	
	exports.FormText = _FormText2.default;
	
	var _Input2 = _interopRequireDefault(__webpack_require__(711));
	
	exports.Input = _Input2.default;
	
	var _InputGroup2 = _interopRequireDefault(__webpack_require__(712));
	
	exports.InputGroup = _InputGroup2.default;
	
	var _InputGroupAddon2 = _interopRequireDefault(__webpack_require__(713));
	
	exports.InputGroupAddon = _InputGroupAddon2.default;
	
	var _InputGroupButtonDropdown2 = _interopRequireDefault(__webpack_require__(714));
	
	exports.InputGroupButtonDropdown = _InputGroupButtonDropdown2.default;
	
	var _InputGroupText2 = _interopRequireDefault(__webpack_require__(253));
	
	exports.InputGroupText = _InputGroupText2.default;
	
	var _Label2 = _interopRequireDefault(__webpack_require__(716));
	
	exports.Label = _Label2.default;
	
	var _Media2 = _interopRequireDefault(__webpack_require__(721));
	
	exports.Media = _Media2.default;
	
	var _Pagination2 = _interopRequireDefault(__webpack_require__(732));
	
	exports.Pagination = _Pagination2.default;
	
	var _PaginationItem2 = _interopRequireDefault(__webpack_require__(733));
	
	exports.PaginationItem = _PaginationItem2.default;
	
	var _PaginationLink2 = _interopRequireDefault(__webpack_require__(734));
	
	exports.PaginationLink = _PaginationLink2.default;
	
	var _TabContent2 = _interopRequireDefault(__webpack_require__(742));
	
	exports.TabContent = _TabContent2.default;
	
	var _TabPane2 = _interopRequireDefault(__webpack_require__(743));
	
	exports.TabPane = _TabPane2.default;
	
	var _Jumbotron2 = _interopRequireDefault(__webpack_require__(715));
	
	exports.Jumbotron = _Jumbotron2.default;
	
	var _Alert2 = _interopRequireDefault(__webpack_require__(245));
	
	exports.Alert = _Alert2.default;
	
	var _Toast2 = _interopRequireDefault(__webpack_require__(745));
	
	exports.Toast = _Toast2.default;
	
	var _ToastBody2 = _interopRequireDefault(__webpack_require__(746));
	
	exports.ToastBody = _ToastBody2.default;
	
	var _ToastHeader2 = _interopRequireDefault(__webpack_require__(747));
	
	exports.ToastHeader = _ToastHeader2.default;
	
	var _Collapse2 = _interopRequireDefault(__webpack_require__(252));
	
	exports.Collapse = _Collapse2.default;
	
	var _ListGroupItem2 = _interopRequireDefault(__webpack_require__(718));
	
	exports.ListGroupItem = _ListGroupItem2.default;
	
	var _ListGroupItemHeading2 = _interopRequireDefault(__webpack_require__(719));
	
	exports.ListGroupItemHeading = _ListGroupItemHeading2.default;
	
	var _ListGroupItemText2 = _interopRequireDefault(__webpack_require__(720));
	
	exports.ListGroupItemText = _ListGroupItemText2.default;
	
	var _UncontrolledAlert2 = _interopRequireDefault(__webpack_require__(748));
	
	exports.UncontrolledAlert = _UncontrolledAlert2.default;
	
	var _UncontrolledButtonDropdown2 = _interopRequireDefault(__webpack_require__(749));
	
	exports.UncontrolledButtonDropdown = _UncontrolledButtonDropdown2.default;
	
	var _UncontrolledCollapse2 = _interopRequireDefault(__webpack_require__(751));
	
	exports.UncontrolledCollapse = _UncontrolledCollapse2.default;
	
	var _UncontrolledDropdown2 = _interopRequireDefault(__webpack_require__(752));
	
	exports.UncontrolledDropdown = _UncontrolledDropdown2.default;
	
	var _UncontrolledTooltip2 = _interopRequireDefault(__webpack_require__(754));
	
	exports.UncontrolledTooltip = _UncontrolledTooltip2.default;
	
	var _Spinner2 = _interopRequireDefault(__webpack_require__(741));
	
	exports.Spinner = _Spinner2.default;
	
	var _Util = _interopRequireWildcard(__webpack_require__(5));
	
	exports.Util = _Util;

/***/ },
/* 756 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    nullTag = '[object Null]',
	    proxyTag = '[object Proxy]',
	    undefinedTag = '[object Undefined]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isFunction;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 757 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(7));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(107));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(340));
	
	var _Manager = __webpack_require__(150);
	
	var _utils = __webpack_require__(260);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.safeInvoke)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.safeInvoke)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerContext.Consumer, null, function (_ref2) {
	    var referenceNode = _ref2.referenceNode;
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(25);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(17));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(107));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(765));
	
	var _Manager = __webpack_require__(150);
	
	var _utils = __webpack_require__(260);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "refHandler", function (node) {
	      (0, _utils.safeInvoke)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerContext.Consumer, null, function (_ref) {
	    var setReferenceNode = _ref.setReferenceNode;
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(764);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(763);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(760);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 762 */
327,
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(762);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 764 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 765 */
44,
/* 766 */
[914, 768, 770, 261, 263],
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(31);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(262));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 768 */
[916, 3, 769],
/* 769 */
485,
/* 770 */
486,
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _has = __webpack_require__(67);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _isSchema = __webpack_require__(52);
	
	var _isSchema2 = _interopRequireDefault(_isSchema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function callOrConcat(schema) {
	  if (typeof schema === 'function') return schema;
	
	  return function (base) {
	    return base.concat(schema);
	  };
	}
	
	var Conditional = function () {
	  function Conditional(refs, options) {
	    _classCallCheck(this, Conditional);
	
	    var is = options.is,
	        then = options.then,
	        otherwise = options.otherwise;
	
	
	    this.refs = [].concat(refs);
	
	    then = callOrConcat(then);
	    otherwise = callOrConcat(otherwise);
	
	    if (typeof options === 'function') this.fn = options;else {
	      if (!(0, _has2.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
	
	      if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
	
	      var isFn = typeof is === 'function' ? is : function () {
	        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	          values[_key] = arguments[_key];
	        }
	
	        return values.every(function (value) {
	          return value === is;
	        });
	      };
	
	      this.fn = function () {
	        for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          values[_key2] = arguments[_key2];
	        }
	
	        var currentSchema = values.pop();
	        var option = isFn.apply(undefined, values) ? then : otherwise;
	
	        return option(currentSchema);
	      };
	    }
	  }
	
	  Conditional.prototype.getValue = function getValue(parent, context) {
	    var values = this.refs.map(function (r) {
	      return r.getValue(parent, context);
	    });
	
	    return values;
	  };
	
	  Conditional.prototype.resolve = function resolve(ctx, values) {
	    var schema = this.fn.apply(ctx, values.concat(ctx));
	
	    if (schema !== undefined && !(0, _isSchema2.default)(schema)) throw new TypeError('conditions must return a schema object');
	
	    return schema || ctx;
	  };
	
	  return Conditional;
	}();
	
	exports.default = Conditional;
	module.exports = exports['default'];

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isSchema = __webpack_require__(52);
	
	var _isSchema2 = _interopRequireDefault(_isSchema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Lazy = function () {
	  function Lazy(mapFn) {
	    _classCallCheck(this, Lazy);
	
	    this._resolve = function () {
	      var schema = mapFn.apply(undefined, arguments);
	      if (!(0, _isSchema2.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
	
	      return schema;
	    };
	  }
	
	  Lazy.prototype.resolve = function resolve(_ref) {
	    var value = _ref.value,
	        rest = _objectWithoutProperties(_ref, ['value']);
	
	    return this._resolve(value, rest);
	  };
	
	  Lazy.prototype.cast = function cast(value, options) {
	    return this._resolve(value, options).cast(value, options);
	  };
	
	  Lazy.prototype.validate = function validate(value, options) {
	    return this._resolve(value, options).validate(value, options);
	  };
	
	  return Lazy;
	}();
	
	Lazy.prototype.__isYupSchema__ = true;
	
	exports.default = Lazy;
	module.exports = exports['default'];

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['', '[', ']'], ['', '[', ']']);
	
	var _typeName = __webpack_require__(910);
	
	var _typeName2 = _interopRequireDefault(_typeName);
	
	var _inherits = __webpack_require__(66);
	
	var _inherits2 = _interopRequireDefault(_inherits);
	
	var _isAbsent = __webpack_require__(78);
	
	var _isAbsent2 = _interopRequireDefault(_isAbsent);
	
	var _isSchema = __webpack_require__(52);
	
	var _isSchema2 = _interopRequireDefault(_isSchema);
	
	var _makePath = __webpack_require__(264);
	
	var _makePath2 = _interopRequireDefault(_makePath);
	
	var _mixed = __webpack_require__(51);
	
	var _mixed2 = _interopRequireDefault(_mixed);
	
	var _locale = __webpack_require__(65);
	
	var _runValidations = __webpack_require__(154);
	
	var _runValidations2 = _interopRequireDefault(_runValidations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var hasLength = function hasLength(value) {
	  return !(0, _isAbsent2.default)(value) && value.length > 0;
	};
	
	exports.default = ArraySchema;
	
	
	function ArraySchema(type) {
	  var _this = this;
	
	  if (!(this instanceof ArraySchema)) return new ArraySchema(type);
	
	  _mixed2.default.call(this, { type: 'array' });
	
	  // `undefined` specifically means uninitialized, as opposed to
	  // "no subtype"
	  this._subType = undefined;
	
	  this.withMutation(function () {
	    _this.transform(function (values) {
	      if (typeof values === 'string') try {
	        values = JSON.parse(values);
	      } catch (err) {
	        values = null;
	      }
	
	      return this.isType(values) ? values : null;
	    });
	
	    if (type) _this.of(type);
	  });
	}
	
	(0, _inherits2.default)(ArraySchema, _mixed2.default, {
	  _typeCheck: function _typeCheck(v) {
	    return Array.isArray(v);
	  },
	  _cast: function _cast(_value, _opts) {
	    var _this2 = this;
	
	    var value = _mixed2.default.prototype._cast.call(this, _value, _opts);
	
	    //should ignore nulls here
	    if (!this._typeCheck(value) || !this._subType) return value;
	
	    return value.map(function (v) {
	      return _this2._subType.cast(v, _opts);
	    });
	  },
	  _validate: function _validate(_value) {
	    var _this3 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var errors = [];
	    var sync = options.sync;
	    var path = options.path;
	    var subType = this._subType;
	    var endEarly = this._option('abortEarly', options);
	    var recursive = this._option('recursive', options);
	
	    var originalValue = options.originalValue != null ? options.originalValue : _value;
	
	    return _mixed2.default.prototype._validate.call(this, _value, options).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
	      if (!recursive || !subType || !_this3._typeCheck(value)) {
	        if (errors.length) throw errors[0];
	        return value;
	      }
	
	      originalValue = originalValue || value;
	
	      var validations = value.map(function (item, idx) {
	        var path = (0, _makePath2.default)(_templateObject, options.path, idx);
	
	        // object._validate note for isStrict explanation
	        var innerOptions = _extends({}, options, {
	          path: path,
	          strict: true,
	          parent: value,
	          originalValue: originalValue[idx]
	        });
	
	        if (subType.validate) return subType.validate(item, innerOptions);
	
	        return true;
	      });
	
	      return (0, _runValidations2.default)({
	        sync: sync,
	        path: path,
	        value: value,
	        errors: errors,
	        endEarly: endEarly,
	        validations: validations
	      });
	    });
	  },
	  of: function of(schema) {
	    var next = this.clone();
	
	    if (schema !== false && !(0, _isSchema2.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + (0, _typeName2.default)(schema));
	
	    next._subType = schema;
	
	    return next;
	  },
	  required: function required(msg) {
	    var next = _mixed2.default.prototype.required.call(this, msg || _locale.mixed.required);
	
	    return next.test('required', msg || _locale.mixed.required, hasLength);
	  },
	  min: function min(_min, message) {
	    message = message || _locale.array.min;
	
	    return this.test({
	      message: message,
	      name: 'min',
	      exclusive: true,
	      params: { min: _min },
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value.length >= this.resolve(_min);
	      }
	    });
	  },
	  max: function max(_max, message) {
	    message = message || _locale.array.max;
	    return this.test({
	      message: message,
	      name: 'max',
	      exclusive: true,
	      params: { max: _max },
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value.length <= this.resolve(_max);
	      }
	    });
	  },
	  ensure: function ensure() {
	    return this.default(function () {
	      return [];
	    }).transform(function (val) {
	      return val === null ? [] : [].concat(val);
	    });
	  },
	  compact: function compact(rejector) {
	    var reject = !rejector ? function (v) {
	      return !!v;
	    } : function (v, i, a) {
	      return !rejector(v, i, a);
	    };
	
	    return this.transform(function (values) {
	      return values != null ? values.filter(reject) : values;
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _inherits = __webpack_require__(66);
	
	var _inherits2 = _interopRequireDefault(_inherits);
	
	var _mixed = __webpack_require__(51);
	
	var _mixed2 = _interopRequireDefault(_mixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = BooleanSchema;
	
	
	function BooleanSchema() {
	  var _this = this;
	
	  if (!(this instanceof BooleanSchema)) return new BooleanSchema();
	
	  _mixed2.default.call(this, { type: 'boolean' });
	
	  this.withMutation(function () {
	    _this.transform(function (value) {
	      if (!this.isType(value)) {
	        if (/^(true|1)$/i.test(value)) return true;
	        if (/^(false|0)$/i.test(value)) return false;
	      }
	      return value;
	    });
	  });
	}
	
	(0, _inherits2.default)(BooleanSchema, _mixed2.default, {
	  _typeCheck: function _typeCheck(v) {
	    if (v instanceof Boolean) v = v.valueOf();
	
	    return typeof v === 'boolean';
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _mixed = __webpack_require__(51);
	
	var _mixed2 = _interopRequireDefault(_mixed);
	
	var _inherits = __webpack_require__(66);
	
	var _inherits2 = _interopRequireDefault(_inherits);
	
	var _isodate = __webpack_require__(781);
	
	var _isodate2 = _interopRequireDefault(_isodate);
	
	var _locale = __webpack_require__(65);
	
	var _isAbsent = __webpack_require__(78);
	
	var _isAbsent2 = _interopRequireDefault(_isAbsent);
	
	var _Reference = __webpack_require__(77);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var invalidDate = new Date('');
	
	var isDate = function isDate(obj) {
	  return Object.prototype.toString.call(obj) === '[object Date]';
	};
	
	exports.default = DateSchema;
	
	
	function DateSchema() {
	  var _this = this;
	
	  if (!(this instanceof DateSchema)) return new DateSchema();
	
	  _mixed2.default.call(this, { type: 'date' });
	
	  this.withMutation(function () {
	    _this.transform(function (value) {
	      if (this.isType(value)) return isDate(value) ? new Date(value) : value;
	
	      value = (0, _isodate2.default)(value);
	      return value ? new Date(value) : invalidDate;
	    });
	  });
	}
	
	(0, _inherits2.default)(DateSchema, _mixed2.default, {
	  _typeCheck: function _typeCheck(v) {
	    return isDate(v) && !isNaN(v.getTime());
	  },
	  min: function min(_min, msg) {
	    var limit = _min;
	
	    if (!_Reference2.default.isRef(limit)) {
	      limit = this.cast(_min);
	      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
	    }
	
	    return this.test({
	      name: 'min',
	      exclusive: true,
	      message: msg || _locale.date.min,
	      params: { min: _min },
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value >= this.resolve(limit);
	      }
	    });
	  },
	  max: function max(_max, msg) {
	    var limit = _max;
	
	    if (!_Reference2.default.isRef(limit)) {
	      limit = this.cast(_max);
	      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
	    }
	
	    return this.test({
	      name: 'max',
	      exclusive: true,
	      message: msg || _locale.date.max,
	      params: { max: _max },
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value <= this.resolve(limit);
	      }
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = NumberSchema;
	
	var _inherits = __webpack_require__(66);
	
	var _inherits2 = _interopRequireDefault(_inherits);
	
	var _mixed = __webpack_require__(51);
	
	var _mixed2 = _interopRequireDefault(_mixed);
	
	var _locale = __webpack_require__(65);
	
	var _isAbsent = __webpack_require__(78);
	
	var _isAbsent2 = _interopRequireDefault(_isAbsent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNaN = function isNaN(value) {
	  return value != +value;
	};
	
	var isInteger = function isInteger(val) {
	  return (0, _isAbsent2.default)(val) || val === (val | 0);
	};
	
	function NumberSchema() {
	  var _this = this;
	
	  if (!(this instanceof NumberSchema)) return new NumberSchema();
	
	  _mixed2.default.call(this, { type: 'number' });
	
	  this.withMutation(function () {
	    _this.transform(function (value) {
	      if (this.isType(value)) return value;
	
	      var parsed = parseFloat(value);
	      if (this.isType(parsed)) return parsed;
	
	      return NaN;
	    });
	  });
	}
	
	(0, _inherits2.default)(NumberSchema, _mixed2.default, {
	  _typeCheck: function _typeCheck(value) {
	    if (value instanceof Number) value = value.valueOf();
	
	    return typeof value === 'number' && !isNaN(value);
	  },
	  min: function min(_min, msg) {
	    return this.test({
	      name: 'min',
	      exclusive: true,
	      params: { min: _min },
	      message: msg || _locale.number.min,
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value >= this.resolve(_min);
	      }
	    });
	  },
	  max: function max(_max, msg) {
	    return this.test({
	      name: 'max',
	      exclusive: true,
	      params: { max: _max },
	      message: msg || _locale.number.max,
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value <= this.resolve(_max);
	      }
	    });
	  },
	  positive: function positive(msg) {
	    return this.min(0, msg || _locale.number.positive);
	  },
	  negative: function negative(msg) {
	    return this.max(0, msg || _locale.number.negative);
	  },
	  integer: function integer(msg) {
	    msg = msg || _locale.number.integer;
	
	    return this.test('integer', msg, isInteger);
	  },
	  truncate: function truncate() {
	    return this.transform(function (value) {
	      return !(0, _isAbsent2.default)(value) ? value | 0 : value;
	    });
	  },
	  round: function round(method) {
	    var avail = ['ceil', 'floor', 'round', 'trunc'];
	    method = method && method.toLowerCase() || 'round';
	
	    // this exists for symemtry with the new Math.trunc
	    if (method === 'trunc') return this.truncate();
	
	    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
	
	    return this.transform(function (value) {
	      return !(0, _isAbsent2.default)(value) ? Math[method](value) : value;
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['', '.', ''], ['', '.', '']);
	
	exports.default = ObjectSchema;
	
	var _has = __webpack_require__(67);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _omit = __webpack_require__(900);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _snakeCase2 = __webpack_require__(902);
	
	var _snakeCase3 = _interopRequireDefault(_snakeCase2);
	
	var _camelCase2 = __webpack_require__(884);
	
	var _camelCase3 = _interopRequireDefault(_camelCase2);
	
	var _mapKeys = __webpack_require__(897);
	
	var _mapKeys2 = _interopRequireDefault(_mapKeys);
	
	var _transform = __webpack_require__(905);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	var _propertyExpr = __webpack_require__(119);
	
	var _mixed = __webpack_require__(51);
	
	var _mixed2 = _interopRequireDefault(_mixed);
	
	var _locale = __webpack_require__(65);
	
	var _sortFields = __webpack_require__(785);
	
	var _sortFields2 = _interopRequireDefault(_sortFields);
	
	var _sortByKeyOrder = __webpack_require__(784);
	
	var _sortByKeyOrder2 = _interopRequireDefault(_sortByKeyOrder);
	
	var _inherits = __webpack_require__(66);
	
	var _inherits2 = _interopRequireDefault(_inherits);
	
	var _makePath = __webpack_require__(264);
	
	var _makePath2 = _interopRequireDefault(_makePath);
	
	var _runValidations = __webpack_require__(154);
	
	var _runValidations2 = _interopRequireDefault(_runValidations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var isObject = function isObject(obj) {
	  return Object.prototype.toString.call(obj) === '[object Object]';
	};
	
	function unknown(ctx, value) {
	  var known = Object.keys(ctx.fields);
	  return Object.keys(value).filter(function (key) {
	    return known.indexOf(key) === -1;
	  });
	}
	
	function ObjectSchema(spec) {
	  var _this2 = this;
	
	  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);
	
	  _mixed2.default.call(this, { type: 'object', default: function _default() {
	      var _this = this;
	
	      var dft = (0, _transform2.default)(this._nodes, function (obj, key) {
	        obj[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
	      }, {});
	
	      return Object.keys(dft).length === 0 ? undefined : dft;
	    }
	  });
	
	  this.fields = Object.create(null);
	  this._nodes = [];
	  this._excludedEdges = [];
	
	  this.withMutation(function () {
	    _this2.transform(function coerce(value) {
	      if (typeof value === 'string') {
	        try {
	          value = JSON.parse(value);
	        } catch (err) {
	          value = null;
	        }
	      }
	      if (this.isType(value)) return value;
	      return null;
	    });
	
	    if (spec) {
	      _this2.shape(spec);
	    }
	  });
	}
	
	(0, _inherits2.default)(ObjectSchema, _mixed2.default, {
	  _typeCheck: function _typeCheck(value) {
	    return isObject(value) || typeof value === 'function';
	  },
	  _cast: function _cast(_value) {
	    var _this3 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var value = _mixed2.default.prototype._cast.call(this, _value, options);
	
	    //should ignore nulls here
	    if (value === undefined) return this.default();
	
	    if (!this._typeCheck(value)) return value;
	
	    var fields = this.fields,
	        strip = this._option('stripUnknown', options) === true,
	        extra = Object.keys(value).filter(function (v) {
	      return _this3._nodes.indexOf(v) === -1;
	    }),
	        props = this._nodes.concat(extra);
	
	    var innerOptions = _extends({}, options, {
	      parent: {}, // is filled during the transform below
	      __validating: false
	    });
	
	    value = (0, _transform2.default)(props, function (obj, prop) {
	      var field = fields[prop];
	      var exists = (0, _has2.default)(value, prop);
	
	      if (field) {
	        var fieldValue = void 0;
	        var strict = field._options && field._options.strict;
	
	        // safe to mutate since this is fired in sequence
	        innerOptions.path = (0, _makePath2.default)(_templateObject, options.path, prop);
	        innerOptions.value = value[prop];
	
	        field = field.resolve(innerOptions);
	
	        if (field._strip === true) return;
	
	        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
	
	        if (fieldValue !== undefined) obj[prop] = fieldValue;
	      } else if (exists && !strip) obj[prop] = value[prop];
	    }, innerOptions.parent);
	
	    return value;
	  },
	  _validate: function _validate(_value) {
	    var _this4 = this;
	
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var endEarly = void 0,
	        recursive = void 0;
	    var sync = opts.sync;
	    var errors = [];
	    var originalValue = opts.originalValue != null ? opts.originalValue : _value;
	
	    endEarly = this._option('abortEarly', opts);
	    recursive = this._option('recursive', opts);
	
	    opts = _extends({}, opts, { __validating: true, originalValue: originalValue });
	
	    return _mixed2.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
	      if (!recursive || !isObject(value)) {
	        // only iterate though actual objects
	        if (errors.length) throw errors[0];
	        return value;
	      }
	
	      originalValue = originalValue || value;
	
	      var validations = _this4._nodes.map(function (key) {
	        var path = (0, _makePath2.default)(_templateObject, opts.path, key);
	        var field = _this4.fields[key];
	
	        var innerOptions = _extends({}, opts, {
	          path: path,
	          parent: value,
	          originalValue: originalValue[key]
	        });
	
	        if (field) {
	          // inner fields are always strict:
	          // 1. this isn't strict so the casting will also have cast inner values
	          // 2. this is strict in which case the nested values weren't cast either
	          innerOptions.strict = true;
	
	          if (field.validate) return field.validate(value[key], innerOptions);
	        }
	
	        return true;
	      });
	
	      return (0, _runValidations2.default)({
	        sync: sync,
	        validations: validations,
	        value: value,
	        errors: errors,
	        endEarly: endEarly,
	        path: opts.path,
	        sort: (0, _sortByKeyOrder2.default)(_this4.fields)
	      });
	    });
	  },
	  concat: function concat(schema) {
	    var next = _mixed2.default.prototype.concat.call(this, schema);
	
	    next._nodes = (0, _sortFields2.default)(next.fields, next._excludedEdges);
	
	    return next;
	  },
	  shape: function shape(schema) {
	    var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var next = this.clone(),
	        fields = _extends(next.fields, schema);
	
	    next.fields = fields;
	
	    if (excludes.length) {
	      if (!Array.isArray(excludes[0])) excludes = [excludes];
	
	      var keys = excludes.map(function (_ref) {
	        var first = _ref[0],
	            second = _ref[1];
	        return first + '-' + second;
	      });
	
	      next._excludedEdges = next._excludedEdges.concat(keys);
	    }
	
	    next._nodes = (0, _sortFields2.default)(fields, next._excludedEdges);
	
	    return next;
	  },
	  from: function from(_from, to, alias) {
	    var fromGetter = (0, _propertyExpr.getter)(_from, true);
	
	    return this.transform(function (obj) {
	      var newObj = obj;
	
	      if (obj == null) return obj;
	
	      if ((0, _has2.default)(obj, _from)) {
	        newObj = alias ? _extends({}, obj) : (0, _omit2.default)(obj, _from);
	        newObj[to] = fromGetter(obj);
	      }
	
	      return newObj;
	    });
	  },
	  noUnknown: function noUnknown() {
	    var noAllow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _locale.object.noUnknown;
	
	    if (typeof noAllow === 'string') {
	      message = noAllow;
	      noAllow = true;
	    }
	
	    var next = this.test({
	      name: 'noUnknown',
	      exclusive: true,
	      message: message,
	      test: function test(value) {
	        return value == null || !noAllow || unknown(this.schema, value).length === 0;
	      }
	    });
	
	    if (noAllow) next._options.stripUnknown = true;
	
	    return next;
	  },
	  transformKeys: function transformKeys(fn) {
	    return this.transform(function (obj) {
	      return obj && (0, _mapKeys2.default)(obj, function (_, key) {
	        return fn(key);
	      });
	    });
	  },
	  camelCase: function camelCase() {
	    return this.transformKeys(_camelCase3.default);
	  },
	  snakeCase: function snakeCase() {
	    return this.transformKeys(_snakeCase3.default);
	  },
	  constantCase: function constantCase() {
	    return this.transformKeys(function (key) {
	      return (0, _snakeCase3.default)(key).toUpperCase();
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = StringSchema;
	
	var _inherits = __webpack_require__(66);
	
	var _inherits2 = _interopRequireDefault(_inherits);
	
	var _mixed = __webpack_require__(51);
	
	var _mixed2 = _interopRequireDefault(_mixed);
	
	var _locale = __webpack_require__(65);
	
	var _isAbsent = __webpack_require__(78);
	
	var _isAbsent2 = _interopRequireDefault(_isAbsent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
	var rUrl = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
	
	var hasLength = function hasLength(value) {
	  return (0, _isAbsent2.default)(value) || value.length > 0;
	};
	var isTrimmed = function isTrimmed(value) {
	  return (0, _isAbsent2.default)(value) || value === value.trim();
	};
	
	function StringSchema() {
	  var _this = this;
	
	  if (!(this instanceof StringSchema)) return new StringSchema();
	
	  _mixed2.default.call(this, { type: 'string' });
	
	  this.withMutation(function () {
	    _this.transform(function (value) {
	      if (this.isType(value)) return value;
	      return value != null && value.toString ? value.toString() : value;
	    });
	  });
	}
	
	(0, _inherits2.default)(StringSchema, _mixed2.default, {
	  _typeCheck: function _typeCheck(value) {
	    if (value instanceof String) value = value.valueOf();
	
	    return typeof value === 'string';
	  },
	  required: function required(msg) {
	    var next = _mixed2.default.prototype.required.call(this, msg || _locale.mixed.required);
	
	    return next.test('required', msg || _locale.mixed.required, hasLength);
	  },
	  length: function length(_length, msg) {
	    return this.test({
	      name: 'length',
	      exclusive: true,
	      message: msg || _locale.string.length,
	      params: { length: _length },
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value.length === this.resolve(_length);
	      }
	    });
	  },
	  min: function min(_min, msg) {
	    return this.test({
	      name: 'min',
	      exclusive: true,
	      message: msg || _locale.string.min,
	      params: { min: _min },
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value.length >= this.resolve(_min);
	      }
	    });
	  },
	  max: function max(_max, msg) {
	    return this.test({
	      name: 'max',
	      exclusive: true,
	      message: msg || _locale.string.max,
	      params: { max: _max },
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value.length <= this.resolve(_max);
	      }
	    });
	  },
	  matches: function matches(regex) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var excludeEmptyString = false,
	        message = void 0;
	
	    if (options.message || options.hasOwnProperty('excludeEmptyString')) {
	      excludeEmptyString = options.excludeEmptyString;
	      message = options.message;
	    } else message = options;
	
	    return this.test({
	      message: message || _locale.string.matches,
	      params: { regex: regex },
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value === '' && excludeEmptyString || regex.test(value);
	      }
	    });
	  },
	  email: function email(msg) {
	    return this.matches(rEmail, {
	      message: msg || _locale.string.email,
	      excludeEmptyString: true
	    });
	  },
	  url: function url(msg) {
	    return this.matches(rUrl, {
	      message: msg || _locale.string.url,
	      excludeEmptyString: true
	    });
	  },
	
	
	  //-- transforms --
	  ensure: function ensure() {
	    return this.default('').transform(function (val) {
	      return val === null ? '' : val;
	    });
	  },
	  trim: function trim(msg) {
	    msg = msg || _locale.string.trim;
	
	    return this.transform(function (val) {
	      return val != null ? val.trim() : val;
	    }).test('trim', msg, isTrimmed);
	  },
	  lowercase: function lowercase(msg) {
	    return this.transform(function (value) {
	      return !(0, _isAbsent2.default)(value) ? value.toLowerCase() : value;
	    }).test({
	      name: 'string_case',
	      exclusive: true,
	      message: msg || _locale.string.lowercase,
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value === value.toLowerCase();
	      }
	    });
	  },
	  uppercase: function uppercase(msg) {
	    return this.transform(function (value) {
	      return !(0, _isAbsent2.default)(value) ? value.toUpperCase() : value;
	    }).test({
	      name: 'string_case',
	      exclusive: true,
	      message: msg || _locale.string.uppercase,
	      test: function test(value) {
	        return (0, _isAbsent2.default)(value) || value === value.toUpperCase();
	      }
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createValidation;
	
	var _mapValues = __webpack_require__(898);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _ValidationError = __webpack_require__(152);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	var _Reference = __webpack_require__(77);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _synchronousPromise = __webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var formatError = _ValidationError2.default.formatError;
	
	var thenable = function thenable(p) {
	  return p && typeof p.then === 'function' && typeof p.catch === 'function';
	};
	
	function runTest(testFn, ctx, value, sync) {
	  var result = testFn.call(ctx, value);
	  if (!sync) return Promise.resolve(result);
	
	  if (thenable(result)) {
	    throw new Error('Validation test of type: "' + ctx.type + '" returned a Promise during a synchronous validate. ' + 'This test will finish after the validate call has returned');
	  }
	  return _synchronousPromise.SynchronousPromise.resolve(result);
	}
	
	function resolveParams(oldParams, newParams, resolve) {
	  return (0, _mapValues2.default)(_extends({}, oldParams, newParams), resolve);
	}
	
	function createErrorFactory(_ref) {
	  var value = _ref.value,
	      label = _ref.label,
	      resolve = _ref.resolve,
	      originalValue = _ref.originalValue,
	      opts = _objectWithoutProperties(_ref, ['value', 'label', 'resolve', 'originalValue']);
	
	  return function createError() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$path = _ref2.path,
	        path = _ref2$path === undefined ? opts.path : _ref2$path,
	        _ref2$message = _ref2.message,
	        message = _ref2$message === undefined ? opts.message : _ref2$message,
	        _ref2$type = _ref2.type,
	        type = _ref2$type === undefined ? opts.name : _ref2$type,
	        params = _ref2.params;
	
	    params = _extends({
	      path: path,
	      value: value,
	      originalValue: originalValue,
	      label: label
	    }, resolveParams(opts.params, params, resolve));
	
	    return _extends(new _ValidationError2.default(formatError(message, params), value, path, type), { params: params });
	  };
	}
	
	function createValidation(options) {
	  var name = options.name,
	      message = options.message,
	      test = options.test,
	      params = options.params;
	
	
	  function validate(_ref3) {
	    var value = _ref3.value,
	        path = _ref3.path,
	        label = _ref3.label,
	        options = _ref3.options,
	        originalValue = _ref3.originalValue,
	        sync = _ref3.sync,
	        rest = _objectWithoutProperties(_ref3, ['value', 'path', 'label', 'options', 'originalValue', 'sync']);
	
	    var parent = options.parent;
	    var resolve = function resolve(value) {
	      return _Reference2.default.isRef(value) ? value.getValue(parent, options.context) : value;
	    };
	
	    var createError = createErrorFactory({
	      message: message, path: path, value: value, originalValue: originalValue, params: params,
	      label: label, resolve: resolve, name: name
	    });
	
	    var ctx = _extends({ path: path, parent: parent, type: name, createError: createError, resolve: resolve, options: options }, rest);
	
	    return runTest(test, ctx, value, sync).then(function (validOrError) {
	      if (_ValidationError2.default.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
	    });
	  }
	
	  validate.TEST_NAME = name;
	  validate.TEST_FN = test;
	  validate.TEST = options;
	
	  return validate;
	}
	
	module.exports.createErrorFactory = createErrorFactory;
	module.exports = exports['default'];

/***/ },
/* 781 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = parseIsoDate;
	/**
	 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
	 * NON-CONFORMANT EDITION.
	 * © 2011 Colin Snover <http://zetafleet.com>
	 * Released under MIT license.
	 */
	//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
	var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
	
	function parseIsoDate(date) {
	  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
	      minutesOffset = 0,
	      timestamp,
	      struct;
	
	  if (struct = isoReg.exec(date)) {
	    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
	    for (var i = 0, k; k = numericKeys[i]; ++i) {
	      struct[k] = +struct[k] || 0;
	    } // allow undefined days and months
	    struct[2] = (+struct[2] || 1) - 1;
	    struct[3] = +struct[3] || 1;
	
	    // allow arbitrary sub-second precision beyond milliseconds
	    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0;
	
	    // timestamps without timezone identifiers should be considered local time
	    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
	      if (struct[8] !== 'Z' && struct[9] !== undefined) {
	        minutesOffset = struct[10] * 60 + struct[11];
	
	        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
	      }
	
	      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
	    }
	  } else timestamp = Date.parse ? Date.parse(date) : NaN;
	
	  return timestamp;
	}
	module.exports = exports['default'];

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = merge;
	
	var _has = __webpack_require__(67);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _isSchema = __webpack_require__(52);
	
	var _isSchema2 = _interopRequireDefault(_isSchema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isObject = function isObject(obj) {
	  return Object.prototype.toString.call(obj) === '[object Object]';
	};
	
	function merge(target, source) {
	  for (var key in source) {
	    if ((0, _has2.default)(source, key)) {
	      var targetVal = target[key],
	          sourceVal = source[key];
	
	      if (sourceVal === undefined) continue;
	
	      if ((0, _isSchema2.default)(sourceVal)) {
	        target[key] = (0, _isSchema2.default)(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
	      } else if (isObject(sourceVal)) {
	        target[key] = isObject(targetVal) ? merge(targetVal, sourceVal) : sourceVal;
	      } else if (Array.isArray(sourceVal)) {
	        target[key] = Array.isArray(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
	      } else target[key] = source[key];
	    }
	  }return target;
	}
	module.exports = exports['default'];

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = reach;
	
	var _propertyExpr = __webpack_require__(119);
	
	var _has = __webpack_require__(67);
	
	var _has2 = _interopRequireDefault(_has);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trim = function trim(part) {
	  return part.substr(0, part.length - 1).substr(1);
	};
	
	function reach(obj, path, value, context) {
	  var parent = void 0,
	      lastPart = void 0;
	
	  // if only one "value" arg then use it for both
	  context = context || value;
	
	  (0, _propertyExpr.forEach)(path, function (_part, isBracket, isArray) {
	    var part = isBracket ? trim(_part) : _part;
	
	    if (isArray || (0, _has2.default)(obj, '_subType')) {
	      // we skipped an array: foo[].bar
	      var idx = isArray ? parseInt(part, 10) : 0;
	
	      obj = obj.resolve({ context: context, parent: parent, value: value })._subType;
	
	      if (value) {
	        if (isArray && idx >= value.length) {
	          throw new Error('Yup.reach cannot resolve an array item at index: ' + _part + ', in the path: ' + path + '. ' + 'because there is no value at that index. ');
	        }
	
	        value = value[idx];
	      }
	    }
	
	    if (!isArray) {
	      obj = obj.resolve({ context: context, parent: parent, value: value });
	
	      if (!(0, _has2.default)(obj, 'fields') || !(0, _has2.default)(obj.fields, part)) throw new Error('The schema does not contain the path: ' + path + '. ' + ('(failed at: ' + lastPart + ' which is a type: "' + obj._type + '") '));
	
	      obj = obj.fields[part];
	
	      parent = value;
	      value = value && value[part];
	      lastPart = isBracket ? '[' + _part + ']' : '.' + _part;
	    }
	  });
	
	  if (obj) {
	    obj = obj.resolve({ context: context, parent: parent, value: value });
	  }
	
	  return obj;
	}
	module.exports = exports['default'];

/***/ },
/* 784 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = sortByKeyOrder;
	
	function findIndex(arr, err) {
	  var idx = Infinity;
	  arr.some(function (key, ii) {
	    if (err.path.indexOf(key) !== -1) {
	      idx = ii;
	      return true;
	    }
	  });
	
	  return idx;
	}
	
	function sortByKeyOrder(fields) {
	  var keys = Object.keys(fields);
	  return function (a, b) {
	    return findIndex(keys, a) - findIndex(keys, b);
	  };
	}
	module.exports = exports["default"];

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = sortFields;
	
	var _has = __webpack_require__(67);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _toposort = __webpack_require__(909);
	
	var _toposort2 = _interopRequireDefault(_toposort);
	
	var _propertyExpr = __webpack_require__(119);
	
	var _Reference = __webpack_require__(77);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _isSchema = __webpack_require__(52);
	
	var _isSchema2 = _interopRequireDefault(_isSchema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortFields(fields) {
	  var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var edges = [],
	      nodes = [];
	
	  function addNode(depPath, key) {
	    var node = (0, _propertyExpr.split)(depPath)[0];
	
	    if (!~nodes.indexOf(node)) nodes.push(node);
	
	    if (!~excludes.indexOf(key + '-' + node)) edges.push([key, node]);
	  }
	
	  for (var key in fields) {
	    if ((0, _has2.default)(fields, key)) {
	      var value = fields[key];
	
	      if (!~nodes.indexOf(key)) nodes.push(key);
	
	      if (_Reference2.default.isRef(value) && !value.isContext) addNode(value.path, key);else if ((0, _isSchema2.default)(value) && value._deps) value._deps.forEach(function (path) {
	        return addNode(path, key);
	      });
	    }
	  }return _toposort2.default.array(nodes, edges).reverse();
	}
	module.exports = exports['default'];

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55),
	    root = __webpack_require__(38);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(844),
	    hashDelete = __webpack_require__(845),
	    hashGet = __webpack_require__(846),
	    hashHas = __webpack_require__(847),
	    hashSet = __webpack_require__(848);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55),
	    root = __webpack_require__(38);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55),
	    root = __webpack_require__(38);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(156),
	    setCacheAdd = __webpack_require__(872),
	    setCacheHas = __webpack_require__(873);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55),
	    root = __webpack_require__(38);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 792 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 793 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 794 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 795 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 796 */
/***/ function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ },
/* 797 */
/***/ function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(79),
	    keys = __webpack_require__(68);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(79),
	    keysIn = __webpack_require__(293);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(159),
	    isFlattenable = __webpack_require__(852);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(833);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 802 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 803 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(54),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    equalArrays = __webpack_require__(277),
	    equalByTag = __webpack_require__(837),
	    equalObjects = __webpack_require__(838),
	    getTag = __webpack_require__(80),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(116),
	    isTypedArray = __webpack_require__(173);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(80),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(157),
	    baseIsEqual = __webpack_require__(272);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(117),
	    isMasked = __webpack_require__(854),
	    isObject = __webpack_require__(56),
	    toSource = __webpack_require__(291);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(80),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(54),
	    isLength = __webpack_require__(172),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(167),
	    nativeKeys = __webpack_require__(867);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56),
	    isPrototype = __webpack_require__(167),
	    nativeKeysIn = __webpack_require__(868);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(807),
	    getMatchData = __webpack_require__(840),
	    matchesStrictComparable = __webpack_require__(287);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(272),
	    get = __webpack_require__(890),
	    hasIn = __webpack_require__(891),
	    isKey = __webpack_require__(166),
	    isStrictComparable = __webpack_require__(285),
	    matchesStrictComparable = __webpack_require__(287),
	    toKey = __webpack_require__(81);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 815 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(161);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 817 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(887),
	    defineProperty = __webpack_require__(276),
	    identity = __webpack_require__(292);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 819 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(53),
	    arrayMap = __webpack_require__(158),
	    isArray = __webpack_require__(35),
	    isSymbol = __webpack_require__(118);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(112),
	    last = __webpack_require__(896),
	    parent = __webpack_require__(871),
	    toKey = __webpack_require__(81);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(158);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 823 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(273);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(38);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)(module)))

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(164);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 827 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(53);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(164);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(79),
	    getSymbols = __webpack_require__(165);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(79),
	    getSymbolsIn = __webpack_require__(281);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(38);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 833 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(824),
	    hasUnicode = __webpack_require__(283),
	    stringToArray = __webpack_require__(290),
	    toString = __webpack_require__(82);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(893);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(817);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(53),
	    Uint8Array = __webpack_require__(265),
	    eq = __webpack_require__(169),
	    equalArrays = __webpack_require__(277),
	    mapToArray = __webpack_require__(286),
	    setToArray = __webpack_require__(289);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(279);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(889),
	    overRest = __webpack_require__(870),
	    setToString = __webpack_require__(874);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(285),
	    keys = __webpack_require__(68);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(53);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 842 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 843 */
/***/ function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(115);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 845 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(115);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(115);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(115);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 849 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(164),
	    cloneDataView = __webpack_require__(826),
	    cloneRegExp = __webpack_require__(827),
	    cloneSymbol = __webpack_require__(828),
	    cloneTypedArray = __webpack_require__(829);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(270),
	    getPrototype = __webpack_require__(114),
	    isPrototype = __webpack_require__(167);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(53),
	    isArguments = __webpack_require__(170),
	    isArray = __webpack_require__(35);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 853 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(832);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 855 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 856 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(110);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(110);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(110);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(110);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(787),
	    ListCache = __webpack_require__(109),
	    Map = __webpack_require__(155);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(113);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(113);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(113);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(113);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(899);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(288);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 868 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 869 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(792);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(161),
	    baseSlice = __webpack_require__(273);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 872 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 873 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(818),
	    shortOut = __webpack_require__(875);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 875 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(109);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 877 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 878 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 879 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(109),
	    Map = __webpack_require__(155),
	    MapCache = __webpack_require__(156);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(866);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 882 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ },
/* 883 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(885),
	    createCompounder = __webpack_require__(275);
	
	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar--');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__FOO_BAR__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});
	
	module.exports = camelCase;


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(82),
	    upperFirst = __webpack_require__(906);
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	module.exports = capitalize;


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(269);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.cloneWith` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.cloneWith
	 * @example
	 *
	 * function customizer(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(true);
	 *   }
	 * }
	 *
	 * var el = _.cloneDeepWith(document.body, customizer);
	 *
	 * console.log(el === document.body);
	 * // => false
	 * console.log(el.nodeName);
	 * // => 'BODY'
	 * console.log(el.childNodes.length);
	 * // => 20
	 */
	function cloneDeepWith(value, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	}
	
	module.exports = cloneDeepWith;


/***/ },
/* 887 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(836),
	    toString = __webpack_require__(82);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(800);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(161);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(803),
	    hasPath = __webpack_require__(282);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(806),
	    baseUnary = __webpack_require__(163),
	    nodeUtil = __webpack_require__(168);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(54),
	    getPrototype = __webpack_require__(114),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(809),
	    baseUnary = __webpack_require__(163),
	    nodeUtil = __webpack_require__(168);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(54),
	    isArray = __webpack_require__(35),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 896 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(111),
	    baseForOwn = __webpack_require__(160),
	    baseIteratee = __webpack_require__(162);
	
	/**
	 * The opposite of `_.mapValues`; this method creates an object with the
	 * same values as `object` and keys generated by running each own enumerable
	 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	 * with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapValues
	 * @example
	 *
	 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   return key + value;
	 * });
	 * // => { 'a1': 1, 'b2': 2 }
	 */
	function mapKeys(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, iteratee(value, key, object), value);
	  });
	  return result;
	}
	
	module.exports = mapKeys;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(111),
	    baseForOwn = __webpack_require__(160),
	    baseIteratee = __webpack_require__(162);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(156);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(158),
	    baseClone = __webpack_require__(269),
	    baseUnset = __webpack_require__(821),
	    castPath = __webpack_require__(112),
	    copyObject = __webpack_require__(79),
	    customOmitClone = __webpack_require__(835),
	    flatRest = __webpack_require__(839),
	    getAllKeysIn = __webpack_require__(280);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(815),
	    basePropertyDeep = __webpack_require__(816),
	    isKey = __webpack_require__(166),
	    toKey = __webpack_require__(81);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(275);
	
	/**
	 * Converts `string` to
	 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the snake cased string.
	 * @example
	 *
	 * _.snakeCase('Foo Bar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('fooBar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('--FOO-BAR--');
	 * // => 'foo_bar'
	 */
	var snakeCase = createCompounder(function(result, word, index) {
	  return result + (index ? '_' : '') + word.toLowerCase();
	});
	
	module.exports = snakeCase;


/***/ },
/* 903 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(53),
	    copyArray = __webpack_require__(274),
	    getTag = __webpack_require__(80),
	    isArrayLike = __webpack_require__(171),
	    isString = __webpack_require__(895),
	    iteratorToArray = __webpack_require__(855),
	    mapToArray = __webpack_require__(286),
	    setToArray = __webpack_require__(289),
	    stringToArray = __webpack_require__(290),
	    values = __webpack_require__(907);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Built-in value references. */
	var symIterator = Symbol ? Symbol.iterator : undefined;
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike(value)) {
	    return isString(value) ? stringToArray(value) : copyArray(value);
	  }
	  if (symIterator && value[symIterator]) {
	    return iteratorToArray(value[symIterator]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	  return func(value);
	}
	
	module.exports = toArray;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(266),
	    baseCreate = __webpack_require__(270),
	    baseForOwn = __webpack_require__(160),
	    baseIteratee = __webpack_require__(162),
	    getPrototype = __webpack_require__(114),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(116),
	    isFunction = __webpack_require__(117),
	    isObject = __webpack_require__(56),
	    isTypedArray = __webpack_require__(173);
	
	/**
	 * An alternative to `_.reduce`; this method transforms `object` to a new
	 * `accumulator` object which is the result of running each of its own
	 * enumerable string keyed properties thru `iteratee`, with each invocation
	 * potentially mutating the `accumulator` object. If `accumulator` is not
	 * provided, a new object with the same `[[Prototype]]` will be used. The
	 * iteratee is invoked with four arguments: (accumulator, value, key, object).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The custom accumulator value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.transform([2, 3, 4], function(result, n) {
	 *   result.push(n *= n);
	 *   return n % 2 == 0;
	 * }, []);
	 * // => [4, 9]
	 *
	 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 */
	function transform(object, iteratee, accumulator) {
	  var isArr = isArray(object),
	      isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	  iteratee = baseIteratee(iteratee, 4);
	  if (accumulator == null) {
	    var Ctor = object && object.constructor;
	    if (isArrLike) {
	      accumulator = isArr ? new Ctor : [];
	    }
	    else if (isObject(object)) {
	      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	    }
	    else {
	      accumulator = {};
	    }
	  }
	  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	    return iteratee(accumulator, value, index, object);
	  });
	  return accumulator;
	}
	
	module.exports = transform;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(834);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(822),
	    keys = __webpack_require__(68);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(797),
	    hasUnicodeWord = __webpack_require__(843),
	    toString = __webpack_require__(82),
	    unicodeWords = __webpack_require__(883);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ },
/* 909 */
/***/ function(module, exports) {

	
	/**
	 * Topological sorting function
	 *
	 * @param {Array} edges
	 * @returns {Array}
	 */
	
	module.exports = exports = function(edges){
	  return toposort(uniqueNodes(edges), edges)
	}
	
	exports.array = toposort
	
	function toposort(nodes, edges) {
	  var cursor = nodes.length
	    , sorted = new Array(cursor)
	    , visited = {}
	    , i = cursor
	
	  while (i--) {
	    if (!visited[i]) visit(nodes[i], i, [])
	  }
	
	  return sorted
	
	  function visit(node, i, predecessors) {
	    if(predecessors.indexOf(node) >= 0) {
	      throw new Error('Cyclic dependency: '+JSON.stringify(node))
	    }
	
	    if (visited[i]) return;
	    visited[i] = true
	
	    // outgoing edges
	    var outgoing = edges.filter(function(edge){
	      return edge[0] === node
	    })
	    if (i = outgoing.length) {
	      var preds = predecessors.concat(node)
	      do {
	        var child = outgoing[--i][1]
	        visit(child, nodes.indexOf(child), preds)
	      } while (i)
	    }
	
	    sorted[--cursor] = node
	  }
	}
	
	function uniqueNodes(arr){
	  var res = []
	  for (var i = 0, len = arr.length; i < len; i++) {
	    var edge = arr[i]
	    if (res.indexOf(edge[0]) < 0) res.push(edge[0])
	    if (res.indexOf(edge[1]) < 0) res.push(edge[1])
	  }
	  return res
	}


/***/ },
/* 910 */
/***/ function(module, exports) {

	/**
	 * type-name - Just a reasonable typeof
	 *
	 * https://github.com/twada/type-name
	 *
	 * Copyright (c) 2014-2016 Takuto Wada
	 * Licensed under the MIT license.
	 *   https://github.com/twada/type-name/blob/master/LICENSE
	 */
	'use strict';
	
	var toStr = Object.prototype.toString;
	
	function funcName (f) {
	    if (f.name) {
	        return f.name;
	    }
	    var match = /^\s*function\s*([^\(]*)/im.exec(f.toString());
	    return match ? match[1] : '';
	}
	
	function ctorName (obj) {
	    var strName = toStr.call(obj).slice(8, -1);
	    if ((strName === 'Object' || strName === 'Error') && obj.constructor) {
	        return funcName(obj.constructor);
	    }
	    return strName;
	}
	
	function typeName (val) {
	    var type;
	    if (val === null) {
	        return 'null';
	    }
	    type = typeof val;
	    if (type === 'object') {
	        return ctorName(val);
	    }
	    return type;
	}
	
	module.exports = typeName;


/***/ },
/* 911 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 912 */
911,
/* 913 */
911,
/* 914 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _addClass = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _PropTypes = __webpack_require__(__webpack_module_template_argument_3__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _reactLifecyclesCompat = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _PropTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(__webpack_module_template_argument_0__);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.b06dc59e.js